import { ShortCourseInfo } from '../server/types';

export const courseCatalog: ShortCourseInfo[] = [
  {
    course_code: 'ACG2021',
    course_name: 'Principles of Financial Accounting',
    course_desc:
      'Introduction to financial accounting as an information and decision support system for users of financial information.',
  },
  {
    course_code: 'ACG2071',
    course_name: 'Principles of Managerial Accounting',
    course_desc:
      'Role of accounting as a tool in decision making process within economic framework of the firm.',
  },
  {
    course_code: 'ACG3082',
    course_name: 'Accounting for Non-Majors',
    course_desc:
      'Coverage of financial, managerial, and cost accounting topics with an emphasis on uses of accounting information; available to non- business majors only.',
  },
  {
    course_code: 'ACG3101',
    course_name: 'Intermediate Financial Accounting I',
    course_desc:
      'Accounting principles and financial accounting practices. Particular emphasis on analysis of balance sheet accounts through problem solving.',
  },
  {
    course_code: 'ACG3111',
    course_name: 'Intermediate Financial Accounting II',
    course_desc: 'Continuation of ACG3101.',
  },
  {
    course_code: 'ACG3180',
    course_name: 'Financial Statement Analysis',
    course_desc:
      'Introduction to the study of financial statements, including interpreting accounting data and analyzing financial statements. Cross listed with FIN3461.  Prerequisites:  FIN3403 minimum grade of C.',
  },
  {
    course_code: 'ACG3343',
    course_name: 'Cost Accounting',
    course_desc:
      'Provides students with the skills to prepare accounting information for use in the management decision making process. Contains material on accounting system design, budgeting, standard costing, direct costing, performance evaluation, and use of accounting information.',
  },
  {
    course_code: 'ACG3401',
    course_name: 'Accounting Information Systems',
    course_desc:
      'Design of systems to capture, process and report accounting information.',
  },
  {
    course_code: 'ACG3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ACG4151',
    course_name: 'Accounting Theory',
    course_desc:
      'Critical evaluation of broad framework of financial accounting theory.',
  },
  {
    course_code: 'ACG4201',
    course_name: 'Advanced Financial Accounting',
    course_desc:
      'Problems in external financial reporting including business combinations and consolidated financial statements, foreign operations, and partnerships. Offered concurrently with ACG5205; ACG5205 includes additional learning objectives not included in ACG4201. Credit for both ACG4201 and ACG5205 is not permitted.',
  },
  {
    course_code: 'ACG4501',
    course_name: 'Governmental and Non-Profit Accounting',
    course_desc:
      'Principles of financial accounting and reporting for governmental and nonprofit organizations. Offered concurrently with ACG5658; ACG5658 includes additional learning objectives not included in ACG4501. Credit for both ACG4501 and ACG5658 is not permitted.',
  },
  {
    course_code: 'ACG4651',
    course_name: 'Auditing',
    course_desc:
      'Introduction to principles of auditing and other assurance services with an emphasis on attestation standards and ethical requirements promulgated by the American Institute of Certified Public Accountants.',
  },
  {
    course_code: 'ACG4682',
    course_name: 'Forensic Accounting',
    course_desc:
      'The purpose is to acquaint the student with both the pervasiveness of and the causes of financial fraud in our society, and to explore in detail the methods in which financial fraud is perpetrated.',
  },
  {
    course_code: 'ACG4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ACG4941',
    course_name: 'Accounting Internship',
    course_desc:
      'Supervised field practicum in accounting-related position. May include activities in professional accounting, accounting information systems, or controllership. Graded on satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'ACG5205',
    course_name: 'Advanced Financial Accounting',
    course_desc:
      'Problems in external financial reporting including business combinations and consolidated financial statements, foreign operations and partnerships. Offered concurrently with ACG4201; ACG5205 includes additional learning objectives not included in ACG4201. Credit for both ACG4201 and ACG5205 is not permitted. ACG3111 Intermediate Financial Accounting II is a prerequisite.',
  },
  {
    course_code: 'ACG5658',
    course_name: 'Governmental and Non-Profit Accounting',
    course_desc:
      'Principles of financial accounting and reporting for governmental and nonprofit organizations. Offered concurrently with ACG4501; ACG5658 includes additional learning objectives not included in ACG4501. Credit for both ACG4501 and ACG5658 is not permitted.',
  },
  {
    course_code: 'ACG5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ACG5931',
    course_name: 'CPA Examination Review Financial Accounting and Reporting',
    course_desc:
      "This course is designed to cover the Financial Accounting and Reporting (FAR) topics tested on the Uniform CPA Examination. It will focus on topics related to Financial Accounting and Reporting as they relate to business enterprises, governmental entities, and not-for-profit organizations. This course and its sister courses, ACG5932, ACG5933, and ACG5935 are designed to provide a review of topics tested on all sections of the CPA examination. This course will not satisfy Florida's 150 semester hour requirement or Florida's upper-level accounting requirement.",
  },
  {
    course_code: 'ACG5932',
    course_name: 'CPA Examination Review of Regulation',
    course_desc:
      "This course is designed to cover the Regulation (REG) topics tested on the Uniform CPA Examination. It will focus on federal tax law, business law, ethics and a Certified Public Accountant's professional and legal responsibilities. This course and its sister courses, ACG5931, ACG5933, and ACG5935 are designed to provide a review of topics tested on all sections of the CPA examination. This course will not satisfy Florida's 150 semester hour requirement, or Florida's upper level accounting requirement.",
  },
  {
    course_code: 'ACG5933',
    course_name: 'CPA Examination Review of Auditing and Attestation',
    course_desc:
      "This course is designed to cover the Auditing and Attestation (AUD) topics tested on the Uniform CPA Examination. It will will stress a proficiency in the professional skills assessed on the Auditing and Attestation section of CPA examination. This course and its sister courses, ACG5931, ACG5932, ACG5935 are designed to provide a review of topics tested on all sections of the CPA examination. This course will not satisfy Florida's 150 semester hour requirement, or Florida's upper level accounting requirement.",
  },
  {
    course_code: 'AMH5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BSC2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ACG5935',
    course_name: 'CPA Examination Review of Business Environment and Concepts',
    course_desc:
      "This course is designed to cover the Business Environment and Concepts (BEC) topics tested on the Uniform CPA Examination. It will focus on the general business environment and business concepts needed to understand the implications of accounting in business transactions, and the underlying business reasons for decisions made in the business environment as it deals with accounting principles. This course and its sister courses, ACG5931, ACG5932, and ACG5933 are designed to provide a review of topics tested on all sections of the CPA examination. This course will not satisfy Florida's 150 semester hour requirement, or Florida's upper level accounting requirement.",
  },
  {
    course_code: 'ACG6308',
    course_name: 'Advanced Managerial Accounting',
    course_desc:
      'Management control and behavior, control structures, responsibility accounting, cost / profit / investment centers, budgets and performance evaluation, control of projects, control in service, and non-profit organizations.  Must have completed ACG3343 or the equivalent with a grade of C (2.0) or better to enroll.',
  },
  {
    course_code: 'ACG6309',
    course_name: 'Accounting for Decision Making',
    course_desc:
      'Upon completion of the course, students will gain knowledge about budgeting, profit planning, and controlling aspects of business decision making. This course covers three broad areas: fundamental financial and managerial concepts; revenue and cost accumulation techniques; and revenue and cost analysis. Available to non-accounting majors only.',
  },
  {
    course_code: 'ACG6405',
    course_name: 'Advanced Accounting Information Systems',
    course_desc:
      'A seminar for the study of contemporary accounting system topics with an emphasis on internal controls. Primary emphasis is placed on an accounting system design project. Must have completed ACG3401 or equivalent with C (2.0) or better to enroll.',
  },
  {
    course_code: 'ACG6805',
    course_name: 'Seminar in Financial Accounting',
    course_desc:
      'A blend of traditional and contemporary accounting issues with focus on the development of financial accounting theory, the relationship of theory and research to standard setting, and discussion of current accounting standards. Examines the objectives, measurement models, controversies, and philosophy of financial accounting.',
  },
  {
    course_code: 'ACG6856',
    course_name: 'Advanced Auditing',
    course_desc:
      'Advanced research, interpretation, and application of professional and ethical standards of auditing, assurance, attestation, and accounting and review services, including standards promulgated by the American Institute of Certified Public Accountants, the United States Public Company Accounting Oversight Board, International Federation of Accountants, and the United States Government Accountability Office.  Must have completed ACG4651 or the equivalent with a grade of C (2.0) or better to enroll.',
  },
  {
    course_code: 'ACG6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ADV3101',
    course_name: 'Creative Strategy & Tactics I',
    course_desc:
      'Covers the strategy, conceptualization, and execution of effective advertising. Professional advertising writing and art direction for both print, broadcast and digital media will be addressed. Familiarity with desktop publishing, especially Adobe Creative Suite is required.',
  },
  {
    course_code: 'ADV3213',
    course_name: 'Advertising Graphics II',
    course_desc:
      "Addresses professional publication design theory and practice. Subjects include magazine, newsletter, collateral, and brochure design. Design topics include: typography, grids, graphics, paper, color, and identity. Commercial and desktop publishing are incorporated from a designer's viewpoint. Familiarity with desktop publishing, especially Adobe Creative Suite and Macintosh platform is required. Credit may not be received in both ADV3213 and ADV 3213C.",
  },
  {
    course_code: 'ADV3216',
    course_name: 'Advertising Graphics I',
    course_desc:
      'Provides an introduction to the use of computers in the communication professions. Students will get "hands-on" experience using selected Adobe Creative Suite applications (Photoshop, Illustrator, and InDesign) for advertising and publication design on a Mac platform. Some basic design principles will be introduced along with the use of software. Acceptable prerequisite for advanced computer-based Communication  courses.',
  },
  {
    course_code: 'ADV3300',
    course_name: 'Advertising Media Strategy & Planning',
    course_desc:
      'Analysis and evaluation of advertising media, market analysis, media planning, media strategies, discussions, and costs. Credit may not be received in both ADV3300 and ADV 3300C.',
  },
  {
    course_code: 'ADV3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ADV4202',
    course_name: 'Creative Strategy and Tactics II',
    course_desc:
      'Advanced creative direction theory and  execution. Course will build professional level portfolio. Students will learn how to find a job opening, create job search materials (including an advertising\nportfolio), acquire the  skills needed to apply and interview for a job, and learn how to successfully negotiate getting hired. Students will also gain valuable experience learning to rely on themselves, and their own resourcefulness to succeed in class and life.',
  },
  {
    course_code: 'ADV4801',
    course_name: 'National Student Advertising Competition',
    course_desc:
      "Preparation for the American Advertising Federation National Student Advertising Competition (NSAC). Student agency prepares complete campaign, including: market research and segmentation, media and promotion plans, strategy, creation, and presentation. Professional standards stressed. Permission is required and students must become dues-paying members of UWF's American Advertising Federation (AAF) chapter as required by NSAC guidelines. Credit may be received in ADV4801 for up to 6 sh.",
  },
  {
    course_code: 'ADV4802',
    course_name: 'Integrated Communication-Campaigns',
    course_desc:
      'The capstone experience for advertising and public relations majors. Prepare complete integrated communication campaign, including: research, strategy, design, copy, and presentation to client. Senior major or minor status in advertising or public relations required.',
  },
  {
    course_code: 'ADV4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ADV6215',
    course_name: 'Emerging Topics in Advertising',
    course_desc:
      'Covers advanced theories and practices in advertising, with a focus on visual communication and brand communication. Principles of graphic communication, theories of semiotics, the concept of branding, brand positioning, brand image, and brand personality will be introduced. Students will evaluate advertising images, brand image, and brand personality using theories and principles covered in the course. They will also develop visual promotional materials and brand-based communication strategies by implementing those theories and principles.',
  },
  {
    course_code: 'ADV6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BSC3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'AFH4503',
    course_name: 'Africans in the Atlantic World',
    course_desc:
      'Africans comprised roughly two-thirds of 12 million migrants to the Americas between the 15th and 19th centuries. Course examines their experiences and their descendants in the making of the Atlantic world. Surveys critical time periods, institutions, individuals, and events, in the development of Creole societies throughout the Atlantic littoral. Emphasis placed on the construction of a "black Atlantic" identity among Africans and African-descended people throughout the Atlantic world. Special attention is paid to the history of West Africa. Story is told from an African point of view.',
  },
  {
    course_code: 'AFR1101',
    course_name: 'Heritage and Values I',
    course_desc:
      'AFR1101 is a course designed to introduce students to the United States Air Force and encourage participation in Air Force Reserve Officer Training Corps. Featured topics include: overview of ROTC, special programs offered through ROTC, mission and organization of the Air Force, brief history of the Air Force, introduction to leadership and leadership related issues, Air Force Core Values, Air Force officer opportunities, and an introduction to communication studies. Leadership Laboratory is mandatory for AFROTC cadets and complements this course by providing cadets with followership experiences.',
  },
  {
    course_code: 'AFR1101L',
    course_name: 'Heritage and Values I Lab',
    course_desc:
      'Leadership Laboratory (LLAB) Provides an introduction to the military profession, including applications in leadership, drill and ceremony, and customs and courtesies. The focus of Initial Military Training (IMT) objectives/activities are to promote the Air Force way of life and help effectively recruit and retain qualified cadets. This time is spent acquainting cadets with basic Air Force knowledge and skills to help them determine whether they wish to continue with the AFROTC program.',
  },
  {
    course_code: 'AFR1112',
    course_name: 'Heritage and Values II',
    course_desc:
      'AFR1112 is designed to introduce students to the United States Air Force and encourage participation in Air Force Reserve Officer Training Corps. Featured topics include: overview of ROTC, special programs offered through ROTC, mission and organization of the Air Force, Air Force Core Values, an introduction to Principles of War and Tenets of Airpower, ethical decision-making and Air Force Major Commands.',
  },
  {
    course_code: 'AFR1112L',
    course_name: 'Heritage and Values II Lab',
    course_desc:
      'Leadership Laboratory (LLAB) Provides an introduction to the military profession, including applications in leadership, drill and ceremony, and customs and courtesies. The focus of Initial Military Training (IMT) objectives/activities are to promote the Air Force way of life and help effectively recruit and retain qualified cadets. This time is spent acquainting cadets with basic Air Force knowledge and skills to help them determine whether they wish to continue with the AFROTC program.',
  },
  {
    course_code: 'AFR2130',
    course_name: 'Team and Leadership Fundamentals I',
    course_desc:
      'AFR2130 is designed to provide a fundamental understanding of both leadership and team building. Students will apply leadership perspectives when completing team building activities and discussing things like conflict management. Students should demonstrate basic verbal and written communication skills.',
  },
  {
    course_code: 'AFR2130L',
    course_name: 'Team and Leadership Fundamentals I Lab',
    course_desc:
      'Leadership Laboratory (LLAB) is a dynamic and integrated grouping of leadership developmental activities designed to prepare Field Training Prep (FTP) cadets for field training ensuring every cadet is mentally and physically prepared for the rigorous field training environment. FTP cadets will learn drill and ceremonies, road guard procedures, flag-raising procedures for reveille and retreat, as well as flight commander commands, positions, and movements.',
  },
  {
    course_code: 'AFR2132',
    course_name: 'Team and Leadership Fundamentals II',
    course_desc:
      'AFR2132 is designed to provide a fundamental understanding of both leadership and team building. Students will apply leadership perspectives when completing team building activities, discussing conflict management, human relations, stress management and resiliency, and ethical decision-making. Students should demonstrate basic verbal and written communication skills. Cadets will apply these lessons at Field Training.',
  },
  {
    course_code: 'AFR2132L',
    course_name: 'Team and Leadership Fundamentals II Lab',
    course_desc:
      'Leadership Laboratory (LLAB) is a dynamic and integrated grouping of leadership developmental activities designed to prepare Field Training Prep (FTP) cadets for field training ensuring every cadet is mentally and physically prepared for the rigorous field training environment. FTP cadets will learn drill and ceremonies, road guard procedures, flag-raising procedures for reveille and retreat, as well as flight commander commands, positions, and movements.',
  },
  {
    course_code: 'AFR2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'AFR3221',
    course_name: 'Leading People/Effective Communications I',
    course_desc:
      'AFR3221 is designed to build on the leadership fundamentals taught in AFR2132. Cadets will have the opportunity to utilize their skills as they begin a leadership role in the detachment. The course continues into advanced skills and ethics training that will prepare them for becoming an officer and supervisor. Case studies are used to examine Air Force leadership and management situations as a means of demonstrating and exercising practical application of the concepts being studied. A mandatory Leadership Laboratory complements this course by providing advanced leadership experiences in officer type activities, giving students the opportunity to apply leadership and management principles of this course.',
  },
  {
    course_code: 'AFR3221L',
    course_name: 'Leading People/Effective Communication I Lab',
    course_desc:
      'Leadership Laboratory (LLAB) is a dynamic and integrated grouping of leadership developmental activities where Intermediate Cadet Leaders (ICL) will demonstrate leadership and management skills in supervising the cadet corps through advanced leadership experiences. The cadets will comprehend the importance of adhering to Air Force Core Values. In addition to applying leadership skills, ICL cadets will participate in objectives/activities, focused on further developing leadership and followership skills learned at field training.',
  },
  {
    course_code: 'AFR3232',
    course_name: 'Leading People/Effective Communication II',
    course_desc:
      'AFR3232 is designed to build on the leadership fundamentals taught in AFR2132. Cadets will have the opportunity to use their skills as they continue in a leadership role in the detachment. The course covers advanced leadership theory, mentoring, feedback professionalism, and organizational climate. Case studies are used to examine Air Force leadership situations as a means of demonstrating and exercising practical application of the concepts being studied. A mandatory Leadership Laboratory complements this course by providing advanced leadership experiences in officer type activities, giving students the opportunity to apply leadership principles of this course.',
  },
  {
    course_code: 'AFR3232L',
    course_name: 'Leading People/Effective Communication II Lab',
    course_desc:
      'Leadership Laboratory (LLAB) is a dynamic and integrated grouping of leadership developmental activities where Intermediate Cadet Leaders (ICL) will demonstrate leadership and management skills in supervising the cadet corps through advanced leadership experiences. The cadets will comprehend the importance of adhering to Air Force Core Values. In addition to applying leadership skills, ICL cadets will participate in objectives/activities, focused on further developing leadership and followership skills learned at field training.',
  },
  {
    course_code: 'AFR4211',
    course_name: 'National Security, Leadership Responsibilities I',
    course_desc:
      'AFR4211 examines the national security strategy, joint operations, Unified Combatant Commands, Air Force domains and how the Air Force deploys. Special topics of interest focus are the civilian control of the military, defense support of civil authority, command and control, and global hot spots. Within this structure, continued emphasis is given to refining communication skills.',
  },
  {
    course_code: 'AFR4211L',
    course_name: 'National Security, Leadership Responsibilities I Lab',
    course_desc:
      'Leadership Laboratory (LLAB) is a dynamic and integrated grouping of leadership developmental activities where senior cadet leaders (SCL) will demonstrate leadership and management skills in supervising the cadet corps or through advanced leadership experiences. The cadets will comprehend the importance of adhering to Air Force Core Values. In addition to applying leadership skills, SCL cadets will participate in objectives/activities, focused on preparing them for active duty.',
  },
  {
    course_code: 'AFR4214',
    course_name:
      'National Security, Leadership Responsibilities & Commissioning Preparation II',
    course_desc:
      'AFR4214 examines professional and unprofessional relationships, base agencies, leadership authority and responsibility, military justice, and corrective supervision and counseling. Special topics include green dot refresher, religious accommodation, suicide prevention, SAPR program, officer and enlisted evaluations, and fist officer assignments. Within this structure, continued emphasis is given to refining communication skills.',
  },
  {
    course_code: 'AFR4214L',
    course_name: 'National Security, Leadership Responsibilities II Lab',
    course_desc:
      'Leadership Laboratory (LLAB) is a dynamic and integrated grouping of leadership developmental activities where senior cadet leaders (SCL) will demonstrate leadership and management skills in supervising the cadet corps or through advanced leadership experiences. The cadets will comprehend the importance of adhering to Air Force Core Values. In addition to applying leadership skills, SCL cadets will participate in objectives/activities, focused on preparing them for active duty.',
  },
  {
    course_code: 'AFR4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'AMH2010',
    course_name: 'United States to 1877',
    course_desc:
      'Survey of the United States history beginning with Native American cultures on the eve of colonization through the end of Reconstruction. Examines political, economic, and social developments.\nMeets General Education requirement in Social Sciences.',
  },
  {
    course_code: 'AMH2020',
    course_name: 'United States since 1877',
    course_desc:
      'Survey of the United States history beginning in 1877 and ending with a discussion of America in the present era. Examines political, economic, and social developments.\nMeets General Education requirement in Social Sciences.',
  },
  {
    course_code: 'AMH3540',
    course_name: 'American Military History',
    course_desc:
      'The American military experience from the colonial era to the present, including causes, conduct, and consequences of wars in American history, civil-military relations, and technology.',
  },
  {
    course_code: 'AMH4111',
    course_name: 'Colonial America',
    course_desc:
      'History of British Colonial America (1585 - 1776): founding of the colonies; development of economic, social, and political structures; the maturing of the colonies; and background to the American Revolution.',
  },
  {
    course_code: 'AMH4131',
    course_name: 'American Revolutions, 1763-1828',
    course_desc:
      'The social, economic and political histories of the American, Spanish-American and Haitian revolutions between 1763 and 1828.',
  },
  {
    course_code: 'AMH4170',
    course_name: 'The American Civil War',
    course_desc:
      'The general objective of this course is to provide students with a deeper knowledge of the origins, evolution, and conduct of the American Civil War (or "War Between the States").  More specifically, after completion of the course students should better comprehend:\t- why the war occurred;\t- the strategic goals of the North and South;\t- the advantages/disadvantages facing both belligerents\t- the military campaigns/conduct of the war 1861-1865\t- the differences between Northern and Southern war experience;\t- how the war affected life on the home-front;\t- the reasons for the ultimate triumph of the Union;\t- the social, economic, political, and scientific consequences of the war;\t- the international significance of the war. \t -The Civil War in society and culture today\nCourse activities consist of lectures, films, class reading assignments, research papers, quizzes and examinations.',
  },
  {
    course_code: 'AMH4375',
    course_name: 'Inventing the Future: The History of American Technology',
    course_desc:
      'Explores the history of technological change in the United States from the period of industrialization to the digital age.',
  },
  {
    course_code: 'AMH4380',
    course_name: 'Disaster in North American History',
    course_desc:
      'Explores disaster as an analytical theme in the history of North America from the colonial era through the present.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'AMH4420',
    course_name: 'History of Florida',
    course_desc:
      'Pre-Columbian to present; social, economic, and political development.',
  },
  {
    course_code: 'AMH4427',
    course_name: 'Florida Panhandle History',
    course_desc:
      'Exposes students to the diverse history of that section of Florida bounded in the west by the Perdido River and in the east by the Apalachicola River - the Florida Panhandle.',
  },
  {
    course_code: 'AMH4442',
    course_name: 'The American West',
    course_desc:
      'Seminar examines the complex relationships between history, myth-making, and national identity in the American West.',
  },
  {
    course_code: 'AMH4575',
    course_name: 'Civil Rights',
    course_desc:
      'U.S. civil rights movement from its roots in the nineteenth century to the present.',
  },
  {
    course_code: 'AMH4693',
    course_name: 'Sun, Surf, and Sand: The History of the American Beach',
    course_desc:
      'This course surveys the social, cultural, political, and environmental history of the American beach. It introduces students to the emerging, vibrant subfield of "New Coastal History" by exploring the innovative approaches and methodologies historians are using to study coastal people and places.',
  },
  {
    course_code: 'AMH4694',
    course_name: 'North American Seafaring',
    course_desc:
      'Explores the history of North American seafaring from the pre-Columbian era\nthrough the twentieth century.',
  },
  {
    course_code: 'AMH4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'AMH6116',
    course_name: 'Colonial America',
    course_desc:
      'Seminar explores the major historiographical trends in Colonial American history (1585-1776). The course is more thematic than comprehensive and stresses breadth rather than depth.',
  },
  {
    course_code: 'AMH6137',
    course_name: 'Revolutionary America',
    course_desc:
      'This course explores the causes, course and consequences of the revolution. We consider two dimensions of the revolution - as a war of independence and a social upheaval within the colonies. Topics include the commercial and political strands of empire; the nature of creole identity, culture and society; the imperial crises and opening of the war; the role of various fighting forces through the Peace of Paris; and the subsequent struggles over the character of new state and national governments.',
  },
  {
    course_code: 'AMH6149',
    course_name: 'Transformations of America',
    course_desc:
      'This course examines the major issues, events, and figures that defined the early American republic, the formative period of American history from the War of 1812 to the Civil War. All aspects of the early republic will be covered -- social, cultural, economic, political, constitutional, diplomatic, military, and biographical.',
  },
  {
    course_code: 'AMH6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'AML2010',
    course_name: 'American Literature I',
    course_desc:
      'Survey of major American literature from colonial times to the Civil War. Open to all students.\nMeets General Education requirement in Humanities.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'AML2020',
    course_name: 'American Literature II',
    course_desc:
      'Survey of major American literature from the Civil War to the present. Open to all students.\nMeets General Education requirement in Humanities.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'AML2072',
    course_name: 'Sex, Money, and Power in American Literature',
    course_desc:
      'From the days of Columbus, who came to the New World seeking fame and gold, to the era of Sex and the City, America has seen its share of sex scandals, political corruption, and war. What this suggests is that there have always been two different "Americas": the one of our dreams and the one that forever disappoints us. This course explores these two Americas through literary study.\nMeets General Education requirement in Humanities.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'AML2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'AML3604',
    course_name: 'African American Literature',
    course_desc:
      'This is a discussion and collaborative group work course in which literary texts from various genres including slave narratives, dramas, short stories, novels, poetry, and the nonfiction essay will be used to reveal how complicit the factors of race, gender, sexuality, nationality, class, and the "divided self" are in the African-American experience. Attendance and participation in the interactive classroom discussions and in in-class and out-of-class group work are crucial to a student\'s success in the class.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'AML3624',
    course_name: 'Black Women Writers',
    course_desc:
      'Poetry, drama, and prose of black women writers in America. Emphasis on works from the Harlem Renaissance to the present.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'AML3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'AML4014',
    course_name: 'Topics in Early American Literature',
    course_desc:
      'Thematic approaches to the New World and early American literature, from the time of the Spanish conquest through the American Revolution and the early Republic. Topics vary according to faculty expertise and research interests.',
  },
  {
    course_code: 'AML4015',
    course_name: 'Topics in Nineteenth-Century American Literature',
    course_desc:
      'Explores themes in nineteenth-century American literature, from the Romantics through realism and early modernism. Emphasizes new critical approaches and the racial, ethnic and cultural diversity of American literature. Topics vary according to faculty expertise and research interests.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'AML4054',
    course_name:
      'Topics in Twentieth-Century and Contemporary American Literature',
    course_desc:
      'Thematic approaches to twentieth-century and contemporary American Literature, from modernism through the present. Studies literature in relation to artistic and social movements of the past century. Topics vary according to faculty expertise and research interests.',
  },
  {
    course_code: 'AML4302',
    course_name:
      'Single Author Seminar, American Literature, 1700 to the Present',
    course_desc:
      "This course is designed to give students an in-depth view into American Literature through detailed study of the work of a single canonical author. Extended study of the oeuvre of a single author gives students insight into not only specific moments of history and the overall scene of publishing/literature, but also how a specific author's style and treatment of themes develop over time.",
  },
  {
    course_code: 'AML4640',
    course_name: 'Topics in Native American Literature',
    course_desc:
      'This course examines the history, form, and cultural context of Native American literature using a variety of texts and genres.  Oral traditions, material culture, and written texts will be considered.  Works by Native American authors will be examined in their own right, and in relation to texts by non-native writers.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'AML4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'AML5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'AML6455',
    course_name: 'Topics in American Literature',
    course_desc:
      'Studies in major figures or movements in American literature. Topics change each term. See department or instructor for specific topic.',
  },
  {
    course_code: 'AML6506',
    course_name: 'Topics in American Literature to 1900',
    course_desc:
      'This course examines canonical and non-canonical texts of early American literature. Emphasis on specialized study of one or more selected authors or genres. Theoretical and critical approaches current in the field will be stressed. In close consultation with the professor, students will produce a substantial body of written work reflecting their own research interests.',
  },
  {
    course_code: 'AML6507',
    course_name: 'Topics in American Literature 1900-Present',
    course_desc:
      'This course examines canonical and non-canonical texts post-1900 American literature. Emphasis on specialized study of one or more selected authors or genres. Theoretical and critical approaches current in the field will be stressed. In close consultation with the professor, students will produce a substantial body of written work reflecting their own research interests.',
  },
  {
    course_code: 'AML6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ANT2000',
    course_name: 'Introduction to Anthropology',
    course_desc:
      'Introduction to subdivision of anthropology and anthropological thought, basic treatment of human evolution, origins of civilization, world archaeology and modern work cultures, stressing the continuities of human nature.\nMeets General Education requirement in Social Sciences.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ANG5001',
    course_name: 'Archaeological Field Survey',
    course_desc:
      'Instruction in archaeological field survey techniques for the identification, location, and documentation of both terrestrial and submerged cultural resources. Subjects include research methodologies, cultural resource management process and regulations, ethical concerns relating to archaeological sites, remote sensing methodologies, magnetometer and sonar applications in maritime archaeology, collection of archaeological and environmental data, use of mapping and surveying equipment, field survey strategies and research design, fundamentals of data collection and recording, FMSF survey forms, report writing and production. Permission is required. Offered concurrently with ANT4820. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'ANG5080',
    course_name: 'Archaeological Field Survey',
    course_desc:
      'Instruction in archaeological field survey techniques for the identification, location, and documentation of both terrestrial and submerged cultural resources. Subjects include research methodologies, cultural resource management process and regulations, ethical concerns relating to archaeological sites, remote sensing methodologies, magnetometer and sonar applications in maritime archaeology, collection of archaeological and environmental data, use of mapping and surveying equipment, field survey strategies and research design, fundamentals of data collection and recording, FMSF survey forms, report writing and production. Permission is required. Offered concurrently with ANT4820. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'ANG5137',
    course_name: 'Nautical Archaeology Seminar',
    course_desc:
      'Method and theory of nautical archaeology, development as a discipline, ethical considerations, evolution of ship construction and public laws and education.',
  },
  {
    course_code: 'ANG5172',
    course_name: 'Historical Archaeology Seminar',
    course_desc:
      'Emphasizes the goals, methods and theoretical base of historical archaeology. Particular emphasis is placed on theoretical development, acculturation, ethnicity, archaeological methods and documentary research. The class is an organized seminar with readings and discussions of specific topics.',
  },
  {
    course_code: 'ANG5173',
    course_name: 'Historical Research Methods in Archaeology',
    course_desc:
      'A practical introduction to the use of historical documents in archeological research, both as primary sources of data for understanding the past, and as a complement to archaeological and other types of data. Examples and case-studies will center on the history of Florida during Spanish, British, and early American periods.',
  },
  {
    course_code: 'ANG5181',
    course_name: 'Geographic Information Systems in Archaeology',
    course_desc:
      'A methods course in the use of Windows based Geographic Information Systems (GIS) technology that teaches the basic skills necessary to use GIS for research in anthropology, archaeology and cultural resource management. GIS philosophy and concepts, database design and use, computer assisted cartography and anthropological research using ArcGIS will be covered.',
  },
  {
    course_code: 'ANG5191',
    course_name: 'Ritual Use of Human Remains',
    course_desc:
      'Ritual Use of Human Remains explores human mortuary practices and other ritual uses of bones, bodies, and body parts across the world and through time. Utilizing archaeological and ethnographic data from the New World (North America, South America, Mesoamerica, and the Caribbean), Old World (Africa, Asia, Europe, and the Near East), and Polynesia, the course introduces students to a diversity of ritual practices and outlines the theoretical concepts underlying their interpretation. \nCourse material will be presented in lecture format, supplemented by in-class discussions and team-based activities. Graduate student grades are based on two (2) non-cumulative exams, two (2) in-class essays, one (1) research paper, one (1) annotated bib, one (1) presentation, one (1) discussion-leader assignment, and in-class participation.  One textbook is required, and multiple non-textbook required readings are provided on the course website. Offered concurrently with ANT 4191, Graduate students will be assigned additional work.',
  },
  {
    course_code: 'ANG5408',
    course_name: 'Disease and Culture',
    course_desc:
      'Through lecture and discussion of readings we will explore the relationships between disease and culture. Main topics will include the basics of disease epidemiology in humans, human bio-cultural adaptations to disease, and the effects and influences of disease on human culture and society. Offered concurrently with ANT4532; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ANG5453',
    course_name: 'Anthropology of Human Rights',
    course_desc:
      'Examines contemporary debates, topics, and issues in human rights cross-culturally, and focuses on the history of the concept of human rights, universalism vs. particularism, gender, race, religion, social justice movements, and current human rights conventions.',
  },
  {
    course_code: 'ANG5472',
    course_name: 'Anthropology of Globalization',
    course_desc:
      'Critically analyzes globalization and the global processes and connections operating in the world today. Examines the complex interactions of people, ideas, economic systems, technologies, commodities, media and other forms that encompass globalization in the post-Cold War era. Offered concurrently with ANT4473; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ANG5514',
    course_name: 'Human Origins',
    course_desc:
      'Overview of the fossil evidence for human evolution, and hominid behavioral reconstruction using ethnographic and primate models. Offered concurrently with ANT4586; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ANG5516',
    course_name: 'Modern Human Physical Variation',
    course_desc:
      'This course provides an evolutionary perspective on biological variation in modern humans, a cultural context for how flawed interpretations of human variation have been historically misused, and a framework for learning from and rectifying the mistakes of the past. Offered currently with ANT4516; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ANG5520',
    course_name: 'Human Osteology',
    course_desc:
      'Detailed examination of human skeletal and dental anatomy, structure, and function. Techniques of osteological analysis, including determination of age, sex, stature, ancestry, and pathology. Offered concurrently with ANT4525; graduate students will be assigned additional work. Credit may not be received in both ANG5520 and ANG 5466.',
  },
  {
    course_code: 'ANG5536',
    course_name: 'Bioarchaeology',
    course_desc:
      'Bioarchaeology is the study of human skeletal remains from archaeological sites. It draws on techniques from archaeology, anatomy, biology, chemistry, pathology, demography, and history in order to reconstruct both individual lives and collective population histories across the globe.  Offered concurrently with ANT4536; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ANT2100',
    course_name: 'Introduction to Archaeology',
    course_desc:
      'Basic introduction to archaeology; includes fundamental principles, field and laboratory methods, theories construction, special sites and conditions, and ethics. Information from all over the world is used. Field trips to local archeological sites are usually included.\nMeets General Education requirement in Social Sciences.',
  },
  {
    course_code: 'MUS3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ANG5537',
    course_name: 'Food, Biology and Culture',
    course_desc:
      'This course is a biocultural examination of the relationship between food, human health, and society in past and present populations. Food is a fundamental link between human biology and culture; the great diversity of human food preferences, aversions, and avoidance is rooted in both of these domains. The objective of this course is to consider some of this diversity, and to try to achieve some understanding, within an evolutionary paradigm, of the causes and consequences of our food habits. Offered concurrently with ANT4537; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ANG5550',
    course_name: 'Primatology',
    course_desc:
      'Overview of the taxonomy, evolutionary history, ecology, and behavior of non-human primates, and the theoretical basis and methodology of primate studies. Offered concurrently with ANT4550; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ANG5803',
    course_name: 'Ethnographic Research Methods',
    course_desc:
      'This course serves as an opportunity for students to conduct original research, and to put anthropological theory and method into practice for insight into a small part of the human experience. We will conduct a semester-long research project, incorporating several of the methods anthropologists use "in the field" to better understand a cultural group: behavioral observation, interviews and surveys. From the resulting data, we will work together to analyze and interpret it, culminating in an original written ethnography. Offered concurrently with ANT4803; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ANG5836',
    course_name: 'Scientific and Research Diving',
    course_desc:
      'The Scientific Diving course would involve interdisciplinary instruction in both classroom and the field designed to give students an understanding on how to conduct scientific research safely in the underwater environment. Specific topics are based on the NOAA Diving Manual, and will include the history of scientific diving, diving physiology, approaches to scientific/research diving, background on different scientific diving methodologies, dive planning for scientific research, scientific diving in different environments, applications for underwater research, survey methods, data retrieval, site selection, underwater navigation, search and recovery techniques, instrument implementation, diving accident management and emergency procedures. Offered concurrently with ANT4836. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'ANG5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ANG6002',
    course_name: 'Proseminar in Anthropology',
    course_desc:
      "Examines selected subjects in anthropology using the perspectives of all three sub-disciplines; cultural anthropology, biological anthropology, and archaeology. The seminar's goals are to introduce students to the subject, provide in-depth understanding of current issues, and examine the variety of theoretical and methodological approaches used by anthropologists. Contact department for specific topic each semester offered. No more than 6 semester hours credit may be received.",
  },
  {
    course_code: 'ANG6093',
    course_name: 'Research Design in Anthropology',
    course_desc:
      'The fundamental issues of research design and implementation and the objectives and strategies of contemporary anthropological research. Scientific procedures and methods in the development of research programs that are logically structured and fundable. Alternative forms of deriving knowledge relating to important issues in epistemology and the philosophy of science will also be discussed.',
  },
  {
    course_code: 'ANG6110',
    course_name: 'Advanced Method and Theory in Archaeology Seminar',
    course_desc:
      'Includes an overview of the history and development of American archaeology with an emphasis on methodological and theoretical topics. Class is an organized seminar with readings and discussions of specific topics.',
  },
  {
    course_code: 'ANG6183L',
    course_name: 'Advanced Laboratory Methods in Archaeology',
    course_desc:
      'Advanced training in the operation of an archaeological laboratory. Activities include laboratory organization and management as well as planning laboratory activities to meet deadlines, assignment of tasks, training, and supervising beginning students. Graduate students will instruct undergraduate students in artifact identification and documentation. Credit may not be received in both ANG6183L and ANG 6823L.',
  },
  {
    course_code: 'ANG6196',
    course_name: 'Policies, Practices and Archaeology in Historic Preservation',
    course_desc:
      'Legislation and regulations concerning cultural resources and the historic preservation system. Also covers compliance archaeology, contract archaeology, ethics, collecting, looting and the role of Native Americans and ethnic groups.',
  },
  {
    course_code: 'ANG6286',
    course_name: 'Contemporary Cultural Anthropological Theory',
    course_desc:
      'Through readings and seminar discussion, students will explore key themes and thinkers of the past few decades which have contributed to the production of contemporary culture theory in anthropology. Important topics will include structuralism, cultural materialism, feminism and anthropology, post-modernism, world systems theory, post-colonialism, and symbolic anthropology. Key theorists will include Claude Levi-Strauss, Marvin Harris, Mary Douglas, Clifford Geertz, Sherry Ortner, Gayle Rubin, Pierre Bourdieu, Arjun Appadurai, and James Clifford.',
  },
  {
    course_code: 'ANG6583',
    course_name: 'Evolutionary Theory in Biological Anthropology',
    course_desc:
      'Overview of seminal literature and key concepts in evolutionary theory, with particular emphasis on contemporary issues in human bio-cultural evolution.',
  },
  {
    course_code: 'ANG6824',
    course_name: 'Advanced Archaeological Field Methods',
    course_desc:
      'Advanced training in field methods including survey, testing, and site excavation. Also includes training in project planning, budgeting, supervision, and integration of information recovered from the field. Material and Supply Fee will be assessed. Permission is required.',
  },
  {
    course_code: 'ANG6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ANG6971',
    course_name: 'Anthropology Thesis',
    course_desc:
      "Preparation of master's thesis which includes problem identification, review of literature, design, data collection, analysis, and results. Permission of Thesis Committee required. Graded on satisfactory / unsatisfactory basis only.",
  },
  {
    course_code: 'ANT1001',
    course_name: 'Anthropology as a Profession',
    course_desc:
      'This course serves as a one-credit introduction to the field of anthropology, the skills and training anthropologists typically receive, and the kinds of employment opportunities anthropologists are well-suited to fill.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ANT1138',
    course_name: 'Introduction to Maritime Studies',
    course_desc:
      'Basic introduction to maritime studies designed to familiarize students with the dynamic cultural and natural resources of the maritime environment. Students will gain knowledge and understanding of maritime environments.',
  },
  {
    course_code: 'APK4125L',
    course_name: 'Exercise Testing and Prescription Laboratory',
    course_desc:
      'Provides practical experience in body fat analysis, flexibility testing, basic exercise stress testing, the PWC - 170 Submaximal Aerobic Capacity test, and performance testing for 7 fitness parameters.',
  },
  {
    course_code: 'ANT2301',
    course_name: 'Human Sexuality and Culture',
    course_desc:
      'This course examines human sexuality from an anthropological perspective, which focuses on the diversity of experiences, beliefs and practices of sexuality across cultures and over time, including our evolutionary history. Using a critical lens, this course addresses cultural and biological dimensions of sex, gender, and sexuality, and engages with issues inclusivity, safety, and sexual and reproductive health.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ANT2400',
    course_name: 'Current Cultural Issues',
    course_desc:
      'Deals with the problems that confront American culture such as poverty, language, race, gender, and violence. Involves critical, analytical and objective thinking so that our own culture and values can be viewed more objectively and other cultures can be better understood and respected. An important element is to provide an understanding of the role of the individual in the continuation or amelioration of issues that afflict American society.\nMeets General Education requirement in Social Sciences.',
  },
  {
    course_code: 'ANT2511',
    course_name: 'Biological Anthropology',
    course_desc:
      'Human evolution and variation with emphasis on principles of evolution, primate biology, fossil records, variability in living populations, and the biological foundations of human culture capacities.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'ANT2511L',
    course_name: 'Biological Anthropology Lab',
    course_desc: 'Lab corresponding with ANT2511.',
  },
  {
    course_code: 'ANT2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ANT3015',
    course_name: 'Forensics in the Media',
    course_desc:
      'Provides students with relevant learning experiences focusing on the standard methods and techniques of forensic science and how it is inaccurately portrayed in popular media. Dispels CSI related myths in popular media, while learning about the multidisciplinary science behind real crime scene investigations.',
  },
  {
    course_code: 'ANT3101',
    course_name: 'Principles of Archaeology',
    course_desc:
      'Detailed explanation of the principles and methodology of current archaeology in U.S.; includes a brief history and theoretical orientation development of American archaeology.',
  },
  {
    course_code: 'ANT3137',
    course_name: 'Shipwreck Archaeology',
    course_desc:
      "Introductory course in Underwater Archaeology with an emphasis on American Maritime History and New World Archaeology as they relate to Pensacola's maritime heritage. The format centers on assigned readings and classroom meetings with lectures, discussions, educational slides and videos, and workshops. An attempt is made to incorporate field activities on at least one occasion.",
  },
  {
    course_code: 'ANT3141',
    course_name: 'Origins of Civilization',
    course_desc:
      'Cultural processes leading toward civilization and theories explaining the emergence of civilization. Comparison of the early civilizations of Mesopotamia, Egypt, India, China, Mesoamerica, and Peru.',
  },
  {
    course_code: 'ANT3153',
    course_name: 'North American Archaeology',
    course_desc:
      'Overview of archaeology of North America. Emphasis on patterns of development of regional cultures based on the archaeological record. Open to students in all majors.',
  },
  {
    course_code: 'ANT3158',
    course_name: 'Florida Archaeology',
    course_desc:
      'Archaeology of Florida with emphasis on general patterns of development of Florida Indians. Field trips to area archaeological sites.',
  },
  {
    course_code: 'ANT3212',
    course_name: 'Peoples and Cultures of the World',
    course_desc:
      'Culture areas of the world and frameworks for cultural comparison. Detailed study of representative peoples around the world gives emphasis to non-Western societies and the reporting tool of ethnography.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ANT3241',
    course_name: 'Anthropology of Religion',
    course_desc:
      'Connections of religion with the social organization, behavioral systems, and technology of traditional peoples outside the world of Western monotheism. Emphasis on animistic symbolism, shamanism, traditional metaphors for deities, and prehistoric, historic, or ethnographic accounts of ritual systems.',
  },
  {
    course_code: 'ANT3311',
    course_name: 'Indians of the Southeast: An Anthropological Perspective',
    course_desc:
      'Southeastern Indians is a survey course of the Native American groups in the Southeastern U. S. and their culture. It begins with an overview of prehistory and continues into the early 19th century. Examines such key areas as sociocultural archaeology, archaeology, biological archaeology, and history. Credit may not be received in both ANT3311 and ANT 3317.',
  },
  {
    course_code: 'ANT3312',
    course_name: 'North American Indians',
    course_desc:
      'Past and present life styles of the diverse Native American cultures north of Mexico; discussion of the major culture areas with emphasis upon Indians of the Southeastern United States.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ANT3352',
    course_name: 'African Cultures',
    course_desc:
      "An introduction to African culture and society. Examination and analysis of the social foundations, beliefs, practices, and institutions that make up the rich and unique cultural values of the African people. The aim is to broaden students' awareness of the beliefs, practices, and institutions that make up the cultural values of the African people. Attention will be given to pre-colonial years with an overview of the post-colonial era.",
  },
  {
    course_code: 'ANT3363',
    course_name: 'Japanese Culture',
    course_desc:
      'Basic introduction to the distinctive cultural heritage of the Japanese people. A brief overview of key historical events, fundamental philosophical tenets and basic religious beliefs form the background for exploring the prevalent customs, lifestyles and business practices in Japan today.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ANT3403',
    course_name: 'Cultural Ecology',
    course_desc:
      'Interactions between human cultures and the natural and social environment. Stress is placed on the adaptive aspect of human culture and the maintenance or disruption of the ecosystem.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ANT3520',
    course_name: 'Forensic Anthropology',
    course_desc:
      'Introduces students to the basic principles of forensic anthropology, and to current methods of determining personal identity, manner and cause of death, elapsed time since death, and other relevant information from skeletonized remains.',
  },
  {
    course_code: 'ANT3610',
    course_name: 'Language and Culture',
    course_desc:
      'Introduction to linguistic principles as they relate to the study of culture. Discussion of origins and nature of language. Direct applications of linguistic concepts in anthropological structure analyses and ethnography. Credit may not be received in both ANT3610 and ANT 3620.',
  },
  {
    course_code: 'ANT3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ANT4006',
    course_name: 'Anthropology of Human Rights',
    course_desc:
      'Examines contemporary debates, topics, and issues in human rights cross-culturally, and focuses on the history of the concept of human rights, universalism vs. particularism, gender, race, religion, social justice movements, and current human rights conventions. Offered concurrently with ANG5453; graduate students will be assigned additional work.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ANT4025',
    course_name: 'Ritual Use of Human Remains',
    course_desc:
      'Ritual Use of Human Remains explores human mortuary practices and other ritual uses of bones, bodies, and body parts across the world and through time. Utilizing archaeological and ethnographic data from the New World (North America, South America, Mesoamerica, and the Caribbean), Old World (Africa, Asia, Europe, and the Near East), and Polynesia, the course introduces students to a diversity of ritual practices and outlines the theoretical concepts underlying their interpretation. \nCourse material will be presented in lecture format, supplemented by in-class discussions and team-based activities. Grades are based on two (2) non-cumulative exams, two (2) in-class essays, one (1) research paper, and in-class participation. One textbook is required, and multiple non-textbook required readings are provided on the course website. Offered concurrently with ANG5191, Graduate students will be assigned additional work.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ANT4034',
    course_name: 'History of Anthropology',
    course_desc:
      'Development of anthropology with emphasis on the emergence of modern American discipline; detailed treatment of the formation of evolutionary, historical, functional and ecological orientations of the discipline.',
  },
  {
    course_code: 'ANT4115',
    course_name: 'Method and Theory in Archaeology',
    course_desc:
      'History and evolution of archaeological methods and theory in the United States. Major schools of thought and currently developing ideas are compared and contrasted: sampling theory, site formation, geosciences. Permission is required.',
  },
  {
    course_code: 'ANT4121',
    course_name: 'Combined Archaeological Field Methods',
    course_desc:
      'Onsite training in maritime and terrestrial archaeology (6 weeks each). Structured hands on experience including training in both field and laboratory methods. Emphasized methods include site control grids, setting up excavation units, basic excavation techniques, use of hand tools, identification of ship structure and features, screening techniques, field documentation, principles and procedures. A diving certificate from a nationally recognized program and permission is required. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'ANT4155',
    course_name: 'Archaeology of the Southeastern United States',
    course_desc:
      'Prehistory of the Southeastern United States including chronology, ways of life and the evolution of cultural adaptations for the past 15,000 years. Field trips to archaeological sites and museums will be conducted.',
  },
  {
    course_code: 'ANT4172',
    course_name: 'Historical Archaeology',
    course_desc:
      'Principles and methodology of historical archaeology; includes history of this specialty and theoretical development. Course is detailed and is required for Historical Archaeology graduate students prior to taking ANG5172. Field trips to local historical archaeology sites and museums and permission is required.',
  },
  {
    course_code: 'ANT4180L',
    course_name: 'Laboratory Methods in Archaeology',
    course_desc:
      'Introduction to the basic methods of processing, classifying, coding and analysis or archaeological material. Hands-on laboratory methods are taught utilizing collections from recent field school and project excavations. These materials may include European, Mexican, and Native American ceramics, glass, metal, lithics, masonry, plants, and faunal remains.',
  },
  {
    course_code: 'ANT4182C',
    course_name: 'Conservation of Archaeological Materials',
    course_desc:
      'Techniques of stabilizing and preserving deteriorated or corroded artifacts from archaeological sites. Hands on conservation techniques are taught in seminar / laboratory using chemicals and treatment procedures.',
  },
  {
    course_code: 'ANT4190',
    course_name: 'Historic Preservation in Archaeology',
    course_desc:
      'Includes a detailed review of basic historic preservation laws and regulations, the historic preservation system, and the articulation of archaeological resources in that system. Topics include historic preservation law, historic preservation system, archaeological resource management, and the contributions to the discipline of anthropology. Permission is required.',
  },
  {
    course_code: 'ANT4191C',
    course_name: 'Archaeological Data Analysis',
    course_desc:
      'Focuses on the methods and techniques of analysis of archaeological data which is an essential step in the interpreting of data. The analytical techniques of archaeological data include construction and use of spread sheets, digital image development and manipulation, map making, data base construction, management, and querying. Geographic Information Systems (GIS) and computer assisted drawing (CAD) will also be introduced. Windows applications for the personal computer are used to perform these analyses.',
  },
  {
    course_code: 'ANT4247',
    course_name: 'Anthropology of the Bible',
    course_desc:
      'Social and cultural interpretation of the scriptures pertinent to Hebrew / Aramaic and Eastern Mediterranean cultures from the 2nd century BCE through the 4th century CE. Students will read the assigned texts from the Torah, the Hebrew Bible generally, the Dead Sea Scrolls, the Christian canon, and the scriptures of the Naj Hammadi library. Offered concurrently with ANG 5247; graduate students will be assigned additional work. Credit may not be received in both ANT4247 and ANT 4174.',
  },
  {
    course_code: 'ANT4302',
    course_name: 'Sex Roles in Anthropological Perspective',
    course_desc:
      'Female and male behavioral, social and biological similarities and differences viewed from a biological-cultural perspective. Emphases upon evolution and cross-cultural comparison.',
  },
  {
    course_code: 'ANT4322',
    course_name: 'Mesoamerican Cultural Traditions',
    course_desc:
      'Students will explore important themes of Mesoamerican cultural tradition. Includes examination of both ancient and contemporary Native American culture in Mexico and Guatemala. Students will learn about continuities between ancient and contemporary Mesoamerican culture, including the ways in which indigenous cultural traditions are maintained in the face of persistent acculturative pressure, as well as about ways in which Native American cultural traditions in the region in other ways have been shaped and modified by the 500 year history since the Spanish Conquest. Offered concurrently with ANG 5322; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ANT4451',
    course_name: 'Race, Ethnicity, and Culture',
    course_desc:
      'Explores race and ethnicity and their relationship to culture in a cross-cultural, anthropological perspective. Will consider cultural constructions of race and ethnicity in the United States, in other areas of the Americas, and other areas of the world. Offered concurrently with ANG 5451; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ANT4473',
    course_name: 'Anthropology of Globalization',
    course_desc:
      'Critically analyzes globalization and the global processes and connections operating in the world today. Examines the complex interactions of people, ideas, economic systems, technologies, commodities, media and other forms that encompass globalization in the post-Cold War era.Offered concurrently with ANG5472; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ART3930',
    course_name: 'Special Topics in Painting and Drawing',
    course_desc:
      'Unique topics concerning painting and drawing. Students should have background of fundamentals in painting and/or drawing. Assignments will vary.',
  },
  {
    course_code: 'ANT4516',
    course_name: 'Modern Human Physical Variation',
    course_desc:
      'This course provides an evolutionary perspective on biological variation in modern humans, a cultural context for how flawed interpretations of human variation have been historically misused, and a framework for learning from and rectifying the mistakes of the past.  Offered concurrently with ANG5516 (Modern Human Physical Variation); graduate students will be assigned additional work.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ANT4523',
    course_name: 'Field Methods in Forensic Anthropology',
    course_desc:
      'On-site training in forensic field methods for the location, documentation, and recovery of human skeletal remains from surface and buried contexts. Includes use of surveying equipment and hand excavation tool. Permission is required.',
  },
  {
    course_code: 'ANT4525',
    course_name: 'Human Osteology',
    course_desc:
      'Detailed examination of human skeletal and dental anatomy, structure, and function. Techniques of osteological analysis, including determination of age, sex, stature, ancestry, and pathology. Offered concurrently with ANG5520; graduate students will be assigned additional work. Credit may not be received in both ANT4525 and ANT 4466.',
  },
  {
    course_code: 'ANT4532',
    course_name: 'Disease and Culture',
    course_desc:
      'Through lecture and discussion of readings we will explore the relationships between disease and culture. Main topics will include the basics of disease epidemiology in humans, human bio-cultural adaptations to disease, and the effects and influences of disease on human culture and society. Offered concurrently with ANG5408; graduate students will be assigned additional work. Credit may not be received in both ANT4532 and ANT 4408.',
  },
  {
    course_code: 'ANT4536',
    course_name: 'Bioarchaeology',
    course_desc:
      'Bioarchaeology is the study of human skeletal remains from archaeological sites. It draws on techniques from archaeology, anatomy, biology, chemistry, pathology, demography, and history in order to reconstruct both individual lives and collective population histories across the globe.  Offered concurrently with ANG5536; graduate students will be assigned additional work.\nPre requisite: ANT2511/L minimum grade C.',
  },
  {
    course_code: 'ANT4537',
    course_name: 'Food, Biology and Culture',
    course_desc:
      'This course is a biocultural examination of the relationship between food, human health, and society in past and present populations. Food is a fundamental link between human biology and culture; the great diversity of human food preferences, aversions, and avoidance is rooted in both of these domains. The objective of this course is to consider some of this diversity, and to try to achieve some understanding, within an evolutionary paradigm, of the causes and consequences of our food habits. Offered concurrently with ANG5537; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ANT4550',
    course_name: 'Primatology',
    course_desc:
      'Overview of the taxonomy, evolutionary history, ecology, and behavior of non-human primates, and the theoretical basis and methodology of primates studies. Offered concurrently with ANG5550; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ANT4586',
    course_name: 'Human Origins',
    course_desc:
      'Overview of the fossil evidence for human evolution, and hominid behavioral reconstruction using ethnographic and primate models. Offered concurrently with ANG5514; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ANT4651',
    course_name: 'Aesthetics & Critical Theory',
    course_desc:
      'Experiential and anthropological/semiotic examination of the topic of aesthetics as a central foundation of human culture. Students encounter working artists and scholars, engage Western and non-Western systems of aesthetic value, develop tools for several kinds of postmodern cultural criticism, and explore personal constructions of aesthetics and cultural studies. Permission is required.',
  },
  {
    course_code: 'ANT4803',
    course_name: 'Ethnographic Research Methods',
    course_desc:
      'This course serves as an opportunity for students to conduct original research, and to put anthropological theory and method into practice for insight into a small part of the human experience. We will conduct a semester-long research project, incorporating several of the methods anthropologists use "in the field" to better understand a cultural group: behavioral observation, interviews and surveys. From the resulting data, we will work together to analyze and interpret it, culminating in an original written ethnography. Offered concurrently with ANG5803; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ANT4808',
    course_name: 'Applied Anthropology',
    course_desc:
      'Methods and techniques of applied anthropology, including ethical issues and approaches to planned culture change - social intervention, policy formation, small scale systems analysis. Practical activities in the local community will be included in the course.',
  },
  {
    course_code: 'ANT4820',
    course_name: 'Archaeological Field Survey',
    course_desc:
      'Instruction in archaeological field survey techniques for the identification, location, and documentation of both terrestrial and submerged cultural resources. Subjects include research methodologies, cultural resource management process and regulations, ethical concerns relating to archaeological sites, remote sensing methodologies, magnetometer and sonar applications in maritime archaeology, collection of archaeological and environmental data, use of mapping and surveying equipment, field survey strategies and research design, fundamentals of data collection and recording, FMSF survey forms, report writing and production.  Offered concurrently with ANT 5001. Graduate students will be assigned additional work.Permission is required.',
  },
  {
    course_code: 'ANT4824',
    course_name: 'Terrestrial Archaeological Field Methods',
    course_desc:
      'Onsite training in terrestrial field methods includes use of hand tools, surveying equipment, and some power equipment. Emphasized in the field are excavation techniques in a variety of situations, field scale drawings, and documentation. Field lab methods are often included. Permission is required. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'ANT4835',
    course_name: 'Maritime Archaeological Field Methods',
    course_desc:
      'Onsite training in maritime archaeology. Structured hands on experience including training in both field and laboratory methods. Emphasized methods include site control grids, setting up excavation units, basic excavation techniques, use of hand tools, identification of ship structure and features, screening techniques, field documentation, principles and use of field instruments, and field conservation procedures. A diving certificate from a nationally recognized program and permission is required. Credit may not be earned in both ANT 4135 and ANT4835. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'APK4125',
    course_name: 'Exercise Testing and Prescription',
    course_desc:
      'Physiological theory, administrative principles and techniques of exercise testing and prescription. Includes health appraisal, risk stratification, and goal setting. Students are required to complete an exercise prescription assignment outside of class.',
  },
  {
    course_code: 'MUS4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ANT4836',
    course_name: 'Scientific and Research Diving',
    course_desc:
      'The Scientific Diving course would involve interdisciplinary instruction in both classroom and the field designed to give students an understanding on how to conduct scientific research safely in the underwater environment. Specific topics are based on the NOAA Diving Manual, and will include the history of scientific diving, diving physiology, approaches to scientific/research diving, background on different scientific diving methodologies, dive planning for scientific research, scientific diving in different environments, applications for underwater research, survey methods, data retrieval, site selection, underwater navigation, search and recovery techniques, instrument implementation, diving accident management and emergency procedures. Offered concurrently with ANG5836. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'ANT4853C',
    course_name: 'Geographic Information Systems in Anthropology',
    course_desc:
      'Application of Geographical Information Systems technology in anthropology, archaeology and cultural resource management.',
  },
  {
    course_code: 'ANT4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ANT4944',
    course_name: 'Anthropology Internship',
    course_desc:
      'Placement in community agency or other social or organizational setting. Supervision by faculty and agency. Student participates in full range of services available in the setting. An internship paper is required. A maximum of 6 sh may be applied to the major requirements. Permission is required.',
  },
  {
    course_code: 'ANT4945',
    course_name: 'Anthropology Capstone',
    course_desc:
      "This course is designed to bring together an interplay of ideas gained through the courses required for the anthropology major. Students will debate, discuss, and critically assess the different perspectives and approaches within the discipline to current issues and problems related to the chosen topic. This course should be taken near the end of students' program.",
  },
  {
    course_code: 'APK2000',
    course_name: 'Introduction to Exercise Science',
    course_desc:
      'This course is an introduction to the discipline of Exercise Science and provides an overview of exercise physiology, sport and exercise psychology, biomechanics, motor behavior, sport nutrition, and other related topics. This course also provides information on career paths that stem from the Exercise Science discipline.',
  },
  {
    course_code: 'APK2100C',
    course_name: 'Applied Human Anatomy and Physiology I with Laboratory',
    course_desc:
      'This class is the first of a two-semester sequence which provides a comprehensive study of human anatomy and physiology from a systematic approach. Topics include the structure, function, and interrelationship of organ systems with an emphasis on the processes which produce movement and maintain homeostasis. Understanding anatomical terminology, gross structures, and locations of different body structures are primary objectives. Upon completion, students should be able to demonstrate an in-depth understanding of the principles of anatomy and physiology and their interrelationships. This course is designed for students interested in pursuing study in the health professions.',
  },
  {
    course_code: 'APK2105C',
    course_name: 'Applied Human Anatomy and Physiology II with Laboratory',
    course_desc:
      'This course is the second of a two-semester sequence of the study of the structure, function, and homeostasis of the human body. The endocrine, cardiovascular, lymphatic, respiratory, digestive, urinary and reproductive systems, as well as the concepts of development, metabolism, fluid and electrolyte balance, acid-base balance, and the ability to apply these in novel situations are included. Upon completion, students should be able to demonstrate an in-depth understanding of the principles of anatomy and physiology and their interrelationships. This course will encourage students to consider how physiological systems are dependent on each other, and develop the ability to apply this understanding in novel case-based situations. This course will provide a sound basis in human anatomy and physiology to support further study in health and medical sciences, or related fields.',
  },
  {
    course_code: 'APK3110',
    course_name: 'Exercise Physiology',
    course_desc:
      'Application of physiological principles to the study of human physical performance related to health, sports, and leisure activities.',
  },
  {
    course_code: 'APK3110L',
    course_name: 'Exercise Physiology Laboratory',
    course_desc:
      'Student shall become familiar with instruments and test procedures used to gather data on the physiology of exercise. Material and Supply fee will be assessed.',
  },
  {
    course_code: 'APK3220',
    course_name: 'Biomechanical Basis of Movement',
    course_desc:
      'The fundamentals of engineering (kinematics and kinetics) related to motor skills and human performance are introduced. Basic college mathematics and physics knowledge will be applied to problem solving in a classroom setting.',
  },
  {
    course_code: 'APK3220L',
    course_name: 'Biomechanical Basis of Movement Laboratory',
    course_desc:
      'As a co-requisite to the lecture course APK3220, the laboratory section allows for hands-on experiences relative to human movement. Students will interact with biomechanical data collection systems, including three-dimensional motion capture, electromyography, accelerometry, and force plates. Students will gather data necessary to complete a condensed research project.',
  },
  {
    course_code: 'APK3232',
    course_name: 'Measurement and Evaluation in Health, Leisure, and Sports',
    course_desc:
      'Application of measurement and evaluation principles to study of man and human performance related to health, leisure and sports activities. Instructional designs of physical fitness, sport skills and knowledge testing are examined.',
  },
  {
    course_code: 'APK4114C',
    course_name: 'Physiological Basis of Strength Development',
    course_desc:
      'This course covers the physiological functions of skeletal muscle and the dynamics of strength development.',
  },
  {
    course_code: 'APK4119',
    course_name: 'Exercise Testing for Special Populations',
    course_desc:
      'This course is designed to provide the student with a basic understanding of the pathophysiology and exercise responses in special populations based on the American College of Sports Medicine guidelines. The course will also focus on the understanding diagnostic techniques and medical and surgical treatments practiced in each of these subcategories. Special attention will be given to applicable exercise assessment techniques used in the laboratory and in clinical exercise settings.',
  },
  {
    course_code: 'DEC4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ECT5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'APK4163',
    course_name: 'Sports Nutrition',
    course_desc:
      'Students will examine the fundamental principles of sports nutrition, with an emphasis on evidence-based nutritional strategies to optimize health, fitness, and athletic performance. Topics include human energy systems, optimal nutrient amounts and timing, and weight management strategies in sports.',
  },
  {
    course_code: 'APK4200',
    course_name: 'Neuromechanics of Human Movement',
    course_desc:
      'This course covers the neural mechanisms associated with human movement and control. Central and peripheral components associated with movement will be discussed. A major emphasis will be placed on the mechanistic control of coordinated movement. This course includes high impact practices (HIPs) where students critically critique relevant literature and evaluate different aspects of human movement and control in a variety of laboratory experiences related to course topics.',
  },
  {
    course_code: 'APK4234C',
    course_name: 'Electrocardiogram Interpretation and Graded Exercise Testing',
    course_desc:
      'The acquisition and interpretation of both resting and exercise electrocardiograms is covered, as well as an overview of heart anatomy, function and electrophysiology. Students are taught to identify various cardiac dysrhythmias and to administer a graded exercise test according to the American College of Sports Medicine guidelines. Students will engage in laboratory hands-on assignments that will include prepping of subjects, conduction and interpretation of a resting and graded exercise test. Department Permission is required.',
  },
  {
    course_code: 'APK4409',
    course_name: 'Success in Sports',
    course_desc:
      'Success in Sports (SIS) is an integration of cross-boundary research documenting the determinants of success in sports. Special emphasis will be placed on elite athletic performance. Will be organized round theoretical accounts for the attainment of elite performance. In addition, the themes of Who in which profiles characteristics of elite athletes will be presented. Why in which inherited and acquired capacities responsible for elite performance will be presented, and How in which selected techniques to maximize training effects will be examined.',
  },
  {
    course_code: 'APK4600C',
    course_name: 'Aging and Physical Performance',
    course_desc:
      'Provides an overview of the aging process and its effects on physical performance, and the major effects of regular exercise on the aging process. Emphasis will be placed on the understanding of the physiological, psychological and social factors which affect movement capabilities, the assessment of physical performance, and the development of activity programs for the aging.',
  },
  {
    course_code: 'APK4610C',
    course_name: 'Applied Resistance Training and Conditioning',
    course_desc:
      'This course covers advanced techniques of resistance training and conditioning to improve athletic performance and will be taught mainly as a laboratory/practical experience. The student will gain hands-on experience in Olympic-style lifting techniques, unilateral training, free-weight exercises and techniques for alternative modes and nontraditional implement training.',
  },
  {
    course_code: 'APK4901',
    course_name: 'Research Methods in Exercise Science',
    course_desc:
      'This course examines the scientific method and the role of research in developing knowledge in the discipline of Exercise Science. Students will gain experience to become critical consumers of research.',
  },
  {
    course_code: 'APK4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'APK4941C',
    course_name: 'Senior Capstone Experience in Exercise Science',
    course_desc:
      'As a capstone experience for Exercise Science students, this 6-credit course will provide opportunities for students to put theory into practice through active participation in on-the-job related participation. Students are supervised by practitioners in an Exercise Science relevant field and by faculty academic support. Additionally, students are required to attend a series of five (5) online lectures on topics related to professionalism, management, legal and health behavior in the health and fitness industry. Departmental permission, attendance to initial internship meeting, and online lectures are mandatory.',
  },
  {
    course_code: 'APK4944',
    course_name: 'Exercise Science Practicum',
    course_desc:
      'A laboratory practicum course for evaluation, review, and mastery of the competencies required per ACSM guidelines and CAAHEP accreditation standards.',
  },
  {
    course_code: 'APK5116C',
    course_name: 'Applied Physiology in Muscular Development',
    course_desc:
      'Knowledge and understanding of the physiological functions of skeletal muscle and the dynamics of strength development.',
  },
  {
    course_code: 'APK5204',
    course_name: 'Applied Motor Learning/Control in Exercise Science',
    course_desc:
      'Advanced study of principles / theories of human motor learning, behavior, performance.',
  },
  {
    course_code: 'APK5601',
    course_name: 'Preventative Health in the Aging Population',
    course_desc:
      'Provides an overview of the aging process and its effects on physical performance, and the major effects of regular exercise on the aging process. Emphasis will be placed on the understanding of physiological, psychological, and social factors affecting movement capabilities, the assessment of physical performance, and the development of activity programs for the aging population.',
  },
  {
    course_code: 'APK5702',
    course_name: 'Statistics in Exercise Science',
    course_desc:
      'This course covers statistical analysis methods for descriptive, correlational, and experimental designs. Descriptive statistics, linear regression, introduction to multiple regression, t-ratio, analysis of variance for independent and repeated measures designs, factorial designs (Independent Groups, Repeated Measures, and Mixed Factorials), Analysis of Covariance, MANOVA, Chi square, and Non-parametric measures are included. Discriminant Function Analysis, and Power Analysis. In addition, reliability and validity issues related to experimental designs are addressed. Students receive instruction in the use of SPSS.',
  },
  {
    course_code: 'APK6111C',
    course_name: 'Advanced Exercise Physiology',
    course_desc:
      'Research and problems in exercise physiology; advanced study of reactions of the human body under stress and during exercise. Material and supply fee will be assessed.',
  },
  {
    course_code: 'ARH4892',
    course_name:
      'Inscribed Bodies: Concepts of Tattoo and Body Art in World History',
    course_desc:
      'Explores the history of body art, from its association with prehistoric non-western cultures to contemporary artistic expression.  Topics include: tattoo, piercings, body modification, adornment, conceptions of beauty, status, power, and identity.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ARH4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'APK6127C',
    course_name: 'Clinical Exercise Testing and Interpretation',
    course_desc:
      'Physiological theory, administrative principles and techniques of exercise testing and prescription. Includes health appraisal, risk stratification, and goal setting. Students are required to complete an exercise prescription assignment outside of class. Course includes hands on experience in exercise testing with advanced equipment including hydrostatic weighing, environmental conditions, and blood glucose and lactate analysis. Course concludes with a student presentation of an exercise prescription based on testing results, medical and exercise history and risk stratification. Material and Supply fee will be assessed.',
  },
  {
    course_code: 'APK6167C',
    course_name: 'Advanced Human Nutrition and Metabolism',
    course_desc:
      'An advanced study of the role of nutrition as a means to enhance performance in exercise and sport. Topics include principles of energy metabolism, nutrients in their use during exercise, regulation of metabolism by macro and micro nutrients and their role in weight control with athletes. The validity and safety of proposed ergogenic aids are also explored. This course will evaluate the role of nutrition and supplementation vis-à-vis exercise. Topics include: fat, carbohydrate, protein, vitamin, mineral and water needs of the active person; energy metabolism; nutritional and body composition issues; nutritional concerns for special groups; sports supplements; body composition issues.\nPrerequisites: An undergraduate exercise physiology class.',
  },
  {
    course_code: 'APK6172C',
    course_name: 'Cardiac Electrophysiology',
    course_desc:
      'This course is designed to instruct students in the acquisition and interpretation of resting and exercise, normal and abnormal electrocardiograms. This course will acquaint students in identifying several supraventricular and ventricular dysrhythmias as well as the procedures for exercise testing and prescription in healthy and diseased populations.',
  },
  {
    course_code: 'APK6226',
    course_name: 'Analysis of Human Movement',
    course_desc:
      'The course will provide students with the tools necessary to collect and analyze characteristics of human movement using current neuromechanical technologies. Students will engage in neuromechanical study design, implementation, analysis, and dissemination within the laboratory setting.',
  },
  {
    course_code: 'APK6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'APK6940',
    course_name: 'Internship in Exercise Science',
    course_desc:
      'This course provides opportunities for graduate students to complete an internship in an agency or organization directly related to the exercise science discipline for the purpose of gaining necessary experience in the field. Faculty and agency personnel will supervise the student as the student participates in a wide range of services available in the setting. Goals and objectives will be planned by the student, instructor, and agency supervisor. Reports will be required on a regular basis with a final comprehensive exam on topics related to exercise science. Permission is required.',
  },
  {
    course_code: 'APK6970',
    course_name: "Research for Master's Thesis",
    course_desc:
      'Graded on satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'ARA1120C',
    course_name: 'Beginning Arabic and Language Culture I',
    course_desc:
      'Designed for students with no experience in the Arabic language to develop knowledge through listening, speaking, reading, and writing Modern Standard Arabic. Focuses primarily on cultural understanding of the Arabic world, and basic Arabic language pronunciation, comprehension, communication, and grammar. In addition to the scheduled activities, students are required to complete weekly laboratory assignments.',
  },
  {
    course_code: 'ARA1121C',
    course_name: 'Beginning Arabic and Language Culture II',
    course_desc:
      'Continuation of ARA1120C emphasizing listening and speaking skills with continued practice in reading and writing. Basic grammatical structures will be reviewed and new grammar introduced. The cultural component consists of in-depth considerations of issues in the Arabic world.',
  },
  {
    course_code: 'ARA2200C',
    course_name: 'Intermediate Arabic Language and Culture I',
    course_desc:
      'Continuation of ARA1121C with increased complexity of grammatical constructions, greater emphasis on reading and writing and increased use of authentic materials. Some of the cultural information will be given in Arabic.',
  },
  {
    course_code: 'ARE3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ARE4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ARH1000',
    course_name: 'Art Appreciation',
    course_desc:
      'Surveys the key monuments of Western art and architecture from the upper Paleolithic period to the modern era. Not open to art majors. Credit may not be received in both ARH1000 and ARH1010.\nMeets General Education requirement in Humanities.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ARH2050',
    course_name: 'Western Survey I: Prehistory to the Medieval Period',
    course_desc:
      'Analyzes the western aesthetic heritage within its cultural context from the birth of art through the Medieval period.\nMeets General Education requirement in Humanities.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ARH2051',
    course_name: 'Western Survey II: Renaissance to Contemporary',
    course_desc:
      'Analyzes the Western aesthetic heritage within its cultural context from the fifteenth century to the present. Required of all art majors. Satisfies the lower division requirement, ARH1000.\nMeets General Education requirement in Humanities.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ARH3150',
    course_name: 'Ancient Roman Art and Architecture',
    course_desc:
      'Explores the development of art and architecture of ancient Rome, from its foundation to the breakup of the empire and the death of Constantine.  Important works, sites, and architectural achievements will be studied within the context provided by history, archaeology, literature, and ideology.',
  },
  {
    course_code: 'ARH3255',
    course_name: 'Medieval European Visual Culture',
    course_desc:
      'This course will survey the development of the visual arts in western Europe in the period 4th century into the early 15th century.  The formation of a distinctive medieval European visual culture will be considered through the study of selected objects and translated primary sources.  The development of European aesthetic principles will be studied in the context of the regional centers of the British Isles, France, the Holy Roman Empire, Southern Europe, and Iberia.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'ARH4911',
    course_name: 'Research in Art History',
    course_desc:
      'Provides the advanced art history student with an opportunity to execute an intensive original research project, one which ideally leads to publication or implementation. This is the capstone experience for art history. Prereq.: ARH2050, ARH2051.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'ECT6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ARH3301',
    course_name: 'Early European Renaissance',
    course_desc:
      'This course will examine the visual arts in western Europe from the 14th to the 15th century.  Through a variety of visual and translated written sources, we will actively reconsider the idea of the Renaissance visual culture outside of the long-standing paradigms of the Italian and Northern Renaissance.  The effect of cultural exchange will be considered against the formation of increasingly regional identities, and the influence of changing economic, social, political, and ideological conditions.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'ARH3303',
    course_name: 'Late European Renaissance',
    course_desc:
      'This course will examine the visual arts in western Europe from the 15th to the 16th century.  Through a variety of visual and translated written sources, we will actively reconsider the idea of the Renaissance visual culture outside of the long-standing paradigms of the Italian and Northern Renaissance.  We will sample a variety of media produced in major centers of artistic production.  Special consideration will be given to the continued process of artistic exchange within Europe, as well as the lasting influence of new discoveries and broadened cultural contacts.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'ARH3350',
    course_name: 'Baroque Art and Architecture',
    course_desc:
      'Explores artistic expression in Italy, France, Spain, the Low Countries, England, Germany and Austria in the 17th and early 18th centuries.  Examines the work of major artists from the period from within regional social and cultural contexts, as well as European and worldwide cultural contacts.  Major works of art will be considered in context with notions of religion, morality, humor, and history.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'ARH3590',
    course_name: 'Non-Western Art',
    course_desc:
      'The changing interpretations of non western art will be examined in the context of contemporary opinion. Emphasis will be placed on the arts of Asia, Africa, Oceania, and the Americas.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ARH3607',
    course_name: 'Native American Art',
    course_desc:
      'This course examines the history of Native North American art from its prehistory to the present.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ARH3621',
    course_name: 'American Art',
    course_desc:
      'A comprehensive survey of American painting, sculpture, and architecture from the seventeenth century to the third quarter of the twentieth century.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'ARH3724',
    course_name: 'History of Graphic Design',
    course_desc:
      'An analysis of the history of Graphic Design from its inception through its current role in contemporary society. Explores the historical relationship between graphic design and additional design disciplines such as: fashion, architecture, industrial, furniture and digital media design.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'ARH3871',
    course_name: 'Women in Art',
    course_desc:
      "Investigates the history and issues surrounding the roles of women in the visual arts: women as artists, models, subjects, and patrons. Explores differences in the portrayal of women by both women and men artists. Includes assessment of women's themes, materials, critical theory, and cultural identities.\nMeets Gordon Rule Writing Requirement.",
  },
  {
    course_code: 'ARH3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ARH4302',
    course_name: 'Late Renaissance Art in Italy',
    course_desc:
      'Examines the achievements of Italian artists and architects during the Cinquecento, including the art of Leonardo, Michelangelo, Raphael, Titian, Bramante and other noted masters. Offered concurrently with ARH 5314; graduate students will be assigned additional work.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ARH4305',
    course_name: 'Early Italian Renaissance Art',
    course_desc:
      'Examines the growth of the Italian Renaissance style in architecture, sculpture and painting from the late Dugento to the end of the Quattrocento. Offered concurrently with ARH 5315; graduate students will be assigned additional work.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ARH4412',
    course_name: 'The Age of Revolution to Romanticism in Europe: 1750-1850',
    course_desc:
      'Focuses on the conflict between revolutionary and conservative forces in European art from Neo-Classicism to Romanticism.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ARH4417',
    course_name: 'Art and Science in the Nineteenth Century',
    course_desc:
      'This course considers topics and ideas in the representation of emergent scientific theories of the nineteenth century and the complex entanglement of artistic and scientific imagery.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'ARH4450',
    course_name: 'Modern Art: 1850-1980',
    course_desc:
      'Ideas and styles which shaped the course of avant-garde art from Realism to 1980.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ARH4470',
    course_name: 'Contemporary Art',
    course_desc:
      'Central issues and concepts of contemporary movements in art.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ARH4563',
    course_name: 'Art of Japan',
    course_desc:
      'Major works of art from Japanese history will be explored within their social, political, and ideological contexts.  Students will gain a broad knowledge of the important developments in Japanese visual culture.  The course covers the time period ranging from the Neolithic to Contemporary.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ARH4710',
    course_name: 'History of Photography',
    course_desc:
      'The history of photography and how it documents, relates to, reflects, and shapes history, culture and the arts. Offered concurrently with ARH 5715; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ARH4723',
    course_name:
      'History of Graphic Design 2: Late Modern, Postmodern, and Contemporary',
    course_desc:
      'A follow up to the History of Graphic Design with special attention on work from the mid twentieth century through today.',
  },
  {
    course_code: 'ARH4830C',
    course_name: 'Museum and Gallery Studies',
    course_desc:
      'Examines in depth the theoretical and practical aspects of museum / gallery management. Includes promotion, finance, grantsmanship, space design and other related issues. Offered concurrently with ARH5836; graduate students will be assigned additional work. Credit may not be received in both ARH4830C and ARH 3830C.',
  },
  {
    course_code: 'ARH4835',
    course_name: 'Museum and Gallery Studies Practicum',
    course_desc:
      'Advanced study of theoretical and practical aspects of museum / gallery management through placement in a non-profit museum or gallery. Students participate in full range of activities available in the setting, but are also expected to complete a specific museum / gallery project. Offered concurrently with ARH 5947; graduate students will be assigned additional work. Permission is required.',
  },
  {
    course_code: 'ARH4930',
    course_name: 'Theory and Methods in Art History',
    course_desc:
      'Explores the many methodologies employed by art historians to understand works of art, including biography, formalism, psychoanalysis, iconography, semiotics,Post-Structuralism, Marxism, Feminism, and Postcolonial Theory.   Required for art history majors.Prereqs. ARH2050, ARH2051.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'ARH4940C',
    course_name: 'Internship in Art History',
    course_desc:
      'This course offers immersive experience for students with an internal or external internship partner, integrating key elements of professions in the field of art history and focusing on the acquisition of 21st Century skills. Internships are on an "as available" basis; Art Majors may request an internship by submitting written proposals to the Department\'s Internship Coordinator, their advisor, or the Chair. Proposals must be approved by the Internship Coordinator prior to registration as well as by the advisor and sponsor. Senior status, 2.5 GPA overall, and a 3.0 GPA in the major is required. All internships include reports on internship experience, including weekly journals, written reports, and an oral presentation to Internship coordinator. Graded on a satisfactory/unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'ARH5836',
    course_name: 'Museum and Gallery Studies',
    course_desc:
      'Examines in depth the theoretical and practical aspects of museum/gallery management. Includes promotion, finance, grantsmanship, space design and other related issues. Offered concurrently with ARH4830C; graduate students will be assigned additional work. Permission is required.',
  },
  {
    course_code: 'ARH5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ARH6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ART1001C',
    course_name: 'Studio Art for Beginners',
    course_desc:
      'This course is designed as an introduction to diverse studio art practices and disciplines that potential art majors will need, including portfolio development. Students can have general "high-school" level experience with studio art but this isn\'t necessary.A sampling of Painting, Drawing, Ceramics, and Print Making will be studied through discussion and studio practice. Students will also begin developing their own portfolios for critique.',
  },
  {
    course_code: 'ART1015C',
    course_name: 'Exploring Artistic Vision',
    course_desc:
      'Challenges the student to explore alternative modes of perception and interpretation, through lectures, discussion, and hands-on application. Material and Supply fee will be assessed.\nMeets General Education requirement in Humanities.',
  },
  {
    course_code: 'ART1300C',
    course_name: 'Drawing I - Fundamentals',
    course_desc:
      'Students will study several media and how to use them. Instruction in drawing still life, landscapes and other objects / subjects provided. Students develop perception of proportions along with black / white media compositional concepts. Invites all students. Material and supply fee will be assessed.',
  },
  {
    course_code: 'ART1301C',
    course_name: 'Drawing II - Fundamentals',
    course_desc:
      'Continuation and further development of the studies in ART1300C. Material and supply fee will be assessed.',
  },
  {
    course_code: 'ART2201C',
    course_name: 'Two-Dimensional Design',
    course_desc:
      'Introduction to the concepts by which shape, value and color control space; ideas fundamental to the visual arts. Invites all students. Material and supply fee will be assessed.',
  },
  {
    course_code: 'ART2203C',
    course_name: 'Three-Dimensional Design',
    course_desc:
      'Designed to provide the beginning art major with a firm grounding in the technical strategies needed to create forms in space. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'ART2400C',
    course_name: 'General Printmaking',
    course_desc:
      'Introduction to various printmaking techniques possibly including block printing, calligraphy, monotype, etching and engraving. Content varies according to instructor. Prerequisite for all other printmaking courses. Invites all students. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'ART2500C',
    course_name: 'Painting I - Fundamentals',
    course_desc:
      'Students will study paint, color, the tools to use and how to use them. The student is instructed to paint using still life, landscapes, possibly figures, and other objects / subjects. Some materials supplied. Primarily an introductory painting course for art majors. Credit may not be earned in both ART 2510C and ART2500C. Material and supply fee will be assessed.',
  },
  {
    course_code: 'ART2602C',
    course_name: 'Introduction to Digital Studio Practice',
    course_desc:
      'A prerequisite for all courses in the Digital Practice Studio. Students gain a working knowledge of Apple Macintosh OS, are introduced to the basics of Adobe Photoshop and exposed to the myriad of programs and equipment available in the Department of Art Mac Lab. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'ART2701C',
    course_name: 'Fundamentals of Sculpture',
    course_desc:
      'Course explores a wide range of contemporary sculpture, and familiarizes students with current genres and issues. Assignments develop important foundational skills in 3-D design, construction and materials, while challenging the mind with compelling concepts. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'ART2821',
    course_name: 'The Self, Creativity, Your Career and Visual Culture',
    course_desc:
      'This class is designed to teach students abstract and creative thinking through the dynamics of visual culture.  Incorporated into the course are the ways we process and read the visual world that surrounds us. Students will explore theories of cognition and creativity.  Although this course is based in theoretical constructs, the practice of High Impact Learning experiences will be utilized in order to apply creative thinking in the major field of study students are pursuing. Ultimately, students will learn how to apply the creative method to a diverse array of disciplines, helping to foster entrepreneurship in their chosen career paths.\nMeets General Education requirement in Humanities.',
  },
  {
    course_code: 'ART2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ART3213C',
    course_name: 'Advanced Ideas and Concepts',
    course_desc:
      'A personal and group exploration of the artistic process, which harnesses the skills developed in the foundation art and media-based course to expand the creative potential. For advanced art majors and all BFA candidates in their junior year. Material and Supply fee will be assessed.',
  },
  {
    course_code: 'ART3312C',
    course_name: 'Drawing III: The Figure',
    course_desc:
      'Requires essential education in drawing the human figure, whose accurate visualization remains a vital component of all artistic media and practice. Builds on the foundation art courses in drawing and two dimensional-design, which are necessary prerequisites. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'ART3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDA3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ART3313C',
    course_name: 'Drawing for Non-Majors',
    course_desc:
      'Drawing for Non-Majors is for beginning artists who want to improve their drawing skills. Emphasizes composition, line, proportion, perspective, value, shading, and introduces color. Students will explore the technical handling of different types of materials through exercises and finished drawings. Material and Supply fee will be assessed.',
  },
  {
    course_code: 'ART3442C',
    course_name: 'Advanced Printmaking: Intaglio',
    course_desc:
      'Discussion and exploration into a variety of printmaking techniques unique to the intaglio process. The philosophical and functional aspects of the course will be cultivated. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'ART3504C',
    course_name: 'Painting II-Intermediate',
    course_desc:
      "Includes fundamentals review. Develops individuality. Uses observational and conceptual experiences / project. Stresses understanding / perceiving color, using media and techniques appropriate to the student's personal development. Primarily for art majors. Credit may not be earned in both ART 3530C and ART3504C. Material and Supply Fee will be assessed.",
  },
  {
    course_code: 'ART3505C',
    course_name: 'Painting III-Advanced',
    course_desc:
      'Individual development in media, technique and concept will be stressed. Possibilities of painting other than easel painting will be presented. Investigation and experimentation responding to situations and projects is required. Credit cannot be received for both ART3505C and ART 3405C.',
  },
  {
    course_code: 'ART3507C',
    course_name: 'Painting for Non-Majors',
    course_desc:
      'Students will study paint, color, the tools to use and how to use them. The student is instructed to paint using still life, landscapes, possibly figures, and other objects / subjects. Some materials supplied. Primarily an introductory painting for majors outside of art. Invites all students. Material and Supply Fee will be assessed. Credit may not be received in both ART3507C and ART 3500C.',
  },
  {
    course_code: 'ART3613C',
    course_name: 'Digital Multimedia',
    course_desc:
      'Issues and applications of digital technology and critical thinking in art. Conceptual utilization of both theoretical thinking and contemporary digital studio art practice, with possible emphasis on video art, video streaming technology, emerging technology, installation, programming and / or robotics to be determined by instructor. Students work both individually and collaboratively on projects that can involve video, space, time, objects, film, robotics, programming, or any other appropriate media. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'ART3618C',
    course_name: 'Introduction to Web-based Art',
    course_desc:
      'An introduction to the Internet as a platform for fine art practice. A study of the history of web-based interactive artworks, contemporary concepts and issues are explored through regular critiques, readings, and screenings. Students will produce and critique artworks using HTML, scripting, and software-based site production for the web. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'ART3630C',
    course_name: "Artist's Video",
    course_desc:
      'An introduction to digital video using Final Cut Pro, iMovie, and After Effects. Focuses on video as an art medium, the history of video art and looking at examples from key artists of our time. Students must purchase a flash drive or a firewall external hard drive of at least 40GB for use in this class. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'ART3660C',
    course_name: 'Digital Photo Exploration',
    course_desc:
      'Designed for student artists interested in capturing digital images that can stand alone as compelling visual statements, or be incorporated within a broader artistic framework. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'ART3681C',
    course_name: 'Interactive Electronic Art',
    course_desc:
      'Introduction to microcontrollers, electronics, and coding in the development of interactive objects and environments for artists and designers. Issues addressed include accessibility, usability, interface development, product design, fabrication, etc.',
  },
  {
    course_code: 'ART3714C',
    course_name: 'Advanced Sculpture: Exploring Materials',
    course_desc:
      'Focuses on sculptural media and object making, both traditional and in contemporary practice. Provides further investigation into the selection of 3-D materials and its implications for authorship, meaning, environmental responsibility, and health concerns. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'ART3718C',
    course_name: 'Advanced Sculpture: Intro to New Genres',
    course_desc:
      'Reorganizes the open-ended nature of "sculpture" as a category in art practice today. Moves beyond the conventional definition of sculpture as concerned with volume and mass in space. Topics include how art is responsive to its context, and the issue of authorship, process, and vulnerability will be explored. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'ART3737C',
    course_name: 'Advanced Sculpture: Non-Place',
    course_desc:
      "Theory-based studio course that addresses anthropologist Marc Auge's concept of the Non-Place. Course will examine what makes a space a non-place. Students will be challenged to think about the ways in which various kinds of art, architecture, and design can transform our everyday experiences of non-places into places that inspire. Material and Supply Fee will be assessed. Permission is required.",
  },
  {
    course_code: 'ART3739C',
    course_name: 'Advanced Sculpture: Site Specific Installation',
    course_desc:
      "Course will examine strategies for work on site, gaining an understanding of the complex intersection of the social, cultural, built, and natural environment that are essential to the creation of an artist's intention, independently or in collaboration with others, in and out of the art world. Material and Supply Fee will be assessed.",
  },
  {
    course_code: 'ART3760C',
    course_name: 'Ceramics',
    course_desc:
      "Variety of hand-forming processes including throwing on the potter's wheel. Deals with basic glazing and firing techniques. Invites all students. Material and Supply Fee will be assessed.",
  },
  {
    course_code: 'ART3762C',
    course_name: 'Ceramics: Wheelthrowing',
    course_desc:
      'Intermediate course in throwing techniques. Deals with clay in terms of functional as well as sculptural considerations. Covers a broad range of technical information. Material and supply fee will be assessed.',
  },
  {
    course_code: 'ART3769C',
    course_name: 'Sculptural Ceramics',
    course_desc:
      'Designed to encompass all skill levels from beginning to advanced. Work will be focused on using the clay body and glazes to create non-utilitarian works of art. Wheel throwing, coil building and slab building methods will be employed as needed to realize this goal. The main firing method will be cone 10 gas firing to create long-lasting stoneware pieces. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'ART3827C',
    course_name: 'Conceptual Research and Development',
    course_desc:
      'Course engages art majors as leaders in the creation of cultural products for a fabricated society, one whose structure bears an intended resemblance to today\'s society. Students learn to lead group discussions and activities, culminating in a public exhibition of the culture\'s "artifacts".',
  },
  {
    course_code: 'ART3950',
    course_name: 'Junior Portfolio Review',
    course_desc:
      'A required pass/fail evaluation of the student\'s critical and technical skills essential for successful completion of Bachelor of Fine Arts programs in Studio Art and Digital Art. The Junior Portfolio Review is required for those students pursuing the Studio Art B.F.A. or the Digital Art B.F.A. This is typically taken at the end of the sophomore or beginning of the junior year. Passing this review is required for enrollment in upper division courses and BFA Senior Seminar I and II. \nStudents must be enrolled in or have completed (with a "C" or better) the required pre-requisites below. Students who are enrolled in one or more of the prerequisite course(s) in the semester applying for portfolio must submit an unofficial transcript at the end of the semester showing a grade of "C" or better in the course.\nStudents who do not pass the review may retake the review.\nTransfer students who are not currently enrolled at UWF must submit an unofficial transcript before enrolling in the section.',
  },
  {
    course_code: 'ART4161C',
    course_name: 'New and Mixed Media: Personal Directions',
    course_desc:
      'Focused research in new and mixed media with attention to the development of a personal artistic statement. For advanced upper-level students only. May be designated a capstone experience. Permission is required. Material and Supply fee will be assessed.',
  },
  {
    course_code: 'ART4332C',
    course_name: 'Drawing IV - Advanced',
    course_desc:
      'While there is a continuation of the development of many of the concepts of drawing from ART3312C, this course is dedicated to the study of life drawing concepts. The human figure will be the primary subject matter. Extensive experimentation and exploration of drawing media use in relation to the figure will be stressed. Permission is required. Material and supply fee will be assessed. Credit cannot be received for both ART4332C and ART 4320C.',
  },
  {
    course_code: 'ART4333C',
    course_name: 'Drawing V - Advanced',
    course_desc:
      'Use of classroom / studio situation to direct the student towards independent study. Student will be required to participate in the structuring of projects and experiences that demand individual investigation and development. Material and supply fee will be assessed. Credit may not be earned in both ART4332C and ART4333C.',
  },
  {
    course_code: 'ART4386C',
    course_name: 'Drawing: Personal Directions',
    course_desc:
      "Topics tailored to the advanced drawing student's personal creative exploration. May be used as a capstone experience by studio art majors. Permission is required. Material and Supply Fee will be assessed.",
  },
  {
    course_code: 'ART4506C',
    course_name: 'Painting IV-Advanced',
    course_desc:
      'Use of the classroom / studio to direct the student in independent study. Students will be required to initiate the structuring of projects and experiences and to pursue them with individual development and investigation.',
  },
  {
    course_code: 'ART4520C',
    course_name: 'Painting: Personal Directions',
    course_desc:
      'Unique topics concerning painting for the upper level or advanced student. Students should have an extensive background in the fundamentals of painting, drawing, and design, as well as an advanced knowledge of ideas / concepts in contemporary painting. May be designated a capstone experience.',
  },
  {
    course_code: 'ART4619C',
    course_name: 'Advanced Digital Multimedia',
    course_desc:
      'Advanced issues and applications of digital technology and critical thinking in art. Conceptual utilization of both theoretical thinking and contemporary digital studio art practice, with possible emphasis on video art, video streaming technology, installation, programming and / or robotics to be determined by instructor. Students work both individually and in collaboration on projects that can involve video, sound, space, time, objects, film, robotics, programming or any other appropriate media. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'ART4632C',
    course_name: 'Digital Design Studio Senior Project',
    course_desc:
      "Designed for seniors in the Graphic Design BA and Digital Art BFA programs pursuing self-initiated and self-directed projects. Projects may include the development of a single (or sequential) large-scale artwork, the further development of projects begun at the lower level for inclusion in   the senior portfolio, and/or design and development of the senior exit show and/or senior design portfolio. Students' proposals must be approved by the instructor at least two weeks before the start of the semester. May be designated a capstone experience. Permission is required. Material and   Supply Fee will be assessed.",
  },
  {
    course_code: 'ART4633C',
    course_name: 'Advanced Interactive Electronic Art',
    course_desc:
      'Advanced practice and development using microcontrollers, electronics, and coding of interactive objects and environments for artists and designers. Issues addressed include accessibility, usability, interface development, product design, fabrication, etc.',
  },
  {
    course_code: 'ART4712C',
    course_name: 'Sculpture: Personal Directions',
    course_desc:
      'Focused research into advanced specialized sculptural processes not normally covered within the normal sculpture course offerings. Processes covered are dependent upon direction of work. Contemporary art concepts are an integral part of this class. For advanced upper-level students only. May be designated a capstone course. Material Supply fee will be assessed.',
  },
  {
    course_code: 'ART4787C',
    course_name: 'Ceramics: Personal Directions',
    course_desc:
      'Design and the development of individual expression in clay. Student has a choice of forming techniques. Covers advanced firing and glazing techniques. Material and supply fee will be assessed.',
  },
  {
    course_code: 'ART4800',
    course_name: 'Portfolio',
    course_desc:
      'Provides the information, support, and technical ability needed to build a strong portfolio and prepare applications to graduate schools, residencies, and internships. Explains how to professionally enter the contemporary art market. Open to all art majors, but required of BFA students.',
  },
  {
    course_code: 'ART4801C',
    course_name: 'BFA Senior Seminar I',
    course_desc:
      "This is a seminar course designed to provide an advanced progression of work/projects associated with BFA Senior Seminar II in regard to key critical terms and topics widely used and discussed in Art practice and theory. Activities are designed to provide a guided inquiry into each student's own art practice and to support the completion of a body of work and critical writings required for the BFA Exit Exhibition. \nPrerequisites: Departmental permission required.",
  },
  {
    course_code: 'ART4891C',
    course_name: 'BFA Senior Seminar II',
    course_desc:
      "This is a seminar course designed to provide an advanced progression of work/projects associated with BFA Senior Seminar I in regard to key critical terms and topics widely used and discussed in Art practice and theory. Activities are designed to provide a guided inquiry into each student's own art practice and to support the completion of a body of work and critical writings required for the BFA Exit Exhibition. \nPrerequisites: Departmental permission required.",
  },
  {
    course_code: 'ART4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ART4936C',
    course_name: 'BFA Professional Seminar I',
    course_desc:
      "This is a seminar course designed to provide an advanced progression of work/projects associated with BFA Professional Seminar II and BFA Professional Seminar III in regard to key critical terms and topics widely used and discussed in Art practice and theory. The course also provides a guided inquiry into each student's own art practice.",
  },
  {
    course_code: 'ART4937C',
    course_name: 'BFA Professional Seminar II',
    course_desc:
      "This is a seminar course designed to provide an advanced progression of work/projects associated with BFA Professional Seminar I and BFA Professional Seminar III in regard to key critical terms and topics widely used and discussed in Art practice and theory. The course also provides a guided inquiry into each student's own art practice. Prerequisites: Departmental permission required.",
  },
  {
    course_code: 'ART4938C',
    course_name: 'BFA Professional Seminar III',
    course_desc:
      "This is a seminar course designed to provide an advanced progression of work/projects associated with BFA Professional Seminar I and BFA Professional Seminar II in regard to key critical terms and topics widely used and discussed in Art practice and theory. The course also provides a guided inquiry into each student's own art practice.",
  },
  {
    course_code: 'ART4940',
    course_name: 'Internship in Studio Art',
    course_desc:
      'This course offers immersive experience for students with an internal or external internship partner, integrating key elements of professions in the specific fields of art and focusing on the acquisition of 21st Century skills. Internships are on an "as available" basis; Art Majors may request an internship by submitting written proposals to the Department\'s Internship Coordinator, their advisor, or the Chair. Proposals must be approved by the Internship Coordinator prior to registration as well as by the advisor and sponsor. Senior status, 2.5 GPA overall, and a 3.0 GPA in the major is required. All internships include reports on internship experience, including weekly journals, written reports and an oral presentation to the Internship coordinator. Graded on a satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'ART5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ART6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'AST1002',
    course_name: 'Descriptive Astronomy',
    course_desc:
      'Introductory astronomy. Basic astronomical concepts; gravitation and other cosmic forces; planets, moons, and other components of the solar system; nature and evolution of the sun and of other stars; structure of galaxies and of the universe as a whole. Credit may not be received in both AST1002 and AST3033.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'AST2037',
    course_name: 'Life in the Universe',
    course_desc:
      'This astronomy-based course contemplates the possibilities of life elsewhere in our solar system and the universe through a multidisciplinary science approach. Conditions for life to form and the likelihood that such conditions may exist elsewhere in the universe are discussed. Also considered are schemes proposed for the search for extraterrestrial intelligence (SETI).\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'AST3222',
    course_name: 'Introduction to Astrophysics',
    course_desc:
      'Comprehensive survey of the universe and its appearance from earth. Seasons, tides, eclipses. The solar system, stellar evolution and galaxies. Quasars, pulsars, black holes.',
  },
  {
    course_code: 'AST3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ATR2000',
    course_name: 'Basic Care and Prevention Principles of Athletic Training',
    course_desc:
      'Designed to provide an overview of proper roles and responsibilities of the National Athletic Trainers\' Association Board of Certification (NATABOC), Certified Athletic Trainer (ATC) in providing quality health care to the physically active individual, as well as other health care professionals that comprise the sports medicine team. In addition, specific skills related to athletic health care will be addressed. A grade of "B" or better is required. Credit may not be earned in both PET 2603, ATR2000 and PET 2604.',
  },
  {
    course_code: 'ATR2010',
    course_name:
      'Advanced Prevention and Care of Injuries in Health, Leisure, and Sports',
    course_desc:
      'Fitness and health, prevention and care of injuries, and restoration and rehabilitation of the injured. Standard first aid, anatomy and physiology are required.',
  },
  {
    course_code: 'ATR3132',
    course_name: 'Functional Kinesiology',
    course_desc:
      'Provides an in-depth, hands-on approach to learning the human skeletal and muscular anatomy and how it relates to motion and mechanism of injury, muscle origins, insertions, and actions will be learned through palpation.',
  },
  {
    course_code: 'ATR4902',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ATR5105C',
    course_name: 'Advanced Principles in Athletic Training',
    course_desc:
      'Current principles and professional practice in the prevention of acute and chronic medical conditions and the underlying theory and practice of reducing risk of injury/illness associated with participation in physical activity. This course addresses the selection, fabrication, and application of tape, braces, and other orthopedic devices used in sports medicine.',
  },
  {
    course_code: 'ATR5115C',
    course_name: 'Management of Medical Emergencies in AT',
    course_desc:
      'Course includes instruction in the prevention, diagnosis, and intervention of acute and emergency medical conditions. Students will learn the basic principles of managing medical emergencies while utilizing immediate first aid techniques.',
  },
  {
    course_code: 'ATR5120C',
    course_name: 'Anatomical Basis of Clinical Practice in Sports Medicine',
    course_desc:
      'By way of SynDavers and palpation labs, an in-depth, hands-on approach to learning the human skeletal and muscular anatomy will be offered. Students will learn anatomical and physiological studies through didactic and laboratory experiences; specifically  how they relate to motion and mechanism of injury, muscle origins, insertions, and actions. Furthermore, students will develop and apply the principles and concepts of human movement, including normal osteokinematics and arthrokinematics.',
  },
  {
    course_code: 'ATR5217C',
    course_name: 'Orthopedic Assessment I',
    course_desc:
      'A specialized course dealing with anatomy, signs and symptoms, and specific orthopedic examination procedures used when assessing injuries and conditions of the lower extremity, pelvic region and lumbar spine, as well as lower extremity gait analysis.',
  },
  {
    course_code: 'ATR5218C',
    course_name: 'Orthopedic Assessment II',
    course_desc:
      'A specialized course dealing with anatomy, signs and symptoms, and specific orthopedic examination procedures used when assessing injuries and conditions of the upper extremity and cervical and thoracic spine, as well as posture assessment.',
  },
  {
    course_code: 'ATR5435',
    course_name: 'General Medical Conditions in the Athlete',
    course_desc:
      'This is a specialized course dealing with anatomy, signs and symptoms, and specific examination procedures and diagnostic tests for the assessment of injuries and conditions of the cardiovascular, endocrine, respiratory, gastrointestinal, genitourinary, integumentary, neurological, and reproductive systems; the eyes, ears, nose, throat, mouth, and teeth; and behavioral health.',
  },
  {
    course_code: 'ATR5815C',
    course_name: 'Athletic Training Clinical Experience I',
    course_desc:
      'This course is the initial clinical experience for MSAT students. Students will focus on a variety of field experiences and the application of learned principles from athletic training clinical skills. Students will be directly supervised by a preceptor and given the opportunity to practice learned skills in the clinical setting.',
  },
  {
    course_code: 'ATR5825C',
    course_name: 'Athletic Training Clinical Experience II',
    course_desc:
      'Students will focus on a variety of field experiences and the application of learned principles from athletic training clinical skills. Students will be directly supervised by a preceptor and given the opportunity to practice learned skills in the clinical setting.',
  },
  {
    course_code: 'ATR6305C',
    course_name: 'Therapeutic Modalities in Athletic Training',
    course_desc:
      'This course will explore an evidence-based approach to therapeutic modality usage and implementation into a treatment plan. Students will investigate and analyze indications, contraindications, and biophysics of agents that aid in the healing of athletic injuries and the reduction of pain utilizing appropriate therapeutic modalities.',
  },
  {
    course_code: 'ATR6316C',
    course_name: 'Rehabilitation Techniques in Athletic Training',
    course_desc:
      'This course will explore the principles of a comprehensive rehabilitation program; specifically related to the design and implementation of a therapeutic program. Students will learn to incorporate exercises related to strength, proprioception and neuromuscular control to achieve the patient plan of care goals. Students will assess rehabilitation progress and criteria for return to activity.',
  },
  {
    course_code: 'ATR6425',
    course_name: 'Pharmacology and Diagnostic Imaging in Athletic Training',
    course_desc:
      'This course is designed to introduce students to the principles of pharmacology and the role of the athletic trainer regarding the therapeutic use and effects of the drugs.  Students will become familiar with legal issues related to prescription and non-prescription medications, and on the use and effects of drugs and of the disease states treated by these drug categories.  The student to learn how to read and understand diagnostic imaging. This will include describing the basic principles, the different ways of testing, and their role in the diagnostic process.',
  },
  {
    course_code: 'ATR6517',
    course_name: 'Administration and Professionalism in Athletic Training',
    course_desc:
      'This course focuses on the concepts of legal liability, budgeting, inventory, personnel and facilities management, and public relations and education.   Students gain an understanding of administrative components and provision of services to athletes and other physically active individuals offered in healthcare facilities.',
  },
  {
    course_code: 'ATR6620',
    course_name: 'Research in Athletic Training I',
    course_desc:
      'This course will focus on the fundamentals of evidence-based practice (EBP) in athletic training.  Students will develop knowledge to critically review research studies and make clinical decisions based on the selection and appraisal of the literature.',
  },
  {
    course_code: 'ATR6621',
    course_name: 'Research in Athletic Training II',
    course_desc:
      'This course explores quantitative and qualitative research methodologies used in athletic training and evaluation of published research in the field.  Students will learn to develop clinically based research questions related to athletic training, design effective research procedures to investigate those questions, and use various publication and presentation outlets to disseminate the findings.  The capstone activity for this course involves designing a research project with a culminating research presentation.',
  },
  {
    course_code: 'ATR6835',
    course_name: 'Athletic Training Clinical Experience III',
    course_desc:
      'Students will focus on an immersive clinical experience and the application of learned principles from athletic training clinical skills. Students will be directly supervised by a preceptor and given the opportunity to practice learned skills in the clinical setting.',
  },
  {
    course_code: 'ATR6845',
    course_name: 'Athletic Training Clinical Experience IV',
    course_desc:
      'Students will focus on a variety of field experiences and the application of learned principles from athletic training clinical skills. Students will be directly supervised by a preceptor and given the opportunity to practice learned skills in the clinical setting.',
  },
  {
    course_code: 'BCH3033',
    course_name: 'Biochemistry I',
    course_desc:
      'A first course in biochemistry dealing with the classification, function, and chemistry of proteins, carbohydrates, and nucleic acids and the smaller molecules from which they are derived. Conformational properties of biomolecules, enzyme kinetics and mechanisms, allosterism and cooperativity are surveyed. Material and supply fee will be assessed for corresponding lab.',
  },
  {
    course_code: 'BCH3033L',
    course_name: 'Biochemistry I Laboratory',
    course_desc:
      'A first course in biochemistry dealing with the classification, function, and chemistry of proteins, carbohydrates, and nucleic acids and the smaller molecules from which they arrived. Conformational properties of biomolecules, enzyme kinetics, and mechanisms, allosterism and cooperativity are surveyed. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'BCH3034',
    course_name: 'Biochemistry II',
    course_desc:
      'This course builds on the knowledge gained in BCH3033 or CHM2210 / CHM2211 and deals with the biochemical properties of biological membranes and the anabolic and catabolic pathways of the major biological macromolecules.',
  },
  {
    course_code: 'BCH3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BCH4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BCH5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BCH6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BSC4263',
    course_name: 'Biological Oceanography',
    course_desc:
      'Biota of the oceans, including systematics, special morphological adaptations, physiology, natural history and zoogeography of plankton and nekton. Relationship between biota and the physiochemical properties of the pelagic realm.',
  },
  {
    course_code: 'BCN2210',
    course_name: 'Construction Materials',
    course_desc:
      'This course offers an introduction to the economic, mechanical, non-mechanical, production, and aesthetic considerations of materials currently used in construction in accordance with the 16 divisions of the Construction Specifications Institute. The course explores changing materials, methods and technologies in construction, and focuses on the most common and practical building materials and methods to provide students with knowledge, skills and abilities related to the "means and methods" of construction.',
  },
  {
    course_code: 'BCN2251C',
    course_name: 'Construction Drawings',
    course_desc:
      'Provides basic working knowledge of architectural graphics, practice in instrumental drawing and experience in free hand sketching. Provides students with knowledge, skills and abilities to accurately interpret commercial construction documents. Addresses standards for construction drawings, drawing quality, drafting techniques and drawing literacy and information retrieval.',
  },
  {
    course_code: 'BCN2272',
    course_name: 'Blueprint Reading',
    course_desc:
      'Provides students with knowledge, skills and abilities to accurately interpret commercial construction documents.  Addresses standards for construction drawings, drawing quality, drafting techniques and drawing literacy and information retrieval.',
  },
  {
    course_code: 'BCN2405',
    course_name: 'Statics and Strength of Materials',
    course_desc:
      'Analyze strength of structural elements for buildings, bridges and specialized structures that utilize steel and timber and concrete. Covers the statics of particles, rigid bodies, friction, strengths of materials such as wood, steel and concrete.',
  },
  {
    course_code: 'BCN2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BCN3224',
    course_name: 'Construction Materials and Method',
    course_desc:
      'Explores changing materials, methods and technologies in construction. Focuses on the most common and practical building materials and methods to provide students with knowledge, skills and abilities related to the "means and methods" of construction.',
  },
  {
    course_code: 'BCN3281C',
    course_name: 'Construction Survey and Building Layout',
    course_desc:
      'Application of surveying skills required in the field of construction, including building layout, indirect determination of elevation and distance, referencing, establishment of grade, and topographic mapping. Instruments used will include transit and automatic level. Credit cannot be received for both BCN3281C and BCN 3282C.',
  },
  {
    course_code: 'BCN3561',
    course_name: 'Construction Mechanics',
    course_desc:
      'Introduction to building systems. Areas of study included in this course are heating and cooling, plumbing, and electrical systems.',
  },
  {
    course_code: 'BCN3590',
    course_name: 'Sustainable Construction',
    course_desc:
      'Provides an overview of Sustainable Construction, the basic philosophical premises and concepts, the cutting edge in design and construction, methods of assessment, project delivery, economics, and green building evaluation systems, such as LEED and Green Globes. Students will learn the importance of sustainable construction and the emergence of green building concepts in the construction industry. Focuses on concepts and learning to facilitate application in real-world scenarios.',
  },
  {
    course_code: 'BCN3731',
    course_name: 'Construction Safety',
    course_desc:
      'Addresses the principles of safety in construction and project management. Focuses on  the OSHA 29 CFR 1926 Construction Industry Regulations, construction site risk aversion, insurance, site specific paperwork and documentation, maintenance of traffic, cost, scheduling and job hazard analysis.',
  },
  {
    course_code: 'BCN3762',
    course_name: 'Building Codes',
    course_desc:
      'Covers the general requirements of the Florida Building Code for commercial construction, based on occupancy classification and construction type. Provides information about code agencies, organizations and resources related to the building construction approval process.',
  },
  {
    course_code: 'BCN3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BCN4258C',
    course_name: 'Building Information Modeling',
    course_desc:
      'Introduction to 3D Modeling software for Building Information Modeling (BIM).  Activities are designed to provide in-depth theory with the use of BIM information and the impact on construction contracts and processes.  There is a downloadable free BIM program that will be used but the student must have their own computer to load the program and use it for this course.',
  },
  {
    course_code: 'BCN4431',
    course_name: 'Structures I',
    course_desc:
      'Introduction to structural design using wood and steel. Structural behavior and properties of building materials will be covered as they apply to stresses in beams, columns, diaphragms, and structural connections.',
  },
  {
    course_code: 'BCN4461',
    course_name: 'Structures II',
    course_desc:
      'Introduction to structural design of foundations and reinforced concrete elements. Structural behavior and properties of soils will be investigated as they apply to building foundations. Properties of reinforced concrete will be covered as they apply to stresses in beams, columns, and foundations.',
  },
  {
    course_code: 'BCN4564',
    course_name: 'Construction Mechanics II',
    course_desc:
      'Introduction to electricity, power supply and distribution, communications, life safety, and security systems, electrical design and wiring, light and lighting, lighting equipment and systems, and calculations of illumination.',
  },
  {
    course_code: 'BCN4701',
    course_name: 'Construction Administration',
    course_desc:
      "Overview of the construction industry and professional requirements of management, administration and project management in construction environments. Consideration of information required to sit for the contractor's examination.",
  },
  {
    course_code: 'BCN4720C',
    course_name: 'Scheduling',
    course_desc:
      'Provides fundamental concepts of scheduling techniques, applications and software packages.  Students will be provided hands on experience with appropriate software.',
  },
  {
    course_code: 'BOT5376L',
    course_name: 'Plant Developmental Biology Laboratory',
    course_desc:
      'Is designed to accompany BOT5376. Features experiments that demonstrate and reinforce developmental processes presented in the lecture. Topics include cell division and elongation, phototropism, gravitropism, photoperiodism, seed germination, senescence, and plant tissue culture. Offered concurrently with BOT4374L; graduate students will be assigned additional work. Material and supply fee will be assessed.',
  },
  {
    course_code: 'CBH5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BCN4773',
    course_name: 'Construction Finance and Controls',
    course_desc:
      "Examines application of construction ownership and business management, and the principles and techniques needed for making economic decisions about building systems and subsystems. Covers various aspects of construction management, financing, risk management, labor law, and worker's compensation. Basic accounting practices are also covered. Students will also explore decision making techniques pertaining to cost and value engineering. Emphasis will be placed on the time-value of money and equivalence, replacement analysis, uncertainty and life cycle costing.",
  },
  {
    course_code: 'BCN4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BCN4940',
    course_name: 'Construction Internship/Senior Project',
    course_desc:
      'Field-based experience where students work in real-world situations with industry professionals.  Students unable to locate an internship complete a complex problem solving project under the direction of the instructor. Permission is required.',
  },
  {
    course_code: 'BOT2010',
    course_name: 'General Botany',
    course_desc:
      'Introduction to the basic concepts which apply to all plants including cell theory, biosynthetic processes, physiological response, development and reproduction, as well as consideration of plant morphology, systematics and evolution. Material and supply fee will be assessed for corresponding lab.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'BOT2010L',
    course_name: 'General Botany lab',
    course_desc: '',
  },
  {
    course_code: 'BOT2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BOT3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BOT4374',
    course_name: 'Plant Developmental Biology',
    course_desc:
      'Examines the succession of changes that occurs in plants as they progress from a simple embryo to a complex mature plant and through senescence. Plant growth, differentiation, organogenesis, morphogenesis, and environmental influences such as light, temperature, and gravity will be explored emphasizing the cellular and molecular events that control developmental processes. The accompanying laboratory features experiments selected to demonstrate and reinforce important principles discussed in lecture. Offered concurrently with BOT5376; graduate students will be assigned additional work. Material and Supply fee will be assessed to corresponding lab.',
  },
  {
    course_code: 'BOT4374L',
    course_name: 'Plant Developmental Biology Laboratory',
    course_desc:
      'Is designed to accompany BOT4374. Features experiments that demonstrate and reinforce developmental processes presented in the lecture. Topics include cell division and elongation, phototropism, gravitropism, photoperiodism, seed germination, senescence, and plant tissue culture. Offered concurrently with BOT5376L; graduate students will be assigned additional work. Material and supply fee will be assessed.',
  },
  {
    course_code: 'BOT4404C',
    course_name: 'Aquatic Botany',
    course_desc:
      'Morphology, taxonomy, physiology and ecology of aquatic plants, especially freshwater and marine algae. Material and supply fee will be assessed for corresponding lab.',
  },
  {
    course_code: 'BOT4503',
    course_name: 'Plant Physiology',
    course_desc:
      'Examines the basic physiological and biochemical processes that determine and govern plant function. Topics include photosynthesis, mitochondrial metabolism, energetics, transport systems, water relations, cell walls, phytohormones, gene expression, and selected aspects of secondary plant metabolism. The accompanying laboratory features experiments selected to demonstrate and reinforce important principles discussed in lecture. Offered concurrently with BOT 5506; graduate students will be assigned additional work. Material and supply fee will be assessed for corresponding lab.',
  },
  {
    course_code: 'BOT4503L',
    course_name: 'Plant Physiology Laboratory',
    course_desc:
      'Designed to accompany BOT4503 and features experiments that demonstrate and reinforce physiological and biochemical principles presented in the lecture. Topics include plant nutrition, enzymology, photosynthesis, respiration, transpiration, plant hormones, and seed germination. Material and supply fee will be assessed. Offered concurrently with BOT 5506L; graduate students will be assigned additional work.',
  },
  {
    course_code: 'BOT4734',
    course_name: 'Plant Biotechnology',
    course_desc:
      'Provides students with a foundation in the molecular biology and genetic manipulation of plants. Model plant systems are used to illustrate current concepts and methodologies used in a modern plant biotechnology laboratory. Case studies illustrate commercial applications of products derived from plant biotechnology and introduce students to ethical issues arising from the use of plant biotechnology. The accompanying laboratory provides students with the opportunity to perform basic manipulations required in a plant biotechnology laboratory and reinforces the principles presented in lecture. Material and supply fee will be assessed for corresponding lab. Offered concurrently with BOT5735; graduate students will be assigned additional work.',
  },
  {
    course_code: 'BOT4734L',
    course_name: 'Plant Biotechnology Lab',
    course_desc: 'Corresponding Lab for Plant Biotechnology.',
  },
  {
    course_code: 'BOT4850',
    course_name: 'Medicinal Botany',
    course_desc:
      'Pharmacognosy, the knowledge of drugs, grew out of the old herbal remedies passed down by tradition. Plant natural products continue to form the basis of many new therapeutic treatments in modern and alternative medicines. Provides a survey of phytochemicals that have proven useful for improving human health beyond the basic use of plants as a food source. Offered concurrently with BOT5852 graduate students will be assigned additional work.',
  },
  {
    course_code: 'BOT4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BOT5376',
    course_name: 'Plant Developmental Biology',
    course_desc:
      'Examines the succession of changes that occurs in plants as they progress from a simple embryo to a complex mature plant and through senescence. Plant growth, differentiation, organogenesis, morphogenesis, and environmental influences such as light, temperature, and gravity will be explored emphasizing the cellular and molecular events that control developmental processes. Offered concurrently with BOT4374; graduate students will be assigned additional work. Material and Supply fee will be assessed to corresponding lab.',
  },
  {
    course_code: 'BSC2844',
    course_name: 'Biology Skills',
    course_desc:
      'A professional development course for students in the Biology and Pre-professional curriculum plan. It will introduce the students to necessary skills for upper division biology courses,\nincluding reading and interpretation of scientific publications, scientific writing styles, ethics, and critical thinking.',
  },
  {
    course_code: 'BOT5735',
    course_name: 'Plant Biotechnology',
    course_desc:
      'Provides students with a foundation in the molecular biology and genetic manipulation of plants. Model plant systems are used to illustrate current concepts and methodologies used in a modern plant biotechnology laboratory. Case studies illustrate commercial applications of products derived from plant biotechnology and introduce students to ethical issues arising from the use of plant biotechnology. The accompanying laboratory provides students with the opportunity to perform basic manipulations required in a plant biotechnology laboratory and re-enforces the principles presented in lecture. A material and supply fee will be assessed for corresponding lab. Offered concurrently with BOT4734; graduate students will be assigned additional work.',
  },
  {
    course_code: 'BOT5735L',
    course_name: 'Plant Biotechnology Lab',
    course_desc: 'Corresponding lab for Plant Biotechnology.',
  },
  {
    course_code: 'BOT5852',
    course_name: 'Medicinal Botany',
    course_desc:
      'Pharmacognosy, the knowledge of drugs, grew out of the old herbal remedies passed down by tradition. Plant natural products continue to form the basis of many new therapeutic treatments in modern and alternative medicines. Provides a survey of phytochemicals that have proven useful for improving human health beyond the basic use of plants as a food source. Offered concurrently with BOT4850; graduate students will be assigned additional work.',
  },
  {
    course_code: 'BOT5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BOT6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BSC1005',
    course_name: 'General Biology for Non-Majors',
    course_desc:
      'Survey of abiotic and biotic principles as they apply to basic structural and functional topics at the cellular, organismal, population and community levels; and the application of these principles to issues of current interest.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'BSC1005L',
    course_name: 'General Biology Laboratory for Non-Majors',
    course_desc:
      'Lab correlating with BSC1005. Material and Supply Fee will be assessed.\nSatisfies Florida Common Core Natural Sciences requirement.',
  },
  {
    course_code: 'BSC1050',
    course_name: 'Fundamentals of Ecology',
    course_desc:
      'Intended for non-majors who have an interest in nature and how they interact with nature. Gives general overview of ecological principles and how these principles influence the outside world around us. Imbedded are several activities that are associated with each chapter. The activities were developed so that the student will gain a respect for ecology as well as show how ecological principles affect your daily life.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'BSC1085',
    course_name: 'Anatomy and Physiology I',
    course_desc:
      'General introduction to form and function of the human body. Review of basic anatomical / physiological attributes of integumentary, skeletal, muscular, nervous and sensory organ systems. Designed for students with little or no previous anatomy or physiology experience. Lab optional.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'BSC1085L',
    course_name: 'Anatomy and Physiology I Laboratory',
    course_desc:
      'Optional lab associated with course. Anatomical dissection and experimental physiology exercises that enhance understanding of human form and function. Exercises parallel topics presented in the lecture series. Material and supply fee will be assessed.',
  },
  {
    course_code: 'BSC1086',
    course_name: 'Anatomy and Physiology II',
    course_desc:
      'Continuation of Anatomy and Physiology I. Reviews basic anatomical/ physiological attributes of endocrine, cardiopulmonary, digestive, reproductive and immune systems. Lab optional.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'BSC1086L',
    course_name: 'Anatomy & Physiology II Laboratory',
    course_desc:
      'Optional lab associated with course. Anatomical dissections and experimental physiology exercises that enhance understanding of human form and function. Exercises parallel topics presented in the lecture series. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'BSC1905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BSC2010',
    course_name: 'Biology I',
    course_desc:
      'Introduction to the cellular processes of living organisms, including subcellular structures, biochemical and genetic regulation of function and growth, reproduction, heredity, and evolution.  Material and supply fee will be assessed for the corresponding lab.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'BSC2010L',
    course_name: 'Biology I Laboratory',
    course_desc:
      'Introduction to the science method, reading, and writing, microscopy, and science measurement.  Cellular processes of prokaryotic and eukaryotic organisms, including subcellular structures, biochemical and genetic regulation of function and growth, reproduction, heredity, and evidence of evolution.  Material and supply fee will be assessed for this lab.',
  },
  {
    course_code: 'BSC2011',
    course_name: 'Biology II',
    course_desc:
      'Explores the diversity of life including bacteria, protists, fungi, plants and animals at the introductory level designed for students starting a major in biology. The course will outline the tree of life in illustrating the evolutionary relationships among organisms. The course will also cover basic functional morphology and physiology at the organismal level, and provide an introduction to ecological interactions at the population and community level.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'BSC2011L',
    course_name: 'Biology II Laboratory',
    course_desc:
      'Explores the diversity of life including bacteria, protists, fungi, plants and animals at the introductory level designed for students starting a major in biology. The course will outline the tree of life in illustrating the evolutionary relationships among organisms. The course will also cover basic functional morphology and physiology at the organismal level, and provide an introduction to ecological interactions at the population and community level.',
  },
  {
    course_code: 'BSC2311',
    course_name: 'Introduction to Oceanography and Marine Biology',
    course_desc:
      'An introduction to the chemical, physical and geological features of the world ocean and the major groups of living marine organisms that inhabit it. Physical chemical and biological interrelationships will be emphasized. Credit not granted toward a major in Biology.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'BSC2311L',
    course_name: 'Introduction to Oceanography and Marine Biology Laboratory',
    course_desc:
      'Lab correlating with BSC2311. Credit not granted toward a major in Biology. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'BSC4303',
    course_name: 'Biogeography',
    course_desc:
      'Relates the principles of taxonomy, ecology and evolution to the distribution of plants and animals. Codes of taxonomic nomenclature and the processes of describing species and ranges, species concepts and speciation, paradigms of constructing phylogenies, a review of the geologic ages of the earth, modern terrestrial and oceanic biodiversity and biogeographic provinces and human impact on species extinctions and introductions. Offered concurrently with BSC5305; graduate students will be assigned additional work.',
  },
  {
    course_code: 'BSC4434',
    course_name: 'Bioinformatics and Data Science',
    course_desc:
      'This course explores concepts and practical applications in bioinformatics. It covers essential topics such as data organization, representing and reasoning about sequence data, simple data mining strategies, and ethical protocols for data collection. Students will learn how to apply data science principles to biological and clinical problems to effectively work with large data sets, format data, and design applications to help visualize, analyze, interpret, and communicate the resulting insights in ways that advance science. Offered concurrently with BSC5459; graduate students will be assigned additional work.',
  },
  {
    course_code: 'BSC4854',
    course_name: 'Bioterrorism',
    course_desc:
      'Biological weapons employed against man (emphasis), animals and plants will be discussed during the semester. The major biological agents targeted for use as weapons against humans will be dealt with in detail including the various clinical forms induced by exposure to the agents, prophylaxis and treatment for the resulting diseases and the primary routes of dissemination of the agents studied. The class will cover the potential for biowarfare/bioterrorist acts, how destruction is produced, and what countries / groups have access to sufficient bioagent or the capacity for producing large quantities of biological agents for use as a weapon. Wargames in which bioagents are employed, including casualty estimates and socioeconomic impact will be discussed and played out. Government preparedness to deal with biowarfare / bioterrorism will be addressed with emphasis on plans for surveillance and response. Offered concurrently with BSC5856; graduate students will be assigned additional work.',
  },
  {
    course_code: 'BSC4860',
    course_name: 'Conservation Biology',
    course_desc:
      'This course will introduce students to the field of conservation biology from the perspective of terrestrial, freshwater and marine habitats. Conservation biology is broadly concerned with maintaining and restoring biodiversity at all levels from genes to ecosystems, and by definition is interdisciplinary. Conservation biology broadly aims to develop the scientific and technical approach to protection, maintenance and restoration of biological diversity. We will consider the causes and consequences of biodiversity loss, established and emerging approaches to conservation, the interface with human dimensions, and the complexities of implementing science-based conservation policy and management. This course combines lectures, readings, in-class discussions, writing exercises and student presentations, with an emphasis on critical thinking, problem solving and global fluency. This class draws from all aspects of biology for those at the upper undergraduate or beginning graduate student level who are interested in conservation, whether from a biodiversity or ecosystem perspective. Often students are majors in Environmental Sciences or Biology, but they may also come from diverse backgrounds, including Environmental Studies, Law, Government, City and Regional Planning, Geography, and Anthropology. Offered concurrently with BSC5865. Graduate students will be assigned additional work.\nA basic course in ecology is required, but seek the permission of the instructor if you have a special interest in conservation biology.',
  },
  {
    course_code: 'BSC4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BSC4941',
    course_name: 'Clinical Experience in Health Care',
    course_desc:
      'Clinical experience in select health care locations within the region through Memoranda of Understanding (MOU) established with UWF and Biology. Permission process includes an interview conducted by the target health care entity to ensure expectations of student and health care entity will be met. Students will be expected to invest a minimum of 12 hrs / week on the project during the semester in which they are enrolled. A final report on the project(s) will be submitted. Permission is required.',
  },
  {
    course_code: 'BSC5305',
    course_name: 'Biogeography',
    course_desc:
      'Relates the principles of taxonomy, ecology and evolution to the distribution of plants and animals. Codes of taxonomic nomenclature and the processes of describing species and ranges, species concepts and speciation, paradigms of constructing phylogenies, a review of the geologic ages of the earth, modern terrestrial and oceanic biodiversity and biogeographic provinces and human impact on species extinctions and introductions. Offered concurrently with BSC4303; graduate students will be assigned additional work.',
  },
  {
    course_code: 'BSC5459',
    course_name: 'Bioinformatics and Data Science',
    course_desc:
      'This project-based course explores concepts and practical applications in bioinformatics. It covers essential topics such as data organization, representing and reasoning about sequence data, simple data mining strategies, and ethical protocols for data collection. Students will learn how to apply data science principles to biological, clinical, and public health problems to effectively work with large data sets, format data, and design applications to help visualize, analyze, interpret, and communicate the resulting insights in ways that advance science. Students will further examine current events demonstrating how collaborative, cross-disciplinary teams use bioinformatic technologies and tools with big data analytics to support translational research. Open to students from any discipline.',
  },
  {
    course_code: 'BSC5856',
    course_name: 'Bioterrorism',
    course_desc:
      'Biological weapons employed against man (emphasis), animals and plants will be discussed during the semester. The major biological agents targeted for use as weapons against humans will be dealt with in detail including the various clinical forms induced by exposure to the agents, prophylaxis and treatment for the resulting diseases and the primary routes of dissemination of the agents studied. The class will cover the potential for biowarfare / bioterrorist acts, how destruction is produced, and what countries / groups have access to sufficient bioagent or the capacity for producing large quantities of biological agents for use as a weapon. Wargames in which bioagents are employed, including casualty estimates and socioeconomic impact, will be discussed and played out. Government preparedness to deal with biowarfare / bioterrorism will be addressed with emphasis on plans for surveillance and response. Offered concurrently with BSC4854; graduate students will be assigned additional work.',
  },
  {
    course_code: 'EUH4521',
    course_name: 'Victorian England',
    course_desc:
      'England and British Empire in 19th century: emphasis upon economic, social, cultural and constitutional history.',
  },
  {
    course_code: 'BSC5865',
    course_name: 'Conservation Biology',
    course_desc:
      'This course will introduce students to the field of conservation biology from the perspective of terrestrial, freshwater and marine habitats. Conservation biology is broadly concerned with maintaining and restoring biodiversity at all levels from genes to ecosystems, and by definition is interdisciplinary. Conservation biology broadly aims to develop the scientific and technical approach to protection, maintenance and restoration of biological diversity. We will consider the causes and consequences of biodiversity loss, established and emerging approaches to conservation, the interface with human dimensions, and the complexities of implementing science-based conservation policy and management. This course combines lectures, readings, in-class discussions, writing exercises and student presentations, with an emphasis on critical thinking, problem solving and global fluency. This class draws from all aspects of biology for those at the upper undergraduate or beginning graduate student level who are interested in conservation, whether from a biodiversity or ecosystem perspective. Often students are majors in Environmental Sciences or Biology, but they may also come from diverse backgrounds, including Environmental Studies, Law, Government, City and Regional Planning, Geography, and Anthropology. Offered concurrently with BSC4860. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'BSC5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BSC6002L',
    course_name: 'Contemporary Laboratory Skills',
    course_desc:
      'A review of contemporary laboratory protocols and techniques necessary for the modern biologist to succeed in the professional, academic, or intellectual biology community. Provides students with a theoretical understanding of various techniques, their application, and the opportunity to master basic essential techniques in the laboratory. Topics include good laboratory practices, cell culture techniques, nucleic acid manipulation, macromolecular separation and detection, DNA analysis, chromatographic separations, spectrophotometry, microscopy, and radioisotope usage. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'BSC6840',
    course_name: 'Professional Development in Biology',
    course_desc:
      'A review of contemporary protocols, techniques, and methods needed to succeed in the professional, academic, or intellectual biology community. Topics include 1) organization of the professional and academic biology environment, 2) reading, interpreting, organizing and publishing biological literature, 3) biological project development, presentation, and funding, 4) locating and securing positions in the biological sciences.',
  },
  {
    course_code: 'BSC6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BSC6971',
    course_name: 'Thesis',
    course_desc:
      'Graded on satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'BUL3130',
    course_name: 'Legal and Ethical Environment of Business',
    course_desc:
      'Background of law and the legal and ethical environment of business. Coverage includes ethical decision making, courts and alternative dispute resolution, torts, criminal law, contracts, intellectual property, agency and an introduction to business organizations.',
  },
  {
    course_code: 'BUL3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BUL4244',
    course_name: 'Commercial Law',
    course_desc:
      'Study of selected topics in law pertaining to business transactions, business environment and associations, and financial securities. Offered concurrently with BUL5831; BUL5831 includes additional learning objectives not included in BUL 4424. Credit for both BUL 4424 and BUL5831 is not permitted.',
  },
  {
    course_code: 'BUL4514',
    course_name: 'Intellectual Property Law',
    course_desc:
      'Patents, trademarks, copyrights, and trade secrets are the four building blocks of a secure Intellectual Property protection plan for a business. This course introduces these topics using classroom discussion, readings, presentations from local businesses. Students will apply the concepts in a paper which focuses on intellectual property protection for an imaginary business. Offered concurrently with BUL5378. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'BUL4602',
    course_name: 'Legal Fundamentals of Healthcare',
    course_desc:
      'This course provides an overview of laws most affecting healthcare practices. The legal basis for government involvement in healthcare is examined with an analysis of the laws controlling the provision of healthcare industry and professional regulations. This course provides an in-depth overview of healthcare law, allowing students to acquire skills to confirm their actions to legal requirements and ethically analyze daily healthcare situations.',
  },
  {
    course_code: 'BUL4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BUL5378',
    course_name: 'Intellectual Property',
    course_desc:
      'Patents, trademarks, copyrights, and trade secrets are the four building blocks of a secure Intellectual Property protection plan for a business. This course introduces these topics and covers laws applicable to Intellectual property rights using classroom discussion, readings, presentations from local businesses. Students will apply the concepts in a paper which focuses on intellectual property protection for an imaginary business. Offered concurrently with BUL4514. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'BUL5831',
    course_name: 'Commercial Law',
    course_desc:
      'Study of selected topics in law pertaining to business transactions, business environment and associations, and financial securities.  Offered concurrently with BUL4244; BUL5831 includes additional learning objectives not included in BUL 4424. Credit for both BUL 4424 and BUL5831 is not permitted.',
  },
  {
    course_code: 'BUL5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'BUL6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CAP4136',
    course_name: 'Malware Analysis',
    course_desc:
      'This course covers software reverse engineering of executable code (or malware) to determine its function and affects or to recover the source code implementation.',
  },
  {
    course_code: 'CAP4601',
    course_name: 'Introduction to Artificial Intelligence',
    course_desc:
      'Introduction to Artificial Intelligence principles and techniques. Students will learn about core AI techniques for solving complex problems, including search strategies, knowledge-based techniques, and agent-based systems. Overview of AI topics such as intelligent agents, machine learning, as well as AI applications.\nMay be offered concurrently with CAP5600. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'MLS4462L',
    course_name: 'Medical Microbiology Lab',
    course_desc: 'Corresponding lab for Medical Microbiology.',
  },
  {
    course_code: 'CAP4770',
    course_name: 'Data Mining',
    course_desc:
      'Exposes students to data mining concepts and techniques and different data mining software. Covers data pre-processing and cleaning, concept hierarchy generation, attribute relevance analysis, association rule mining, classification algorithms, and cluster analysis.',
  },
  {
    course_code: 'CAP4786',
    course_name: 'Introduction to Big Data Analytics',
    course_desc:
      "This course introduces students to the handling of Big Data on Hadoop's MapReduce environment. Students also learn Spark architecture and programming with the aim of doing big data analytics with machine learning algorithms in Spark.",
  },
  {
    course_code: 'CAP4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CAP5326',
    course_name: 'Digital Media Analytics',
    course_desc:
      'Digital Media Analytics focuses on the processing and analysis of the copious amounts of data generated by digital media. Students will utilize standard programming languages and available software packages to design and implement solutions to acquire, process and analyze data in multiple formats.',
  },
  {
    course_code: 'CAP5600',
    course_name: 'Introduction to Artificial Intelligence',
    course_desc:
      'Introduction to Artificial Intelligence principles and techniques. Students will learn about core AI techniques for solving complex problems, including search strategies, knowledge-based techniques, and agent-based systems. Overview of AI topics such as intelligent agents, machine learning, as well as AI applications. \nMay be offered concurrently with CAP4601. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'CAP5668',
    course_name: 'Human Agent/Robot Teamwork',
    course_desc:
      'This course provides an introduction to human interaction with intelligent systems and robotics. It is a study of how intelligent systems cooperate with humans to achieve a common objective. The course includes seminar discussions and a paper with a practical computer programming assignment.',
  },
  {
    course_code: 'CAP5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CAP6579',
    course_name: 'Advanced Data Mining',
    course_desc:
      'This course will cover advanced topics in data mining on high dimensional data, including advanced feature selection techniques, advanced pattern mining, similarity searches (including minwise hashing and locality sensitive hashing), advanced classification methods, advanced cluster analysis, mining data streams, mining social networks, tree/graph mining, and privacy-preserving issues in data mining. Students are expected to have a course in data mining before taking this course.',
  },
  {
    course_code: 'CAP6624',
    course_name: 'Introduction to Machine Learning and Data Science',
    course_desc:
      'Models and methods of intelligent systems and robotics focusing on computational methods and their algorithmic performance. Optimization theory, sampling theory, partially observable Markov decision processes, recursive Bayesian filters including Kalman and particle filters supervised and unsupervised machine learning, deep learning, incremental sampling and search.',
  },
  {
    course_code: 'CAP6667',
    course_name: 'Advanced Topics in Intelligent Systems & Robotics',
    course_desc:
      'This seminar-style course provides doctoral students with an overview of trends in Intelligent Systems and Robotics and prepares them to conduct independent research in the field. Permission of the Instructor is required.',
  },
  {
    course_code: 'CAP6671',
    course_name: 'Intelligent Agents',
    course_desc:
      'The course will cover the underlying theory of intelligent agents, both software agents and embodied agents, their implementation, and applications of single and multi-agent systems. The course will address common agent architectures and various methods of agent cooperation. The course will also explore how a range of other Artificial Intelligence techniques such as knowledge representation, reasoning, machine learning, planning, ontologies, and natural language interaction are leveraged by agents. Students will construct their own agents in order to solve a range of problems. The course will employ simulations of multi-agent systems involving both cooperating and competing agents. Students are expected to have a background with computer networks.',
  },
  {
    course_code: 'CAP6771',
    course_name: 'Data Mining',
    course_desc:
      'The course addresses methods to discover patterns and trends in large datasets. With the aid of contemporary data mining software, students will apply the theoretical skills they acquire in the course to go through the complete data mining process starting from data pre-processing and cleaning, concept hierarchy generation, attribute relevance analysis to frequent itemset mining and association rule mining. Traditional methods such as Bayesian decision theory as well as modern approaches in classification and unsupervised clustering will be covered as well.',
  },
  {
    course_code: 'CAP6772',
    course_name: 'Data Warehousing',
    course_desc:
      'The primary focus of this course is on Data Warehousing and its applications to business intelligence. Some areas of concentration are: requirements gathering for data warehousing; data warehouse architecture; dimensional model design for data warehousing; physical database design for data warehousing; extracting, transforming, and loading strategies; introduction to business intelligence; design and development of business intelligence applications; expansion and support of a data warehouse. Prerequisites are COP4710 or COP5725 with a minimum grade of C.',
  },
  {
    course_code: 'CAP6789',
    course_name: 'Advanced Big Data Analytics',
    course_desc:
      "In this course students study advanced methods to handle and analyze very large data sets in Hadoop's Big Data environment. Students work with the Spark architecture in the MapReduce framework. Students also learn to apply machine learning algorithms in Spark.",
  },
  {
    course_code: 'CAP6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CAP7640',
    course_name: 'Topics in Natural Language Processing',
    course_desc:
      'This course covers fundamental concepts in processing natural language text. It provides an in-depth examination of state-of-the-art knowledge-based and statistical methods to process unstructured text, perform word and sentence-level syntactic and semantic analysis, and build machine representations to perform different natural language tasks. The course covers a variety of applications of these methods including syntactic parsing, word sense disambiguation, text classification, information extraction, text summarization, language generation, language translation, and dialogue systems. Students taking this course are expected to have a background in computer programming and mathematical statistics. Successful completion of coursework is necessary to enroll in the dissertation.',
  },
  {
    course_code: 'CCJ2002',
    course_name: 'Survey of Crime and Justice',
    course_desc:
      'Provides an introduction to the issues of crime and justice in the United States. Discusses the complexities of studying crime and evaluates the role of various criminal justice subsystems.\nMeets General Education requirement in Social Sciences.',
  },
  {
    course_code: 'CCJ3014',
    course_name: 'Criminology',
    course_desc:
      'Examines the causes, types, and patterns of crime in society. Major schools of thought and current research are introduced, compared, and contrasted in the study of crime and its social context.',
  },
  {
    course_code: 'CCJ3024',
    course_name: 'Criminal Justice System',
    course_desc:
      'Introductory analysis of the American criminal justice system. Structure, organization and process of the criminal justice system, the roles and responsibilities of criminal justice professionals, and the dynamics of the justice system in a democratic society. Additional focus will be on academic writing, APA formatting, searching and using scholarly references.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'CCJ3060',
    course_name: 'Ethics and the Justice System',
    course_desc:
      'Identification and analysis of ethical issues in the American justice system.',
  },
  {
    course_code: 'CCJ3450',
    course_name: 'Criminal Justice Management and Organization',
    course_desc:
      "Acquaints student with the basic management processes affecting criminal justice agencies, develops the student's ability to analyze management problems and apply effective interventions to those problems in police departments, courts, and corrections agencies.",
  },
  {
    course_code: 'CCJ3553',
    course_name: 'Family Crime and Violence',
    course_desc:
      'Survey of major issues related to family relationships and criminal activity, including theoretical explanations for family violence, patterns of family violence in the United States, and how family relationships during childhood can affect long-term behavior. This course will help to elucidate some of the most important elements of the connection between family relationships and crime.',
  },
  {
    course_code: 'CCJ3651',
    course_name: 'Drugs, Crime, and Criminal Justice',
    course_desc:
      'Explores the interactions between drugs, crime, and society. Relevant history, theory, and research related to drug use, prevention, rehabilitation, and the drug-crime link will be explored critically. Additionally, this course will examine the pharmacology of drugs and the prevalence of usage. As such, this course aims to provide a foundation for a better understanding the relationship between drugs, crime, and the criminal justice system.',
  },
  {
    course_code: 'CCJ3666',
    course_name: 'Victimology',
    course_desc:
      "The study of the interrelationships between crime, criminals, victims, and the criminal justice system. Areas of emphasis include victim's rights, restorative justice, as well as the psychological, financial, and medical needs and problems of the victim.",
  },
  {
    course_code: 'CCJ3678',
    course_name: 'Race, Gender, Ethnicity, and Crime',
    course_desc:
      'Analysis of the demographic state of affairs in criminal justice in the United States. Designed to elicit discussion regarding the interrelationships between race, gender, ethnicity, and the criminal justice system.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'CCJ3691',
    course_name: 'Sex Offenses and the Offender',
    course_desc:
      'Comprehensive overview of psychological, sociological and legal issues related to sex offenses. Additionally, the sexual offenders and different typologies of the sex offender will be discussed.',
  },
  {
    course_code: 'CCJ3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CCJ4026',
    course_name: 'Contemporary Issues in Criminal Justice',
    course_desc:
      'Examines the nature and extent of crime in modern Western society. Emphasis placed on issues selected from, but not limited to, emerging patterns of violence, organized crime, white-collar crime, victimless crime, corruption, and those crime strategies deemed appropriate in a democracy.',
  },
  {
    course_code: 'CCJ4141',
    course_name: 'Restorative Justice',
    course_desc:
      'Introduces the philosophy of restorative justice. Students critically analyze and compare retributive justice with restorative justice. Explores various restorative justice methodologies and evaluation of those methodologies. Hands on instruction in the use of restorative practices will be given.',
  },
  {
    course_code: 'CCJ4641',
    course_name: 'Organized Crime',
    course_desc:
      'An exploration of major issues related to organized crime. Topics include historical aspects, theoretical perspectives, and criminal actions commonly associated with organized crime activities.',
  },
  {
    course_code: 'CCJ4644',
    course_name: 'White Collar Crime',
    course_desc:
      'Considers the question "what is white-collar crime?" and the implications associated with enforcement of laws related to white-collar criminality, investigation and prosecution of such offenses and sentencing of white-collar offenders. Various forms of white-collar crime will be examined and illustrated through case studies and research, including estimates of cost, victim and offender profiles, and legal issues. Examines theoretical explanations for white-collar crime and questions of corporate liability.',
  },
  {
    course_code: 'CCJ4700',
    course_name: 'Research Design in Criminal Justice',
    course_desc:
      "Designed to give students an understanding of the basic principles and practices of empirical research as they are practiced in criminal justice and to enhance students' critical thinking skills with respect to criminal justice programs and proposals.\nMeets Gordon Rule Writing Requirement.",
  },
  {
    course_code: 'CCJ4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CCJ4931',
    course_name: 'Special Topics in Criminal Justice',
    course_desc:
      'The study of special issues in criminal justice. Subject matter will vary each semester to reflect an in-depth study of particular issues (e.g. gangs) or fields of criminology (e.g. corrections and theories of punishment) being examined. This includes grounding course content in criminological theory, as well as related theoretical frameworks.',
  },
  {
    course_code: 'CCJ4939',
    course_name: 'Criminal Justice Seminar',
    course_desc:
      'This capstone class is a comprehensive and critical review of the criminal justice curriculum with a focus on contemporary issues. This seminar will help students explore and prepare for a career in criminal justice and/or graduate education. Students are provided the opportunity to explore current criminal justice issues and criminal justice careers through an integration of knowledge gained in the criminal justice curriculum. Students will demonstrate oral and written communication skills.',
  },
  {
    course_code: 'CCJ4940',
    course_name: 'Criminal Justice Internship',
    course_desc:
      'Internship in field of criminal justice intended to give field observation and\nexperience. This internship is a cooperative effort between the criminal justice program at the University of West Florida and public or private community agencies. The purpose of the internship is to give students the opportunity to apply their education to actual work situations. The student works under the supervision of an agency professional. A 3 credit hour internship may be used to satisfy the capstone experience in the criminal justice core requirements.',
  },
  {
    course_code: 'CCJ5018',
    course_name: 'Crime and Public Policy',
    course_desc:
      'Analysis of various policy initiatives designed to reduce the level of crime. Applies elements of criminological theory and research methods to critically evaluate the effectiveness of policies.',
  },
  {
    course_code: 'CCJ5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CCJ6006',
    course_name: 'Criminal Justice Administration',
    course_desc:
      'This course focuses on the principles of organization, administration, and function of criminal justice agencies. These agencies include law enforcement, the courts, and corrections. The course includes an examination of management approaches and problems in criminal justice, including the planning and evaluation techniques and the use of information systems.',
  },
  {
    course_code: 'CCJ6008',
    course_name: 'Criminal Justice Theory',
    course_desc:
      'Analyzes the theoretical perspectives associated with the policies, organizations, decisions, and operations of criminal justice systems, agencies, and individuals. Examines classical and contemporary research in criminal justice.',
  },
  {
    course_code: 'CCJ6061',
    course_name: 'Criminological Theory',
    course_desc:
      'Examines criminological theories with emphasis on the origins and applications of relevant theoretical approaches to crime and criminally deviant behavior. Addresses theoretical concepts and propositions of most (though not all) of the major criminological theories, the related empirical research that has tested these theories, and the corresponding policy implications.',
  },
  {
    course_code: 'CCJ6704',
    course_name: 'Research Methodology',
    course_desc:
      'Covers issues related to research methods and data analysis as they are applied in the field of criminal justice and criminology. Explores scientifically acceptable inquiry and how to conduct empirical research in criminology and criminal justice. Evaluates methodological and ethical issues related to crime and criminal justice research.',
  },
  {
    course_code: 'CCJ6705',
    course_name: 'Analysis of Quantitative and Qualitative Data',
    course_desc:
      'Methods and techniques for diagnostics, management, and analysis of criminological and criminal justice data in both quantitative and qualitative nature. Statistical theory and research design issues specific to criminological and criminal justice analyses are covered along with hands-on computer experience using computerized statistical programs such as SPSS.',
  },
  {
    course_code: 'CCJ6715',
    course_name: 'Issues in Contemporary Criminal Justice',
    course_desc:
      'An in-depth study of issues confronting 21st Century criminal justice systems. Topics include those associated with current events and controversies.',
  },
  {
    course_code: 'CCJ6745',
    course_name: 'Policing and Society',
    course_desc:
      'Analysis of classical and contemporary readings designed to examine the unique position, organization, and challenges of policing a complex society. Also explores the future of policing.',
  },
  {
    course_code: 'CCJ6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CCJ6910',
    course_name: 'Criminal Justice Area Paper',
    course_desc:
      'Under the direction of the faculty, the student prepares a comprehensive analysis of a topic within criminal justice. The paper will include a critical and comprehensive review of the literature related to the chosen topic. The paper may include a research proposal and/or presentation of research findings.',
  },
  {
    course_code: 'CCJ6946',
    course_name: 'Criminal Justice Internship',
    course_desc:
      'Internship in field of criminology and criminal justice intended to give field observation and experience. This internship is a cooperative effort between the criminal justice program at the University of West Florida and public or private community agencies. The purpose of the internship is to give students the opportunity to apply their education to actual work situations. The student works under the supervision of an agency professional. Course requirements include a research component.',
  },
  {
    course_code: 'CDA3101',
    course_name: 'Introduction to Computer Organization',
    course_desc:
      'Introduction to the organization and operation of a digital computer including the internal representation of data and instructions, processor design and execution along with bus and I-O subsystems and assembly language programming.',
  },
  {
    course_code: 'CDA4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CDA5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CDA6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CEN3031',
    course_name: 'Software Engineering I',
    course_desc:
      'Preparation of software planning, specifications, design, coding, testing and maintenance. Familiarization with the team approach to large software system development with an emphasis on software process and methodology.',
  },
  {
    course_code: 'CEN3032',
    course_name: 'Software Engineering II',
    course_desc:
      'Focus on software design, implementation, and testing. Students will  work in teams to develop software systems using the design principles discussed in class.',
  },
  {
    course_code: 'CEN4053',
    course_name: 'Software Engineering Management',
    course_desc:
      'Reviews concepts and principles related to the management of software engineering projects. Focus is on both heavyweight and lightweight processes.',
  },
  {
    course_code: 'CEN4078',
    course_name: 'Secure Software Development',
    course_desc:
      'Examines the importance of building security into the design, implementation and testing phases of software development. Covers coding techniques that avoid known vulnerabilities and test strategies that can uncover previously unknown weaknesses. Includes discussion of security policies and design principles.',
  },
  {
    course_code: 'EUH4522',
    course_name: 'Modern Britain',
    course_desc:
      'Survey course in British history in the modern period.  Overview of British history from the end of the Victorian period in 1901 to the present.',
  },
  {
    course_code: 'CEN4340C',
    course_name: 'IT Infrastructure Planning, Acquisition, and Integration',
    course_desc:
      'A systematic examination of the hardware and software analysis and design or information technology systems. Acquisition of assets for integration into a new or existing infrastructure. Explores what makes IT projects different from other types of systems and how the principles and methods of system development can be integrated to define the IT system. Topics include hardware and software system implementation, information assurance, hardware and software catastrophe recovery, hardware and software configuration management, software license knowledge and monitoring, system hardware and software infrastructure support, infrastructure environmental concerns, and data and system integration.',
  },
  {
    course_code: 'CEN4721',
    course_name: 'Human-Computer Interaction',
    course_desc:
      'Introduces students to the design of the interaction between people and computers. It will give students insight and experience in key issues of HCI design, and will sample different areas related to human-computer interaction. Students will discuss issues and tradeoffs in interaction design, propose effective designs, conduct user studies, and evaluate alternative solutions to design problems.',
  },
  {
    course_code: 'CEN4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CEN5079',
    course_name: 'Secure Software Development',
    course_desc:
      'Examines the importance of building security into the design, implementation and testing phases of software development. Covers coding techniques that avoid known vulnerabilities and test strategies that can uncover previously unknown weaknesses. Includes discussion of security policies and design principles. Prior to taking this course students should have knowledge and skill in software development.',
  },
  {
    course_code: 'CEN5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CEN6016',
    course_name: 'Software Engineering Process',
    course_desc:
      'CEN6016 is a professional practice course in which the students will create several software engineering design documents.  Students will also critique and debate current topics and trends in software engineering.  Finally, prominent software engineering approaches, methods, and processes (e.g., CMMI, Agile processes) are examined and compared.',
  },
  {
    course_code: 'CEN6017',
    course_name: 'Continuous Software Engineering',
    course_desc:
      'This course focuses on aspects of modern software engineering as they pertain to continuous workflows. Topics of continuous testing, integration, delivery, and deployment will be discussed throughout the course. Significant programming experience is required for this course.',
  },
  {
    course_code: 'CEN6030',
    course_name: 'Agile Software Engineering',
    course_desc:
      'Analysis and overview of concepts in agile software development. Covers agile principles, methodologies, practices, and artifacts. \nThis course may require completion of graduate foundations courses in computer programming or the equivalent undergraduate coursework if a student has insufficient academic or professional experience in computer science.',
  },
  {
    course_code: 'CEN6064',
    course_name: 'Software Design',
    course_desc:
      'The course examines the design principles/methodologies appropriate for developing complex software systems. Goals include a comparative analysis of existing design methods, object-oriented design paradigms, and the extensions of modern design techniques and principles to the design of software with distributed implementations in mind.',
  },
  {
    course_code: 'CEN6074',
    course_name: 'Software Assurance and Security',
    course_desc:
      'Concepts and principles related to developing and maintaining secure software systems with no exploitable vulnerabilities with high levels of integrity and reliability.',
  },
  {
    course_code: 'CEN6095',
    course_name: 'Software Engineering Practice and Tools',
    course_desc:
      'Practicum course simulating best practices used in the software industry for maintaining software systems. Emphasis on the use of modern software methods and tools. Permission is required.',
  },
  {
    course_code: 'CEN6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CET3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CET4454',
    course_name: 'Technology Systems Implementation Strategies',
    course_desc:
      'Examines the processes and challenges posed by those processes involved in the conception, planning and implementation of a technology systems project. Learners will develop model documents for each process and each phase of the project implementation process.',
  },
  {
    course_code: 'CET4743',
    course_name: 'Network Systems Architecture, Operations and Management',
    course_desc:
      'Students will develop skills and abilities to effectively design, operate and manage a networked system. Network-related fault management, configuration, security, performance, and utilization measurements will be addressed. Lessons will include in-depth examination and appropriate applications in each functional area. Hardware and software tools that.',
  },
  {
    course_code: 'CET4772',
    course_name: 'Cloud Computing Operations and Security',
    course_desc:
      'Students will develop skills and abilities to effectively design, operate manage and distribute applications and services on the cloud. Lessons will include discussion on implementing infrastructure and applications as a service, virtualization on the cloud, and securing applications and services on the cloud.',
  },
  {
    course_code: 'CET6666',
    course_name: 'NOPS Project',
    course_desc:
      'Students enrolled in the MSIT/NOPS degree program are required to complete a two course, six-credit hour, capstone project.  Students will work in consultation with their instructor and an identified industry host to identify and complete a complex project related to their program of study.  Students synthesize and apply knowledge developed during the academic program to identify, propose and develop solutions to meet the complex networking needs of the host organization. This is the first course in the two course sequence.',
  },
  {
    course_code: 'CET6790C',
    course_name: 'Network Infrastructure and Operations',
    course_desc:
      'Explores the workings related to computer communications, formation of networks, various networking operations and implementation strategies, and recent trends in networking. COP2253 is a concurrent prerequisite for this course.  Students must have completed the course with a minimum grade of B prior to enrollment or be enrolled in the course concurrently.',
  },
  {
    course_code: 'PCB6971',
    course_name: 'Thesis',
    course_desc:
      'Graded on satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'CET6882',
    course_name: 'Network Performance Monitoring and Security',
    course_desc:
      'Students enrolled in the MSIT program take a sequence of courses related to Information processing, analytics and security.  This course examines network performance, strategies to optimize network performance and protocols related to network security. Students should have a basic understanding of computer networks.',
  },
  {
    course_code: 'CGS2020',
    course_name: 'Introduction to Machine Learning',
    course_desc:
      'This course offers an introduction to machine learning that is designed for an interdisciplinary audience. Students in this course will explore the machine learning landscape including the scope and its applicability in a wider context and in a variety of disciplines. This course will also provide students with an overview of the field of data science should they like to pursue it as their choice in higher education.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'CGS2060',
    course_name: 'Excursions in Computing',
    course_desc:
      'This course introduces students to essential concepts related to computing and software systems so that students may develop a computing literacy necessary to interact proficiently with modern computing systems in personal and professional domains.',
  },
  {
    course_code: 'CGS2570',
    course_name: 'Personal Computer Applications',
    course_desc:
      'An online course that provides practical experience with current and popular office software tools and exposure to the fundamentals of computing and networks. Issues in privacy, ethics, personal conduct, and security in professional settings are also covered. Students learn to use word processing, spreadsheet, presentation, and database software.',
  },
  {
    course_code: 'CGS2920',
    course_name: 'Foundations in Information Technology',
    course_desc:
      'This course will serve as a program cornerstone, introducing BS in IT students to the general scope of the Information Technology field. \nStudents will begin the process of assessing academic and professional goals, including evaluating potential capstone experiences/goals, considering professional development opportunities within and outside UWF, and evaluating interest in graduate studies.',
  },
  {
    course_code: 'CGS3183',
    course_name: 'Basic Web Applications',
    course_desc:
      'Introduces the student to the concepts and principles of designing software tools used in web applications. The student will gain hands on experience in developing, manipulating, and implementing web tools such as a databases and server-side programming. Credit may not be received in both CGS3183 and CGS 3172.',
  },
  {
    course_code: 'CGS3464',
    course_name: 'Programming Using Visual Basic',
    course_desc:
      'An introductory course in programming for non-majors. Incorporates the basic concepts of programming, programming logic and problem solving, as well as the design features of a visual, event driven language. Students will use a visual interface to program useful applications.  Credit cannot be earned in both COP3826 and CGS3464.',
  },
  {
    course_code: 'CGS3604',
    course_name: 'Applications of Information Technology',
    course_desc:
      'Investigates current applications of information technology in business, scientific research, education, and media, and examines issues facing the information technology professional working in a variety of disciplines.',
  },
  {
    course_code: 'CGS3763',
    course_name: 'Operating Systems Concepts',
    course_desc:
      'Presents basic and applied skills/abilities to effectively utilize computer operating systems and analyze operating system performance.',
  },
  {
    course_code: 'CGS4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CGS4912',
    course_name: 'Undergraduate Research in Information Technology',
    course_desc:
      'Students will propose, design, and perform a research project in consultation with a UWF professor, who will serve as research supervisor. Research will be summarized and presented within the department and University. Permission is required.',
  },
  {
    course_code: 'CGS4935',
    course_name: 'Senior Seminar in Information Technology',
    course_desc:
      'Students will meet with Information Technology professionals and faculty to learn about professional issues and responsibilities, employability skills and careers in Information Technology.  This will help students understand the job market so they will be able to transfer skills to future job positions.',
  },
  {
    course_code: 'CGS5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CGS6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CHI1100',
    course_name: 'Chinese Language I',
    course_desc:
      'Chinese I is a semester-long course designed for non-natve Chinese learners. It introduces\nstudents to  the official Chinese language-Mandarin (or Putonghua). The course aims to help students obtain an adequate mastery of basic language skills in both spoken and written Chinese and lay a good foundation for further study of this language. Throughout the semester,\nthis class will also introduce the Chinese culture and tradition to students. Students will learn\nthe Chinese phonology, vocabulary and grammar, and sentence patterns; they will also learn\nhow to read and write Chinese characters. Specifically, through such activities as vocabulary-in-context, sentence pattern practice, listening and reading comprehension, dialogue and role-play, students will learn to use Chinese in speech and writing in common, real-life scenarios.',
  },
  {
    course_code: 'CHI1101',
    course_name: 'Chinese Language II',
    course_desc:
      'This semester-long course, as a continuation of Chinese Language I is designed for non-native Chinese speakers with one semester (or less than one year) of Chinese; it continues to emphasize the basic skills of listening, speaking, reading, and writing. In this course, students will learn more vocabulary and grammar while consolidating what they have learned of Chinese in the first semester; students will learn a new vocabulary of more than 300 Chinese characters. At the end of this second semester of Chinese, students should be able to converse on more daily topics with relative ease and effectiveness while developing further reading and writing abilities. In this course, students will continue to develop and integrate the skills of listening, speaking, reading, and writing in Chinese and will learn more about Chinese culture and traditions.',
  },
  {
    course_code: 'CJE4110',
    course_name: 'Policing',
    course_desc:
      'Analysis of the role of and challenges to policing in a democratic society.  Examination of contemporary and historical influences on police policy, personnel, and organization. Discussion of police function within society.',
  },
  {
    course_code: 'CHM1020',
    course_name: 'Concepts in Chemistry',
    course_desc:
      'Introduces the non-scientist to current and critical issues in chemistry. Readings from popular science publications. Discussion on topics such as polymers, radioactivity, toxic chemicals, energy, etc. Registration for the corresponding lab is encouraged but not required.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'CHM1032',
    course_name: 'Fundamentals of General Chemistry',
    course_desc:
      'A one semester course presenting an introduction to the principles of general chemistry. Designed for students majoring in sciences other than biology and chemistry. Cannot be used to satisfy major requirements in chemistry or biology.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'CHM1905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CHM2045',
    course_name: 'General Chemistry I',
    course_desc:
      'Chemical and physical properties, relationship between observables and concepts and the development of a theoretical framework. Topics will include atomic and molecular structure, theories of bonding, properties of the elements and periodicity. A grade of "C-" or higher is required in prerequisite courses.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'CHM2045L',
    course_name: 'General Chemistry I Laboratory',
    course_desc:
      'Introduction to laboratory safety, experimental techniques, graphing of data, chemical reactivity and separations, calorimetry and volumetric analysis. Material and supply fee will be assessed. Students taking CHM2045 concurrently are required to withdraw from CHM2045L if they withdraw from CHM2045. A grade of "C-" or higher is required in prerequisite courses.',
  },
  {
    course_code: 'CHM2046',
    course_name: 'General Chemistry II',
    course_desc:
      'Continuation of CHM2045 with emphasis on chemical calculations and problem solving. Topics include thermodynamics, equilibria, kinetics and an introduction to transition metal complexes.  A grade of "C-" or higher is required in prerequisite courses.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'CHM2046L',
    course_name: 'General Chemistry II Laboratory',
    course_desc:
      'Experiments based on colligative properties, qualitative analysis, solution equilibria, kinetics, electrochemistry, radioactivity and synthesis. Material and supply fee will be assessed. Students taking CHM2046 concurrently are required to withdraw from CHM2046L if they withdraw from CHM2046. A grade of "C-" or higher is required in prerequisite courses.',
  },
  {
    course_code: 'CHM2210',
    course_name: 'Organic Chemistry I',
    course_desc:
      'Nomenclature, structure, fundamental reactions, mechanistic interpretation of reactions, and spectroscopy.',
  },
  {
    course_code: 'CHM2210L',
    course_name: 'Organic Chemistry I Laboratory',
    course_desc:
      'Introduction to laboratory techniques in Organic Chemistry. Isolation, purification, and synthesis. Material and supply fee will be assessed. Students taking CHM2210 concurrently are required to withdraw from CHM2210L if they withdraw from CHM2210. A grade of "C-" or higher is required in prerequisite courses.',
  },
  {
    course_code: 'CHM2211',
    course_name: 'Organic Chemistry II',
    course_desc:
      'Nucleophilic and electrophilic substitution reactions, additions, eliminations, redox and rearrangement reactions, carbohydrates, amino acids, peptides, isoprenoids. A grade of "C-" or higher is required in prerequisite courses.',
  },
  {
    course_code: 'CHM2211L',
    course_name: 'Organic Chemistry II Lab',
    course_desc:
      'Multistep synthesis, separation of mixtures, identification of unknown organic compounds by classical and spectroscopic techniques. Material and supply fee will be assessed. Students taking CHM2211 concurrently are required to withdraw from CHM2211L if they withdraw from CHM2211. A grade of "C-" or higher is required in prerequisite courses.',
  },
  {
    course_code: 'CHM3120',
    course_name: 'Analytical Chemistry',
    course_desc:
      'Fundamentals of quantitative chemical analysis; introduction to modern techniques. Material and supply fee will be assessed for corresponding lab. 8 sh of general chemistry required. A grade of "C-" or higher is required in prerequisite courses.',
  },
  {
    course_code: 'CHM3120L',
    course_name: 'Analytical Chemistry Lab',
    course_desc:
      "Fundamentals of quantitative chemical analysis; introduction to modern techniques. Material and Supply Fee will be assessed. 8 sh of general chemistry required. A grade of 'C-' or better is required in the prerequisite.",
  },
  {
    course_code: 'CHM3230',
    course_name: 'Organic Chemistry III',
    course_desc:
      'Focuses on spectroscopic techniques used to understand the structure of molecules, stereochemistry and stereoselective syntheses. While most examples will arise from organic chemistry, structures of selected organometallics and inorganic complexes will be discussed. Concepts of resonance and aromaticity are presented as they impact on the structure of molecules. Use of Molecular Mechanics calculations is introduced. 8 sh of organic chemistry required. A grade of "C-" or higher is required in prerequisite courses.',
  },
  {
    course_code: 'CHM3400C',
    course_name: 'Basic Physical Chemistry',
    course_desc:
      'A survey of the principles of Structure, Equilibrium, and Dynamics, applied to chemical systems. Includes experiments and other hands-on learning experiences.',
  },
  {
    course_code: 'CHM3410',
    course_name: 'Physical Chemistry I',
    course_desc:
      'Properties of gases, kinetic theory, chemical thermodynamics, heterogeneous equilibria, electrochemistry. A grade of "C-" or higher is required in prerequisite courses.',
  },
  {
    course_code: 'CHM3411',
    course_name: 'Physical Chemistry II',
    course_desc:
      'Atomic, molecular structure, spectroscopy, introduction to quantum theory and statistical mechanics. A grade of "C-" or higher is required in prerequisite courses.',
  },
  {
    course_code: 'CHM3740L',
    course_name: 'Advanced Laboratory Techniques',
    course_desc:
      'Experimental work including advanced laboratory techniques for the synthesis and purification of organic, organometallic and inorganic complexes. Training in the use of instrumentation (chromatographic techniques, NMR, GC / MS, IR, UV-Vis, ORD / CD, etc.) for the purification and characterization of these materials. Students will be introduced to the use of the chemical literature, as well as record keeping and report writing. Material and supply fee will be assessed.',
  },
  {
    course_code: 'CHM3741L',
    course_name: 'Physical Chemistry Laboratory',
    course_desc:
      'Experiments with emphases on equilibria, kinetics and spectroscopy. Material and supply fee will be assessed.',
  },
  {
    course_code: 'CHM3801',
    course_name: 'Responsible Conduct of Research',
    course_desc:
      'A wide range of topics will be discussed, including (but not limited to) mentoring, authorship and peer review, ownership and professional standards of data of data collection, handling, and analysis, use of animals and humans in research, and conflict of interest.',
  },
  {
    course_code: 'CHM3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CHM3940',
    course_name: 'Chemistry Internship',
    course_desc:
      'Placement in an appropriate chemical company for the purposes of gaining some experience in the field. Faculty and agency personnel will supervise as the student participates in a wide range of services available in the setting. Goals and objectives will be planned by the student, instructor and agency supervisor. Reports will be required on a regular basis with a final report. Graded on a Satisfactory/Unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'CHM4130',
    course_name: 'Instrumental Analysis',
    course_desc:
      'Physical chemical methods of chemical analysis. Required lab. Material and Supply Fee will be assessed for corresponding lab. A grade of "C-" or higher is required in prerequisite courses. Offered concurrently with CHM 5134; graduate students will be assigned additional work.',
  },
  {
    course_code: 'CHM4130L',
    course_name: 'Instrumental Analysis lab',
    course_desc: 'Corresponding lab for Instrumental Analysis lab.',
  },
  {
    course_code: 'CHM4455',
    course_name: 'Introduction to Polymer Science',
    course_desc:
      'Intended to introduce students to some of the major concepts Polymer Science: An Introduction to Macromolecules - Terms and Definitions; Structure and Bonding in Polymers; Step Growth Polymerization; Chain Growth Polymerization; Ionic Polymerization and Living Polymers; Copolymers; Chain Configurations, the Theta State and Chi Parameter; The Glass Transition Temperature; Biological Polymers; and Plastics Recycling.',
  },
  {
    course_code: 'CHM4455L',
    course_name: 'Introduction to Polymer Science Laboratory',
    course_desc:
      'Laboratory to accompany CHM4455. Will provide fundamental laboratory skills in polymer synthesis and analysis. Material and supply fee will be assessed.',
  },
  {
    course_code: 'CHM4610L',
    course_name: 'Inorganic Synthesis',
    course_desc:
      'Modern techniques in the synthesis, separation, purification and characterization of inorganic compounds. Material and Supply fee will be assessed.',
  },
  {
    course_code: 'CHM4611',
    course_name: 'Inorganic Chemistry',
    course_desc:
      'The structure, reactivity, kinetics and reaction mechanisms of inorganic and organometallic compounds.',
  },
  {
    course_code: 'CHM4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CHM4912',
    course_name: 'Undergraduate Chemistry Research',
    course_desc:
      "Undergraduate research is conducted with a faculty advisor or mentor. The student's research project is typically based on the faculty mentor's research interests. The mentor meets regularly with the student to make research plans, assess risks associated with the proposed research, and review results. The student is encouraged to take primary responsibility for the project and to make substantial input into its direction. A formal written report or thesis is required upon completion of the course. Permission is required.",
  },
  {
    course_code: 'CHM4930',
    course_name: 'Seminar: Special Topics in Advanced Chemistry',
    course_desc:
      'Will focus on advanced topics in chemistry that will extend the knowledge learned in the core chemistry courses. Specific topic will vary depending on instructor. Offered concurrently with CHM 5932; graduate students will be assigned additional work.',
  },
  {
    course_code: 'CHM4931',
    course_name: 'Seminars in Chemistry',
    course_desc:
      'The course will include seminars by visiting scientists, university faculty and students on current research in chemistry, as well as scientific literacy, professional ethics, hazard waste regulations, resume writing, and presentation skills.',
  },
  {
    course_code: 'CIS2530',
    course_name: 'Introduction to Cybersecurity',
    course_desc:
      'This course introduces students to cybersecurity . It provides information related to cyber threats as well as the basic security design and information assurance fundamentals. In addition the course covers information assurance controlling laws and guidelines.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'CIS3325',
    course_name:
      'Information Technology Infrastructure Analysis and Recommendation',
    course_desc:
      'Students will develop the knowledge, skills and abilities necessary to analyze technology infrastructure needs of various types and sizes of organizations and provide appropriate solution recommendations to solve complex problems.',
  },
  {
    course_code: 'CIS3385',
    course_name: 'Introduction to Digital Forensics',
    course_desc:
      'Explores methodologies and techniques for maintaining integrity of forensic evidence. Uses popular forensics tools and provides specific guidance on the investigation process of cases relating to law and technology. Topics include representation, preservation and recovery of data from multiple sources, and legal issues unique to the digital forensics investigation process. Students will collect, examine, analyze and prepare detailed reports showing the relevance of digital evidence to cases.',
  },
  {
    course_code: 'CIS3949',
    course_name: 'Cooperative Education',
    course_desc:
      'Alternating full-time or consecutive parallel terms of practical experience in the intended field. Reinforcing academic preparation; confirming educational and career goals; personal and professional development; early start in career; earnings toward self-support; improved employability. (See program description under Cooperative Education). Graded on satisfactory/unsatisfactory basis only. Permission of director of Cooperative Education is required.',
  },
  {
    course_code: 'CIS4361',
    course_name: 'Information Technology Security',
    course_desc:
      'This course provides an overview of security challenges and strategies of countermeasure in the information systems environment. Topics include definition of terms, concepts, elements, and goals incorporating industry standards and practices with a focus on confidentiality, availability, and integrity aspects of information systems.',
  },
  {
    course_code: 'FIN4504',
    course_name: 'Investments',
    course_desc:
      'Introduction to an extensive development of theoretical concepts related to areas of securities analysis and portfolio management.',
  },
  {
    course_code: 'CIS4368',
    course_name: 'Introduction to Database Security',
    course_desc:
      'The Database Security course follows guidelines set forth by the National Security Agency/Department of Homeland Security Centers of Academic Excellence in Information Assurance and Cyber Defense.  This course is considered a core knowledge unit for institutions to be considered a Center of Academic Excellence. Database Security is designed to teach students how database systems are used, managed, and issues associated with protecting the associated data assets.  This undergraduate course is a requirement for the B.S. in Cybersecurity and will be an elective for all other undergraduate Computer Science programs.\nPrerequisites: COP4710, minimum grade of C-.',
  },
  {
    course_code: 'CIS4385',
    course_name: 'Ethical Hacking and Penetration Testing',
    course_desc:
      'This course provides a understanding of how to effectively protect computer networks. Students will learn the tools and penetration testing methodologies used by ethical hackers. The tools and methodology will focus on gathering information and identifying flaws and vulnerabilities in documentation, software and computer systems, and exploiting those flaws. In addition, the course provides a thorough discussion of what and who an ethical hacker is and how important they are in protecting corporate and government data from cyber attacks. Students will be provided with an overview of computer crime laws. This course is offered concurrently with CIS5396; graduate students will be assigned additional work. Credit cannot be received in both CIS4385 and CIS5396.',
  },
  {
    course_code: 'CIS4592',
    course_name: 'Capstone Project',
    course_desc:
      'This course requires students to apply their skills in design, implementation, and evaluation of a software product addressing a complex, real-world problem. The course reinforces software engineering concepts and skills from previous coursework, focusing on best practices and methods for building software. Students will work as teams to develop a project plan, multiple prototypes, and a final software system for the project topic. Students will be required to prepare a final presentation on their project and a report that describes their achievements and provides a critical assessment of professional and ethical issues as well as their work and final product.',
  },
  {
    course_code: 'CIS4595',
    course_name: 'Capstone Project',
    course_desc:
      'This course brings together students from different computing and security disciplines to solve complex, real-world problems in teams. Students develop, secure, and analyze computing systems applying the skills they have acquired in their respective majors. They develop and deliver relevant artifacts such as requirements, design, test, and security plans, as well as user documentation for those systems. Teams shall focus on the use of modern tools for collaboration, communication, and project management throughout the duration of this course. Students produce presentations and individual project evaluations. Ethical and professional issues will be addressed in the context of the project.',
  },
  {
    course_code: 'CIS4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CIS4941',
    course_name: 'Computer Science Internship',
    course_desc:
      'Supervised field practicum in computer-related position. May include activities in computer programming, database administration, web-development, systems administration, network security, etc. Graded on satisfactory / unsatisfactory basis only. Juniors or seniors with minimum cumulative GPA of 3.00 will be eligible. Permission is required.',
  },
  {
    course_code: 'CIS4947',
    course_name: 'Internship/Practicum in Information Technology',
    course_desc:
      'Practical and significant Information Technology professional work experience under approved industrial supervision.',
  },
  {
    course_code: 'CIS5396',
    course_name: 'Ethical Hacking and Penetration Testing',
    course_desc:
      'This course provides a understanding of how to effectively protect computer networks. Students will learn the tools and penetration testing methodologies used by ethical hackers. The tools and methodology will focus on gathering information and identifying flaws and vulnerabilities in documentation, software and computer systems and exploiting those flaws. In addition, the course provides a thorough discussion of what and who an ethical hacker is and how important they are in protecting corporate and government data from cyber attacks. Students will be provided with an overview of computer crime laws. Offered concurrently with CIS4385; graduate students will be assigned additional work. Credit may not be received in both CIS5396 and CIS4385.',
  },
  {
    course_code: 'CIS5775',
    course_name: 'Cybersecurity Principles',
    course_desc:
      'This course introduces students to topics in cybersecurity. It provides information related to threat models, vulnerability analysis, and security-policy formation and enforcement. In addition, the course covers information assurance controlling laws and guidelines as well as introduces students to broad topics in network and system security, Internet services, and digital forensics.',
  },
  {
    course_code: 'CIS5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CIS6084',
    course_name: 'Cloud Computing Architecture and Security',
    course_desc:
      'This course provides students with the necessary knowledge and skills of cloud computing architecture and security. Students identify and evaluate cloud computing resources and services. Also, this course focuses on security issues and countermeasures. Additional topics vary but may include access control, identity access management, compliance, and trustworthy computing.',
  },
  {
    course_code: 'CIS6376',
    course_name: 'Database Security',
    course_desc:
      'Database Security is designed to teach students how database systems are used, managed, and issues associated with protecting the associated data assets.  This course will cover various methods to ensure information confidentiality, integrity and availability on an assortment of data storage systems.  This graduate course is a requirement for the M.S.A. in Cyber Security and will be an elective for all other graduate Computer Science programs.\nPrerequisites: COP5725 minimum grade of C.',
  },
  {
    course_code: 'CIS6379',
    course_name: 'Applied Information Security',
    course_desc:
      'This course covers a variety of topics which range from information security fundamentals to the management and planning aspects of information security. Students in this course will learn to design and create information security policies, disaster recovery and risk analysis & mitigation plans. Students will also learn about security models and various physical and technical security controls.',
  },
  {
    course_code: 'CTS4348',
    course_name: 'Linux System Administration',
    course_desc:
      'This course focuses on essential Linux administration tasks, including installation, establishing network connectivity, managing physical storage and basic security administration.',
  },
  {
    course_code: 'CIS6394',
    course_name: 'Digital Forensics',
    course_desc:
      'This course will provide a solid foundation for performing a digital forensic examination; introduces tools and techniques required for conducting a forensic analysis on systems and data pertaining to evidences in civil, criminal or administrative cases. It introduces systematic problem-solving techniques and applies them to digital investigations. The techniques directly correlate to methods used to recover/restore data for various requirements, ranging from litigation to fraud-based investigations.',
  },
  {
    course_code: 'CIS6415',
    course_name: 'Advanced Computer Systems and Networks',
    course_desc:
      'Examines current advancements in computer hardware, operating systems and networks. their relation to each other, and programming practices that takes advantage of them. Topics include pipelined, hyperthreaded, multicore and multiprocessor architectures, scheduling methods, distributed and real-time systems, high-speed networks, routing, congestion and flow control, and quality of service.',
  },
  {
    course_code: 'CIS6511',
    course_name: 'Enterprise Information Technology Risk Management',
    course_desc:
      'This course introduces the risks that may emerge in enterprises. Students follow a holistic approach to applying well defined best practices in information systems risk management. This course provides the necessary skills and knowledge to evaluate, plan, mitigate, and protect information infrastructure and assets. Case studies may be used to demonstrate the issues and challenges in risk management.',
  },
  {
    course_code: 'CIS6625',
    course_name: 'Data Security',
    course_desc:
      'This course covers concepts of Data Security from a data centric perspective. Challenges faced by today?s systems will be studied and the future of data security will be discussed.\nThis course may require completion of graduate foundations courses in computer programming or the equivalent undergraduate coursework if a student has insufficient academic or professional experience in computer science.',
  },
  {
    course_code: 'CIS6710',
    course_name: 'Trends in Information Technology',
    course_desc:
      'Trends in Information Technology focuses on leveraging the latest technology to solve existing problems and to propose effective and efficient solutions. Students will also evaluate options and provide rationale for choices made in problem solving related to system performance and security.',
  },
  {
    course_code: 'CIS6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CIS6950',
    course_name: 'Information Technology Capstone Seminar',
    course_desc:
      'Students enrolled in the MSIT degree program are required to complete a two course, six-credit hour, capstone project. Students will work in consultation with their instructor and an identified industry host to identify and complete a complex project related to their program of study. Students synthesize and apply knowledge developed during the academic program to identify, propose and develop solutions to meet the complex networking needs of the host organization.\nStudents must complete 18 graduate hours and obtain department permission to enroll.',
  },
  {
    course_code: 'CIS6971',
    course_name: 'Thesis',
    course_desc:
      'Graded on satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'CJC4010',
    course_name: 'Corrections',
    course_desc:
      'Basic analysis of correctional systems in the United States. Focus is on widely held conceptions of punishment, physical design and organizational structures of prison facilities, community based correctional options, the death penalty and the evaluation of correctional research. Other topics of interest include sentencing policy, key issues faced by prison administrators and prisoners as well as the role of the victim in corrections.',
  },
  {
    course_code: 'CJC4167',
    course_name: 'Community Corrections',
    course_desc:
      'Introduces the student to the subject of community corrections including social, political, and economic conditions that have contributed to the development of community corrections. Identifies the types of community corrections and the effectiveness of such options. The needs of special offender populations for corrections alternatives are also explored.',
  },
  {
    course_code: 'CJC6021',
    course_name: 'Penology',
    course_desc:
      'Examines classical and contemporary readings in corrections. Uses historical and philosophical contexts to critically assess contemporary correctional issues and introduces students to the importance of data-driven policy promoting critical evaluation and debate.',
  },
  {
    course_code: 'CJE3174',
    course_name: 'Comparative Criminal Justice',
    course_desc:
      "The evolution and operation of criminal justice systems in other nations and cultures including the development of criminal justice in response to social, historical, and political factors. Includes a brief history of the world's legal systems and an analysis of key procedural and substantive similarities and differences. Associated topics include: administration and function of police, courts, and corrections, and a study and analysis of the increasing internationalization of both the incidence of crime and the administration of criminal justice.",
  },
  {
    course_code: 'CJE3444',
    course_name: 'Crime Prevention',
    course_desc:
      'Provides a foundation of various methods of community crime prevention (prevention outside the traditional confines of the CJS) and their effectiveness. Relevant theory and research related to neighborhood efforts at crime prevention, community policing, school crime prevention, and other situational prevention measures will be explored critically.',
  },
  {
    course_code: 'CJE3617',
    course_name: 'Cold Case Investigations',
    course_desc:
      'An examination of investigative methods and efforts to solve crimes previously deemed closed or pending development of evidence; cold cases.',
  },
  {
    course_code: 'CJE3674',
    course_name: 'Introduction to the Forensic Sciences',
    course_desc:
      'Forensic Science is the application of scientific disciplines and principles to the legal system, particularly the litigation in court of contested factual disputes. Examines the distinct fields of education and study that collectively comprise the forensic sciences. These fields include among others forensic psychiatry and psychology, forensic anthropology, forensic pathology, forensic toxicology, serology and DNA typing, questioned documents, crime scene investigation, forensic engineering, fingerprint evidence, polygraph and other investigative devices, and forensic chemistry including drug analysis. Credit may not be received in both CJE3674 and CJE 3670.',
  },
  {
    course_code: 'CJE3694',
    course_name: 'Cybercrime',
    course_desc:
      'Cybercrime is a course for students with a beginning interest in studying crimes committed using digital technology. The course explores the etiology of cybercrime, the various types of cybercrime, law enforcement response, and the prevention of digital crime.',
  },
  {
    course_code: 'CJE4161',
    course_name: 'Crime and Media',
    course_desc:
      "Analysis of the depiction of crime and the criminal justice system presented through the major mass media within America. Forms of media may include, but are not limited to: crime movies, television crime dramas, television news, the internet, and newspaper crime coverage. This course uses media as a learning tool to allow students to more deeply examine how the criminal justice system works and how society's reaction to crime is influenced by the media.",
  },
  {
    course_code: 'CJE4610',
    course_name: 'Criminal Investigation',
    course_desc:
      'An introduction to criminal investigation. Topics will include investigative theory, collection and preservation of evidence, sources of information, interview and interrogation, uses of forensic sciences and case and trial preparation. Credit may not be received in both CJE4610 and CCJ 4239.',
  },
  {
    course_code: 'CJE4613',
    course_name: 'Homicide',
    course_desc:
      'An examination of homicide and its investigation. Includes types of homicide as well as death by natural and accidental causes. Reviews and expands on investigative theory, collection and preservation of evidence, sources of information, interview and interrogation, uses of forensic sciences and case and trial preparation.',
  },
  {
    course_code: 'CJJ4010',
    course_name: 'Juvenile Justice',
    course_desc:
      'Examines the nature and extent of delinquency in the United States and the system response to juvenile crime. Particular attention is given to theoretical explanations of juvenile delinquency and examination of how politics, courts, and correctional agencies respond to juvenile offenders, and the effectiveness of these responses. Credit may not be received in both CJJ4010 and CCJ 4501.',
  },
  {
    course_code: 'CJJ6020',
    course_name: 'Criminal Justice and the Juvenile',
    course_desc:
      'Explores the nature and extent of juvenile delinquency and examines explanatory models and theories of juvenile delinquency. Topics related to the juvenile justice system and the process, such as juvenile waiver to the adult court, diversion and deinstitutionalization, police interaction, and community intervention.',
  },
  {
    course_code: 'CJL3510',
    course_name: 'Courts',
    course_desc:
      'Examination of the judicial component of the criminal justice system. Analysis of structure, procedures, and personnel of American courts. General discussion of the political and social influences on the judicial process and organization.',
  },
  {
    course_code: 'CJL6521',
    course_name: 'Courts and Society',
    course_desc:
      'Analyzes the role of courts in American society; examines the various influences on judicial organization, process, and decision making; and explores the impact of courts within society and the criminal justice system.',
  },
  {
    course_code: 'CLP3144',
    course_name: 'Abnormal Psychology',
    course_desc:
      'Broad overview of psychological disorders of children and adults including history of abnormal human behavior, research methods, theories and causes, and contemporary treatment. Typical topics include adjustment, mood, anxiety, somatoform, factitious, dissociative, substance-related, personality, and psychotic disorders (including schizophrenia).',
  },
  {
    course_code: 'CLP3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CLP4110',
    course_name: 'Eating Disorders',
    course_desc:
      'Eating Disorders provides an introduction to the characteristics and criteria associated with a variety of forms of disordered eating.  It covers Pica, Avoidant-Restrictive Food Intake Disorder, anorexia nervosa, bulimia, binge eating disorder, and compulsive overeating, among others, and overviews key features of their causes, presentation, and treatment.  Special attention is dedicated to understanding eating disorders in women, men, athletes, and multicultural populations.  Attention is given to critical factors in the development and maintenance of eating disorders, including personality features, family characteristics, sexual orientation, sociocultural environment, and genetic influences.  Further, the medical and physiological consequences of eating disorders will be covered.  Treatment strategies for those with eating disorders are also reviewed, including nutritional, psychological and pharmacological forms of treatment.  Finally, strategies for preventing eating disorders are explored.',
  },
  {
    course_code: 'CLP4185',
    course_name: 'Behavioral and Technology Addictions',
    course_desc:
      'This course focuses on the varied forms of addictive behaviors and treatments, including gambling, online gaming, food addiction, pornography addiction, sex addiction, compulsive shopping, Internet addiction, and other impulse control disorders.  Attention is given to the relationship between behavioral addictions and substance addictions across a number of domains, including their natural history, phenomenology, comorbidity, genetic predisposition, neurobiological mechanisms, and response to treatment.  Developments in the conceptualization, prevention, and intervention are addressed as well, in relation to the rapidly evolving field of behavioral addictions.',
  },
  {
    course_code: 'CLP4314',
    course_name: 'Health Psychology',
    course_desc:
      'Survey of contributions of the discipline of psychology to the promotion and maintenance of health and prevention and treatment of illness. Application of biopsychosocial model to health. Credit cannot be received in both CLP4314 and PSY 4820.',
  },
  {
    course_code: 'CLP4390',
    course_name: 'Introduction to Forensic Psychology',
    course_desc:
      'This upper-level undergraduate course is designed to be an exciting and intellectually challenging introduction to the study of Forensic Psychology. Forensic Psychology deals with the interplay between the disciplines of psychology and law. Specifically, this class examines the legal system through the use of psychological concepts, methods, and research results. Although the course covers both criminal and civil aspects of the legal system, the primary focus will be on the role of psychologists in those areas pertaining to the criminal legal system. Class content focuses on theory but also has a strong experiential component as well. Specifically, the class learning experience culminates in the production of a Mock Trial.',
  },
  {
    course_code: 'CLP4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CLP5166',
    course_name: 'Psychopathology',
    course_desc:
      'Students must take CLP3144 before enrolling in this course.\nIn depth analysis of child and adult psychological disorders focusing on practical application of the current diagnostic manual in developing diagnostic formulations. Emphasis on an integrative theoretical approach and the empirical foundation for theory, causes, and treatment of psychological disorders.',
  },
  {
    course_code: 'CLP5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CLP6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'DAA3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'DAA4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CNT3004',
    course_name: 'Introduction to Networks',
    course_desc:
      'This course introduces the technologies and skills used in the world of networking.  Emphasis is on practical applications of networking technology to real-world problems. Students gain the knowledge necessary to design, install, and configure a local area network. Students will build simple LANs, perform basic configurations for routers and switches, and implement IP addressing schemes.',
  },
  {
    course_code: 'CNT3112',
    course_name: 'Routing and Switching Essentials',
    course_desc:
      'This course provides students with intermediate level knowledge in the architecture, components, and operations of routers and switches in a small network. Content includes how to configure and troubleshoot routers and switches. Students will learn how to design and configure virtual LANs, inter-VLAN routing in both IPv4 and IPv6 networks, and routing protocols.',
  },
  {
    course_code: 'CNT4007',
    course_name: 'Theory and Fundamentals of Networks',
    course_desc:
      'A functional systematic examination of the key components and theories of modern computer networks, including protocol stack, mobile networking, network security, multimedia networking and network management. Emphasizes the internet for studying network fundamentals and includes the use of tools to analyze network operations.',
  },
  {
    course_code: 'CNT4013',
    course_name: 'Connecting Networks',
    course_desc:
      'This course enables students to put emphasis on network services required by converged applications in a complex network. Students learn how to configure, troubleshoot, and manage network devices, and resolve issues with data link protocols. Students will also implement and configure IPSec and virtual private network (VPN) in a complex network.',
  },
  {
    course_code: 'CNT4014C',
    course_name: 'IT Administration',
    course_desc:
      "Introduction to principles behind design, installation, and support of organization's LAN, WAN, network segment, intranet, or Internet, including maintenance of network hardware and software, and monitoring of network to ensure availability to system users. Topics include gathering of data to determine customer needs, identification, interpretation, and evaluation of system and network requirements and technical-management issues.",
  },
  {
    course_code: 'CNT4403',
    course_name: 'Computer and Network Security',
    course_desc:
      'This course provides students with an understanding of the concepts of computer and network security using currently available technology. The course provides students with an understanding of the options available to mitigate threats within a system and teach students the techniques that can be taken to protect a network and communication assets from cyber threats.',
  },
  {
    course_code: 'CNT4416',
    course_name: 'Cyber War Gaming',
    course_desc:
      'Every organization, whether part of the government or the private sector, needs "battle-tested" IT personnel in order to defend its networks against attack. The most effective way to provide this experience is to recreate the exact scenarios, no matter how nefarious, they will see in the real world. This course provides exercises that use different specialties (network, security, visualization, software, etc.) into color-coded red and blue teams that perform specific roles\nin attacking and defending IT infrastructures.',
  },
  {
    course_code: 'CNT4526',
    course_name: 'Wireless and Mobile Communications',
    course_desc:
      'Introduces common wireless technologies and wireless network architectures including common carrier cellular networks. Learners will examine characteristics of these technologies and identify their roles in enterprise-class information technology operations. Learners will identify common tools and applications associated with these technologies and explain their roles in design, deployment and management of them.\nWireless technologies strengths and weaknesses are described in the context of their effect on enterprise security, performance and cost management.',
  },
  {
    course_code: 'CNT4701',
    course_name: 'Scaling Networks',
    course_desc:
      'This course covers the architecture and operations of routers and switches in complex networks. Students learn how to configure and troubleshoot routers and switches in large networks. This course provides students with skills and knowledge needed to resolve common issues with OSPF, EIGRP, STP, and VTP in both IPv4 and IPv6 networks. Students will also develop the skills needed to configure DHCP and DNS related servers in a network.',
  },
  {
    course_code: 'CNT5407',
    course_name: 'System and Network Security',
    course_desc:
      'This course covers the basic strategies and tools that prepare students to engage in proactive and aggressive cybersecurity activities, with an increased focus on computer, network and system security. Students will learn about protection strategies which are most effective when dealing with cyber attacks, especially in an age of increased reliance on distributed devices. \nThis course may require completion of graduate foundational courses in computer science or undergraduate coursework in computer networks and operating systems if a student has insufficient academic or professional experience in the field.',
  },
  {
    course_code: 'CNT6519',
    course_name: 'Wireless Network Security',
    course_desc:
      'The objective of the course is to study and understand the security and research challenges of existing and emerging wireless networks. Students will learn about various security issues such as key management, privacy, authentication and secure data aggregation and the algorithms used to resolve these issues.',
  },
  {
    course_code: 'COM2023',
    course_name: 'Death and Communication',
    course_desc:
      'In this course we shall examine topics related to death. The chief focus of this class will be interpersonal communication and death. We will explore end-of-life communication in a family context. Other topics include death rituals in diverse cultural contexts, the high cost of dying in the United States, and death policy. Please be aware that some of these issues can be rather disquieting to consider and discuss. Students should consider the subject matter before deciding to enroll in this course.\nMeets General Education requirement in Social Sciences.',
  },
  {
    course_code: 'COM2203',
    course_name: 'Communication Dynamics',
    course_desc:
      'This course provides a theoretical foundation for understanding communication in the workplace, personal relationships, and mediated environments. Students will master the basics of conflict management, listening, nonverbal communication, strategic use of language, interviewing, leadership, teamwork, and intercultural communication. The course provides a foundation for advance-level studies in communication and helps students master communication proficiencies essential to success in professional and personal life.',
  },
  {
    course_code: 'EEE3396',
    course_name: 'Solid-State Electronic Devices',
    course_desc:
      'Introduction to the principles of semiconductor electron device operation. A grade of "C-" or better is required in the prerequisite.',
  },
  {
    course_code: 'COM2713',
    course_name: 'Writing for the Communication Professions',
    course_desc:
      'This introductory course exposes students to writing for communication professions such as advertising, public relations, and journalism. Students strengthen grammar and develop the writing skills necessary for specific forms of writing. Students will explore various types of writing such as newswriting, public relations writing, and advertising copy. Students will become familiar with Associated Press Style.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'COM3003',
    course_name: 'Integrated Advertising & Public Relations Concepts',
    course_desc:
      'Three hours. Survey of advertising and public relations methods.  Emphasis on preparation of advertisements, professional communication strategies and tactics, use of industry standard research methods, and communication campaigns. This course serves as the foundation for all other advertising & public relations courses.',
  },
  {
    course_code: 'COM3014',
    course_name: 'Gender Communication',
    course_desc:
      'Examines the roles gender plays in managing diversity in the workplace, developing personal relationships and exploring mass media in contemporary culture.  This course is designed to increase your understanding of gender as it is constructed, performed, evaluated, and negotiated through communication.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'COM3461',
    course_name: 'Intercultural Communication',
    course_desc:
      'Explores issues related to intercultural communication processes. Considers the important role of context (social, cultural, and historical) in intercultural interactions. The goal is to develop an understanding of the process of communicating across cultural boundaries. Operates from the premise that culture is both a producer and product of communication, and, therefore, an appreciation of communication processes is an essential factor in promoting positive intercultural relations and pursuing a more just global society.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'COM3465',
    course_name: 'Conflict Management',
    course_desc:
      'This course focuses on the management of conflict through effective communication. Hands on student learning is emphasized. The course offers the theoretical investigation of communication barriers and breakdowns in interpersonal and public settings. The areas of interpersonal, organizational, cross-cultural and moral conflicts are highlighted.',
  },
  {
    course_code: 'COM3471',
    course_name: 'Fundamentals of Social Media Communication',
    course_desc:
      'This course provides students with an introduction to the history, theory, technology, and uses of social media. Social media are technologies that enable individuals to create, collaborate, share messages, and communicate with audiences of varying diversity and backgrounds. Students will consider the role of individual choice, social influence, technological influence, and how these perspectives can be seen in social media communication. Students will also explore the implications of social media for personal relationships, organizations, and culture.',
  },
  {
    course_code: 'COM3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'COM3948',
    course_name: 'Service Learning Field Study II',
    course_desc:
      'Placement in community agency or other social organizational setting related to field of study. Supervision by faculty and agency. Students and faculty "customize" courses to fit a full range of services that are available in the setting. Student must be able to draw correlations between the discipline and field study. Journal and reflective experience paper are required. With the agreement of the student\'s faculty sponsor, a minimum of 6-8 hours\' work per week must be done at the field site per semester hour of credit.',
  },
  {
    course_code: 'COM4022',
    course_name: 'Health Communication',
    course_desc:
      'Provides an up-to-date overview of the health care industry, spotlighting communication issues in patient care, health care administration, public relations, human resources, health education, and the media. Includes coverage of diverse cultures and ethical considerations. A highly interdisciplinary course useful for students considering any type of career in the health care industry. Offered concurrently with COM5025; graduate students will be assigned additional work.',
  },
  {
    course_code: 'COM4103',
    course_name: 'Leadership Communication',
    course_desc:
      'Promotes leadership development through study of leadership theory and concepts and practical application of leadership laboratory experience. Based on a servant leader philosophy, focuses on building leadership competencies in interpersonal communication, public presentations, team building, working in multicultural environments, mentoring, problem solving and influence strategies used in interpersonal and public forums to bring about community and organizational change. Leadership skill-building opportunity to all participants. Credit may not be received in both COM4103 and COM 4103C.',
  },
  {
    course_code: 'COM4110',
    course_name: 'Business and Professional Communication',
    course_desc:
      'Practical understanding of communication practices affecting the workplace. Emphasis on managing work relationships, listening, organizational interviews, professional presentations, communication technologies and multi-cultural diversity.',
  },
  {
    course_code: 'COM4120',
    course_name: 'Organizational Communication',
    course_desc:
      'Examines the dynamics of communicating within organizations and with stakeholders. Students analyze case studies of actual organizations and build skills related to teamwork, motivation, morale-building, leadership, decision-making, and more.',
  },
  {
    course_code: 'COM4250',
    course_name: 'Strategic Communication for the Sciences',
    course_desc:
      'This course presents students with the knowledge, strategies and tactics for effectively communicating STEM research and emerging issues to a general or mass audience. The course explores the opportunities and constraints of varying media outlets and the social, cultural and political challenges of science communication.',
  },
  {
    course_code: 'COM4301',
    course_name: 'Communication Research',
    course_desc:
      'This course will examine primary and secondary research methods useful to comprehensive communication investigation and integrated public relations/advertising campaigns.',
  },
  {
    course_code: 'COM4484',
    course_name: 'Rhetoric of Popular Trials',
    course_desc:
      'This course will explore how legal trials that capture the public consciousness reveal much about communication theory and rhetorical practice. Students will study popular trials - for example, the Scottsboro Nine Trials, the Sacco and Vanzetti Trial, the O.J. Simpson Trial, and the Patty Hearst Trial - and read scholarly analysis of the trials and public discourse surrounding them. Students can expect to learn more about legal advocacy, jury decision-making, and the relationship between public belief and legal judgment.',
  },
  {
    course_code: 'COM4561',
    course_name: 'Social Media Content Development',
    course_desc:
      'The emphasis of this course is on the production of professional communication for organizational social media accounts. Students will analyze each social media platform for communication effectiveness and identify the message, voice, and customer service opportunities.  Students will gain the skills needed to produce each aspect of social media communication including messages, graphics, profile content, and videos.',
  },
  {
    course_code: 'COM4564',
    course_name: 'Social Media Management',
    course_desc:
      'This course explores the day-to-day operations of a social media communication team. Students will learn how to create overarching strategies, content calendars, obtain and interpret social media analytics, and be able to write metric reports for senior management. Additional time will be spent on budgeting, workflow procedures, working cross-departmentally, and managing special initiatives.',
  },
  {
    course_code: 'COM4620',
    course_name: 'Communication Ethics',
    course_desc:
      'Guides students in examining ethical considerations in business and public life. Includes diverse ethical perspectives, critical methods of analysis, and greater awareness of the role ethics plays in everyday life.',
  },
  {
    course_code: 'COM4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'COM4940',
    course_name: 'Internship in Communication',
    course_desc:
      'Supervised field practicum in a communication-related position, to include advertising, broadcast and print journalism, telecommunications and film, organizational communication and public relations. Senior standing and a 2.7 overall GPA is required. Graded on a Satisfactory /  Unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'COM5005',
    course_name: 'Introduction to Graduate Studies in Communication',
    course_desc:
      'Designed to introduce graduate students to critical elements of graduate studies in communication. Central topics include mastering the basics of APA style, honing analytic writing skills related to the study of communication, instructional resources, academic integrity issues unique to communication, and the history of the communication discipline.',
  },
  {
    course_code: 'COM5025',
    course_name: 'Health Communication',
    course_desc:
      'Provides an up-to-date overview of the health care industry, spotlighting communication issues in patient care, health care administration, public relations, human resources, health education and the media. Includes coverage of diverse cultures and ethical considerations. A highly interdisciplinary course useful for students considering any type of career in the health care industry. Offered concurrently with COM4022; graduate students will be assigned additional work. Graduate standing is required.',
  },
  {
    course_code: 'COM5146',
    course_name: 'Fundraising Communication',
    course_desc:
      'Fundraising Communication introduces students to the principles and practice of fundraising in the United States. The theoretical underpinnings of fundraising are approached from a public relations perspective. Students will have the opportunity to demonstrate mastery of relevant skills worthy of a professional fundraising campaign.',
  },
  {
    course_code: 'COM5206',
    course_name: 'Communication Training',
    course_desc:
      'Prepares students to design and conduct communication skills training for professionals. Emphasizes adult learning, conducting needs assessments, establishing training objectives, using communication technology and evaluating training efforts. Involves a hands-on student learning project in which students conduct needs assessments and present two-hour workshops for local professional organizations. Other majors must confer with instructor regarding comparable prerequisites. Offered Fall of every other year.',
  },
  {
    course_code: 'COM5527',
    course_name: 'Communication Agency',
    course_desc:
      'Guides students through the development and implementation of a series of strategic and organizational communication projects utilizing an "agency-style" team based format. Permission is required.',
  },
  {
    course_code: 'COM5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'COM5933',
    course_name: 'Special Topics in Communication',
    course_desc:
      'Designed to provide students with specialized knowledge in a particular field of communication such as organizational communication, media criticism, rhetorical criticism, or visual communication.',
  },
  {
    course_code: 'COM6024',
    course_name: 'Emerging Topics in Health Communication',
    course_desc:
      'Highlights how communication issues in health care are interwoven with community well-being, civic life, professional development, and opportunities for collaboration and mutual gain. Topics may include health care reform, leadership in health care settings, patient and family satisfaction, privacy issues, and burnout among health professionals. Utilizes current research, theoretical foundations, and local health care experts to explore relevant and emerging issues. Uses health care case studies to develop effective leadership and strategic communication strategies.',
  },
  {
    course_code: 'COM6129',
    course_name: 'Assessing Organizational Dynamics',
    course_desc:
      'Applying systems thinking to analyze the dynamics of communication within an actual organization. Emphasis on deep-level analysis to reveal who talks to whom, when, why, and about what. Goals are (1) to reveal communication patterns and assumptions that make it either easy or difficult to achieve high quality organizational production and (2) to help organizational members design processes that foster the creation of high-performance, high-capacity teams.',
  },
  {
    course_code: 'COM6207',
    course_name: 'Advanced Communication Leadership',
    course_desc:
      "Based on a hands-on leadership project informed by the study of leadership communication theory, research, and case studies. Emphasis is on developing communication skills, strategy, and awareness to enhance leaders' effectiveness. Permission is required.",
  },
  {
    course_code: 'COM6210',
    course_name: 'Emerging Topics in Organizational Communication',
    course_desc:
      "Explores current communication issues and challenges facing today's organizations. Emphasizes the development of strategies to address these issues through case studies, course readings, and by studying the communication challenges of actual organizations.",
  },
  {
    course_code: 'COM6236',
    course_name: 'Advanced Crisis Communication',
    course_desc:
      'This course focuses on the role of communication in preventing and responding to crises relevant to organizations. It is especially relevant to health-related crisis, but has implications for all types of organizations. Students will learn how to create crisis communication plans and respond effectively to emerging crises. The course emphasizes the practical application of crisis communication theories, strategies, and tactics when developing and implementing crisis communication plans.',
  },
  {
    course_code: 'COM6312',
    course_name: 'Advanced Communication Research Methods',
    course_desc:
      'This course addresses the philosophy of scientific research including the origins, nature, and effects of communication processes. Focuses on both theoretical and applied research. Primary emphasis is on quantitative investigation and applied research. Primary emphasis is on qualitative investigation with some consideration of qualitative methods. Focus is on achieving a solid understanding of the strengths and weaknesses of different methodological approaches (i.e., experiments vs. surveys vs. interviews) in order to determine the most effective methods for research questions or hypotheses. Students are expected to have completed at least one introductory college level statistics course preceding enrollment in this course.',
  },
  {
    course_code: 'COM6401',
    course_name: 'Communication Theory',
    course_desc:
      'Examines the process of theory creation, development, application, and evaluation. Theories focus on human decision making, organizational communication, and industry best practices. Oriented toward professional application.',
  },
  {
    course_code: 'COM6525',
    course_name: 'Strategic Communication',
    course_desc:
      'Provides a conceptual framework for strategic communication, sharpens analytical and critical thinking, and provides a unifying function for the Strategic Communication & Leadership Program. Addresses all aspects of the development and execution of communication programs. Offers "real world" experience through the analysis of case studies. Case studies and coursework will be drawn from the profit, non-profit, product, and service sectors. Particular attention will be paid to sociopsychological, legal, and ethical issues as they relate to the decision-making process.',
  },
  {
    course_code: 'COM6565',
    course_name: 'Social Media for Public Relations and Advertising',
    course_desc:
      'This course provides advance-level instruction in the creation and analysis of social media content as it relates to public relations and advertising. Students will create social media campaigns informed by the latest research and best practices.',
  },
  {
    course_code: 'COM6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'COM6930',
    course_name: 'Capstone Project',
    course_desc:
      'This course incorporates an advanced research project for a corporate or organizational client. Working with a client, students will identify a problem for study, perform an extensive review of issues related to the project, gather and analyze qualitative and/or quantitative data, and write an extensive report, including a summary and recommendations based on the study. Students may enroll in the course more than once, and are required to continue enrolling in it until their project is complete. A minimum of 3sh is required for the M.A. degree. Graded on a satisfactory/unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'COP2253',
    course_name: 'Programming Using Java',
    course_desc:
      'Introduction to algorithms and object-oriented programming. Topics include control constructs, looping constructs, parameter passing, and arrays. Emphasizes developing fundamental programming skills and software engineering principles in the context of an object-oriented language to solve complex problems in a secure and robust manner.',
  },
  {
    course_code: 'COP2334',
    course_name: 'Programming Using C++',
    course_desc:
      'Introduction to computers and algorithms. Programming in a high level language. Topics include structured programming techniques, procedural and data abstraction. Students will learn the fundamentals of developing coherent, expressive programs.',
  },
  {
    course_code: 'COP2830',
    course_name: 'Script Programming',
    course_desc:
      'Introduction to the essential skills of programming with scripting. Topics include use and manipulation of variable, design and validation of forms, and writing scripts for systems calls and command line arguments.',
  },
  {
    course_code: 'COP3014',
    course_name: 'Algorithm and Program Design',
    course_desc:
      'An introduction to advanced computational and problem solving techniques. Emphasis on the use of basic programming constructs to create correct, efficient algorithms. Secondary focus on the basic structure and decomposition of programs. This course will include several laboratory projects.',
  },
  {
    course_code: 'COP3022',
    course_name: 'Intermediate Computer Programming',
    course_desc:
      'An intermediate course in object-oriented programming. Topics include object-oriented modeling, algorithms, inheritance, polymorphism, input/output. Emphasis will be on issues of object-oriented design and good programming practices. Students entering this course are expected to have a solid knowledge of programming in the object-oriented paradigm. The focus will\nbe on developing skills in program design as a necessary prerequisite to effective implementation.',
  },
  {
    course_code: 'COP3530',
    course_name: 'Data Structures and Algorithms I',
    course_desc:
      'A first course in Data Structures and Algorithms. Topics will include traditional data structures with a major focus on design and analysis of algorithms and will include projects that stress mathematics and science.',
  },
  {
    course_code: 'COP3665',
    course_name: 'Mobile Programming',
    course_desc:
      'Concepts and skills related to programming mobile devices, with specific emphasis on at least one modern mobile programming language or framework.',
  },
  {
    course_code: 'COP3813',
    course_name: 'Server-Side Programming',
    course_desc:
      'A course in principles of server-side technologies that form the core of classical three-tier applications. This course provides a solid foundation for the concepts of server-side programming, using a current server-side programming/scripting language.',
  },
  {
    course_code: 'COP3826',
    course_name: 'User Interface Programming',
    course_desc:
      'This course is directed towards undergraduate students pursuing a bachelors degree in Information Technology. This course provides students with skills to design, build and test user interfaces suitable for multiple platforms including the web, mobile devices etc. Students will also be able to design interactive systems incorporating principles of universal design. Credit cannot be earned in both COP3826 and CGS3464.',
  },
  {
    course_code: 'COP3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'COP4020',
    course_name: 'Programming Languages',
    course_desc:
      'Programming language theory and practice, including language design and implementation, theoretical foundations, language translation, and exposure to a variety of programming paradigms.',
  },
  {
    course_code: 'COP4027',
    course_name: 'Advanced Computer Programming',
    course_desc:
      'Addresses advanced topics in computer programming including advanced tools and IDEs, user interface design and implementation, user validation, network programming, data communication, enterprise programming principles, multi-tier systems, and concurrent programming. Emphasis will be developing skills in program design as necessary prerequisite to effective implementation.',
  },
  {
    course_code: 'COP4331',
    course_name: 'Object Oriented Programming',
    course_desc:
      'Exploration of the fundamental ideas behind object-oriented programming, including encapsulation, inheritance, and polymorphis. Applications will focus on extracting objects from a problem domain, designing problem solutions based on message-passing between objects, and documenting object-oriented design. Implementations will be done in a current object-oriented language.',
  },
  {
    course_code: 'COP4365C',
    course_name: 'Advanced Topics in C# Programming',
    course_desc:
      'This course covers advanced concepts and applications of C# programming. Topics covered will include: event-driven programming, user interfaces, inheritance, exception handling and input/output, data structures, threads and animation, networking, interfacing with databases, ASP.NET.\nPrerequisites: (COP2253 or COP2334) and COP4710 (minimum grade C-).',
  },
  {
    course_code: 'PCO2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'COP4534',
    course_name: 'Data Structures and Algorithms II',
    course_desc:
      'A second course in Data Structures and Algorithms. Topics include mathematical properties of algorithms (complexity, correctness), heaps, height-balanced trees, graphs, greedy algorithms, dynamic programming, and proof techniques pertaining to computational complexity. Emphasis on issues of correctness and efficiency. Students entering this course are expected to have a solid knowledge of programming.',
  },
  {
    course_code: 'COP4610',
    course_name: 'Theory and Fundamentals of Operating Systems',
    course_desc:
      'A functional systematic examination of the key components and theories of a modern operating system, including process, thread management, synchronization, I/O, and memory management. Emphasizes using several modern operating systems and writing programming scripts to manipulate these operating systems.',
  },
  {
    course_code: 'COP4634',
    course_name: 'Systems & Networks I',
    course_desc:
      'This course reviews fundamental principles of modern operating systems and relates them to computer programming. Students learn about the design of various components of operating systems and the services they provide to end-users and application developers. The role of security in operating systems and their relation to computer networks are also covered.',
  },
  {
    course_code: 'COP4635',
    course_name: 'Systems & Networks II',
    course_desc:
      'This course is a continuation of topics discussed in System & Networks I, focusing on fundamental principles of modern computer networks and network programming. The course will study the structure of networks, networking devices, network protocol stacks, congestion and flow control analysis and algorithms, network routing algorithms and protocols, and network traffic analysis. The course also covers client/server and peer-to-peer network programming and the role of security in networks.',
  },
  {
    course_code: 'COP4710',
    course_name: 'Database Systems',
    course_desc:
      'Introduction to database systems and database management system architectures. Various database models are discussed with an emphasis on the relational model and relational database design. Case applications using fourth-generation languages, such as SQL, are included. Offered concurrently with COP5725; graduate students will be assigned additional work.',
  },
  {
    course_code: 'COP4723',
    course_name: 'Database Administration',
    course_desc:
      'Database administration skills covering installation, configuration and tuning a database, administering servers and server groups, managing and optimizing schemes, tables, indexes, and views, creating logins, configuring permissions, assigning roles and performing other essential security tasks, backup and recovery strategies, automation and maintenance.',
  },
  {
    course_code: 'COP4856',
    course_name: 'Distributed Software Architecture',
    course_desc:
      'Software aspects of distributed architecture, with emphasis on database integration and interoperability of distributed components.',
  },
  {
    course_code: 'COP4864',
    course_name: 'Client-Side Programming',
    course_desc:
      'A course in principles of client-side technologies that form the complement of server-side applications. This course provides a solid foundation for the concepts of client-side programming and an introduction into client-side frameworks.',
  },
  {
    course_code: 'COP4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'COP5007',
    course_name: 'Foundations: Programming Essentials',
    course_desc:
      'A course in the Accelerated Software Engineering Foundations Series in which students will gain a comprehensive understanding of principles/concepts of Java programming and how to apply those principles/concepts in conjunction with principles of software engineering to design and develop object- oriented software systems.  Students taking this course should have an understanding of programming language fundamentals including variables, constants, selection, iteration, arrays, and functions or methods.',
  },
  {
    course_code: 'COP5416',
    course_name: 'Foundations: Data Structure & Algorithms Essentials',
    course_desc:
      'A comprehensive overview of the most commonly used data structures including arrays, linked lists, trees, graphs, hash tables, and heaps. A survey of common algorithms including those that are used with the data structures as well as sorting, searching, divide-and-conquer, greedy algorithms and dynamic programming. Students taking this course should have a good understanding of programming language fundamentals including variables, constants, selection, iteration, arrays, file I/O and functions.\nThis course may require completion of graduate foundations courses in computer programming or the equivalent undergraduate coursework if a student has insufficient academic or professional experience in the discipline.',
  },
  {
    course_code: 'COP5518',
    course_name: 'Foundations: Computing Essentials',
    course_desc:
      'This course reviews fundamental principles of modern computer architectures, operating systems and computer networks and relates them to computer programming. The course covers topics such as the design of various components of operating systems and services they provide to users and application developers, network structures & devices, network protocol stacks, network performance metrics, network routing algorithms, and network traffic analysis. The role of security in systems and networks will also be covered.\nThis course may require completion of graduate foundations courses in computer programming or the equivalent undergraduate coursework if a student has insufficient academic or professional experience in the discipline.',
  },
  {
    course_code: 'COP5519',
    course_name: 'Programming for Information Technology',
    course_desc:
      'Programming for IT focuses on using scripting languages to interact with the terminal and using libraries, dictionaries, user defined functions and automation technologies to ensure that IT systems are working effectively, efficiently and in a secured environment.',
  },
  {
    course_code: 'COP5522',
    course_name: 'Parallel and Distributed Programming',
    course_desc:
      'A comprehensive overview of parallel programming using MPI and OpenMP. A survey of common parallel architectures, communication primitives, applications of those primitives to design of efficient parallel algorithms, definition of models and metrics to evaluate the effectiveness of parallel algorithms theoretically and empirically, and introduction to cloud computing. Students taking this course should have a good understanding of undergraduate level data structures and algorithms, and mastery of undergraduate level programming in a Unix environment.',
  },
  {
    course_code: 'ECT4562',
    course_name: 'Introduction to Career and Technical Special Needs Education',
    course_desc:
      'Introduces historical evolution, legislative development and instructional methodologies in career and technical special needs education. Credit may not be received in both ECT4562 and EVT 4562.',
  },
  {
    course_code: 'COP5725',
    course_name: 'Database Systems',
    course_desc:
      'Introduction to database systems and database management system architectures. Various database models are discussed with emphasis on the relational model and relational database design. Case applications using fourth-generation languages, such as SQL are included. \nThis course requires completion of graduate foundations courses in computer programming or the equivalent undergraduate coursework.',
  },
  {
    course_code: 'COP5775',
    course_name: 'Database Administration',
    course_desc:
      'Database administration skills covering installation, configuration and tuning a database, administering servers and server groups, managing and optimizing schemas, tables, indexes, and views, creating logins, configuring permissions, assigning roles and performing other essential security tasks, backup and recovery strategies, automation and maintenance.',
  },
  {
    course_code: 'COP5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'COP6025',
    course_name: 'Advanced Programming Languages',
    course_desc:
      'Theory and practice of programming language design. Topics include: advanced language constructs, an overview of parallel programming, formal specification of programming languages, the analysis/synthesis model of program translation, code optimization, and compiler construction tools. Students will design and implement a small programming language. Knowledge of COP4020 or COT4420 is necessary for success in this course.',
  },
  {
    course_code: 'COP6416',
    course_name: 'Advanced Algorithms',
    course_desc:
      'A comprehensive overview of the most commonly used approaches for approximate solution of NP-Hard problems, including linear programming, dynamic programming, and greedy algorithms. A survey of common algorithms including cache-aware algorithms, randomized algorithms, network flow algorithms, and online algorithms. This course will take an "experimental algorithms" approach to educating students on augmenting theoretical results with empirical methods for the design of algorithms that are effective in practice. Students taking this course should have a good understanding of undergraduate-level data structures and algorithms, competence in programming, and the ability to write formal proofs.',
  },
  {
    course_code: 'COP6727',
    course_name: 'Advanced Database Systems',
    course_desc:
      'Advanced topics in database management systems will be covered, for example, further dependencies and higher normal forms, transaction processing, concurrency control, backup and recovery, indexing, replication, managing large databases, and contemporary issues and topics in databases.',
  },
  {
    course_code: 'COP6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'COT3100',
    course_name: 'Discrete Structures',
    course_desc:
      'Foundations of Discrete Math with applications to modeling, programming and data structures. Propositional and predicate logic, number systems and number theory, sequences, summations, graph and tree structures.  \nPrerequisites: (COP2253 or COP2334 or COP3014) and (MAC2233 or MAC2311) minimum grade of C-.',
  },
  {
    course_code: 'COT4420',
    course_name: 'Theory of Computation',
    course_desc:
      'Theoretical foundations of computer science. Classification of formal languages, grammars, and automata. Parsing and recognition of syntactic expressions. Turing Machines and random access machines. Church-Turing thesis. Insolvability of the halting problem.',
  },
  {
    course_code: 'COT4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'COT5205',
    course_name: 'Theory of Computation',
    course_desc:
      'Theoretical foundations of computer science. Classification of formal languages, grammars and automata. Parsing and recognition of syntactic expressions. Turing Machines and random access machines. Church-Turing thesis. Insolvability of the halting problem. Dual-listed with COT4420; graduate students will be assigned additional work. Students cannot receive credit for COT5205 and COT4420.',
  },
  {
    course_code: 'COT5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'COT6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'COT6931',
    course_name: 'Computer Science Project',
    course_desc:
      'Capstone course for Masters students who do not elect the thesis option. Normally taken for 3 credits in each of two consecutive semesters. Students will define and carry out a project that shows mastery of some topic in computing and produces some concrete product such as a report or a computer program. Students should not enroll until they have completed at least 15 semester hours of their graduate coursework. Permission is required.',
  },
  {
    course_code: 'COT6935',
    course_name: 'Seminar in Cybersecurity',
    course_desc:
      'This graduate research seminar will provide cybersecurity graduate students with the opportunity to identify, research, report and discuss contemporary issues in cybersecurity. Students are expected to have completed the foundational courses in the curriculum and to work independently on a relevant topic approved by the instructor.',
  },
  {
    course_code: 'CPO2002',
    course_name: 'Comparative Politics',
    course_desc:
      'Examination of political processes and political institutions in selected foreign countries such as Britain, France, Germany, USSR, Japan and India. Methods of cross-national political analysis.\nMeets General Education requirement in Social Sciences.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'CPO3055',
    course_name: 'Dictatorships',
    course_desc:
      'The course will carry out a comparative analysis of dictatorships across time and space, with special attention paid to 20th century totalitarian regimes, including those of Hitler, Stalin, and Mao. The analysis will focus on some of the causes for the rise and fall of these dictatorships, their ruling personalities and methods, the costs imposed on their subject populations, and their long-term effects on the politics of their representative countries. Course readings range from selections on tyranny from classical political philosophers such as Plato, Aristotle, Suetonius, and Machiavelli to modern biographical works and empirical analysis pieces. Historical cases from several continents are evaluated using a variety of media that may involve scholarly texts, novels, and films in order to draw parallels and contrasts among the cases.',
  },
  {
    course_code: 'DAN3744',
    course_name: 'Dance Fitness',
    course_desc:
      'Combines basic fitness and movement principles applied to movements in jazz dance and low-impact elements of ballet. Progressive daily knowledge and skills for dance learning and performance. Also provides the opportunity for students to enhance health and fitness through the medium of dance.',
  },
  {
    course_code: 'CPO3103',
    course_name: 'Politics of Western Europe',
    course_desc:
      'The course will introduce students to government structures, political parties, interest groups, and policy issues across Western Europe. The role of Western Europe in the twenty-first century will be explored. European Union and country nationalism versus European unity will be considered. Several country case studies will provide a focus for the course, including the United Kingdom, France, Germany, and Austria.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'CPO3773',
    course_name: 'Great World Leaders',
    course_desc:
      'This course compares and evaluates both ancient and modern leaders from around the world. It compares their statesmanship, exercise of political power, vision and agendas as leaders. Their personalities and styles of leadership including how they led and mobilized people will be explored. It considers their strategies pertaining to political adversaries and how they dealt with challenges during their time as leaders. Finally, how they prepared for transfer of power or their departure from leadership roles will be examined.',
  },
  {
    course_code: 'CPO4074',
    course_name: 'Political Economy',
    course_desc:
      'This course has two objectives in mind. One is to inquire into methods of analysis that borrow certain ideas from economics, such as self-interest and incentives, to the study of politics. One might call this the methodological objective. The other objective is to examine the reciprocal relations between government and the domestic economy. Specifically, it surveys what political scientists and public intellectuals have said about the effect of economic conditions on regime survival and elections, on the one hand, and on the other the impact of regime type and public policy on various measures of the general welfare as economic growth, human development, and income or wealth inequality. We shall begin with excerpts from ancient and modern thinkers, then proceed to analyze scholarship by contemporary political scientists and political economists.',
  },
  {
    course_code: 'CPO4303',
    course_name: 'Politics of Spain, Portugal, and Latin America',
    course_desc:
      'This course examines political institutions, including democracies and dictatorships of several Latin American countries and also Spain and Portugal as colonizers. It examines the process of political development in Latin America, considering conditions that promote democratic development and the occurrence of revolutions. The course depicts the roles that leaders, political parties, the military, the Catholic Church (and other religious denominations),\ninternational organizations (OAS, UN) and the United States played in the establishment or maintenance of democracy. It also examines Latin America?s role in world politics.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'CPO4314',
    course_name: 'Democracies',
    course_desc:
      'This course examines what it means to be a 21st century democracy. It explores institutional variants of democracy, including different structures of government and electoral systems.  It considers the promise and the problems within democracies. The course explores democratic variants by examining factors such as accountability, competitiveness, transparency, and representation. The course examines democratization including how to build and sustain democracy.  The class will consider preconditions for democracy and discuss the complex relationship between\ndemocracy and economics.',
  },
  {
    course_code: 'CPO4761',
    course_name: 'Religion and International Politics',
    course_desc:
      'This course analyzes how religious beliefs and institutions shape politics that cross borders. It draws upon an array of writings to examine major global phenomena like the religious roots of international order; religious challenges both to modern states and to recent globalization; and activism amongst global religious movements. In turn, the course concentrates on two major issues for scholars, policy-makers and citizens alike: 1) international religious extremism and violence and 2) religious influences on - and targets of - U.S. foreign policy. Examples of topics covered along the way include Evangelical activism and ideologies, religious terrorism and the Israeli-Palestinian conflict.',
  },
  {
    course_code: 'CPO4774',
    course_name: 'Radicalism and Extremism',
    course_desc:
      'Political radicals and political extremists reside outside of the boundaries of mainstream politics because they diverge sharply in their ideological orientation strategy and tactics relative to the parties of the political center. This course focuses on the ideology, discourse, goals and actions of certain parties and groups on the "fringe" of politics. Emphasis is placed on conceptualizing the terms "radical" and "extremist" to develop an understanding of how these groups stand apart from the mainstream. Comparative cases will be examined ranging from consideration of a wide variety of American radicals on both the political right and political left, European radical right political parties, religious radicals and fundamentalism, and Middle Eastern radical Islam. We will characterize various extremist groups, discuss strategies and tactics, explore factors that catalyze such groups, and consider their impact and significance on policy but also on governance and society. The course is offered concurrently with CPO5779; graduate students will have additional work.',
  },
  {
    course_code: 'CPO4792',
    course_name: 'Geopolitics',
    course_desc:
      'Exploration and study of patterns of conflict, geography, cooperation and change in world politics in the post-Cold war period; the examination of the creation of world order under anarchic conditions; and the study of religious, cultural, resources and economic crises in large portion of the world; which relates to the larger issue of state power and US national policy. Offered concurrently with CPO 5797 graduate students will be assigned additional work.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'CPO4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CPO5769',
    course_name: 'Religion and International Politics',
    course_desc:
      'This course analyzes how religious beliefs and institutions shape politics that cross borders. It draws upon an array of writings to examine major global phenomena like the religious roots of international order; religious challenges both to modern states and to recent globalization; and activism amongst global religious movements. In turn, the course concentrates on two major issues for scholars, policy- makers and citizens alike: 1) international religious extremism and violence and 2) religious influences on - and targets of - U.S. foreign policy. Examples of topics covered along the way include Evangelical activism and ideologies, religious terrorism and the Israeli-Palestinian conflict.',
  },
  {
    course_code: 'CTS4139',
    course_name: 'Information Technology Applications in CompTIA Network+',
    course_desc:
      'Network+ includes topics in network technologies, installation and configuration, media and topologies, management, and security. Certification in Network+ enhances several occupations including: network administrator, network technician, network installer, help desk technician and IT cable installer. Network+ is the "technical prerequisite option" for IT technicians requesting to join the Apple Consultants Network. Successful completion of the certification exam is recognized by the U.S. Department of Defense. Non-degree seeking students will be required to pass an online pre-test with a score of 80% or better prior to enrollment.',
  },
  {
    course_code: 'CPO5779',
    course_name: 'Radicalism and Extremism',
    course_desc:
      'Political radicals and political extremists reside outside of the boundaries of mainstream politics because they diverge sharply in their ideological orientation strategy and tactics relative to the parties of the political center. This course focuses on the ideology, discourse, goals and actions of certain parties and groups on the "fringe" of politics. Emphasis is placed on conceptualizing the terms "radical" and "extremist" to develop an understanding of how these groups stand apart from the mainstream. Comparative cases will be examined ranging from consideration of a wide variety of American radicals on both the political right and political left, European radical right political parties, religious radicals and fundamentalism, and Middle Eastern radical Islam. We will characterize various extremist groups, discuss strategies and tactics, explore factors that catalyze such groups, and consider their impact and significance on policy but also on governance and society. This course is offered concurrently with CPO4774; graduate students will have additional work.',
  },
  {
    course_code: 'CPO6006',
    course_name: 'Seminar in Comparative Politics',
    course_desc:
      'Comparison and analysis of political systems, theoretical and empirical.',
  },
  {
    course_code: 'CPO6206',
    course_name: 'African Politics and Security',
    course_desc:
      'Africa is a diverse and expansive continent. Its politics are no different. This course examines African politics with significant appreciation for and attention to the historical and geographical factors that shaped and continue to shape them. A key phenomenon in African politics is the lack of security, or insecurity. This, too, will be examined and discussed in detail. Furthermore, the role of technology on African politics will be studied. Africa will be examined as a continent as well as in its constituent parts, including sub-regions and individual nation-states. And the role of both state and non-state actors will be considered throughout. The course does not assume specific knowledge or understanding of Africa or its politics; but it does assume general knowledge and understanding of international and comparative politics.',
  },
  {
    course_code: 'CPO6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CRW2001',
    course_name: 'Introduction to Creative Writing',
    course_desc:
      'Overview and introduction to three genres of creative writing: poetry, fiction, and creative nonfiction. Will be taught as part lecture/ discussion and part writing workshop. Credit cannot be received in both CRW2001 and CRW 2000.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'CRW2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CRW3110',
    course_name: 'Fiction Writing',
    course_desc:
      'Workshop in narrative fiction. Practice in developing plot and character and establishing point of view. Emphasis on writing for publication in specific markets.',
  },
  {
    course_code: 'CRW3310',
    course_name: 'Poetry Writing',
    course_desc:
      'Workshop in writing poetry. Practice in traditional forms and extensive work in contemporary free verse.',
  },
  {
    course_code: 'CRW3424',
    course_name: 'Playwriting',
    course_desc:
      'Playwriting is devoted to the analysis and creation of literary drama. Introduces the student to the dramatic elements of plot, scene, character development and motivation, and dramatic action through the study of established playwrights and plays. Students will also submit their own original creative work for discussion and analysis by the professor and class.',
  },
  {
    course_code: 'CRW3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CRW4211',
    course_name: 'Creative Non-Fiction',
    course_desc:
      'Writing workshop in which students explore the personal essay through the process of reading and writing about autobiography, travel, science, politics, and art.',
  },
  {
    course_code: 'CRW4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CRW5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CRW6130',
    course_name: 'Workshop in Fiction Writing',
    course_desc:
      'Writing, editing, and evaluating fiction. Students will be expected to write original publishable fiction and critique writing produced in class. Permission is required.',
  },
  {
    course_code: 'CRW6236',
    course_name: 'Workshop in Creative Non-Fiction Writing',
    course_desc:
      'Writing, editing, and evaluating original pieces of creative non-fiction. Permission is required.',
  },
  {
    course_code: 'CRW6331',
    course_name: 'Workshop in Poetry Writing',
    course_desc:
      'Writing, editing, and evaluating poetry. Students will be expected to familiarize themselves with both traditional forms and free verse. Permission is required.',
  },
  {
    course_code: 'CRW6806',
    course_name: 'Workshop in Teaching Creative Writing',
    course_desc:
      'The teaching of workshop methods used in poetry, fiction, and creative non-fiction writing classes. Emphasis on writing standards, resources, evaluation methods, publishing, and course planning. Permission is required.',
  },
  {
    course_code: 'CRW6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'CRW6934',
    course_name: 'Special Topics in Creative Writing',
    course_desc:
      'A writing workshop with a central theme such as autobiography, nature writing, the persuasive essay, biography, or studies of place. Topics change each term. See department or instructor for specific topic.',
  },
  {
    course_code: 'CTS3159',
    course_name: 'End User Support',
    course_desc:
      'An applied course pertaining to the usual activities that are involved in supporting end users of computers. Addresses the technical capabilities a support specialist needs and the "soft skills" necessary when dealing with clients. Topics include computer facility management, customer service skills, user needs analysis, installing and troubleshooting computer systems, help desk organization, product evaluation, and user training.',
  },
  {
    course_code: 'CTS4121',
    course_name: 'Information Technology Applications in CompTIA Security+',
    course_desc:
      'Security+ includes important foundational principles for securing a network and managing risk. Access control, identity management and cryptography are important components of the course. Mitigation and deterrent techniques are provided to prevent network attacks and expose potential vulnerabilities. Successful completion of the CompTIA Security+ exam meets the "Information Assurance (I.A.) technical and management certification requirement" outlined by the U.S. Department of Defense. Non-degree seeking students will be required to pass an online pre-test with a minimum score of 80% prior to enrollment.',
  },
  {
    course_code: 'CTS4323',
    course_name: 'Server Administration',
    course_desc:
      'This course provides students with skills and knowledge necessary to plan, install, configure, and manage server technologies. Specifically, students will be able to implement and manage server storage, file systems, server clusters, Hyper-V, web server technologies, and apply various security controls. This course should prepare students for a Microsoft administration certification exam.',
  },
  {
    course_code: 'CTS4360',
    course_name: 'Advanced Server Administration',
    course_desc:
      'This course is the second in a series of courses that provides the skills necessary to implement a core server infrastructure at the enterprise level. The course focuses on the networking skills\nrequired to deploy and support server technologies in an enterprise environment. This course includes topics related to IP fundamentals, remote access technologies, DirectAccess, domain\nname system (DNS), virtual private networks (VPNs), and more advanced content including software-defined networking (SDN), and distributed files system (DFS).',
  },
  {
    course_code: 'CTS4362',
    course_name: 'Active Directory',
    course_desc:
      'This course covers part three in a series of server administration courses that provides the skills necessary to implement a core server infrastructure at the enterprise level. This course focuses on how to deploy and configure Active Directory Domain Services (AD DS) in a distributed environment. Other areas covered in this course include Group Policy, User and Service Account Configuration, Active Directory Federation Services (AD FS), and Active Directory Certificate Services (AD CS).',
  },
  {
    course_code: 'CTS4457',
    course_name: 'Data Visualization',
    course_desc:
      'Students will develop skills to efficiently and effectively display data, using a variety of tools that can be used to prepare and present the data in visually compelling manners. Data visualization tools have wide applicability in a wide variety of settings and environments in documentation and presentations. Offered concurrently with CTS5458; graduate students will be assigned additional work.',
  },
  {
    course_code: 'CTS4910',
    course_name: 'Social Media Data Analytics',
    course_desc:
      'This is a new course for anyone interested in social media analytics. Students enrolled in this course will use the vast amounts of data generated by social media and analyze the data to make informed decisions applicable to interdisciplinary projects and products.',
  },
  {
    course_code: 'CTS4911',
    course_name: 'Information Technology Capstone',
    course_desc:
      'Applying and integrating the knowledge of the development life cycle, project management, development tools, and skills gained throughout the major to plan, analyze, design, and build a fully functional information system/component(s) to solve a business problem for organizations. Demonstrating an understanding of the skills in documenting and presenting the project to company representatives.',
  },
  {
    course_code: 'CTS4950',
    course_name: 'Innovative Solutions for Industry',
    course_desc:
      "Innovative Solutions for Industry is a teams-based problem-solving course that allows students to develop a deep understanding of the requirements of a specific industry. Over the academic term, students will work intimately together on teams to rapidly iterate prototypes and produce solutions to problem sponsors' needs. Student teams will utilize the lean methodology, which emphasizes customer discovery, and will experience the intensities and challenges of a startup company. Government and/or business sponsors shall support and mentor teams during the term.",
  },
  {
    course_code: 'CTS5458',
    course_name: 'Data Visualization',
    course_desc:
      'This course provides students with skills to describe theory and concepts related to efficient and effective display of data. Students will use a variety of tools necessary to prepare and present the factual data in a visually compelling manner. Data Visualization tools have a wide applicability and tools and technologies available today allow students, researchers and other users of data leverage on these tools to empower their presentations. Offered concurrently with CTS4457; graduate students will be assigned additional work.',
  },
  {
    course_code: 'CYP6005',
    course_name: 'Community Psychology',
    course_desc:
      'Introduces the student to the field of community psychology which is the branch of psychology that seeks to understand relationships between environmental conditions and the development of health and well-being of all members of a community. Students will study the development of the field of community psychology and its theories and paradigms of research and action. Additionally, students will concentrate on the practice of community psychology.',
  },
  {
    course_code: 'CYP6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'DAA1300',
    course_name: 'Ballroom Dance',
    course_desc:
      'This course is designed to teach beginner level ballroom dancing steps in the Foxtrot, Waltz, Jitterbug, Cha Cha, Tango, Merengue, Mambo, and the Charleston. In addition, the fitness benefits of social dance, the application of fitness to dance, and a brief history of each dance will be presented.',
  },
  {
    course_code: 'DAA2000',
    course_name: 'Dance Fundamentals',
    course_desc:
      'Dance foundation course for Music Theatre performance. Course focus is on the proper technique needed for dance in the theatre and will cover dance kinesiology, proper warm-up, and foundations of ballet and jazz dance.',
  },
  {
    course_code: 'DAA2204C',
    course_name: 'Music Theatre Dance Skills',
    course_desc:
      'Course focus is on the proper technique needed for dance in the theatre and will cover dance kinesiology, proper warm-up, and foundations of a beginning ballet dance, as well as the foundations of Music Theatre styles.',
  },
  {
    course_code: 'DAA2570C',
    course_name: 'Beginning Jazz and Tap Technique',
    course_desc:
      'Beginning Jazz and Tap for Music Theatre performance. Course focus is on the proper technique needed for dance in the theatre and will cover dance kinesiology, proper warm-up, and foundations of beginning jazz and tap dance.',
  },
  {
    course_code: 'DAA2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'DAA3004',
    course_name: 'Dance Styles I',
    course_desc:
      'Dance styles for the music theatre student in the area of ballet and classical forms of dance.',
  },
  {
    course_code: 'DAA3005',
    course_name: 'Dance Styles II',
    course_desc:
      'Dance styles for the music theatre student in the area of modern dance, jazz, and tap.',
  },
  {
    course_code: 'DAA3006C',
    course_name: 'Music Theatre Dance Styles',
    course_desc:
      'This course is designed to give the Musical Theatre performer an understanding of the structure behind stage choreography and an insight into the necessary showmanship and/or\nperformance of that choreography.',
  },
  {
    course_code: 'DAA3205C',
    course_name: 'Intermediate Ballet',
    course_desc:
      'This intermediate level course is designed to provide students with an opportunity to continue their pursuit of the classical ballet technique with an emphasis on technical development and extended movement combinations.',
  },
  {
    course_code: 'DAA3571C',
    course_name: 'Intermediate Jazz and Tap Technique',
    course_desc:
      'This intermediate level course is designed to provide students with an opportunity to continue their pursuit of the jazz and tap technique with an emphasis on technical development and extended movement combinations.',
  },
  {
    course_code: 'DEP2004',
    course_name: 'Human Development Across the Lifespan',
    course_desc:
      'Survey of major themes and recent findings in the area of human development across the life span. Emphasis will be on the major transitions from fetal development through death in the physical, cognitive, social, and emotional domains. The impact of ethnic, gender, and cultural factors on development will be examined.\nMeets General Education requirement in Social Sciences.',
  },
  {
    course_code: 'DEP2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'DEP3103',
    course_name: 'Child Development',
    course_desc:
      'Development and behavior of children from infancy to adolescence from two viewpoints: age periods (prenatal, infancy, preschool, school) and areas (physical, intellectual, personality, etc.).',
  },
  {
    course_code: 'DEP3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'DEP4222',
    course_name: 'Autism Spectrum',
    course_desc:
      'The autism course provides an opportunity for students to learn about autism spectrum disorders (ASD), research methods, the diagnostic process, and programs for assisting individuals identified as having ASD, their families, and professionals who work with them. The course counts three semester hours and is fully online.',
  },
  {
    course_code: 'DEP4230',
    course_name: 'Gifted Children',
    course_desc:
      'This course provides a comprehensive overview of giftedness in children, the varying forms of giftedness, and special subgroups within the gifted population. The course will discuss methods to identify giftedness, educational strategies, and the social and emotional development of gifted children.',
  },
  {
    course_code: 'DEP4305',
    course_name: 'Psychology of Adolescence',
    course_desc:
      'Social, emotional, biological, and intellectual elements of adolescence. Addresses the transitions from childhood to adolescence and from adolescence to adulthood. Application of theories is stressed. Option for partial credit via field experiences.',
  },
  {
    course_code: 'DEP4404',
    course_name: 'Adulthood and Aging',
    course_desc:
      'Physiological, psychological, sociological and economic aspects for young, middle and old adulthood presented within a multidisciplinary perspective. Lifespan objectives are emphasized, including development as a life-long process, with multiple determinants of change, and correspondingly, multiple alternatives for change. Successful aging is also emphasized. Credit may not be received for DEP4404 and either DEP 4402 or DEP 4401.',
  },
  {
    course_code: 'DEP4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'DEP5055',
    course_name: 'Developmental Psychology',
    course_desc:
      'Representative theories of development; methodological issues in developmental research; study of research knowledge in selected areas of developmental psychology. One undergraduate or graduate course in the area of developmental is required.',
  },
  {
    course_code: 'DEP5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'DIG3309C',
    course_name: 'Digital 2D Animation',
    course_desc:
      'An introduction to the fundamentals of time-based design through the medium of two-dimensional animation. Exercises and projects will introduce students to the basic concepts of animation as a fundamental medium for understanding design in time. Students will be introduced to the attributes of time and movement, elements of the moving image, serial, sequential, and narrative ordering, moving image editing, sound and image relations, and object and event analysis. Students will be introduced to time-based media as an expressive and communicative art form. Aesthetic, technical, historical, and conceptual issues will be addressed through lectures, demonstrations, exercises, projects, screenings, research, and readings.',
  },
  {
    course_code: 'DSC3012',
    course_name: 'Terrorism',
    course_desc:
      'Introduction to terrorism, which examines the history and evolution of terrorism in both international and domestic arenas. Topics will include the causes, motives, means, and organization of terrorism and terrorist groups. Finally, the course will explore governmental and law enforcement responses and programs aimed at terrorism and threats.',
  },
  {
    course_code: 'DSC4013',
    course_name: 'Homeland Security',
    course_desc:
      'Concepts of homeland security in theory and practice; the history and development of the U.S. Department of Homeland Security and its components; terrorism and other threats to U.S. National Security and the issues associated with achieving national security in a free society.  The course will also examine the components of Critical Infrastructure, Emergency Management and Preparedness, and Policing, related to the practical application of homeland security initiatives.',
  },
  {
    course_code: 'DSC5020',
    course_name: 'Terrorism',
    course_desc:
      'Critical analysis of major issues related to the study of terrorism. From initially critiquing the numerous conceptualizations of terrorism, the course will then evaluate theories of terrorist activity, the organizational and financial structure of terrorist cells, and the different tactics terrorists adopt in order to fulfill their objectives. The course will explore the contentious and oftentimes violent history of the Middle East and how this part of the world has spawned the development of multiple terrorist groups. Scientifically-based methods of inquiry will be utilized in the study of the extent and impact of terrorism on society.',
  },
  {
    course_code: 'DSC6045',
    course_name: 'Homeland Security',
    course_desc:
      'This course will provide students a critical assessment of the larger history, purpose, function and effectiveness of homeland security initiatives. In so doing, we will evaluate the different threats posed to the homeland, the way we prepare for them, the law surrounding our response to homeland security as well as the different agencies tasked with minimizing threats to the homeland. Analyzes homeland security efforts geared towards the fight against terrorism and those directed at minimizing threats from natural disasters, technological hazards, cyber and transportation attack. Scientifically-based methods of inquiry will be utilized in the study of the extent and impact of homeland security efforts.',
  },
  {
    course_code: 'EAB4704',
    course_name: 'Introduction to Behavior Modification',
    course_desc:
      'Principles and practical application of behavior modification techniques in a wide variety of settings: school, home, medical and business. Especially appropriate for non-psychology majors.',
  },
  {
    course_code: 'EAB4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ECP3301',
    course_name: 'Principles of Environmental Economics',
    course_desc:
      'A first course in economics that provides students with the fundamentals of microeconomics and macroeconomics with a structured focus on environmental and natural resource issues. The principles of economics are developed using examples and cases that are directed at environmental policy issues and natural resource decision making.  Available to non-business majors only. Offered Fall Semester only.',
  },
  {
    course_code: 'EAB5705',
    course_name: 'Behavioral and Cognitive Therapies',
    course_desc:
      'This course provides an overview of the principles and interventions of contemporary behavior therapy approaches, as well as in-depth examination of selected cognitive and cognitive-behavioral therapies. Theoretical foundations and empirical findings of these approaches are reviewed, and an emphasis is placed upon the application of this knowledge to various behavioral and psychological problems and disorders.  Students must take EXP4404 or equivalent, or have an undergraduate degree in Psychology before enrolling in this course.',
  },
  {
    course_code: 'EAB5738',
    course_name: 'Behavioral Medicine',
    course_desc:
      'Application of psychological expertise to problems in medicine. Emphasis primarily on role of behavioral principles and techniques in the treatment of medically related complaints and traditional psychosomatic disorders.',
  },
  {
    course_code: 'EAB5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ECO2013',
    course_name: 'Principles of Economics Macro',
    course_desc:
      'Introduction to economics with emphasis on the study of aggregate economic activity, national income, price level determination, and economic growth and development.\nMeets General Education requirement in Social Sciences.',
  },
  {
    course_code: 'ECO2023',
    course_name: 'Principles of Economics Micro',
    course_desc:
      'Introduction to economics with an emphasis on the determination of prices in the market economy and their role in allocating commodities and economic resources to various users. Study of market structure and efficiency. This course is recommended to be taken after ECO2013.',
  },
  {
    course_code: 'ECO3003',
    course_name: 'Principles of Economic Theory and Public Policy',
    course_desc:
      'Survey and analysis of contemporary economic theory and public policy. Available to non-business majors only.',
  },
  {
    course_code: 'ECO3101',
    course_name: 'Intermediate Microeconomics',
    course_desc:
      'Economic activity of individual economic units as consumers, resource owners and business firms. Analysis of consumer motivation as the basis of demand theory. Study of how business firms determine what to produce, how to produce at least cost, how to maximize profits, and how to distribute products. Monopoly, oligopoly, imperfect competition, and the different market conditions for resources are studied to present how the optimum use of each resource is determined by the firm.',
  },
  {
    course_code: 'ECO3106',
    course_name: 'Behavioral Economics',
    course_desc:
      'The study of many situations where and consequences from human decisions that deviate from basic economic theory, often in predictable ways.  From a consumer standpoint, understanding this behavior helps us avoid outcomes we regret.  From a business perspective, the same understanding teaches us how some firms profit from the behavior.',
  },
  {
    course_code: 'ECO3203',
    course_name: 'Intermediate Macroeconomics',
    course_desc:
      'National income accounts. Aggregate supply and demand functions. Savings and consumption functions. The multiplier, the accelerator, marginal efficiency of capital, and determinants of interest rate. Problems of growth and full employment.',
  },
  {
    course_code: 'ECO3223',
    course_name: 'Money and Banking',
    course_desc:
      'Monetary and financial systems of the United States; organization and function of financial institutions including the Federal Reserve System; problems of money, prices, interest, credit, national income, and employment; international finance; recent monetary and financial trends.',
  },
  {
    course_code: 'ECO3504',
    course_name: 'Public Policy',
    course_desc:
      'This course examines the role of the public sector in the economy. The aim of the course is to provide an understanding of the reasons for government intervention in the economy, the extent of that intervention, how government actions affect the economy including the response of private agents to these actions, and how the government finances its operations through taxation.',
  },
  {
    course_code: 'ECO3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ECO4401',
    course_name: 'Introduction to Mathematical Economics',
    course_desc:
      'Links basic mathematical tools with topics in economics. It provides illustrations of the use of those tools in analyzing practical problems faced by households and firms in making economic decisions.',
  },
  {
    course_code: 'ECO4431',
    course_name: 'Business and Economic Forecasting',
    course_desc:
      'Provides the student with alternative forecasting techniques with applications to processes that occur in business and economics. Students will learn what are the typical forecasting problems in business and economics, what are the tools that can be used for forecasting purposes, how these tools are used in practice (the mechanics), and how they are applied to particular business and economic problems (the application). Concentrates on conditional forecasts using econometric methods and time series models including smoothing methods and Box-Jenkins ARIMA models.',
  },
  {
    course_code: 'ECO4704',
    course_name: 'International Trade and Commercial Policy',
    course_desc:
      'Reason for trade. Analysis of U.S. exports and imports. Commercial policy, foreign investments, and changing trends in world trade. Financing and management of business ventures overseas.',
  },
  {
    course_code: 'ECO4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ECO4941',
    course_name: 'Economics Internship',
    course_desc:
      'Supervised field practicum in economics related position. May include activities in one or more functional areas of economics (research, forecasting, business cycles, money & banking, labor, etc.). Graded on satisfactory/unsatisfactory basis only. A 3.0 GPA in major course(s) and permission is required.',
  },
  {
    course_code: 'ECO5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ECO6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ECP3054',
    course_name: 'Public Economic Policy',
    course_desc:
      "This course focuses on the role of the government in the economy.  The aim is to provide an understanding of the reasons for government intervention in the economy, analyzing the benefits of possible government policies, and the response of economic agents to the government's actions.  The course covers tax policy and inequality, social insurance programs, public goods, environmental protection, and the interaction between different levels of government.  Special emphasis is on current policy issues such as inequality and poverty, health care reform, income tax reform, and budget deficits.",
  },
  {
    course_code: 'ECP3530',
    course_name: 'Health Economic Policy',
    course_desc:
      'The purpose of this course is to develop/strengthen the student?s ability to use economic concepts and theories to analyze health care issues and to inform decision making and policy development. The provision and production of health care have different characteristics and incentives from other consumer goods. We will cover a number of topics including aspects of the US health care market, health care in other countries, health care reform, health care policies as well as discussing some basic economic evaluation techniques.',
  },
  {
    course_code: 'ECP4302',
    course_name: 'Environmental Economics and Policy',
    course_desc:
      'Involves the student in the study of a broad range of environmental problems and the appropriate analysis of policy responses. Specific environmental issues include declining urban air quality, global warming, the effect of development on water systems and contamination from waste disposal systems. Traditional environmental regulations and policies are analyzed and contrasted with current, cutting-edge policies aimed at improving the environment.',
  },
  {
    course_code: 'ECP4314',
    course_name: 'Natural Resources Economics',
    course_desc:
      'The impact of human activity on the natural world raises a myriad of issues for society. Efficient management of our natural resources requires understanding of both economic and physical factors. Decisions on resource use affect everyone, with impacts that may come immediately or in the future. This course uses economic tools to analyze those decisions and the resulting impacts. Methods developed in the first part of the course are used to examine applied problems in selected areas such as mineral extraction, energy, forestry, fisheries, water, agriculture, outdoor recreation, wildlife management, and biodiversity.',
  },
  {
    course_code: 'ECP4413',
    course_name: 'Industrial Economics',
    course_desc:
      'Covers economic aspects of the behavior of firms in the United States including degree of concentration, price discrimination, competitive practices, strategic behavior, and regulated industries. The material covered will help students to understand how firms can continue to maintain high profits, how competition might lead to concentration, and how the government serves as a regulator in the economy. Credit may not be received in both ECP4413 and ECP 4403.',
  },
  {
    course_code: 'ECP4613',
    course_name: 'Urban and Regional Economic Development',
    course_desc:
      'Contemporary urban and regional issues such as crowding, congestion, pollution and crime have long been the subject of political, moral and social debate. In order to understand and work towards solutions to these problems a command of economic theory and its relevant applications is essential. Takes simple economic principles and applies them to these pressing social issues including those found in the Gulf Coast area of Northwest Florida. In each case, various alternative solutions are discussed in the context of scarcity of resources, a fundamental principle of economics.',
  },
  {
    course_code: 'ECP4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ECP5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ECP6045',
    course_name: 'General Aviation Economics and Finance',
    course_desc:
      "Course will develop students' ability to use economic concepts and theories to analyze issues in general aviation. This includes the interaction of financial markets and general aviation facilities along with the role of aviation policies in the structure of the US general aviation market.",
  },
  {
    course_code: 'ECP6046',
    course_name: 'Commercial Aviation Economics and Finance',
    course_desc:
      "Course will develop students' ability to use economic concepts and theories to analyze economic and financial issues in commercial aviation.  Specific emphasis is given to federal aviation policy and the effects on the industry along with analysis of the global commercial aviation market.  This course also addresses anti-trust issues in commercial aviation.",
  },
  {
    course_code: 'ECP6705',
    course_name: 'Advanced Managerial Economics',
    course_desc:
      'Concepts of competition as they relate to business management policies and practices; profit goals and measurement problems; multiple product policy; demand analysis; cost concepts; pricing problems; case studies. Contains a portfolio project.',
  },
  {
    course_code: 'ECP6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ECT3004',
    course_name: 'Principles of Career and Technical Studies',
    course_desc:
      'Provides an opportunity to develop philosophy of career and technical studies through the understanding of basic concepts and principles underlying education of occupational competency. Credit may not be received in both ECT3004 and EVT 3065.',
  },
  {
    course_code: 'ECT3183',
    course_name: 'Course Construction for Career and Technical Training',
    course_desc:
      'Organization of instruction for career and technical teaching. Evaluation of career and technical philosophy in determining objectives and constructing course materials in career and technical studies programs. Credit may not be received in both ECT3183 and EVT 3165.',
  },
  {
    course_code: 'ECT3367',
    course_name: 'Career and Technical Instructional Evaluation',
    course_desc:
      'Testing and evaluating career and technical instruction. Methods of evaluating student progress in all levels of career and technical instruction; emphasis on principles, preparations, administration, and evaluation of picture, performance, oral, and written exams. Credit may not be received in both ECT3367 and EVT 3367.',
  },
  {
    course_code: 'ECT3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ECT3945',
    course_name: 'Problem-based Investigations in CTE',
    course_desc:
      'Students will identify, research and provide solutions for problems in industrial-vocational environment.',
  },
  {
    course_code: 'ECT4380',
    course_name: 'Special Methods in Career and Technical Studies',
    course_desc:
      'Provides opportunity to become proficient in using special methods and procedural activities in career and technical studies classes. Credit may not be received in both ECT4380 and EVT 4380.',
  },
  {
    course_code: 'ECT4560',
    course_name:
      'Selection and Guidance of Career and Technical Studies Students',
    course_desc:
      'Methods of selecting and guiding students into career and technical education programs. Emphasis on career selection and placement procedures. Credit may not be received in both ECT4560 and EVT 4560.',
  },
  {
    course_code: 'ECT4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ECT4930',
    course_name: 'Seminar',
    course_desc: '',
  },
  {
    course_code: 'EDA5191',
    course_name: 'Leadership in Education: Theory and Practice',
    course_desc:
      'Leadership theories and planning models which have been developed through studies in education, business, industry, and the military will be examined. The subject matter, class activities, and skill developments of this course were selected to assist your personal growth.  The success of educational leaders is conditioned largely by their ability to lead faculty, staff, and other constituencies through appropriate human relationships and leadership techniques. Application will focus on both personal and professional leadership development.',
  },
  {
    course_code: 'EDA5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDA6063',
    course_name: 'Introduction to Educational Leadership',
    course_desc:
      'An introduction for graduate students to the educational leadership program. Major topics will be leadership, William Cecil Golden Modules, Code of Ethics, communication-both verbal and nonverbal, and interpersonal skills. Permission is required.',
  },
  {
    course_code: 'EDA6193',
    course_name: 'Instructional Leadership',
    course_desc:
      'This course focuses on problems, practices, and theories pertinent to the success of building-level administrators in elementary, middle, and high schools. Students will have the opportunity to learn through real case studies, role plays and simulations reflecting the real work of school principals.  By aligning the specific knowledge and skill dimensions, candidates will learn to contextualize theories and how they will apply as future instructional leaders.',
  },
  {
    course_code: 'EDA6222',
    course_name: 'Administration of School Personnel',
    course_desc:
      'Focus is on the improvement of educational programs through the proper management of human resources. Emphasis is upon recruitment, selection placement, and evaluation of school personnel.',
  },
  {
    course_code: 'EDA6232',
    course_name: 'Law and Education',
    course_desc:
      'Examines law and its relationship to education. Students study constitutional law, legislative enactments, school policies, and the relationships among these aspects of school law as they pertain to administration. Tort liability, due process for students, corporal punishment, teacher contracts, and other law relating to authority and responsibility of teachers and administrators are included.',
  },
  {
    course_code: 'EDA6240',
    course_name: 'Introduction to School Finance',
    course_desc:
      'Focus is on principles, trends, and practices in financing public education, including federal, state, and local financial support programs. School finance as related to taxation and other areas of school finance is included. Fiscal policies, planning, and management as related to the total education program are central themes.',
  },
  {
    course_code: 'EDA6503',
    course_name: 'The Principalship',
    course_desc:
      'Students will participate in a robust practicum experience with the opportunity to intern in two diverse school sites, under the mentoring support of two different principals.  Candidates will lead instructional and program improvement efforts that are aligned to state and national leadership standards.  This course provides opportunities for students to develop leadership skills and knowledge.  The 60-hour practicum experience is designed to provide two clinical settings, where students can apply and connect theory to practice.',
  },
  {
    course_code: 'EDA6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDA7905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDA8103',
    course_name: 'Theories of Administration and Leadership',
    course_desc:
      'This course will address theories and theorists focused in the areas of administration, management and leadership. The course will include completing a literature review, developing a theoretical framework, and examining foundational constructs of multiple theorists.',
  },
  {
    course_code: 'EDE3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDE4200',
    course_name: 'Planning and Curriculum I',
    course_desc:
      'Designed to assist students to learn basic planning and instructional skills in preparation for teaching. Course also includes essential mathematics skills requisite to the Florida Teacher Certification Exam. Students will implement the knowledge gained through lower division content-specific courses and prepare for the methodological courses in the teacher education program.',
  },
  {
    course_code: 'EDE4201',
    course_name: 'Planning and Curriculum II',
    course_desc:
      'This course is designed to assist prospective teachers to use their knowledge of content and pedagogical methods as a basis for developing skills in planning integrated elementary curriculum.  Students will implement the knowledge gained through lower division content-specific courses and upper division methods courses to create interdisciplinary units of instruction that are designed to facilitate elementary children?s learning across all content areas.',
  },
  {
    course_code: 'EDE4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDE5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDE6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDF1005',
    course_name: 'Introduction to Education',
    course_desc:
      'This course is for students who are considering teaching as a profession in the k-12 public education setting. The course will provide students with an introduction to the field of education:  the structure of schools, historical/philosophical foundations of education, current challenges and requirements of the profession, and best practices for the k-12 classroom.  \nThis course requires a minimum of 15 hours of field experience in a k-12 school setting.',
  },
  {
    course_code: 'EDF2085',
    course_name: 'Teaching Diverse Populations',
    course_desc:
      'Provides students with the opportunity to explore personal values and attitudes toward cultural diversity. The theoretical component will examine the issues of education in a culturally diverse society. Attention will be given to skills necessary to deal with people from various cultural, economic, and philosophical backgrounds. In our global society, it is imperative that students in various fields understand multiculturalism and the impact of exceptionalities, culture, family, gender, sexual identity, socioeconomic status, religion, language of origin and ethnicity on human interactions especially as this applies to an educational setting.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'EDF3234',
    course_name: 'Applied Foundations of Education',
    course_desc:
      'The course focuses on principles of growth and development from birth through adolescence. Students examine personal, social and moral development as well as cognitive learning and motivation.  The course contains an emphasis on learners from diverse backgrounds and with special needs.',
  },
  {
    course_code: 'EDF3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDF5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDF6221',
    course_name: 'Intensive Intervention in Autism and Related Disabilities',
    course_desc:
      'An in-depth analysis of the core components of Early Intensive Behavior Intervention. Students learn how to structure intensive session to facilitate optimal medical treatment results for their clients. Students learn techniques to implement in practice to become fluent at precisely leading discrete trial training and incidental teaching as appropriate by context of medical ABA treatment in any appropriate setting.',
  },
  {
    course_code: 'EDF6222',
    course_name: 'Concepts of Applied Behavior Analysis',
    course_desc:
      "Concepts of Applied Behavior Analysis using B.F. Skinner's writings as a primary source in addition to other historical contributors to the field. The course may be organized around a given theme. This course is required for students meeting the BACB 5th Edition Task List.",
  },
  {
    course_code: 'EDF6223',
    course_name: 'Applied Behavior Analysis and System Support',
    course_desc:
      'This course provides information on the fundamental elements of behavior change and specific behavior change procedures. The content is based on specific topics via the Behavior Analyst Certification Board (BACB) Fifth Edition Task List.',
  },
  {
    course_code: 'EDF6224',
    course_name: 'Supervision and Management Fluency',
    course_desc:
      'This course provides students with the applied knowledge for personnel supervision and management when implementing Applied Behavior Analysis. Students will be able to establish clear procedures and approaches to personnel management using Applied Behavior Analysis methods and improved client outcomes via precise data collection. The content is based on\nthe Behavior Analyst Certification Board (BACB) Fifth Edition Task List in its entirety. This course is part of a verified course sequence that prepares students to apply for the Board Certified Behavior Analyst (BCBA) exam or the Board Certified Associate Behavior Analyst (BCaBA) exam.',
  },
  {
    course_code: 'EDF6225',
    course_name: 'Foundations of Applied Behavior Analysis',
    course_desc:
      'This course serves as a basic introduction to behavior analytic principles, definitions, characteristics, processes, and concepts. The content is based on the Behavior Analyst Certification Board (BACB) Fifth Edition Task List in its entirety. This course serves to prepare students to apply for the Board Certified Behavior Analyst (BCBA) exam or the Board Certified Assistant Behavior Analyst (BCaBA exam.',
  },
  {
    course_code: 'EDF6226',
    course_name: 'Behavioral Assessments',
    course_desc:
      'Participants learn to identify behaviors appropriate for change using behavioral assessments and related professional issues relevant to the practice of assessing behavior. Content is drawn from the Behavior Analyst Certification Board (BACB) Fifth Edition Task List. This course serves as the second in a series of courses that prepares students to apply for the Board Certified Behavior Analyst (BCBA) exam.',
  },
  {
    course_code: 'EDF6227',
    course_name: 'Experimental Analysis of Behavior',
    course_desc:
      'Foundational knowledge and concepts of experimental analysis of behavior to include demonstrating the operations of principles of behavior in the context of basic research in multiple areas of investigation such as schedules of reinforcement, stimulus control, conditioned reinforcement choice, and establishing/motivating operations.',
  },
  {
    course_code: 'EDF6229',
    course_name: 'Curriculum Design for Behavior Analysts',
    course_desc:
      'Prepares students to create behavioral programming appropriate to meet the individual needs presented by a client when practicing as a Board Certified Behavior Analysis across medical, community, and educational settings.',
  },
  {
    course_code: 'EDF6325',
    course_name: 'Autism and the Law',
    course_desc:
      'This course equips students with an understanding of the legal aspects impacting practice as a Board Certified Behavior Analyst in the field of Autism and Related Disabilities and any other clinical application of behavior analysis including Behavioral Health treatment. Relevant law in both Education and Health Care is introduced, discussed, and applied in real world scenarios to help students better grasp the regulation, rules, and accountability expected of them as practitioners.',
  },
  {
    course_code: 'EDF6437',
    course_name: 'Measurement and Single Case Design',
    course_desc:
      'This course provides students with concepts in measurement and design of single case methodology to establish reliable intervention procedures, positive behavior change, systems support, while adhering to management, supervision, and ethical and professional issues relevant to the practice of behavioral intervention and research design. The content is based on the Behavior Analyst Certification Board (BACB) Fifth Edition Task List in its entirety. This course is part of a verified course sequence that prepares students to apply for the Board Certified Behavior Analyst (BCBA) exam or the Board Certified Associate Behavior Analyst (BCaBA) exam.',
  },
  {
    course_code: 'EDF6460',
    course_name: 'Foundations of Measurement',
    course_desc:
      'Provides an understanding of the nature of instrument and test development and focuses on the information and skills needed to design, develop, analyze, and interpret tests and instruments; the use of testing or instrument results in planning, monitoring, and evaluating instruction or programs; and to evaluate student or program progress. Intended to provide a foundation in testing and instrument development skills for those who work in a variety of applied settings.',
  },
  {
    course_code: 'EDF6481',
    course_name: 'Educational Research',
    course_desc:
      'Develops skills for evaluating and for conducting applied research studies in an appropriate area of emphasis. Includes strategies of research appropriate for particular area of emphasis and methods appropriate for those strategies. Students are required to select a problem, perform a review of the research literature, plan a research study, and write a research proposal.',
  },
  {
    course_code: 'FIN4514',
    course_name: 'Security Analysis and Portfolio Management',
    course_desc:
      'Portfolio construction, management and measurement bridging modern theory and practice.',
  },
  {
    course_code: 'EDF6557',
    course_name: 'Ethics in Applied Behavior Analysis',
    course_desc:
      'In this course, participants learn the issues relevant to ethical and professional conduct in applied behavior analysis including consent, conflict of interest, assessment, behavior change, monitoring, reporting, and applicable law. The content is based on\nthe Behavior Analyst Certification Board (BACB) Fifth Edition Task List in its entirety. This course is part of a verified course sequence that prepares students to apply for the Board Certified Behavior Analyst (BCBA) exam or the Board Certified Associate Behavior Analyst (BCaBA) exam.',
  },
  {
    course_code: 'EDF6691',
    course_name: 'Issues in Education: A Bio-Psycho-Social Perspective',
    course_desc:
      'This course presents a holistic approach to understanding various theories of learning and development. The biological, psychological and social factors that affect human development and learning will be emphasized. Students will explore various issues in education and best practices in the classroom with an emphasis on diversity.',
  },
  {
    course_code: 'EDF6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDF6943',
    course_name: 'Supervised Experience in Single Case Design',
    course_desc:
      'Supervised field experience of positive behavioral support implementation in educational or related settings evaluated using single case designs. Topics covered will include the ethics and philosophy of positive behavioral support. Graded on satisfactory/unsatisfactory basis only.',
  },
  {
    course_code: 'EDF6944',
    course_name: 'Advanced Single Case Design',
    course_desc:
      'This course provides students with an applied environment to practice measurement and design of single case methodology using reliable intervention procedures, positive behavior change, systems support, while adhering to management, supervision, and ethical and professional issues relevant to the practice of behavioral intervention and research design. The content is based on the Behavior Analyst Certification Board (BACB) Fifth Edition Task List in its entirety. This course may be used as part of a verified course sequence that prepares students to apply for the Board Certified Behavior Analyst (BCBA) exam or the Board Certified Associate Behavior Analyst (BCaBA) exam.',
  },
  {
    course_code: 'EDF7404',
    course_name: 'Quantitative Methods and Educational Statistics I',
    course_desc:
      'Designed as an entry-level course in statistics and covers both descriptive and inferential statistical techniques to solve applied research problems. Emphasis is also placed on using statistical software packages and will cover the most widely used statistical procedures in education. This course presumes an understanding of basic statistics. Thus, students should complete the online statistics tutorial before enrolling.',
  },
  {
    course_code: 'EDF7407',
    course_name: 'Quantitative Methods and Educational Statistics II',
    course_desc:
      'This course is designed as an intermediate statistics course for students who work in applied settings in education and the social sciences.',
  },
  {
    course_code: 'EDF7468',
    course_name: 'Advanced Program Development and Evaluation',
    course_desc:
      'Focusing on leading evaluation approaches and providing an in-depth examination of evaluation theory, this course will encourage students to critically examine and discuss current and emerging variations in theoretical evaluation development.  These relationships will be analyzed through an applied research perspective designed to illuminate and evaluate the effectiveness of organizational program strategies dealing with societal concerns.  Grant funding methods will be introduced as an intervention tool in this process.',
  },
  {
    course_code: 'EDF7475',
    course_name: 'Qualitative Research I - Methods',
    course_desc:
      'This course is to prepare doctoral students for the process of designing scholarly research in general and their dissertation in particular. This course will guide students in constructing a qualitative design methodology section and developing the necessary skills required for critical evaluation of published research in their area of expertise. In addition, this course will provide insight to conducting ethical research and will guide students in identifying and designing a study using qualitative methods approach. The course focuses on the design and implementation of research that utilizes qualitative data collection and analysis.',
  },
  {
    course_code: 'EDF7478',
    course_name: 'Qualitative Research II-Design, Analysis, and Presentation',
    course_desc:
      'This course is an advance level course in qualitative research. This advanced course in qualitative research is needed to strengthen student knowledge and competence in understanding qualitative research procedures related to participant selection procedures, data collection approaches, data sources, credibility and trustworthiness, data analyses, and data presentation. It is designed for students who intend to use qualitative research approaches in their dissertations and or for further research.',
  },
  {
    course_code: 'EDF7489',
    course_name: 'Mixed Methods Research Design',
    course_desc:
      'Identify a potential dissertation topic, analyze and synthesize research on the topic, and produce a concept paper for the dissertation to be presented to the dissertation committee. Study the application of both qualitative and quantitative research methodologies towards addressing a research problem. Apply concepts from educational research in synthesizing current research articles for the development of a research project. Gain expertise in educational research that will facilitate student research agendas for action research, thesis research, and dissertation research.',
  },
  {
    course_code: 'EDF7536',
    course_name:
      'Cultural Competence and Education of Marginalized Ethnic Groups',
    course_desc:
      'This course presents students with cultural-specific information about marginalized groups within an educational setting. The course sheds light on how important it is in educating marginalized groups to be culturally sensitive, and the need to accept and respect the differences of the worldview particularly of those on the fringes of society.',
  },
  {
    course_code: 'EDF7537',
    course_name:
      'Education and Marginalization: Gender, Sexuality, Aging and Disabilities',
    course_desc:
      'The course provides an overview of issues affecting marginalized students in K-12 institutions. Topics include gender, sexuality, ageism, disability, and the emergence of institutions that serve special populations. A critical review of research on the above topics and the policies and discourse regarding gender, sexuality, ageism and disabilities will also be conducted.',
  },
  {
    course_code: 'EEE3308L',
    course_name: 'Electronics Laboratory',
    course_desc:
      'Electronic instrumentation devices and systems. Material and supply fee will be assessed. A grade of "C" or better is required in the prerequisites. Credit may not be received in both EEE 4308L and EEL 4304L.',
  },
  {
    course_code: 'EDF7538',
    course_name:
      'Education and Marginalization: Second Language Acquisition, Socioeconomic status',
    course_desc:
      'This course gives an overview of issues related to second language acquisition, socioeconomic status and immigration. This course will help students be knowledgeable about different practices and policies related to the education of students in marginalized communities in the United States and other places in the world.',
  },
  {
    course_code: 'EDF7539',
    course_name: 'Theoretical Perspectives Underpinning Marginalization',
    course_desc:
      'This course provides theoretical and philosophical overviews on poverty in the United States and other countries, as well as policies used to eradicate poverty. While education is important with regard to understanding and fighting poverty, the course will also draw from different fields, including philosophy, economics, and sociology. The course exposes students to competing theories of marginalization and different governmental and community practices aimed at uplifting the status of the marginalized.',
  },
  {
    course_code: 'EDF7573',
    course_name: 'Contemporary Curriculum Issues and Theories',
    course_desc:
      'Explores curriculum conceptions, contributions to curriculum decisions, issues and dilemmas in curriculum development, proposals for the organization of curriculum choices (both past and present), and analysis of curricular reforms. Theoretical foundations underlying curriculum considerations and implications of these for curriculum decision-makers at all levels.',
  },
  {
    course_code: 'EDF7638',
    course_name: 'Social Change and Reform',
    course_desc:
      'Analyzes different perspectives on agency and the structure of social change and reform. It examines the historical, cultural, social, economic, and political factors that lead ordinary citizens to join together as a collective group to promote social change and reform. Utilizing real life case studies from organizations for social change, students will interrogate the dynamics of social and cultural change in democratic societies with a special focus on social movements and collective behavior. The two aspects of the course, social change and reform, will be analyzed to reveal the critical aspects of vibrant democracies, civic engagement, and grassroots movement.',
  },
  {
    course_code: 'EDF7640',
    course_name: 'Netnography',
    course_desc:
      'This course will include opportunities for students to explore and practice the qualitative research method of ethnography within virtual environments.  The course will also involve opportunities for students to design and conduct virtual ethnographic studies or netnography research efforts. Topics to be discussed include: introduction to the nature of Netnography; review of Ethnography as a qualitative research design; Ethnography and virtual research environments; and Ethnography and Netnography: Commonalities and differences.',
  },
  {
    course_code: 'EDF7685',
    course_name: 'Philosophical Foundations of Education',
    course_desc:
      'This course explores the fundamental nature of education. The learner will consider what it means to educate, the purpose of education, the foundations of knowledge, the roles of educators and educational leaders, as well as the best means by which to achieve the goals of education. Students will examine problems of education through the consideration of questions of metaphysical, ontological, epistemic, and axiological import. Major historical trends in educational philosophies including Idealism, Realism, Pragmatism, and Existentialism will be incorporated through application to problems of educational authority, responsibility, curriculum and instruction. Foundational educational theorists, including Plato, Aristotle, John Locke, John Dewey, and Nel Noddings will be studied in order to understand their historical importance and the impact of their work on the conceptual structure of educational philosophy.  Students will compare and contrast theories of education, specifically, Essentialism, Perennialism, Progressivism, and Social Reconstructionism.  Students will investigate the major ideologies under-girding policy, curriculum and advocacy in education, including Nationalism, Liberalism, Conservatism, and Marxism.',
  },
  {
    course_code: 'EDF7728',
    course_name: 'Poverty, Education, and Human Rights',
    course_desc:
      "The course focuses on understanding the interrelationships between socioeconomic status and education, as well as the relationships between educational opportunity and achievement. The course will explore how income groups, particularly lower income groups in America and other regions of the world, access education and persist through graduation.\nThis course further explores civil and human rights campaigns since 1945. The course examines the origins, outcomes, and the ways in which these campaigns drew from and contributed to an emerging international framework. The course will look at issues of women's rights and sexual liberation, freedom of speech, economic justice and unfair trade. The relationships between universal notions of justice and differences of gender, culture and belief, and potential differences between local and global understandings of 'rights' are also covered.",
  },
  {
    course_code: 'EDF7730',
    course_name: 'Administration and Leadership Communication Techniques',
    course_desc:
      'This course will focus on specific effective professional communication efforts of administrators and leaders from military, social agencies, educational settings, and organizational environments, including non-profit agencies and organizations,  Skills emphasized in the course include:  Oral and written presentations for varied audiences and technology-rich communications for leading organizations and developing communicative organizational environments.',
  },
  {
    course_code: 'EDF7790',
    course_name: 'Foundations of Doctoral Research and Writing',
    course_desc:
      'The central purpose of this course is to provide students with the information and orientation needed to successfully navigate the doctoral program.  In addition to reviewing the policies and procedures of doctoral study (choosing an advisor, engaging in coursework, forming a committee, taking preliminary/comprehensive exams, designing a research study, conducting research, and defending a prospectus and dissertation), students will also study the behaviors and dispositions needed to be an educational researcher and scholar, including what it means to read, think, and write critically.  Students will explore how to develop a sense of themselves as a scholar and to take ownership over their own education, including setting goals, identifying opportunities, and developing a research agenda. In addition, the course will include an introduction to research designs.',
  },
  {
    course_code: 'EDF7905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDF8649',
    course_name: 'Policy Analysis and Education',
    course_desc:
      'The course is designed to critically review current policy issues in education. The focus will be on the analyses of policymaking processes, methods of policy analyses, and policy research. Additionally, solutions to selected issues and problems will be reviewed, and alternative solutions interrogated.',
  },
  {
    course_code: 'EDF7912',
    course_name: 'Educational Specialist Degree Capstone Course',
    course_desc:
      "The capstone course is to be taken as the last course in the Educational Specialist Degree Program in Curriculum and Instruction during the 33-36 credit hours. The capstone project provides the opportunity for the student to explore and investigate a topic of interest emerging from the cumulative knowledge of the coursework pursued.  The selected topics for the capstone project should address an existing concern, problem or issue in an organization or institution of interest to the student. Through an analysis of theoretical, empirical, and conceptual literature the student will conduct research and complete a capstone project under the guidance of a faculty member within an 8-week period. The capstone project serves as a gauge of students' learning indicative of their post-graduation success as well as a dossier for employment.",
  },
  {
    course_code: 'EDF7930',
    course_name: 'Virtual Survey Research for the Social Sciences',
    course_desc:
      'This course focuses on methods and ethics related to conducting online research interviews and surveys.  Students will determine the appropriateness of online (virtual) interviews and other survey methods within virtual research environments.  The course includes multiple online types of research efforts and survey methodologies. Topics to be discussed include: introduction to virtual survey research; methodologies for conducting virtual survey research; creating virtual survey interviews; and responsible conduct of research and virtual survey research.',
  },
  {
    course_code: 'EDF7934',
    course_name: 'APA Seminar',
    course_desc:
      'This self-paced, online, noncredit-bearing course spread the first academic year of admission into the Ed.D. or Ed.S. programs. The course will be organized into six modules in total. Students will complete two modules every semester to improve scholarly writing abilities and accurate resource referencing practices needed for the successful completion of the coursework and the dissertation project.',
  },
  {
    course_code: 'EDF7938',
    course_name: 'Preparatory Educational Statistics',
    course_desc:
      'This self-paced, online, noncredit-bearing course takes place during the first academic year of admission into the Ed.D. or Ed.S. programs. The course will be organized into six modules in total. Students will complete modules every semester to improve quantitative research methods and statistics familiarity.',
  },
  {
    course_code: 'EDF8059',
    course_name:
      'Instrumentation Development and Validation Using Virtual Environments',
    course_desc:
      'This course includes the nature of measurement theory and methodology of reliability estimation and validation using virtual environments and considerations.  Course emphasis is on applications of instrumentation for assessment, research, and evaluation uses within virtual environments. Topics to be discussed include: introduction to logical, statistical, and empirical measurement; and reliability models and validation principles; scaling, scoring, and measurement principles within virtual environments.',
  },
  {
    course_code: 'EDF8289',
    course_name: 'Curriculum Design',
    course_desc:
      'This course incorporates recent general developments in curriculum theory and construction. Reviewing current specific curriculum models, plans, and guidelines provide students with the ability to analyze and interpret curriculum and instruction programs. This course further explores historical, sociological, psychological, and philosophical foundations of curriculum models, theory, and design.',
  },
  {
    course_code: 'EDF8438',
    course_name: 'Social Network Analysis and Data Visualization',
    course_desc:
      'This course provides students with the various concepts, methods, and applications related to measures on groups of individuals.  Topics include the nature of social network data visualization, embedding, dyadic and triadic analysis, centrality, and egocentric networks.  These topics will focus on actions surrounding virtual environments in the social sciences.',
  },
  {
    course_code: 'EDF8469',
    course_name: 'Advanced Program Evaluation Using Virtual Environments',
    course_desc:
      'This course focuses on program evaluation theories and practices.  The course includes evaluation designs by scholarly theorists and extends evaluation theory to virtual environments. A strong component of the course is the development of program evaluation proposals for virtual environment designs with appropriate technological support. Topics to be discussed include: introduction to advanced program evaluation; theory and program evaluation; and program evaluation and virtual environment.',
  },
  {
    course_code: 'EDF8483',
    course_name: 'Digital and Archival Media Analysis',
    course_desc:
      'This course provides opportunities for students to explore a variety of investigative methods related to fundamental histographic skills and strategies for archival investigations to digital and multi-dimensional  scaling.  Analytic endeavors that seek to gain insights through media analysis and other material artifacts are included in the course. Topics to be discussed include: introduction to archival media; digital analysis; archival investigations; and multidimensional scaling.',
  },
  {
    course_code: 'EDF8486',
    course_name:
      'Advanced Topics in Quantitative Research and Educational Statistics',
    course_desc:
      'The student will develop advanced skills required to conduct educational research and analyze results. Emphasis is placed on aligning research methodology with appropriate statistical techniques for a particular purpose and set of research questions, and the interpretation of statistical output.',
  },
  {
    course_code: 'EDF8493',
    course_name: 'Assessing Educational Programs',
    course_desc:
      'The course examines current evaluation models used to assess programs implemented in various educational settings. Students will explore and analyze the application of evaluability assessment in multiple settings and the use of methodological scoping as part of evaluability assessment. Additionally, students will utilize various models and instruments to evaluate existing educational programs.',
  },
  {
    course_code: 'EDF8498',
    course_name: 'Improvement Science and Design Decision Making in Education',
    course_desc:
      'The course is designed to examine a disciplined approach to educational innovation. Improvement Science focuses on creating a collaborative space for teachers, leaders, and researchers to solve specific problems of practice. The course is designed to examine current research on reasoning, problem solving, and decision making as well introducing students to the fundamental techniques of using data to make informed education related decisions. Additionally, the course focuses on ways of modeling, or thinking structurally about, problems of practice in order to enhance decision making skills. The course further examines the rationales for different innovations by integration multiple perspectives.',
  },
  {
    course_code: 'GEO6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDF8749',
    course_name: 'Psychological and Social Theories of Education',
    course_desc:
      'This course is designed to provide an extensive study of psychological and social theories in the field of education. The historical/social milieu that gave birth to the theories will be examined. In addition, the major tenets of the theories and their implications for educational policy, research, and practice will be critiqued. Further the strengths and weaknesses of the theories will be interrogated.',
  },
  {
    course_code: 'EDF8905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDF8931',
    course_name: 'Doctoral Seminar : Background Paper',
    course_desc:
      "This is the first of a series of four-sequenced doctoral seminars for students in their 33rd semester hour of coursework. The first seminar focuses on assisting students in identifying a topic, developing appropriate research questions, and stating a problem. In addition, the seminar seeks to assist students to develop an outline of a literature map for a literature review related to an identified phenomenon. In addition, the seminar will strengthen students' scholarly writing capabilities, improve synthesis skills, assist in critiquing research, reviewing literature, mastering APA citation style, examining the role of theoretical and or conceptual frameworks in framing research studies, and exploring issues of alignment between topic, problem, research questions, theoretical framework and methodology in research studies. The capstone paper for this Doctoral Seminar is an extensive Background Paper.",
  },
  {
    course_code: 'EDF8932',
    course_name: 'Doctoral Seminar: Comprehensive Exam',
    course_desc:
      "This is the third in the series of four-sequenced doctoral seminars courses for students who have completed 48 semester hours in their doctoral course work. This third doctoral seminar serves as the doctoral students' written and oral comprehensive examination. Additionally, the seminar focuses on the following: demonstrating synthesis across ideas, content areas, and courses; demonstrating specialization of knowledge within a particular domain; demonstrating in-depth competency within program areas; integrating content from program courses with professional/experiential knowledge; and supporting initial work efforts toward the dissertation. Further, students will orally defend their written responses to the examination questions before their Doctoral and Comprehensive Examinations Committee. Students who successfully complete the written and oral components of the examination are admitted to the Advanced Standing phase in their doctoral journey.",
  },
  {
    course_code: 'EDF8933',
    course_name: 'Doctoral Seminar: Proposal',
    course_desc:
      "This is the fourth of the series of four-sequenced doctoral seminar courses for students in their doctoral journey. This fourth doctoral seminar serves as the doctoral students' dissertation proposal phase. This semester-long (16 week seminar will focus on student readiness and competence for pursuing research objectives outlined in the Doctoral Student Toolbox Structural Guidelines. Additionally, this seminar guides students in demonstrating their ability to integrate and apply the knowledge and skills developed through formal course work by designing and writing an original research proposal on a researchable topic or phenomenon in accordance with the UWF Structural Guidelines for Proposals and Dissertations. Students should successfully defend their proposals orally to their Doctoral Dissertation Committee. Obtaining two unsatisfactory grades at this level may result in the removal of the student from the doctoral program.",
  },
  {
    course_code: 'EDF8935',
    course_name: 'Doctoral Seminar : Dissertation Inquiry',
    course_desc:
      'This is the second in a series of four-sequenced doctoral seminar courses for students in their doctoral journey. This second doctoral seminar serves as a research inquiry. Additionally, this doctoral seminar course will introduce students to the process of formulating ideas in ways directly related to critical aspects of their proposal. Students shall complete the "Pre-proposal Document," as the capstone assignment for the course. The ?Pre-proposal Document, is designed as a guide for committee members and students to serve the purpose of providing them with a sufficient road map about what the student intends to do. The "Pre-proposal Document" incorporates aspects of the background context to a proposed issue, problem statement, purpose of the study, research questions, significance of the issue to policy, practice, and theory, literature review, theoretical framework, methodology, ethical issues and related IRB processes. The "Pre-proposal Document" allows students to capture all these aspects in a form of a mini proposal. Students shall orally defend the "Pre-proposal Document.',
  },
  {
    course_code: 'EDF8936',
    course_name: 'Action Research Methods',
    course_desc:
      'This course is designed to introduce students to action research. Action research focuses on improvement of practice, a better understanding of that practice, and an improvement in the situation in which the practice is carried out. The primary objective of the course is to equip students with the knowledge-base and skill-set to be able to undertake action research studies.\nTopics include definitions, importance and applications of action research; identifying and refining the focus of an action research study; planning for action research and reviewing related literature; articulating a theory of action and determining research questions; building a data collection plan and analyzing data; and presenting findings, action plans and future cycles.',
  },
  {
    course_code: 'EDF8937',
    course_name: 'Research Applications',
    course_desc:
      'This course will engage Ed.D. students in applying advanced research methods in application areas specific to their specializations. The course will involve dissertation research methods and writing skills as well as field site activities and data analysis. The course will also include activities focused on presenting and publishing research findings.',
  },
  {
    course_code: 'EDF8940',
    course_name: 'Seminar: Supervised Doctoral Internship',
    course_desc:
      'Applied field experience chosen by doctoral students with the approval of the dissertation advisory committee. The supervised doctoral internship is designed to provide students with the opportunity to develop conceptual and professional skills through their experiences at an approved field site as they integrate theory and practice. Specific activities and assignments will be determined collaboratively by the student, the site supervisor, and the University supervisor to ensure that the intern obtains practical experience consistent with the expectations of a curriculum and instruction professional in a field of specialization.',
  },
  {
    course_code: 'EDG4936',
    course_name: 'Senior Seminar and Reading Practicum',
    course_desc:
      'Integrates theory, and general professional preparation with actual school practice. Includes a supervised reading practicum that provides opportunities to apply knowledge of reading instruction and assessment in order to increase reading proficiency of struggling readers. Prepares student for achieving initial certification and continuing success in the classroom.',
  },
  {
    course_code: 'EDF8980',
    course_name: 'Dissertation',
    course_desc:
      "Major individual research in an area of significant educational interest; designed specifically for candidates in the Ed.D. Curriculum and Instruction, Teacher Education Specialization. The dissertation reflects intensive educational research produced by the student and collaboratively developed with the student's graduate committee. Graded on a satisfactory/unsatisfactory basis only. Admission to candidacy, completion of all other doctoral program requirements and permission are required.",
  },
  {
    course_code: 'EDG2041',
    course_name: 'Exploring Inquiry Teaching',
    course_desc:
      'This course is for students who are considering teaching STEM courses in the 6-12 public education setting as a profession. The course will provide students with an introduction to the field of education:  the structure of schools, historical/philosophical foundations of education, current challenges and requirements of the profession, and best practices for the k-12 classroom.',
  },
  {
    course_code: 'EDG2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDG3323',
    course_name: 'Methods of K-12 Literacy Instruction',
    course_desc:
      'This course provides K-12 pre-service teachers with dynamic methods of planning, presenting, and assessing literacy instruction for all learners.  Course content and learning activities focus on applying knowledge and skills related to effective teaching and learning in the various content areas.',
  },
  {
    course_code: 'EDG3661',
    course_name: 'Adult Learning Theory and Curriculum Development',
    course_desc:
      'Examines the unique characteristics of adult learners and their impact on the design and development of education and training programs.  Addresses adult learning theories and the role of motivation, relevance and autonomy in adult learning.',
  },
  {
    course_code: 'EDG3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDG3945',
    course_name: 'Field Experience 1',
    course_desc:
      'This field experience includes carefully planned and designed course assignments and activities, with students working for a minimum of 100 hours in a field placement. This experience includes: focused and specific introductions, observations & identification, demonstration, and reflection. In order to receive a C- or above in the course, students must earn at least a "Needs Improvement" or above rating on the Danielson evaluation tool for elements 1a,1b,1c, 1f,2a,3b,4a,4e & 4f and a passing score on all dispositions. Permission is required and a program GPA of 2.0 for those in the Community Ed. Degree or 2.5 Program GPA for those in the ESE/Elem or Elem Ed. degrees.',
  },
  {
    course_code: 'EDG4064',
    course_name: 'Teaching at Risk Learners',
    course_desc:
      'This course is designed for individuals who will facilitate community-based education programs for children, youth, and families living in poverty. The course explores the impacts of poverty on education, health, and well-being of individuals, as well as ways to reduce these impacts. Emphasis is placed on the role of community educators in implementing effective educational programs and strategies that improve outcomes for disadvantaged children and youth.',
  },
  {
    course_code: 'EDG4077',
    course_name: 'Learning In Community Education Environments',
    course_desc:
      'Students will explore the variety of settings that offer community learning opportunities such as museums, science discovery centers, child care programs, outdoor programs, adult and continuing education.  The demands of these environments are varied and are often considered "free-choice" education options.  Therefore, the skills and tools for communicating messages to varied audiences in these settings can be very different from the traditional classroom instruction.  We will explore and practice motivation, communication, interpretation. design, evaluation, and promotion.',
  },
  {
    course_code: 'EDG4334',
    course_name:
      'Universal Design for Learning in Community Learning Environments',
    course_desc:
      'This course will prepare students to use the Universal Design for Learning (UDL) framework to create learning experiences for a wide variety of learners in non-classroom settings such as child care settings, museums, after-school programs, adult learning centers, and libraries. Specifically, students will explore UDL principles including multiple means of representation, action and expression, and engagement. Students will use UDL resources and strategies for planning and evaluating inclusive learning experiences with an emphasis on at risk student populations.',
  },
  {
    course_code: 'EDG4351',
    course_name: 'Educational Assessment',
    course_desc:
      'This general assessment course is designed for all students in Teacher Education and focuses on assessment concepts that are critical for good teaching. Topics include (1) measurement issues to determine assessment quality; (2) teacher-constructed assessments such as paper and pencil assessments, informal assessments, and performance and product assessments; (3) interpreting standardized assessments commonly used in public schools; (4) using assessment data to develop instructional plans; and(5) using specialized assessment tools to meet varied student needs.',
  },
  {
    course_code: 'EDG4373',
    course_name: 'Integrated Arts and Contemporary Educational Tools',
    course_desc:
      'Prepares students to effectively integrate the arts and contemporary tools into instruction delivered in K-12 classrooms and community settings. Emphasis is on engaging learning experiences for learners that are designed to deepen and integrate their knowledge and understanding of subject matter across disciplines and support teaching and learning in inclusive settings.',
  },
  {
    course_code: 'EDG4442',
    course_name: 'Effective Learning Environments',
    course_desc:
      'This course focuses on strategies for creating and maintaining effective learning environments with activities related to building relationships, organizing groups, developing and implementing rules and procedures, teaching effectively, utilizing positive behavior support strategies, and implementing individual behavioral interventions.',
  },
  {
    course_code: 'EDG4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDG4931',
    course_name: 'Capstone Seminar in Community Education',
    course_desc:
      "This course provides opportunity for students to demonstrate their achievement of the goals of community education. The course is designed as a student-centered, content-related learning experience and serves as a summary and synthesis of the experiences in the education program. The process and products of the course are designed to assess cognitive, affective, and dispositional outcomes appropriate to the students' chosen focus of study.",
  },
  {
    course_code: 'EDG4940',
    course_name: 'Student Teaching',
    course_desc:
      'The course involves a minimum of ten weeks of supervised teaching in a public or private school assigned to the student by the TEEL Field Placement Office and approved by the TEEL Chair. This is a full-time assignment, and students may not take additional coursework or maintain employment during the student teaching experience without prior approval from the TEEL Chair. In order to receive a "satisfactory" in the course, students must earn at least a "Developing" rating on the Danielson evaluation tool for all elements and a passing score on all dispositions. Performance in student teaching is graded on a satisfactory/unsatisfactory basis only.',
  },
  {
    course_code: 'EDG4941',
    course_name: 'Teaching Internship I',
    course_desc:
      'Teaching Internship I is designed to be the culminating experience for those preparing to become a professional educator.  This elite program will provide the student with a 10 month placement in which they will apply all the knowledge they have gleaned from their coursework.  The placement will provide opportunities for students to practice skills under careful observation and in cooperation with a master teacher.  Phase 1 of this year-long supervised teaching experience in public and private schools will focus on planning and executing effective instruction.  (Students will register for this series in successive semesters) Graded on Satisfactory/Unsatisfactory basis only. In order to receive a "satisfactory" in the course, students must earn at least a "Developing" rating on the Danielson evaluation tool for all elements and a passing score on all dispositions. (See Teacher Education/Admission to Student Teaching) Permission is required.',
  },
  {
    course_code: 'EDG4942',
    course_name: 'Teaching Internship II',
    course_desc:
      'Internship Internship II is designed to be the culminating experience for those preparing to become a professional educator.  This elite program will provide the student with a 10 month placement in which they will apply all the knowledge they have gleaned from their coursework.  The placement will provide opportunities for students to practice skills under careful observation and in cooperation with a master teacher.  Phase 2 of this year-long supervised teaching experience in public and private schools will focus on classroom management and professional development.  (Students will register for this series in successive semesters) Graded on Satisfactory/Unsatisfactory basis only.  (See Teacher Education/Admission to Student Teaching).',
  },
  {
    course_code: 'EDG4944',
    course_name: 'High Impact Practice Practicum',
    course_desc:
      "Students will complete a 10-week high-impact learning experience that integrates service learning and reflection to support career success. The overarching intent of the course is to make linkages between academic content, and applied service learning experience, and students' career plans.",
  },
  {
    course_code: 'EDG4947',
    course_name: 'High-Impact Practice Seminar',
    course_desc:
      'This seminar course will present the concept of high-impact practices (HIPs) with an emphasis on collaborative assignments, service-learning, and self-reflection. Students will investigate, analyze, and apply HIPs in varied community education settings. Learning activities will include students working collaboratively to develop a service learning project to address a community need.',
  },
  {
    course_code: 'EDG4948',
    course_name: 'Apprenticeship Teaching',
    course_desc:
      'Apprenticeship teaching is designed to be the culminating experience for those preparing to become a professional educator.  This elite program will provide the student with a half-time  placement in which they will apply all the knowledge they have gleaned from their coursework. The placement will provide opportunities for students to practice skills under careful observation and in cooperation with a master teacher. This supervised teaching experience in public and private schools will focus on planning and executing effective instruction, classroom management and professional development. Graded on Satisfactory/Unsatisfactory basis only. In order to receive a "satisfactory" in the course, students must earn at least a "Developing" rating on the Danielson evaluation tool for all elements and a passing score on all dispositions. (See Teacher Education/Admission to Student Teaching) Permission is required.',
  },
  {
    course_code: 'EDG4949',
    course_name: 'Field Experience 2',
    course_desc:
      'Students in this course will complete a minimum of 100 hours of supervised work in an assigned educational setting, with 25 hours devoted to an ESOL placement. Students will continue to build connections between theory and practice, demonstrating competency on the Florida Educator Accomplished Practices (FEAPs) and ESOL Performance Standard. Specific learning activities include observation, planning, implementation of planned learning experiences, and assessment of students from diverse backgrounds including students identified as culturally and linguistically diverse (English Language Learners - ELL).  \nIn order to receive a C- or above in the course, students must earn a "Needs Improvement" or above rating on 16 or more elements of the Danielson evaluation tool and a passing score on all dispositions.  \nStudents must have a 2.5 program GPA and satisfactorily complete the FTCE General Knowledge exam as well as submit an application by the deadline listed on the department website and in the Student Guide in order to be eligible for placement. Permission is required.',
  },
  {
    course_code: 'EDG5250',
    course_name: 'Principles of Curriculum',
    course_desc:
      'Emphasis on school curricula, underlying theories, and strategies for improvement make up the foundation for curricular reform. Students intending to meet FDOE certification requirements should select specialization areas. The specialization areas are (a) early childhood/ primary education, (b) middle school education, (d) secondary school education, and (e) exceptional student education.',
  },
  {
    course_code: 'EDG5304',
    course_name: 'Introduction to Teaching and Learning',
    course_desc:
      'Introduces students to the field of education by exploring instructional planning, effective teaching strategies, and professional educator responsibilities.  Florida Educator Accomplished Practices are presented to provide an awareness of effective teaching practices and pedagogy.  Students\nobserve and participate in a classroom field experience to practice skills of an effective educator as defined in the Educator Accomplished Practices Competencies.',
  },
  {
    course_code: 'EDG7008',
    course_name: 'Assessment Literacy',
    course_desc:
      'This course explores various research-based approaches to assessing student learning; educational programs; and organizational structures, systems, and cultures.  Learning activities focus on various approaches to assessing student learning in addition to the role of assessment in various models of measurement and evaluation.',
  },
  {
    course_code: 'EDG5309',
    course_name: 'Inquiry-based Teaching in Secondary Schools',
    course_desc:
      'This course will provide students with the opportunity to explore teaching secondary (grades 6-12) math, science, or social studies as a career. Students will observe experienced teachers in the classroom, as well as practice designing and delivering inquiry-based lessons in their discipline. \nThis course requires a minimum of 30 hours of field experience. Participants will be required to complete a background check and provide their own transportation to the field placement site, which will be a local middle or high school.',
  },
  {
    course_code: 'EDG5342',
    course_name: 'Effective Teaching and Instruction',
    course_desc:
      'This course is designed to allow participants to explore effective teaching practices and strategies to enhance student learning in the K-12 classroom. Course content begins with a brief overview of research on learning and cognition with an emphasis on implications for classroom practice. Following that, students will investigate research-based effective teaching practices within and across multiple subject areas (e.g., mathematics, history, science) and then deconstruct and reflect on the use of various evaluation models (e.g., Marzano, Danielson) currently being used to gauge and improve the quality of classroom instruction. Lastly, collaborative professional learning strategies for supporting teachers in improving their instruction will be introduced and practiced.',
  },
  {
    course_code: 'EDG5349',
    course_name: 'Models of Teaching Math, Science and Social Studies',
    course_desc:
      'In Models of teaching, students explore instructional models for teaching in math, science and social studies.  Students investigate various models of teaching including inquiry, synectics, problem solving, socratic, cooperative and inductive in order to apply them to their classroom.  Students examine the rationale and research supporting each model as well as real-world examples.',
  },
  {
    course_code: 'EDG5366',
    course_name:
      'Investigative Strategies and Empirical Foundations in Learning and Development',
    course_desc:
      'This course is an introduction to the foundations of empirical research, investigative strategies, and data sources used to study issues in teacher education. It provides an overview of the elements of the research process through the critical analysis of quality peer-reviewed journal articles. The purpose of this course is to provide students with the basic skills and knowledge to identify, analyze, and interpret empirical research; to identify the elements of the research process; and to apply quality peer-reviewed research findings in practice.',
  },
  {
    course_code: 'EDG5446',
    course_name:
      'Classroom Management, Assessment, and Instruction in Secondary Education',
    course_desc:
      'This course is designed to provide students with practical information about classroom management, assessment and effective models of instruction. The focus will be on how assessment information can be used to plan and modify instruction, instructional models, and classroom management strategies. Students will be exposed to Positive Behavior Intervention Support systems and assessment techniques.',
  },
  {
    course_code: 'EDG5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDG6285',
    course_name:
      'Data Driven Decisions Using Standardized Student Achievement Data',
    course_desc:
      'Using data to drive decisions is a critical component of the accountability system currently in place in Florida. Participants will develop skills in determining data needed to make certain decisions; in analyzing data; in communicating information about the decision making process to stakeholders. This course is designed specifically for administrators in the K-12 educational setting.',
  },
  {
    course_code: 'EDG6288',
    course_name: 'Educational Assessment',
    course_desc:
      'The focus of this course is assessment concepts that are critical for good teaching. Topics include measurement issues to determine assessment quality; teacher constructed assessments such as paper and pencil assessments, informal assessments, and performance and product assessments; and interpreting standardized assessments commonly used in public schools. Required course for students participating in the Professional Educator Preparation Program.',
  },
  {
    course_code: 'EDG6415',
    course_name: 'Issues in Classroom Management',
    course_desc:
      'This course is designed for educators with existing capacity regarding classroom management and is intended to advance their understanding and develop a knowledge of systematic models of classroom management. The content will focus on shaping teacher behaviors and structuring the classroom for success. Additionally, focus will be placed on recognizing the various and competing philosophies of classroom management and the benefits of using a systematic model within a classroom or school.',
  },
  {
    course_code: 'EDG6662',
    course_name: 'Principles of Curriculum and Instruction',
    course_desc:
      'This is an advanced curriculum course for graduate-level education students. This course is designed to give educators a comprehensive overview of the field of curriculum and instruction, including the influence of educational philosophies, curriculum theories, significant social forces, and learning theories about how knowledge, skills, and dispositions are constructed and transferred. It is a practical guide for curriculum development, instructional applications, and curriculum evaluation.',
  },
  {
    course_code: 'EDG6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDG6916',
    course_name: 'Applied Research',
    course_desc:
      'This capstone course is designed for students to apply methods of scholarly inquiry and composition, synthesizing insights and findings in a scholarly product. The course goals are to provide students with hands-on experiences in the collection and analysis of data related to a specific field.  Students will have options that include: 1) a comprehensive synthesis of research that answers a specific question, 2) an action research project, or 3) an instructor approved design.',
  },
  {
    course_code: 'EDG6918',
    course_name: 'Introduction to Research',
    course_desc:
      'This course is designed to provide foundational knowledge about qualitative and quantitative methods for conducting meaningful inquiry and research in the social sciences.  Students will gain an understanding of research intent and design, methodology and technique, data management and analysis, and format and presentation.  The purpose of the course is to explore selected types of research and related techniques to provide students with the basic skills and knowledge to develop a research plan.',
  },
  {
    course_code: 'EEE3308',
    course_name: 'Electronic Circuits I',
    course_desc:
      'Fundamentals of analog electronic circuits and systems. A grade of "C" or better is required in the prerequisites. Credit may not be received in both EEE3308 and EEL 3304.',
  },
  {
    course_code: 'EDG7241',
    course_name: 'Social Justice, Inequalities, and Power: A Global Overview',
    course_desc:
      "This course will provide a global analysis on issues grounded in the structure of power, the origins of inequalities, and the social responses to egalitarianism. Additionally, the course focuses on the interdependence of race/ethnicity, gender orientation, sexuality, human rights, age, disability, and healthcare under the intersectionality of power. The intersectionality as a theoretical framework to analyze marginalization will be interrogated. Other topics include socioeconomic, cultural, social, institutional structures and movements in society's struggle for inclusion, fairness, empowerment, and eradication of oppression and systemic racism from an educational perspective.",
  },
  {
    course_code: 'EDG7256',
    course_name: 'Assessing Curricula and Educational Programs',
    course_desc:
      'This course examines current evaluation models used to assess curricula and programs implemented in various educational settings. Beyond theories, students will explore the application of evaluability assessment in multiple settings, the methodological scoping as part of evaluability assessment, and using various models and instruments to evaluate existing educational curricula & programs.',
  },
  {
    course_code: 'EDG7354',
    course_name: 'Test, Measurement, & Data Literacy',
    course_desc:
      'This course explores varied constructs and concepts in measurement theory, test construction, reliability and validity, item analysis in test development, and test scoring and interpretation.',
  },
  {
    course_code: 'EDG7667',
    course_name: 'Evaluating Models of Curriculum & Assessment',
    course_desc:
      "With a focus on learning outcomes, this course aims to broaden students' knowledge about designing and assessing curricula in various educational settings ranging from K-12 to higher education. Using various change models, this course offers a practical approach to systemic change with a focus on the relationship between courses and the curriculum.",
  },
  {
    course_code: 'EDG7905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDG7935',
    course_name: 'Research Design Seminar',
    course_desc:
      'Provides students with an understanding of how to undertake a research thesis. Concepts include format, style, literature reviews, hypothesis formulation, research design and statistical application.',
  },
  {
    course_code: 'EDG8668',
    course_name: 'Curriculum and Instructional Strategies for Adult Learners',
    course_desc:
      'This course provides an overview of the theories and research that are important for those interested in the instruction of adults (andragogy). Through this course, students will gain a greater understanding of instructional strategies for adult learners and critically examine examples of these approaches.',
  },
  {
    course_code: 'EDG8938',
    course_name: 'Seminar: Advanced Methods in Curriculum and Instruction',
    course_desc:
      'This course will explore contemporary research and methodologies in curriculum and instruction in the current era of educational reform and globalization. Emphasis will be placed on understanding factors that influence the development of new curricula and the enactment of reformed instructional practices contained therein, and strategies to support and sustain curriculum change and the adoption of reform practices.',
  },
  {
    course_code: 'EDG8980',
    course_name: 'Dissertation',
    course_desc:
      "Major individual research in an area of significant educational interest; designed specifically for candidates in the Ed.D. Curriculum and Instruction program. This dissertation will reflect intensive educational research produced by the student and collaboratively developed with the student's graduate committee. Graded on a satisfactory/unsatisfactory basis only. Admission to candidacy and completion of all other doctoral program requirements are required.",
  },
  {
    course_code: 'EDH5040',
    course_name: 'The American College Student: Trends in Higher Education',
    course_desc:
      'Studies the characteristics of American college students, trends affecting higher education, and the effects of these trends on students? college experience and outcomes.  Assignments and lesson plans will also engage students in the practice of skills vital for success in a complex and dynamic work environment.',
  },
  {
    course_code: 'EDH5070',
    course_name: 'Assessment Issues in College Student Affairs',
    course_desc:
      "The course will provide an introduction to assessment issues in student affairs. Students will focus on specific aspects of research design and methodology and the critical analysis of journal articles and research reports that employ these methods to investigate major issues in higher education.  Students will explore the practical applications of assessment within the student affairs field, and develop a working knowledge about conducting assessments in their post-masters' positions.",
  },
  {
    course_code: 'EDH6045',
    course_name: 'Theories of College Student Development',
    course_desc:
      'The purpose of this course is to study the various student development theories used as a foundation for student affairs work. Students will learn theories related to psychosocial, identity development, cognitive-structural, and typology. Individuals will learn how to put theory into practice with working with students.',
  },
  {
    course_code: 'EDH6368',
    course_name: 'Multicultural Competence in Student Affairs',
    course_desc:
      'This graduate seminar focuses on assisting students in deepening their critical understanding of multicultural issues in higher education. We will explore ways in which issues of difference extend beyond individual relationships to the\nsystems in which people operate, in the unique context of colleges and universities. We will focus on developing awareness, knowledge, and skills necessary to be a multiculturally-competent student affairs practitioner and address responsibilities, challenges, and opportunities for creating and sustaining affirming, pluralistic, and inclusive campus communities for all students.',
  },
  {
    course_code: 'EDH6369',
    course_name: 'Capstone Seminar in Student Affairs',
    course_desc:
      'As the culminating experience in the College Student Affairs Administration Program, this course prepares graduates for employment in the student affairs profession by means of the Comprehensive Assignment. Students develop and present a formal program proposal that demonstrates mastery of the CSAA program course content and skills. The course also includes job search preparation and employment strategies, as well as transitional issues from being a graduate student to a new professional, such as establishing a professional identity and social media pitfalls. This course is team taught by two CSAA faculty.',
  },
  {
    course_code: 'IDH4038',
    course_name: 'Honors Seminar: Topic IX',
    course_desc:
      'Specific Topics will vary; see the Director of the University Honors Program for current offerings. Enrollment in Honors Seminars is by permission of the Director of the Honors Program only.',
  },
  {
    course_code: 'EDH6405',
    course_name: 'Legal Issues in Higher Education',
    course_desc:
      'An examination of the legal status of higher education in the United States; the rights and responsibilities of educators and students including topics such as, due process; torts, liability, and contracts; student rights; student conduct, Higher Education compliance and other topical areas.',
  },
  {
    course_code: 'EDH6505',
    course_name: 'Budgeting & Financial Management in Higher Education',
    course_desc:
      'This course is designed to provide students with a general overview of the financing of higher education and a basic understanding of the budgeting process.  Students will be provided with a theoretical and practical overview of budgeting and financial management in higher education in general and Student Affairs specifically.  Topics will include budget components and processes, the relationship of strategic planning to budgeting, and models for financing the higher education enterprise.  Guest speakers from across campus will present perspectives and information related to budgeting and financial management in relation to their professional roles.',
  },
  {
    course_code: 'EDH6634',
    course_name: 'Introduction to College Student Affairs',
    course_desc:
      'The primary goal of this course is to provide the graduate student with a comprehensive introduction to the field of student affairs and its role within the context of American higher education.  To that end, students will be introduced to: the philosophical and theoretical bases of the profession; the history of modern student affairs work in higher education; the roles and functions of selected professionals in the field; a review of skills and competencies required for the profession; and current issues and concerns relevant to student services in general.  The course also provides opportunities for students to explore various aspects of the profession related to their career goals and interests.',
  },
  {
    course_code: 'EDH6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDH6948',
    course_name: 'Internship in Higher Education',
    course_desc:
      'Consists of two components, one involving practical application and the second involving an approved independent study. Interns will work on one or more projects or activities in an appropriate students affairs or student support services unit. Practical experience must include specified learning outcomes and appropriate documentation of work and learning. The practical experience component will provide the opportunity to observe how a student affairs or student services unit operates and to learn about critical issues, essential knowledge, and applicable skills required to be successful in the field. The independent study portion of the internship will allow development of an area of special interest and expertise. Permission is required.',
  },
  {
    course_code: 'EDH8225',
    course_name:
      'Curriculum and Instruction in the Context of Higher Education',
    course_desc:
      'This course prepares students to identify, develop and lead innovative strategies in teaching and learning in higher education. Students will be able to articulate the importance of student learning outcomes from multiple perspectives. Students will explore the ways in which organizational culture interfaces with student learning and will develop a critical understanding of the ways in which issues of diversity influence equity considerations in American higher education.',
  },
  {
    course_code: 'EDH8405',
    course_name: 'Law and Policy in Higher Education',
    course_desc:
      'Students will analyze contemporary legal, ethical and policy issues confronting higher education today enabling them to recognize the legal parameters around which decisions are made. Students will examine the historical, contextual and theoretical aspects of higher education law and policy as they affect students, faculty members, administrators, and organizational systems in both two- and four-year institutions.',
  },
  {
    course_code: 'EDH8505',
    course_name: 'Finance in Higher Education',
    course_desc:
      'This course approaches higher educational institutions as complex systems and analyzes the literature, topics, and recent trends in economical and financial issues in higher education for purposes of both practical application and ongoing research. The focus will be on the knowledge and skills required to effectively respond to the financial changes and trends for two and four year institutions of higher education, including fiscal planning and management, enrollment management, alumni management, grant writing, and institutional advancement/comprehensive campaigning.',
  },
  {
    course_code: 'EDH8635',
    course_name: 'Organizational Leadership and Change in Higher Education',
    course_desc:
      'This course examines leadership concepts in two and four year higher educational institutions. Areas of focus will include factors influencing strategic level decision-making, such as organizational structures and culture. Students will analyze key aspects of the change process and will be able to draw on and apply appropriate leadership strategies based on this analysis.',
  },
  {
    course_code: 'EDH8648',
    course_name:
      'Institutional Research and Outcomes Assessment in Higher Education',
    course_desc:
      'Students will explore the theoretical and practical application of institutional research as a discipline in higher education enabling them to recognize Institutional research an embedded function with direct applications in all administrative and strategic processes within two- and four-year institutions.',
  },
  {
    course_code: 'EDM3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDM4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDM6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDS5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EDS6105',
    course_name: 'Human Relations and Communication in Education',
    course_desc:
      'Theoretical and experiential framework for maximizing human relations and communication within the educational domain including principles of persuasion, public information management, effective communication strategies and personal effectiveness with staff and the public.',
  },
  {
    course_code: 'EDS6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EEC3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EEC4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EEC5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EEC6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EEE4306',
    course_name: 'Electronic Circuits II',
    course_desc:
      'Design-oriented continuation of Electronics I; feedback on am circuits and applications, digital electronics. A grade of "C" or better is required in the prerequisites.',
  },
  {
    course_code: 'EEE4306L',
    course_name: 'Electronic Circuits II Laboratory',
    course_desc:
      'Electronic Circuits II laboratory. A grade of "C" or better is required in the prerequisites. Material and Supply fee will be assessed. Credit may not be received in both EEE4306L and EEL 4306L.',
  },
  {
    course_code: 'EEE4310',
    course_name: 'VLSI Circuit Design',
    course_desc:
      'Analysis and design of digital circuits using MOS and bipolar devices.',
  },
  {
    course_code: 'EEE5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EEE6730',
    course_name: 'Special Topics in Intelligent Systems',
    course_desc:
      'In this course the student will acquire a robust understanding of the foundations and fundamental results in a specific area of interest in the field of intelligent systems. Examples include knowledge representation, Bayesian reasoning, graphical models, multi-agent systems, computational social choice, social networks, cognitive models, ethical aspects of AI, natural language processing and  human-computer interaction. This course is meant to provide a solid foundation in the area on which the student intends to focus for his/her dissertation.',
  },
  {
    course_code: 'EEE6734',
    course_name: 'Bipedal Walking Robots',
    course_desc:
      'The study of walking robots and what it means to balance. Topics include static balance/stability, dynamic balancing and the study of the fundamentals of the inverted pendulum. The course addresses a series of increasingly complex bipedal walkers and various ways to interpret stability including static stability, center of mass, center of pressure, zero moment point and capturability. Concepts include what it means to walk and how complex movement such as running and trotting are achieved, and how disturbances affect walking, such as unexpected step-downs and pushes.',
  },
  {
    course_code: 'EEE6772',
    course_name: 'Foundations of Intelligent Systems',
    course_desc:
      'The aim of this course is to provide the student with an introduction to the main concepts and techniques playing a key role in the modern arena of artificial intelligence. In addition to covering the main topics that concern modern AI, such as automated reasoning and search, particular attention will be devoted to its applications in several fields. Among the topics covered are, "What is an intelligent artificial agent?", problem solving using search and constraint satisfaction, uncertainty, Bayesian networks and probabilistic inference, reinforcement learning, multi-agent systems, ethics, as well as several additional topics which may vary from semester to semester.',
  },
  {
    course_code: 'EEL3111',
    course_name: 'Circuits I',
    course_desc: 'Basic Analysis of DC and AC electric circuits.',
  },
  {
    course_code: 'EEL3111L',
    course_name: 'Electrical Circuits Laboratory',
    course_desc:
      'Introductory electrical engineering laboratory in electrical instrumentation, devices, and systems. Material and supply fee will be assessed. Credit may not be received in both EEL 3117L and EEL 3303L.',
  },
  {
    course_code: 'EEL3112',
    course_name: 'Circuits II',
    course_desc:
      'Continuation of EEL3111 with emphasis on circuit applications of convolution, the Fourier series, and the Laplace and Fourier transforms. A grade of "C-" or better is required in the prerequisites.',
  },
  {
    course_code: 'EEL3135',
    course_name: 'Discrete-Time Signals and Systems',
    course_desc:
      'Difference equations, discrete convolutions, the z transform, discrete and fast Fourier transforms, digital processing of analog signals, sampling theorem, probability and random signals.',
  },
  {
    course_code: 'EEL3211',
    course_name: 'Basic Electric Energy Engineering',
    course_desc:
      'Introduction to the fundamentals of energy conversion; Power transformers, DC machines, Poly-phase induction machines, synchronous machines, single phase motors and permanent magnet machines, Speed control of DC motors, Speed control of ac motors.  A C is required in the prerequisites to this course.',
  },
  {
    course_code: 'EEL3211L',
    course_name: 'Electric Energy Engineering Laboratory',
    course_desc:
      'Hands on experience with fundamental devices of electric power systems such as transformers, electrical machines, power passive components, and power electronic converters as well as all measuring and recording instruments.  Lab corresponds with EEL3211.',
  },
  {
    course_code: 'EEL3472',
    course_name: 'Electromagnetic Fields and Applications I',
    course_desc:
      "Electric and magnetic fields and forces, Maxwell's equations in point and integral form, plane wave propagation, energy and power.",
  },
  {
    course_code: 'EEL3701',
    course_name: 'Digital Logic and Computer Systems',
    course_desc:
      'An overview of logic design, algorithms, computer organization, sequential circuit design, and computer engineering technology.',
  },
  {
    course_code: 'EEL3701L',
    course_name: 'Digital Logic and Computer Systems Laboratory',
    course_desc:
      'Practical applications of digital logic. Material and supply fee will be assessed.',
  },
  {
    course_code: 'EEL3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EEL4210',
    course_name: 'Smart Distribution Systems',
    course_desc:
      'Theory and practical application methods available in the industry for the protection of distribution systems and includes smart grid applications for protection and control. Covering a broad range of topics related to developments and trends in smart distribution technologies including automatic restoration, data management, cybersecurity, interoperability and standards, and future vision. Offered concurrently with EEL5291. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'EEL4213',
    course_name: 'Electric Energy Systems 1',
    course_desc:
      'System models for generators, transformers, transmission lines and large-scale power networks. Matrix formulations, power flow and analysis, symmetrical component theory, balanced and unbalanced fault analysis. A grade of "C" or better is required in the prerequisite(s).',
  },
  {
    course_code: 'EEL4241',
    course_name: 'Advanced Topics in Power Electronics',
    course_desc:
      'The course covers Advanced topics and trend in power electronics such as converters topologies for renewable energies and electric vehicles applications, Grid synchronization, power and voltage control, multilevel converters and wideband gap semiconductors. Offered concurrently with EEL5245. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'EEL4242',
    course_name: 'Power Electronic Circuits',
    course_desc:
      'Circuit topologies, analysis, design, and simulation of electronic circuits such as power supplies and motor drives. A grade of "C" or better is required in the prerequisite(s).',
  },
  {
    course_code: 'EEL4276',
    course_name: 'Cyber Security of Industrial Control System',
    course_desc:
      'This course is used to teach and share in-depth defense strategies and up-to-date information on cyber threats and mitigations for vulnerabilities with the goal of improving cyber security preparedness in the industrial control systems community. This course provides an overview of operations security for industrial control systems and prepares the students for the risks and threats associated with electric grids and other centralized and distributed control systems. Offered concurrently with EEL5277; graduate students will have additional work.',
  },
  {
    course_code: 'EEL4283',
    course_name: 'Introduction to Renewable Energy',
    course_desc:
      'The main objective of this course is to study the different types of energy sources and storages, renewable energy systems, energy distribution, energy policy and management. Computer-aided analysis of renewable energy resource information and data for evaluating energy potential and energy costs.',
  },
  {
    course_code: 'EEL4287',
    course_name: 'Future Energy Systems',
    course_desc:
      'Study and analyze renewable energy sources and their integration into the grid, microgrid, smart grid power management, plug in electric vehicles, modern energy storage technologies, energy efficient buildings, cyber security and other new technologies that are revolutionizing the power industry.',
  },
  {
    course_code: 'EEL4290',
    course_name: 'Sustainable Power Systems',
    course_desc:
      "Key technical and economic characteristics of power systems and their interaction in the design and operation of markets that foster environmental, economic, and security stability in today's complex power systems.",
  },
  {
    course_code: 'EEL4514',
    course_name: 'Communication Systems and Components',
    course_desc:
      'Theory of communication, and applications to radio, television, telephone, satellite, cellular telephone, spread spectrum, and computer communication systems. A grade of "C" or better is required in the prerequisite(s).',
  },
  {
    course_code: 'EEL4514L',
    course_name: 'Communication Laboratory',
    course_desc:
      'Experiments with communication circuits and radio frequency instruments, devices, and measurements. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'EEL4594',
    course_name: 'Introduction to Mobile Robotics',
    course_desc:
      'This is an introductory course to mobile robotics with emphasis on mobile robot models, control, planning, and navigation. The course will cover proprioceptive and exteroceptive mobile robot sensors and their processing; basic concepts of localization and mapping; Kalman filtering; design and evaluation of path tracking algorithms; planning and obstacle avoidance; intelligent control architecture.',
  },
  {
    course_code: 'EEL4603L',
    course_name: 'Introduction to KUKA Robotics',
    course_desc:
      'A hands on, laboratory based introductory course in programming robot operational tasks utilizing an industry standard controller and robot work cell.  Upon completion of this course, students may choose to take the KUKA Robot Programming and Simulation exam  and earn certification.',
  },
  {
    course_code: 'EEL4657',
    course_name: 'Linear Control Systems',
    course_desc: 'Theory and design of linear control systems.',
  },
  {
    course_code: 'EEL4657L',
    course_name: 'Linear Controls Laboratory',
    course_desc: 'Practical applications of linear control theory.',
  },
  {
    course_code: 'EEL4663',
    course_name: 'Elements of Robotics',
    course_desc:
      'An introductory course in the multidisciplinary field of robotics with analysis and design of robots and robotic tasks. Includes class projects in robot programming and design. A grade of "C-" or better is required in the prerequisite(s). Material and supply fee will be assessed.',
  },
  {
    course_code: 'EEL4712',
    course_name: 'Digital Design',
    course_desc:
      'Advanced modular logic design, design languages,finite state machines, and binary logic.  A grade of "C" or better is required in all prerequisites.',
  },
  {
    course_code: 'EEL4712L',
    course_name: 'Digital Design Laboratory',
    course_desc:
      'Design and applications of advanced digital logic using VHDL.',
  },
  {
    course_code: 'EEL4713',
    course_name: 'Digital Computer Architecture',
    course_desc:
      'The use of electronic digital modules to design computers. Organization and operation of computers.  Hardware/software trade-offs.  Design of computer interfacing.',
  },
  {
    course_code: 'EEL4744',
    course_name: 'Microprocessor Applications',
    course_desc:
      'Elements of microprocessor-based systems; hardware interfacing and software design for their application. A grade of "C" or better is required in the prerequisite(s).',
  },
  {
    course_code: 'EEL4744L',
    course_name: 'Microprocessor Applications Laboratory',
    course_desc:
      'Practical applications of microprocessor-based systems, software and hardware interface. A grade of "C" or better is required in the prerequisites. Material and supply fee will be assessed.',
  },
  {
    course_code: 'EEL4759',
    course_name: 'Digital Image Processing',
    course_desc:
      'An introduction to digital images and digital image processing techniques, including frequency and spatial image enhancement, image restoration, wavelets and morphology.',
  },
  {
    course_code: 'EEL4822',
    course_name: 'Pattern Recognition',
    course_desc:
      'An introduction to pattern recognition and classification techniques, including Bayesian classifiers, linear and non-linear classifiers, clustering, perceptrons, and feature generation/selection.',
  },
  {
    course_code: 'EEL4834',
    course_name: 'Programming for Engineers',
    course_desc:
      'Develop computer skills and art of writing good computer programs using a high level programming language like C. Examples and exercises relevant to Electrical Engineering are used.',
  },
  {
    course_code: 'EEL4888',
    course_name: 'Software/Hardware Integration',
    course_desc:
      'The course is concerned with the learning of software and hardware systems integration. Students will design and implement digital and analog systems using Arduino Mega microcontrollers, C, and C Sharp programming.',
  },
  {
    course_code: 'EEL4905',
    course_name: 'Individual Problems in Electrical Engineering',
    course_desc:
      "May be repeated with a change of content up to a maximum of 4 credits. Selected problems or projects in the student's major field of engineering study. Permission is required.",
  },
  {
    course_code: 'EEL4930',
    course_name: 'Special Topics in Electrical Engineering',
    course_desc:
      'May be repeated with change of content up to a maximum of 6 credits. Special courses covering selected topics in electrical engineering. Permission is required. A grade of "C" or better is required in the prerequisite(s). (Contact the department for prerequisites).',
  },
  {
    course_code: 'EEL4940',
    course_name: 'Engineering Internship',
    course_desc:
      'Practical and significant discipline applicable engineering based work experience under approved industrial supervision. Graded on a satisfactory / unsatisfactory basis only. Permission from department co-op advisor is required.',
  },
  {
    course_code: 'EEL4949',
    course_name: 'Co-Op Work Experience',
    course_desc:
      'Practical co-op work under approved industrial supervision. Grading is on satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'EEL5245',
    course_name: 'Advanced Topics in Power Electronics',
    course_desc:
      'The course covers Advanced topics and trend in power electronics such as converters topologies for renewable energies and electric vehicles applications, Grid synchronization, power and voltage control, multilevel converters and wideband gap semiconductors. Offered concurrently with EEL4241. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'EEL5266',
    course_name: 'Power System Operation and Control',
    course_desc:
      'An overview of modern power systems operation and control problems and solution techniques, including the current and advanced technologies and trends in development that will shape future electrical power systems.',
  },
  {
    course_code: 'EEL5267',
    course_name: 'Intelligent Systems Applications to Power Systems',
    course_desc:
      'An overview of the intelligent systems applications in power system operation. It covers applications of artificial neural networks, fuzzy systems, and heuristic search algorithms.',
  },
  {
    course_code: 'EEL5277',
    course_name: 'Cyber Security of Industrial Control System',
    course_desc:
      'This course is used to teach and share in-depth defense strategies and up-to-date information on cyber threats and mitigations for vulnerabilities with the goal of improving cyber security preparedness in the industrial control systems community. This course provides an overview of operations security for industrial control systems and prepares the students for the risks and threats associated with electric grids and other centralized and distributed control systems. This course introduces students to new developments in cyber threats, breaches and incidents in electrical grid and other industrial control systems. The course also discusses issues and methods to improve industrial security on the automation platform. Offered concurrently with EEL4276; graduate students will have additional work.',
  },
  {
    course_code: 'EEL5291',
    course_name: 'Smart Distribution Systems',
    course_desc:
      'Theory and practical application methods available in the industry for the protection of distribution systems and includes smart grid applications for protection and control. Covering a broad range of topics related to developments and trends in smart distribution technologies including automatic restoration, data management, cybersecurity, interoperability and standards, and future vision, this course will be taught as a multidisciplinary course and emphasis is placed on the importance of strong collaboration between academia, utility and industry.',
  },
  {
    course_code: 'EEL5520',
    course_name: 'Communications Networks',
    course_desc:
      'Introduction to communications networks. Design principles of communications networks, Protocols. The OSI model and layering model of networks. Physical, data link, network layers. Network topologies. Routing, multiplexing, and error detection and correction. Local Area networks (intro).',
  },
  {
    course_code: 'EEL5553',
    course_name: 'Digital Signal Processing',
    course_desc:
      'Discrete-time signals and systems. Frequency analysis of discrete-time signals and systems. Sampling and quantization. Discrete Fourier transform. Windowing effect. Z-transform. FIR and IIR Digital filters designs. Fast Fourier transform.',
  },
  {
    course_code: 'EEL5630',
    course_name: 'Digital Control Systems',
    course_desc:
      'The course introduces feedback computer-controlled systems, the components of digital control systems, and system models using the z-domain (z-transfer functions) and the time domain (state variable representations). Evaluation of system performance is studied. Discrete-time controllers are designed including PID-controllers, state and output feedback controllers, and reconstruction of states using observers.',
  },
  {
    course_code: 'EEL5654',
    course_name: 'Advanced Control Systems',
    course_desc:
      'This course is focused on the analysis, modeling, and design of advanced control systems in time and frequency domains. Implementation of control systems using continuous and digital techniques will also be covered.',
  },
  {
    course_code: 'EEL5683',
    course_name: 'Introduction to Autonomous Systems',
    course_desc:
      'This course is focused on mobile robotics with emphasis on robot control, navigation, and motion planning using kinematics and dynamics. Topics include mobile robot sensors, sensor data processing, Kalman filtering, mobile robot localization, basic concepts of mapping, path planning and obstacle avoidance, and intelligent control architecture.',
  },
  {
    course_code: 'EEL5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EEX6051',
    course_name: 'Exceptionalities',
    course_desc:
      'This course provides an introduction to special education including legislation, professional practices, trends, and research. Students will learn about characteristics and educational needs of individuals with disabilities and explore evidence-based practices that support student success.',
  },
  {
    course_code: 'EEL6042',
    course_name: 'Data Analytics and Applications to Engineering',
    course_desc:
      'An overview of Engineering data analytic techniques structured around the broad contours of the different types of data analytics, namely, descriptive, inferential, predictive, and prescriptive analytics. Mathematical approaches (such as linear algebra) and software programming will be used to develop a better intuition for machine learning and deep learning algorithms so as to ensure that a better model is developed to solve graduate level engineering problems.',
  },
  {
    course_code: 'EEL6245',
    course_name: 'Power Electronics and Utility Applications',
    course_desc:
      'This course focuses on power electronics structures and interfaces as related to various utility applications.',
  },
  {
    course_code: 'EEL6617',
    course_name: 'Multivariable Linear Control Systems',
    course_desc:
      'This course focuses on input-output and state space representation of linear continuous time dynamic systems. Topics include: analysis and synthesis techniques for multi-input/multi-output (MIMO) control systems, design and analysis of single and multi-variable feedback control systems in transform and time domain. Students will study the stability and robustness of feedback loops, while employing approaches for optimal and robust feedback control design, chiefly H2, H-infinity, and mu synthesis.',
  },
  {
    course_code: 'EEL6692',
    course_name: 'Wearable Robotics',
    course_desc:
      'An applied investigation of wearable robotics. Physical assistive devices can take many forms, but all have a foundation in mechanical design, robotics, and biomechanics. This applied course will investigate the issues and approaches for assistance in the areas of mobility, rehabilitation, strength enhancement, and injury prevention. The student will review and present the state of the art in each of these areas.',
  },
  {
    course_code: 'EEL6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EEX3070',
    course_name: 'Methods in Inclusion and Collaboration',
    course_desc:
      'This course is required for all education majors. The course provides students with background knowledge related to Special Education issues including laws and regulations, terminology, disability categories, and common educational practices. Students are also challenged to learn the skills necessary to work collaboratively within an educational environment to include students with disabilities, while meeting their individual educational, behavioral, and social needs. Evidence-based instructional and behavior strategies will also be presented.',
  },
  {
    course_code: 'EEX3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EEX4141',
    course_name: 'Teaching Students with Language and Communication Disorders',
    course_desc:
      'This course is designed to help teachers (ESE and general education) better understand the nature of speech and language development and common challenges that students may experience during their developing years. Characteristics of common speech & language problems and interventions for classroom teachers are highlighted.',
  },
  {
    course_code: 'EEX4254',
    course_name:
      'Instructional Strategies for Teaching Students with Exceptionalities',
    course_desc:
      'Through lecture, discussion, and projects, this course provides an introduction to a comprehensive knowledge base pertinent to the nature and needs of students with exceptional needs.  Course content focuses on current legislation, professional practices, trends, and research, and students will learn about and explore current evidence-based practices that support student success. Additional emphasis is placed on identifying specific instructional strategies developed for students who struggle in subject-specific content areas.',
  },
  {
    course_code: 'EEX4255',
    course_name: 'Curriculum for Teaching Students with Exceptionalities',
    course_desc:
      'This course prepares pre-service teachers to effectively utilize specialized curriculum and research-supported practices for teaching students with high incidence disabilities (learning disabilities, emotional/behavioral disorders, and intellectual disabilities) in inclusive, general education environments; to analyze and evaluate curriculum standards and resources; and to interpret assessment results to generate data-based decisions for individualized, instructional programs.',
  },
  {
    course_code: 'EEX4474',
    course_name: 'Curricula for Teaching Students with Severe Disabilities',
    course_desc:
      'This course provides an introduction to curricula pertaining to students with severe disabilities including intellectual disabilities, physical impairments, and autism. Emphasis is placed on person-centered planning, team approaches, access to the general education curriculum, integrating life skills and academic skills instruction, activity-based instruction, and community-based instruction. Course content includes curriculum and instructional strategies related to communication, motor and self-care skills.',
  },
  {
    course_code: 'EEX4772',
    course_name:
      'Personal, Social and Employment Skills for Exceptional Students',
    course_desc:
      'A primary goal of this course is building capacity with regard to identifying holistic needs, as well as strategies to promote and maximize independence, to identify career goals that are consistent with the career aptitudes and interests of children and youth. Related components of this focus include: self-awareness, self-determination, transition planning for independent living, selective placement and social skill development. Emphasis throughout is placed on identifying access points to available community, state and federal resources. A required field experience requires students to develop a Transition Plan for an at-risk youth or adult that is an application of the essential course content.',
  },
  {
    course_code: 'EEX4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EEX5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EEX6035',
    course_name: 'Best Practices in Teaching Challenging Students',
    course_desc:
      'A comprehensive overview of the exceptional student to include the knowledge, skills, and dispositions needed to be an effective teacher in the ESE classroom or inclusive education environment. Covers a broad range of topics to prepare the professional for the Florida Teacher Certification Examination for K-12 ESE. Discusses best practices as reflected in the professional literature related to effective program development and delivery for students who are at-risk or identified as needing special educational services.',
  },
  {
    course_code: 'EGN6975',
    course_name: 'Thesis',
    course_desc:
      "Design, research, and presentation of a master's thesis under the direction of a faculty committee.",
  },
  {
    course_code: 'EEX6225',
    course_name: 'Assessment of Exceptional Children',
    course_desc:
      'This assessment course is designed for graduate students in Teacher Education and focuses on an analysis of the professional literature to determine best practices in assessment. Topics include (1) measurement issues to determine assessment quality; (2) an examination of effective assessment practices with children who are exceptional; ( 3) issues involving the interpretation of test scores; (4) best practices in assessment; and (5) best practices in linking assessment to instruction.\nCredit may not be awarded for both EEX6225 and EEX 6227.',
  },
  {
    course_code: 'EEX6612',
    course_name: 'Behavior Management',
    course_desc:
      'Provides a comprehensive knowledge base concerning behavior management including structuring the classroom for success, assessing and managing individuals and group behavior, and motivating and managing exceptional and at-risk students.',
  },
  {
    course_code: 'EEX6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EEX7905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EGI4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EGI5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EGI6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EGM2500',
    course_name: 'Engineering Mechanics-Statics',
    course_desc:
      'Covers basic aspects of reduction of force systems, equilibrium of particles and rigid bodies, vector methods, and application to structures and mechanisms.',
  },
  {
    course_code: 'EGM3344',
    course_name: 'Numerical Methods',
    course_desc:
      'Programming fundamentals, interpolation, curve fitting, optimization, computations with series, numerical integration, and the numerical solution of algebraic, transcendental, simultaneous and differential equations.',
  },
  {
    course_code: 'EGM3401',
    course_name: 'Engineering Mechanics-Dynamics',
    course_desc:
      'Dynamics of particles and rigid bodies for rectilinear translation, curvilinear motion, rotation and plane motion. Principles of work and energy, impulse and momentum.',
  },
  {
    course_code: 'EGM4313',
    course_name: 'Intermediate Engineering Analysis',
    course_desc:
      'Engineering applications of linear algebra, vector differential, calculus (including the concepts of gradient, divergence, and curl), complex variables (and functions of complex variables), and fourier series and transforms.  Engineering applications of statistics.',
  },
  {
    course_code: 'EGN2911L',
    course_name: 'Sophomore Engineering Design I',
    course_desc:
      'First course in a sophomore engineering design sequence. Students work in teams with other engineering design students in an active, discovery based learning environment employing practice based learning.',
  },
  {
    course_code: 'EGN2912L',
    course_name: 'Sophomore Engineering Design II',
    course_desc:
      'Second course in a sophomore engineering design sequence. Students work in teams with other engineering design students in an active, discovery based learning environment employing practice based learning.',
  },
  {
    course_code: 'EGN3204',
    course_name: 'Engineering Software Tools',
    course_desc:
      'Gives students an introduction to important Engineering software tools such as MATLAB, Labview, MATHCAD, and FSPICE.',
  },
  {
    course_code: 'EGN3365',
    course_name: 'Engineering Materials',
    course_desc:
      'Fundamentals in structure, properties, and mechanical behavior of engineering materials.',
  },
  {
    course_code: 'EGN3613',
    course_name: 'Principles of Engineering Economy',
    course_desc:
      'Provides students with a broad-based understanding of finance, cash flow, and economic decision making practices. Addresses the principles and techniques needed for making economic decisions about building systems and subsystems. Explores decision making techniques pertaining to cost and value engineering. Emphasis will be placed on the time-value of money and equivalence, replacement analysis, uncertainty and life cycle costing.',
  },
  {
    course_code: 'EGN3913L',
    course_name: 'Junior Engineering Design I',
    course_desc:
      'First course in a junior engineering design sequence. Students work in teams with other engineering design students in an active, discovery based learning environment employing practice based learning. This course may be a continuation of the project from the Sophomore Engineering Design, or may be a starting point for Juniors who are new to the program (Students without Sophomore Engineering Design must receive permission from their adviser).',
  },
  {
    course_code: 'EGN3914L',
    course_name: 'Junior Engineering Design II',
    course_desc:
      'Continuation of a Junior engineering design sequence. Students work in teams with other engineering design students in an active, discovery based learning environment employing practice based learning. This course is repeatable for elective credit with permission of the instructor.',
  },
  {
    course_code: 'EGN4950',
    course_name: 'Capstone Design I',
    course_desc:
      'Preliminary work on senior design project.  This portion of the senior design will focus on the objectives and criteria, synthesis, and analysis elements of project development.  After developing design concepts, researching for implementation methods, and performing a feasibility study (which will include economic, social, ethical, etc., factors), the semester will culminate with a senior design project proposal and presentation.',
  },
  {
    course_code: 'EGN4952L',
    course_name: 'Capstone Design II',
    course_desc:
      'Continuation of Capstone Design I, with emphasis on construction, testing, and evaluation elements of project development.  Material and Supply fee will be assessed.  Permission is required.',
  },
  {
    course_code: 'EGN6429',
    course_name: 'Principles of Engineering Analysis',
    course_desc:
      'This course will cover topics in advanced engineering analysis, including linear algebra, partial differential equations, Fourier series, complex variables, and vector calculus with numerical techniques.',
  },
  {
    course_code: 'EGN6960',
    course_name: 'Engineering Project',
    course_desc:
      'Capstone course for Masters of Engineering students who do not elect the thesis option. Students will define and carry out a project that shows mastery of some topic in Engineering and produces a final product.',
  },
  {
    course_code: 'EGS1006',
    course_name: 'Introduction to Engineering',
    course_desc:
      'Introduces the student to engineering topics and guides the student toward Electrical and Computer Engineering at UWF. Students get the opportunity to interact with current engineering students and practicing engineers from various engineering fields. The student also participates\nin a hands-on design component. The goal of the class is to help the student make an informed choice about career alternatives.',
  },
  {
    course_code: 'EGS3441',
    course_name: 'Engineering Statistics',
    course_desc:
      'Survey of the basic concepts in probability and statistics with engineering applications. Topics include probability, discrete and continuous random variables, estimation, hypothesis testing and linear and multiple regression.',
  },
  {
    course_code: 'EGS4032',
    course_name: 'Professional Ethics',
    course_desc:
      'An interactive study of ethics, theory and the development of professionalism. Case studies of ethical conflicts in engineering practice. Covers engineering codes of ethics and requires students to resolve theoretical situations through application of ethical codes.',
  },
  {
    course_code: 'EIN4354',
    course_name: 'Engineering Economy',
    course_desc:
      'Basic principles and applications of economic decision making between alternatives encountered in engineering systems projects. The analysis will include methodologies of economics and finance in addition to engineering fundamentals. Upper division classification in engineering is required.',
  },
  {
    course_code: 'EME2040',
    course_name: 'Introduction to Educational Technology',
    course_desc:
      'Assists educators in developing skills and competencies which are essential to the integration of technology into the delivery of classroom instruction. Students will survey a wide variety of instructional technology materials and systems. They will also learn to use these tools in a classroom environment.',
  },
  {
    course_code: 'EME3002',
    course_name: 'Intelligence and National Security',
    course_desc:
      'Students will develop an academic understanding of national security and the government agencies that are responsible for protecting the United States and its interests. Students will learn about the intelligence cycle, national security decision making, and the intelligence community and review case studies of intelligence in action. Students will also become familiar with analytic writing and intelligence analysis through case studies and weekly assignments of current national security news.',
  },
  {
    course_code: 'EME3003',
    course_name: 'Open Source Intelligence',
    course_desc:
      'Provides students with an academic and practical understanding of Open Source Intelligence (OSINT) and its applications. Students will learn about Open Source Intelligence as a discipline, its place in the intelligence world, and OSINT planning and execution. Students will become familiar with OSINT acquisition and exploitation techniques by developing an understanding of available technological tools and capabilities.',
  },
  {
    course_code: 'EME3233',
    course_name: 'Technology Integration Planning',
    course_desc:
      'Provides students with the knowledge, skills, abilities, and attitudes necessary to implement instructional technology. Students will learn to identify the constraints and risks associated with instructional technology planning and implementation. Students will utilize software tools associated with the implementation of instructional technology.',
  },
  {
    course_code: 'EME3312',
    course_name: 'Technology Supported Learning',
    course_desc:
      'Examines the use of current and emerging technologies to facilitate learning.  Topics covered will include distance learning, formal and informal technology based learning and mobile learning. Strategies for integrating technology in educational settings will be explored.',
  },
  {
    course_code: 'EME3351',
    course_name: 'Introduction to Instructional and Performance Technology',
    course_desc:
      'The distinct purposes of instructional technology and human performance technology are explored in depth in this course. The foundations and evolution of each discipline serve to establish distinct definitions that will be investigated. The similarities and differences will be compared to include the historical basis, models, major tasks, and desired outcomes.',
  },
  {
    course_code: 'EME3410',
    course_name: 'Emerging Technology in the Classroom',
    course_desc:
      'Examines specific methods for integrating technology (hardware and software) into subject area curricula in the classroom. Students will explore models of technology integration, classroom management and administrative tasks that can be performed more efficiently using technology, and learn strategies to select appropriate mediums when planning for technology integration. Individualization will allow each student to select and develop materials in their disciplines.',
  },
  {
    course_code: 'EME3624',
    course_name: 'Training Needs Assessment',
    course_desc:
      'Examines the role of training needs assessment in instructional design.  Students will be introduced to techniques used to collect and analyze data to identify and clarify training needs.  Prepares students to employ needs assessment techniques to determine who needs to learn what and why prior to engaging in the design and development of instructional materials.',
  },
  {
    course_code: 'EME3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EME4001',
    course_name: 'HUMINT Operations',
    course_desc:
      'Students will learn the importance of human originated information, or HUMINT, in the context of law enforcement, military and intelligence operations. Students will learn about interview, interrogation and elicitation techniques that are employed within the law enforcement and national security communities. Students will be able to recognize and describe the difference between overt and clandestine source operations and when HUMINT should and should not be utilized in the pursuit of legal or national security priorities. Students will also be able to assess basic psychological indicators in the profiling of historic espionage cases and their impact on national security.',
  },
  {
    course_code: 'EME4043',
    course_name: 'Instructional Technology Leadership',
    course_desc:
      'Students will examine the role of the technology leader in effective integration, management and use of technology in a variety of settings, including education, training, military, public sector and non-profits. The course focuses on technology, information, and information literacy.  Special attention is paid to the role of systems thinking in effective technology leadership. Offered concurrently with EME5316, graduate students will have additional work.',
  },
  {
    course_code: 'IDH4039',
    course_name: 'Honors Seminar: Topics X',
    course_desc:
      'Specific Topics will vary; see the Director of the University Honors Program for current offerings. Enrollment in Honors Seminars is by permission of the Director of the Honors Program only.',
  },
  {
    course_code: 'EME4083',
    course_name: 'Program Evaluation in Instructional Design and Technology',
    course_desc:
      'Students will develop skills used in selecting the appropriate model for conducting various types of evaluations. A series of models will be reviewed and aligned with evaluation purposes and questions. Applying the appropriate evaluation model is critical to ensuring that interventions, programs, and projects are successful. Development of a comprehensive evaluation plan will provide students with the opportunity to align an evaluation model with data collection strategies and techniques for a specific evaluation purpose.',
  },
  {
    course_code: 'EME4343',
    course_name: 'Multimedia Design and Development',
    course_desc:
      'The basic visual and typographical elements and technical aspects of multimedia design and development to support learning are the focus of this course. Students will apply instructional design strategies and principles of multimedia learning to the design and development of multimedia. Included are a selection of software applications and services, design principles, hands-on production, and discussion of issues and useful resources.',
  },
  {
    course_code: 'EME4350',
    course_name: 'Human Performance Technology',
    course_desc:
      'Students are introduced to the field of Human Performance Technology (HPT).  Through examination of the research, theories and models associated with HPT, students will be prepared to conduct comprehensive performance, gap and cause analyses in organizations, and identify training and non-training based solutions to resolve organizational performance concerns.',
  },
  {
    course_code: 'EME4352',
    course_name: 'HPT Intervention Selection and Design',
    course_desc:
      'Human Performance Technology (HPT) interventions are selected to resolve gaps in desired performance. The skills required to align interventions with the cause(s) of the problem are the focus of this course. Students will classify interventions using various models of Human Performance Technology and select potential interventions to resolve identified problems in human performance scenarios. Students will also develop a formal proposal to communicate recommendations to stakeholders.',
  },
  {
    course_code: 'EME4474',
    course_name: 'Technical Intelligence Collection',
    course_desc:
      'Introduces students to intelligence disciplines (ELINT, SIGINT, MASINT, GEOINT) and intelligence organizations (NSA, NGA, NRO and DIA). Students will examine the history of these organizations, technologies used in each intelligence discipline, and common uses of each technology. The course focuses on improving analytical writing and research skills in the intelligence discipline.',
  },
  {
    course_code: 'EME4673',
    course_name: 'Foundations of Instructional Design',
    course_desc:
      'Introduces students to the field of instructional design, a systemic and systematic, research-based means of designing effective, efficient, learner focused instruction.  Students will use the ADDIE process to design a lesson.',
  },
  {
    course_code: 'EME4674',
    course_name: 'Development of Instructional Materials',
    course_desc:
      'The pedagogical, technical, and logistical aspects of instructional messages will provide the foundation for students to learn the fundamentals of instructional development in this course. Message design principles and individual preferences are considered as they relate to the development of instructional materials. Media and technology aspects relating to effective message delivery will be addressed and related to the logistical constraints of time and cost.',
  },
  {
    course_code: 'EME4684',
    course_name: 'Instructional Design and Technology Capstone',
    course_desc:
      'The capstone is designed to enable students to demonstrate mastery of the Instructional Design and Technology knowledge, skills, and abilities developed during the academic program. Students will identify, propose, and complete a capstone project and develop an electronic portfolio highlighting their attainment of the program level learning outcomes. Permission is required.',
  },
  {
    course_code: 'EME4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EME5316',
    course_name: 'Instructional Technology Leadership',
    course_desc:
      'Students will examine the role of the technology leader in effective integration, management and use of technology in a variety of settings, including education, training, military, public sector and non-profits. The course focuses on technology, information, and information literacy.  Special attention is paid to the role of systems thinking in effective technology leadership. Offered concurrently with EME4043, graduate students will have additional work.',
  },
  {
    course_code: 'EME5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EME6054',
    course_name: 'Foundations of Instructional Technology',
    course_desc:
      'Students investigate theoretical, historical, sociological, and philosophical perspectives and applications of instructional technology in education and training environments. Students develop the knowledge, skills, and abilities needed to integrate instructional technology theories and processes into education and training settings.   Students are introduced to the theoretical and philosophical foundations of the field, and they are empowered to develop a comprehensive definition of the field and a broad perspective of IT on educational and training settings.',
  },
  {
    course_code: 'EME6062',
    course_name: 'Applied Instructional Technology Investigations',
    course_desc:
      'This course provides an introduction to past, present, and future instructional technology research. Research paradigms and underlying theory appropriate for IT are emphasized. Quantitative, qualitative, and mixed methods research designs and appropriate data analysis techniques are explored.',
  },
  {
    course_code: 'EME6317',
    course_name: 'Instructional Technology for Educational Leaders',
    course_desc:
      'This course provides future technology leaders with the basic terminology, historical perspectives, theoretical basis, research and practical application of instructional technology to enable them to be empowered persons and professionals who work in educational settings. This course builds knowledge and skills to assist school and district leaders in using and applying instructional technology planning and management techniques to real-world situations. Upon completion of the course, students will have the ability to use instructional technology for administrative and instructional purposes and to plan, organize, and promote its use in PK-12 educational environments.',
  },
  {
    course_code: 'EML5570',
    course_name: 'Principles of Fracture Mechanics',
    course_desc:
      'This course will investigate topics related to fracture analysis of mechanical structures. Topics include brittle and ductile fracture, linear elastic fracture mechanics and determination of stress intensity, elastic-plastic fracture, J-integral, and fatigue failure.',
  },
  {
    course_code: 'EME6408',
    course_name: 'Integrated Technology Learning Environments',
    course_desc:
      'The skills and abilities necessary in planning for the integration of technology into educational and training environments are the focus of this course. Students will develop a technology integration plan for a real-world scenario through the application of the major practices and models of technology integration.',
  },
  {
    course_code: 'EME6409',
    course_name: 'Distance Learning Implementation',
    course_desc:
      'Integrates theory and best practices to explore and develop skills for developing and implementing effective education and training environments delivered via distance learning media. Students will focus on the principles and practices that are research-based and result in quality distance learning experiences, and students will explore technologies available to support and distribute distance learning and the considerations unique to distance learning.  The course focuses heavily on online environments, and it emphasizes application of the best practices by enabling students to develop and implement their own instructional lessons that are delivered via distance learning technologies.',
  },
  {
    course_code: 'EME6414C',
    course_name: 'Web-Based Instructional Tools for Educators',
    course_desc:
      'Provides students with the knowledge and skills necessary to design and develop web-based instruction using current authoring software and services. The course integrates theory and application. Students will learn to critically examine the instructional capabilities of various technologies and identify instructional strategies that support integration. Students will design and develop multiple units of instruction that demonstrate their ability to author courseware.',
  },
  {
    course_code: 'EME6415',
    course_name: 'Digital Video for Instruction',
    course_desc:
      'Principles of instructional video design and development including designing for learning objectives, effective audio and lighting techniques, video recording, editing, and delivery will be taught. Students will explore the opportunities and technical challenges associated with web-based video as a communication medium.  Practical application projects are an integral part of the learning experience as students explore all aspects of instructional video pre-production, production,\nand post-production.',
  },
  {
    course_code: 'EME6426',
    course_name: 'HPT Interventions',
    course_desc:
      'Human Performance Technologists, the education and training leaders in organizations, identify gaps between desired and actual employee performance levels. Once the gaps have been identified, the HPT practitioner determines interventions or combinations of interventions that are needed to close those gaps. These interventions consist of instructional and non-instruction solutions that educators and trainers design and develop that, in turn, solve organizational performance problems.',
  },
  {
    course_code: 'EME6427',
    course_name: 'Implementing HPT Interventions',
    course_desc:
      'Provides students with fundamental knowledge and skills related to the intervention implementation and change management activities associated with the practice of Human Performance Technology (HPT).  Examines models of change management, the role of the change agent and the importance of developing and implementing effective change management plans to insure successful intervention implementation and institutionalization.',
  },
  {
    course_code: 'EME6428',
    course_name: 'Evaluating HPT Interventions',
    course_desc:
      'Students will examine the theory and practice of evaluation models and processes as they relate to the formative, summative and confirmative evaluation of instructional and non-instructional HPT interventions. Students will develop the knowledge, skills and abilities necessary to plan and conduct comprehensive evaluations based on best practices.',
  },
  {
    course_code: 'EME6429',
    course_name: 'Human Performance Improvement',
    course_desc:
      'Provides students with fundamental knowledge and skills related to the performance, gap and cause analysis activities associated with the practice of Human Performance Technology (HPT).  Examines the importance of systems thinking in HPT and the theories and theorists of the field.',
  },
  {
    course_code: 'EME6458',
    course_name: 'Distance Learning Policy and Planning',
    course_desc:
      'Examines the history of distance learning and the principles, policies and issues related to the design, development, implementation and administration of distance learning courses and programs in various settings.  Issues related to technology, teaching, learning, assessment and faculty and student preparation will be considered from both theoretical and practical perspectives.',
  },
  {
    course_code: 'EME6607',
    course_name: 'Implementation of Instructional Technology Projects',
    course_desc:
      'Provides students with the knowledge, skills, abilities, and attitudes necessary to provide leadership in the implementation of instructional technology. Students will learn to identify the constraints and risks associated with instructional technology planning and implementation and develop ways to manage these factors.  Students will utilize software tools to manage the implementation of an instructional technology project.',
  },
  {
    course_code: 'EME6609',
    course_name: 'Principles of Instructional Design',
    course_desc:
      'Learners will apply a systems approach to the instructional design process.  Theoretical underpinnings and practical applications for instructional design will ground the course. Students will apply a research-based model and best practices to design a pedagogically sound instructional product.',
  },
  {
    course_code: 'EME6626',
    course_name: 'Emerging and Innovative Technology Systems',
    course_desc:
      'New technology and approaches to teaching and learning evolve and revolutionize how professionals approach technology integration. Explore how innovation and new technologies can be used in instructional strategies to promote performance and learning.',
  },
  {
    course_code: 'EME6678',
    course_name: 'Theoretical Foundations of Instructional Design',
    course_desc:
      'Students will examine the key components of the instructional system and the theoretical perspectives that inform the practice of instructional design.  The role of communication theories, learning theories, and instructional theories, and the overarching concept of alignment in instructional design will be explored.',
  },
  {
    course_code: 'EME6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EME6946',
    course_name: 'Instructional Design and Technology Capstone',
    course_desc:
      'Students critique the academic program, identifying their key learning outcomes, and the courses and specific instructional strategies that led to those outcomes. Students identify, propose, and complete a complex project, integrating knowledge, skills, and abilities developed in multiple classes to solve an instructional or performance related problem in a real organization. Permission is required.',
  },
  {
    course_code: 'EME7015',
    course_name: 'Analysis in Human Performance Technology',
    course_desc:
      'Students investigate the role of analysis in Human Performance Technology and examine theories, models, and philosophical perspectives related to the performance, gap, and cause analysis processes that guide the practice of HPT. Students will integrate theory and practice to design theoretically sound analysis plans to identify root causes of organizational performance issues in various settings.',
  },
  {
    course_code: 'EME7067',
    course_name: 'Technology Leadership in Performance Improvement',
    course_desc:
      'Students will investigate the role of a technology leader in identifying performance problems and solutions in various settings. Explorations will include researching the impact technology has on resolving performance problems at different levels, applying technologies available, determining which technology is most appropriate for given situations, and deciding how to effectively use the technology to support performance. Special focus will be given to systems thinking.',
  },
  {
    course_code: 'EME7068',
    course_name: 'Technology-Based Learning Theory and Research',
    course_desc:
      'Students develop a comprehensive picture of the research and theory related to the field of technology-based learning. Theoretical, historical, empirical, and philosophical perspectives are investigated as students delve into the various aspects of technology-based learning and related research. Students learn to critically analyze how theory and research influence practice.',
  },
  {
    course_code: 'EME7075',
    course_name: 'Distance Learning Design and Development Leadership',
    course_desc:
      'Students will develop a systems perspective of the design and development of distance learning, exploring the associated risks and constraints and ways to mitigate these risks and constraints, particularly with regard to planning for distance learning. Students will investigate the processes and best practices associated with designing and developing distance learning and will develop skills and knowledge to provide leadership in distance learning.',
  },
  {
    course_code: 'EME7079',
    course_name: 'Distance Learning Implementation and Evaluation',
    course_desc:
      'Students will develop the knowledge and skills to be leaders in the implementation of distance learning into educational and training environments. As part of this process, students will develop a plan for implementing and evaluating distance learning and will consider all needed aspects of this kind of plan, including human and financial resources. Students will take a systems approach to implementing and evaluating distance learning, considering the impact of the implementation on the system.',
  },
  {
    course_code: 'EME7353',
    course_name: 'Leading Intervention Implementation and Evaluation',
    course_desc:
      'Students examine strategies for leading the implementation and evaluation of Human Performance Technology interventions. Students will analyze change management and evaluation models and develop the skills necessary to select and implement appropriate approaches to facilitate intervention implementation and evaluation efforts aligned with the planned change, the available resources, and the constraints of the organization.',
  },
  {
    course_code: 'EME7357',
    course_name: 'Intervention Selection, Design and Development Leadership',
    course_desc:
      'Students will critically examine a wide range of potential performance improvement interventions to determine which solutions are best suited for various situations. Students will focus on aligning solutions with identified problems and organizational constraints and effectively communicating recommendations to stakeholders. Students will apply research, theory, and best practices to lead intervention design and development projects.',
  },
  {
    course_code: 'EME7365',
    course_name: 'Performance Improvement Theory and Research',
    course_desc:
      'Students examine the theoretical and conceptual foundations of the field of Performance Improvement through a comprehensive review and critical examination of the literature of the field. Students will develop knowledge, skills, and abilities necessary to apply research and theory to practice to improve organizational performance.',
  },
  {
    course_code: 'EME7366',
    course_name: 'Data Collection in Performance Improvement',
    course_desc:
      'Examines data types and collection methods, sources, and instrumentation. Examines how, when, and why to collect quantitative and qualitative data for performance improvement projects. Critically investigates researcher bias, reflexivity, and positionality when conducting data collection for performance improvement research.',
  },
  {
    course_code: 'EME7367',
    course_name: 'Data Analysis in Performance Improvement',
    course_desc:
      'Examines the various types of data analysis consistent with improvement science. Appropriate qualitative and quantitative data analysis procedures and alignment with research questions and study purposes are addressed in this course.',
  },
  {
    course_code: 'EME7609',
    course_name: 'Principles of Instructional Systems Design',
    course_desc:
      'Students will examine the use of instructional systems design models to create instruction that is appropriate from a pedagogical and practical viewpoint. Theories and models to support the design of instruction for use in a variety of instructional formats will be emphasized. Focus areas will include analysis, instructional goals and objectives, assessment, instructional strategies and the role of formative evaluation in instructional design. Students will apply theories and best practices to design a pedagogically sound instructional product.',
  },
  {
    course_code: 'EME7618',
    course_name: 'Instructional Design and Technology Research',
    course_desc:
      'This course provides an introduction to the design of research studies in the field of instructional design and technology. Aspects of research design and associated methodologies will be explored. Critical analysis of the research literature will highlight trends for problems and issues warranting further investigation. The quality and rigor of research will be emphasized, including research validity, methods of data collection and analysis, conclusions drawn from evidence, and ethical standards.',
  },
  {
    course_code: 'EME7676',
    course_name: 'Theoretical Foundations of ID, IT, and PT',
    course_desc:
      'Examination of the theoretical foundations of the fields of instructional design, instructional technology, and performance technology.  Students will research, discuss, and critique systems, communication, and learning theories and their relationships to instructional and performance technology research and practice.  Students will develop the knowledge, skills, and abilities necessary to select and apply appropriate theories to solve instructional and performance technology related problems.',
  },
  {
    course_code: 'IDH4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EME7685',
    course_name: 'Research-based Models of ID, IT, and PT',
    course_desc:
      'Examination of the research-based models that guide practice in the fields of instructional design, instructional technology, and performance technology. Students will research, discuss, and critique instructional design models, technology integration models, and performance technology models and their applications. Students will develop the knowledge, skills, and abilities necessary to select and apply appropriate models to solve instructional and performance technology related problems.',
  },
  {
    course_code: 'EME7692',
    course_name: 'Doctoral Seminar-Leading Performance Improvement Projects',
    course_desc:
      'Focuses on the development of the skills necessary to effectively lead instructional and non-instructional performance improvement projects. Critical skills included in the course and related residency include leading projects and change initiatives, facilitating organizational communication, ethical behavior, and social justice. Coursework will also provide students with opportunities to continue to develop skills in critical thinking, scholarly research, and professional writing.',
  },
  {
    course_code: 'EME7695',
    course_name: 'Applied Research in IDT',
    course_desc:
      'This course will prepare students to conduct applied research in organizational settings. Students will examine the concepts, processes, and components of applied research, including actionable problems of practice and the application of improvement science as a research methodology. Applied research is presented as a disciplined process of inquiry for the dissertation in practice.',
  },
  {
    course_code: 'EME7905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EME7938',
    course_name: 'IT Research Design Seminar',
    course_desc:
      'Provides Instructional Technology advanced graduate students with the opportunity to conduct an in-depth examination of the processes and procedures in applied IT research, specifically as related to the dissertation process. Students explore how to determine appropriate topics for IT research, format and style for research publications, strategies for conducting literature reviews, hypotheses, a research design, and appropriate statistical application.',
  },
  {
    course_code: 'EME8608',
    course_name: 'IDT Foundations, Issues and Trends',
    course_desc:
      'Students examine the history and evolution of the field of instructional design and technology and its three major areas of emphasis; instructional design, instructional technology, and performance technology.  Students will also analyze current issues and trends influencing the field and their impact on research and practice.  This course focuses heavily on research, critical thinking, and communication skills.',
  },
  {
    course_code: 'EME8609',
    course_name: 'IDT Research Design',
    course_desc:
      'Students should enroll in this course after successfully completing the Coursework Capstone Experience. This course guides students through the development of the dissertation-in-practice proposal. Students will work with the instructor and peers to identify an appropriate research opportunity and design the key components of the study, preparing them to work with their individual committees throughout the remainder of the program to develop and defend a proposal, conduct a study, and finalize and defend the dissertation.',
  },
  {
    course_code: 'EME8693',
    course_name:
      'Doctoral Seminar-Analysis and Dissemination of Performance Impvmt Research',
    course_desc:
      'Critically examines the types of written reports and oral presentations practitioner-scholars use to communicate findings and recommendations to stakeholders. Students will learn how to tailor written and oral communications to meet the culture of the organization and the information needs of the audience. This course includes a residency requirement to be held on campus in Pensacola, during which students will defend deliverables one and two of the dissertation-in-practice.',
  },
  {
    course_code: 'EME8695',
    course_name: 'Doctoral Seminar-Ed.D. Capstone',
    course_desc:
      'This seminar serves as the culminating experience for students enrolled in the Instructional Design and Technology Ed.D. program. Students will demonstrate attainment of program level learning outcomes and present and defend the final dissertation-in-practice. The course will be presented primarily online; however, it will also include the third and final on-campus residency.',
  },
  {
    course_code: 'EME8905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EME8980',
    course_name: 'Dissertation',
    course_desc:
      "Major individual research in an area of significant educational interest; designed specifically for candidates in the Ed.D. Curriculum and Instruction, Instructional Technology program. The dissertation reflects intensive educational research produced by the student and collaboratively developed with the student's graduate committee. Graded on a satisfactory / unsatisfactory basis only. Admission to candidacy, completion of all other doctoral program requirements and permission is required.",
  },
  {
    course_code: 'EME8981',
    course_name: 'Dissertation in Practice-Phase 1',
    course_desc:
      'Under the supervision of the dissertation-in-practice committee chair, students will use feedback received during the defense of deliverables one and two during EME8693 to modify their applied research intervention recommendations. Upon approval of the modifications by the dissertation-in-practice chair and organizational stakeholders, students will design and develop the planned performance improvement interventions. Students will demonstrate ethical research practices and effective communication in all interactions. Students must complete EME8693 with a minimum grade of B prior to enrolling in this class.',
  },
  {
    course_code: 'EME8982',
    course_name: 'Dissertation in Practice-Phase 2',
    course_desc:
      'Under the supervision of the dissertation-in-practice committee chair, students will pilot test, modify, and implement applied research interventions aligned with a previously identified problem of practice. Students will demonstrate ethical research practices and effective communication in all interactions with clients. Students must successfully complete EME8981, where they will design and develop their approved interventions, prior to enrolling in this class.',
  },
  {
    course_code: 'EML6237',
    course_name: 'Advanced Solid Mechanics',
    course_desc:
      'This course covers stress analysis of mechanical structures. Topics include unsymmetrical bending, three-dimensional stress-strain, torsion, rotational stress, thin walled pressure vessels, beams on elastic foundations, and stress concentrations.',
  },
  {
    course_code: 'IDH4970',
    course_name: 'Honors Thesis',
    course_desc:
      'Capstone project for University Honors Program. Formal presentation of research / creative activity. Open to Honors students only. Graded on satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'EME8983',
    course_name: 'Dissertation in Practice-Phase 3',
    course_desc:
      'Under the supervision of the dissertation-in-practice committee chair, students will collect and analyze quantitative and qualitative data to evaluate the impact of their applied research interventions on the previously identified problem of practice. Students will demonstrate ethical research practices and effective communication in all interactions. Students must successfully complete dissertation-in-practice phases one and two (EME8981 and EME8982) prior to registering for this course. Final defense of the dissertation-in-practice, including reporting of findings, conclusions, and recommendations identified in this course, will take place during the residency portion of EME8695.',
  },
  {
    course_code: 'EME8984',
    course_name: 'Dissertation in Practice-Continuation',
    course_desc:
      'Facilitates continuous enrollment for students who have completed all required coursework without successfully defending the dissertation-in-practice and/or meeting other graduation requirements. Students enrolled in this course will work with their dissertation-in-practice committee chair to complete all remaining requirements to successfully graduate.',
  },
  {
    course_code: 'EML3011',
    course_name: 'Mechanics of Materials',
    course_desc:
      'Strength and elastic deflection of engineering materials due to loads applied axially, in torsion, in bending, and in shear. Combined stresses and principal stresses. Applications to design of beams and shafts. Computer simulation of stress under loading.',
  },
  {
    course_code: 'EML3015',
    course_name: 'Thermal Fluid Systems I',
    course_desc:
      'Introduction to thermodynamics including the first and second laws of thermodynamics as well as power and refrigeration cycles. Fundamentals of heat transfer including an introduction to conduction, convection, and radiation.',
  },
  {
    course_code: 'EML3016',
    course_name: 'Thermal Fluid Systems II',
    course_desc:
      'Further study of thermal fluid systems including an introduction to fluid mechanics. Fluid statics, Bernoulli and energy equations, open and closed flow, drag and lift. Heat transfer via convection and radiation.',
  },
  {
    course_code: 'EML3016L',
    course_name: 'Thermal Fluid Systems II lab',
    course_desc:
      'Laboratory experiments related to thermodynamics, fluid mechanics, and heat transfer. Thermal systems measurement devices, performance characteristics and design of engineering experiments.',
  },
  {
    course_code: 'EML3022',
    course_name: 'Computer Aided Design and Modeling',
    course_desc:
      'Introduction to industry standards for graphical representation of objects and simulation of processes utilizing 2D presentations and 3D modeling.',
  },
  {
    course_code: 'EML3172L',
    course_name: 'Mechanics of Materials lab',
    course_desc:
      'Laboratory experiments in materials science, material processing, material stress, strain and bending.',
  },
  {
    course_code: 'EML3500',
    course_name: 'Machine Design',
    course_desc:
      'Design of machine elements including fasteners, bearings, gears and other power transmission components.',
  },
  {
    course_code: 'EML4081',
    course_name: 'Non-Destructive Evaluation',
    course_desc:
      'Non-destructive evaluation (NDE) techniques with emphasis on recent advancements in the field. Introduction to the field of NDE. Overview of common NDE techniques, such as visual inspection, eddy current, X-ray, and ultrasonics. Recent development and research areas in NDE.',
  },
  {
    course_code: 'EML4225',
    course_name: 'Dynamic Systems',
    course_desc:
      'Introduction to modeling and control of dynamic physical systems, vibration analysis, and design of control systems.',
  },
  {
    course_code: 'EML4321',
    course_name: 'Manufacturing Processes',
    course_desc:
      'An integrated treatment of the analysis of traditional and non-traditional manufacturing processes.',
  },
  {
    course_code: 'EML4722',
    course_name: 'Computational Fluid Dynamics',
    course_desc:
      'Fluid kinematics, differential formulation of conservation laws for fluid mechanics, numerical schemes for discretizing differential equations, turbulence models, simulation of laminar and turbulent flows using modern tools.',
  },
  {
    course_code: 'EML4804',
    course_name: 'Mechatronic Systems',
    course_desc:
      'This course introduces and demonstrates the synergistic combination of mechanical engineering, electrical and electronics engineering, control engineering, and programming to solve engineering problems and build intelligent systems.',
  },
  {
    course_code: 'EML4804L',
    course_name: 'Mechatronic Systems lab',
    course_desc:
      'This is an introduction to Mechatronics by lab experience for interfacing of mechanical and electrical systems. It provides instruction and practical exercises in C programming, microcontroller programming, interfacing with sensors and actuators, data acquisition, communication, and closed-loop control.',
  },
  {
    course_code: 'EML4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EML4930',
    course_name: 'Special Topics in Mechanical Engineering',
    course_desc:
      'Special courses covering selected topics in mechanical engineering.',
  },
  {
    course_code: 'EML4940',
    course_name: 'Engineering Internship',
    course_desc:
      'Practical and significant discipline applicable engineering based work experience under approved industrial supervision. Graded on a satisfactory / unsatisfactory basis only. Permission from department co-op advisor is required.',
  },
  {
    course_code: 'EML4948',
    course_name: 'Co-Op Work Experience',
    course_desc:
      'Practical co-op work under approved industrial supervision. Grading is on satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'EML5546',
    course_name: 'Composite Materials',
    course_desc:
      'This course is an introduction to composite materials and their applications. Properties and microstructure of high-strength fiber materials (glass, carbon, polymer, ceramic fibers) and matrix materials (polymer, metal, ceramic, and carbon matrices) will be analyzed. Additionally, specific strength and stiffness of high-performance composites, design of composite structures and components, and manufacturing processes will be examined.',
  },
  {
    course_code: 'ENG4013',
    course_name: 'Introduction to Literary Theory',
    course_desc:
      'Designed to provide an introduction to a wide range of current theories about the uses and effects of literature and literary criticism. Primarily for English majors and minors.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'EML6805',
    course_name: 'Foundations for Robotics',
    course_desc:
      'This course is focused on robot modeling. It addresses fundamental concepts of robot kinematics including forward kinematics, inverse kinematics, and differential kinematics. In addition, it deals with robot dynamics, trajectory generation, and tracking. Advanced topics on high-level control such as admittance and impedance will also be covered. Students are expected to have a background in linear algebra, knowledge of computational logic and logic-based programming.',
  },
  {
    course_code: 'EML6938',
    course_name: 'Special Topics in Robotics',
    course_desc:
      'In this course the student will acquire a robust understanding of the foundations and fundamental results in a specific area of interest in the field of robotics. Examples include human agent/robot teamwork, multivariable Linear Control Systems, humanoid robots, wearable robotics, human assistive devices, guidance and path planning, fault detection and isolation, autonomous navigation and obstacle avoidance, human-friendly industrial robotics and automation, social robotics, field robotics, robotics for education and training and rehabilitation robotics.',
  },
  {
    course_code: 'ENC1101',
    course_name: 'English Composition I',
    course_desc:
      'Guided practice in critical thinking and the writing process for various rhetorical situations. Documented paper is included. Requires additional work in the Writing Lab.\nIntroduction to academic writing and research at the college level. Course focuses on rhetorical practice, the writing process, language, style, argument, source analysis, critical thinking, and documentation. Students will learn to organize and present ideas and information effectively in argumentative essays supported by research.\nMeets General Education requirement in Communication.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'ENC1102',
    course_name: 'English Composition II',
    course_desc:
      'Introduction to public writing with an emphasis on rhetorical and genre analysis. Course provides instruction on writing to audiences in situations and contexts beyond the academic essay. Students will learn to organize and present ideas in a range of digital and print genres and multiple modes of communication.\nMeets General Education requirement in Communication.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'ENC1905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ENC2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ENC3213',
    course_name: 'Professional and Technical Writing',
    course_desc:
      'Students will learn an overview of professional and technical writing principles, current communication issues, research practices, and emerging technologies. This course focuses on communications skills essential for success in technical and professional communication, including audience analysis, collaboration, and document design. Students will create documents such as letters, manuals, reports and proposals used in a variety of workplace environments. Students who have already passed ENC 3240 or ENC 3250 must receive instructor permission to enroll in this course.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'ENC3350',
    course_name: 'Advanced Writing Studio',
    course_desc:
      'Advanced Writing Studio is a one-hour course that students take concurrently with ENG3010 Critical Methods for Literature Study. Studio students will discuss and edit writing projects assigned in ENG3010. Students receive one-on-one feedback on their writing in a small-group, workshop context. Class size is typically limited to 10 students. Writing Studio provides an intensive investigation into the skills and objectives that make critical writing effective. In a collaborative environment, students interpret assignments, generate and research ideas, invent topics, and write, evaluate, revise, and edit drafts.',
  },
  {
    course_code: 'ENC3416',
    course_name: 'Digital Writing',
    course_desc:
      'Students will compose and analyze digital texts that incorporate images, sounds, video, and language. Course focuses on the theory, analysis, and production of digital texts such as blogs, websites, audio podcasts, video, and visual arguments. Across the semester, students will study audience analysis, and as a final culmination of their work, students will design and deliver an e-Portfolio project.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'ENC3455',
    course_name: 'Writing for Science, Technology, Engineering and Math Majors',
    course_desc:
      'This class focuses on the writing style and research conventions of STEM communication. Students will learn how to identify audiences and determine purposes for writing so they can make informed choices about media, genre, content, organization, style, and visual design. Students develop their skills by writing and analyzing Lab Reports and abstracts and by applying the scientific method to solve problems.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'ENC3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ENC4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ENC4940',
    course_name: 'Writing and Editing Internship',
    course_desc:
      'Students will be involved in all aspects of publishing magazines, brochures, and newspapers. They will research assigned topics, conduct interviews, write feature articles, edit and proof-read articles, and participate in editorial discussions. Permission is required.',
  },
  {
    course_code: 'ENC5333',
    course_name: 'Topics in Rhetoric',
    course_desc:
      'Examination of various topics in rhetoric, composition and / or pedagogy as they apply to the history, theory, analysis, and/or practice of rhetoric. Topics change each term. Contact department or instructor for specific topic.',
  },
  {
    course_code: 'ENC5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ENC5945',
    course_name: 'English Internship',
    course_desc:
      'Course description: Students will be placed in internship positions with professional businesses and non-profit organizations in which they may use their advanced skills in writing, research, creativity, and analysis within a professional environment.  Students will write final evaluations of their employer site, a lengthy research & reflection paper, and a professional portfolio. 12 hours of graduate courses must be completed prior to taking course.  Permission is required. Offered only Fall and Spring Semesters.',
  },
  {
    course_code: 'ENC6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ENG2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ENG3010',
    course_name: 'Critical Methods for Literary Study',
    course_desc:
      'Development of writing and critical thinking skills specific to the study of literature. English majors and minors only. Credit may not be received in both ENG3010 and ENC 3320.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'ENG3113',
    course_name: 'Fiction and Film',
    course_desc: 'Selected prose fiction and film adaptations.',
  },
  {
    course_code: 'ENG3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ENG4823',
    course_name: 'Careers in Writing',
    course_desc:
      'In this course students will examine and research professional and post-degree concerns for English Majors. There will be a series of projects and course materials related to various career fields such as publishing, editing, grant writing, academia, non-profit promotion and marketing, professional and technical writing, social media management and web marketing, freelance article writing, and writing for specialty websites. The course will also incorporate an assignment designed to help students develop materials needed for application in each of these fields - resume & curriculum vitae, cover letters, query letters, personal web presence, and interview techniques. Offered concurrently with ENG5825; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ENG4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ENG4934',
    course_name: 'Capstone Experience',
    course_desc:
      'Covers a wide range of literary genres and works that have been considered controversial at some point in their history because of their subject matter, form, or style. Changing attitudes toward what is considered "literature" or "literary" will be emphasized. Required texts will vary according to instructor\'s expertise. Permission is required.',
  },
  {
    course_code: 'ENG5009',
    course_name: 'Introduction to Advanced Literary Study',
    course_desc:
      'Examination of the history and current state of literary studies and introduction to current methods and resources necessary for advanced literary studies.',
  },
  {
    course_code: 'ENG5825',
    course_name: 'Careers in Writing',
    course_desc:
      'In this course students will examine professional and post-degree concerns for English students completing the MA degree. In addition to a strong focus on developing a teaching portfolio for faculty positions, there will be a series of projects and course materials related to various career fields such as publishing, editing, grant writing, academia, non-profit promotion and marketing, professional and technical writing, social media management and web marketing, freelance article writing, and writing for specialty websites. The course will also incorporate an assignment designed to help students develop materials needed for application in each of these fields - resume & curriculum vitae, cover letters, query letters, personal web presence, and interview techniques. Offered concurrently with ENG4823; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ENG5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ENG6018',
    course_name: 'History of Literary Theory',
    course_desc:
      'Survey of literary theory from Plato to contemporary thought.',
  },
  {
    course_code: 'ENG6019',
    course_name: 'Topics in Literary Theory',
    course_desc: 'Topics in literary theory.',
  },
  {
    course_code: 'ENG6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ENG6971',
    course_name: 'Thesis',
    course_desc:
      'Graded on satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'ENL2010',
    course_name: 'History of English Literature I',
    course_desc:
      'Historical survey of British literature from Beowulf to 1660.  Open to all students.\nMeets General Education requirement in Humanities.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'ENL2020',
    course_name: 'History of English Literature II',
    course_desc:
      'Historical trends: 1660 to present. Primarily for English majors and minors.\nMeets General Education requirement in Humanities.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'ENL2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ENL3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ENL4203',
    course_name: 'Old English Language',
    course_desc:
      'Language instruction for speaking, writing, and reading Old English. Offered Fall semester only.',
  },
  {
    course_code: 'ENL4210',
    course_name: 'Topics in Medieval Literature',
    course_desc:
      'Students read and discuss a variety of texts by diverse authors across the 1000-year period which can be termed the extended Middle Ages, as well as significant precursor texts and authors, in order to discover lines of origin and influence for evolving formal, stylistic, socio-political and theological results, and to acquire an aesthetic appreciation of the literatures of the period. An awareness of significant critical and theoretical terminologies will be developed and incorporated into classroom discussion and writing projects.',
  },
  {
    course_code: 'ENL4224',
    course_name: 'Topics in Early Modern Literature',
    course_desc:
      'Focused study of a particular issue, theme or body of work in sixteenth and seventeenth-century literature in a variety of genres and Anglophone contexts. Specific course topics will vary depending on faculty expertise and research interests.',
  },
  {
    course_code: 'ENL4234',
    course_name: 'Topics in Eighteenth-Century British Literature',
    course_desc:
      'Focused study of a particular issue, theme or body of work in Restoration and eighteenth-century literature in a variety of genres and Anglophone contexts. Specific course topics will vary according to faculty expertise and research interests.',
  },
  {
    course_code: 'ENL4240',
    course_name: 'Topics in Romantic Literature',
    course_desc:
      'Selected topics engaging the prose and poetry of major Romantics: Blake, Coleridge, Wordsworth, Byron, Keats, Shelley.',
  },
  {
    course_code: 'ENL4251',
    course_name: 'Topics in Victorian Literature',
    course_desc:
      'Covers the period leading up to and including the reign of Queen Victoria of England (1837-1901). Literary works will be considered in the context of numerous cultural transformations underway during the period.',
  },
  {
    course_code: 'ENL4284',
    course_name: 'Topics in 20th-Century and Contemporary British Literature',
    course_desc:
      'Covers representative works from all genres written from 1900 to the present by authors living in the British Empire. Emphasis will be placed on Modernist and Postmodernist works.',
  },
  {
    course_code: 'ENL4333',
    course_name: 'Shakespeare',
    course_desc: 'Selected comedies, histories and tragedies.',
  },
  {
    course_code: 'ENL4341',
    course_name: 'Milton',
    course_desc:
      'Major and selected poems; emphasis on reading of Paradise Lost.',
  },
  {
    course_code: 'ENL4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ENL5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ENL6297',
    course_name: 'Topics in British Literature to the Romantics',
    course_desc:
      'Studies in major figures or movements in British literature until 1789.',
  },
  {
    course_code: 'ENL6298',
    course_name: 'Topics in British Literature from the Romantics to Present',
    course_desc:
      'Studies in major figures or movements in British literature from 1789. Topics change each term. See department or instructor for specific topic.',
  },
  {
    course_code: 'ENL6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EUH4511',
    course_name: 'Tudor and Stuart England',
    course_desc:
      'England at home and in international relations during the Tudor and Stuart dynasties (1485-1714). Strong emphasis on overall development and use of primary sources.',
  },
  {
    course_code: 'ENT2612',
    course_name: 'Entrepreneurial Creativity and Innovation',
    course_desc:
      'This course explores the integral role creativity and generation of ideas play in the innovation process.  The course is designed to  examine the theory behind creativity and innovation and to analyze how individual characteristics and organizational processes can enhance creativity.  Students will engage in experiential learning assignments and exercises to facilitate skill development and increased confidence in these important areas.  Students will work individually and in teams to apply the course content to a variety of real-world scenarios.',
  },
  {
    course_code: 'ENT4615',
    course_name: 'Foundations of Entrepreneurial Leadership',
    course_desc:
      'The course provides a transformative experience beyond the classroom by helping student develop an entrepreneurial mindset that can be applied to startups as well as organizations of all kinds. The class will promote active learning and engagement. Student will be required to address the challenges of generating new ideas, designing valued innovations, conceptualizing business opportunities and envisioning new business models in a global framework to achieve a competitive advantage.',
  },
  {
    course_code: 'ENT4940',
    course_name: 'Internship in Entrepreneurial Leadership',
    course_desc:
      'This internship is facilitated through the Center for Entrepreneurship and marks the final step toward completing the Innovation Leadership minor. It affords students the opportunity to be embedded in an actual enterprise, learn first-hand how innovation works in that enterprise and contribute to the success of the enterprise.  Candidate enterprises may include new entrepreneurial ventures as well as those existing enterprises who partner with the Center for Entrepreneurship and the College of Business. Students will engage in experiential learning assignments and exercises and work to achieve the experiential objectives in a variety of real-world scenarios. All proposals for internship must be approved by advisor, chairperson and sponsor. All internships include seminar on internship experience, including weekly journals, written reports and an oral presentation to department chairperson. Graded satisfactory/unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'ESC2000',
    course_name: 'Introduction to Earth Science',
    course_desc:
      "This course introduces concepts that form the foundation of our understanding of Earth's physical environment, including an examination of processes that formed Earth and continue to affect its physical environment and the communities that live on its surface.  This course demonstrates the basic relationships among lithosphere, hydrosphere, atmosphere, and biosphere, including the human interactions with the physical Earth system.\nMeets General Education requirement in Natural Sciences.",
  },
  {
    course_code: 'ESC2000L',
    course_name: 'Introduction to Earth Science Laboratory',
    course_desc:
      "This course introduces concepts that form the foundation of our understanding of Earth's physical environment, including an examination of processes that formed Earth and continue to affect its physical environment and the communities that live on its surface.  This course demonstrates the basic relationships among lithosphere, hydrosphere, atmosphere, and biosphere, including the human interactions with the physical Earth system.\nCo-requisites: ESC2000.",
  },
  {
    course_code: 'ESE3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ESE4322',
    course_name: 'Instruction, Management, and Assessment: Secondary Education',
    course_desc:
      'This course provides an introduction to the teacher?s role in managing the classroom, instruction, and evaluation as it relates to teaching the essential secondary (grades 6-12) school competencies. Models of teaching are briefly introduced to support new teachers in developing a broader perspective regarding teaching practice and their implications for classroom management. Throughout the course, students will investigate the effective (authoritative) teacher perspective with respect to each model with the following teaching-learning goals in mind: 1) Organizing the classroom for a productive learning environment; 2) Building positive student-teacher relationships for culturally responsive instruction; 3) Handling challenging circumstances with effective strategies; 4) Supporting students with special needs; and 5) Assessing and evaluating student understanding and skills.',
  },
  {
    course_code: 'ESE4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ESE4940',
    course_name: 'Secondary Practicum',
    course_desc:
      'Secondary Practicum is designed to be a practical experience for those preparing to become a professional educator. This program will provide the student with a secondary school placement in their discipline in which they will apply knowledge and skills from their coursework. The placement will provide opportunities for students to practice skills under careful observation and in cooperation with a supervising teacher. During the 100 hour placement, students will observe quality teaching strategies and then plan, deliver and evaluate multiple lessons. In order to receive a C- or above in the course, students must earn at least a "needs improvement" or above rating on the elements in the Danielson evaluation tool and a passing score on all dispositions.  Permission is required.',
  },
  {
    course_code: 'ESE5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ESE6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ETD2320',
    course_name: 'Computer Aided Design',
    course_desc:
      'Provides in-depth, hands on experience using a single, industry-standard CAD application.  Students will use application mode settings and drawing aids, shortcuts, and other software features to prepare work.',
  },
  {
    course_code: 'ETI3445',
    course_name: 'Construction Estimating',
    course_desc:
      'Processes involved in estimating, including the formats appropriate for construction jobs and projects are examined. Terminology, software options, and general requirements will be explored. Modeling of real-world experiences will include a project bid and formal "mock" bid opening.',
  },
  {
    course_code: 'ETI3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ETI4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EUH1000',
    course_name: 'Western Perspectives I',
    course_desc:
      "Study of the West's geographical, cultural, political, and economic environments, with an emphasis on how the development of the Western World is part of a larger process of historical development.\nMeets General Education requirement in Social Sciences.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.",
  },
  {
    course_code: 'EUH1001',
    course_name: 'Western Perspectives II',
    course_desc:
      "Study of the West's geographical, socio-cultural, political and scientific developments with an emphasis on how changes in these areas helped to shape civilization in the West, influenced the non-western world, and provided insight into the current conditions in the West and its relationship with the global community.\nMeets General Education requirement in Social Sciences.\nMeets Multicultural Requirement.",
  },
  {
    course_code: 'EUH3121',
    course_name: 'Fall of Rome, Birth of Europe',
    course_desc:
      "Analysis of the continuity and changes in the social, religious, and political life of what constituted Rome's empire following its decline. Study of the converging cultures that created Europe. Covers the period 400-1050.",
  },
  {
    course_code: 'EUH3122',
    course_name: 'High Middle Ages',
    course_desc:
      'Covers the formation of Europe from 1050-1450, a period of dramatic change. Dispels the notion of the "Dark Ages" by analyzing social alignments, religious reform, the rise of universities, economic advancement, and the development of constitutional forms of government.',
  },
  {
    course_code: 'EUH3200',
    course_name: 'Early Modern Europe',
    course_desc:
      'Developing nations emphasizing political, social, economic, cultural and intellectual aspects of Europe from 1500 through French Revolution and Napoleonic period.',
  },
  {
    course_code: 'EUH3203',
    course_name: 'Modern Europe',
    course_desc:
      'European history since 1815, emphasizing contemporary problems, their historical development and interpretations. Credit may not be earned in both EUH3203 and EUH 3205.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'EUH3280',
    course_name: 'The Second World War',
    course_desc:
      'Examines the military, social, political, diplomatic, cultural, and economic aspects of the Allied and Axis powers on all fronts of World War II.',
  },
  {
    course_code: 'EUH3411',
    course_name: 'Rome and the Mediterranean World',
    course_desc:
      "The development of Rome from a tiny town to its domination of the entire Mediterranean. Focuses on the structures of family, government, and military that allowed for this ascendancy. Includes Rome's cultural evolution, social relationships, wealth, and women's roles.\nMeets Multicultural Requirement.",
  },
  {
    course_code: 'EUH3502',
    course_name: 'England Since 1485',
    course_desc:
      'Political, social, cultural and intellectual history of England in modern period stressing growth and development of Britain and Empire/ Commonwealth in contemporary world.',
  },
  {
    course_code: 'EUH3570',
    course_name: 'Russia to 1917',
    course_desc:
      'Beginning with the formation of Kievan Russia in the 10th century, traces the history of Russia until the October Revolution of 1917. Topics considered include the Mongol yoke, the expansion of Muscovy, imperial Russia, the rise of socialism, and the First World War.',
  },
  {
    course_code: 'EUH3576',
    course_name: 'Soviet Union since 1917',
    course_desc:
      "Starting with the October Revolution of 1917, this course traces the history of the Soviet Union through its disintegration in the early 1990s. Topics considered include War Communism, Lenin's New Economic Policy, Stalinism, the Khrushchev and Brezhnev eras, Gorbachev's reforms, the collapse of the Soviet Union, and the emergence of successor states.\nMeets Multicultural Requirement.",
  },
  {
    course_code: 'EUH4140',
    course_name: 'The Renaissance in Italy and Northern Europe',
    course_desc:
      'This course on "the Renaissance" will examine the Italian and Northern European Renaissances, extending from the early 14th century through the 17th century, and encompassing the lasting and significant changes in political, philosophical, religious, artistic, literary, and commercial systems and structures in Europe.',
  },
  {
    course_code: 'EUH4144',
    course_name: 'The Reformation and Transformation of Europe',
    course_desc:
      'This course on the European Reformations, will focus on the societal role of religion in the Later Middle Ages, and the economic, social, political, cultural, and institutional changes in Europe through c. 1650. It will include a study of the figures, texts, and movements within the Protestant Reformation, and those in the Catholic (Counter) Reformation. Also included are the revolts and wars over religion, and the legal restrictions on individuals enacted through c. 1650, dramatically changing both state and society.',
  },
  {
    course_code: 'EUH4185',
    course_name: 'Vikings in History and Legend',
    course_desc:
      'The period 800-1100 is often considered the Age of the Vikings. Utilizing historical and archaeological evidence, this course examines how the Vikings came about, lived, and why this period ended. Analysis covers society in Scandinavia as well as outlying areas of Russia, England and North America. Offered concurrently with EUH5196; graduate students will have additional work.',
  },
  {
    course_code: 'EUH4242',
    course_name: 'The First World War',
    course_desc:
      "Origins, evolution and consequences of World War I. Emphasis on European affairs and how they affected the cultural, military, and political environment of the early 20th Century. Special emphasis on Imperial Germany's culture of militarism, the web of alliances between nations, and how the arms race between the great powers resulted in conflict in Europe. Additionally, the technology, conduct, and developments of the war will be examined and discussed. Offered concurrently with EUH 5246; graduate students will be assigned additional work.",
  },
  {
    course_code: 'EUH4245',
    course_name: 'Tranquility and Turmoil: The New Europe, 1918-1939',
    course_desc:
      'Examines events in selected countries of Europe between the First and Second World Wars. Lectures and readings will consider many aspects of European life, with an emphasis on political, economic, and social issues. In each section, the focus will be on how states cultivated representative democracy or failed at maintaining it.',
  },
  {
    course_code: 'EUH4453',
    course_name: 'The French Revolution',
    course_desc:
      'This course is designed to provide the student with an extensive understanding of the origins, evolution and consequences of the French Revolution and the rise of Napoleon Bonaparte.',
  },
  {
    course_code: 'EUH4462',
    course_name: 'Germany since 1866',
    course_desc:
      "Beginning with unification of Germany between 1866 and 1871, this course will consider the history of imperial Germany, the Weimar Republic, the Third Reich, divided Germany after 1945, and Germany's reunification in 1989-90.",
  },
  {
    course_code: 'EUH4465',
    course_name: 'Nazi Germany',
    course_desc:
      'Origins, evolutions and consequences of the rise of Nazi Germany, ascendancy of Adolf Hitler and subsequent erosion of traditional European culture. Various military and political leaders who served predominate roles within the Third Reich will be studied and discussed, as will the myriad paramilitary organizations within the Nazi Party. Offered concurrently with EUH5467; graduate students will be assigned additional work.',
  },
  {
    course_code: 'EUH4503',
    course_name: 'English Constitutional and Legal History',
    course_desc:
      'English constitutional history from Anglo-Saxon period to present; emphasis upon historical development of English governmental institutions (e.g. parliament, monarchy and legal system), interpretation of their interrelationship and their overall impact upon English nation. Much use of primary sources.',
  },
  {
    course_code: 'EUH4535',
    course_name: 'England and America from the Colonial Period to Present',
    course_desc:
      'Intensive study and analysis of the social, cultural, economic and political forces which served both England and America during the first two centuries of the British empire. Offered concurrently with EUH 5539; graduate students will be assigned additional work.',
  },
  {
    course_code: 'EUH4563',
    course_name: 'Habsburg Monarchy 1526-1918',
    course_desc:
      "Examines the Habsburg Monarchy from its inception to its demise at the end of the First World War. Covers the rise of the monarchy, dynastic affairs of the Habsburgs, problems of political integration, the Monarchy as a bastion against the Islamic Turks, the age of the Counter Reformation and the Baroque, Metternich's diplomacy after the Napoleonic Wars, economic development, constitutional difficulties, nationality problems, Viennese culture around 1900, and the Monarchy's dissolution.",
  },
  {
    course_code: 'EUH4614',
    course_name: 'Medieval Women',
    course_desc:
      "Survey of the experiences of women from the beginning of the Christian era through the Reformation. Focuses on Western Europe and pays particular attention to the social construction of sexuality, the definition of separate spheres, and the roles of law, medicine, and especially the Church in defining women's work, and social and family roles.",
  },
  {
    course_code: 'EUH4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EUH5178',
    course_name: 'Medieval Women',
    course_desc:
      "Medieval Women, which focuses on the experiences of women from the beginning of the Christian era through the early Renaissance in Western Europe and the Mediterranean. This course will pay particular attention to the social construction of sexuality, the definition of separate spheres, and the roles of law, medicine, and the Church in defining women's work, social roles and opportunities, and family functions and responsibilities. Excerpts from primary sources written by women will be read and analyzed, and carefully explored according to History methodology, to understand more deeply their everyday challenges, struggles, and experiences. Offered concurrently with EUH4614; graduate students will be assigned additional work.",
  },
  {
    course_code: 'EUH5196',
    course_name: 'Vikings in History and Legend',
    course_desc:
      'The period 800-1100 is often considered the Age of the Vikings. Utilizing historical and archaeological evidence, this course examines how the Vikings came about, lived, and why this period ended. Analysis covers society in Scandinavia as well as outlying areas of Russia, England and North America. Offered concurrently with EUH4185; graduate students will be given additional work.',
  },
  {
    course_code: 'EUH5467',
    course_name: 'Nazi Germany',
    course_desc:
      'Origins, evolution, and consequences of the rise of Nazi Germany, ascendancy of Adolf Hitler and subsequent erosion of traditional European culture. Military and political leaders who served predominate roles within the Third Reich will be studied and discussed, as will the myriad paramilitary organizations within the Nazi Party. Offered concurrently with EUH4465; graduate students will be assigned additional work.',
  },
  {
    course_code: 'EUH5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EUH6338',
    course_name: 'Seminar: East Central Europe and the Balkans',
    course_desc:
      'Students will examine a specific aspect of a state, ethnic group, or region in East-Central Europe and the Balkans since 1815. Requires readings and reports, but the largest portion of the grade is based on an analytical research paper using primary and secondary sources.',
  },
  {
    course_code: 'EUH6666',
    course_name: 'European Ideologies and Political Movements Since 1789',
    course_desc:
      'Examines the great political ideologies, movements, and theories that shaped not only European affairs but Western thought as a whole from the time of the French Revolution to the present.',
  },
  {
    course_code: 'EUH6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EUH6925',
    course_name: 'Seminar: Dirt, Death & Disease in Middle Ages',
    course_desc:
      'This graduate reading seminar will provide the history graduate student with a thorough introduction to the main themes and areas of historical study within the field of European History from c. 300 to 1453 AD, focusing on the reality of daily life for the different levels of society. It will also introduce the student to the historiography of pre-modern Europe, including current areas of scholarly debate.',
  },
  {
    course_code: 'EUH6935',
    course_name:
      'Faith, Hope, and Conflict: Jerusalem in Antiquity and the Middle Ages',
    course_desc:
      'Jerusalem, the holy city of the three major monotheistic religions today, acquired that designation over millennia. This graduate seminar will explore the evolution of Jerusalem into the "Holy City" of the "Holy Land," from the perspective of each of the three religions. Primary sources from events in the history of ancient and medieval Jerusalem will be read and discussed. Historical evidence for co-existence of the three major religious groups in the microcosm of Jerusalem, their shared religious experiences, and violent conflicts will be investigated, as the land itself became terra sancta.',
  },
  {
    course_code: 'EVR2001',
    course_name: 'Introduction to Environmental Science',
    course_desc:
      'Study of interrelationships between human activity and the natural systems in our environment. Interdisciplinary approach to the study of natural processes and how they affect and are affected by human activity. Particular emphasis will be given to examination of the ways in which science offers solutions to the pressure human activity places on natural resources. Credit may not be received in both EVR2001 and GEO2330.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'EVR2920',
    course_name: 'Foundations in Environmental Science',
    course_desc:
      'A professional development course for students in Earth and Environmental Sciences Department. This course is designed to introduce students to the necessary skills for upper division courses, introduce community engagement opportunities, introduce undergraduate research opportunities and lead students toward an appropriate capstone experience.',
  },
  {
    course_code: 'EVR3894',
    course_name: 'Environmental Writing',
    course_desc:
      'This course will cover important and substantive issues, concepts, and tools on writing in the environmental sciences. The course will provide tools for how you can convey environmental concepts to a wider audience and assist you with strategies to be a more productive and coherent writer.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'EVR3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EVR6930',
    course_name: 'Special Topics in Environmental Sciences',
    course_desc:
      'Covers various advanced subjects in the environmental sciences, depending on the specialization of the instructor. Topics include environmental pedagogy, coastal meteorology, groundwater modeling, etc. Graduate-level standing is required.',
  },
  {
    course_code: 'EVR4023',
    course_name: 'Coastal and Marine Environments',
    course_desc:
      "The world's ocean and its marine environments such as beaches, estuaries, coral reefs, upwelling areas, and hydrothermal vents. The physical, chemical, and biologic components that make each environment unique. Case studies of the environmental impact of anthropogenic and natural phenomena based on readings of scientific papers.\nOffered concurrently with EVR5071; graduate students will be assigned additional work.",
  },
  {
    course_code: 'EVR4035',
    course_name: 'Environmental Law',
    course_desc:
      'Overview of current local, state and federal laws relating to the environment. Includes the legal history of current laws and case studies.',
  },
  {
    course_code: 'EVR4039',
    course_name: 'Community Engagement through Environmental Science',
    course_desc:
      'This course is designed as a Carnegie Service Learning Designation course.  Students will bring into practice the theories and ideas they have acquired through previous course lectures and assignments to collaborate with a community partner on a project designed to address a particular community issue. This semester project has two main outcomes: to help the community partner further their mission and to give hands on experience for students in a local environmental organization or agency.  The completion of this co-created project will allow students to reflect on the connections between their course lessons, real-world experience, and community needs.',
  },
  {
    course_code: 'EVR4412',
    course_name: 'Environmental Aspects of Urban Growth',
    course_desc:
      'The purpose is to examine urban areas as they have sprawled out over green landscapes during the past century and left behind a legacy of environmentally distressed properties and broken communities. Emphasis is upon community-based action to deal with local situations, using as a base the experiences of communities throughout the United States. Offered concurrently with EVR5413; graduate students will be assigned additional work. Senior standing is required.',
  },
  {
    course_code: 'EVR4823',
    course_name: 'Environmental Impact Assessment',
    course_desc:
      'Environmental Impact Assessment (EIA) is a process to assure disclosure of environmental consequences before human actions are taken. This course introduces students to the legal, scientific, and administrative considerations and procedures that define the EIA process in completing an Environmental Impact Statement (EIS). The course focuses on the concept of environmental impact and the techniques and responsibilities as set forth in the National Environmental Policy Act of 1970 as amended. Offered concurrently with EVR 5824; graduate students will be assigned additional work.',
  },
  {
    course_code: 'EVR4870',
    course_name: 'Urban Planning',
    course_desc:
      'This course will cover important substantive areas, concepts, and tools in the field of urban planning. It will provide insight into the many actors (e.g., individuals, organizations, agencies, and levels of government) involved in planning and how planning pervades a multitude of segments in our daily lives. At the end of the course, you will have a better understanding of how the field of planning has evolved, the topics that urban planners study, and the type of work urban planning practitioners engage in. Offered concurrently with EVR5435. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'EVR4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EVR4941',
    course_name: 'Internship in Environmental Sciences',
    course_desc:
      'Supervised field experience in business, government, non-profit, educational or other environmental organization. Offered concurrently with EVR5332; graduate students will be assigned additional work. Permission is required.',
  },
  {
    course_code: 'EVR4949',
    course_name: 'Co-Op Work Experience',
    course_desc: '',
  },
  {
    course_code: 'EVR4970',
    course_name: 'Research in Earth and Environmental Sciences',
    course_desc:
      'Students will propose, design, and perform a research project in consultation with a UWF professor, who will serve as research supervisor. Research will be summarized and presented within the department and University. Permission is required.',
  },
  {
    course_code: 'EVR5071',
    course_name: 'Coastal and Marine Environments',
    course_desc:
      "This course will investigate the world's ocean and its marine environments such as beaches, estuaries, coral reefs, upwelling areas, and hydrothermal vents. The physical, chemical, and biologic components that make each environment unique. Case studies of the environmental impact of anthropogenic and natural phenomena based on readings of scientific papers. This course is built on basic concepts established in introductory Earth Science courses, so graduate students should be familiar with those concepts.  Please consult with the course instructor for any\nquestions regarding these prerequisite concepts.  Cross listed with EVR4023; Graduate students will be assigned additional work.",
  },
  {
    course_code: 'EVR5332',
    course_name: 'Practicum in Environmental Studies',
    course_desc:
      'Supervised field experience in business, government, nonprofit, educational or other environmental organizations. Offered Summer term only.  Offered concurrently with EVR4941; graduate students will be assigned additional work. Permission is required.',
  },
  {
    course_code: 'EVR5413',
    course_name: 'Environmental Aspects of Urban Growth',
    course_desc:
      'The purpose is to examine urban areas as they have sprawled out over green landscapes during the past century and left behind a legacy of environmentally distressed properties and broken communities. Emphasis is upon community-based action to deal with local situations, using as a base the experiences of communities throughout the United States. Offered concurrently with EVR4412; graduate students will be assigned additional work. Graduate status is required.',
  },
  {
    course_code: 'EVR5435',
    course_name: 'Urban Planning',
    course_desc:
      'This course will cover important substantive areas, concepts, and tools in the field of urban planning. It will provide insight into the many actors (e.g., individuals, organizations, agencies, and levels of government) involved in planning and how planning pervades a multitude of segments in our daily lives. At the end of the course, you will have a better understanding of how the field of planning has evolved, the topics that urban planners study, and the type of work urban planning practitioners engage in. Offered concurrently with EVR4870. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'EVR6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUE4465',
    course_name: 'Brass Instrument Methods and Materials',
    course_desc:
      'Brass instrument playing techniques, pedagogy, literature and materials. Required of students in music teaching track.',
  },
  {
    course_code: 'EVS4192C',
    course_name: 'Environmental Soil Science',
    course_desc:
      'Examines the delicate nature of soils and the importance of soils for healthy ecosystems. Important ecosystem services provided by soils include food and fiber production, storage of organic carbon, and water and nutrient cycles. Reviews the basic principles of soil science and applies them to environmental issues. Includes the fundamental characteristics and processes of soils and their application to pollution, soil degradation, soil conservation, and remediation along with the physical and chemical properties of common soil pollutants such as trace metals, fertilizers, and some organic pollutants. Includes lectures by the instructor, presentations by graduate students, lab, and field activities. Offered concurrently with EVS5194C (Environmental Soil Science); graduate students will be assigned additional work. Permission is required.',
  },
  {
    course_code: 'EVS5194C',
    course_name: 'Environmental Soil Science',
    course_desc:
      'Examines the delicate nature of soil and the importance of soils for healthy ecosystems. Important ecosystem services provided by soils include food and fiber production, storage of organic carbon, and water and nutrient cycles. Reviews the basic principles of soil science and applies them to environmental issues. Includes the fundamental characteristics and processes of soils and their application to pollution, soil degradation, soil conservation, and remediation along with the physical and chemical properties of common soil pollutants such as trace metals, fertilizers, and some organic pollutants. Includes lectures by the instructor, presentations by graduate students, lab, and field activities. Students will be assigned additional work. Permission is required.',
  },
  {
    course_code: 'EVS6196C',
    course_name: 'Sampling and Analysis in Environmental Sciences',
    course_desc:
      'Theory and techniques of modern field and laboratory methods used for physical and chemical analysis of soil, sediment, and water samples. Procedures for exploratory data analysis and interpretation. Emphasis will be upon the collection of samples and their subsequent analysis. Written reports and oral presentations are required. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'EVS6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EVS6940',
    course_name: 'Internship',
    course_desc:
      'Supervised and structured participation in environmental work experience in the private, government, or educational sectors. Permission is required.',
  },
  {
    course_code: 'EVS6971',
    course_name: 'Thesis',
    course_desc:
      "Design, research, and presentation of a master's thesis under the direction of the faculty committee. Graded on a Satisfactory/Unsatisfactory basis only.",
  },
  {
    course_code: 'EXP3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EXP4204',
    course_name: 'Sensation and Perception',
    course_desc:
      'Will survey the theory and literature related to the study of sensation and perception. Topics will include the neural mechanisms involved in coding sensory information, visual processing, audition, speech perception, cutaneous and chemical senses, development of perceptual processes, and impairment of vision and hearing.',
  },
  {
    course_code: 'EXP4250',
    course_name: 'Human Factors Psychology',
    course_desc:
      'Surveys the field of human factors psychology. Specifically, the principles of psychology from various specialty areas (e.g., cognitive, experimental, industrial/organizational, physiological etc.) will be applied to the study of human performance in work settings. Students will learn how work is designed to capitalize on cognitive and physical capabilities and compensate for human limitations. Students will also become familiar with the tools and techniques that human factors psychologists use to study human-machine interaction and work design. Offered concurrently with EXP5256; graduate students will be assigned additional work.',
  },
  {
    course_code: 'EXP4404',
    course_name: 'Psychology of Learning',
    course_desc:
      'Principles and applications of learning theories, including conditioning and extinction, reinforcement and punishment, attention, memory, cognitive processes and physiological correlates of memory and cognition. It is preferred that the student has had several other psychology courses.',
  },
  {
    course_code: 'EXP4507',
    course_name: 'Memory and Cognition',
    course_desc:
      'Will survey theory and literature related to the study of human memory and cognition. Topics will include attention, memory, imagery, language and bilingualism, problem solving, metamemory, expertise, and the development of language and cognitive processes.',
  },
  {
    course_code: 'EXP4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'EXP5208',
    course_name: 'Advanced Sensation and Perception',
    course_desc:
      'Students must take EXP4204 before enrolling in this course.\nStudents will develop an in-depth understanding of how human beings use environmental energies to sense and perceive the world. Topics include the examination of neural systems involved in vision, audition, somatosensation, olfaction, and gustation. Physiological, psychophysical, and cognitive research methodologies used to understand and predict human perception will be discussed.',
  },
  {
    course_code: 'EXP5256',
    course_name: 'Human Factors Psychology',
    course_desc:
      'Surveys the field of human factors psychology. Specifically, the principles of psychology from various specialty areas (e.g., cognitive, experimental, industrial/organizational, physiological etc. ) will be applied to the study of human performance in work settings. Students will learn how work is designed to capitalize on cognitive and physical capabilities and compensate for human limitations. Students will also become familiar with the tools and techniques that human factors psychologists use to study human-machine interaction and work design. Offered concurrently with EXP4250; graduate students will be assigned additional work.',
  },
  {
    course_code: 'EXP5735',
    course_name: 'Experimental and Correlational Statistics for Psychology',
    course_desc:
      'This course focuses on quantitative research approaches with particular attention given to the selection of procedures for obtaining empirical data that provide meaningful answers to research questions and to the relation between research design and statistical analysis.  Topics include researching the literature, developing research questions, designing and evaluating empirical research, and communicating research methods and results in standard technical format (APA style).  Ethical issues in the conduct of research will be addressed.',
  },
  {
    course_code: 'EXP5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'FIN4424',
    course_name: 'Problems in Corporate Finance',
    course_desc:
      'Cases and readings in corporation finance in areas of capital budgeting, working capital management, capital structure, cost of capital, mergers, reorganizations, and international finance.',
  },
  {
    course_code: 'EXP6085',
    course_name: 'Seminar in Applied Psychological Sciences',
    course_desc:
      "This course provides an opportunity for students in the Applied Experimental Psychology (AEP) MA track to explore a range of study domains and research methodologies across the science of psychology. It is intended as an advanced survey course in which faculty members and students from the School of Psychological and Behavioral Sciences present brief seminars in their areas of research and on topics related to student's professional development.",
  },
  {
    course_code: 'EXP6506',
    course_name: 'Advanced Cognitive Psychology',
    course_desc:
      'Students must take PSY3213 and PSY3215 and EXP4404; or an undergraduate degree in Psych before enrolling in this course.\nStudents will develop a broad understanding of current research and theorizing in the various topics of memory and cognition, including attention, memory systems and processes, representation of knowledge, metamemory, language, problem solving, expertise, decision making, and creativity. Emphasis will be placed on current research and theory in human memory cognition. Students will develop an in-depth understanding of a selected topic in cognition and will write a literature review paper discussing current research and theory in this topic.',
  },
  {
    course_code: 'EXP6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'FAS6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'FIL3427',
    course_name: 'Film Production I',
    course_desc:
      'This is an introductory course covering single-camera film and television production. Course\nrequirements include basic efficiency with cameras, lighting equipment, sound recording, and\nediting picture and sound. The theory and practice of Narrative film production, as well as\naspects television and documentary production, will be covered.',
  },
  {
    course_code: 'FIL3833',
    course_name: 'Film Styles',
    course_desc:
      'The Film Styles course explores important film genres and sub-genres (e.g., Westerns, Science Fiction, Crime/Gangster, Film Noir, Sports Films), important film movements (e.g., German Expressionism, Soviet Montage, the Japanese Golden Age, Italian Neo-Realism, and the French and British New Waves), as well as conventions within film production approaches (e.g., dramatic films, documentary films, and satire). The course focuses on the traits of styles of film, the circumstances under which these styles came to be, and the perspective of the filmmakers who were integral to their development. The course includes on-line film viewings, readings, and short essays.',
  },
  {
    course_code: 'FIL3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'FIL4036',
    course_name: 'History of Motion Pictures',
    course_desc:
      'Evolution of film as a dynamic art form and medium of mass communication. Weekly film screening. Credit may not be received in FIL4036 and either FIL 4036C or FIL 4403C.',
  },
  {
    course_code: 'FIL4102',
    course_name: 'Screenwriting for Film, TV, and Digital Media',
    course_desc:
      'Study and practice of writing for narrative mass media, including screenplays, teleplays, and digital media formats. Study of various approaches to the craft of developing, planning, writing, and rewriting narrative works for the screen. Additional topics include script formats, storyboarding, and story pitches. Credit may not be received in both FIL4102 and MMC 4103.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'FIL4364',
    course_name: 'Documentary Film and Television',
    course_desc:
      'Historical and sociological study of the development of documentary film and television. Includes analysis of documentary film techniques and viewing of selected documentaries. Offered concurrently with FIL 5367; graduate students will be assigned additional work.',
  },
  {
    course_code: 'FIL4435',
    course_name: 'Film Production II',
    course_desc:
      'This is an advanced course covering single-camera film and television production. Course prerequisites include FIL3427 Film Production I, or permission of the instructor. Course requirements include the ability to use digital production cameras, lighting equipment, sound recording equipment, and editing picture and sound. Advanced theory and practice of narrative film production, as well as television and documentary production, will be covered.',
  },
  {
    course_code: 'FIL4514',
    course_name: 'Film Production III',
    course_desc:
      'This is an advanced, practicum course covering single-camera narrative film production. Course requirements include the advanced ability to use digital production cameras, lighting equipment, sound recording equipment, and editing picture and sound. The culmination of the course for each student will be the production of a short, narrative film short (typically 10 to 20 minutes in length). The use of advanced narrative and documentary film production techniques will be emphasized.',
  },
  {
    course_code: 'FIL4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'FIL6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'FIN2104',
    course_name: 'Personal Financial Planning',
    course_desc:
      'Survey of personal financial planning topics. Includes: managing money and credit, personal loans, insurance, investments, home ownership, and taxes.\nMeets General Education requirement in Social Sciences.',
  },
  {
    course_code: 'FIN3144',
    course_name: 'Financial Planning with Business Applications',
    course_desc:
      'The course covers the business applications and considerations that owners and employees in various industries face (e.g. insurance, home/auto sales, retirement planning). Furthermore, this course considers a variety of consumer financial issues for personal household management.  May not be used to satisfy a Finance elective in either the Finance major or the Finance minor.',
  },
  {
    course_code: 'FIN3244',
    course_name: 'Financial Markets and Institutions',
    course_desc:
      'Structure and functions of financial markets and institutions; interest rates, exchange rates, intermediation, and markets.',
  },
  {
    course_code: 'FIN3403',
    course_name: 'Managerial Finance',
    course_desc:
      'Analytical concepts available to financial manager in acquisition and effective utilization of funds in relation to other management functions.',
  },
  {
    course_code: 'FIN3461',
    course_name: 'Financial Statement Analysis',
    course_desc:
      'Introduction to the study of financial statements, including interpreting accounting data and analyzing financial statements. Cross Listed with ACG3180.\nPrerequisites: FIN3403 minimum grade of C.',
  },
  {
    course_code: 'FIN3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'FIN4414',
    course_name: 'Financial Theory and Practice',
    course_desc:
      'Designed as an extension of FIN3403. Topics such as risk and return, stock and bond valuation, time value of money, and capital budgeting, will be covered in greater depth. New topics will include lease financing, hybrid financing, international finance, et al.',
  },
  {
    course_code: 'FIN4560',
    course_name: 'Equity Fund Management',
    course_desc:
      "This is a student-managed stock fund class that allows students to control and manage a half million dollars of real capital to invest in the stock market. Students in the class have total control to decide as a group to select and invest in no more than 20 stocks. The portfolio performance will be used to compete on the national level with other schools' performances. Offered concurrently with FIN5565; graduate students will be assigned additional work.",
  },
  {
    course_code: 'FIN4561',
    course_name: 'Bond Fund Management',
    course_desc:
      "This is a student-managed bond fund class that allows students to control and manage one million dollars of real capital to invest in the bond market. Students in the class have total control to decide as a group to select and invest in no more than 15 bonds. The portfolio performance will be used to compete on the national level with other schools' performances. Offered concurrently with FIN5566; graduate students will be assigned additional work.",
  },
  {
    course_code: 'FIN4562',
    course_name: 'Derivatives Fund Management',
    course_desc:
      "This is a student-managed derivatives fund class that allows students to control and manage a half million dollars of real capital to invest in the derivatives market. Students in the class have total control to decide as a group to select and invest in covered positions in derivatives. The portfolio performance will be used to compete on the national level with other schools' performances. Offered concurrently with FIN5567; graduate students will be assigned additional work.",
  },
  {
    course_code: 'FIN4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'FIN4941',
    course_name: 'Financial Services Internship',
    course_desc:
      'Supervised field practicum in financial services-related position. May include activities in any one or more of the functional areas in financial services (commercial banking, mutual funds and investments, insurance, real estate and personal financial planning). Graded on a satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'FIN5565',
    course_name: 'Equity Fund Management',
    course_desc:
      'The course allows students to manage an institutional stock portfolio with real money.  Students learn to develop investment thesis, industry analysis, valuations, and risk analysis in the process of stock portfolio management.  Students are responsible for executing the actual trades and monitoring the invested portfolio on a real-time basis.  Offered concurrently with FIN4560; graduate students will be assigned additional work. FIN3403 with a grade of C or better is the prerequisite.',
  },
  {
    course_code: 'FIN5566',
    course_name: 'Bond Fund Management',
    course_desc:
      'The course allows students to manage an institutional bond portfolio with real money.  Students learn to make interest rate forecasts, sector selections, credit analysis, and valuations in the process of bond portfolio management.  The actual invested portfolio will be monitored by the students on a real-time basis.  Offered concurrently with FIN4561; graduate students will be assigned additional work. FIN3403 with a grade of C or better is the prerequisite.',
  },
  {
    course_code: 'FIN5567',
    course_name: 'Derivatives Fund Management',
    course_desc:
      'This is a student-managed derivatives fund class that allows students to control and manage a half million dollars of real capital to invest in the derivatives market. Students will learn investment strategies related to derivatives including forecasting, pre-event momentum analysis, estimating time value and intrinsic value of options Formulating investment policy statements and option stress tests.\nOffered concurrently with FIN4562; graduate students will be assigned additional work. FIN3403 with a grade of C or better is the prerequisite.',
  },
  {
    course_code: 'FIN5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'FIN6406',
    course_name: 'Financial Management',
    course_desc:
      'Advanced treatment of investment and financing decisions of firms, emphasis on current theory and practice. Course contains a portfolio project. Prerequisites GEB5878 Business Process Integration and GEB5930 Information Resources and Industry Analysis.',
  },
  {
    course_code: 'FIN6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'FLE2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'FLE3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'FLE4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'FOL3301',
    course_name: 'World Languages and Cultures in Contact',
    course_desc:
      'In this class, students will be introduced to the various language families of the world. A variety of examples from each of the language families will be provided. Students will also be introduced to several basic linguistic concepts, which will guide our discussion and study of language families. Students will begin by learning the basic universals of all languages, looking at topics such as greetings and good-byes, formality/ informality, expression of time and place, expression of gender, universal grammar aspects, and others. We will be answering questions such as: What is language? What are language varieties? What are (universal) basic language features? What has impacted the development of language? Alongside these questions, students will also learn about and discuss underlying social and political conditions that influence a language, as well as different forms of cultural expressions that are mediated through language. Thus, the class will ground students in a basic understanding of how social, religious, political, historical, and foreign factors have influenced and changed languages around the globe, and in turn how the cultural expressions through language establish their own set of social, political, and historical factors. Last but not least, the course will facilitate a rigorous understanding of diversity through language and culture, and let students think about what connects us all, regardless of the variations that exist.',
  },
  {
    course_code: 'FRE1905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'FRE2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'FRE3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'FRE4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'FRE4955',
    course_name: 'Supervised Foreign Language Field Experience Abroad',
    course_desc:
      "Supervised and individualized foreign language experience tailored to each student's individual proficiency needs in language and culture. Permission is required.\nMeets Multicultural Requirement.",
  },
  {
    course_code: 'FRW3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'FRW4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'GEA2000',
    course_name: 'Nations and Regions of the World',
    course_desc:
      'Regional treatment of the physical & cultural environments of the world. Interdependence of peoples and nations of the world will be stressed within the context of environmental attributes and shortcomings and human responses to environmental opportunities or limitations.\nMeets General Education requirement in Social Sciences.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'GEA4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'GEB1011',
    course_name: 'Introduction to Business',
    course_desc:
      "Provides in-depth coverage of all aspects of business by presenting an integrated and balanced review of the external and internal forces that comprise business and economic systems. Intended primarily for freshmen/sophomores to assist the student's selection of a business career or business major.\nMeets General Education requirement in Social Sciences.",
  },
  {
    course_code: 'GEB3032',
    course_name: 'Business Foundations for Non-Business Majors',
    course_desc:
      'Provides non-business students a foundation in the functional areas of management, marketing, finance, accounting and economics. Designed to provide students with a knowledge base that will give access to a broad range of upper level business courses. Available only to non-business majors.',
  },
  {
    course_code: 'GEB3213',
    course_name: 'Writing for Business: Theory and Practice',
    course_desc:
      "Augments the basics of business writing while reviewing the various kinds of written business correspondence. Students are expected to integrate ethical decision making skills, word processing skills, grammar and writing skills, and analytical thinking skills into the content. Students must be able to determine solutions to problem based exercises. Team assignments and oral presentations may relate to student's discipline.\nMeets Gordon Rule Writing Requirement.",
  },
  {
    course_code: 'GEB3453',
    course_name: 'Business Ethics and Stakeholder Management',
    course_desc:
      "Managers are confronted with increasingly complex environments and face challenges trying to balance economic, legal, and ethical responsibilities vis-a-vis the stakeholder groups with which they interact. This course investigates the spectrum of business ethics and social responsibility issues that managers face in today's organizations. Course will be grounded in contemporary events and addresses these challenges from an individual and a managerial perspective.",
  },
  {
    course_code: 'GEB4361',
    course_name: 'International Business',
    course_desc:
      'Introduces students to the complexities of conducting business on a global scale. Businesses typically develop in a domestic setting and then expand into international commerce. Focuses on the necessary adaptations of business practices for success in global markets. Offered concurrently with GEB 5365; graduate students will be assigned additional work.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'GEB4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'GEB5116',
    course_name: 'Venture Development',
    course_desc:
      'Students develop the knowledge and skills to begin a start-up business and evaluate it for possible launch. The curriculum includes constructing a board of directors, adding managers for key functions, reaching revenue targets and examining the steps of taking a company public.',
  },
  {
    course_code: 'GEB5118',
    course_name: 'New Ventures',
    course_desc:
      'Students will develop the knowledge and skills needed to start a new business. They create potential opportunities, assess the opportunities and evaluate how to seek seed capital through an elevator speech and business plan with an eye toward the profitability horizon. Students are expected to have an understanding of financial accounting and the business relationships that exist between the generation and use of financial information.',
  },
  {
    course_code: 'GEB5535',
    course_name: 'MBA Foundations',
    course_desc:
      'This survey course provides the essential business foundational knowledge needed to take advanced MBA classes. The content covered includes the fundamentals of accounting, business mathematics and statistics, economics, finance, management and marketing. The class is designed for those students who have not completed a business undergraduate degree in the last five years. The course is offered on a satisfactory/unsatisfactory basis.',
  },
  {
    course_code: 'GEB5816',
    course_name: 'MBA Foundations: Principles of Human Resources Management',
    course_desc:
      'A course in the Accelerated MBA Foundations Series in which students are introduced to the basic functions of human resource management, including employment law, planning, job analysis, recruitment and selection, training and development, performance management, compensation and benefits, employee and labor relations, safety and health, and international human resource management.',
  },
  {
    course_code: 'GEB5870',
    course_name: 'MBA Foundations: e-Business Systems',
    course_desc:
      'A course in the Accelerated MBA Foundations Series in which students will gain an understanding of the principles of e-Business systems planning, development, and implementation. The overall objective is to provide a common foundation composed of the fundamental concepts required for the use and application of systems and technologies found in the e-Business environment. Permission is required.',
  },
  {
    course_code: 'GEB5871',
    course_name: 'MBA Foundations: Managerial Economics',
    course_desc:
      'A course in the Accelerated MBA Foundations Series in which students will gain an understanding of basic economics. Special emphasis will be placed on the determinants of supply and demand and the desirable properties of a competitive equilibrium; followed by the undesirable properties of markets with a monopoly and with externalities. Permission is required.',
  },
  {
    course_code: 'GEB5872',
    course_name: 'MBA Foundations: Financial Management I',
    course_desc:
      'A course in the Accelerated MBA Foundations Series in which students are introduced to the accounting process of analyzing, measuring, and reporting business activity. Explores the precise language, assumptions, concepts, principles, and logic patterns inherent in the analysis and measurement of business activity. Describes the form and content of major financial statements. Briefly introduces the recording and reporting process used by accounting systems and examines basic financial reporting issues.',
  },
  {
    course_code: 'GEB5873',
    course_name: 'MBA Foundations: Financial Management II',
    course_desc:
      'A course in the Accelerated MBA Foundations Series in which students who have an understanding of financial accounting are introduced to the business relationships that exist between the generation and use of financial information. Includes the role of accounting in measuring financial performance, an overview of financial management, keys to understanding financial information via financial ratio analysis, effective use of financial analysis, and a brief introduction to the time value of money.',
  },
  {
    course_code: 'GEB5874',
    course_name: 'MBA Foundations: Financial Management III',
    course_desc:
      'A course in the Accelerated MBA Foundations Series in which students with an understanding of financial analysis are introduced to financial valuation and decision making tools that are used by managers and owner/managers of business organizations. The three foundation concepts covered are the Time Value of Money, the Risk- Return Relationship, and the use of Incremental After-Tax Cash Flows. Provides a theoretical understanding and a practical application in financial decision-making. Permission is required.',
  },
  {
    course_code: 'GEB5875',
    course_name: 'MBA Foundations: Management Skills and Applications',
    course_desc:
      'Covers the historical evolution of management, organizational design, motivation, team building, leadership, change management, culture, strategic planning, and critical implementation/control elements critical to successful management and strategy. Social responsibility, ethics, globalization, and futures are also stressed.',
  },
  {
    course_code: 'GEB5876',
    course_name: 'MBA Foundations: Marketing Management',
    course_desc:
      'A course in the Accelerated MBA Foundations Series in which students are introduced to foundational concepts of marketing management processes. Provides students with intensive exposure to the basic philosophy, concepts, and knowledge common to effective marketing management.',
  },
  {
    course_code: 'GEB5878',
    course_name: 'Business Process Integration',
    course_desc:
      'An introductory MBA core course in which students must combine the practical skills and discipline of specific concepts learned in previous foundation courses in order to solve a complex integrated real-life business problem.  Serves as an initial integrating experience from which to launch students into the core MBA study.  Permission is required.',
  },
  {
    course_code: 'GEB5879',
    course_name: 'MBA Foundations: Business Analytics',
    course_desc:
      'Business requires the application of a variety of analytical tools. Integrates several key analytical tools into a specific business decision framework that focuses on the interrelationship of these tools as they are used in business decisions. After an on-line review/introduction of basic algebraic and financial equations, combines the concepts of time value of money, descriptive statistics, production functions, correlation, simple regression and specifically applied calculus into a decision-making framework. This framework will serve as a foundation for analysis in subsequent courses and create a model for considering risk adjusted financial consequences of future business decisions. Permission is required.',
  },
  {
    course_code: 'GEB5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'GEB5930',
    course_name: 'Information Resources and Industry Analysis',
    course_desc:
      'Provides the background for beginning the MBA Portfolio. Gives introduction to information resources available to perform business problem analysis. Students learn to prepare a thorough analysis of their Portfolio industry.',
  },
  {
    course_code: 'GEB6895',
    course_name: 'Business and Public Policy',
    course_desc:
      'Develops expertise in the use of a set of tools to analyze the effect of economic, regulatory and tax policies (external environment) on the business environment and the conduct of business in domestic and international markets. Ethical implications of business response to these environments are also considered.',
  },
  {
    course_code: 'GEB6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'GEO2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'GEO3210',
    course_name: 'Geomorphology',
    course_desc:
      "Description of landforms and landscapes on the Earth's surface, along with a systematic analysis of the geomorphic processes that produce them. Emphasis is placed on the climatic and geologic controls on landscape evolution.",
  },
  {
    course_code: 'GEO3210L',
    course_name: 'Geomorphology Lab',
    course_desc:
      'A one-credit, practical laboratory course, reinforcing concepts from an associated lecture section (GEO3210), and requiring both quantitative and conceptual analyses of geomorphic data to draw conclusions about real-world geomorphic processes and landform/landscape evolution.',
  },
  {
    course_code: 'GEO3372',
    course_name: 'Conservation of Natural Resources',
    course_desc:
      'Nature and extent of mineral, soil, water, forest and wildlife resources and their conservation, with particular emphasis on the United States against a general background of world resources. Conservation philosophies, practices and their geographic bases. Occasional field trips may be arranged.',
  },
  {
    course_code: 'GEO3421',
    course_name: 'Cultural Geography',
    course_desc:
      'Sociocultural distributions with emphases on social regions, spatial behavior and cultural landscapes. Topics include population, spatial diffusion and processes, race, language, religion, political organization, methods of livelihood, settlement patterns, and the regional distribution of the elements over the earth.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'GEO3471',
    course_name: 'Geography of World Affairs',
    course_desc:
      'Geographic study of world events; environmental influences on events; impact of events on environment; ramifications of events on social, economic, political, physical and psychological worlds. Credit cannot be received for both GEO3471 and GEO 3470.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'GEO3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'GEO4004',
    course_name: 'Environmental Science, Politics and Policy',
    course_desc:
      'This course examines the role of science in the environmental policy-making process - both locally and internationally. It investigates the methods scientists use to learn about the natural world; the way scientific knowledge accumulates and disseminates; the treatment of science by advocates, dissenters, and the media; and the role of science in decision making about environmental issues.',
  },
  {
    course_code: 'GEO4005',
    course_name: 'Environmental Management & Planning',
    course_desc:
      'This course will cover important and substantive issues, concepts, and tools in the field of environmental planning and management. It will provide insight into the many actors (e.g., individuals, organizations, agencies, and levels of government) involved in environmental management and planning - both locally and internationally, and try to identify ways in which we are responsibly managing (or not) our physical environment. At the end of the course, you will have a better understanding of how the field of environmental management and planning has evolved, the issues that environmental managers and planners deal with, and the type of work environmental managers and planners engage in. Offered concurrently with GEO5007. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'GEO4164',
    course_name: 'Geostatistics',
    course_desc:
      'Course reviews basic sampling and experimental design skills as a means to reintroduce data analysis using standard univariate techniques in the geosciences. Introduces spatial, multivariate and time series techniques for both pattern exploration and hypothesis testing. Offered concurrently with GEO5165; graduate students will be assigned additional work. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'GEO4221',
    course_name: 'Coastal Morphology and Processes',
    course_desc:
      "An introduction to the world's coastal landforms, with emphasis upon dominant processes (especially waves, tides, and currents), geographical variations, human impacts and policies and environmental concerns. Offered concurrently with GEO5225; graduate students will be assigned additional work.",
  },
  {
    course_code: 'GEO4221L',
    course_name: 'Coastal Morphology and Processes Laboratory',
    course_desc:
      'Laboratory correlating with GEO4221. Offered concurrently with GEO5225L; graduate students will be assigned additional work. Material and supply fees will be assessed.',
  },
  {
    course_code: 'GEO4250',
    course_name: 'Weather and Climate',
    course_desc:
      'Nature of individual weather elements, their measurements, and analysis over time and space. Analysis of global climate emphasizing control factors, resulting areal patterns and climatic classifications. Emphasis upon North American weather and climate patterns, micro climate, climate change, modification and related problems. Material and supply fee will be assessed for corresponding lab.',
  },
  {
    course_code: 'GEO4250L',
    course_name: 'Weather and Climate Lab',
    course_desc:
      'A one-credit, practical laboratory course, reinforcing concepts from an associated lecture section (GEO 3250), and requiring both quantitative and conceptual analyses of weather data and weather maps to draw conclusions about real-world weather and/or climate outcomes.',
  },
  {
    course_code: 'GEO4251',
    course_name: 'Advanced Climatology and Climate Change',
    course_desc:
      "A survey of Earth's climate during the past several millennia. Explores current scientific literature on global climate as well as paleoclimatic research. Changes in global climate prior to modern record-keeping (pre-1895) are compared and contrasted with observed contemporary global climate change. Offered concurrently with GEO5256 Advanced Climatology and Climate Change); graduate students will be assigned additional work.",
  },
  {
    course_code: 'GEO4260',
    course_name: 'Geography of Soils',
    course_desc:
      'Nature, properties and distribution of soils and their relationship to the influence of vegetation, climate, landforms, and human activity. Understanding how soils form and how and why they vary horizontally across the landscape and vertically with depth. Emphasis upon North American patterns. Occasional field trips. It is recommended that GEO4260L be taken concurrently.',
  },
  {
    course_code: 'GEO4260L',
    course_name: 'Geography of Soils Laboratory',
    course_desc:
      'Deals with the nature, properties and distribution of soils and their relationship to the influence of vegetation, climate, landforms, and human activity. Intended to be fundamental soil science lab that provides hands-on experience. Field trips required. Material and supply fee will be assessed.',
  },
  {
    course_code: 'GEO4280',
    course_name: 'Basic Hydrology',
    course_desc:
      'Hydrologic cycle with emphasis upon surface water components. Particular topics include: precipitation, evapotranspiration, water budget, stream flow, and underground water sources and their measurements. Material and supply fee will be assessed for corresponding lab.\nOffered concurrently with GEO5289; graduate students will be assigned additional work.',
  },
  {
    course_code: 'GEO4280L',
    course_name: 'Basic Hydrology Lab',
    course_desc: 'Corresponding Lab for Basic Hydrology.',
  },
  {
    course_code: 'GEO4332',
    course_name: 'Senior Seminar',
    course_desc:
      'This is a course designed to provide students with skills in researching topics in the field of environmental science and making presentations to their peers along with making post-graduation professional plans. The course consists of a combination of techniques workshops, learning to conduct and present research material, content lectures and guest lectures, discussion, and student presentations. The intent of the course is to prepare upper-level undergraduates for post-graduate study and/or the job market by teaching them research, presentation, and evaluation skills. Senior level standing is required.',
  },
  {
    course_code: 'GEO4357',
    course_name: 'Environment and Economy',
    course_desc:
      'This course will cover important concepts to understanding the relationship between the environment and economy and how such an understanding can influence environmental action that is economically feasible and economic action that is environmentally supportive. It will provide an introductory insight into the history of thinking that has linked the economy and the environment, the main academic responses to resolve the tensions between the environment and economy, and introduce key topics and tools in understanding and resolving this tension. The course will also focus briefly on how environmental projects are funded in the US, and how to gain funding for such endeavors. Offered concurrently with GEO5358. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'GEO4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'GEO5007',
    course_name: 'Environmental Management and Planning',
    course_desc:
      'This course will cover important and substantive issues, concepts, and tools in the field of environmental planning and management. It will provide insight into the many actors (e.g.,\nindividuals, organizations, agencies, and levels of government) involved in environmental management and planning - both locally and internationally, and try to identify ways in which we are responsibly managing (or not) our physical environment. At the end of the course, you will have a better understanding of how the field of environmental management and planning has evolved, the issues that environmental managers and planners deal with, and the type of work environmental managers and planners engage in. Course discusses ways in which we mediate human-environment interactions in order to promote a sustainable bio-physical and social environment.\nOffered concurrently with GEO4005. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'GEO5165',
    course_name: 'Geostatistics',
    course_desc:
      'Course reviews basic sampling and experimental design skills as a means to reintroduce data analysis using standard univariate techniques in the geosciences. Introduces spatial, multivariate and time series techniques for both pattern exploration and hypothesis testing. Offered concurrently with GEO4164; graduate students will be assigned additional work. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'GEO5225',
    course_name: 'Coastal Morphology and Processes',
    course_desc:
      "An introduction to the world's coastal landforms, with emphasis upon dominant processes (especially waves, tides, and currents), geographical variations, human impacts and policies, and environmental concerns. Offered concurrently with GEO4221; graduate will be assigned additional work.",
  },
  {
    course_code: 'GEO5225L',
    course_name: 'Coastal Morphology and Processes Laboratory',
    course_desc:
      'Laboratory correlating with GEO5225. Offered concurrently with GEO4221L graduate students will be assigned additional work. Material and supply fee will be assessed.',
  },
  {
    course_code: 'GEO5246',
    course_name: 'Weather and Climate',
    course_desc:
      'Nature of individual weather elements, their measurements, and analysis over time and space. Analysis of global climate emphasizing control factors, resulting areal patterns and climatic classifications. Emphasis upon North American weather and climate patterns, micro climate, climate change, modification and related problems.',
  },
  {
    course_code: 'GEO5246L',
    course_name: 'Weather and Climate Lab',
    course_desc:
      'A one-credit, practical laboratory course, reinforcing concepts from an associated lecture section, and requiring both quantitative and conceptual analyses of weather data and weather maps to draw conclusions about real-world weather and/or climate outcomes.',
  },
  {
    course_code: 'GEO5256',
    course_name: 'Advanced Climatology and Climate Change',
    course_desc:
      "A survey of Earth's climate during the past several millennia. Explores current scientific literature on global climate as well as paleoclimatic research. Changes in Global climate prior to modern record-keeping (pre-1895) are compared and contrasted with observed contemporary global climate change. Offered concurrently with GEO4251 (Advanced Climatology and Climate Change); graduate students will be assigned additional work.",
  },
  {
    course_code: 'GEO5261',
    course_name: 'Geography of Soils',
    course_desc:
      'Nature, properties and distribution of soils and their relationship to the influence of vegetation, climate, landforms, and human activity. Understanding how soils form and how and why they vary horizontally across the landscape and vertically with depth. Emphasis upon North American patterns. Occasional field trips.',
  },
  {
    course_code: 'GEO5262L',
    course_name: 'Geography of Soils Lab',
    course_desc:
      'Deals with the nature, properties and distribution of soils and their relationship to the influence of vegetation, climate, landforms, and human activity. Intended to be fundamental soil science lab that provides hands-on experience. Field trips required. Material and supply fee will be assessed.',
  },
  {
    course_code: 'GEO5289',
    course_name: 'Basic Hydrology',
    course_desc:
      'This course focuses on the hydrologic cycle, with emphasis on surface water components. Particular topics include: precipitation, evapotranspiration, water budget, stream flow, and underground water sources and their measurements. This course is built on basic concepts established in introductory Earth Science courses, so graduate students should be familiar with those concepts.  Please consult with the course instructor for any questions regarding these prerequisite concepts.  Material and supply fee will be assessed for corresponding lab. \nCross listed with GEO4280; Graduate Students will be assigned additional work.\nCo-requisites: GEO5289L.',
  },
  {
    course_code: 'GEO5289L',
    course_name: 'Basic Hydrology Lab',
    course_desc:
      'Hydrologic cycle with emphasis upon surface water components. Particular topics include: precipitation, evapotranspiration, water budget, stream flow, and underground water sources and their measurements. This course is built on basic concepts established in introductory Earth Science courses, so graduate students should be familiar with those concepts.  Please consult with the course instructor for any questions regarding these prerequisite concepts. Material and\nsupply fee will be assessed for corresponding lab.',
  },
  {
    course_code: 'GEO5331',
    course_name: 'Environmental Science, Politics and Policy',
    course_desc:
      'This course examines the role of science and politics in the environmental policy-making process - both locally and internationally. It investigates the methods scientists use to learn about the natural world; the way scientific knowledge accumulates and disseminates; the treatment of science by advocates, dissenters, and the media; the role of science in decision making about environmental issues, and how environmental scientists can become better communicators. Offered concurrently with GEO4004; graduate students will be assigned additional work.',
  },
  {
    course_code: 'GEO5358',
    course_name: 'Environment and Society',
    course_desc:
      'This course will cover important concepts to understanding the relationship between the environment and economy and how such an understanding can influence environmental action that is economically feasible and economic action that is environmentally supportive. The course will provide an introductory insight into the history of thinking that has linked the economy and the environment, the main academic responses to resolve the tensions between the environment and economy, and introduce key topics and tools in understanding and resolving this tension. The course will also focus on how environmental projects are funded in the US, and how to gain funding for such endeavors. Offered concurrently with GEO4357. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'GEO5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'GEO5930',
    course_name: 'Seminar in Environmental Issues',
    course_desc:
      'Examines a wide spectrum of current topics that are concerned with or affect the interaction between humans and the environment. Policy issues, economic processes, and natural phenomena will all be considered as each topic is analyzed and solutions to environmental problems are sought. Offered concurrently with GEO 4333; graduate students will be assigned additional work.',
  },
  {
    course_code: 'GEO6118',
    course_name: 'Research Design',
    course_desc:
      "Introduces non-thesis-track Master's students to the essentials of designing and executing a research project in the environmental sciences using the scientific method. Students will design and complete a research project.",
  },
  {
    course_code: 'GEO6936',
    course_name: 'Graduate Seminar',
    course_desc:
      'An overview of the disciplinary evolution of the geosciences, the prevailing paradigms and methodologies, and current and future directions in the field. The scientific method, grant proposals, and research publications will be examined in detail.',
  },
  {
    course_code: 'GER1120C',
    course_name: 'German I',
    course_desc:
      'For students with no knowledge of German or with fewer than two years of high school German. Lays a foundation for speaking, writing, and reading the language. One hour of lab work per week is required.',
  },
  {
    course_code: 'GER1121C',
    course_name: 'German II',
    course_desc:
      'For students with prior knowledge of German at the basic level and /or completion of GER1120C. German II continues to introduce students to the German language and German-speaking cultures and further develops abilities in speaking, writing, and reading the language. One hour of lab work per week is required. This course is not available to native speakers. Pre-requisite is GER1120C (minimum grade of C) or successful completion of a placement test.',
  },
  {
    course_code: 'GER1905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'GER2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'GER3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'GER4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'GEY4001',
    course_name: 'Gerontology',
    course_desc:
      'This course addresses the biological impacts of the aging process on the older adult; it enhances the knowledge and understanding of biological changes associated with aging in humans and their manifestations for health care professionals who work with older adults; it addresses many biopsychosocial issues older adults may face in society today and in the future.',
  },
  {
    course_code: 'GIS3015',
    course_name: 'Cartographic Skills',
    course_desc:
      'Designed to teach students the basics of maps, including map projections, datums, grid systems, map interpretations, elements of map design, and basic field mapping. Material and supply fee will be assessed for corresponding lab. Credit cannot be received for both GEO 3100 and GIS3015.',
  },
  {
    course_code: 'GIS3015L',
    course_name: 'Cartographic Skills Lab',
    course_desc: 'Corresponding lab for Cartographic Skills.',
  },
  {
    course_code: 'GIS3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'GIS4006',
    course_name: 'Computer Cartography',
    course_desc:
      'The course focuses on the fundamentals of cartography, spatial statistics, thematic mapping techniques, and web based mapping.  Students will gain an inter-disciplinary understanding of cartographic representation and visualization with hands on applications using cutting edge GIS and graphic design software to create purpose tailored maps.  Upon successful completion of this course, students will be able to interpret and appropriately communicate spatial data; will have developed a personalized cartographic style; will have created a professional GIS portfolio for current/potential employers; and most importantly will have developed a keen appreciation for maps and spatial awareness.',
  },
  {
    course_code: 'GIS4006L',
    course_name: 'Computer Cartography Lab',
    course_desc:
      'The course focuses on the fundamentals of cartography, spatial statistics, thematic mapping techniques, and web based mapping. Students will gain an inter-disciplinary understanding of cartographic representation and visualization with hands on applications using cutting edge GIS and graphic design software to create purpose tailored maps. Upon successful completion of this course, students will be able to interpret and appropriately communicate spatial data; will have developed a personalized cartographic style; will have created a professional GIS portfolio for current/potential employers; and most importantly will have developed a keen appreciation for maps and spatial awareness. Prior to enrollment, students should be competent with Windows operating system including: storage, copying and management of multiple data types, managing multiple windows and applications, and discipline to save work frequently; basic competence with ArcGIS and Microsoft Excel is recommended.',
  },
  {
    course_code: 'GIS4035',
    course_name: 'Photo Interpretation and Remote Sensing',
    course_desc:
      'Applied skills emphasizing the fundamentals of aerial photograph interpretation and basics of multiband spectral reconnaissance of the environment-multispectral photography, infrared, microwave scanning and multifrequency radar systems. Application includes their uses in the study of cultural and biophysical phenomena. Material and supply fee will be assessed for corresponding lab.',
  },
  {
    course_code: 'GIS4035L',
    course_name: 'Photo Interpretation and Remote Sensing Lab',
    course_desc:
      'Corresponding lab for Photo Interpretation and Remote Sensing.',
  },
  {
    course_code: 'GIS4043',
    course_name: 'Geographic Information Systems',
    course_desc:
      'Spatial database will be queried to solve spatial problems, analyze related attributes, and produce computerized cartographic output. Examines spatial data structures, data acquisition, processing, management, manipulation, and analysis for interdisciplinary applications and research.  Permission is required. Material and Supply Fee will be assessed for corresponding lab. Credit cannot be received for both GIS4043 and GEO 4151.',
  },
  {
    course_code: 'GIS4043L',
    course_name: 'GIS Laboratory',
    course_desc:
      'This course teaches fundamental concepts and techniques of Geographic Information Systems (GIS). It covers basic concepts such as map projections, spatial data models, relational databases, spatial analysis, and visualization of spatially distributed data and phenomena. By the end of the course, students are expected to have an understanding of elementary GIS theory, working knowledge of ArcGIS, and the ability to develop GIS-based solutions to geographic modeling and analysis tasks. For most exercises, students will use real-world GIS data in order to learn how to overcome typical problems encountered by GIS practitioners. The last three weeks of the course will focus on the development, execution and presentation of a final GIS project.\nPrior to enrollment, students should be competent with Windows operating system including: storage, copying and management of multiple data types, managing multiple windows and applications, and saving files to local drives; a basic familiarity with Microsoft Excel, Word, and PowerPoint. Materials and Supply fee will be assessed.',
  },
  {
    course_code: 'HSA4431',
    course_name: 'Healthcare Operations',
    course_desc:
      'This course explores the application of operational concepts to healthcare organizations. Students will gain a solid foundation in operations and processes to improve the efficiency and effectiveness of delivering healthcare.',
  },
  {
    course_code: 'GIS4048',
    course_name: 'Applications in Geographic Information Systems',
    course_desc:
      'The Applications in GIS course strives to provide a balance between the "how-to" of using ArcGIS 10 and the "why" of GIS by explaining the roles GIS technology plays in analyzing local, regional, and international problems. The course builds upon topics covered in Introduction to GIS (GIS4043). Major components of the course include computer representation of geographic information, the construction of GIS databases, spatial analysis with GIS, application areas of GIS, and management issues that concern GIS. Examples include the study of geohazards, natural disasters, urban planning, homeland security/law enforcement, and marketing or location decisions. Laboratory exercises, case studies and course projects use true-to-life datasets to solve real-world problems.\nOffered both as a stand-alone course online and concurrently with GIS5100 at the Pensacola Campus where graduate students will be assigned additional work. Permission is required. Material and supply fee will be assessed. Credit cannot be received for both GIS4048 and GEO 4152. Basic competency with ArcGIS software is required. Prior coursework including Introduction to GIS (GIS4043 with lab) is recommended.',
  },
  {
    course_code: 'GIS4071',
    course_name:
      'Methods and Techniques in Environmental Resource Management and Planning',
    course_desc:
      "Tools, methods, and techniques employed in the study of environmental impact and resource management. Research fundamentals studied and applied to environmental problems such as land use, environmental impact studies, Florida's development of regional impact, resource evaluation, and other topics.",
  },
  {
    course_code: 'GIS4102',
    course_name: 'GIS Programming',
    course_desc:
      "In today's technology driven world we are fortunate to have access to many tools with which to analyze and explore digital spatial data. During this course students will learn to use programming techniques to create applications that perform fundamental spatial analysis and automation tasks, such as geoprocessing, editing, database management, projecting data, and map creation. The course will focus primarily on using the Python programming language within the context of Esri's desktop GIS environment. Offered as a stand-alone course online and concurrently with GIS5103 where graduate students will be assigned additional work. Permission required. Credit may not be received in both GIS4102 and GIS5103.",
  },
  {
    course_code: 'GIS4260',
    course_name: 'GIS Applications for Archaeology',
    course_desc:
      'This course will serve as an introduction to archaeological applications of GIS technology and data management and analysis. Students will learn how to compile, transform, analyze and present sources of archaeological and historical data, and will utilize this information in GIS for cultural resources interpretation, management and predictive modeling. Additionally, this course is designed to reinforce best practices for collecting spatially-related data on anthropological archaeology projects. Restricted to students in the online GIS Certificate Program. Basic competency with ArcGIS software is required. Prior coursework including GIS4043 with Lab Introduction to GIS is recommended.',
  },
  {
    course_code: 'GIS4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'GIS4930',
    course_name: 'Special Topics in Geographic Information Science',
    course_desc:
      'The Special Topics in GIS course examines scientific methods used to derive useful information from spatial data in real-world situations. We will visit various problems faced by GIS managers and analysts. Students can expect to conduct research, plan projects, import and process various types of data in a GIS, analyze and explore data based on commonly accepted methods, and report conclusions and present results where various formats are explored.\nOffered as both a stand alone course online and concurrently with GIS5935 at Pensacola campus where graduate students will be assigned additional work. Permission is required. Material and supply fee will be assessed. \nBasic competency with ArcGIS software is required. Prior coursework including GIS4043, GIS4048 and GIS4102 is recommended.',
  },
  {
    course_code: 'GIS4938',
    course_name: 'Special Topics in GIS for Archaeology',
    course_desc:
      'This course will serve as an advanced approach to archaeological applications of\nGIS technology and data management and analysis. Students will learn how to\ncompile, transform, analyze and present sources of archaeological and historical\ndata, and will utilize this information in GIS for cultural resources\ninterpretation, management and predictive modeling. Additionally, this course is\ndesigned to reinforce best practices for collecting spatially-related data on\nanthropological archaeology projects.\nRestricted to the online GIS Certificate program. Basic competency with ArcGIS software is required. Prior coursework including GIS4043, GIS4260 and GIS4102 is recommended. Offered concurrently with GIS5938; graduate students will be assigned additional work.',
  },
  {
    course_code: 'GIS4944',
    course_name: 'GIS Internship',
    course_desc:
      'Supervised application of Geographic Information Science (GIS) in business, government, non-profit, educational or other environmental organizations. Offered concurrently with GIS5945; graduate students will be assigned additional work. Permission is required.',
  },
  {
    course_code: 'GIS5007',
    course_name: 'Computer Cartography',
    course_desc:
      'The course focuses on the fundamentals of cartography, spatial statistics, thematic mapping techniques, and web based mapping.  Students will gain an inter-disciplinary understanding of cartographic representation and visualization with hands on applications using cutting edge GIS and graphic design software to create purpose tailored maps.  Upon successful completion of this course, students will be able to interpret and appropriately communicate spatial data; will have developed a personalized cartographic style; will have created a professional GIS portfolio for current/potential employers; and most importantly will have developed a keen appreciation for maps and spatial awareness.',
  },
  {
    course_code: 'GIS5265',
    course_name: 'GIS Applications for Archaeology',
    course_desc:
      'This course will serve as an introduction to archaeological applications of GIS technology and data management and analysis. Students will learn how to compile, transform, analyze and present sources of archaeological and historical data, and will utilize this information in GIS for cultural resources interpretation, management and predictive modeling. Additionally, this course is designed to reinforce best practices for collecting spatially-related data on anthropological archaeology projects. Restricted to students in the online GIS Certificate program. Basic competency with ArcGIS software is required. Prior coursework including Introduction to GIS (GIS4043 or GIS5050 with lab) is recommended.',
  },
  {
    course_code: 'GIS5007L',
    course_name: 'Computer Cartography Lab',
    course_desc:
      'The course focuses on the fundamentals of cartography, spatial statistics, thematic mapping techniques, and web based mapping. Students will gain an inter-disciplinary understanding of cartographic representation and visualization with hands on applications using cutting edge GIS and graphic design software to create purpose tailored maps. Upon successful completion of this course, students will be able to interpret and appropriately communicate spatial data; will have developed a personalized cartographic style; will have created a professional GIS portfolio for current/potential employers; and most importantly will have developed a keen appreciation for maps and spatial awareness. Prior to enrollment, students should be competent with Windows operating system including: storage, copying and management of multiple data types, managing multiple windows and applications, and discipline to save work frequently; basic competence with ArcGIS and Microsoft Excel is recommended.',
  },
  {
    course_code: 'GIS5027',
    course_name: 'Aerial Photography and Remote Sensing',
    course_desc:
      'This course is designed to familiarize students with the fundamentals of remote sensing and photo interpretation through hands-on techniques with aerial photographs and satellite imagery based on real-world applications. Both active and passive sensors will be discussed in lecture. The course is broken up into two distinct sections - the first five weeks are spent interpreting digital aerial photographs; the rest of the semester is spent examining and manipulating digital data from satellites and other remote sensors. \nThe lecture will focus on the history, technology, concepts, processes, and applications of Aerial Photography and Remote Sensing. \nPlease consult with the course instructor for any questions regarding these prerequisite concepts. Introduction to GIS, GIS4043 or GIS5050 with Lab is recommended prerequisite. Offered concurrently with GIS4035, graduate students will be assigned additional work.',
  },
  {
    course_code: 'GIS5027L',
    course_name: 'Aerial Photography and Remote Sensing Lab',
    course_desc:
      'This course is designed to familiarize students with the fundamentals of remote sensing and photo interpretation through hands-on techniques with aerial photographs and satellite imagery based on real-world applications. Both active and passive sensors will be discussed in lecture. The course is broken up into two distinct sections - the first five weeks are spent interpreting digital aerial photographs; the rest of the semester is spent examining and manipulating digital data from satellites and other remote sensors.\nThe lab will focus on techniques for the practical use of digital aerial photography and satellite imagery using both Erdas Imagine and ESRI ArcGIS. The labs are structured to complement the material and readings assigned in lectures. Please consult with the course instructor for any questions regarding these prerequisite concepts. Introduction to GIS, GIS4043 or GIS5050 with Lab is recommended prerequisite. Offered concurrently with GIS4035, graduate students will be assigned additional work.',
  },
  {
    course_code: 'GIS5050',
    course_name: 'Geographic Information Systems',
    course_desc:
      'This course teaches fundamental concepts and techniques of Geographic Information Systems (GIS). It covers basic concepts such as map projections, spatial data models, relational databases, spatial analysis, and visualization of spatially distributed data and phenomena. The applications of GIS are presented. Future issues for GIS and state-of-the-art technology are also discussed. \nCross listed with GIS4043; Graduate students will be assigned additional work.',
  },
  {
    course_code: 'GIS5050L',
    course_name: 'Geographic Information Systems Lab',
    course_desc:
      'This course teaches fundamental concepts and techniques of Geographic Information Systems (GIS). It covers basic concepts such as map projections, spatial data models, relational databases, spatial analysis, and visualization of spatially distributed data and phenomena. By the end of the course, students are expected to have an understanding of elementary GIS theory, working knowledge of ArcGIS, and the ability to develop GIS-based solutions to geographic modeling and analysis tasks. For most exercises, students will use real-world GIS data in order to learn how to overcome typical problems encountered by GIS practitioners. The last three weeks of the course will focus on the development, execution and presentation of a final GIS project.\nPrior to enrollment, students should be competent with Windows operating system including: storage, copying and management of multiple data types, managing multiple windows and applications, and saving files to local drives; a basic familiarity with Microsoft Excel, Word, and PowerPoint. Cross listed with GIS4043L; Graduate students will be assigned additional work. Materials and Supply fee will be assessed.',
  },
  {
    course_code: 'GIS5100',
    course_name: 'Applications in Geographic Information Systems',
    course_desc:
      'The Applications in GIS course strives to provide a balance between the "how-to" of using ArcGIS 10 and the "why" of\nGIS by explaining the roles GIS technology plays in analyzing local and regional (even global) problems. The course\nbuilds upon topics covered in Introduction to GIS (GIS4043). Major components of the course include computer\nrepresentation of geographic information, the construction of GIS databases, spatial analysis with GIS, application areas\nof GIS, and social and management issues that concern GIS. A generic process for applying GIS techniques in problem solving is introduced, and several case studies of GIS applications in environmental and social domains will be analyzed. Offered both as a stand-alone course online and concurrently with GIS4048 on the Pensacola Campus where graduate students are assigned additional work. Material and supply fee will be assessed. Credit cannot be received for both GIS5100 and GEO 5157. Basic competency with ArcGIS software is required. Prior coursework including Introduction to GIS (GIS4043 or GIS5050 with lab) is recommended.',
  },
  {
    course_code: 'GIS5103',
    course_name: 'GIS Programming',
    course_desc:
      "In today's technology driven world we are fortunate to have access to many tools with which to analyze and explore digital spatial data. During this course students will learn to use programming techniques to create applications that perform fundamental spatial analysis and automation tasks, such as geoprocessing, editing, database management, projecting data, and map creation. The course will focus primarily on using the Python programming language within the context of Esri's desktop GIS environment. Offered as a stand-alone course online and concurrently with GIS4102 where graduate students will be assigned additional work. Permission is required. Credit may not be received in both GIS5103 and GIS4102. Basic competency with ArcGIS software is required. Completion of GIS4043 with Lab or GIS5050 with lab is recommended.",
  },
  {
    course_code: 'HIS4935',
    course_name: 'Senior Seminar',
    course_desc:
      'The Senior Seminar is the capstone experience for history majors.  Students will work closely with the instructor to create a substantial and original research paper based on primary sources.  This course requires the student to utilize a broad range of skills required of a historian.  The seminar will conclude with a oral presentation.',
  },
  {
    course_code: 'GIS5935',
    course_name: 'Special Topics in Geographic Science',
    course_desc:
      'Geographic information systems (GIS) today are being used by everyone from scientists to everyday citizens to solve geographic problems ranging from the very simple to the extremely complex. As the use of GIS and the availability of digital data increase, GIS users need to be aware of how the data being put into a GIS affects the reliability of the information products being produced from a GIS. Producing new and useful information from spatial data requires a thorough understanding of their limitations and the methods used to process them. Students explore GIS theory and practice related to the visualization, measurement, transformation, and optimization of spatial data. An underlying theme that uncertainty is an inherent characteristic of spatial data is thoroughly examine and students learn how to identify it, measure it, and live with it.\nBy the end of this course, students will have gained extensive knowledge about various GIS analysis techniques, methods, outputs and uncertainties as they relate to specific problems experienced by many cities (large and small) around the world. Combining lessons learned in previous GIS courses with more in-depth techniques presented in this course gives students the opportunity to piece together previous knowledge and gain a greater sense of understanding for what it means to conduct GI Science.\nOffered as both a stand alone course online and concurrently with GIS4930 at the Pensacola Campus where graduate students will be assigned additional work. Permission is required. Material and supply fee will be assessed. Competency with GIS topics and ArcGIS software is required. Prior coursework including GIS4043 or GIS5050, GIS5100 and GIS5103 are recommended.',
  },
  {
    course_code: 'GIS5938',
    course_name: 'Special Topics in GIS for Archaeology',
    course_desc:
      'This course will serve as an advanced approach to archaeological applications of GIS technology and data management and analysis. Students will learn how to compile, transform, analyze and present sources of archaeological and historical data, and will utilize this information in GIS for cultural resources interpretation, management and predictive modeling. Additionally, this course is designed to reinforce best practices for collecting spatially-related data on anthropological archaeology projects.\nRestricted to students in the online GIS Certificate program. Offered concurrently with GIS4938; graduate students will be assigned additional work. Competency with ArcGIS software is required. Prior coursework including GIS4043 or GIS5050 with lab and GIS5265 is recommended.',
  },
  {
    course_code: 'GIS5945',
    course_name: 'GIS Internship',
    course_desc:
      'Supervised application of Geographic Information Science (GIS) in business, government, non-profit, educational, or other environmental organizations. Offered concurrently with GIS4944; graduate students will be assigned additional work. Permission is required.',
  },
  {
    course_code: 'GIS6005',
    course_name: 'Communicating GIS',
    course_desc:
      'This course begins with the basic theory of graphic design, cartography, and map\nproduction and distribution. Students then learn to communicate specific types of spatial and analytical information through maps, written and oral explanations, graphs, tables, charts, and interactive web mapping applications. \nCourse includes lecture, hands-on exercises, written reports, and a final presentation. Restricted to students majoring in MS GIS Administration program, it is best taken during one of the first three semesters. Basic competency in GIS concepts and software is expected.',
  },
  {
    course_code: 'GIS6105',
    course_name: 'Spatial Data Management',
    course_desc:
      'This course begins with the basic theory of database design. It then proceeds on to incorporate spatial data and its unique data management requirements. Students then learn how to extract, transform and load spatial data and its associated attribute data using specific GIS case study workflows. \nCourse includes lecture, hands-on exercises, written reports, and a final project with a presentation requirement. \nPrior coursework in Introduction to GIS and GIS Programming is recommended.',
  },
  {
    course_code: 'GIS6110',
    course_name: 'Advanced Topics in Geographic Information Science',
    course_desc:
      'This class brings together a number of open source GIS tools in order to educate students on the methods and processes behind web-based geographic information systems (Web GIS). Specifically, we will review techniques with spatial databases, web mapping application programming interfaces (APIs), geospatial scripting and theories of map interaction within the context of Web GIS. In order to achieve this near-complete picture of how Web GIS works use a pattern of software architecture known as model-view-controller or MVC. Finally, we will cover design considerations for Web GIS within browsers on mobile devices. Material and supply fee will be assessed. Credit cannot be received for both GIS6110 and GEO 6159. Competency with the principles of GIS and ArcGIS software is required. Prior upper-level GIS course work (GIS5100, GIS5935, GIS5103) is recommended.',
  },
  {
    course_code: 'GIS6555',
    course_name: 'Geographic Information Systems Management',
    course_desc:
      'This course provides practical information on the development, implementation, and operation of GIS programs and projects intended for both seasoned and aspiring GIS managers. The course focuses on planning and implementing GIS solutions for government agencies and contractors. The course combines lecture, discussion, and group exercises. An end of term project involves writing in response to real or hypothetical solicitations for a project that targets GIS tool development, implementation, and/or training to support management activities in local, regional, state, national, or international contexts. Restricted to students in MS GIS Administration program and is best completed  towards the last half of the program and before enrolling in GIS6955 GIS Capstone.',
  },
  {
    course_code: 'GIS6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'GRA3112C',
    course_name: 'Graphic Design Studio II',
    course_desc:
      "This course focuses on the refinement of student's problem-solving abilities through the advanced application of the design process. Students  will work to gain control over the interaction of perceptual and conceptual compositional elements to enhance visual communication skills. Students research and analyze topical subjects to create works of visual communication skills. Students research and analyze topical subjects to create works of visual communication as they explore the role of graphic design in visual culture. This course varies by semester and instructor to  cover some of the following depending on the term: Poster Design and Digital Illustration, Branding and Identity Systems, Data Visualization and Information Design, and Packaging Design.",
  },
  {
    course_code: 'HIS4955',
    course_name: 'Overseas and Field Study in History',
    course_desc:
      'Supervised independent study in historical field research or study in the United States or overseas. Studies include, but are not restricted to, foreign research, supervised visitation and analytical observation of historical sites, participation in foreign university exchange programs. Permission is required.',
  },
  {
    course_code: 'GIS6955',
    course_name: 'GIS Capstone',
    course_desc:
      "A final capstone experience for students who are nearing completion of their MS GIS Administration program. \nPrior to enrollment, students must submit a capstone intention form to program faculty outlining their project idea, relevant research, potential client(s), and review committee members. Upon faculty approval, the student may enroll in capstone and begin writing a draft project proposal, including a literature review for committee review. By the end of the first semester, students are expected to have completed a final proposal and gain approval from their review committee before enrolling in the second capstone course. The second semester of capstone is dedicated to carrying out the project and presenting findings and/or products in the form of (at least) a paper and presentation. \nStudents work in collaboration with local partners, faculty, or the student's current employer to develop a real-world GIS application. Working independently, students: communicate with project partners to identify project goals; acquire and prepare spatial data for GIS data analysis; communicate with project partners to assess progress; manage spatial data; and produce necessary outputs for presentation as part of a final report. \nThis final project should affirm the student's ability to think critically and creatively, to solve practical problems, to make reasoned and ethical decisions, and to communicate effectively. The capstone course serves as documentation of the student's personal mastery of professional competencies. It is designed to be an integrative experience for MS GIS Administration students.\nCourse is restricted to students in their last two semesters of the MS GIS Administration program.",
  },
  {
    course_code: 'GLY2010',
    course_name: 'Physical Geology',
    course_desc:
      'Material, structures, surface features of the earth and processes that have produced them.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'GLY2010L',
    course_name: 'Physical Geology Laboratory',
    course_desc:
      'Lab correlating with GLY2010. Material and supply fee will be assessed.',
  },
  {
    course_code: 'GLY3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'GLY4240',
    course_name: 'Geochemistry',
    course_desc:
      'Fundamentals of the interactions between geological and chemical concepts in Earth systems. Will assess how chemical properties influence geological and environmental processes in a range of Earth environments. Topics will include the application of geochemical tools to interpret modern and ancient environments. Offered concurrently with GLY5246; graduate students will be assigned additional work.',
  },
  {
    course_code: 'GLY4244',
    course_name: 'Biogeochemistry',
    course_desc:
      'An introduction to the interactions between biological and inorganic components of Earth systems. Integrates fundamental concepts of Biology, Geology, and Chemistry. Topics will include the interactions of major nutrient cycles and connections between Earth components (atmosphere, lithosphere, and hydrosphere). Offered concurrently with GLY5266; graduate students will be assigned additional work. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'GLY4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'GLY5246',
    course_name: 'Geochemistry',
    course_desc:
      'Fundamentals of the interactions between geological and chemical concepts in Earth systems. Will assess how chemical properties influence geological and environmental processes in a range of Earth environments. Topics will include the application of geochemical tools to interpret modern and ancient environments. Offered concurrently with GLY4240; graduate students will be assigned additional work. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'GLY5266',
    course_name: 'Biogeochemistry',
    course_desc:
      'An introduction to the interactions between biological and inorganic components of Earth systems. Integrates fundamental concepts of Biology, Geology, and Chemistry. Topics will include the interactions of major nutrient cycles and connections between Earth components (atmosphere, lithosphere, and hydrosphere). Offered concurrently with GLY4244; graduate students will be assigned additional work. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'GLY6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'GRA2111C',
    course_name: 'Introduction to Graphic Design',
    course_desc:
      'An overview of the formal elements of design, contextualized within a framework that stresses experimentation, creativity, innovation, and expression.  An introduction to design fundamentals used in all advanced applications of design. An exploration of the principles of design as the necessary foundations for all applied art and design work. Products using vector-based and raster-based design applications to combine type and graphics are oriented towards commercial applications. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'GRA2208C',
    course_name: 'Typography',
    course_desc:
      'This course is an examination of basic typography as a compositional tool.  Students will explore the architecture of type from a single letterform to an entire page layout.  Students will be introduced to the history of typography and explore concepts relating to contextualization of            typographic form in relation to that history.  This class will investigate  issues of denotation\nand connotation, context and theme, graphic/image-type  relationships, and / or expression through a refinement of the craft of typography.',
  },
  {
    course_code: 'GRA2508C',
    course_name: 'Color Theory',
    course_desc:
      'Study of the additive and subtractive principles of color theory as they apply to the visual communications in the fine and applied arts. Emphasis placed on color mixing, color relationships, visual impact as well as psychological and symbolic uses of color. Topics will include major historical and contemporary color systems, production of projects in applied color, and the elements of design as they apply to color.',
  },
  {
    course_code: 'GRA3102C',
    course_name: 'Graphic Design Studio I',
    course_desc:
      "This course focuses on the refinement of student's problem-solving abilities through the advanced application of the design process. Students will work to gain control over the interaction of perceptual and conceptual compositional elements to enhance visual communication skills. Students research and analyze topical subjects to create works of visual communication as they explore the role of graphic design in visual culture. This course varies by semester and instructor to cover some of the following depending upon the term: Poster Design and Digital Illustration, Branding and Identity Systems, Data Visualization and Information Design, and Packaging Design. Emphasis will be placed on expressive and creative communication through rough design.",
  },
  {
    course_code: 'GRA3139C',
    course_name: 'Motion Graphics',
    course_desc:
      'A further articulation of the techniques and components of time-based media design.  Exercises and projects will introduce basic concepts of art and design in time. Students will use time and movement, elements of the moving image, serial, sequential, and narrative ordering, moving image editing, sound and image relations, as well as object and event analysis to create time-based designs. Students will develop advanced skills in time-based media as an expressive and communicative art form. Aesthetic, technical, historical, and conceptual issues will be addressed through lectures, demonstrations, exercises, projects, screenings, research, and readings.',
  },
  {
    course_code: 'GRA3151C',
    course_name: 'Digital Illustration',
    course_desc:
      'An introductory class in creating illustration in a digital environment. Topics including the study of illustration as visual interpretation of words, concepts, and ideas. Students are challenged by assignments based on jobs typical of those given in the professional arena such as advertising, publishing, and editorial illustration. Students will develop illustrations using traditional thumbnails, sketches, and color studies, and complete the final artwork using industry standard software in a digital environment with digital tablets and pens. Students will learn to render in varying styles, and begin to develop a digital illustration style of their own. Final digital illustrations will be expected to demonstrate the same qualities as traditional illustration, including but not limited to style, composition, color theory, perspective, and concept. Final illustrations will also be assessed for technical cleanliness, edit-ability, and adherence to guidelines given.',
  },
  {
    course_code: 'GRA3196',
    course_name: 'Contemporary Design Culture',
    course_desc:
      'Exploration of contemporary design culture presented in a studio problem-solving format. Explores how the interplay of artists, designers, and thinkers with technological and economic forces has created the look and feel of the objects and practices that shape our culture. Combines study of pop culture and recent design history with an investigation of philosophical, sociological, psychological, and technological issues. This senior-level studio course consists of three advanced projects that are built around the study of modern, post-modern, and contemporary design theory.',
  },
  {
    course_code: 'GRA3225C',
    course_name: 'Typography II: Publication Design',
    course_desc:
      'Typography II offers an advanced understanding of typographic conventions and standards (placement, order or chronology, size, weight, leading or interline spacing, column width, alignment, style, orientation, and choice of typeface) and the principles of how legibility and readability affect visual communication for print and web. User experience will also play a role in how information is read, created, and understood. The conventions and standards used are placed within context. Students are introduced to the interconnectedness of systems, with particular focus on what those systems are, how contexts affect the production and interpretation of typographic messages, how meaning is constructed, and structural and relational aspects of hierarchy.',
  },
  {
    course_code: 'GRA3521C',
    course_name: 'Graphic Design for Interactive Applications',
    course_desc:
      'An intermediate graphic design course involving complex interactive projects for the web and other technologies using standards-compliant HTML and CSS. Students will have the opportunity to learn the application of semantic code markup in order to gain an understanding of the separation of content and form in dynamic media. Alternate forms of scripting for the web and interaction with databases will also be introduced.',
  },
  {
    course_code: 'GRA3881C',
    course_name: 'Understanding Comics: Sequential Art and Design',
    course_desc:
      'An exploration of how signs and symbols are used to create meaning in design.',
  },
  {
    course_code: 'GRA4154C',
    course_name: 'Advanced Digital Illustration',
    course_desc:
      'An advanced class in creating illustration in a digital environment, meant as a further exploration of topics introduced in GRA3151C Digital Illustration. Topics including the study of illustration as visual interpretation of words, concepts, and ideas will be explored more thoroughly. Students will continue to develop illustrations in a digital environment based on assigned tasks typical of those given in the professional arena such as advertising, publishing, and editorial illustration while advancing illustration skills and further developing an illustration style of their own.',
  },
  {
    course_code: 'GRA4873C',
    course_name: 'Exhibition Design Studio',
    course_desc:
      'The students will work with the graphic design faculty and various arts directors at UWF to learn to produce real world event graphics; arts event collateral including postcards, brochures, and catalogs; exhibition design components including super graphics; and other designs for various UWF Arts events. The students will work in the digital lab as well as on-site/ in-the-field with the museum directors and exhibit designers of the UWF Center for Fine and Performing Arts and the Historic Trust including the Pensacola Museum of Art to produce designs for the various events at the Center and the Trust. Students will respond to professional project briefs to create presentations and project proposals. The implementation of the projects will take place in the field, by students working directly with museum professionals to produce designs to be used in the field, at both the UWF Center for Fine and Performing Arts and the Museums of the UWF Historic Trust.',
  },
  {
    course_code: 'GRA4874C',
    course_name: 'Senior Design Studio',
    course_desc:
      "Designed for seniors in the Graphic DesignBFAprogram to pursue long term specialized projects in the students' chosen fields of study.Projects may include the development of a single (or sequential) large-scale design project as well as thedesignanddevelopment ofwork for thethe seniorgraduation exhibition and thesenior graphic design portfolio.Projects will be realized physically as well as in digital/oral presentation form.May be designated a capstone experience. Permission is required.6 credits total required of Graphic Design majors to be taken in Fall and Spring of Senior Year.Material and Supply Fee will be assessed.",
  },
  {
    course_code: 'GRA4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'GRA4930C',
    course_name: 'Special Topics in Digital Media Design',
    course_desc:
      "This course focuses on the refinement of student's problem-solving abilities through the advanced application of the design process. Students will work to gain control over the interaction of perceptual and conceptual compositional elements to enhance visual communication skills. Students research and analyze topical subjects to create works of visual communication as they explore the role of graphic design in visual culture.",
  },
  {
    course_code: 'HIS4284',
    course_name: 'Maritime History',
    course_desc:
      'Survey of impact of oceans, rivers and other bodies of water upon the development of mankind. Focus on settlement in maritime areas, maritime commerce, exploration, military and naval history, social intellectual and other activities and developments impacted or influenced by the sea.',
  },
  {
    course_code: 'HIS6911',
    course_name: "Master's Research",
    course_desc: 'Permission is required.',
  },
  {
    course_code: 'GRA4940L',
    course_name: 'Internship in Graphic Design',
    course_desc:
      'On an "as available" basis, Graphic Design majors may request an internship by submitting written proposals to the Graphic Design Internship Coordinator. Proposals must be approved by the Graphic Design Internship Coordinator prior to registration. Senior status, 2.5 GPA overall, and a 3.0 GPA in Graphic Design required. All internships include report on internship experience, including weekly journals, written reports and an oral presentation to department advisor. Graded on a satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'GRA4950C',
    course_name: 'Graphic Design Portfolio/Presentation/Exhibition',
    course_desc:
      'This course focuses on the development and execution of the graphic design portfolio across several platforms including print, networked, and website. Additionally, this course focuses on the development of the graphic design presentation, also across multiple platforms including physical/oral and digital/oral. Final, the course focuses on the presentation of graphic communication in space, or the exhibition of graphic design. Topics include creation of personal design identities across multiple platforms and design team collaboration. Interview, job search, and design pitch skills will be discussed and developed through the practice of visual/oral design presentation. Individual assignments will be given to strengthen and round out each portfolio.',
  },
  {
    course_code: 'GRE3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'HFT2000',
    course_name: 'Introduction to the Hospitality Industry',
    course_desc:
      'Introduction to management career options within the hospitality industry; which includes lodging, food and beverage, meetings and conventions, recreation and leisure, gaming entertainment, cruising, clubs, and transportation. The importance of leadership and service culture are also discussed.',
  },
  {
    course_code: 'HFT3053',
    course_name: 'Travel and Tourism Management',
    course_desc:
      'Future innovative hospitality leaders will explore the critical connections between destinations, communities, and the hospitality and tourism industry. Economic, environmental, and socio-cultural impacts of the hospitality and tourism industry are differentiated, assessed, and analyzed through real-world examples.',
  },
  {
    course_code: 'HFT3214',
    course_name: 'Hospitality Safety, Sanitation and Risk Management',
    course_desc:
      'Study of safety and sanitation management principles in the hospitality industry related to safe food handling practices and responsible alcohol service. Students may obtain National Restaurant Association ServSafe Food Safety and ServSafe Alcohol certifications.',
  },
  {
    course_code: 'HFT3221',
    course_name: 'Human Resources in the Hospitality Industry',
    course_desc:
      'Introduction to human resource management in the hospitality industries with emphasis placed upon motivation and training. Guest satisfaction is dependent upon employee satisfaction; therefore, strategies are explored to combat the high turnover which characterizes hospitality fields.',
  },
  {
    course_code: 'HFT3271',
    course_name: 'Spa Management',
    course_desc:
      "An examination of today's spa industry, spa careers, spa director's perspective, quality of spa experience, industry trends and future directions. Students will learn best practices that have proven successful in the spa industry. Major treatments/shared/services are reviewed: facial therapies, massage therapies, water therapies, face and body services, salon services, exercise, personal training, etc. In addition to operations, the functional areas of marketing, human resources, and financial management are discussed within the context of spas.",
  },
  {
    course_code: 'HFT3333',
    course_name: 'Contemporary Club Management',
    course_desc:
      'Introduction to the world of private club management, including club governance, service excellence, organizational structure, human resources, quality management systems for clubs, government regulations, club marketing, food and beverage operations, computer technology for clubs, golf operations in clubs, club fitness operations, and club facilities management. Students learn how to incorporate sustainability practices in club management.',
  },
  {
    course_code: 'HFT3414',
    course_name: 'Managing Front Office Operations',
    course_desc:
      'Provide a systematic approach to front office procedures by detailing the flow of business through a hotel, from the reservations process to check-out and account settlement. Various elements of effective front office management will be examined, paying particular attention to the planning and evaluation of front office operations and to human resources management. Front office procedures and management are discussed within the context of the overall operation of a hotel.',
  },
  {
    course_code: 'HFT3444',
    course_name: 'Global Citizenship in Hospitality and Tourism',
    course_desc:
      'This course will serve as an exploration for students who are interested in global travel, global careers, and overall understanding of global citizenship while traveling.  Students will research and become aware of how to contribute in global culture, communities, education, and within hospitality organizations.  This course will foster an understanding of hospitality and tourism from the global lens which will promote cross-cultural communications.',
  },
  {
    course_code: 'HFT3745',
    course_name: 'Innovative Technologies for Hospitality & Tourism',
    course_desc:
      'Provides future innovative hospitality leaders with information regarding technology applications, trends and issues specific to the hospitality and tourism industry. The role of technology to gain competitive advantage in the hospitality and tourism industry will be the main focus. Examples of technologies that students will explore include technology to help manage guest rooms, e-commerce, social media, distribution, self-service engagement, cybersecurity and others designed for the hospitality and tourism industry.',
  },
  {
    course_code: 'HFT3814C',
    course_name: 'Management of Food and Beverage Operations',
    course_desc:
      'Provides the foundation for understanding the various challenges and responsibilities involved in food and beverage management. Students will examine the formulation, implementation, and evaluation of food and beverage organizations and apply the conceptual frameworks to specific situations. Many aspects of food and beverage operations are introduced, including organization, marketing, menus, costs and pricing, production, service, safety, and finances.',
  },
  {
    course_code: 'HFT3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'HIS4316',
    course_name: 'Women in the Atlantic World',
    course_desc:
      'Examines the Atlantic World through the experiences of African, European, and American Women. Explores how women fit within the continuously evolving multicultural setting of the sixteenth, seventeenth, and eighteenth centuries.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'HIS4491',
    course_name: 'History of Medicine and Society',
    course_desc:
      'Explores the selected topics in the history of western medicine and public health from the early modern period to the present.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'HFT3932',
    course_name:
      'The Disney Semester: Experiential Learning in the Hospitality Industry',
    course_desc:
      "As a Disney College Program participant, you'll gain valuable, on-the-job experience working in the Disney parks and resorts, participating in college coursework, and having the opportunity to meet and live with people from all over the country and potentially the world in company-sponsored housing. Student participants will work at Walt Disney World in Orlando, Florida. This truly unique program allows participants to network with leaders, take part in personal and career development classes, and build transferable skills related to, for example, problem-solving, teamwork, guest service, and effective communication. Students must apply and be accepted into the Walt Disney World College Program. Permission is required.",
  },
  {
    course_code: 'HFT3941',
    course_name: 'Field Study in Hospitality, Recreation and Resort Management',
    course_desc:
      'Students work in a hospitality, recreation or resort-related organization under the supervision of an agency representative and a faculty advisor. Skills, knowledge and values are developed on-the-job in entry level service industry positions; total of 300 work hours. Permission is required.',
  },
  {
    course_code: 'HFT4106',
    course_name: 'Global Hospitality and Tourism Shared Economies',
    course_desc:
      'This course offers the study of unconventional economic and social activities involving peer-to-peer based sharing of access to goods and services through transactions occurring mainly online, known as "Shared or Access Economies." It will focus on how these are directly affecting the global hospitality and tourism industry. Students experience the different hospitality-related shared economies, infrastructures, and impacts on the present and future of our industry. Resources utilized will include case studies, research, and course materials that expand on the topic, specifically focusing on Access Economies. Senior status is required. Restricted to BSBA majors. Offered concurrently with HMG5296; graduate students will be assigned additional work.',
  },
  {
    course_code: 'HFT4252',
    course_name: 'Hotel and Resort Management',
    course_desc:
      "This course defines the principles, practices, and procedures of managerial functions, operating procedures, and competencies hotel and resorts.   Students gain knowledge on management, ownership, franchising, and other current topics in the hotel and resort industry with a focus on the analysis of data as they apply it to operational and fiscal decision making. Stemming from the operational manager's perspective, industry-specific tools are used to discuss performance analysis, including but not limited to, service measurement, financial performance measurement, turnover and human resources information, competitor performance data, and other measures of operational performance.",
  },
  {
    course_code: 'HFT4274',
    course_name: 'Condominium and Vacation Interval Ownership',
    course_desc:
      'A comprehensive study of timeshare and vacation ownership of condominium properties. Legal structures, projects budgeting, marketing, sales and property management. Students are introduced to the fastest growing segment of the lodging industry. Differences between traditional and non-traditional lodging operations are examined.',
  },
  {
    course_code: 'HFT4277',
    course_name: 'Resort Operations and Management',
    course_desc:
      'This course is taught as an overview - covering resort history, resort operations, and trends for the future. It is taught from a Department Manager perspective. Emphasis will be placed upon the functions of each department and the interrelationships between departments.',
  },
  {
    course_code: 'HFT4295',
    course_name: 'Strategic Leadership in Hospitality Management',
    course_desc:
      'Strategic management case approach is used to solve realistic problems by drawing upon all previous course concepts while developing leadership skills. In depth analysis of hospitality and tourism organizations dealing with strategic planning, leadership, management, budgeting, records and reports, risk management, staff organization, and coordination of resources.',
  },
  {
    course_code: 'HFT4343',
    course_name: 'Planning and Design for the Hospitality Industry',
    course_desc:
      'Provides information needed to manage the physical plant of a hotel or restaurant and work effectively with the engineering and maintenance department.',
  },
  {
    course_code: 'HFT4426',
    course_name: 'Hospitality Financial Analysis & Revenue Optimization',
    course_desc:
      'Students will gain analytical and technical proficiency of financial analysis within the hospitality industry. Using financial data, students will study hotel performance reports to determine critical elements to maximize revenue and develop strategies to improve profitability. Upper level status is required. Offered concurrently with HMG5466; graduate students will be assigned additional work.',
  },
  {
    course_code: 'HFT4462',
    course_name: 'Revenue Management for Hospitality Business',
    course_desc:
      'This course is designed to provide the students with an applied understanding of the strategies and tactics used in hospitality revenue management. The fundamental principles and concepts of revenue management including capacity management, duration control, demand and revenue forecasting, discounting, overbooking practices, displacement analysis, rate management and sales mix analysis will be discussed throughout the term. The course will also examine best pricing strategies that increase revenue during seasonal low periods and maximize revenues during high demand seasons. Senior status required.',
  },
  {
    course_code: 'HFT4481',
    course_name:
      'Advanced Revenue Management and Predictive Analytics in Hospitality',
    course_desc:
      "Exploration of revenue management, big data, and predictive analytics within the hospitality industry from a comprehensive perspective as it pertains to the importance of generating business revenues and contributions to the overall service-firm's value proposition and financial performance. Students will identify the direct link between big data and hospitality and learn how to incorporate analytics into strategic management initiatives. Students will learn which data types are critical, how to identify productive data sources, and how to integrate analytics into multiple business processes to create an overall analytic culture that turns information into insight. This course will serve as the Global Hospitality and Tourism BSBA capstone. Senior status is required. Restricted to BSBA majors.",
  },
  {
    course_code: 'HFT4503',
    course_name: 'Service Experience Marketing for Hospitality Management',
    course_desc:
      'Provides students with management skills related to marketing and sales for hotels. The best practices that have proven successful in marketing and sales in the hospitality industry are also discussed. Offered concurrently with HMG5506; graduate students will be assigned additional work.',
  },
  {
    course_code: 'HIS4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'HFT4536',
    course_name: 'Hospitality Innovation and Brand Design',
    course_desc:
      "Hospitality industry organizations connote instantaneous images, associations, and expectations. Innovative brands indeed play an imperative role on the 21st century consumer, driving loyalty and business by aligning with the customer's perception of oneself. This course explores the power of brands across the hospitality industry on guests, associates, and management alike, with special emphasis on the translation of brand aspirations to design and experience creation, delivery to guests, and the future role of a brand in general. Initial investigations explore the components of a brand, from its mission and positioning, to defining target and aspirational audiences. Students will assess the ideas behind rendering big-picture values into sophisticated experiences for guests at engineered moments, as well as the business of hospitality design, brand administration, and standards and compliance. Senior status is required.",
  },
  {
    course_code: 'HFT4753',
    course_name: 'Special Event Management',
    course_desc:
      'Convention facilities, convention and visitors bureaus, sponsors, host venues, stakeholders, tradeshow and meeting management are examined. Analysis of the methods and techniques of event design, organization, implementation, and evaluation. Legal issues and trends are studied. The economic impact of the special events business upon destinations is studied.',
  },
  {
    course_code: 'HFT4799',
    course_name: 'Hospitality and Tourism Experience Management',
    course_desc:
      'This is the capstone course for the Global Hospitality and Tourism BS degree. The course experience allows students to utilize what they have learned in their previous course work by applying it to a real life project that is specific to the hospitality and tourism industry. The course focus, for example, is on the guest experience, interactions between guests and service providers, guest perceptions of service, quality assurance, and best practices in the creation of engaging hospitality and tourism guest experiences.',
  },
  {
    course_code: 'HFT4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'HFT4940',
    course_name: 'Internship in Hospitality Management',
    course_desc:
      'Students are required to work 800 paid hours in a hospitality industry position. Students work in a hospitality, recreation or resort related organization and have the opportunity to  put theory into practice through active participation. Students are supervised by a management-level agency employee as well as by a faculty advisor. Permission is required to enroll.',
  },
  {
    course_code: 'HFT4945',
    course_name: 'Internship and Career Development Preparation',
    course_desc:
      'Students are required to work a total of 500 hours in a hospitality industry position to complete their degree. This is the first of 3 internship classes. This is an online class that students must take before they sign up for the internship experiences. This class explains the internship process and helps students select appropriate experiences.',
  },
  {
    course_code: 'HFT4946',
    course_name: 'Global Leadership Development II: Cross-Functional Training',
    course_desc:
      'Students are required to work a total of 500 hours in hospitality industry positions to complete their degrees. This is the second of three internship classes. Students must work in the hospitality or tourism industry and have the opportunity to put theory into practice through active participation. Students are supervised by a management-level agency employee. Permission is required to enroll. Students should work a minimum of 200 hours and a maximum of 300 hours in this experience.',
  },
  {
    course_code: 'HFT4947',
    course_name: 'Global Leadership Development III: Insights into Management',
    course_desc:
      'Students are required to work a total of 500 hours in hospitality industry positions to complete their degrees. This is the third of three internship classes. Students must work in the hospitality or tourism industry and have the opportunity to put theory into practice through active participation. Students are supervised by a management-level agency employee. Permission is required to enroll. Students should work a minimum of 200 hours and a maximum of 300 hours in this experience.',
  },
  {
    course_code: 'HFT5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'HIS2050',
    course_name: 'Explore! History',
    course_desc:
      'This course provides an in-depth experience for students to learn about a specific topic in history. Each course is designed to introduce students to the field of history, explore how history majors practice their craft, and to learn about career opportunities.\nMeets General Education requirement in Social Sciences.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'HIS3002',
    course_name: "The Historian's Craft",
    course_desc:
      'Intensive experience in historical research and writing, methodology, and interpretations. Required for all history majors. Permission is required.',
  },
  {
    course_code: 'HIS3313',
    course_name: 'Issues in Gender and Diversity',
    course_desc:
      'Provides an interdisciplinary introduction to the theoretical and social issues regarding diverse groups and gender stereotypes. Focuses on how gender and diversity fit into the actions and interactions of the private and public sectors, and presents information on how to effectively promote institutions, relationships, politics, and services that value diversity and eliminate gender stereotypes.',
  },
  {
    course_code: 'HIS3930',
    course_name: 'Junior Seminar',
    course_desc:
      "The Junior Seminar acts as a 'capstone' course for history majors in their Junior year. This course provides the student with an opportunity to refine and practice skills learned in previous courses and to produce a work of historical scholarship. Each student will conduct original research and write a paper based on primary and secondary sources. At the end of the semester the student will give an oral presentation.",
  },
  {
    course_code: 'HIS4066',
    course_name: 'Local History',
    course_desc:
      'Introduction to theory, methodology, and application of local history. Required attendance on field trips to local historical archives, museums, and sites.',
  },
  {
    course_code: 'HIS4072',
    course_name: 'Oral and Community History',
    course_desc:
      'Introduces students to the discipline of oral history and to demonstrate the techniques in which oral history is used to address the history, structure, function, and development of communities. Offered concurrently with HIS5077; graduate students will be assigned additional work.',
  },
  {
    course_code: 'HIS4164',
    course_name: 'Doing Digital History',
    course_desc:
      'Surveys the key topics, debates, and methodologies of digital history. Students create a digital history project. Offered concurrently with HIS5165; graduate students will be assigned additional work.',
  },
  {
    course_code: 'HIS5059',
    course_name: "Methods I: The Historian's Craft",
    course_desc:
      'Even though history is the study of the past, recent developments have begun to revolutionize how historians access and analyze their sources. This course begins by discussing the development of the study and theory of history. We will then move forward to consider new approaches to history. From anthropological theory and material cultural to the use of digital archives, we will delve into the many different ways to access the past, including even popular history. Through the use of digital archives we will then learn how to read the oldest sources through the art of paleography. All the while students will learn or review the basic skills of a historian as he/she begins to research a topic. Students will begin by choosing a research topic and then slowly create their research paper through the perusal of primary sources, historiographic essays, and scholarly reviews. By the end of the course students will possess a well-crafted research paper that will form the basis of future research at UWF and perhaps as future PhD students.',
  },
  {
    course_code: 'HIS5063',
    course_name: 'Graduate Methods II: The Professional Historian',
    course_desc:
      "Graduates of history master's degree programs pursue a wide range of careers. This professional development seminar familiarizes students with many of these career opportunities. It also provides training in the practical, professional skills, habits, and modes of thought of working historians. Through hands-on workshops, panel discussions, guest speakers, and site visits, students will hone the skills historians commonly use in a variety of professional capacities. Students will develop a comprehensive professional portfolio, curate their professional online presence, present at an academic conference, and produce a publishable article based on their Methods I research paper.",
  },
  {
    course_code: 'HIS5066',
    course_name: 'Local History',
    course_desc:
      'Introduction to theory, methodology, and application of local history. Required attendance on field trips to local historical archives, museums, and sites. Offered concurrently with HIS4066; graduate students will be assigned additional work.',
  },
  {
    course_code: 'HIS5077',
    course_name: 'Oral and Community History',
    course_desc:
      'Introduces students to the discipline of oral history and to demonstrate the techniques in which oral history is used to address the history, structure, function, and development of communities. Offered concurrently with HIS4072; graduate students will be assigned additional work.',
  },
  {
    course_code: 'HIS5087',
    course_name: 'Museology and Museography',
    course_desc:
      'The historical development and fundamental operations of history and other humanities-focused museums.',
  },
  {
    course_code: 'HIS5165',
    course_name: 'Doing Digital History',
    course_desc:
      'Surveys the key topics, debates, and methodologies of digital history. Students create a digital history project. Offered concurrently with HIS4164; graduate students will be assigned additional work.',
  },
  {
    course_code: 'HIS5515',
    course_name: 'History of Architecture',
    course_desc:
      'Examines the development of European architecture as a basis for understanding trends in American architecture from the colonial era to the twentieth century. Introduces the professional aspects of building and construction along with materials and techniques in building restoration and renovation.',
  },
  {
    course_code: 'HIS6055',
    course_name: 'Public History Seminar',
    course_desc:
      'Seminar examines the core concepts, principles, processes, and methodologies of Public History. The course also includes an introduction to foundational applied methodologies.',
  },
  {
    course_code: 'HIS6056',
    course_name: 'Public History Practicum',
    course_desc:
      'Practicum introduces students to multiple aspects of Public History practice through placement in a non-profit museum, archive, or other relevant institution. Students participate in the full range of activities available in the setting under the direct supervision of on-site professionals while completing aligned coursework with History Department faculty. Minimum of 160 hours required at the partnering site.',
  },
  {
    course_code: 'HIS6083',
    course_name: 'Historic and Heritage Preservation Seminar',
    course_desc:
      'Examines the evolution and theory of the historic preservation movement in the United States and the various methodologies associated with preservation and cultural resources management activities in the government and private sectors.',
  },
  {
    course_code: 'HIS6085',
    course_name: 'Historic Preservation Certificate Capstone',
    course_desc:
      'This is the capstone professional research project for the Historic Preservation Graduate Certificate Program.  In concern with HP faculty and the Historic Preservation Certificate program coordinator students will select a historic property for evaluation using the standards and format specified by the U.S. Secretary of Interior under the National Historic Preservation Act of 1966.  The coordinator and associated HP faculty must approve the project.  The project culminates in draft nomination for the National Register of Historic Places. Students must have completed all required courses for the Historic Preservation Certificate before completing the capstone project for evaluation.  Satisfactory completion of the project is required to receive the Certificate.',
  },
  {
    course_code: 'HIS6089',
    course_name: 'Capstone Public History Internship',
    course_desc:
      'This required capstone internship experience providesan extended practical experience in the field of public history under the supervision of an on-site professional at an institution or agency such as a local, state, or national museum; archive; historic preservation site; oral history program; historic district; or other relevant non-profit organization. Students submit an individual portfolio, developed over the course of the program, for evaluation. Minimum of 220 hours required at the partnering site.',
  },
  {
    course_code: 'HIS6285',
    course_name: 'Maritime History',
    course_desc:
      'Survey of impact of oceans, rivers, and other bodies of water upon the development of mankind. Focuses on settlement in maritime areas, maritime commerce, exploration, military and naval history, social intellectual and other activities and developments impacted or influenced by the sea.',
  },
  {
    course_code: 'HIS6450',
    course_name: 'Comparative Slaveries in the Atlantic World',
    course_desc:
      'Everyone can agree on the magnitude, impact, and violence of the trans-Atlantic African slave trade. What is less known are the diversity of actors who participated in this trade. From Prussian merchants to African kings and Canary Islanders, this course investigates the many faces of the Atlantic and Pacific slave trades. We will also compare and contrast the African trade with the Indian slave trades (trades in the Circum-Caribbean to the Southeastern U.S. as well as the trade from the Philippines to Central America) to see how each business affected one another. In addition we look at the diverse ways that different European powers approached slavery. Finally, we will focus on the many strategies for survival employed by Indian, Chino, and African slaves in the face of unimaginable violence and exploitation. It is in the resistance and agency of slaves that we find the seeds of present day African American culture.',
  },
  {
    course_code: 'HIS6904',
    course_name: 'Directed Readings',
    course_desc: 'Permission is required.',
  },
  {
    course_code: 'HIS6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'HIS6946',
    course_name: 'Public History Internship',
    course_desc:
      'The internship provides an extended practical experience in the field of public history under the supervision of an on-site professional at an institution or agency such as a local, state, or national museum; archive; historic preservation site; oral history program; historic district; or other relevant non-profit organization. Minimum of 220 hours required at the partnering site. Permission required.',
  },
  {
    course_code: 'HIS6956',
    course_name: 'Advanced Overseas and Field Study in History',
    course_desc:
      'Supervised independent study in historical field research or study in the United States or overseas. Studies include, but are not restricted to, foreign research, supervised visitation and analytical observation of historical sites, participation in foreign university exchange programs. Permission is required.',
  },
  {
    course_code: 'HIS6971',
    course_name: 'Thesis',
    course_desc:
      'Graded on satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'HLP2081',
    course_name: 'Health, Nutrition and Physical Fitness',
    course_desc:
      'Principles of exercise and nutrition and their roles in maintenance of good health. Students will be given the opportunity to develop their individual aerobic fitness program. An introductory level course.',
  },
  {
    course_code: 'HLP3300',
    course_name: 'Organization and Administration of Professional Programs',
    course_desc:
      'Analysis of leadership principles related to study of man and human performance related to health, leisure and sports activities.',
  },
  {
    course_code: 'HLP3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'HLP4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'HLP4922',
    course_name: 'Field Experience',
    course_desc:
      'Placement in an appropriate setting for the purpose of learning more about a specific field. Student will observe and participate in a wide range of activities as determined by instructor and agency supervisor. Graded on satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'HLP5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'HLP6535',
    course_name: 'Research Procedures',
    course_desc:
      'Research methodology, critical analyses and evaluation of current research, and design of a research proposal in the major field.',
  },
  {
    course_code: 'HLP6595',
    course_name: 'Research Seminar',
    course_desc:
      'Development of a research design suitable for a thesis or research project in health, leisure or sports science.',
  },
  {
    course_code: 'HLP6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'HLP6922',
    course_name: 'Field Experience',
    course_desc:
      'Field experience in school or community agencies under faculty direction and on-the-job supervision. Graded on satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'HLP6940',
    course_name: 'Internship',
    course_desc:
      'Placement in an appropriate agency or organization for the purpose of gaining some experience in the field.  Faculty and agency personnel will supervise the student as the student participates in a wide range of services available in the setting.  Goals and objectives will be planned by the student, instructor and agency supervisor.  Reports will be required on a regular basis with a final report and oral interview. Permission is required.',
  },
  {
    course_code: 'HLP6971',
    course_name: 'Thesis',
    course_desc:
      'Graded on a satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'HLP7001',
    course_name: 'Promoting Physical Activity for Youth and Adults',
    course_desc:
      'This course focuses on the current physical activity recommendations for youth and adults. Emphasis is placed on the benefits of physical activity on various health outcomes; determinants of physical activity; how to measure physical activity at the individual and population levels; policy approaches to promote active living; and strategies to promote physical activity.',
  },
  {
    course_code: 'HLP7306',
    course_name: 'Planning and Designing Health and Physical Activity Programs',
    course_desc:
      "This course is designed to enhance students' knowledge and abilities related to curriculum development in Health and Physical Activity programs. Course activities will guide students through analyses of current programs, identification of needs, framework and curriculum development, and instructional strategies and practice construction. Students will use evidence from research and practice to both develop and support content.",
  },
  {
    course_code: 'HLP8002',
    course_name: 'Leadership in Health and Physical Activity',
    course_desc:
      'This course is designed to provide students with a detailed understanding of how health and physical activity program areas are impacted by higher education, grants, research, and the community.  Content will prepare students to embrace and utilize activities that play supportive roles in health and physical activity management, administration, services, and promotion.',
  },
  {
    course_code: 'HLP8003',
    course_name: 'Health and Physical Activity Research Methodology',
    course_desc:
      'This course is designed to provide students with a detailed understanding of how health and physical activity program areas are impacted by higher education, grants, research, and the community.  Content will prepare students to embrace and utilize activities that play supportive roles in health and physical activity management, administration, services, and promotion.',
  },
  {
    course_code: 'HLP8515',
    course_name:
      'Development and Administration of Health and Physical Activity Programs',
    course_desc:
      'This course examines the models and process to systematically plan, implement, administrate, and evaluate health and physical activity programs. Students will develop skills in assessment, planning, administrating, and evaluating health and physical activity programs through extensive literature review, class discussions, and presentations. Course will emphasize importance of teams and partnerships in successful health and physical activity programs.',
  },
  {
    course_code: 'HSA4383',
    course_name: 'Quality Improvement in Healthcare',
    course_desc:
      'This course provides students with an introduction to the underlying principles and the fundamentals of quality management and improvement in the delivery of healthcare.  An emphasis is placed on literacy and awareness of the concepts, topics and practices needed to address quality improvement challenges in complex healthcare systems.',
  },
  {
    course_code: 'HSA4430',
    course_name: 'Health Economics',
    course_desc:
      'This course provides instruction in healthcare economic theories, tools, and concepts and their application to the evolving healthcare industry.',
  },
  {
    course_code: 'HMG5296',
    course_name: 'Advanced Global Hospitality and Tourism Shared Economies',
    course_desc:
      "This course offers the study of unconventional economic and social activities involving peer-to-peer based sharing of access to goods and services through transactions occurring mainly online, known as 'Shared or Access Economies'. It will focus on how these are directly affecting the global hospitality and tourism industry. Students experiment the different aspects involved, its infrastructures, the drivers and the mechanisms that make it possible, and how it impacts the present and future of our industry, by going through real case studies, research and course materials, that expand on the topic, specifically focusing on Access Economies and their influence in the Hospitality and Tourism Industry. Offered concurrently with HFT4106 Global Hospitality and Tourism Shared Economies; graduate students will be assigned additional work.",
  },
  {
    course_code: 'HMG5466',
    course_name: 'Hospitality Financial Analysis & Revenue Optimization',
    course_desc:
      'Specialized accounting techniques applicable to the hospitality industry; interpret hospitality financial statements, capital investment decision making, financial instruments and concepts; survey of revenue management and analytics related tactics, issues, and trends in the hospitality industry. \nPerishable inventory with variable demand necessitates effective revenue management to realize the tourism and hospitality mechanism of revenue optimization. Participation in this course will afford students the opportunity to identify and exploit the core elements of revenue management, namely forecasting, controls (pricing and allocation/optimization decisions) and monitoring. This course aims for students to establish a reasonable level of relevant analytical/technical proficiency in each one of these core revenue management elements. Within the broader area of pricing theory, additional emphasis is placed on overbooking, consumer behavior, distribution channel management, and market segmentation. Utilizing STR hospitality metrics, students will develop hotel analytical skills and the opportunity to receive the Certification in Hotel Industry Analytics (CHIA). Offered concurrently with HFT4426; graduate students will be assigned additional work.',
  },
  {
    course_code: 'HMG5506',
    course_name: 'Service Experience Marketing for Hospitality Management',
    course_desc:
      'Examine significant issues facing hospitality and tourism service providers and the successful implementation of a customer focus in service-based businesses. Course includes an overview of services marketing; understanding the customer; standardizing and aligning the delivery of services; the people who deliver and perform services; managing demand and capacity; and promotion and pricing strategies in hospitality and tourism marketing. Offered concurrently with HFT4503; graduate students will be assigned additional work.',
  },
  {
    course_code: 'HSA3111',
    course_name: 'Understanding U.S. Health Care',
    course_desc:
      'This course provides an orientation to the characteristics of the U.S. Healthcare delivery system including a review of utilization, organization, hospitals, integrated systems, quality, insurance, policy, and technology.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'HSA3140',
    course_name: 'Strategic Planning in Healthcare',
    course_desc:
      'This course focuses on strategic management as it applies to health care organizations with special emphasis on strategic planning, analysis of the health services environment (both internal and external), marketing and implementation. Healthcare case studies are used to illustrate key concepts.',
  },
  {
    course_code: 'HSA3170',
    course_name: 'Principles of Healthcare Finance',
    course_desc:
      'This course provides students with an introduction to the fundamentals of healthcare finance as practiced in health services organizations. The course will enable students entering administrative positions to more readily become effective and efficient participants in the achievement of organizational goals. Reimbursement insurance and third-party payments are covered.',
  },
  {
    course_code: 'HSA3551',
    course_name: 'Health Ethics and Professionalism',
    course_desc:
      "This course includes an overview of ethical issues facing today's healthcare practitioners in addressing clinical and administrative decision-making. This course will also focus on the importance of professionalism and effective communication skills in dealing with healthcare consumers and other medical professionals in the healthcare industry.",
  },
  {
    course_code: 'HSA4002',
    course_name: 'Healthcare Administration',
    course_desc:
      'This course provides students with an overview of concepts and issues related to healthcare administration in a variety of healthcare settings, such as hospitals, nursing homes, clinics and others. Emphasis is placed on important issues such as ethics, controlling costs, strategic planning and marketing, information technology, and personnel administration.',
  },
  {
    course_code: 'HSA4110',
    course_name: 'Health Care Policy and Administration',
    course_desc:
      'Management principles, processes and techniques as applied to hospitals and other health-related institutions. Offered concurrently with HSA5115; graduate students will be assigned additional work.',
  },
  {
    course_code: 'HSA4191',
    course_name: 'Health Information Systems',
    course_desc:
      'Provides an overview of various health information such as patient-care, clinical decision-support, disease and demographic surveillance, imaging and simulation, and safety and environmental assessment. Fundamentals of proposing, reporting, and refereeing evaluation studies are covered. Legal and ethical issues related to training, security, confidentiality, and the use of informed consent are also addressed. Working knowledge of how to use personal computers, including knowledge of word-processing, spreadsheet packages and Internet searching.',
  },
  {
    course_code: 'HSA4192',
    course_name: 'Current Topics in Health Informatics',
    course_desc:
      'Provides an overview of the multifaceted, interdisciplinary nature of health (medical) informatics. Fundamentals of computer applications in medicine, health data classification and coding, and legal and ethical issues (including documentation, security, and regulatory requirements). Additional avenues for further credentialing will be covered. Credit may not be received in both HSA4192 and HSA 4190. This course was formally known as Introduction to Medical Informatics.',
  },
  {
    course_code: 'HSA4193',
    course_name: 'Electronic Clinical Record Systems',
    course_desc:
      'This course explores the use and evaluation of commercially available electronic medical record systems. Healthcare workflow issues will be addressed as well as billing, collections, HIPAA, and scheduling. Offered concurrently with HSA5198; graduate students will be assigned additional work.',
  },
  {
    course_code: 'HSA4340',
    course_name: 'Personnel Administration in Healthcare',
    course_desc:
      'This course focuses on the fundamental concepts and practical tools used in the healthcare industry which are necessary for maximizing employee performance. Special emphasis is placed on the complex factors that influence the performance of the unique healthcare workforce in a dynamic industry.',
  },
  {
    course_code: 'HSA4703',
    course_name: 'Coordinating Clinical Trials',
    course_desc:
      'This course provides an overview of clinical trial operations for learners of any academic field. Subject matter focuses on the history and regulatory guidance surrounding human subjects in drug trials, including current standards of Good Clinical Practices (GCP). Course emphasizes administrative functions required in real-world clinical research, such as informed consent, protocol review, study documentation, and research staff roles and responsibilities. Course also covers the storage, shipment, and safety issues concerning pharmaceutical drugs and biologic materials. Students participate in a virtual "Mock Study" to demonstrate comprehension of course materials and ability to work as a clinical team.',
  },
  {
    course_code: 'HSA4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'HSA4941',
    course_name: 'Internship',
    course_desc:
      'This internship experience will provide students with hands-on experience in the health industry and exposure to key elements in this environment. Emphasis will be placed on effective professional communication, career development, and preparation of the student for the workforce.',
  },
  {
    course_code: 'HSA5115',
    course_name: 'Health Care Policy and Administration',
    course_desc:
      'Management principles, processes and techniques as applied to hospitals and other health-related institutions. Offered concurrently with HSA4110; graduate students will be assigned additional work.',
  },
  {
    course_code: 'HSA5198',
    course_name: 'Electronic Clinical Record Systems',
    course_desc:
      'This course explores the use and evaluation of commercially available electronic medical record systems. Healthcare workflow issues will be addressed as well as billing, collections, HIPAA, and scheduling. Offered concurrently with HSA4193; graduate students will be assigned additional work.',
  },
  {
    course_code: 'HSA5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'HSA6103',
    course_name: 'Health Services Administration',
    course_desc:
      'This course will introduce essential concepts and developing trends in health services administration which are applicable in professional practice and provide a baseline for further study.',
  },
  {
    course_code: 'HSA6106',
    course_name: 'Health Delivery Systems',
    course_desc:
      'This course explores healthcare delivery in the United States. Examines healthcare systems in other countries along with covering topics including American beliefs and values related to healthcare delivery, evolution of health services in the United States, health service professions, influence of medical technology, and the financing of health services.',
  },
  {
    course_code: 'HSA6175',
    course_name: 'Healthcare Finance',
    course_desc:
      'This course focuses on the application of finance theory, principles, and concepts to healthcare organizations. Topics covered also include the healthcare environment, long term financing, and capital investment decisions in the healthcare industry.',
  },
  {
    course_code: 'HSA6197',
    course_name: 'Health Informatics',
    course_desc:
      'This course discusses the multifaceted, interdisciplinary nature of health informatics. Topics covered include: computer applications in medicine, health data classification and coding, and legal and ethical issues (including documentation, security, and regulatory requirements). Additional avenues for further credentialing will be covered.',
  },
  {
    course_code: 'HSA6342',
    course_name: 'Human Resources in Healthcare',
    course_desc:
      'This course applies the concepts and theories of human resources to the unique needs of the healthcare workforce. Areas of focus include recruitment and retention, training and development, performance appraisal, and employment law as it relates to healthcare employment. Students will acquire the skills needed to oversee a diverse healthcare workforce effectively.',
  },
  {
    course_code: 'HSA6385',
    course_name: 'Quality Improvement Processes in Health Organizations',
    course_desc:
      'This course provides an overview of methods to improve healthcare systems and healthcare delivery using quality improvement theories and frameworks to execute an improvement project. Students will learn to focus on identifying opportunities to improve processes, developing methods to identify factors that affect process, and using data to determine appropriate actions.',
  },
  {
    course_code: 'HSA6425',
    course_name: 'Healthcare Law',
    course_desc:
      'This course provides an overview of laws most affecting healthcare practices. The legal basis for government involvement in healthcare is examined with an analysis of the laws controlling the provision of healthcare industry and professional regulations. This course provides and in-depth overview of healthcare law, allowing students to acquire skills to confirm their actions to legal requirements and ethically analyze daily healthcare situations. Although no prerequisites are required, HSC 6206 is recommended prior to taking this course.',
  },
  {
    course_code: 'HSA6435',
    course_name: 'Decision Making in Healthcare',
    course_desc:
      'This course explores financial topics, theory, tools, and decision making in healthcare while analyzing cases. This course builds on topics covered in HSA6175 Healthcare Finance. Prerequisite: Grade of C or higher in HSA6175.',
  },
  {
    course_code: 'HSA6436',
    course_name: 'Health Economics',
    course_desc:
      'This course evaluates health economic theories and tools and their application to current issues from the perspective of healthcare administrators. Prerequisites: GEB5871 or its equivalent with a grade of C (2.0) or better. HSA6752 or its equivalent with a grade of C (2.0) or better.',
  },
  {
    course_code: 'HSA6521',
    course_name: 'Critical Analysis of Health',
    course_desc:
      'Analysis of research being conducted on causes of illness and death in the United States and other countries. Credit may not be received in both HSA6521 and HSA6106.',
  },
  {
    course_code: 'HSA6707',
    course_name: 'Current Issues in Health Administration',
    course_desc:
      'Students will examine current issues in the dynamic field of healthcare and the implications for healthcare administrators and other health professionals. Topics include outpatient services and primary care; hospital facilities; managed care; long-term care; healthcare concerns in vulnerable populations; cost, access and quality of healthcare; healthcare policy; and future of health\nservices delivery in the US.',
  },
  {
    course_code: 'HSA6752',
    course_name: 'Quantitative Foundations and Data Analysis for Health Admin',
    course_desc:
      'This course will introduce the methods for description and analysis which provide healthcare professionals with useful tools for making sense from data. The course will cover how healthcare data is dependent on analysis, categorization, and management.',
  },
  {
    course_code: 'HSA6944',
    course_name: 'Internship in Health Administration',
    course_desc:
      'The internship program is intended to provide students with the opportunity to use and develop conflict resolution skills, integrate the theory and practice of conflict analysis and resolution, and network with professionals in the field to enhance employment opportunities.  Students have the opportunity to take on leadership roles, gain new knowledge and skills, develop workplace competencies and connect theories from courses to the practical world outside of the classroom.  As a student of conflict analysis and resolution, the combined internship and academic credit provide the occasion and space to reflect as you practice. Students should take this course close to the completion of the MHA program. Grades are provided on a satisfactory / unsatisfactory basis only.',
  },
  {
    course_code: 'HSA6947',
    course_name: 'Healthcare Administration Capstone',
    course_desc:
      'Designed to help students make the transition from theory to practice, this course focuses on sharpening analytical and intuitive leadership practices through interactive projects. The purpose of this capstone is to facilitate the integration and synthesis of content through critical thinking. Students demonstrate critical thinking skills in actively and skillfully conceptualizing information to inform executive decisions. The capstone is a total immersion experience in which students are challenged to use all of the tools and concepts learned to date to tackle a new venture for a healthcare organization.',
  },
  {
    course_code: 'HSC2100',
    course_name: 'Personal Health',
    course_desc:
      'Provides information on personal health issues from which students may base current and future decisions regarding their health and wellness. To promote an environment where effective decision making skills can be acquired through structured group interaction.',
  },
  {
    course_code: 'HSC2130',
    course_name: 'Sex & Booze: A Peer Health Education Course',
    course_desc:
      'Educates and trains students in assessing college life health issues and experiences among peers utilizing an active learning approach in order to educate college students on issues such as peer education, leadership, alcohol misuse/abuse prevention, sexual assault prevention, healthy relationships, and sexual health responsibility. Participation in the course will equip students\nwith vital knowledge and skills needed for their experience as, and interactions with, college students. Students should also expand their abilities for developing and providing useful presentations and expertise in offering feedback and resources for issues affecting UWF peers. The material will help to build a team environment and leadership skills.',
  },
  {
    course_code: 'HSC2577',
    course_name: 'Principles of Nutrition',
    course_desc:
      'The fundamentals of nutrition are explored, emphasizing the biochemical and physiological mechanisms of digestion, absorption, metabolic pathways, energy requirements, and nutritional status. It provides students with an understanding of nutrients and their roles in the body while examining current issues in food science. An emphasis is placed on promotion of growth and health by examining weight control, disease prevention, food safety, and planning a healthy diet.',
  },
  {
    course_code: 'HSC2622',
    course_name: 'Introduction to Global Health Sciences',
    course_desc:
      'This health sciences course considers the influence of factors such as access to healthcare, biology, infectious diseases, societal status, culture, the environment, and  the management of healthcare resources, on the well-being of people around the globe. The course will also examine the role of equity, social justice, and ethics in healthcare. Case studies demonstrating how various actors have cooperated across national borders to solve problems like pandemics, healthcare access challenges and disease eradication will be analyzed. Students will integrate ideas from different disciplines to identify problems affecting society in the international context.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'HSC3032',
    course_name: 'Foundations in Health Education',
    course_desc:
      'Explores the philosophy and principles that provide the foundations of health education as an academic discipline and as a profession. Emphasis will focus on health education in our society, theoretical basis, settings, ethical issues, current issues, marketing, planning and future outlook in the field.',
  },
  {
    course_code: 'HSC3034',
    course_name: 'Career Essentials for Healthcare',
    course_desc:
      "This course provides an overview of the field of health sciences and introduces students to essential skills required for career success in various healthcare professions.  Content will also cover important issues facing today's healthcare environment.",
  },
  {
    course_code: 'HSC3102',
    course_name: 'Health Science Essentials of Behavior Analysis',
    course_desc:
      'This course is designed to provide the curriculum requirements necessary to become a Registered Behavior Technician (RBT). Completion of this course, together with practical and exam requirements (stipulated by the Behavior Analyst Certification Board), may help students qualify for employment opportunities in the field of healthcare. For those interested in pursuing a career path in the field of health, this course is the first in a series of courses designed to meet the curriculum requirements to become a Board Certified Assistant Behavior Analyst. This course serves as a basic introduction to behavior analytic principles, definitions, characteristics, processes, and concepts, in conjunction with instruction on the ethical implementation of Behavior Analysis. The content is based on the Behavior Analyst Certification Board (BACB) Task List and the Registered Behavior Technician Task List posted on the BACB website. The course is offered independent of the BACB.',
  },
  {
    course_code: 'HSC3114',
    course_name:
      'Problem Identification and Functional Assessment in Health Science',
    course_desc:
      'For those interested in pursuing a career path in the field of health, this course is the second in a series of courses designed to meet the curriculum requirements to become a Board Certified Assistant Behavior Analyst. This course provides in-depth analysis of behavior analytic principles, definitions, characteristics, processes, and concepts, in conjunction with instruction on the ethical implementation of Behavior Analysis. Students learn the knowledge and skills to conduct meaningful functional assessments in multiple applications within the health context from leadership and management to individual clinical practice. The content is based on the Behavior Analyst Certification Board (BACB) Task List and the Registered Behavior Technician Task List posted on the BACB website. The course is offered independent of the BACB.',
  },
  {
    course_code: 'HSC3147',
    course_name: 'Pharmacology for Health Professionals',
    course_desc:
      'This course will focus on the general principles of drug action and pharmacology of therapeutic agents. The general principles of pharmacology, including drug absorption, distribution and metabolism along with receptor theory will be covered. The course will also focus on mechanism of action of specific drug classes and their effective use in different diseases.',
  },
  {
    course_code: 'HSC3406C',
    course_name: 'Advanced First Aid and Emergency Care',
    course_desc:
      'Study and practice of standard first aid procedures which are essential for survival in emergency and disastrous situations. Cardiopulmonary resuscitation method will be included. Red Cross certification will be available to students who meet current standards. Material and supply fee will be assessed.',
  },
  {
    course_code: 'HSC3510',
    course_name: 'Data Analysis in the Health Sciences',
    course_desc:
      'This course focuses on the application of computer technology and software in conducting analysis of data, including how to retrieve, clean, organize, and analyze data using computational methods, as well as report findings using existing general purpose software. Additionally, students will acquire skills in data presentation through using tables, charts, and written reports.  All students must complete STA2023 or equivalent prior to taking HSC3510.',
  },
  {
    course_code: 'HSC3535',
    course_name: 'Medical Terminology',
    course_desc:
      'This course is designed to familiarize students with the vocabulary used in the medical and health professions. Students will employ a systematic, word-building approach to master the complex terminology of the medical field. An emphasis is placed on word dissection of compound medical terms and inferring word meanings from their prefixes, suffixes, and stem words. Credit may not be received in both HSC3535 and HSC 3534.',
  },
  {
    course_code: 'HSC3555',
    course_name: 'Pathophysiology',
    course_desc:
      'Disease as an abnormal biological process. Selected physiological processes and basic concepts of body response to pathology will be explored. Approach appropriate to students of nursing, allied health, medicine, and biology. Recommended prerequisite; one course in anatomy and physiology.',
  },
  {
    course_code: 'HSC3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'HSC3991',
    course_name: 'Special Topics Course',
    course_desc: '',
  },
  {
    course_code: 'HSC3992',
    course_name: 'Special Topics Course',
    course_desc: '',
  },
  {
    course_code: 'HSC3993',
    course_name: 'Special Topics Course',
    course_desc: '',
  },
  {
    course_code: 'HSC4050',
    course_name: 'Health Sciences Capstone Course',
    course_desc:
      'This capstone course will focus on contemporary research in the health sciences. The course will cover topics such as the scientific method, research study designs, critical evaluation of the literature, technical writing, research ethics, data collection, and analysis. As part of an ongoing semester project, students  will design a research proposal on a specific topic in health. A capstone exam will be given.',
  },
  {
    course_code: 'HSC4104',
    course_name: 'Health Aspects of Stress Management',
    course_desc:
      'A study of physiological, psychological, and sociological aspects of stress as related to overall health. Anger, fear, and depression and their underlying mechanisms related to the stress response on health and disease will be examined. Emphasis is on identification of stressors, methods of prevention and coping strategies. Group activities and individual assignments provide opportunities for personal analysis.',
  },
  {
    course_code: 'HSC4120',
    course_name: 'Consumer Health Education',
    course_desc:
      'Enables students to make intelligent decisions about the health care marketplace. Basic information regarding health care products, services and consumer protection will be of central focus.',
  },
  {
    course_code: 'HSC4133',
    course_name: 'Health Aspects of Human Sexuality',
    course_desc:
      'A study of physical, mental, emotional, social, and psychological phases of human sexuality as they are affected by male and female relationships. Emphasize a holistic perspective on sexuality. Lectures by the instructor and experts from the community will provide an overview of the major issues in sexuality. Assigned readings will provide detailed information. Group activities and individual assignments will provide opportunities for personal analysis and growth with regard to a wide variety of topics.',
  },
  {
    course_code: 'HSC4143',
    course_name: 'Drugs in Society',
    course_desc:
      'Provides students with knowledge of the use and abuse of drugs in American contemporary society. Emphasis on the physiological, psychological, and sociological effects of drug use and abuse on personal and community health. Concepts of prevention, education and control will be covered. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'HSC4211',
    course_name: 'Human Environmental Health',
    course_desc:
      'An online course with an overview of major environmental issues facing society at the dawn of the 21st century. Ecological concerns will be matched with specific elements related to personal and community health, emphasizing the interrelatedness of the two and conveying an awareness of how current environmental issues directly affect your own life.',
  },
  {
    course_code: 'HSC4300',
    course_name: 'Changing Health Behaviors',
    course_desc:
      'Designed to acquaint students with a general theory of behavior, guide them through exercises for developing skills in self-analysis, and to provide information on how to achieve individual behavior change goals. Students will learn techniques for developing community-based health behavior change programs and employ coping skills for personal problem solving.',
  },
  {
    course_code: 'HSC4404',
    course_name: 'Medical Disaster Management',
    course_desc:
      'Introduces students to facets of natural and technological disasters while integrating public health research designs and practices. Class lectures and discussions utilize recent and historical case studies as a basis for developing the critical thinking and leadership skills needed by healthcare professionals in crisis situations. International, domestic, and regional settings are addressed, as well as the social, economic, and political aspects of disaster planning, preparedness, and mitigation. Basic public health concepts and methodologies as they relate to course material.  Permission is required.',
  },
  {
    course_code: 'HSC4500',
    course_name: 'Epidemiology',
    course_desc:
      'A study of the factors determining and influencing the frequency, distribution, and causes of diseases and other events that impact the health and safety of the human population. Programs and strategies to prevent and control such events and diseases will be explored.',
  },
  {
    course_code: 'HSC4502',
    course_name: 'Principles of Human Disease',
    course_desc:
      "The course introduces students to the mechanisms of human disease, disease etiology, symptoms, diagnosis, treatments, prognosis and epidemiology. Diseases and disorders of each of the body's systems will be covered. Special attention will be paid to disease prevention.",
  },
  {
    course_code: 'HSC4551',
    course_name: 'Communicable and Degenerative Diseases',
    course_desc:
      'Designed to explore the basic concepts and principles of the disease process including history and classification. Emphasis will be upon etiology, origin, symptoms, treatments, prevention, host, agent, and environmental factors affecting occurrence, prevention, and control. Offered concurrently with HSC 5552; graduate students will be assigned additional work. Junior / Senior status required.',
  },
  {
    course_code: 'HSC4572',
    course_name: 'Nutrition and Health',
    course_desc:
      "A study of the principles of nutrition science as applied to daily living. Topics include the six major nutrients; carbohydrates, lipids, proteins, vitamins, minerals, and water. Course also examines nutrition standards, Dietary Guidelines, digestive process, energy balance, nutrition controversies, and health educator's scope of practice related to nutrition education and counseling. Previous courses in nutrition, anatomy, physiology, physiology, or biology are highly recommended. Material and Supply Fee will be assessed.",
  },
  {
    course_code: 'HSC4580',
    course_name:
      'Functional Applications of Applied Behavior Analysis in Health Science',
    course_desc:
      'This course is the fourth in a series designed to provide students with the necessary knowledge to be eligible for a career as a Board Certified assistant Behavior Analyst in the field of health. Building on the basic concepts of behavior analysis, functional assessment, and systematic measurement this course serves as an overview of functional applications of behavior analysis in health contexts from leadership and management to individual clinical and therapeutic practice. The content is based on the Behavior Analyst Certification Board (BACB) Task List posted on BACB website.',
  },
  {
    course_code: 'HSC4581',
    course_name: 'Health Promotion and Planning',
    course_desc:
      'Practical application of theory, models, principles, and practices of health promotion, planning, and implementation.  Experiential activity includes creating a health promotion program incorporating: developing and administering a needs assessment, applying a behavioral and environmental assessment, writing goals and measurable objectives, marketing the program, presenting the health program, evaluating the program.',
  },
  {
    course_code: 'HSC4583',
    course_name: 'Theoretical Foundations of Health Promotion and Planning',
    course_desc:
      'A comprehensive overview and analysis of theory, models, principles, and practices of health education and promotion planning and implementation.  Topics for discussion include health promotion and a framework for planning, social assessment and participatory planning, epidemiological assessment, behavioral and environmental assessment, educational and ecological assessment, administrative and policy assessment, evaluation and applications in community, occupational, school, and health care settings.',
  },
  {
    course_code: 'HSC4584',
    course_name: 'Health Promotion Strategies and Funding',
    course_desc:
      'This course will explore, develop, analyze, and apply strategies to promote health in communities. Emphasis will be placed on community organization, coalition building, curriculum development, communication theory and technology, social marketing, mass media and ecological models. Students will conduct critical analysis of interventions that implement each strategy through systematic analysis of public health literature. Grant funding strategies will be addressed.',
  },
  {
    course_code: 'HSC4633',
    course_name: 'Current Issues in Health Promotion',
    course_desc:
      'A study of current and emerging health issues affecting communities on a local and global level. Health promotion programs, approaches, and measures will be examined. Emphasis will be placed on environment, health care, behavioral health, lifestyle factors, social determinants of health, and communicable diseases. This course is designed to provide a comprehensive overview of fundamental research tools, methods, and concepts for assessing health promotion issues.',
  },
  {
    course_code: 'HSC4654',
    course_name:
      'Ethical Considerations in Analysis of Behavior in Health Science',
    course_desc:
      'This course provides students with the necessary knowledge to be eligible for a career as a BCaBA in the field of health. Building on the basic concepts of behavior analysis, this course further develops knowledge of practice by considering ethical aspects of decision making in practice, current law and policy, and advocacy. The emphasis of this course is on the ethical application of behavior analysis in context. The content is based on the BACB Task List.',
  },
  {
    course_code: 'HSC4658',
    course_name: 'End-of-Life Ethics',
    course_desc:
      'An examination of key issues and cases in end-of-life ethics. Credit may not be received in both HSC4658 and HSC4654.',
  },
  {
    course_code: 'HSC4720',
    course_name: 'Methodology in Applied Behavior Analysis in Health Science',
    course_desc:
      'This course is the third in a series designed to provide students with the necessary knowledge to be eligible for a career as a Board Certified Assistant Behavior Analyst in the field of health. Building on the basic concepts of behavior analysis, this course further develops knowledge of measurement, experimental design, behavior change considerations, and ethics. Students learn the knowledge and skills to precisely observe, measure, and design basic assessments and evaluations in multiple applications within the health context from leadership and management to individual clinical practice. The content is based on the Behavior Analyst Certification Board (BACB) Task List posted on the BACB website.',
  },
  {
    course_code: 'HSC4730',
    course_name: 'Research Methods and Evaluation in Health Promotion',
    course_desc:
      'A comprehensive analysis and application of research methods and evaluation for health education and promotion practices. Students will establish or advance their understanding of research and evaluation in health promotion through critical exploration of terminology, ethical considerations, and methodology. Quantitative, qualitative, and mixed research methods will be explored and applied. Students will be provided with opportunities for practical application of evaluation design and implementation. Data will be analyzed, interpreted, and presented paralleling current health promotion professional practices.',
  },
  {
    course_code: 'HSC4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'HSC4910',
    course_name: 'Senior Capstone Experience in Health Promotion',
    course_desc:
      'This capstone experience for Health Promotion majors provides opportunities for students to put theory into practice through active participation and class participation. Students are supervised by practitioners in health promotion.  Departmental permission will be required.',
  },
  {
    course_code: 'IDH4036',
    course_name: 'Honors Seminar: Topic VII',
    course_desc:
      'Specific Topics will vary; see the Director of the University Honors Program for current offerings. Enrollment in Honors Seminars is by permission of the Director of the Honors Program only.',
  },
  {
    course_code: 'HSC4936',
    course_name: 'Accelerated Topics in Behavior Analysis in Health Science',
    course_desc:
      'This course is part of a series designed to provide students with the necessary knowledge to be eligible for a career as a Board Certified Assistant Behavior Analyst in the field of health. This course utilizes previous knowledge of behavior analysis and synthesizes key components into a comprehensive application of expertise regarding measurement, assessment, and behavior change procedures. The content is based on the Behavior Analyst Certification Board (BACB) Task List.',
  },
  {
    course_code: 'HSC4991',
    course_name: 'Special Topics Course',
    course_desc: '',
  },
  {
    course_code: 'HSC4992',
    course_name: 'Special Topics Course',
    course_desc: '',
  },
  {
    course_code: 'HSC5205',
    course_name: 'Public Health Preparedness',
    course_desc:
      'Introduces types of disasters, the national incident management systems and its role in disaster planning, prevention, and mitigation. The structure and organization of medical disaster response, exercises, emergency communication, rapid health assessment, surveillance, and triage. Introduces the public health role in responding to chemical, biological, disease, radiological, nuclear, and explosive incidents. Also covers social/mental health, environmental services, ethical, and legal issues in disasters. Introduces evaluation methods for assessing the medical and public health responses.',
  },
  {
    course_code: 'HSC5506',
    course_name: 'Advanced Epidemiology',
    course_desc:
      'Examines the use of epidemiological procedures as they apply to community health planning. Emphasis is placed on the application of epidemiological concepts in determining the effectiveness of current and potential medical and public health interventions.',
  },
  {
    course_code: 'HSC5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'HSC6037',
    course_name: 'Philosophical Foundations of Health Education',
    course_desc:
      'High-order philosophical, ethical, and theoretical foundations of the professional practice of health education are explored.   Students will be expected to develop their own philosophical, ethical and theoretical approach(es) to the field after becoming familiar with the peer-reviewed literature related to the health education.',
  },
  {
    course_code: 'HSC6135',
    course_name: 'Health Literacy and Cultural Competency',
    course_desc:
      'The course examines the roles of health educators, public health professionals, health administrators, and other health professionals in providing culturally competent guidance and programming to consumers of health services.  The course provides insight into the history of healthcare, examination of the role of culture in health and healing, health literacy, current issues, and challenges facing healthcare in contemporary society.  Students will be challenged to integrate research and theory of health literacy principles as they apply concepts related to health communications and cultural competency.',
  },
  {
    course_code: 'HSC6226',
    course_name: 'Current Issues in Worksite Wellness',
    course_desc:
      'Foundational course for developing, implementing, and evaluating Worksite Health Promotion (WHP) programs.  Current issues related to worksite wellness and health promotion will be discussed and reviewed in detail.  Topics include:  history of WHP; the health/productivity/cost link; and WHP program framework.  Worksite employee issues will be explored including:  employee health needs, employee health interests, employee health interests, and accessing employee data. \nWorksite program goals, policy, implementation, participation generation, and evaluation will be analyzed.  Management hierarchy and organizational values will be assessed in relation to building a healthy worksite environment.  Funding and resource considerations will be evaluated.',
  },
  {
    course_code: 'HSC6528',
    course_name: 'Prevention of Infectious Diseases',
    course_desc:
      'An overview graduate level course of the methods and strategies for the prevention and control of infectious diseases within a population setting and the application of these tools in public health programs to achieve an epidemiologic impact on disease reduction, elimination or eradication. Methods covered in the course are those applied to population settings and address both vaccine and non-vaccine preventable diseases of public health significance.',
  },
  {
    course_code: 'HSC6587',
    course_name: 'Health Education Program Planning and Evaluation',
    course_desc:
      'This course is designed to prepare the graduate student with the theoretical and practical perspectives of health program planning and evaluation. Emphasis will be placed on the major components of program planning models; needs assessment; priority setting; program goals and objectives; program implementation and evaluation; and budgeting. Additional topics include: ethical issues related to health program planning; multicultural literacy; and grant writing. Graduate standing or permission from Health Education faculty for non-graduate students is required.',
  },
  {
    course_code: 'HSC6667',
    course_name: 'Social Marketing in Health Education',
    course_desc:
      'Provides students with an understanding of social marketing definitions, theory, and techniques. Social marketing systematically applies consumer marketing tools to achieve a consumer oriented approach to health promotion programming. Students will learn how to segment, reach, and influence target audiences while examining issues such as product planning, pricing, communication, distribution, and market research. As part of this course, students will apply marketing principles to design program messages and materials for behavior change initiatives.',
  },
  {
    course_code: 'HSC6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'HSC7609',
    course_name: 'Advanced Theories of Health Behavior',
    course_desc:
      'This course provides an in-depth examination of the psychosocial and behavioral science theories and frameworks related to the study of health behavior.  An ecological approach will be used to examine theories at multiple levels of social ecology, focusing on applications that influence translational health and physical activity research.',
  },
  {
    course_code: 'HUM4911',
    course_name: 'Interdisciplinary Humanities Capstone',
    course_desc:
      "Designed so the student may integrate and reflect on his or her undergraduate program of study. Internship or research project is closely coordinated with the student's advisor. Purpose is to provide connection, coherence, and closure to one's major course of study. Permission is required.",
  },
  {
    course_code: 'HUM6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'IDH4037',
    course_name: 'Honors Seminar: Topic VIII',
    course_desc:
      'Specific Topics will vary; see the Director of the University Honors Program for current offerings. Enrollment in Honors Seminars is by permission of the Director of the Honors program only.',
  },
  {
    course_code: 'HUN2201',
    course_name: 'Fundamentals of Human Nutrition',
    course_desc:
      'This course explores the fundamentals of nutrition with emphasizes on the biochemical and physiological mechanisms of digestion, absorption, metabolic pathways, energy requirements, and nutritional status. It provides students with an understanding of nutrients and their roles in the body while examining current issues in food science. In addition, emphasizes are placed on a promotion of growth and health by examining weight control, disease prevention, food safety, and planning a healthy diet.',
  },
  {
    course_code: 'IDH1040',
    course_name: 'Honors Core 1',
    course_desc:
      'Honors Core 1 and Honors Core 2 establish the foundation of the academic experience unique to the Honors program at the University of West Florida.\nHonors Core 1 focuses on the notion of the "the human" as it emerges in Western thought. Topics include philosophy, neuroscience, animal intelligence, and contemporary clashes over human rights and human dignity.  Students enrolling in Core I should be interested in a broad array of subject areas related to the theme of "the human" and possess the social and intellectual maturity required to address complex and controversial topics with objectivity and respect for others.  \nHonors Core 1 is designated as a General Education course. The General Education curriculum at the University of West Florida is designed to provide a cohesive program of study that promotes the development of a broadly educated person and provides the knowledge and skills needed to succeed in university studies. This course has been approved as meeting the Gen Ed Humanities requirement.  Offered Fall Semester only.\nMeets General Education requirement in Humanities.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'IDH1041',
    course_name: 'Honors Core 2',
    course_desc:
      'Honors Core 1 and Honors Core 2 establish the foundation of the academic experience unique to the Honors program at the University of West Florida.  In Honors Core 2, students will explore the philosophical underpinnings of community and investigate the distinctive features of Western and Eastern notions of communal life.  This foundation will prepare students to address those features\nof modern society that threaten community.  Specific attention will be given to various threats to community, including radicalism and globalization, mass society and suburban sprawl, lawlessness and violence, technology and social networking, and economic arrangements and collective action problems.  Students then will consider the ways in which citizens can benefit from engaging their communities of interest, can foster more meaningful civic life, and can provide\nleadership to build a better future.\nHonors Core 2 is designated as a General Education course. The General Education curriculum at the University of West Florida is designed to provide a cohesive program of study that promotes the development of a broadly educated person and provides the knowledge and skills needed to succeed in university studies. This course has been approved as meeting your requirement in the Social Science, Socio-Political Perspectives area.  The major General Education learning outcomes\nfor this course are Analysis / Evaluation, Information Literacy, Team Work Skills, and Service Learning / Civic Engagement. Offered Spring Semester only.\nMeets General Education requirement in Social Sciences.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'IDH2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'IDH3042',
    course_name: 'Honors Core 3',
    course_desc:
      'Required Honors core class for all transfer students and non-freshman students entering the Kugelman Honors Program.  This course employs inter- and multi-disciplinary teaching strategies to teach  undergraduate research skills, problem solving, and critical thinking.   Students will be introduced to Honors pedagogy at UWF and to the many resources offered by the Honors Program.  Course topics may vary, but will focus on issues of global importance (such as climate change).\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'IDH3055',
    course_name: 'Honors Thesis Research Methods',
    course_desc:
      'This course helps students understand the thesis-writing process and covers the basic research methodologies required to begin a thesis project.  Each week, we will address one important step in the thesis process, starting with the question, "What is a thesis?", and finishing with the submission of a completed thesis prospectus and annotated bibliography (aka a literature review) of sources relevant to the student\'s chosen topic.  Along the way, we will cover important areas such as choosing a topic , approaching an advisor, scholarly research methods, time management, and thesis presentation requirements.  The class is conducted as a collaborative, hands-on workshop and thus provides a strong level of peer-support for students just beginning work on their theses.  The goals of the course are to demystify the thesis process, prepare students to write a successful thesis, and provide intellectual and moral support throughout the early thesis-writing process. Department Permission required. Offered Spring only.',
  },
  {
    course_code: 'IDH3701',
    course_name: 'Service Learning and E-Portfolio Development',
    course_desc:
      'Students will learn about Honors service projects in the Pensacola community and develop a plan for getting involved in one or more projects.  Students will also learn how to access and develop the online e-portfolio software and study basic approaches to e-portfolio development.',
  },
  {
    course_code: 'IDH3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'IDH4030',
    course_name: 'Honors Seminar: Topic I',
    course_desc:
      'Specific Topics will vary; see the Director of the University Honors Program for current offerings. Enrollment in Honors Seminars is by permission of the Director of the Honors Program only.',
  },
  {
    course_code: 'IDH4031',
    course_name: 'Honors Seminar: Topic II',
    course_desc:
      'Specific Topics will vary; see the Director of the University Honors Program for current offerings. Enrollment in Honors Seminars is by permission of the Director of the Honors Program only.',
  },
  {
    course_code: 'IDH4032',
    course_name: 'Honors Seminar: Topic III',
    course_desc:
      'Specific Topics will vary; see the Director of the University Honors Program for current offerings. Enrollment in Honors Seminars is by permission of the Director of the Honors Program only.',
  },
  {
    course_code: 'IDH4033',
    course_name: 'Honors Seminar: Topic IV',
    course_desc:
      'Specific Topics will vary; see the Director of the University Honors Program for current offerings. Enrollment in Honors Seminars is by permission of the Director of the Honors Program only.',
  },
  {
    course_code: 'IDH4034',
    course_name: 'Honors Seminar: Topic V',
    course_desc:
      'Specific Topics will vary; see the Director of the University Honors Program for current offerings. Enrollment in Honors Seminars is by permission of the Director of the Honors Program only.',
  },
  {
    course_code: 'IDH4035',
    course_name: 'Honors Seminar: Topic VI',
    course_desc:
      'Specific Topics vary; see the Director of the University Honors Program for current offerings. Enrollment in Honors Seminars is by permission of the Director of the Honors Program only.',
  },
  {
    course_code: 'IDS4890',
    course_name: 'Senior Capstone',
    course_desc:
      "The Senior Capstone for the Bachelor of General Studies is designed to encourage self-analysis of career and intellectual interests in the student's chosen career or academic field based on the four cognate areas. By way of readings, discussion, analytical exercises, writing assignments, group exercises, and class presentations, students will demonstrate and practice the skills they have acquired throughout their academic careers. Students will develop a detailed project proposal and complete a final research project linking the four areas of study of the student's personalized BGS degree plan with career and intellectual interests. The final written project will consist of research, reviews, and analysis targeted toward a specified audience. A presentation of the project is required.",
  },
  {
    course_code: 'INP3004',
    course_name: 'Industrial Psychology',
    course_desc:
      'Application of psychological principles to problems of employee selection, placement, merit rating, job analysis, management training and other factors related to productivity.',
  },
  {
    course_code: 'INP3313',
    course_name: 'Organizational Behavior',
    course_desc:
      'Understanding human processes in formal organizations, utilizing individual and group exercises which simulate behavioral dynamics in organizations. Content areas include conflict resolution, communication, leadership, planning and control and other organizational processes. May not be taken for credit by students having credit in either MAN3240. MAN3025 or equivalent is suggested prior to taking this course, but not required.',
  },
  {
    course_code: 'INP3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'INP4224',
    course_name: 'Psychology of Workforce Diversity',
    course_desc:
      'Addresses the experience of work as it varies with the gender and ethnic background of workers in the United States. Other bases of diversity (e.g., disability) may also be addressed. Topics include work-related stereotypes and attitudes; discrimination and harassment; career choice, occupational segregation, and employment patterns; group differences related to fair testing and employment practices; the relationship of workforce diversity to processes such as supervision, leadership, mentoring, and power; law and public policy related to diversity and work. Lecture, discussion, and participative learning methods are used. Three hours of psychology or sociology are required prior to taking this course.',
  },
  {
    course_code: 'INP4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'INP5131',
    course_name: 'Legal Issues in Industrial/Organizational Psychology',
    course_desc:
      'Exposes students to laws, guidelines, and court cases (e.g., ADA, ADEA, FMLA, Sexual Harassment, Civil Rights Acts) important to human resource functions in organizations, with particular emphasis on employment testing for selection.',
  },
  {
    course_code: 'INP5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'INP6216',
    course_name: 'Personnel Selection and Appraisal',
    course_desc:
      'Current issues and techniques in selection, placement and appraisal, job analysis, criterion development; the validation process, assessment centers and EEO issues.',
  },
  {
    course_code: 'INP6325',
    course_name: 'Training and Development',
    course_desc:
      'Examines both the theory and practice of Training and Development in organizations. Provides students with a working knowledge of the industrial psychology model of training the adult learner (i.e., assessing training needs, developing training programs, delivering training programs, and evaluating the success of training interventions). Also explores theories of learning and motivation and post-training strategies for enhancing the success of a training program.',
  },
  {
    course_code: 'INP6385',
    course_name: 'Group Dynamics in Organizations',
    course_desc:
      'Students must take MAN3025 or PSY2012 or SOP3004 before enrolling in this course.\nEmphasizes the application of general principles and theories derived from group processes research (particularly the social psychological research) to contemporary organizational problems. The classroom experience will be student-centered. Students will be expected to participate in discussion and classroom exercises, and prepare short written analyses of examples and cases. Topics covered may include: group development and socialization, group structure, conformity and influence, conflict, social identity, commitment, power, leadership, performance and decision-making.',
  },
  {
    course_code: 'INP6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'INP6944',
    course_name: 'Practicum in Industrial Psychology',
    course_desc:
      'Primarily for education in traditional industrial areas. Involves placement in an industrial setting. 6-8 hours per week of field experience for every hour of credit. Must be an industrial-organizational program student and permission is required.',
  },
  {
    course_code: 'INR2002',
    course_name: 'International Politics',
    course_desc:
      'Sources and processes of conflict and cooperation among nation-states.\nMeets General Education requirement in Social Sciences.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'INR3035',
    course_name: 'International Political Economy',
    course_desc:
      'This is a course on International Political Economy, with a focus on globalization processes. Its main goal is to provide students with a theoretical and critical understanding of the ways international financial and trade markets interact with governments and how this interaction has changed in the postwar period. The course examines the following questions: Who wins and who loses from globalization of trade and finance? Who sets the rules under which the game of international capitalism is played? How powerful are international organizations like the WTO, the IMF, and the EU vis-à-vis nation-states? What are the causes and effects of financial crises? These issues are explored with reference to economic and political theories, history and contemporary events.',
  },
  {
    course_code: 'INR3073',
    course_name: 'Analyzing Issues in International Politics',
    course_desc:
      'This course examines several key contemporary issues in international politics. The course has both a theoretical and an applied component, with emphasis on readings to build concepts and empirical   understanding combined with application through discussion and exercises designed to engage students in qualitative and quantitative analysis of these topics. For the applied component,\nthe course approaches contemporary topics by employing the tools of political science research, including data interpretation in visual form such as charts and graphs, statistics, and models.',
  },
  {
    course_code: 'ISM3235',
    course_name: 'Business Development Environments',
    course_desc:
      'Explores the concepts involved in the development of event-driven business applications. Concepts covered include GUI application design and development, object-oriented systems linking business objects, and client-server environments. Uses an object-oriented programming language to demonstrate the concepts. Prior programming experience preferred but not required.',
  },
  {
    course_code: 'INR3503',
    course_name: 'International Organizations',
    course_desc:
      'Modern international organizations are a solution. They are created and designed to address a simple problem: a world of separate states with different interests and agendas. This course will examine international organizations through readings, briefings, and simulations. Along the way, we evaluate and discuss ongoing current events as they relate to global issues. Students will start with the origins of international organizations. With a particular focus on the United Nations, students then research and write position papers as well as practice extemporaneous speaking and committee procedures. In\naddition to an exam and smaller papers throughout the course, students will spend time in a committee simulation and, to conclude, draw together their work in a final project.',
  },
  {
    course_code: 'INR3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'INR4060',
    course_name: 'Causes of War',
    course_desc:
      'This course will examine the causes and evolution of war. Drawing widely from new and established scholarship, it addresses several major topics: war\'s origins and evolution; theories about the causes and nature of war; arguments for a contemporary world of "new wars;" and theories about the future of war. Along the way, the course analyzes several very different international conflicts, World War I, the Cold War and the recent Iraq War. Specific issues addressed amidst these major themes include war and the state; structural and psychological explanations for war; terrorism and irregular war; and the moral/ethical dimensions of war.',
  },
  {
    course_code: 'INR4061',
    course_name: 'International Conflict',
    course_desc:
      'This course examines some of the primary theories of the origins and termination of interstate war. The course begins with a discussion of the logic and empirical support for a number of popular hypotheses and questions on war. Do leaders start war to divert attention from domestic problems? Does trade promote peace? Do alliances deter or entrap? Do arms races promote peace? Does a balance of power promote peace? The discussion of these questions and hypotheses leaves us with a new one. Given that war is costly, why are the contending sides unable to reach a settlement short of the major use of armed force? The course concludes with a discussion of the termination of war.',
  },
  {
    course_code: 'INR4102',
    course_name: 'American Foreign Policy',
    course_desc:
      "Americans seek to change the world and remain distinct from it. They energetically export their religious views, yet they officially support secularism. Americans denounce imperialism and coercion, yet they are accused of building a global empire and wielding astounding military power. And above all these tensions, Americans exert unparalleled influence and power in a globalized, increasingly democratic world that they helped create, yet they fret about relative decline and entertain plans for retrenchment and isolation. This course, therefore, seeks to analyze how Americans view and pursue their relationship with the world as well as the foundations and conduct of their foreign policy. It considers the institutions and offices, interests and political culture, and international challenges (including security, economic and humanitarian issues) that shape American foreign policy outcomes. To understand these influences, our readings, lecture and discussion will combine scholarly theories and policy perspectives. We will especially focus on debates regarding America's role as a global leader.",
  },
  {
    course_code: 'INR4124',
    course_name: 'Statecraft',
    course_desc:
      'This course introduces students to fundamental questions, theoretical arguments and concepts in the area of foreign policy analysis and decision making, otherwise known as Statecraft. The course examines core topics in statecraft such as deterrence (conventional and nuclear), coercive diplomacy, tools of coercion, and the ethics of using force. Throughout the course, students will also study several prominent cases.',
  },
  {
    course_code: 'INR4205',
    course_name: 'Spying: Fact or Fiction',
    course_desc:
      "The objective of this course is to immerse the students in the world of human intelligence collection and counterintelligence. Students will explore and examine various aspects of espionage among great powers in the period since 1945. Focus of the course will be in demonstrating the real world contrast to human intelligence (HUMINT), counterintelligence (CI) and espionage activities revealed in six spy novels. Studies will touch on operations by the German, French, British, Soviet and US HUMINT and CI agencies supporting their nation's vital national interests from World War II to the present.",
  },
  {
    course_code: 'INR4224',
    course_name: 'War and Peace in East Asia',
    course_desc:
      "This course uses East Asian international history since the late 19th Century to explore some of the most enduring questions about international politics. What are the causes of war? How, once begun, do wars end? Why do some wars end in negotiated settlements while others continue until one side's total defeat? How can states effectively communicate their intentions in spite of pervasive incentives to dissemble and prevaricate? When can alliances deter one's enemies, and when might they draw states into undesirable conflicts? Finally, how do the most powerful states in the system -- the great powers -- manage the ever-shifting landscape of power between them? We begin the course in Part I by introducing two critical components of the modern theory of war - uncertainty and commitment problems - that shed light on both why wars start and how they end. Part II begins with the Sino-Japanese War of 1894-1895, which began a marked shift in power away from China and towards Japan, and ends with the collapse of the Japanese Empire at the end of the Second World War. Next, Part III explores the politics of the Cold War, which saw the consolidation of Communist China and the retreat of the Nationalist government to Taiwan at the end of the Chinese civil war and the United States' entry into the region as the status quo superpower during the Korean War. Finally, Part IV takes up questions of China's emergence as an economic power, continuing frontier rivalries with Taiwan, Russia, and smaller neighbors, and the possibility of its emergence as a global power in the coming decades.",
  },
  {
    course_code: 'INR4314',
    course_name: 'Grand Strategy in International Relations',
    course_desc:
      "This course evaluates the historical, philosophical and scientific dimensions of grand strategy. As a topic, \"grand strategy\" refers to the link between a state's goals and capabilities. It is how states understand and pursue their perceived interests and roles in the world. Understanding grand strategies offers an essential tool to evaluate states' foreign policies as well as the international system in which they operate. The course works through several historical and contemporary case studies of great and mid-level powers, such as Russia, China and the United States. It considers grand strategy's institutional, cultural and external sources, and it apprises the normative or ethical goals of grand strategy. Throughout these case studies, students will also engage major theories, and they will interrogate key issues such as economic integration, nonproliferation, diplomatic agendas, conflict and cybersecurity.",
  },
  {
    course_code: 'JPN1120C',
    course_name: 'Japanese I',
    course_desc:
      'For students with no knowledge of Japanese. Lays a foundation for speaking, writing and reading the language.',
  },
  {
    course_code: 'JPN1121C',
    course_name: 'Japanese II',
    course_desc: 'Continuation of Japanese I.',
  },
  {
    course_code: 'INR4334',
    course_name: 'National Security Policy',
    course_desc:
      'This course introduces students to the basic concepts, theoretical debates and practical policy issues surrounding American national security. It examines the historical setting and the major theoretical traditions surrounding the study of national security. It explores the context of national security domestically and internationally, including key players in both the international system and the US political system.  The role of institutions of the national security establishment will be considered such as the executive branch of the US government including the President, the National Security Council, the Department of Defense, and intelligence agencies as well as the roles for the legislative branch in the U.S. Congress. The course also looks at the policy-making process in national security decision-making. Multiple historical cases will be considered with applications of key concepts and theories from the class.',
  },
  {
    course_code: 'INR4364',
    course_name: 'Intelligence',
    course_desc:
      'This course explores the National Foreign Intelligence Community (NFIC).  It examines how organizational factors, resources, management and oversight affect the process of supporting the development and executing U.S. National Security Policy. It covers the evolution, organization, oversight, funding and responsibilities of the NFIC: the relationships of the intelligence providers, especially the Director of National Intelligence (DNI), with key policymakers and overseers such as the President, National Security Council, senior executives; the CONGRESS, its relevant committees and staffs; as well as the courts, the media and public opinion.',
  },
  {
    course_code: 'INR4403',
    course_name: 'International Law',
    course_desc:
      'Nature, history and trends of legal controls on international behavior; conflict between theory and practice; cases will be used to illustrate various points of law.',
  },
  {
    course_code: 'INR4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'INR5065',
    course_name: 'Causes of War',
    course_desc:
      'This course will examine the causes and evolution of war. Drawing widely from new and established scholarship, it addresses several major topics: war\'s origins and evolution; theories about the causes and nature of war; arguments for a contemporary world of "new wars;" and theories about the future of war. Along the way, the course analyzes several very different international conflicts, World War I, the Cold War and the recent Iraq War. Specific issues addressed amidst these major themes include war and the state; structural and psychological explanations for war; terrorism and irregular war; and the moral/ethical dimensions of war.',
  },
  {
    course_code: 'INR5088',
    course_name: 'International Conflict',
    course_desc:
      'This course examines some of the primary theories of the origins and termination of interstate war. The course begins with a discussion of the logic and empirical support for a number of popular hypotheses and questions on war. Do leaders start war to divert attention from domestic problems? Does trade promote peace? Do alliances deter or entrap? Do arms races promote peace? Does a balance of power promote peace? The discussion of these questions and hypotheses leaves us with a new one. Given that war is costly, why are the contending sides unable to reach a settlement short of the major use of armed force? The course concludes with a discussion of the termination of war.',
  },
  {
    course_code: 'INR5105',
    course_name: 'American Foreign Policy',
    course_desc:
      "Americans seek to change the world and remain distinct from it. They energetically export their religious views, yet they officially support secularism. Americans denounce imperialism and coercion, yet they are accused of building a global empire and wielding astounding military power. And above all these tensions, Americans exert unparalleled influence and power in a globalized, increasingly democratic world that they helped create, yet they fret about relative decline and entertain plans for retrenchment and isolation. This course, therefore, seeks to analyze how Americans view and pursue their relationship with the world as well as the foundations and conduct of their foreign policy. It considers the institutions and offices, interests and political culture, and international challenges (including security, economic and humanitarian issues) that shape American foreign policy outcomes. To understand these influences, our readings, lecture and discussion will combine scholarly theories and policy perspectives. We will especially focus on debates regarding America's role as a global leader.",
  },
  {
    course_code: 'INR5129',
    course_name: 'Statecraft',
    course_desc:
      'This course introduces students to fundamental questions, theoretical arguments and concepts in the area of foreign policy analysis and decision making, otherwise known as Statecraft. The course examines core topics in statecraft such as deterrence (conventional and nuclear), coercive diplomacy, tools of coercion, and the ethics of using force. Throughout the course, students will also study several prominent cases.',
  },
  {
    course_code: 'INR5316',
    course_name: 'Grand Strategy in International Relations',
    course_desc:
      "This course evaluates the historical, philosophical and scientific dimensions of grand strategy. As a topic, grand strategy refers to the link between a state's goals and\ncapabilities. It is how states understand and pursue their perceived interests and roles in the world. Understanding grand strategies offers an essential tool to evaluate states' foreign policies as well as the international system in which they\noperate. The course works through several historical and contemporary case studies of great and mid-level powers, such as Russia, China and the United States. It considers grand strategy's institutional, cultural and external sources, and it apprises the normative or ethical goals of grand strategy. Throughout these case studies, students will also engage major theories, and they will interrogate key issues such as economic integration, nonproliferation, diplomatic agendas, conflict and cybersecurity.",
  },
  {
    course_code: 'INR5330',
    course_name: 'National Security Policy, Technology and Cyber',
    course_desc:
      "This course introduces the basic concepts, theoretical debates and practical policy issues surrounding American national security with a focus on technology policy.  Technological innovation changes history. It creates new threats, opens opportunities, upends economies, and allows new types of interaction. It also pressures political leaders to innovate and adapt national security policy. This course presents several different approaches to the analysis of technology and national security. It starts with world historical analyses before turning to more recent theories of politics, innovation, and national security. Throughout, the course focuses particularly on cybersecurity as an evolving policy challenge, and it concludes with a concentrated set of readings on the topic. This is a seminar, and students should be prepared to present and evaluate each day's assigned reading. The course may include several written and oral assignments such as short briefings, research projects or papers, and essay questions on exams.",
  },
  {
    course_code: 'JPN1905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'JPN2200',
    course_name: 'Japanese III',
    course_desc:
      'Japanese III will strengthen speaking and hearing communication skills. Practice on speed, rhythm and pronunciation will be stressed. In addition, this course will focus on basic writing and reading comprehension skills with new Kanji and vocabulary.',
  },
  {
    course_code: 'INR5365',
    course_name: 'Intelligence',
    course_desc:
      'This course explores the National Foreign Intelligence Community (NFIC). It examines how organizational factors, resources, management and oversight affect the process of supporting the development and executing U.S. National Security Policy. It covers the evolution, organization, oversight, funding and responsibilities of the NFIC: the relationships of the intelligence providers, especially the Director of National Intelligence (DNI), with key policymakers and overseers such as the President, National Security Council, senior executives; the CONGRESS, its relevant committees and staffs; as well as the courts, the media and public opinion.',
  },
  {
    course_code: 'INR5547',
    course_name: 'War and Peace in East Asia',
    course_desc:
      "This course uses East Asian international history since the late 19th Century to explore some of the most enduring questions about international politics. What are the causes of war? How, once begun, do wars end? Why do some wars end in negotiated settlements while others continue until one side's total defeat? How can states effectively communicate their intentions in spite of pervasive incentives to dissemble and prevaricate? When can alliances deter one's enemies, and when might they draw states into undesirable conflicts? Finally, how do the most powerful states in the system -- the great powers -- manage the ever-shifting landscape of power between them? We begin the course in Part I by introducing two critical components of the modern theory of war-uncertainty and commitment problems-that shed light on both why wars start and how they end. Part II begins with the Sino-Japanese War of 1894-1895, which began a marked shift in power away from China and towards Japan, and ends with the collapse of the Japanese Empire at the end of the Second World War. Next, Part III explores the politics of the Cold War, which saw the consolidation of Communist China and the retreat of the Nationalist government to Taiwan at the end of the Chinese civil war and the United States' entry into the region as the status quo superpower during the Korean War. Finally, Part IV takes up questions of China's emergence as an economic power, continuing frontier rivalries with Taiwan, Russia, and smaller neighbors, and the possibility of its emergence as a global power in the coming decades.",
  },
  {
    course_code: 'INR6007',
    course_name: 'Seminar in International Relations',
    course_desc:
      'International Relations as a field study; theory, empirical data, historical development of the field.',
  },
  {
    course_code: 'INR6095',
    course_name: 'Politics of Terrorism and Counterterrorism',
    course_desc:
      'This seminar provides an advanced, in-depth analysis of international terrorist threats and the means to counter them. The seminar will focus on the most significant terrorist actors, incidents, and attacks around the world. State sponsorship\nof terrorism will also be included in the seminar. From a strategic perspective, the course will examine terrorist motivations and intentions as well as specific tactics, techniques, and procedures.',
  },
  {
    course_code: 'INR6097',
    course_name: 'Political Violence',
    course_desc:
      'This class explores the conditions under which political actors use violence, and the conditions that lead to civil war and genocide. We approach questions of conflict behavior and political violence from the perspective of strategic choice. Strategic choice explains conflict not as an accident, but as the deliberate result of choice by actors. Actors chose the course of action they think will best help them achieve their preferred outcomes. Focusing on strategic choices helps us to understand how we sometimes fail to achieve peaceful solutions to political problems.',
  },
  {
    course_code: 'INR6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'INS3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ISC5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ISC6529',
    course_name: 'Research Methods in Intelligent Systems and Robotics',
    course_desc:
      'This seminar course introduces students to research methods in Intelligent Systems and Robotics at the academic level. They will read research papers, participate in active research projects, and practice preparing and presenting research presentations.  They will also be introduced to grant writing and proposal preparation. This course will also be an opportunity for the students to familiarize with the research conducted at the ISR Department and at IHMC. Department faculty and IHMC researchers will present on their research in order to expose students to the research projects conducted in the department. Research methods such as literature search, experiment design, technical writing, etc. will also be covered. This course is required for all ISR PhD students in Computer Science. The content of this course varies from semester to semester.',
  },
  {
    course_code: 'ISC7248',
    course_name: 'Deep Reinforcement Learning',
    course_desc:
      'This course addresses deep learning and reinforcement learning and their combination in deep reinforcement learning. Topics include reinforcement learning techniques such as dynamic programming, value iteration, policy iteration, and actor-critic methods. Deep learning techniques include convolution neural networks and learning through backpropagation. These techniques will be combined to create learning policies for various control applications. Extensive software projects will utilize open source libraries from several sources. Students will implement solutions to various problems, including agents learning to play video games and bipedal walking robot simulations. Students are expected to have a background in data structures and algorithms, linear algebra, Calculus II or equivalent, linear differential equations, and control theory.',
  },
  {
    course_code: 'ISC8980',
    course_name: 'Dissertation',
    course_desc:
      "This course is the major individual research in a relevant research area. The dissertation reflects intensive research produced by the student and collaboratively developed with the student's graduate committee. Graded on a satisfactory/unsatisfactory basis only. Admission to candidacy, completion of all other doctoral program requirements, and permission are required.",
  },
  {
    course_code: 'ISM3011',
    course_name: 'e-Business Systems Fundamentals',
    course_desc:
      'Use and application of information system technology in the business environment, with emphasis on the fundamental e-Business models, technology concepts and systems used to enable and conduct electronic business. Concepts include the components of an I.S., the systems development process, the functions of the various types of communication networks, hardware, and software, including practical, hands-on projects designed to enhance e-Business analytical skills.',
  },
  {
    course_code: 'ISM3116',
    course_name: 'Introduction to Business Analytics',
    course_desc:
      'This course uses spreadsheets to identify trends and relationships in business data and how to apply them in a business environment. The focus of the course is on the managerial application of the results rather than the algorithmic derivation of the results. Visualization techniques are also shown.',
  },
  {
    course_code: 'ISM3323',
    course_name: 'Information Security Management',
    course_desc:
      'Information Security in the modern organization is both a management and a technology issue. Course recognizes that technology alone cannot address all the security issues; Prepares students for management and control of security of information systems in organizations; prepares students to make informed decisions regarding administration of information security infrastructure.',
  },
  {
    course_code: 'ISM4113',
    course_name: 'Business Systems Design',
    course_desc:
      'A project-based introduction to the principles of business information systems design, including the basic methods and procedures involved in planning and controlling the development and modification of a computer- based information system in an organization. Students use modern microcomputer-based, computer-aided systems design tools and techniques to complete design projects. Focuses on the importance of end-user specifications for information systems projects.',
  },
  {
    course_code: 'ISM4114',
    course_name: 'Business Information Systems Development',
    course_desc:
      'An advanced course in the application of emerging information technologies to the development of business information systems. Students integrate knowledge from previous courses to plan, analyze, design, and implement a comprehensive, real-world, project. Emphasis is on the integration of business requirements with emerging information technologies to develop the business information systems framework.',
  },
  {
    course_code: 'ISM4117',
    course_name: 'Business Intelligence Applications',
    course_desc:
      'Business Intelligence Applications uses various information technologies to identify, locate, acquire, transform, visualize and analyze business data in an effort to create new data products within an organizational context. The focus of the course is on using methodologies from design science to create new data products for management use in decision making. Offered concurrently with ISM5404; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ISM4320',
    course_name: 'Legal, Ethical, and Human Aspects of Cybersecurity',
    course_desc:
      'This course address the human facets of cybersecurity. Coverage will include ethics, legal and regulatory environment, psychology, and hacker culture. The focus will be on the human element and the motivation and deterrence of cyber-crimes.  Offered concurrently with ISM5327; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ISM4321',
    course_name: 'Cybersecurity Risk Management',
    course_desc:
      'The course focuses on the application of risk management theory and principles to information security policy.  An additional major area of focus is incident response and contingency planning consisting of incident response planning, disaster recovery planning, and business continuity planning. Offered concurrently with ISM5328; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ISM4400',
    course_name: 'Decision Support and Data Integration Systems',
    course_desc:
      'Current tools and techniques available to support managerial decision-making. Analysis and practice in the building and use of decision support systems and expert/knowledge-based systems.',
  },
  {
    course_code: 'ISM4481',
    course_name: 'Business Data Management',
    course_desc:
      'Explores the complexities of data management in the digital world of big data. Uses advanced information technology and software tools to analyze data and create business intelligence. Offered concurrently with ISM5208; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ISM4483',
    course_name: 'Business Data Communication',
    course_desc:
      'Explores the technology and management concepts, issues and decisions related to the infrastructure required to support end-to-end, partner-to-partner electronic business processes required to support end-to-end, partner-to-partner electronic business processes. Additionally, the course provides an overview of basic network management and security concepts. Offered concurrently with ISM5222; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ISM4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ISM4943',
    course_name: 'Internship in Management Information Systems',
    course_desc:
      'On as "as available" basis, MIS majors may request an internship by submitting written proposals to their advisor. Proposals must be approved by the advisor, chairperson, and sponsor. Summer semester internships are offered only during the A term. Senior status, 2.5 GPA overall, and a 3.0 GPA in MIS is required. All internships include report on internship experience, including weekly journals, written reports, and an oral presentation to department chairperson. Graded on a satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'ISM5208',
    course_name: 'Business Data Management',
    course_desc:
      'Explores the complexities of data management in the digital world of big data. Uses advanced information technology and software tools to analyze data and create business intelligence. Offered concurrently with ISM4481; graduate students will be assigned additional work. Graduate student status is required.',
  },
  {
    course_code: 'ISM5222',
    course_name: 'Business Data Communication',
    course_desc:
      'Explores the technology and management concepts, issues and decisions related to the infrastructure required to support end-to-end, partner-to-partner electronic business processes.required to support end-to-end, partner-to-partner electronic business processes. Additionally, the course provides an overview of basic network management and security concepts. Offered concurrently with ISM4483; graduate students will be assigned additional work. Graduate student status is required.',
  },
  {
    course_code: 'ISM5327',
    course_name: 'Legal, Ethical, and Human Aspects of Cybersecurity',
    course_desc:
      'This course address the human facets of cybersecurity. Coverage will include ethics, legal and regulatory environment, psychology, and hacker culture. The focus will be on the human element and the motivation and deterrence of cyber-crimes.  Offered concurrently with ISM4320; graduate students will be assigned additional work. Graduate student status is required.',
  },
  {
    course_code: 'ISM5328',
    course_name: 'Cybersecurity Risk Management',
    course_desc:
      'The course focuses on the application of risk management theory and principles to information security policy.  An additional major area of focus is incident response and contingency planning consisting of incident response planning, disaster recovery planning, and business continuity planning. Offered concurrently with ISM4321; graduate students will be assigned additional work. Graduate student status is required.',
  },
  {
    course_code: 'MVB3334',
    course_name: 'Applied Music Euphonium',
    course_desc:
      'Individual instruction in applied music in euphonium. Primarily for music majors of junior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'ISM5404',
    course_name: 'Business Intelligence Applications',
    course_desc:
      'Business Intelligence Applications uses various information technologies to identify, locate, acquire, transform, visualize and analyze business data in an effort to create new data products within an organizational context. The focus of the course is on using methodologies from design science to create new data products for management use in decision making. Offered concurrently with ISM4117; graduate students will be assigned additional work.  Graduate student status is required.',
  },
  {
    course_code: 'ISM5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ISM6026',
    course_name: 'Management of Information Systems and Technology',
    course_desc:
      'Provides the M.B.A. student with a contemporary managerial perspective on the effective use of information systems in global organizations through case analyses and class discussions. Topics include the business value of information systems, integration of information systems with enterprise strategy, the use of information systems to achieve organizational redesign for strategic advantage, and applying the processes of leadership and management to information systems planning and implementation. Contains a portfolio project.',
  },
  {
    course_code: 'ISM6136',
    course_name: 'Big Data Mining: A Managerial Perspective',
    course_desc:
      'Covers the new management paradigm of data-driven decision making from both a technology and managerial perspective.  Principles of big data and data mining will be discussed in class lectures and employed through assignments and projects.',
  },
  {
    course_code: 'ISM6137',
    course_name: 'Business Analytics',
    course_desc:
      'This course focuses on development of quantitative and analytical skills required to model, analyze, interpret and solve managerial decision making problems.',
  },
  {
    course_code: 'ISM6326',
    course_name: 'Information Systems Auditing and Control',
    course_desc:
      'Focuses on the role of management in controlling information technology and understanding the risks of a highly interconnected business environment.  Topics include information security; contingency planning; desktop computer controls; systems development controls;computer center operation controls; and assurance of information related to on-line, client-server, web-based, internet, cloud computing, virtualization and other advanced computer topics. This course will cover all the topic areas and prepare the student to take the Certified Information Systems Auditor (CISA) exam.',
  },
  {
    course_code: 'ISM6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'JOU3101',
    course_name: 'News Reporting',
    course_desc:
      'This course will serve as an introduction to the world of news reporting, both print and online. Students will get a taste of what journalists do daily: generate story ideas, develop sources, conduct interviews, write, edit, rewrite and edit again. The course also will provide an overview of media law, media ethics and Associated Press style.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'JOU3300',
    course_name: 'Feature Writing',
    course_desc:
      'Researching and writing feature articles for newspapers, trade journals and general circulation magazines. Includes manuscript preparation and querying of editors for publication. Credit may not be earned in both JOU 3330 and JOU3300.',
  },
  {
    course_code: 'JOU3314',
    course_name: 'Environmental Reporting',
    course_desc:
      'Focuses on techniques required to research, report and write environmental new stories for newspapers. Students cover an environmental beat during the semester to gain experience with writing about a wide range of issues relating to environmental journalism. The course also examines issues such as reporting ethics, the role of environmental reporters in the community, the history of environmental journalism and utilization of both government databases and the Internet to gain regulatory information for environmental stories. The course explores environmental stories involving public health, public land management, restoration of endangered species, and eco-activism. Permission is required.',
  },
  {
    course_code: 'JOU3342',
    course_name: 'Media Convergence',
    course_desc:
      'Teaches students to report stories simultaneously appearing in print, broadcast and online. Multimedia reporting melds digital technology platforms with traditional reporting skills, ethics and standards.',
  },
  {
    course_code: 'JOU3700',
    course_name: 'Issues in Journalism',
    course_desc:
      "Introduction to major issues challenging news media in today's digital society, including ethics, public perception of the press, the Internet, political pressures, financial viability and standards of press performance.",
  },
  {
    course_code: 'JOU3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'JOU3940',
    course_name: 'Practicum: Voyager',
    course_desc:
      'Experience in preparing news, opinion and feature material for publication in the student newspaper.',
  },
  {
    course_code: 'JOU4181',
    course_name: 'Public Affairs Reporting',
    course_desc:
      'Principles and procedures involved in reporting and writing news stories about public affairs / government for newspapers, broadcasters and online news services. Permission is required.',
  },
  {
    course_code: 'JOU4201',
    course_name: 'News Editing',
    course_desc:
      'The editing of local and wire copy for media outlets. Strong emphasis on principles of grammar, punctuation, diction, syntax, and logic. Headline writing, cutline writing, news judgment and photo display. Use of standard reference books.',
  },
  {
    course_code: 'JOU4213',
    course_name: 'Newspaper Design',
    course_desc:
      'Principles and practices in newspaper layout and design. Credit may not be received in both JOU4213 and JOU 4211.',
  },
  {
    course_code: 'JOU4306',
    course_name: 'Writing Critical Reviews',
    course_desc:
      'Devoted to writing reviews of books, film, art, and music.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'JOU4308',
    course_name: 'Magazine Writing',
    course_desc:
      'Principles and practices in the art of writing for magazines. Focuses on in-depth reporting and refined focus for the magazine market.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'JOU4313',
    course_name: 'Sports Reporting',
    course_desc:
      'Advanced writing and reporting course that offers students a comprehensive exploration of the many facets and platforms of sports journalism. In addition to lessons and practice in the area of gathering and disseminating original articles and opinion pieces, students will be exposed to contemporary issues facing sports and sports journalism as well as historical perspectives on the coverage of sports in the United States.',
  },
  {
    course_code: 'JOU4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'JOU6115',
    course_name: 'Interviewing and Information Gathering',
    course_desc:
      'Provides advanced grounding in how historians, journalists, and qualitative social scientists employ best practices in interviewing and other information seeking to accomplish their objectives.',
  },
  {
    course_code: 'JOU6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'JPN2201',
    course_name: 'Japanese IV',
    course_desc:
      'Japanese IV will continue building speaking and hearing communication skills developed in Japanese III. Intensive practice on speed, rhythm, and pronunciation will be stressed. In addition, this course will focus on strengthening writing and reading comprehension skills and introduce new Kanji and vocabulary.',
  },
  {
    course_code: 'JPN2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'JPN3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'JPN4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'LAE3314',
    course_name: 'Literacy for the Emergent Learner',
    course_desc:
      'This course introduces pre-service teachers to the development of early literacy from birth through the primary grades. It focuses on the development of language skills, phonological awareness, word identification, fluency, and comprehension. Students will examine theories of early literacy development along with effective practices for instructing young children.',
  },
  {
    course_code: 'LAE3324',
    course_name: 'Teaching Language Arts in the Middle and Secondary Schools',
    course_desc:
      'This course is designed to assist pre-service teachers in utilizing researched-based theory and methods in implementing a dynamic and successful literacy program in the middle/secondary classroom.  Emphasis is placed upon provision of a balance between expressive and practical composition opportunities for students and upon instructional procedures to assist pupils in developing the strategies and skills that support effective written and verbal communication.',
  },
  {
    course_code: 'LAE3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'LAE4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'LAE5345',
    course_name: 'Methods of Advanced Language Arts and Writing',
    course_desc:
      'Students will learn inquiry-based pedagogies for teaching writing in grades K-12, how to create a classroom community of writers through a variety of evidence-based frameworks and practical strategies for effective writing instruction, and effective methods for embedding meaningful stylistic and mechanical instruction to support writer/writing development.',
  },
  {
    course_code: 'LAE5468',
    course_name: 'Literature for Children and Young Adults',
    course_desc:
      'Students in this course will explore contemporary and multicultural literature, authors, illustrators, and genres with a focus on selecting and evaluating quality literature for children and young adults. Topics will address literary understandings, critical perspectives, and issues and trends related to the field. Students will also gain skills for integrating literature into the K-12 school curricula and programs.',
  },
  {
    course_code: 'LAE5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'LAE6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'LAH4131',
    course_name:
      "'Atlantic Indians': How Indigenous and African Peoples Shaped Europe & the Americas",
    course_desc:
      'The trajectories of European and Native American cultures and societies were enmeshed after 1492. Soldiers, colonists, missionaries, readers, and consumers were profoundly affected by their exposure to radically different ways of organizing life, and these effects permeated European culture. This course then takes seriously indigenous men and women as participants-not merely as objects-in the re-making of intellectual history in the Atlantic world. From works of natural science, literature, art, cartography, and philosophy to native artifacts this seminar examines how the discovery of America forever changed Europe and ultimately helped to shape what we call the Americas today.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'LAH4135',
    course_name: 'Spanish Conquest of the Americas',
    course_desc:
      'This seminar examines the encounters between "old" and "new" worlds from the 15th to the 17th centuries. Through both primary and secondary readings we study the clash of cultures and ensuing development of new "creole" societies. While this is a story of devastation, suffering, and violence, it is also a tale of endurance, survival, and accommodation. Throughout the semester we will endeavor to view the "conquest" from multiple perspectives, including indigenous and African, looking beyond the European conquerors. We also investigate themes of gender, religion, and law to gain a much richer understanding of the monumental event that is broadly referred to as the "conquest" of the Americas.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'LAH4451',
    course_name:
      'Greater Mexico: Central America from Conquest to the 20th Century',
    course_desc:
      'This course examines the creation of the nation-states of Central America from Mexico to Panama. We begin with the Aztecs and the Maya, then work our way through the Spanish conquest and colonization of the region. The second half of the course looks at the transition from Spanish colonies to independent nation-states, though still closely tied to the U.S. and other European countries throughout the 19th century. We then study how the influence of and economic dependence upon the U.S. and European nations led Central American states first to Socialism and then to authoritarian regimes in the 20th century. We end by looking at current relationships between the U.S. and Central America, covering themes like the "War on Drugs" and immigration. While each of the countries that make up Central America has a unique history, this course examines them as a group (as the Spanish did), paying particular attention to the themes, events, and patterns that they shared. This will give us a better understanding of some of our closest neighbors.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'LAH4474',
    course_name: 'The Colonial Caribbean',
    course_desc:
      "This course introduces students to the colonial Caribbean, from first contact in 1492 to emancipations in the British Islands in the 1830's. The emphasis throughout is on the Anglophone colonies, though we will cover the early Spanish dominance, African migrations, and the revolution on French St. Domingue.",
  },
  {
    course_code: 'LAH4522',
    course_name: 'The Andes: From the Incas to Today',
    course_desc:
      'This course follows the development of the Andean region (Venezuela, Colombia, Bolivia, Peru, Chile, and Argentina), from the Spanish conquest of the Incan Empire to the fall of the military dictatorships of the late 20th century. It examines the formation of the Spanish colonies and their transition to independent nation-states, though many still retained close ties with the U.K. and Germany, in the 19th century. We will then look at how the influence of and economic dependence upon the U.S. and European nations led Andean states first to Socialism and then to authoritarian/military regimes in the 20th century. While each of the countries that make up the Andes has a unique history, we will examine them as a group, paying particular attention to the themes, events, and patterns that they shared. This will give us a better understanding of some of the most prosperous Latin American countries today.',
  },
  {
    course_code: 'LAH4728',
    course_name:
      'Gender and Sexuality in Latin America from Colonization to Today',
    course_desc:
      'This course examines gender roles and sexuality throughout Latin American History. We begin by investigating pre-Colombian conceptions of sex, gender, and the family. Next we explore how the Spanish conquest altered the role of women in Latin American politics, religion, and society. We also look at how ideas of sex and marriage were altered. After the conquest period notions of gender and sexuality continued to evolve and have a significant impact on independence movements, the creation of nation states, and the abolition of slavery. The course tackles all of these themes, concluding in the 20th century examining current obstacles faced by women and the LGBTQ communities of Latin America. This course explores issues of gender and sexuality across Latin America from Mexico and Cuba to Peru, Brazil, and Colombia.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'LAH4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'LAH6139',
    course_name: 'Early American Borderlands',
    course_desc:
      'Whether they are called Borderlands, Frontier Zones, or the Middle Ground, the territories on the edge and in-between empires are diverse and unique spaces. Often borderlands were less tightly governed then the centers of empire, leaving spaces and opportunities open for diverse groups and classes. It is within these areas that Indians, Africans, pirates, women, and rebels were able to refute colonial powers. This course will study these various borderlands, from the U.S. southwest to Florida, the Caribbean and northern South America. We will examine these frontiers of Spanish, French, and English empires, in particular focusing on the development of unique cultures and societies far from the reaches of the metropole.',
  },
  {
    course_code: 'LAH6476',
    course_name: 'Colonial Caribbean',
    course_desc:
      'This class introduces students to the colonial Caribbean as a historically unique region. Beginning with European contact in 1492, students examine the century of Spanish hegemony before turning to the evolution of the British islands from frontiers to mature plantation societies, and finally concluding with the emancipation of 1833. Students will evaluate scholarship and sources in the classroom and in major research projects.',
  },
  {
    course_code: 'LAH6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'LAT1120C',
    course_name: 'Latin I',
    course_desc:
      'Latin I introduces students to the fundamentals of the Latin language and provides the basic skills for reading and translating Latin poetry and prose. It also exposes students to the language, culture and history of the Romans. Students will master the vocabulary, morphology, and syntax and practice in the fluid translation of Latin to English and English to Latin. In addition to the three hours of scheduled classroom time, students are required to do one hour of laboratory work per week.',
  },
  {
    course_code: 'LEI3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'LEI4321',
    course_name: 'Sport, Adventure and Ecotourism',
    course_desc:
      'Discussion of the concepts, theories and issues relevant to the development of tourism, with an emphasis on sport, adventure and nature based tourism. Examination of the challenges and practices associated with the planning and development of tourism, marketing strategies, funding, government involvement, financing of the infrastructure, event organization, contracts, public relation strategies and career opportunities. Introduction and overview of tourism "niches" including festivals, special events, urban, rural, cultural, peace and educational tourism. Upper level status is required.',
  },
  {
    course_code: 'LEI4332',
    course_name: 'Community Tourism Development',
    course_desc:
      'Examines the relationship between tourism development and host communities. Students study the positive and negative economic, social, environmental and political implications of tourism development. The role of natural and man-made attractions, theme parks, convention and sports facilities as catalysts to tourism development. Issues of community participation in tourism planning and managing the tourism/ community relationships. Junior or Senior classification is required.',
  },
  {
    course_code: 'LEI4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'LEI5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'LEI6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'LIN3673',
    course_name: 'Grammar for Professional Success',
    course_desc:
      'An upper-division grammar class which focuses on the principles and conventions of writing. The purpose of this course is twofold: to review the regulatory rules of writing so that students can write responsibly by controlling and editing their own work; and to offer students the language choices available to them as speakers and writers of American English: language choices for informal conversations and texting, for instance, versus language choices for academic, business, and other forms of published writing. Because acceptable professional communication is different from some "acceptable" forms of digital communication, the course makes overt distinctions between the two. Whether your goal is to improve your writing, review the mechanics of writing, become a professional editor, or to learn enough grammar to teach it, this course will give you the kind of knowledge about the English language that most educated members of our society share. The principal goal of Practical Grammar is to offer students a review of the principles and rules of standard American English so that they can edit their own documents. As William Strunk, Jr. says in The Elements of Style, "One must first know the rules [of grammar] to break them.".',
  },
  {
    course_code: 'LIN3742',
    course_name: 'Modern Grammar and Usage',
    course_desc:
      'Grammar of modern English, including traditional; concentration on structural, generative and transformational approaches. Intended for English majors, required of those preparing for careers in secondary education.',
  },
  {
    course_code: 'LIN3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'LIN5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'LIN6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'LIS4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'LIS6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'LIT1905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MVB3335',
    course_name: 'Applied Music Tuba',
    course_desc:
      'Individual instruction in applied music in tuba. Primarily for music majors of junior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'LIT2000',
    course_name: 'Introduction to Literature',
    course_desc:
      'This course is designed for students from all majors who are interested in learning more about reading literature at the college level. A wide range of literary works are examined, with an emphasis on exposing students to as many genres as possible. Critical thinking and writing skills are also emphasized. Students considering a major in English or who enjoy reading good books are encouraged to take this course. Credit may not be received in both LIT2000 and LIT2100.\nMeets General Education requirement in Humanities.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'LIT2030',
    course_name: 'Introduction to Poetry',
    course_desc:
      'Elements of poetry, terminology of prosody, genre, and the poetic process. Writing of short analytical papers and creative works. Course is open to all UWF students.\nMeets General Education requirement in Humanities.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'LIT2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'LIT3084',
    course_name: 'Modern Prose Fiction',
    course_desc:
      'Selected prose fiction of 20th century and related criticism.',
  },
  {
    course_code: 'LIT3191',
    course_name: 'World Literature',
    course_desc:
      'Covers a range of topics focusing on non-U.S. literatures. Texts vary each semester according to interest and expertise of the instructor.',
  },
  {
    course_code: 'LIT3233',
    course_name: 'Postcolonial Literature',
    course_desc:
      'Examines world literature produced in the context of colonialism and subsequent movements for independence. Links the study of literature to the political, psychological and cultural effects of imperialism and globalization. Specific topics vary according to faculty expertise and research interests.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'LIT3463',
    course_name: 'Literature and Visual Studies',
    course_desc:
      'Examines literature in the context of film, the visual arts, and emerging new media. Emphasis on twentieth century and contemporary literary and aesthetic movements.',
  },
  {
    course_code: 'LIT3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'LIT4013',
    course_name: 'The Novel',
    course_desc:
      'The novel as a genre; exploration of the techniques of narrative, characterization, point of view, voice, reflexivity and others. May include texts from diverse national origins.',
  },
  {
    course_code: 'LIT4385',
    course_name: 'Feminist Theory',
    course_desc:
      'This course offers focused study of both the history of feminist theory and contemporary developments in feminist theory. The course will cover both pre-modern ("proto") and modern ("first-wave") feminist works by women as well as explore contemporary ("second" and "third-wave") feminist theory. Specific course readings will vary from year to year.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'LIT4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'LIT5018',
    course_name: 'Topics in Fiction',
    course_desc:
      'Special topics in fiction. Topics change each term. See department or instructor for specific topic.',
  },
  {
    course_code: 'LIT5037',
    course_name: 'Topics in Poetry',
    course_desc:
      'Special topics in poetry. Focus of course will be determined by faculty expertise and interest.',
  },
  {
    course_code: 'LIT5556',
    course_name: 'Feminist Theory',
    course_desc:
      'This course offers focused study of both the history of feminist theory and contemporary developments in feminist theory. The course will cover both pre-modern ("proto") and modern ("first-wave") feminist works by women as well as explore contemporary ("second" and "third-wave") feminist theory. Specific course readings will vary from year to year.',
  },
  {
    course_code: 'LIT5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'LIT6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAA4211',
    course_name: 'Advanced Calculus I',
    course_desc:
      'The theory of functions of a real variable. Inequalities, sequences, rigorous discussion of limits, continuity, differentiability and Riemann integrals. Basic concepts of point set topology on the real line.\nMeets Gordon Rule Theoretical Mathematics Requirement.',
  },
  {
    course_code: 'MAA4402',
    course_name: 'Analytic Functions',
    course_desc:
      'Parts of the theory of complex variables that are prominent in applications of the subject. Topics covered: the algebra and geometry of complex numbers, Cartesian and polar representation, differentiability of complex functions, analytic functions, the elementary functions, contour integrals and the Cauchy-Goursat theorem, the Cauchy integral formulae, power series expansions, residue theorem. Offered concurrently with MAA 5404; graduate students will be assigned additional work.',
  },
  {
    course_code: 'MAA4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAA5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAA6306',
    course_name: 'Real Analysis',
    course_desc:
      'A classical real analysis course begins with a typological study of the real number line and includes the Holder and Minkowski  inequalities, and other classical inequalities; metric spaces, open and closed sets, convergence, Cauchy sequences, completeness, continuity;  normed spaces. The course also includes the Lebesgue integral on the real line, convergence results for sequences of functions. Students are expected to have been exposed to rigorous discussions of limits, continuity, differentiability, Riemann integrals, and basic concepts of point set topology on the real line.',
  },
  {
    course_code: 'MAA6426',
    course_name: 'Complex Analysis',
    course_desc:
      "Several advanced topics in the theory of complex variables are covered including analytic functions, harmonic functions, Cauchy's theorem and integral formula, maximum modulus principle, Laurent series, singularities, and the residue theorem. The course objective is to present in a rigorous manner the parts of the theory that are prominent in applications of the subject.",
  },
  {
    course_code: 'MAA6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAC1105',
    course_name: 'College Algebra',
    course_desc:
      'Provides the concepts and techniques of algebra that are needed to understand subjects such as statistics and economics which contain a considerable amount of quantitative reasoning. Is additionally a preparatory course for the study of calculus. Major topics include: the concept of functions, graphs of functions and relations, operations on functions, rational functions, exponentials and logarithms, systems of equations and inequalities, applications. Prerequisite course or appropriate score on placement test is required.\nMeets General Education requirement in Mathematics.\nMeets Gordon Rule Theoretical Mathematics Requirement.',
  },
  {
    course_code: 'MAC1105C',
    course_name: 'College Algebra with Lab',
    course_desc:
      'Provides the concepts and techniques of algebra that are needed to understand subjects such as statistics and economics, which contain a considerable amount of quantitative reasoning.  It is, additionally, a preparatory course for the study of calculus.  This course reviews the material contained in intermediate algebra and covers the material in college algebra.  Major topics include: the concept of functions, operations on function, rational functions, exponentials and logarithms, systems of equations and inequalities, applications.  Students may not earn credit for both MAC1105C (Intensive College Algebra) and MAC1105 (College Algebra).\nMeets General Education requirement in Mathematics.\nMeets Gordon Rule Theoretical Mathematics Requirement.',
  },
  {
    course_code: 'MAC1114',
    course_name: 'Trigonometry',
    course_desc:
      'Trigonometric functions, their properties and graphs, inverse trigonometric functions, their properties and graphs, trigonometric identities, conditional trigonometric equations; solutions of triangles, vector algebra, parametric equations, polar coordinates, applications. College Algebra or a strong high school algebra background is required.\nMeets General Education requirement in Mathematics.\nMeets Gordon Rule Theoretical Mathematics Requirement.',
  },
  {
    course_code: 'MAC1140',
    course_name: 'Precalculus Algebra',
    course_desc:
      'Stresses the aspects of algebra that are important for the calculus sequence. Lays emphasis on graphs in the study of functions and algebraic relations. Covers polynomials; rational functions; logarithmic, exponential, and piecewise defined functions; inequalities; conic sections; matrices; sequences, and series; mathematical induction. Prerequisite course or appropriate score on placement test is required.\nMeets General Education requirement in Mathematics.\nMeets Gordon Rule Theoretical Mathematics Requirement.',
  },
  {
    course_code: 'MAC1147',
    course_name: 'Precalculus with Trigonometry',
    course_desc:
      'This course stresses the aspects of algebra and trigonometry that are important for the calculus sequence. The course lays emphasis on graphs in the study of functions and algebraic relations; covers polynomials, rational functions, logarithmic, exponential, and piecewise define functions; inequalities; conic sections; matrices; and sequences and series.  Additionally, the course covers angles, trigonometric functions and graphs; inverse trigonometric functions and graphs; trigonometric formulas, identities and equations; solutions of triangles; and polar coordinates, equations, and graphs.\nMeets General Education requirement in Mathematics.\nMeets Gordon Rule Theoretical Mathematics Requirement.',
  },
  {
    course_code: 'MAC1905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAC2233',
    course_name: 'Calculus with Business Applications',
    course_desc:
      'Sets and functions; derivatives; areas under a curve; integration; exponentials and logarithms; applications of derivatives and integrals.\nMeets General Education requirement in Mathematics.\nMeets Gordon Rule Theoretical Mathematics Requirement.',
  },
  {
    course_code: 'MAC2311',
    course_name: 'Analytic Geometry and Calculus I',
    course_desc:
      'Differential and Integral Calculus of Algebraic, Trigonometric, and Transcendental functions of single variables. Related applications.\nMeets General Education requirement in Mathematics.\nMeets Gordon Rule Theoretical Mathematics Requirement.',
  },
  {
    course_code: 'MAC2312',
    course_name: 'Analytic Geometry and Calculus II',
    course_desc:
      'Application of the Definite Integral. Hyperbolic and Inverse Trigonometric Functions. Methods of Integration. Sequences and Infinite Series.\nMeets General Education requirement in Mathematics.\nMeets Gordon Rule Theoretical Mathematics Requirement.',
  },
  {
    course_code: 'MAC2313',
    course_name: 'Analytic Geometry and Calculus III',
    course_desc:
      'Analytic Geometry and Calculus. Vectors and Vector-Valued Functions. Partial Differentiation. Multiple Integration.',
  },
  {
    course_code: 'MAC2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAC3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAC3949',
    course_name: 'Cooperative Education',
    course_desc:
      'Alternating full-time or consecutive parallel terms of practical experience in the intended field. Reinforcing academic preparation; confirming educational and career goals; personal and professional development; early start in career; earnings toward self-support; improved employability. (See program description under Cooperative Education). Graded on satisfactory / unsatisfactory basis only. Permission of director of Cooperative Education is required.',
  },
  {
    course_code: 'MAC4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAD4401',
    course_name: 'Numerical Analysis',
    course_desc:
      'Numerical solutions of equations in one variable, interpolation and polynomial approximation, numerical differentiation and integration, numerical solutions of initial value and boundary value problems for O.D.E., direct methods for solving linear systems, iterative techniques in matrix algebra. Some problems solved with aid of computer. A computer language is required prior to this course.\nMeets Gordon Rule Theoretical Mathematics Requirement.',
  },
  {
    course_code: 'MAD4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAD5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAD6396',
    course_name: 'Topics in Combinatorial Theory',
    course_desc:
      'This course is devoted to topics chosen from among graph theory, coding theory, matroid theory, design theory, finite geometries, projective geometries, optimization, and searching and sorting algorithms.',
  },
  {
    course_code: 'MAD6405',
    course_name: 'Numerical Analysis I',
    course_desc:
      'Theoretical treatment of numerical methods of linear algebra supplemented with use of computers; polynomial approximations, uniform approximations, least square approximations, error analysis for numerical solutions of linear equations, algebraic eigenvalue problems.',
  },
  {
    course_code: 'MAE3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAE4310',
    course_name: 'Teaching Mathematics in Elementary Schools',
    course_desc:
      'This course is a requirement for the elementary education teacher preparation program. The course is designed to provide students with the methodology requisite for effective mathematics teaching in elementary school classrooms. The coursework centers on utilizing mathematics content knowledge and process skills in the development of effective instructional strategies for the elementary level learners. This course addresses B.E.S.T. Standards for K-12 Mathematics within lesson planning assignments. Material and supply fee will be assessed.',
  },
  {
    course_code: 'MAE4320',
    course_name: 'Teaching Mathematics in Middle and Secondary Schools',
    course_desc:
      'Theory and methods of teaching Mathematics in the middle and secondary schools; explores current research on  approaches in teaching and learning mathematics; examines the practice of mathematics, disciplinary core ideas in mathematics, and crosscutting themes in mathematics; compares various models of teaching (i.e.  direct instruction, inquiry, project-based learning); Includes practices to effectively move student thinking toward meaningful understanding focusing on best practices in STEM disciplines.',
  },
  {
    course_code: 'MAE4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAE6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAN3025',
    course_name: 'Management Fundamentals',
    course_desc:
      'Study of principles of management. Process and content of management analyzed. Emphasizes classical, human relations, human resources, behavioral and quantitative management methods. Content includes planning, organizing, leading, control, employment cycle, organization design, and motivation.',
  },
  {
    course_code: 'MAN3240',
    course_name: 'Behavior in Organizations',
    course_desc:
      'A study of human and group behavior in organizations and within society. The focus is on developing student ability to work in group settings and organizations. Topics include personality, motivation, leadership, communication, power, change, and conflict. May not be taken for credit by students having credit  INP3313.',
  },
  {
    course_code: 'MAN3301',
    course_name: 'Human Resources Management',
    course_desc:
      'Introduction to personnel administration; emphasis on the basic personnel function of both the personnel specialist and the operating manager. Critical issues stressed include selection, compensation, OSHA, EEO, unions and discipline.',
  },
  {
    course_code: 'MAN3504',
    course_name: 'Operations Management',
    course_desc:
      'Application of quantitative and qualitative management techniques for improving quality and efficiency of manufacturing and service organizations. Coverage of productivity, quality, forecasting, design of goods/shared/services, project management and other related topics.',
  },
  {
    course_code: 'MAN3550',
    course_name: 'Introduction to Management Science',
    course_desc:
      'Quantitative decision-making methods and their application to planning and control of operations. Systems concept of organization and mathematical reasoning in decision-making emphasized. Cases and incidents provide illustrations. Credit can only be earned for one of these three courses: MAN 3540, MAN3550 and QMB3820.',
  },
  {
    course_code: 'MAN3583',
    course_name: 'Project Management',
    course_desc:
      'An introduction to the field of Project Management. Covers concepts and skills used to propose, plan, secure resources, budget, manage risk, and lead teams to successful project completion. The course emphasizes the universal nature of the techniques which enable individuals to manage a variety of projects in diverse organizational settings. Students individually develop project plans for projects in their respective disciplines.',
  },
  {
    course_code: 'MAN3802',
    course_name: 'Small Business/Family Business Management',
    course_desc:
      'Introduces the student to the world of small business and family business management. Explores the managerial processes related to these areas and differentiates them from those found in corporations and large organizations. Provides the student with an opportunity to analyze the mind of the small business manager, brainstorm potential business options, and consider various contemporary issues facing the small business manager.  Group projects will be utilized and oral and written reports will be required.  Junior standing is required for degree seeking students.',
  },
  {
    course_code: 'MAN3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAN4102',
    course_name: 'Management of Diversity',
    course_desc:
      'Roles, behaviors, career paths, motivational strategies, obstacles, and collegial reaction to managing diversity within the labor force are an integral aspect of the course. Personal assessment of communication styles and diversity in management styles. Discussions focus on diversity awareness and strategies to enhance productivity through team effort. Emphasis on proactive steps to integrate a diverse work force toward a more productive unit. Offered concurrently with MAN5116; graduate students will be assigned additional work.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'MAN4280',
    course_name: 'Business Leadership and Change Management',
    course_desc:
      'A course on Leadership and Change Management to prepare students to respond to the needs of a dynamic global business climate. Prepares students to take responsibility to work collaboratively with others in developing change management strategies in bringing about change and overcoming resistance.',
  },
  {
    course_code: 'MAN4330',
    course_name: 'Compensation and Benefits',
    course_desc:
      "Compensation and benefits play an important role in attracting, motivating, and retaining employees.  This course examines how to establish and manage effective compensation and benefits systems that support the organization's strategic direction while also meeting employee needs and complying with legal requirements. Offered concurrently with MAN5331; graduate students will be assigned additional work.",
  },
  {
    course_code: 'MAP6107',
    course_name: 'Mathematical Methods of Operations Research II',
    course_desc:
      'Interior-point algorithm, linear goal programming, game theory, nonlinear programming, network analysis, PERT / CPM, queuing theory. Credit may not be received in both MAP6107 and STA 6608.',
  },
  {
    course_code: 'MAN4341',
    course_name: 'Performance Management',
    course_desc:
      "Employees are commonly recognized as an organization's most valuable resource. Thus, ensuring that employees achieve and maintain their highest performance is one of the most critical managerial responsibilities. This course examines best practices, current trends, legal issues, and research in change management, organizational development, performance management, and training so that students may learn how to effectively manage human capital for optimal performance. Offered concurrently with MAN5347; graduate students will be assigned additional work.",
  },
  {
    course_code: 'MAN4350',
    course_name: 'Recruitment and Selection',
    course_desc:
      "Employees are commonly recognized as an organization's most valuable resource.  Thus, effectively staffing an organization is one of the most critical managerial responsibilities. This course examines best practices, current trends, legal issues, and research on effective recruitment and selection of human capital so that students may learn how to establish and effectively manage staffing systems. Offered concurrently with MAN5351; graduate students will be assigned additional work.",
  },
  {
    course_code: 'MAN4441',
    course_name: 'Business Negotiation',
    course_desc:
      'A practical understanding of negotiation theories and concepts from a business perspective is offered. Students differentiate and practice distributive and integrative negotiation strategies via business related role plays and cases. As future managers, students: 1) practice negotiation where their responsibility exceeds their authority; 2) build coalitions among different stakeholders; and 3) analyze business conflict situations and select strategies to resolve differences. Offered concurrently with MAN5446; graduate students will be assigned additional work.',
  },
  {
    course_code: 'MAN4570',
    course_name: 'Purchasing and Supply Management',
    course_desc:
      'Students will learn the fundamental concepts of purchasing, negotiation and supply management. Emphasis is placed on strategic sourcing, negotiation, cost management, balanced scorecards, ethics, electronic purchasing, forming supplier partnerships and managing supplier quality. The class will provide strategic understanding for the organizational buyer and challenge students with practical examples of purchasing situations relevant within the supply chain.\nOffered concurrently with MAN 5573; graduate students will be assigned additional work.',
  },
  {
    course_code: 'MAN4597',
    course_name: 'Global Logistics Management',
    course_desc:
      'This course explores logistics and supply chain operations from a global perspective. Course material and experiences will focus on import and export processes, port and logistics facility operations, raw material and finished goods movement across borders, and equipment and technology for global logistics.\nOffered concurrently with MAN5619; graduate students will be assigned additional work.',
  },
  {
    course_code: 'MAN4720',
    course_name: 'Strategic Management',
    course_desc:
      'The capstone course for BSBA in the College of Business offers a culminating experience for students from all majors which involves aggregate planning and development of overall policy for organizations. Emphasizes the system interrelationship of the functional areas of enterprise from the viewpoint of top executives. Senior status and permission is required. Must be taken at UWF.',
  },
  {
    course_code: 'MAN4750',
    course_name: 'The Future: Projecting, Planning and Managing',
    course_desc:
      'Roles that individuals and organizations have in managing the future. Senior status is required; business majors only. Must be taken at UWF.',
  },
  {
    course_code: 'MAN4801',
    course_name: 'Business Plan Development for New Ventures',
    course_desc:
      'Students working in teams will brainstorm potential business options and develop a business plan to serve as a strategic roadmap for the proposed venture as well as the basis for seeking financial support from lenders and / or investors. Business plans will be presented to a jury of practitioners who will evaluate its practical merits and the presentation. Group projects will be utilized and oral and written reports will be required.Senior standing is required for degree seeking students.',
  },
  {
    course_code: 'MAN4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAN4940',
    course_name: 'Internship in Management',
    course_desc:
      'On an "as available" basis, management majors may request an internship in management by submitting written proposals to faculty advisors. Proposals must be approved by advisor, chairperson and sponsor. Students must have a 2.5 GPA overall and a 3.0 GPA in management to be eligible for internships. All internships include seminar on internship experience, including written reports. Graded satisfactory / unsatisfactory basis only. Senior status required. Permission is required.',
  },
  {
    course_code: 'MAN5116',
    course_name: 'Management of Diversity',
    course_desc:
      'Roles, behaviors, career paths, motivational strategies, obstacles, and collegial reaction to managing diversity within the labor force are an integral aspect of the course. Personal assessment of communication styles and diversity in management styles are provided. Discussions focus on diversity awareness and strategies to enhance productivity through team effort. Emphasis on proactive steps to integrate a diverse work force toward a more productive unit. Offered concurrently with MAN4102; graduate students will be assigned additional work. All majors encouraged. Graduate student status is required. Credit may not be earned in both MAN 5105 and MAN5116.',
  },
  {
    course_code: 'MAN5331',
    course_name: 'Compensation and Benefits',
    course_desc:
      "Compensation and benefits play an important role in attracting, motivating, and retaining employees.   This course examines how to establish and manage effective compensation and benefits systems that support the organization's strategic direction while also meeting employee needs and complying with legal requirements. Offered concurrently with MAN4330; graduate students will be assigned additional work. Graduate student status is required.",
  },
  {
    course_code: 'MAN5347',
    course_name: 'Performance Management',
    course_desc:
      "Employees are commonly recognized as an organization's most valuable resource. Thus, ensuring that employees achieve and maintain their highest performance is one of the most critical managerial responsibilities. This course examines best practices, current trends, legal issues, and research in change management, organizational development, performance management, and training so that students may learn how to effectively manage human capital for optimal performance. Offered concurrently with MAN4341; graduate students will be assigned additional work. Graduate student status is required.",
  },
  {
    course_code: 'MAN5351',
    course_name: 'Recruitment and Selection',
    course_desc:
      "Employees are commonly recognized as an organization's most valuable resource.  Thus, effectively staffing an organization is one of the most critical managerial responsibilities. This course examines best practices, current trends, legal issues, and research on effective recruitment and selection of human capital so that students may learn how to establish and effectively manage staffing systems.  Offered concurrently with MAN4350; graduate students will be assigned additional work. Graduate student status is required.",
  },
  {
    course_code: 'MAN5446',
    course_name: 'Business Negotiation',
    course_desc:
      'A practical understanding of negotiation theories and concepts from a business perspective is offered. Students differentiate and practice distributive and integrative negotiation strategies via business related role plays and cases. As future managers, students: 1) practice negotiation where their responsibility exceeds their authority; 2) build coalitions among different stakeholders; and 3) analyze business conflict situations and select strategies to resolve differences. Offered concurrently with MAN4441; graduate students will be assigned additional work. Graduate student status is required.',
  },
  {
    course_code: 'MAN5619',
    course_name: 'Global Logistics Management',
    course_desc:
      'This course explores logistics and supply chain operations from a global perspective. Course material and experiences will focus on import and export processes, port and logistics facility operations, raw material and finished goods movement across borders, and equipment and technology for global logistics.\nMust have the equivalent of MAR3202 Supply Chain Logistics Management, TRA3153 Transportation Strategy, or MAN3504 Operations Management.\nOffered concurrently with MAN4597; graduate students will be assigned additional work.',
  },
  {
    course_code: 'MAN5806C',
    course_name: 'Small Business Management Consulting',
    course_desc:
      'Practicum in providing management assistance to small businesses in area. Usually students work in pairs and provide assistance to two business firms. Weekly meetings, teaching in consulting and final written report on each firm constitute principal elements. Senior or graduate status, 3.0 GPA and permission are required.',
  },
  {
    course_code: 'MAN5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAN6156',
    course_name: 'Management and Organizational Behavior',
    course_desc:
      'Appreciation and understanding of the field of organizational behavior and its application in managing human and other resources. Emphasizes understanding individual behavior (motivation, self-awareness, leadership, etc.) and group dynamics (decision-making, group development and work) plus conflict, climate, learning styles, power, stress, process/content, human rights and quality. Utilizes experiential learning methodologies and other appropriate designs. May not be taken for credit by students having credit for INP 6397. Permission is required.',
  },
  {
    course_code: 'MAN6317',
    course_name: 'Strategic Issues in Human Resources Management',
    course_desc:
      'Integrates current research, best practices, human resource policy and strategy in order to maximize organizational effectiveness using human capital.  Emphasis is placed on applying strategic human resource management principles in order to leverage the workforce to achieve organizational objectives. Case analyses using real business problems are analyzed by integrating the functional areas of human resource management with business strategies, helping students to understand the linkage between theory and practice.',
  },
  {
    course_code: 'MAN6511',
    course_name: 'Operations Management Problems',
    course_desc:
      'Planning and control of domestic and multinational service and manufacturing operations utilizing information inside and outside the organization. Techniques to plan and improve location, layout, flow through the facility, design of work, and management of the human factor; all with an emphasis on management and maintenance of quality.',
  },
  {
    course_code: 'MAN6721',
    course_name: 'Strategic Management and Policy Formulation',
    course_desc:
      'Utilizes case analysis, a strategic simulation and other related experiential exercises. Integrates and applies the various business management functions from the strategic viewpoint of the organizational chief executive officer. Designed for M.B.A. candidates and should be taken the last semester before graduation. Permission is required.',
  },
  {
    course_code: 'MAN6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAP2302',
    course_name: 'Differential Equations',
    course_desc:
      'Introduction to ordinary differential equations; emphasis on linear equations, operator methods, systems of equations. Applications.\nMeets Gordon Rule Theoretical Mathematics Requirement.',
  },
  {
    course_code: 'MAP3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAP4341',
    course_name: 'Partial Differential Equations',
    course_desc:
      'First-order equations, derivation and classification of second-order equations. Solution techniques of boundary value and initial value problems; applications. Offered concurrently with MAP5345; graduate students will be assigned additional work.\nMeets Gordon Rule Theoretical Mathematics Requirement.',
  },
  {
    course_code: 'MAP5345',
    course_name: 'Partial Differential Equations',
    course_desc:
      'First-order equations, derivation and classification of second-order equations. Solution techniques of boundary value and initial value problems; applications. (Gordon Rule Course: Theoretical Math) Offered concurrently with MAP4341; graduate students will be assigned additional work.',
  },
  {
    course_code: 'MAP5471',
    course_name: 'Advanced Probability and Inferences',
    course_desc:
      "Advanced topics in probability, limit theorems, limiting distributions, order statistics, weak law of large numbers, strong law of large numbers, central limit theorem. Advanced topics in point and interval estimation, measures of quality of estimates, Exponential families, Completeness, Unbiasedness, Cramer-Rao inequality, Rao-Blackwell theorem, minimum variance unbiased estimators, maximum likelihood estimators principles, Bayes' and minimax estimation, Robust estimation; Advanced hypothesis testing.",
  },
  {
    course_code: 'MAP5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAP6106',
    course_name: 'Mathematical Methods of Operations Research I',
    course_desc:
      'Mathematical linear programming models, theory of simplex method, revised simplex methods, dual simplex methods; duality theory and sensitivity analysis, transportation problems, theory of integer programming. Credit may not be received for both MAP6106 and STA 6607.',
  },
  {
    course_code: 'MAP6108',
    course_name:
      'Mathematical Modeling and Initial and Boundary Value Problems',
    course_desc:
      'Methodology and framework for mathematical modeling. Current topics in applied mathematics will be presented emphasizing the interdependency of mathematics and its applications to physical, societal and other "real world" phenomena.',
  },
  {
    course_code: 'MAP6114',
    course_name: 'Machine Learning',
    course_desc:
      'Machine learning uses interdisciplinary techniques such as statistics, linear algebra, optimization and computer science to create automated systems that can shift through large volumes of data at high speed to make predictions or decisions without human intervention. \nMAS3105 and the ability to program algorithms in a language of Matlab or Python are required before taking the course.',
  },
  {
    course_code: 'MAP6377',
    course_name: 'Numerical Analysis of Partial Differential Equations',
    course_desc:
      'This course provides a basic foundation in numerical methods for solving partial differential equations.',
  },
  {
    course_code: 'MAP6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAP6930',
    course_name: 'Topics in Applied Mathematics',
    course_desc:
      'This course is devoted to applications chosen from among Numerical Analysis, Numerical Linear Algebra, Ordinary and Partial Differential Equations, Optimization, Mathematical Modeling, and Mathematical Visualization.',
  },
  {
    course_code: 'MAR3023',
    course_name: 'Marketing Fundamentals',
    course_desc:
      'Function of marketing in our economic system; role of the consumer in marketing decisions; the decisions marketing managers must make to provide goods and services priced, promoted and distributed to meet organizational objectives in changing environments.',
  },
  {
    course_code: 'MAR3202',
    course_name: 'Supply Chain Logistics Management',
    course_desc:
      'Presents the fundamental elements of integrated supply chain and logistics management. It examines the strategic and operational decisions necessary to plan, implement, and control the procurement, storage, management, and distribution of materials, components, and finished goods. Emphasis is placed on product, service, information, and financial flows as facilitated by supply chain logistics strategies, transportation and distribution center operations, facility and network design, inventory and order management, customer service, information execution systems, and outsourcing decisions.',
  },
  {
    course_code: 'MAR3370',
    course_name: 'Information Sources for Business Decisions',
    course_desc:
      'Focuses on various secondary information sources that may be used for business decisions. Students learn how secondary information is organized, what types of secondary information sources are available and how these sources may be effectively and efficiently searched. Emphasis is placed on learning the types of online information services and knowledge of when to use which service. A course project is designed to teach students to evaluate, integrate, and report information. A valuable tool in helping students access information; should be taken early in the junior year if possible. Students will be expected to have some familiarity with Windows and the Internet.',
  },
  {
    course_code: 'MAR3503',
    course_name: 'Consumer Behavior',
    course_desc:
      'The study of people as customers of business - how they think and feel when making purchase choices and how they behave in the marketplace. Draws from theory in marketing, social psychology, anthropology, economics, and other social sciences to describe how customers respond to marketing strategies. Emphasis on how to use this in-depth understanding of the market to create winning marketing and business strategy.',
  },
  {
    course_code: 'MAR3714',
    course_name: 'Sports Markets',
    course_desc:
      'Systematic study of the spectator sports industry. The role and importance of the commercial sector is a particular emphasis. Focus on the structure and characteristics of sports markets and how to develop them with sports marketing.',
  },
  {
    course_code: 'MAR3860',
    course_name: 'Customer Relationship Management',
    course_desc:
      "Understanding the needs, desires and behavior of customers often determines which company will survive. Customer Relationship Management (CPM) is doing business through one-to-one relationships using new technological advances created by the information revolution. Focuses on customer development and retention, particularly for the firm's best customers, with emphasis on the management of customer relationships.",
  },
  {
    course_code: 'MAR3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAR4156',
    course_name: 'Seminar in International Marketing',
    course_desc:
      'Emphasis on the emergence of a global marketplace and significant new challenges facing business management in a competitive and rapidly changing international environment. Stresses the problems and challenges that differences in cultural, political, and socioeconomic environments introduce into the marketing process in international operations. Main focus is on the European Union, broadly interpreted to include countries throughout Europe. Foreign competitors and their effects on the American market will also be explored.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'MAR4231',
    course_name: 'Retail Strategy',
    course_desc:
      'Instruction in beginning a successful management career in retailing. The retail firm is presented as an integral part of the overall supply chain with emphasis on entrepreneurial and small business retail strategy and operations applicable to a wide variety of industries. Focus is on equipping students with knowledge and skills necessary to create realistic and successful retail strategy.',
  },
  {
    course_code: 'MAR4236',
    course_name: 'Social Media Marketing',
    course_desc:
      'Students will learn a conceptual foundation and practical approach to developing successful social media marketing plans. Emphasis will be placed on a social media planning model that provides students with a cumulative learning experience, showing them how to construct social media strategies that achieve desired marketing goals.',
  },
  {
    course_code: 'MAR4403',
    course_name: 'Sales Management',
    course_desc:
      "Analysis of the manager's role in sales force management and related organizational environments. Getting results through others by planning, organizing, staffing, directing, controlling, and motivating employees to achieve the organization's objectives. The process of attaining influence, recognition, and power in an organization.",
  },
  {
    course_code: 'MCB3020',
    course_name: 'Microbiology',
    course_desc:
      'Microbial morphology, physiology and taxonomy; relationships of microorganisms to total environment.',
  },
  {
    course_code: 'MAR4407',
    course_name: 'Business-to-Business Relationship Marketing',
    course_desc:
      'Business-to-Business Relationship Marketing builds upon the foundations of marketing to focus specifically on relationships among industrial companies including suppliers, manufacturers, distributors, and brokers.  This course integrates a discussion of organizational behavior, value creation, business-to-business channel relationships, and long term customer retention.\nBusiness-to-Business Relationship Marketing incorporates major business functions such as supply chain management, personal selling, customer relationship management and business communications.  In business markets these functions are interdependent and require seamless integration in order for the firm to survive in a global economy.',
  },
  {
    course_code: 'MAR4412',
    course_name: 'Professional Selling Methods',
    course_desc:
      'Analysis of professional selling methodology including communication, persuasion, negotiation, and salesmanship. Evaluation of these principles in both business and social environments. Credit may not be received in both MAR4412 and MAR 4701.',
  },
  {
    course_code: 'MAR4613',
    course_name: 'Marketing Research',
    course_desc:
      'Conducting marketing research to provide information to be used in decision-making. Emphasis placed on problem formulation and evaluation of research designs leading to problem resolution. Data analysis using statistical analysis package and research report writing. Requires marketing research project. Offered concurrently with MAR 5616; graduate students will be assigned additional work.',
  },
  {
    course_code: 'MAR4721',
    course_name: 'Digital Marketing',
    course_desc:
      'This course explores digital marketing in the context of business issues that concern marketers. Topics will include websites, online branding, search marketing, and social media marketing. In addition, the course covers email marketing and marketing analytics.',
  },
  {
    course_code: 'MAR4803',
    course_name: 'Marketing Strategy',
    course_desc:
      "The integrative capstone experience for all marketing program specializations. Instructional focus is on blending knowledge gained in previous marketing and other business course work with advanced analysis skills in a strategic decision-oriented environment. Course relies primarily on case analysis as an instructional method. Should be taken in the last semester of the student's program of study.",
  },
  {
    course_code: 'MAR4841',
    course_name: 'Services Marketing',
    course_desc:
      'The US, as well as much of the world economy, is dominated by services. Service organizations such as banks, transportation companies, hotels, educational institutions, and consulting firms require a distinctive approach to marketing--both in its development and execution. This course will build and expand on ideas from Marketing Fundamentals and other marketing courses to address the distinct needs and challenges of managing services and delivering quality service to customers. Credit may not be received in both MAR4841 and MAR 4842.',
  },
  {
    course_code: 'MAR4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAR4941',
    course_name: 'Marketing Internship',
    course_desc:
      'Supervised field practicum in marketing-related position. May include activities in any one or more functional areas of marketing (research, sales, advertising, promotion, etc.). Graded on satisfactory/unsatisfactory basis only. A 3.0 GPA in major courses and permission are required.',
  },
  {
    course_code: 'MAR5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAR6815',
    course_name: 'Marketing Management',
    course_desc:
      'Creation of enduring and mutually satisfactory customer relationships through the provision of customer value as an enterprise management philosophy. With consideration given to operating environments, the course is designed to teach the formulation, implementation, and control of comprehensive marketing strategy with emphasis on the integrative aspects of the marketing function in a market based enterprise. Both qualitative and quantitative analyses are used in an applications oriented context. Contains a portfolio project.',
  },
  {
    course_code: 'MAR6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAS3105',
    course_name: 'Linear Algebra',
    course_desc:
      'Systems of linear equation, row echelon form, matrix algebra, determinants and their properties, vector spaces, linear independence, base and dimension, row and column spaces, linear transformations and their matrix representations, similarity, inner product and orthogonality, eigenvalues and eigenvectors, diagonalization, applications of linear algebra.\nMeets Gordon Rule Theoretical Mathematics Requirement.',
  },
  {
    course_code: 'MAS3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAS4203',
    course_name: 'Number Theory',
    course_desc:
      'Divisibility properties of integers, number-theoretic functions, Diophantine equations, theory of congruences and topics in cryptography.\nMeets Gordon Rule Theoretical Mathematics Requirement.',
  },
  {
    course_code: 'MAS4301',
    course_name: 'Abstract Algebra',
    course_desc:
      'Concepts of basic algebraic structures, set, group, ring, integral domain and field.\nMeets Gordon Rule Theoretical Mathematics Requirement.',
  },
  {
    course_code: 'MAS4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAS5145',
    course_name: 'Matrix Theory',
    course_desc: 'Canonical forms of matrices, similarity, quadratic forms.',
  },
  {
    course_code: 'MAS5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAS6219',
    course_name: 'Analytic Number Theory',
    course_desc:
      'This course uses analytical methods to analyze and understand basic arithmetic problems.  The arithmetic concepts include prime numbers, arithmetic functions, prime producing polynomials, and partitions.',
  },
  {
    course_code: 'MAS6329',
    course_name: 'Topics in Applied Algebra',
    course_desc:
      'This course is intended to apply the fundamental concepts of abstract algebra to various branches of mathematics, including number theory, combinatorics, and geometry. There will be an emphasis on graph theory, design theory, and coding theory applications.',
  },
  {
    course_code: 'MAS6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MCB3020L',
    course_name: 'Microbiology Laboratory',
    course_desc:
      'Microbial morphology, physiology, and taxonomy; relationships of microorganisms to total environment. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'MCB3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAT1033',
    course_name: 'Intermediate Algebra',
    course_desc:
      'Provides preparation in the elements of algebra that are required for higher mathematics and statistics courses. Covers basic principles and techniques of the following topics: factoring algebraic expressions, manipulation of algebraic fractions, radicals and exponents; complex numbers, linear, quadratic and rational equations, systems of linear inequalities and their graphical representation, introduction to functions. College preparatory algebra or appropriate score on placement test is required prior to taking this course.',
  },
  {
    course_code: 'MAT1905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAT3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAT4500',
    course_name: 'Undergraduate Proseminar in Mathematics/Statistics',
    course_desc:
      'Each senior (except students with the secondary track specialization) shall, under the supervision of a project advisor, independently investigate a topic or topics in mathematics/statistics or mathematics education. The student shall submit a formal written report and make an oral presentation of the results of his/her investigations. The goal of the proseminar is to provide students with an opportunity to integrate the experience and knowledge they have gained during their undergraduate studies. Graded on satisfactory/unsatisfactory basis only. Senior standing and permission is required.',
  },
  {
    course_code: 'MAT4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAT4935',
    course_name: 'Proseminar Topics',
    course_desc:
      'This course provides students with a comprehensive introduction to technical writing and project time management in a supervised research setting. "Research" is defined as mentored, but self-directed, work that enables individual students or a small group of students to explore an issue of interest and to communicate and disseminate results. Projects may involve inquiry, design, investigation, discovery, or application, depending on the topic. Typically, this course is taken along side the 1-hour proseminar course. By the end of the course, students will complete his or her proseminar final paper using Latex, which includes an abstract, introduction, problem statement (significance of study), literature review, methods section, and references.',
  },
  {
    course_code: 'MAT5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAT6903',
    course_name: 'Mathematics Research 1',
    course_desc:
      'This course will give students the opportunity to engage in group and independent research projects. Research topics and materials vary according to instructor with the thrust being applied or theoretical mathematics. Technical reports and oral presentations will be expected of each student. Students must have completed 15 hours of graduate course work in the program and have maintained at least a 3.0 GPA. Students must also commit to both fall and spring sections of the course.',
  },
  {
    course_code: 'MAT6904',
    course_name: 'Mathematics Research 2',
    course_desc:
      'This course will give students the opportunity to engage in group and independent research projects. Research topics and materials vary according to instructor with the thrust being applied or theoretical mathematics. Technical reports and oral presentations will be expected of each student.',
  },
  {
    course_code: 'MAT6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MAT6910',
    course_name: 'Capstone Projects in Mathematics',
    course_desc:
      'This course will give students the opportunity to engage in group and independent research projects. Research topics and materials may vary according to the instructor with the thrust being applied or theoretical mathematics/Statistics. Technical reports and oral presentations will be expected of each student.',
  },
  {
    course_code: 'MAT6930',
    course_name: 'Proseminar in Mathematics',
    course_desc:
      'Each M.A. or M.A.T. candidate (except those who choose the thesis option) shall, under the direction of a project advisor, independently investigate a topic or topics in mathematics / statistics or mathematics education through the study of journal articles or other appropriate sources. The candidate shall submit a formal written report and make an oral presentation of the results of his / her investigations. The goal of the proseminar is to provide students an opportunity to integrate the total experience gained during their graduate training. Graded on satisfactory / unsatisfactory basis only. M.A. candidacy and permission is required.',
  },
  {
    course_code: 'MAT6971',
    course_name: 'Thesis',
    course_desc:
      'Graded on satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'MCB1000',
    course_name: 'Fundamentals of Microbiology',
    course_desc:
      'An introductory microbiology course for non-science majors specifically designed to meet the microbiology pre-requisite requirement for the 4 year BSN degree. Will cover the principles of microbiology, including cellular organization, growth, and metabolism of major microbial groups (bacteria, fungi, viruses and protozoa); cultivation and control of microbes; and the interaction between microorganisms and humans as it relates to disease transmission, pathogenesis, control measures, and treatment.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'MCB1000L',
    course_name: 'Fundamentals of Microbiology Laboratory',
    course_desc:
      'An introductory microbiology laboratory course for non-science majors specifically designed to meet the microbiology pre-requisite requirement for the 4 year BSN degree. The lab will focus on basic microbiological techniques relating to isolating, growing, and identifying medically significant microorganisms. Laboratory exercises include microscopy and staining techniques; asepsis and culturing of microorganisms; appropriate handling techniques, including sterilization and disinfection; and methods of enumeration and identification of bacteria. Emphasis will be placed on those concepts and methods that are significant in the medical setting. Material and supply fee will be assessed.',
  },
  {
    course_code: 'MCB2510L',
    course_name: 'Phage Finders',
    course_desc:
      'A laboratory course introducing principles of biological research through hands-on experimental work.  The Phage Hunters Advancing Genomics & Evolutionary Science (PHAGES) program generates real scientific data for studying environmental virology.  Students will discover, isolate, and purify new bacteriophages from the environment. Students will obtain microscopic images of their phage as well as isolate the DNA and begin to characterize it on a molecular level.  Along the way, students will learn what it is like to be a part of a scientific research group, how to do microbiological and molecular experiments, how to discuss and analyze data, and how to communicate their findings.',
  },
  {
    course_code: 'MCB4276',
    course_name: 'Epidemiology of Infectious Disease',
    course_desc:
      'The basic principles of epidemiology as they apply to infectious disease and the impact of infectious disease on human civilization will be addressed. The causes and distribution of current epidemics of infectious disease, including newly emerging and reemerging diseases, and the approaches being applied to defeat these diseases will be discussed. Offered concurrently with MCB5273; graduate students will be assigned additional work.',
  },
  {
    course_code: 'MCB4631',
    course_name: 'Molecular Aquatic Microbial Ecology',
    course_desc:
      'Microbial processes, Aquatic microbial ecology, Molecular methods for microbial surveys and processes, Microbial morphology, physiology and taxonomy; relationships of microorganisms to total environment. Offered concurrently with MCB5633. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'MCB4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MCB5273',
    course_name: 'Epidemiology of Infectious Disease',
    course_desc:
      'The basic principles of epidemiology as they apply to infectious disease and the impact of infectious disease on human civilization will be addressed. The causes and distribution of current epidemics of infectious disease, including newly emerging and reemerging diseases, and the approaches being applied to defeat these diseases will be discussed. Offered concurrently with MCB4276; graduate students will be assigned additional work.',
  },
  {
    course_code: 'MCB5633',
    course_name: 'Molecular Aquatic Microbial Ecology',
    course_desc:
      'Microbial processes, Aquatic microbial ecology, Molecular methods for microbial surveys and processes, Microbial morphology, physiology and taxonomy; relationships of microorganisms to total environment. Offered concurrently with MCB4631. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'MCB5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MCB6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MGF1106',
    course_name: 'Mathematics for Liberal Arts I',
    course_desc:
      'Presents topics that illustrate both the aesthetic aspects and the practical applications of mathematics. Intended for students who require only general education mathematics courses. Major course topics: systematic counting, probability, statistics, history of mathematics, geometry, sets, logic.\nMeets General Education requirement in Mathematics.\nMeets Gordon Rule Theoretical Mathematics Requirement.',
  },
  {
    course_code: 'MGF1107',
    course_name: 'Mathematics for Liberal Arts II',
    course_desc:
      'Presents topics that supplement those in MGF1106 needed by elementary teachers. Intended for students in elementary education. Major topics: number sets and properties, number theory, geometry, measurement, graphs--all taught within a problem solving approach.\nMeets General Education requirement in Mathematics.\nMeets Gordon Rule Theoretical Mathematics Requirement.',
  },
  {
    course_code: 'MHF3202',
    course_name: 'Set Theory and Mathematical Logic',
    course_desc:
      'Basic set theory, propositional calculus, predicate calculus, methods of mathematical proof.\nMeets Gordon Rule Theoretical Mathematics Requirement.',
  },
  {
    course_code: 'MHF3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MHF4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MLS3194',
    course_name: 'Clinical Genetics',
    course_desc:
      'This course introduces the student to prokaryotic and eukaryotic genomes and their genetic analysis. The course will look at human disease and principles of inheritance as well as mechanisms of antibiotic resistance in bacteria. The course introduces methodologies used in clinical laboratories to evaluate disease.',
  },
  {
    course_code: 'MLS3621',
    course_name: 'Clinical Biochemistry',
    course_desc:
      'The course is a first in a series of Clinical Chemistry courses for the Medical Laboratory Sciences student. The course is divided into 5 major sections. Nucleic acids, their composition and production; Carbohydrates, their composition and production; Lipids, their composition and function; Proteins, their composition and function. Each macromolecule section will include discussions about diseases associated with deficiencies or derangements. The methods section deals with principles of instrumentation used in the clinical laboratory, such as spectrophotometry, fluorescence, nephelometry, HPLC, electrophoresis, immunoassay, PCR, and mass spectroscopy.',
  },
  {
    course_code: 'MLS3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MLS4191',
    course_name: 'Molecular Diagnostics',
    course_desc:
      'This course offers fundamentals of clinical diagnosis and management of disease by molecular biology laboratory methods. Two broad areas in the current state of the art will be addressed: molecular diseases/variants and molecular methods to diagnose and monitor disease. Disorders due to inherited or acquired molecular defects such as errors of metabolism, hemoglobinopathies, leukemia, and cystic fibrosis are discussed. \nPrinciples and procedures for the diagnosis and management of infectious diseases by molecular methods are also included. The discussion of molecular approaches to diagnosing and monitoring these diseases will span the conventional methods of PCR, gel electrophoresis and Southern Blotting to semi-automated methods of TMA, LCR and Real-time PCR. A survey of molecular diagnostic methods currently available in various sections of a clinical laboratory is included.\nThe laboratory MLS4191L is required for MLS majors.',
  },
  {
    course_code: 'MLS4191L',
    course_name: 'Molecular Diagnostics Laboratory',
    course_desc:
      'Methods for specimen collection and handling, contamination control, amplification and detection of genetic material from humans and microorganisms. Methodologies include conventional PCR, electrophoresis for DNA and proteins, real time PCR, densitometry, Southern Blot and Western Blot techniques. Material and Supply fee will be assessed. Equipment fee will be assessed. Permission is required.',
  },
  {
    course_code: 'MLS4461C',
    course_name: 'Diagnostic Microbiology for the MLT to MLS track',
    course_desc:
      'Study of bacteria associated with infectious diseases. Includes microbial taxonomy, physiology, genetics and host-parasite relationships as they apply to clinical microbiology. Pathogens of particular organ systems, pathogenesis of infectious disease, clinical manifestations, etiology and epidemiology of disease are covered.  Students will perform virtual laboratory activities and interpret laboratory data. Permission is required.',
  },
  {
    course_code: 'PHM3200',
    course_name: 'Social and Political Philosophy',
    course_desc:
      'Social and political theories and ideals that have influenced development of Western man; significance of these for contemporary society.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'MLS4193C',
    course_name: 'Molecular Diagnostics for the MLT to MLS track',
    course_desc:
      'This course covers the fundamentals of clinical diagnosis and management of disease by molecular biology laboratory methods. Two broad areas in the current state of the art are addressed: molecular diseases/variants and molecular methods to diagnose and monitor disease. Disorders due to inherited or acquired molecular defects such as errors of metabolism, hemoglobinopathies, leukemia, and cystic fibrosis are discussed. Principles and procedures for the diagnosis and management of infectious diseases by molecular methods are also included. The discussion of molecular approaches to diagnosing and monitoring these diseases will span the conventional methods of PCR, gel electrophoresis and Southern Blotting to semi-automated methods of TMA, LCR and Real-time PCR. A survey of molecular diagnostic methods currently available in various sections of a clinical laboratory is included. Students will perform virtual laboratory activities and interpret laboratory data. Permission is required.',
  },
  {
    course_code: 'MLS4220',
    course_name: 'Urinalysis/Body Fluids I',
    course_desc:
      'Entry level clinical laboratory scientists will learn the physiology, routine testing and interpretation for the following body fluids: urine, cerebrospinal fluid, semen, amniotic, and serous fluids (peritoneal, pleural, pericardial, synovial). Correlation of laboratory results interpretations to various disease conditions is stressed. \nMLS majors are required to take the corresponding laboratory, MLS4220L, as a co-requisite.',
  },
  {
    course_code: 'MLS4220L',
    course_name: 'Urinalysis/Body Fluids I',
    course_desc: 'Corresponding Lab for Urinalysis / Body Fluids I.',
  },
  {
    course_code: 'MLS4221C',
    course_name: 'Urinalysis/Body Fluids for the MLT to MLS track',
    course_desc:
      'This course teaches the physiology, routine testing and interpretation for the following body fluids: urine, cerebrospinal fluid, semen, sweat, serous fluids (peritoneal, pleural, pericardial, synovial), and dialysates. Correlation of lab findings to various disease conditions is stressed. Students will perform virtual laboratory activities and interpret laboratory data. Permission is required.',
  },
  {
    course_code: 'MLS4305',
    course_name: 'Hematology I',
    course_desc:
      'Study of production, maturation and morphology of normal and abnormal human blood cells. Pathological changes in morphology, cytochemistry and distribution of cells in peripheral blood and bone marrow. Manual and automated methods for blood cell counts, hemoglobin measurement and other hematology parameters. Purpose, principle and clinical value of routine and special procedures. Quality control and quality assurance processes in a clinical hematology laboratory. Material and Supply Fee will be assessed for corresponding lab. Equipment Fee will be assessed. \nMLS students are required to take the corresponding laboratory, MLS4305L, as a co-requisite.',
  },
  {
    course_code: 'MLS4305L',
    course_name: 'Hematology I Lab',
    course_desc: 'Corresponding lab for Hematology I.',
  },
  {
    course_code: 'MLS4306C',
    course_name: 'Hematology for the MLT to MLS track',
    course_desc:
      'Study of production, maturation and morphology of normal and abnormal human blood cells. Pathological changes in morphology, cytochemistry and distribution of cells in peripheral blood and bone marrow. Discussion and interpretation of manual and automated methods for blood cell counts, hemoglobin measurement and other hematology parameters. Purpose, principle and clinical value of routine and special procedures. Quality control and quality assurance processes in a clinical hematology laboratory. Correlation of lab findings to various disease conditions is stressed. Students will perform virtual laboratory activities and interpret laboratory data. Permission is required.',
  },
  {
    course_code: 'MLS4334',
    course_name: 'Hemostasis and Thrombosis',
    course_desc:
      'Role of blood vessels, platelets and coagulation factors in normal hemostasis. Platelet morphology and function, laboratory tests for evaluation of platelets, and platelet disorders. Study of coagulation factors, coagulation pathways, and inherited and acquired coagulation disorders. Normal fibrinolysis and disorders of fibrinolysis. Physiologic and pathologic coagulation inhibitors and their role in normal and abnormal hemostasis. Diagnosis and management of hemorrhagic diseases. Thrombotic disorders and their management by anticoagulant therapy and fibrinolytic therapy. Material and Supply Fee will be assessed for corresponding lab. Equipment Fee will be assessed. Permission is required.\nMLS students are required to take the corresponding laboratory, MLS4334L, as a co-requisite.',
  },
  {
    course_code: 'MLS4334L',
    course_name: 'Hemostasis and Thrombosis Lab',
    course_desc: 'Corresponding lab for Hemostasis and Thrombosis.',
  },
  {
    course_code: 'MLS4335C',
    course_name: 'Hemostasis and Thrombosis for the MLT to MLS track',
    course_desc:
      'Role of blood vessels, platelets and coagulation factors in normal hemostasis. Platelet morphology and function, laboratory tests for evaluation of platelets, and platelet disorders. Study of coagulation factors, coagulation pathways, and inherited and acquired coagulation disorders. Normal fibrinolysis and disorders of fibrinolysis. Physiologic and pathologic coagulation inhibitors and their role in normal and abnormal hemostasis. Diagnosis and management of hemorrhagic diseases. Thrombotic disorders and their management by anticoagulant therapy and fibrinolytic therapy. Correlation of lab findings to various disease conditions is stressed. Students will perform virtual laboratory activities and interpret laboratory data. Permission is required.',
  },
  {
    course_code: 'MLS4460',
    course_name: 'Diagnostic Microbiology I',
    course_desc:
      'Study of bacteria associated with infectious diseases. Includes microbial taxonomy, physiology, genetics and host-parasite relationships as they apply to clinical microbiology. Pathogens of particular organ systems, pathogenesis of infectious disease, clinical manifestations, etiology and epidemiology of disease are covered. Interpretation of test results and clinical relevance are taught utilizing case studies. Permission is required. Equipment Fee will be assessed.',
  },
  {
    course_code: 'MLS4460L',
    course_name: 'Diagnostic Microbiology I Laboratory',
    course_desc:
      'Methods for specimen collection, handling and processing of human tissues and body fluids for isolation and identification of bacteria. Conventional and rapid identification methods for clinically significant bacteria, principles of automation, susceptibility testing, infection control, and quality assurance procedures are included. Material and supply fee will be assessed. Permission is required.',
  },
  {
    course_code: 'MLS4462',
    course_name: 'Medical Microbiology',
    course_desc:
      'Study of medical microbiology covering areas of clinical parasitology, mycobacteriology, clinical virology, clinical mycology, and miscellaneous and emerging pathogens.\nMLS students are required to take the corresponding laboratory, MLS4462L, as a co-requisite.',
  },
  {
    course_code: 'PHM4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MLS4463C',
    course_name: 'Medical Microbiology for the MLT to MLS track',
    course_desc:
      'Study of medical microbiology covering areas of clinical parasitology, mycobacteriology, clinical virology, clinical mycology, and miscellaneous and emerging pathogens. Students will perform virtual laboratory activities to identify parasites, fungi, and to interpret laboratory data. Permission is required.',
  },
  {
    course_code: 'MLS4505',
    course_name: 'Clinical Immunology',
    course_desc:
      'The course is divided into 3 major sections. The immune system and its components, complement, antibody and antigens, cellular and humoral immunity are described. Immune-mediated diseases, such as AIDS, Hemolytic Disease of the Newborn and Lupus Erythematosis are discussed. Diseases that are diagnosed using serologic methods, such as syphilis, infectious mononucleosis, and measles are discussed. Current methodologies used in the medical serology and immunodiagnostic laboratory are introduced. Permission is required.\nMLS students are required to take the corresponding laboratory, MLS4505L as a co-requisite.',
  },
  {
    course_code: 'MLS4505L',
    course_name: 'Clinical Immunology Lab',
    course_desc:
      'The laboratory section is a co-requisite to Clinical Immunology. The course reinforces laboratory safety and sample collection and processing, and gives the student practical experience using serologic and immunologic techniques, such as agglutination, precipitation, immunofluorescence, ELISA, and antibody elution and detection methods. Material and Supply Fee will be assessed. Equipment Fee will be assessed. Permission is required.',
  },
  {
    course_code: 'MLS4506C',
    course_name: 'Clinical Immunology for the MLT to MLS track',
    course_desc:
      'The course is divided into 3 major sections. The immune system and its components, complement, antibody and antigens, cellular and humoral immunity are described. Immune-mediated diseases, such as AIDS, Hemolytic Disease of the Newborn and Lupus Erythematosis are featured. Diseases that are diagnosed using serologic methods, such as syphilis, infectious mononucleosis, and measles are discussed. Current methodologies used in the medical serology and immunodiagnostic laboratory are reviewed. Students will perform virtual laboratory activities and interpret serologic and immunologic results, such as agglutination, precipitation, immunofluorescence, ELISA, and antibody elution and detection methods. Permission is required.',
  },
  {
    course_code: 'MLS4550',
    course_name: 'Immunohematology I',
    course_desc:
      'This course is an introduction to the basic principles and procedures of Blood Bank and Transfusion Medicine. The course covers the fundamentals of blood group immunology, pre-transfusion testing of patient and donor blood for compatibility. The student will also learn red blood cell antibody/antigen interaction and their properties in clinically significant blood group systems. The course covers testing such as ABO/Rh typing, antibody detection and identification, autoimmune hemolytic anemias, and hemolytic disease of the newborn. The student will learn about the collection of blood products and their use in transfusion medicine, including storage, testing for infectious agents, and utilization. The course will also cover regulations and medical, legal, and ethical aspects of transfusion services.\nMLS students are required to take the corresponding laboratory, MLS4550L, as a co-requisite.',
  },
  {
    course_code: 'MLS4550L',
    course_name: 'Immunohematology I Lab',
    course_desc: 'Corresponding lab for Immunohematology I.',
  },
  {
    course_code: 'MLS4552C',
    course_name: 'Immunohematology for the MLT to MLS track',
    course_desc:
      'Review of the basic principles and procedures of Blood Bank and Transfusion services. Fundamentals of blood group immunology. Pre-transfusion testing of patient blood and donor blood for compatibility. Antigens, antibodies and their properties in clinically significant blood group systems. ABO & Rh typing, compatibility testing and special tests. Antibody screen and identification. Autoimmune Hemolytic Anemia and Hemolytic Disease of the Newborn. Transfusion therapy, hazards of transfusion and investigation of transfusion reactions. Donor selection, collection of donor blood and testing for infectious agents. Preparation, storage and utilization of blood components. Regulations, medico-legal and ethical aspects of transfusion services. Students will perform virtual laboratory activities and interpret case studies.',
  },
  {
    course_code: 'MLS4625',
    course_name: 'Clinical Chemistry I',
    course_desc:
      'Course is an introduction to the basic principles and procedures of clinical chemistry. The lecture and lab are devoted to chemical analysis of blood and other body fluids. Lab safety, specimen collection/handling/storage; lab mathematics, basic lab instrumentation and automation, data management, reference range determination and quality control monitoring will be stressed throughout the course. This class will discuss the pathophysiology and diagnostic testing related to the metabolism of carbohydrates and lipids, assessments of diabetes and diabetic risk, assessments of cardiac risk and monitoring and prognosis following myocardial infarction. Methodologies discussed include spectrophotometry, immunodiagnostics and computer generated analyses. Students will participate in class discussions about recent research in clinical chemistry which will be presented in the forms of abstracts, research papers and figures. Material and Supply fee will be assessed for corresponding lab. Equipment Fee will be assessed. Permission is required.\nMLS Students are required to take the corresponding laboratory, MLS4625L, as a co-requisite.',
  },
  {
    course_code: 'MLS4625L',
    course_name: 'Clinical Chemistry I Lab',
    course_desc:
      'Lab devoted to the chemical analysis and interpretation of blood and other bodily fluids. Selected experiments in diabetes and cardiovascular disease risk assessment and monitoring. Safety, instrumentation and quality control will be stressed. Methodologies discussed include spectrophotometry, immunodiagnostics, and computer generated analyses. Material and Supply fee will be assessed. Permission is required.',
  },
  {
    course_code: 'MLS4626C',
    course_name: 'Clinical Chemistry I for the MLT to MLS',
    course_desc:
      'Review of the basic principles and procedures of clinical chemistry. Lecture and case studies devoted to chemical analysis of blood and other body fluids. Lab safety, specimen collection/handling/storage, lab mathematics, basic lab instrumentation and automation, data management, reference range determination and quality control monitoring will be stressed throughout the course. This class will discuss the pathophysiology and diagnostic testing related to the metabolism of carbohydrates and lipids, assessments of diabetes and diabetic risk, assessments of cardiac risk and monitoring and prognosis following myocardial infarction. Methodologies discussed include spectrophotometry, immunodiagnostics and computer generated analyses. Students will participate in class discussions about recent research in clinical chemistry, which will be presented in the forms of abstracts, research papers and figures. Students will perform virtual laboratory activities and to interpret laboratory data. Permission is required.',
  },
  {
    course_code: 'PHM6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MLS4630',
    course_name: 'Clinical Chemistry II',
    course_desc:
      'This course continues where Clinical Chem I left off, discussing kidney function, electrolytes, blood gases, acid-base balance, mineral metabolism, enzyme measurement, liver function studies, and pancreatic function assessment. It also includes the more esoteric tests involved in testing endocrine function, therapeutic drug monitoring, toxicology, tumor markers, and testing during pregnancy. Methodology is primarily immunoassay, potentiometry and spectrophotometry.\nMLS students are required to take the corresponding laboratory, MLS4630L, as a co-requisite.',
  },
  {
    course_code: 'MLS4630L',
    course_name: 'Clinical Chemistry II Lab',
    course_desc:
      'This course covers laboratory procedures evaluating kidney and liver function, electrolytes, acid-base balance, mineral metabolism, enzyme measurements, toxicology and testing during pregnancy. Methodology is primarily immunoassay, potentiometry and spectrophotometry. Material and Supply fee will be assessed. Permission is required.',
  },
  {
    course_code: 'MLS4631C',
    course_name: 'Clinical Chemistry II for the MLT to MLS',
    course_desc:
      'This course continues where Clinical Chemistry I left off, discussing kidney function, electrolytes, blood gases, acid-base balance, mineral metabolism, enzyme measurement, liver function studies, and pancreatic function assessment. It also includes the more esoteric tests involved in testing endocrine function, therapeutic drug monitoring, toxicology, tumor markers, and testing during pregnancy. Methodology is primarily immunoassay, potentiometry and spectrophotometry. Reading and disseminating research in the discipline is emphasized in the format of a journal club.',
  },
  {
    course_code: 'MLS4704',
    course_name: 'Clinical Management Portfolio for the MLT to MLS track',
    course_desc:
      'Fundamentals of clinical laboratory management, research and educational methodologies are covered. Students are introduced to clinical laboratory operations including financial and human resource management, marketing of laboratory services, communication with other health care professionals, laboratory information systems, research design and compliance with regulatory agencies. \nThe student will provide evidence of adequate training or  work experience in Hematology, Clinical Chemistry, Microbiology and Blood Bank equivalent to an MLS clinical internship and produce this in a professionally developed portfolio. The student will produce a professionally written case study that is suitable for publication.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'MLS4705',
    course_name: 'Special Clinical Topics',
    course_desc:
      'Fundamentals of clinical laboratory management, supervision and educational methodologies are covered. Students are introduced to clinical laboratory operations in areas of financial and human resource management, marketing of laboratory services, communications with other health care professionals, laboratory information systems and regulatory compliance with applicable regulatory agencies. Other special clinical topics related to education and training, lab safety, HIV / AIDS, prevention of medical errors, professional ethics and career planning are presented.',
  },
  {
    course_code: 'MLS4820L',
    course_name: 'Clinical Chemistry III',
    course_desc:
      'Application of clinical chemistry principles and techniques presented in Clinical Chemistry I and II. Supervised practice in the hospital laboratory. Permission is required.',
  },
  {
    course_code: 'MLS4821L',
    course_name: 'Diagnostic Microbiology II',
    course_desc:
      'Application of clinical microbiology principles and techniques presented in MLS4460. Supervised practice in an affiliated hospital laboratory. Includes manual and automated identification and susceptibility testing, specimen collection and processing, quality assurance, and laboratory organization. Permission is required.',
  },
  {
    course_code: 'MLS4822L',
    course_name: 'Hematology II',
    course_desc:
      'Application of Hematology I. Advanced practical training in automated hematology instrumentation, routine and special procedures in hematology lab, and practice of quality control methods, maintenance and trouble shooting of clinical hematology equipment. Training includes all aspects of clinical lab medicine in a modern hematology / coagulation lab and prepares the student to assume responsibility as a medical technologist. Permission is required.',
  },
  {
    course_code: 'MLS4823L',
    course_name: 'Immunohematology II',
    course_desc:
      "Continuation of Immunohematology I, at one of the affiliate hospitals. Advanced practical training in modern blood banking and transfusion services at the hospital. Training includes practice and performance, under supervision, of all the procedures involving pre-transfusion tests on patient's blood, selection of donor blood, compatibility determination, problem solving, release of suitable blood/blood components for transfusion therapy. Permission is required.",
  },
  {
    course_code: 'MLS4824L',
    course_name: 'Special Clinical Methods',
    course_desc:
      'Supervised practice in a hospital laboratory. Special methods in clinical laboratory sciences, including non-routine (special) chemistry procedures and methods in immunodiagnostics, mycobacteriology and clinical mycology. Permission is required.',
  },
  {
    course_code: 'MLS4825L',
    course_name: 'Urinalysis/Body Fluids II',
    course_desc:
      'Supervised practice in a hospital laboratory in the analysis of urine and other body fluids; techniques in parasitology and phlebotomy procedures. Permission is required.',
  },
  {
    course_code: 'MLS4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MMC2000',
    course_name: 'Principles of Mass Communication',
    course_desc:
      'Principles, issues, organizations and functions of film, radio, television, print and other media of mass communication. Consideration of current practices and recent developments and their implications for the future direction of mass media.\nMeets General Education requirement in Social Sciences.',
  },
  {
    course_code: 'MMC3743',
    course_name: 'Communicating Fear: Horror Films and Popular Culture',
    course_desc:
      'The popularity of horror films, books, and television provides clear evidence that the public likes to be frightened.  This course explores the ways in which horror films serve to reflect and illuminate cultural issues, practices, and socio-political influences.  Across the semester, students will learn to define horror genres in film, understand the cultural functions horror films serve, and gain a better perspective of the influence of societal fears as they are reflected through film.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'MUE4475',
    course_name: 'Percussion Methods and Materials',
    course_desc:
      'Percussion instruments, playing techniques, history, methodology, pedagogy and literature for solo and ensemble experiences. Observations of representative public school programs required of students planning to practice teach in band programs. Completion of sophomore year program requirements is required.',
  },
  {
    course_code: 'MMC3745',
    course_name:
      'Communicating Fear Abroad: International Horror Films & Popular Culture',
    course_desc:
      'The rapid growth of the film industry and the increased access to international film through streaming technology has allowed new voices to reach a global audience. This course explores the way in which horror films serve to reflect and illuminate cultural issues, practices, and taboos in a myriad of countries and regions. Through the study of horror films, students will learn about different cinematic traditions, traditional mythologies, cultural fears,  and their roots in historical events. Students will gain a better understanding of the relationship between culture and the ways in which fear are communicated on the big screen.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'MMC3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MMC4201',
    course_name: 'The Constitution and the Press',
    course_desc:
      'Concerns of the press as they pertain to prior restraint, libel, privacy, testimonial privilege, access to information, obscenity and ensuring a fair trial. Extensive review of court decisions.',
  },
  {
    course_code: 'MMC4203',
    course_name: 'Media Ethics',
    course_desc:
      'Introduces students to classical ethical philosophies; presents various ethical decision-making strategies; application of ethical models to information-gathering and dissemination dilemmas; helps students form an ethical framework for future positions of responsibility in mass media industries; introduces students to the case method of instruction.',
  },
  {
    course_code: 'MMC4252',
    course_name: 'Media Sales',
    course_desc:
      'The convergence of new and old technologies will redefine past concepts of the media. In this new, digital, interactive, high-cost, highly fragmented, and highly competitive media world, generating revenue is a top priority for survival. Sales people and sales managers have become more important to the media industry. Introduces students to the principles of media selling and sales management and prepares them for media selling and sales management jobs at a time when media companies are cutting back in almost every area except sales, where jobs are actually increasing.',
  },
  {
    course_code: 'MMC4700',
    course_name: 'Interpreting Popular Culture',
    course_desc:
      'The Popular Culture course explores the creation of popular culture and its influence on culture/high-culture and society (with a special emphasis on culture in the United States). The course investigates popular culture broadly and through specific case studies, with an eye toward weighing its benefits and detriments to society. The course includes readings, response papers, and short essays.',
  },
  {
    course_code: 'MMC4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MMC6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MSL1001',
    course_name: 'Introduction to the Army',
    course_desc:
      "Introduces Cadets to the personal challenges and competencies that are critical for effective leadership. Cadets learn how the personal development of life skills such as critical thinking, time management, goal setting, stress management, and comprehensive fitness relate to leadership and the Army profession. The focus is on developing basic knowledge and comprehension of Army leadership dimensions while gaining a big picture of understanding the Reserve Officers' Training Corps (ROTC) program, its purpose in the Army, and its advantages for the student. Physical training is required three days a week.",
  },
  {
    course_code: 'MSL1002',
    course_name: 'Foundations of Agile and Adaptive Leadership',
    course_desc:
      "Course introduces Cadets to the personal challenges and competencies that are critical for adaptive leadership. Cadets learn the basics of the communications process and the importance for leader's to develop the essential skills to effectively communicate in the Army. Students will examine the Army Profession and what it means to be a professional in the U.S. Army. The overall focus is on developing basic knowledge and comprehension of Army leadership while gaining a big picture of understanding the Reserve Officers' Training Corps (ROTC) program, its purpose in the Army, and its advantages for the student. Physical training is required three days a week.",
  },
  {
    course_code: 'MSL1905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MSL2101',
    course_name: 'Leadership and Decision Making',
    course_desc:
      "The course is primarily drawn from the Adaptability - Army Learning Area (ALA). The outcomes are demonstrated through critical and creative Thinking and the ability to apply Troop Leading Procedures(TLP). Comprehension of the officer's role in Leading Change by applying innovative solutions to problems in concert with the Principles of Mission Command. The Army Profession is also stressed through leadership forums and a leadership self-assessment. Students are then required to apply their knowledge outside the classroom in a hands-on performance-oriented environment during Leadership LABs. Physical fitness training is required three days a week.",
  },
  {
    course_code: 'MSL2102',
    course_name: 'Army Doctrine and Team Development',
    course_desc:
      "Cadets begin to understand and demonstrate Cross-Cultural Competencies as they relate to Army doctrine and how they apply in a combatant commander's Engagement Strategies. Army Values, Teamwork, and Warrior Ethos and their relationship to the Law of Land Warfare and philosophy of military service are also stressed. The ability to lead and follow is also covered through Team Building exercises in small units up to squad level. Cadets practice and enhance their leadership abilities in labs and other battalion leadership opportunities. Through Leadership Labs, Cadets develop and demonstrate an understanding and ability to perform basic land navigation, troop-leading, and squad and platoon tactical operations. By the end of the Basic Course, Cadets should possess a basic understanding of how to effectively communicate both orally and in writing, the Army as an organization and as a profession. The design of the lessons is to maximize Cadet participation, inspire intellectual curiosity, stimulate self-study, and encourage Cadets to contract. Physical fitness training is required three days a week.",
  },
  {
    course_code: 'MSL2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MSL3201C',
    course_name: 'Training Management & the Warfighting Functions',
    course_desc:
      "Course focuses on the Professional Competence Army Attribute. This includes introduction to squad/platoon tactical operations using troop leading procedures and battle drills to achieve the assigned mission within the commander's intent. Through the introduction of the Leadership Lab Practicum the Cadets learn to plan, resource, and execute training of subordinates within the Leadership Labs. This experience gives the Cadet the opportunity to work on their teamwork and leadership skills in a hands-on performance-oriented environment. Physical fitness training three days per week. One of the following is required to take this course. Completion of the Basic Course - MSL1001/1002 and 2101/2102, Completion of Basic Camp (4 Week Summer Camp), Completion of 4 Years of Junior ROTC or Prior Service members who have completed Basic and Advance Individual Training or service equivalent.",
  },
  {
    course_code: 'MSL3202C',
    course_name: 'Applied Leadership in Small Unit Operations',
    course_desc:
      'Course balances Adaptability and Professional Competence building on the tactical lessons in order to familiarize the Cadet with materials that they can expect to execute during Cadet Summer Training. Adaptability concepts introduced include analysis of complex problems, creating solutions that exhibit agile and adaptive thinking, analysis of the situational environment and formulation of solutions to tactical and organizational problems. Physical fitness training three days per week. One of the following is required to take this course. Completion of the Basic Course - MSL1001/1002 and 2101/2102, Completion of Basic Camp (4 Week Summer Camp), Completion of 4 Years of Junior ROTC or Prior Service members who have completed Basic and Advance Individual Training or service equivalent.',
  },
  {
    course_code: 'MSL3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MSL4301C',
    course_name: 'The Army Officer',
    course_desc:
      'The Army Officer is a practical application of adaptive leadership focused on the dynamics of leading in complex situations of current military operations and preparing Senior Cadets for their future service as Second Lieutenants and Army Officers. Throughout the semester, students are assigned the duties and responsibilities of an Army staff officer and must apply the Army Training Management System, the Army writing style, and the Military Decision Making Process (MDMP) to execute the approved training plan. During weekly training meetings, Cadets will plan, execute, and assess Argonaut Battalion training and associated events. Cadets will study how Army values and leader ethics are applied in the Contemporary Operating Environment and how these values and ethics are relevant to everyday life. In addition, Cadets are assigned a variety of leadership positions and will be given numerous opportunities to train, mentor, and evaluate underclass students enrolled in the ROTC program while being mentored and evaluated by experienced ROTC Cadre. Physical Training three days per week.',
  },
  {
    course_code: 'MSL4302C',
    course_name: 'Company Grade Leadership',
    course_desc:
      'Exploration of the dynamics of leading in the complexity of warfare while understanding the fundamentals of Decisive actions in support of Unified Land Operations. Examine the Art of Command and how to properly communicate with your NCOs and Soldiers in addition to how to better develop others. Cultural Awareness and Cultural Property Protection will focus on numerous situations and how ethical decisions impact personnel and the unit mission. Through the understanding of your roles and responsibilities, you will learn how Army programs can assist you in preparing Soldiers and their Families stress reduction and management during times of uncertainty. The course places significant emphasis on preparing you for follow-on training and your first unit of assignment. Physical training three days per week.',
  },
  {
    course_code: 'MSL4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MTG3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MTG4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUE2040',
    course_name: 'Introduction to Music Teaching',
    course_desc:
      'A foundation course for potential music educators. An overview of the music education profession and its relationship to mainstream education issues; includes 10 hours of initial observations/participation in local school classrooms. Permission is required.',
  },
  {
    course_code: 'MUE3311',
    course_name: 'Methods for the Elementary School Music Teacher',
    course_desc:
      'How to teach music in the elementary school. Includes "how to" instruction in teaching general music and how to begin and maintain an elementary choral program. For music majors only.',
  },
  {
    course_code: 'MUE3312',
    course_name: 'Kodaly Method',
    course_desc:
      'Presents specific suggestions for teaching music to K-5 elementary school students based on the Kodaly Method as practiced in the United States, Canada, and Hungary. Offering background material, general ideas, and specific techniques, this course will train students to utilize the Kodaly concepts effectively, even if they have not had previous experience with this method.',
  },
  {
    course_code: 'MUE3343',
    course_name: 'Instrumental Programs: Strings and Orchestra',
    course_desc:
      'This course studies methods, curriculum, music, and rehearsal techniques particular to teaching orchestra in the public schools.',
  },
  {
    course_code: 'MUE3355',
    course_name: 'Instrumental General Music',
    course_desc:
      'This course will study methods, curriculum, instruments, and music for instrumental general music in the public school setting, K-12. The focus of the course will be the method of Carl Orff (Orff Schulwerk), Orff instruments, and class guitar methods and materials.',
  },
  {
    course_code: 'MUE3413',
    course_name: 'Chamber Music Coaching',
    course_desc:
      'This class is designed to teach music students how to play chamber music and how to coach and work with different chamber groups.',
  },
  {
    course_code: 'MUE3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUE4330',
    course_name: 'Music in the Middle and Secondary Schools',
    course_desc:
      'The organization and administration of general, choral, and instrumental music in middle and high schools. Permission is required.',
  },
  {
    course_code: 'MUE4343',
    course_name: 'String Methods and Materials',
    course_desc:
      'Designed to teach Music Ed majors how to begin and implement a string program in the school system. It includes strategies for teaching strings in group settings.',
  },
  {
    course_code: 'MUE4344',
    course_name: 'Class Piano Methods and Materials',
    course_desc:
      'This course studies class piano methods, curriculum, techniques, and materials for music education majors.',
  },
  {
    course_code: 'MUE4411',
    course_name: 'Special Methods/Choral Techniques',
    course_desc:
      'Problems related to choral conducting with practical application of applicable choral techniques at all levels, elementary through high school. Includes choral and full score study, repertoire for various levels and observations in the public schools of choral music classes.',
  },
  {
    course_code: 'MUE4447',
    course_name: 'Advanced String Pedagogy',
    course_desc:
      'This course is designed to focus on advanced pedagogical concepts, methods, techniques, and repertoire for string instruments.',
  },
  {
    course_code: 'MUE4451',
    course_name: 'Woodwind Instrument Methods and Materials',
    course_desc:
      'Woodwind instruments, playing techniques, reed making techniques, instrument maintenance, history methodology, pedagogy, literature for solo and ensemble experiences. Observations of representative public school programs of students planning to practice teach in band programs. Completion of sophomore year program requirements is required.',
  },
  {
    course_code: 'MUE4480',
    course_name: 'Marching Band Methods',
    course_desc:
      'Marching Band Methods is a course designed to develop skills, obtain knowledge, and study the application of methods, techniques, and systems related to the total spectrum of administering marching bands. The course will emphasize the pedagogy of developing marching and music fundamentals, stimulate creative thinking, and present a specific system of conceiving, writing, and teaching a marching band show. The course will also introduce the use of current software in computer drill design.',
  },
  {
    course_code: 'MUE4481',
    course_name: 'Jazz Band Techniques',
    course_desc:
      'This course explores current jazz band and jazz combo techniques, methods, and materials and their application in the public school music program.',
  },
  {
    course_code: 'MUE4493',
    course_name: 'Special Methods/Instrumental Techniques',
    course_desc:
      'Problems in organization and administration of school instrumental groups at all levels, elementary through high school including marching bands, jazz bands, and band parent organizations. Advanced conducting of instrumental music; study of baton techniques and score analysis; practical applications to performance. Observation of music programs in public schools with emphasis on large and small performing ensembles.',
  },
  {
    course_code: 'MUE4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUE4940',
    course_name: 'Music Education Internship',
    course_desc:
      'Music Education Internship is a semester long course allowing the student the opportunity to intern in the local school system under the supervision of an experienced music teacher in their area of study. The student is advised not to take other classes or pursue employment during the semester of internship. Internship assignments will be made by the Music Education Coordinator and will be limited to the Pensacola area. Graded on a satisfactory/unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'MUE5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUG2101',
    course_name: 'Conducting',
    course_desc:
      'Applied conducting of vocal and instrumental music; basic concepts and practices of conducting of simple and complex meters; study of baton technique and score analysis; practical applications to performance.',
  },
  {
    course_code: 'MUG3104',
    course_name: 'Conducting 1',
    course_desc:
      'Applied conducting of vocal and instrumental music; basic concepts and practices of conducting of simple and complex meters; study of baton technique and score analysis; practical applications to performance.',
  },
  {
    course_code: 'MUG3108',
    course_name: 'Conducting 2',
    course_desc:
      'Intermediate study of the art of conducting. Lecture and lab experiences for the general, instrumental, and choral music educator to gain essential skills and techniques for rehearsal and performance. This course will focus on the development of a non-verbal vocabulary, which will allow each student to clearly and artistically communicate with an ensemble to solicit a personal interpretation.',
  },
  {
    course_code: 'MUG4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUH2513',
    course_name: 'Music in World Cultures',
    course_desc:
      'This course explores a variety of Non-Western musical styles found in cultural, social and/or political contexts. Students will be introduced to specific music traditions and will learn to write critically about music as it relates to society and culture. The course will examine music traditions from various parts of the world including Latin America, Africa, the Middle East, and Asia.',
  },
  {
    course_code: 'MUH2930',
    course_name: 'The Music Experience: Special Topics',
    course_desc:
      'With a non-traditional and multi-cultural approach, specific topics in music are offered each semester. Topics vary each semester but include such areas as Latin American Music, Jazz, Eastern European Music, Music of the Far East, etc. Consult the current course bulletin for semester topic.\nMeets General Education requirement in Humanities.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'MUH3211',
    course_name:
      'History of Western Music I: End of Ancient World Through 17th Century',
    course_desc:
      "First of two courses designed to increase student's understanding of history and literature of music. Music in Western Civilization from and of ancient world through 17th century. Three hours per week. Listening assignments in Music Listening Library.\nMeets Gordon Rule Writing Requirement.",
  },
  {
    course_code: 'MUH3212',
    course_name: 'History of Western Music II: 18th through 20th Centuries',
    course_desc:
      'Continuation of music history and literature sequence. Vocal and instrumental idioms of 18th-20th centuries emphasizing works of major composers.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'MUH3622',
    course_name:
      'The Irish Experience - A Survey of the History of Irish Music and Culture',
    course_desc:
      'In this study abroad experience, students will learn about major Irish historical and cultural events in addition to studying and performing Irish music. Students will also participate in tours to a variety of cities and museums throughout Ireland.',
  },
  {
    course_code: 'MUH3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUH4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUH5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUH6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUL2010',
    course_name: 'Music Appreciation',
    course_desc:
      "Musical perspectives within Western civilization. Designed to express the correlation of music, art, and literature in Western culture. Special emphases include the nature of music, both past and present, and music as reflection / expression of society's vital activities. Credit cannot be earned in both MUH 2110 and MUL 2110.\nMeets General Education requirement in Humanities.\nMeets Multicultural Requirement.",
  },
  {
    course_code: 'MUL3503',
    course_name: 'Symphonic and String Literature',
    course_desc:
      'Overview of Orchestral and small string ensemble literature for all levels of students from beginning to college. Designed for the music teaching and performance major. Permission is required.',
  },
  {
    course_code: 'MUL3551',
    course_name: 'Band and Wind Literature',
    course_desc:
      'Overview of Symphonic Band and small chamber wind ensemble literature for all levels of students from beginning to college. Designed for the music teaching and performance major. Permission is required.',
  },
  {
    course_code: 'MUL3602',
    course_name: 'Vocal Literature',
    course_desc:
      'Overview of solo vocal literature for all levels of students from beginning to college. Designed for music teaching and performance majors. Explores the origins of solo song, its significant composers, forms and styles from the Renaissance to the present in the four major singing languages; French, German, Italian, and English. Permission is required.',
  },
  {
    course_code: 'MUS3820',
    course_name:
      'The Irish Experience - International Music Study and Performance',
    course_desc:
      'An interdisciplinary, performance-oriented course designed to integrate musical and theatrical performance skills for the singing actor in an international setting.',
  },
  {
    course_code: 'MUL3643',
    course_name: 'Choral Literature',
    course_desc:
      'Overview of choral literature for all levels of students from beginning to college. Designed for music teaching and performance majors. Explores the origins of the major compositions, composers, forms and styles from the Renaissance to the present. Permission is required.',
  },
  {
    course_code: 'MUL3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUL4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUL5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUN2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUN3100',
    course_name: 'UWF Argo Athletic Band',
    course_desc:
      'Open to all students with woodwind, brass, percussion, or color guard experience. The Argo Athletic Bands serves as both a performance-based academic course and a service organization. The course is open by audition to music majors and non-music majors with prior instrumental performance experience in high school or junior college. Students can take the course for 1 credit in order to meet upper division music elective requirements. They can also take the course for 0 credit hours if they have met their music elective requirement or if they are non-music majors and do not have a music elective requirement but would like to continue performing with this elite music ensemble.  \nStudents will be expected to purchase essential personal items totaling $50 or less: Marching Shoes (for safety, uniformity, and the athletic nature of the marching arts). Gloves (for uniformity and instrument longevity to protect our inventory).',
  },
  {
    course_code: 'MUN3133',
    course_name: 'The University of West Florida Symphonic Band',
    course_desc:
      'Group of wind and percussion instrumentalists. Open to all qualified students. Interested students should contact the music office. Previous instrumental experience required. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'MUN3213',
    course_name: 'Advanced Symphony Orchestra',
    course_desc:
      'Symphony Orchestra is a college level orchestra which performs great literature of the past and present. The orchestra is open to all majors with prior orchestral experience. Permission is required. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'MUN3313',
    course_name: 'UWF Singers',
    course_desc:
      'SATB chorus preparing for performances throughout the year. This class is open to all students by audition.  Students enrolled in the course must display the skills necessary to participate in a choir. Previous choral experience is preferred, but not necessary. Students must have a basic understanding of the voice, ability to match and regenerate pitches, and have some level of music-reading skills. Admittance of students in this course is based on this criteria and left to the discretion of the director.',
  },
  {
    course_code: 'MUN3323',
    course_name: 'Concert Choir',
    course_desc:
      'SA (soprano, alto) chorus preparing for performances throughout the year. This class is open to all students. Students enrolled in the course must display the skills necessary to participate in a choir. Students will receive instruction in vocal pedagogy, music literacy and performance practice. Group will perform 2 to 3 times per semester.',
  },
  {
    course_code: 'MUN3363',
    course_name: 'Advanced Chamber Choir',
    course_desc:
      'Select mixed choral ensemble performing a cappella and chamber music. Open to all students by audition. Rehearsals according to schedule. Previous choral experience required. For junior and senior levels only. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'MUN3443',
    course_name: 'Percussion Ensemble',
    course_desc:
      'The percussion ensemble will rehearse and perform a variety of music: music from South America, the Caribbean, Africa and the Middle East that features percussion Approval of instructor, possible audition to demonstrate an understanding of performance technique and sight reading skills.',
  },
  {
    course_code: 'MUN3483',
    course_name: 'Guitar Ensemble',
    course_desc:
      'The UWF Guitar Ensemble is a performing instrumental organization which meets on a regular basis for rehearsals and performs often for community groups, college functions, and local schools and clubs. Required of guitar performance majors. Open to all majors. Permission required. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'MUN3713',
    course_name: 'Jazz Combo',
    course_desc:
      'Performance oriented small group of various sizes. Literature and instrumentation are based upon student and departmental needs. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'MUN3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUN4411',
    course_name: 'String Quartet',
    course_desc:
      'An ensemble to explore the vast literature in the string quartet genre. May be expanded by an additional instrument for certain works. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'MUN4714',
    course_name: 'UWF Jazz Ensemble',
    course_desc:
      'Standard jazz ensemble instrumentation. Opened to qualified students depending on needed instrumentation. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'MUN4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUO3503',
    course_name: 'Advanced Opera Studio',
    course_desc:
      'Study of the techniques of characterization, dramatic analysis, and ensembles singing in English and foreign languages. Special emphasis is given to the study of scenes from the standard operatic repertoire which are presented before the public in a series of opera scenes recitals.  Audition and permission required. Open to junior and senior levels only.',
  },
  {
    course_code: 'MUO4504',
    course_name: 'Opera Workshop',
    course_desc:
      'An interdisciplinary, performance-oriented study of the techniques of characterization, dramatic analysis, and ensemble singing in English and foreign languages. Special emphasis is given to the study of scenes from the standard operatic repertoire which are presented before the public in a recital in order to integrate singing skills and characterization skills for opera and musical\ntheatrical performance.',
  },
  {
    course_code: 'MUS2241',
    course_name: 'Diction for Singers I: Italian',
    course_desc:
      'Study of stage pronunciation and enunciation in Italian with comparisons made to the sound in English, and utilizing the International Phonetic Alphabet.',
  },
  {
    course_code: 'MUS2360',
    course_name: 'Music Technology',
    course_desc:
      'Designed to equip music students with the technological skills necessary and ongoing for the application of music software in all venues. Major emphasis on working knowledge of mainstream software and its applications in music composition, education and performance. Freshman and sophomore theory requirements are needed. Material and supply fee will be assessed.',
  },
  {
    course_code: 'MUS2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUS3253',
    course_name: 'Diction for Singers II: French/German',
    course_desc:
      'Study of stage pronunciation and enunciation in French and German with comparisons made to the sounds in English, and utilizing the International Phonetic Alphabet. Student must be enrolled in applied voice either on the major or minor level.',
  },
  {
    course_code: 'MUT1111',
    course_name: 'Freshman Theory',
    course_desc:
      'Basic fundamentals of music theory, including meter and rhythm, tonic, dominant and sub dominant harmony, cadences, major and minor tonality, and inverted triads. Required of all students majoring in music; non- music majors must have departmental permission.',
  },
  {
    course_code: 'MUT1112',
    course_name: 'Freshman Theory II',
    course_desc:
      'Continuation of MUT1111, including non-harmonic tones, secondary triads, principles of chord progressions, use of harmonic sequence, primary seventh chords and secondary dominants.',
  },
  {
    course_code: 'MUT1271',
    course_name: 'Freshman Theory Lab',
    course_desc:
      'Ear-training, melodic and rhythmic dictation, sight-singing, and basic keyboard harmony. Computer lab time assigned as required.',
  },
  {
    course_code: 'MUT1272',
    course_name: 'Freshman Theory II Lab',
    course_desc:
      'Ear-training, melodic and rhythmic dictation, sight-singing, and basic keyboard harmony. Computer lab time assigned as required.',
  },
  {
    course_code: 'MUT1905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUT2116',
    course_name: 'Sophomore Theory',
    course_desc:
      'Extensive harmonic analysis involving primary and secondary chords and including chromaticism and modulation; altered chords and their functions.',
  },
  {
    course_code: 'MUT2117',
    course_name: 'Sophomore Theory II',
    course_desc:
      'Continuation MUT2116, including augmented sixth chords, the neopolitan sixth, and other chromatically altered chords, in addition to harmonic practices in the 20th Century.',
  },
  {
    course_code: 'MUT2276',
    course_name: 'Sophomore Theory I Lab',
    course_desc:
      'Ear-training, melodic and rhythmic dictation, sight-singing, and basic keyboard harmony. Computer lab time assigned as required.',
  },
  {
    course_code: 'MUT2277',
    course_name: 'Sophomore Theory II Lab',
    course_desc:
      'Ear-training, melodic and rhythmic dictation, sight-singing, and basic keyboard harmony. Computer lab time assigned as required.',
  },
  {
    course_code: 'MUT2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUT3401',
    course_name: 'Techniques of Counterpoint',
    course_desc:
      'Linear writing through species counterpoint and comparison with 16th and 18th century musical idioms. Two years of music theory required.',
  },
  {
    course_code: 'MUT3611',
    course_name: 'Musical Structure and Style',
    course_desc:
      'Systematic analysis of 17th, 18th, 19th and 20th century music, with emphasis upon structural designs and stylistic trends. Two years of music theory required.',
  },
  {
    course_code: 'MUT3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUT4311',
    course_name: 'Instrumentation',
    course_desc:
      'Use of, and writing for, orchestral and band instruments; characteristics and capabilities of each. Instruments studied individually, small groups and as members of full ensemble. Two years of college theory required.',
  },
  {
    course_code: 'MUT4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MUT6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MVB1311',
    course_name: 'Applied Music Trumpet',
    course_desc:
      'Individual instruction in applied music in trumpet. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVB1312',
    course_name: 'Applied Music Horn',
    course_desc:
      'Individual instruction in applied music in horn. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVB1313',
    course_name: 'Applied Music Trombone',
    course_desc:
      'Individual instruction in applied music in trombone. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVB1314',
    course_name: 'Applied Music Euphonium',
    course_desc:
      'Individual instruction in applied music in euphonium. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVB1315',
    course_name: 'Applied Music Tuba',
    course_desc:
      'Individual instruction in applied music in tuba. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVB2321',
    course_name: 'Applied Music Trumpet',
    course_desc:
      'Individual instruction in applied music in trumpet. Primarily for music majors of sophomore-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVB2322',
    course_name: 'Applied Music Horn',
    course_desc:
      'Individual instruction in applied music in horn. Primarily for music majors of sophomore-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVB2323',
    course_name: 'Applied Music Trombone',
    course_desc:
      'Individual instruction in applied music in trombone. Primarily for music majors of sophomore-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVB2324',
    course_name: 'Applied Music Euphonium',
    course_desc:
      'Individual instruction in applied music in euphonium. Primarily for music majors of sophomore-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVB2325',
    course_name: 'Applied Music Tuba',
    course_desc:
      'Individual instruction in applied music in tuba. Primarily for music majors of sophomore-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVB2421',
    course_name: 'Performance: Brass',
    course_desc:
      'Individual instruction in applied music in brasses. Primarily for music majors of sophomore-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVB3331',
    course_name: 'Applied Music Trumpet',
    course_desc:
      'Individual instruction in applied music in trumpet. Primarily for music majors of junior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVB3332',
    course_name: 'Applied Music Horn',
    course_desc:
      'Individual instruction in applied music in horn. Primarily for music majors of junior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVB3333',
    course_name: 'Applied Music Trombone',
    course_desc:
      'Individual instruction in applied music in trombone. Primarily for music majors of junior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVB3970',
    course_name: 'Junior Recital - Brass',
    course_desc:
      "Prior to graduation all students seeking a performance specialization music degree must present at least one-half of a public recital. Permission to give recital is secured from the student's applied teacher at least eight weeks prior to scheduled recital date. Two semesters of 3000 level applied lessons (junior level) and permission is required. Performance majors only.",
  },
  {
    course_code: 'MVB4341',
    course_name: 'Applied Music Trumpet',
    course_desc:
      'Individual instruction in applied music in trumpet. Primarily for music majors of senior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVB4342',
    course_name: 'Applied Music Horn',
    course_desc:
      'Individual instruction in applied music in horn. Primarily for music majors of senior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVB4343',
    course_name: 'Applied Music Trombone',
    course_desc:
      'Individual instruction in applied music in trombone. Primarily for music majors of senior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVB4344',
    course_name: 'Applied Music Euphonium',
    course_desc:
      'Individual instruction in applied music in euphonium. Primarily for music majors of senior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVB4345',
    course_name: 'Applied Music Tuba',
    course_desc:
      'Individual instruction in applied music in tuba. Primarily for music majors of senior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVB4971',
    course_name: 'Senior Recital - Brass',
    course_desc:
      "Prior to graduation all students seeking a music degree must present a complete public recital. Permission to give a recital is secured from students' applied teacher at least eight weeks prior to scheduled recital date. Performance majors will be required to register for 3 credit hours and Education majors will be required to register for 1 credit hour. Two semesters of 4000 level applied music (senior level) and permission is required.",
  },
  {
    course_code: 'MVK1111',
    course_name: 'Class Piano I',
    course_desc:
      'To equip the music major with functional piano skills which correlate with those skills accomplished in Music Theory. Prepares student for piano proficiency exam.',
  },
  {
    course_code: 'MVK1112',
    course_name: 'Class Piano II',
    course_desc:
      'To equip the music major with functional piano skills which correlate with those skills accomplished in Music Theory. Prepares student for piano proficiency exam. Placement / audition may substitute for prerequisite.',
  },
  {
    course_code: 'MVK1115',
    course_name: 'Keyboard Skills',
    course_desc:
      'Development of functional skills at the keyboard. Open only to music majors.',
  },
  {
    course_code: 'MVK1311',
    course_name: 'Applied Music Piano',
    course_desc:
      'Individual instruction in applied music in piano. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVK1313',
    course_name: 'Applied Music Organ',
    course_desc:
      'Individual instruction in applied music in organ. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVK1412',
    course_name: 'Applied Music Harpsichord',
    course_desc:
      'Individual instruction in applied harpsichord. Primarily for music majors of the freshmen level standing. Open to others for credit if a music course or ensemble is taken concurrently and faulty schedules permit.',
  },
  {
    course_code: 'MVK2121',
    course_name: 'Class Piano III',
    course_desc:
      'To equip the music major with functional piano skills which correlate with those skills accomplished in Music Theory. Prepares students for piano proficiency exam. Placement / audition may substitute for prerequisite.',
  },
  {
    course_code: 'MVK2122',
    course_name: 'Class Piano IV',
    course_desc:
      'To equip the music major with functional piano skills which correlate with those skills accomplished in Music Theory. Prepares student for piano proficiency exam. Placement / audition may substitute for prerequisite.',
  },
  {
    course_code: 'MVK2223',
    course_name: 'Applied Music Organ',
    course_desc:
      'Individual instruction in applied music organ. Primarily for majors of sophomore level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVK2321',
    course_name: 'Performance: Keyboards',
    course_desc:
      'Individual instruction in applied music in keyboards. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVK2421',
    course_name: 'Applied Music Piano',
    course_desc:
      'Individual instruction in applied music piano. Primarily for majors of sophomore level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVK2422',
    course_name: 'Applied Music Harpsichord',
    course_desc:
      'Individual instruction in applied harpsichord. Primarily for music majors of the sophomore level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVK3331',
    course_name: 'Performance: Keyboards',
    course_desc:
      'Individual instruction in applied music in keyboards. Primarily for music majors of junior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVK3333',
    course_name: 'Applied Music Organ',
    course_desc:
      'Individual instruction in applied music in organ. Primarily for music majors of junior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVK3431',
    course_name: 'Applied Music Piano',
    course_desc:
      'Individual instruction in applied music piano. Primarily for majors of junior level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVK3432',
    course_name: 'Applied Music Harpsichord',
    course_desc:
      'Individual instruction in applied harpsichord. Primarily for music majors of the junior level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVK3702',
    course_name: 'Accompanying Coaching Class',
    course_desc:
      'Designed to equip the pianist with basic skills in accompanying vocalists, instrumentalists, and choral groups. Emphasis on listening techniques related to vocal, instrumental, and choral literature. Two years of applied piano and permission is required.',
  },
  {
    course_code: 'MVK3720',
    course_name: 'Collaborative Piano (Vocal)',
    course_desc:
      'Through the study of representative works from the Piano/Vocal repertoire, students will learn the necessary skills for a successful collaboration. Among others, issues of balance, tempo, score preparation, rehearsal techniques, learning techniques will discussed. This is a performance based course in which piano/vocal duos will be assigned for in-class performances. Students will be coached and critiqued by their professor and colleagues in a master class format.',
  },
  {
    course_code: 'MVK3721',
    course_name: 'Collaborative Piano (Instrumental)',
    course_desc:
      'Through the study of representative works from the Piano/Instrumental repertoire, students will learn the necessary skills for a successful collaboration. Among others, issues of balance, tempo, score preparation, rehearsal techniques, learning techniques will discussed. This is a performance based course in which piano/instrumental duos will be assigned for in-class performances. Students will be coached and critiqued by their professor and colleagues in a master class format.',
  },
  {
    course_code: 'MVK3722',
    course_name: 'Seminar in Piano Vocal/Piano Instrumental Collaboration',
    course_desc:
      'The course will explore the Piano Vocal and Piano Instrumental repertoire. Through the study and performance of representative works, students will discover and address not only the inherent challenges of collaboration, but also the unique challenges presented by each instrument or voice. Students will learn to observe and critique their colleagues in a master class format.',
  },
  {
    course_code: 'MVK3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MVK3970',
    course_name: 'Junior Recital - Keyboards',
    course_desc:
      "Prior to graduation all students seeking a performance specialization music degree must present at least one-half of a public recital. Permission to give recital is secured from the student's applied teacher at least eight weeks prior to scheduled recital date. Two semesters of 3000 level applied lessons (junior level) and permission is required. Performance majors only.",
  },
  {
    course_code: 'MVK4341',
    course_name: 'Performance: Keyboards',
    course_desc:
      'Individual instruction in applied music in keyboards. Primarily for music majors of senior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVK4343',
    course_name: 'Applied Music Organ',
    course_desc:
      'Individual instruction in applied music in organ. Primarily for music majors of senior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVK4441',
    course_name: 'Applied Music Piano',
    course_desc:
      'Individual instruction in applied music piano. Primarily for majors of senior level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVK4442',
    course_name: 'Applied Music Harpsichord',
    course_desc:
      'Individual instruction in applied harpsichord. Primarily for music majors of the senior level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVK4641',
    course_name: 'Piano Pedagogy',
    course_desc:
      'Comparison of various published piano methods; application of these methods and other techniques of teaching beginning student to most advanced level. Required of all piano majors.',
  },
  {
    course_code: 'MVK4704',
    course_name: 'Accompanying: Instrumental Literature',
    course_desc:
      'Designed to equip pianists specializing in accompanying with a functional and practical knowledge of literature for instruments involving a piano accompaniment. Survey of literature for woodwinds, brass, strings, percussion, chamber music, and two pianos with emphasis on performance techniques. Two years of applied piano and permission is required.',
  },
  {
    course_code: 'MVK4705',
    course_name: 'Accompanying Vocal Literature',
    course_desc:
      'Designed to equip pianists specializing in accompanying with a functional and practical knowledge of literature for voice involving a piano accompaniment. Survey of literature, both chamber and orchestral, for soprano, mezzo soprano, alto, tenor, baritone, and bass voice types with emphasis on performance techniques. Two years of applied piano and permission is required.',
  },
  {
    course_code: 'MVK4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MVK4932',
    course_name: 'Piano Interpretation',
    course_desc:
      'Study and comparison of interpretations of piano music by means of written treatises, recorded examples and demonstration. Required of all piano majors. Junior level standing and permission is required.',
  },
  {
    course_code: 'MVK4942',
    course_name: 'Accompanying Internship I',
    course_desc:
      'An internship with the music department. The students will serve as the departmental accompanist. The students will accompany during applied lessons of varying instruments and voices and will accompany recitals. Two years of applied piano and permission is required.',
  },
  {
    course_code: 'MVK4943',
    course_name: 'Accompanying Internship II',
    course_desc:
      'An internship with the music department. The students will serve as the departmental accompanist. The students will accompany during applied lessons of varying instruments and voices and will accompany recitals. Permission is required.',
  },
  {
    course_code: 'MVK4971',
    course_name: 'Senior Recital - Keyboards',
    course_desc:
      "Prior to graduation all students seeking a music degree must present a complete public recital. Permission to give a recital is secured from students' applied teacher at least eight weeks prior to scheduled recital date. Performance majors will be required to register for 3 credit hours and Education majors will be required to register for 1 credit hour. Two semesters of 4000 level applied music (senior level) and permission is required.",
  },
  {
    course_code: 'MVK5451',
    course_name: 'Applied Piano',
    course_desc:
      'Individual instruction in applied music in piano. Primarily for music majors of Graduate level standing. Permission is required.',
  },
  {
    course_code: 'MVP1311',
    course_name: 'Applied Music Percussion',
    course_desc:
      'Individual instruction in applied music in percussion. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVP2321',
    course_name: 'Applied Music Percussion',
    course_desc:
      'Individual instruction in applied music in percussion. Primarily for music majors of sophomore-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVP2421',
    course_name: 'Performance: Percussion',
    course_desc:
      'Individual instruction in applied music in percussion. Primarily for music majors of sophomore-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVS4343',
    course_name: 'Applied Music Cello',
    course_desc:
      'Individual instruction in applied music in cello. Primarily for music majors of senior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVP3331',
    course_name: 'Applied Music Percussion',
    course_desc:
      'Individual instruction in applied music in percussion. Primarily for music majors of junior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVP3970',
    course_name: 'Junior Recital - Percussion',
    course_desc:
      "Prior to graduation all students seeking a performance specialization music degree must present at least one-half of a public recital. Permission to give recital is secured from the student's applied teacher at least eight weeks prior to scheduled recital date. Two semesters of 3000 level applied lessons (junior level) and permission is required. Performance majors only.",
  },
  {
    course_code: 'MVP4341',
    course_name: 'Applied Music Percussion',
    course_desc:
      'Individual instruction in applied music in percussion. Primarily for music majors of senior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVP4971',
    course_name: 'Senior Recital - Percussion',
    course_desc:
      "Prior to graduation all students seeking a music degree must present a complete public recital. Permission to give a recital is secured from students' applied teacher at least eight weeks prior to a scheduled recital date. Performance majors will be required to register for 3 credit hours and Education majors will be required to register for 1 credit hour. Two semesters of 4000 level applied music (senior level) and permission is required.",
  },
  {
    course_code: 'MVS1311',
    course_name: 'Applied Music Violin',
    course_desc:
      'Individual instruction in applied music in violin. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVS1312',
    course_name: 'Applied Music Viola',
    course_desc:
      'Individual instruction in applied music in viola. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVS1313',
    course_name: 'Applied Music Cello',
    course_desc:
      'Individual instruction in applied music in cello. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVS1314',
    course_name: 'Applied Music Bass',
    course_desc:
      'Individual instruction in applied music in bass. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVS1316',
    course_name: 'Applied Music Guitar',
    course_desc:
      'Individual instruction in applied music in guitar. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVS1811',
    course_name: 'Violin Class',
    course_desc:
      'Small group instruction in violin. Students will be given instruction on the violin in a small group setting. May not be taken for credit by Music majors. Permission is required.',
  },
  {
    course_code: 'MVS2321',
    course_name: 'Applied Music Violin',
    course_desc:
      'Individual instruction in applied music in violin. Primarily for music majors of sophomore-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVS2322',
    course_name: 'Applied Music Viola',
    course_desc:
      'Individual instruction in applied music in viola. Primarily for music majors of sophomore-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVS2323',
    course_name: 'Applied Music Cello',
    course_desc:
      'Individual instruction in applied music in cello. Primarily for music majors of sophomore-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVS2324',
    course_name: 'Applied Music Bass',
    course_desc:
      'Individual instruction in applied music in bass. Primarily for music majors of sophomore-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVS2326',
    course_name: 'Applied Music Guitar',
    course_desc:
      'Individual instruction in applied music in guitar. Primarily for music majors of sophomore-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVS3331',
    course_name: 'Applied Music Violin',
    course_desc:
      'Individual instruction in applied music in violin. Primarily for music majors of junior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVS3332',
    course_name: 'Applied Music Viola',
    course_desc:
      'Individual instruction in applied music in viola. Primarily for music majors of junior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVS3333',
    course_name: 'Applied Music Cello',
    course_desc:
      'Individual instruction in applied music in cello. Primarily for music majors of junior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVS3334',
    course_name: 'Applied Music Bass',
    course_desc:
      'Individual instruction in applied music in bass. Primarily for music majors of junior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVS3336',
    course_name: 'Applied Music Guitar',
    course_desc:
      'Individual instruction in applied music in guitar. Primarily for music majors of junior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVS3970',
    course_name: 'Junior Recital - Strings',
    course_desc:
      "Prior to graduation all students seeking a performance specialization music degree must present at least one-half of a public recital. Permission to give recital is secured from the student's applied teacher at least eight weeks prior to scheduled recital date. Two semesters of 3000 level applied lessons (junior level) and permission is required. Performance majors only.",
  },
  {
    course_code: 'MVS4341',
    course_name: 'Applied Music Violin',
    course_desc:
      'Individual instruction in applied music in violin. Primarily for music majors of senior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVS4342',
    course_name: 'Applied Music Viola',
    course_desc:
      'Individual instruction in applied music in viola. Primarily for music majors of senior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVS4344',
    course_name: 'Applied Music Bass',
    course_desc:
      'Individual instruction in applied music in bass. Primarily for music majors of senior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVS4346',
    course_name: 'Applied Music Guitar',
    course_desc:
      'Individual instruction in applied music in guitar. Primarily for music majors of senior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVS4971',
    course_name: 'Senior Recital - Strings',
    course_desc:
      "Prior to graduation all students seeking a music degree must present a complete public recital. Permission to give a recital is secured from students' applied teacher at least eight weeks prior to scheduled recital date. Performance majors will be required to register for 3 credit hours and Education majors will be required to register for 1 credit hour. Two semesters of 4000 level applied music (senior level) and permission required.",
  },
  {
    course_code: 'MVS5451',
    course_name: 'Applied Viola',
    course_desc:
      'Individual instruction on the viola on the graduate level. Lesson times to be determined in consultation with the instructor.',
  },
  {
    course_code: 'MVV1311',
    course_name: 'Applied Music Voice',
    course_desc:
      'Individual instruction in applied music in voice. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVV2321',
    course_name: 'Performance: Voice',
    course_desc:
      'Individual instruction in applied music in voice. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVV2421',
    course_name: 'Applied Music Voice',
    course_desc:
      'Individual instruction in applied music vocal. Primarily for majors of sophomore level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVV2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MVV3331',
    course_name: 'Performance: Voice',
    course_desc:
      'Individual instruction in applied music in voice. Primarily for music majors of junior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVV3431',
    course_name: 'Applied Music Voice',
    course_desc:
      'Individual instruction in applied music voice. Primarily for majors of junior level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVV3970',
    course_name: 'Junior Recital - Voice',
    course_desc:
      "Prior to graduation all students seeking a performance specialization music degree must present at least one-half of a public recital. Permission to give recital is secured from the student's applied teacher at least eight weeks prior to scheduled recital date. Two semesters of 3000 level applied lessons (junior level) and permission is required. Performance majors only.",
  },
  {
    course_code: 'MVV4341',
    course_name: 'Performance: Voice',
    course_desc:
      'Individual instruction in applied music in voice. Primarily for music majors of senior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVV4441',
    course_name: 'Applied Music Voice',
    course_desc:
      'Individual instruction in applied music vocal. Primarily for majors of senior level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVV4640',
    course_name: 'Vocal Pedagogy',
    course_desc:
      'Explores strategies of teaching voice to students of all ages and levels.',
  },
  {
    course_code: 'MVV4971',
    course_name: 'Senior Recital - Voice',
    course_desc:
      "Prior to graduation all students seeking a music degree must present a complete public recital. Permission to give a recital is secured from students' applied teacher at least eight weeks prior to scheduled recital date. Performance majors will be required to register for 3 credit hours and Education majors will be required to register for 1 credit hour. Two semesters of 4000 level applied music (senior level) and permission is required.",
  },
  {
    course_code: 'MVW1311',
    course_name: 'Applied Music Flute',
    course_desc:
      'Individual instruction in applied music in flute. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVW1312',
    course_name: 'Applied Music Oboe',
    course_desc:
      'Individual instruction in applied music in oboe. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVW1313',
    course_name: 'Applied Music Clarinet',
    course_desc:
      'Individual instruction in applied music in clarinet. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVW1314',
    course_name: 'Applied Music Bassoon',
    course_desc:
      'Individual instruction in applied music in bassoon. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVW1315',
    course_name: 'Applied Music Saxophone',
    course_desc:
      'Individual instruction in applied music in saxophone. Primarily for music majors of freshman-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVW2321',
    course_name: 'Applied Music Flute',
    course_desc:
      'Individual instruction in applied music in flute. Primarily for music majors of sophomore-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVW2322',
    course_name: 'Applied Music Oboe',
    course_desc:
      'Individual instruction in applied music in oboe. Primarily for music majors of sophomore-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVW2323',
    course_name: 'Applied Music Clarinet',
    course_desc:
      'Individual instruction in applied music in clarinet. Primarily for music majors of sophomore-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVW2324',
    course_name: 'Applied Music Bassoon',
    course_desc:
      'Individual instruction in applied music in bassoon. Primarily for music majors of sophomore-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'PHP3786',
    course_name: 'Existentialism',
    course_desc:
      'Basic concepts and ways of experiencing the world through various existential writers. May include Hegel, Kierkegaard, Nietzsche, Jaspers, Sartre, Heidegger and Merleau-Ponty.',
  },
  {
    course_code: 'MVW2325',
    course_name: 'Applied Music Saxophone',
    course_desc:
      'Individual instruction in applied music in saxophone. Primarily for music majors of sophomore-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVW2421',
    course_name: 'Performance: Woodwinds',
    course_desc:
      'Individual instruction in applied music in woodwinds. Primarily for music majors of sophomore-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVW3331',
    course_name: 'Applied Music Flute',
    course_desc:
      'Individual instruction in applied music in flute. Primarily for music majors of junior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVW3332',
    course_name: 'Applied Music Oboe',
    course_desc:
      'Individual instruction in applied music in oboe. Primarily for music majors of junior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVW3333',
    course_name: 'Applied Music Clarinet',
    course_desc:
      'Individual instruction in applied music in clarinet. Primarily for music majors of junior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVW3334',
    course_name: 'Applied Music Bassoon',
    course_desc:
      'Individual instruction in applied music in bassoon. Primarily for music majors of junior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVW3335',
    course_name: 'Applied Music Saxophone',
    course_desc:
      'Individual instruction in applied music in saxophone. Primarily for music majors of junior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVW3970',
    course_name: 'Junior Recital - Woodwinds',
    course_desc:
      "Prior to graduation all students seeking a performance specialization music degree must present at least one-half of a public recital. Permission to give recital is secured from the student's applied teacher at least eight weeks prior to scheduled recital date. Two semesters of 3000 level applied lessons (junior level) and permission is required. Performance majors only.",
  },
  {
    course_code: 'MVW4341',
    course_name: 'Applied Music Flute',
    course_desc:
      'Individual instruction in applied music in flute. Primarily for music majors of senior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVW4342',
    course_name: 'Applied Music Oboe',
    course_desc:
      'Individual instruction in applied music in oboe. Primarily for music majors of senior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVW4343',
    course_name: 'Applied Music Clarinet',
    course_desc:
      'Individual instruction in applied music in clarinet. Primarily for music majors of senior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVW4344',
    course_name: 'Applied Music Bassoon',
    course_desc:
      'Individual instruction in applied music in bassoon. Primarily for music majors of senior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVW4345',
    course_name: 'Applied Music Saxophone',
    course_desc:
      'Individual instruction in applied music in saxophone. Primarily for music majors of senior-level standing. Open to others for credit if a music course or ensemble is taken concurrently and faculty schedules permit.',
  },
  {
    course_code: 'MVW4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'MVW4971',
    course_name: 'Senior Recital - Woodwinds',
    course_desc:
      "Prior to graduation all students seeking a music degree must present a complete public recital. Permission to give a recital is secured from students' applied teacher at least eight weeks prior to a scheduled recital date. Performance majors will be required to register for 3 credit hours and Education majors will be required to register for 1 credit hour. Two semesters of 4000 level applied music (senior level) and permission is required.",
  },
  {
    course_code: 'NGR5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'NGR6002',
    course_name: 'Advanced Health Assessment',
    course_desc:
      "This course will build upon health assessment skills developed in the professional nurse's basic education program. The theoretical and clinical basis for assessment in advanced nursing practice will be developed. The process whereby the advanced nurse utilizes comprehensive physical, psychological, and cultural assessment across the life span to gather specific data relevant to common health problems is demonstrated.",
  },
  {
    course_code: 'NGR6111',
    course_name: 'Foundations of Nursing Science',
    course_desc:
      'The course includes the synthesis of concepts, principles and theories of nursing and related disciplines as applied to the role of the nurse in advanced practice.',
  },
  {
    course_code: 'NGR6140',
    course_name: 'Advanced Pathophysiology',
    course_desc:
      'This course is designed to present an orientation to disease as disordered physiology. It is intended to enable those in advanced nursing practice to understand how and why the symptoms and signs of various conditions appear.  In approaching disease as disordered physiology, this course analyzes the mechanism(s) of production of the symptoms and signs of different disease states. In doing so, it recognizes that those in advanced nursing practice need to understand the mechanism(s) underlying the disease and its clinical manifestations so that rational therapies can be devised. Thus, appropriate screening and diagnostic laboratory evaluation methods will also be included.',
  },
  {
    course_code: 'NGR6172',
    course_name: 'Advanced Pharmacology',
    course_desc:
      "This course is designed to expand the advanced practice student's knowledge of pharmacotherapeutics. Broad categories of pharmacological agents are examined. Learning focuses on skills to assess, diagnose, and manage a client's common health problems in a safe, high quality, and cost-effective manner.",
  },
  {
    course_code: 'NGR6201',
    course_name: 'Care of the Adult I',
    course_desc:
      'This course provides the opportunity to analyze the theoretical skills for diagnosis, management and evaluation of commonly occurring, complex, and/or long term health needs of adults and communities. Content focuses on providing the essentials of current practices in diagnostic reasoning, nursing management, and evidence-based practice in the care of adults.',
  },
  {
    course_code: 'PCO4310',
    course_name: 'Intervention in Addictions',
    course_desc:
      'Models of addictive behaviors and implications for assessment and treatment of addiction. Emphasis primarily on alcohol and drug abuse, with information on smoking and obesity included.',
  },
  {
    course_code: 'NGR6201L',
    course_name: 'Care of the Adult I Practicum',
    course_desc:
      'This course provides the opportunity to apply the theoretical skills for diagnosis, management and evaluation of commonly occurring, complex, and/or long term health needs of adults and communities. Content focuses on the application of current practice in diagnostic reasoning, nursing management, and evidence-based practice in the care of adults. This supervised advanced clinical experience focuses on the role of the nurse practitioner in clinical practice.',
  },
  {
    course_code: 'NGR6202',
    course_name: 'Care of the Adult II',
    course_desc:
      'The course allows the learner to expand on the roles of the Advanced Practice Nurse Practitioner in the care of adults and their families across the lifespan. Students will also explore the foundation for synthesizing health information that is aimed at helping adults and their families to assume responsibility for the prevention of illness and the promotion and maintenance of health. Available health resources from local, regional, national and global sources are analyzed and incorporated into healthcare plans and decisions.',
  },
  {
    course_code: 'NGR6202L',
    course_name: 'Care of the Adult II Practicum',
    course_desc:
      'The course allows the learner to engage in Advanced Nursing Practice with selected adult populations. Learners further define and expand their practice of adult and family health nursing through on the integration of theory, research, self-evaluation, and clinical supervision. A variety of approaches, theories, and issues of healthcare service delivery are further explored, especially those focused on multiple chronic diseases and their management.',
  },
  {
    course_code: 'NGR6301',
    course_name: 'Care of the Child and Family',
    course_desc:
      'This course provides students with the opportunity to develop and apply the theoretical skills for diagnosis, management, and evaluation of commonly occurring, complex, and/or long term health needs of children and their families. Content focuses on the analysis of current practices in diagnostic reasoning, nursing management, and evidence-based practice in the care of children. This includes common normal and abnormal variations in physical, cognitive, and psychological development, and chronic conditions often specific to this population.',
  },
  {
    course_code: 'NGR6301L',
    course_name: 'Care of the Child and Family Practicum',
    course_desc:
      'This course is a supervised advanced clinical experience focused on the roles of the nurse practitioner while dealing with the care of the well and ill child and family. Students will explore the application of theory and skills for evaluation, diagnosis, and management of commonly occurring, complex, and/or long term health needs of children and their families.',
  },
  {
    course_code: 'NGR6343',
    course_name: "Women's Health",
    course_desc:
      'This course provides the opportunity to develop and apply the theoretical skills for diagnosis, management, and evaluation of commonly occurring, complex, and/or long term health needs of women. Content focuses on the analysis of current practices in diagnostic reasoning, nursing management, and evidence-based practice in the care of women, including common normal and abnormal variations in physical, cognitive, and psychological development and chronic conditions often specific to this population.',
  },
  {
    course_code: 'NGR6343L',
    course_name: 'Care of Women Practicum',
    course_desc:
      'This course is a supervised advanced clinical experience focused on the roles of the nurse practitioner when providing care specific to women. Application of theory and skills for diagnosis, management, and evaluation of commonly occurring, complex, and/or long term health needs of women.',
  },
  {
    course_code: 'NGR6638',
    course_name: 'Population Health Promotion and Management',
    course_desc:
      'The purpose of this course is to involve the learner in recognizing diverse influences of varying global populations and issues surrounding access to healthcare.  Students will learn to distinguish between health, wellness, illness, disease, and disability while examining relevant ethical issues and health disparities in current practice regulations. The content will compare levels of prevention (primary, secondary, and tertiary) for health consumers across the lifespan.  The student will analyze the Healthy People 2020 Initiative to determine its status and impact on the health status of vulnerable populations.',
  },
  {
    course_code: 'NGR6700',
    course_name: 'Nursing Theory',
    course_desc:
      'This course explores the theoretical foundations of nursing and nursing practice. It examines the nursing influence on legislation and policy development. Students will critically analyze nursing theories and healthcare policies from a historical, multidisciplinary, and global perspective. Permission is required.',
  },
  {
    course_code: 'NGR6710',
    course_name: 'Nursing Education Seminar I',
    course_desc:
      "This initial seminar course builds on core course content in the development of the nurse as an educator in both the classroom and clinical settings within the student's area of expertise. Coursework explores complex theories and concepts in nursing education and begins the preparation of the student for the nurse educator role. The student will begin to explore curriculum development by examining learning theories, teaching strategies, resources, and technology appropriate for individuals with different learning styles.",
  },
  {
    course_code: 'NGR6710L',
    course_name: 'Nursing Education Practicum I',
    course_desc:
      'This initial practicum course introduces the learner to the nurse educator role in classroom and clinical environments. The course will focus on the application of learning theories, teaching strategies, resources, and technology appropriate for different learning styles and environments.',
  },
  {
    course_code: 'NGR6715',
    course_name: 'Nursing Education Seminar II',
    course_desc:
      'This course continues the analysis and synthesis of teaching learning and related theories in classroom and clinical settings for the emerging nurse educator. The focus of the course is the application of theories in the development of courses and curricula that reflect the mission, vision, and values of the parent organization, current, and emerging standards and regulations, as well as issues and trends in nursing education. Emphasis is on institutional purposes, goals, nursing curricula, and designing instruction for classroom and clinical settings.',
  },
  {
    course_code: 'NGR6715L',
    course_name: 'Nursing Education Practicum II',
    course_desc:
      'This practicum course continues to immerse the learner in the nurse educator role within clinical and classroom settings. Learners will focus on instructional planning, teaching strategies, and curricula development.  Learners will have the opportunity to facilitate a learning session in the clinical or classroom environment.',
  },
  {
    course_code: 'PCO4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PHP5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'NGR6718',
    course_name: 'Nursing Education Seminar III',
    course_desc:
      'This final seminar course focuses on programmatic evaluation, accreditation of nursing education, and scholarship of the nurse educator. Synthesis of curriculum, evaluation, accreditation, and the nurse educator role are primary course components.',
  },
  {
    course_code: 'NGR6718L',
    course_name: 'Nursing Education Practicum III',
    course_desc:
      'The final nurse educator practicum course prepares the learner to synthesize the role of the nurse educator.  Learners will focus on programmatic evaluation, accreditation of nursing education, and scholarship of the nurse educator.',
  },
  {
    course_code: 'NGR6727',
    course_name: 'Nurse Executive Seminar III',
    course_desc:
      'In this course, the student synthesizes and applies concepts,  models, and principles  of evidence-based practice to improve processes and outcomes in the healthcare system.  Organizational dynamics and resistance to change are appraised in the processes of project development and implementation.  The student formulates strategies to serve as a catalyst for change.',
  },
  {
    course_code: 'NGR6727L',
    course_name: 'Nurse Executive Practicum III',
    course_desc:
      'This course focuses on the proposal development process and is centered on principles of evidence-based nursing practice utilizing an evidence based model for evaluating available evidence for its applicability to practice. A primary focus targets leadership behaviors, which promote change and implementation of evidence-based practice.',
  },
  {
    course_code: 'NGR6728',
    course_name: 'Nurse Executive Seminar I',
    course_desc:
      'This initial specialization seminar course explores complex theories and concepts in nursing leadership and management, beginning the preparation of the learner for the nurse executive role. The course will investigate leadership models, theories, and styles, as well as roles and functions of management.  Complex organizational systems are explored to include structure, mission, philosophy, goals, objectives, basic financial management, human resources, accrediting processes, and the political environment.',
  },
  {
    course_code: 'NGR6728L',
    course_name: 'Nurse Executive Practicum I',
    course_desc:
      'The Nurse Executive Role Practicum course provides each student with a 90 hour leadership role practicum to become proficient in applying concepts, principles, and theories from previous courses to the role and functions of the nurse leader/executive. The student is guided by a designated leader/executive preceptor and faculty partner.',
  },
  {
    course_code: 'NGR6729',
    course_name: 'Nurse Executive Seminar II',
    course_desc:
      'This is the second of the Nurse Executive Seminars.  The course focuses on nursing administrators/leaders and making strategic organizational decisions within the healthcare system. Students explore healthcare as a business, organizational culture, and strategic planning. Quality healthcare outcomes, financial outcomes, and development and management of projects are explored. The impact of external regulatory factors on a complex healthcare system(s) are assessed.',
  },
  {
    course_code: 'NGR6729L',
    course_name: 'Nurse Executive Practicum II',
    course_desc:
      'The Nurse Executive Practicum II provides each student with 135 hours of a focused role immersion practicum concentrating on strategic planning, budgeting processes, policy development, identification, and/or resolution of a healthcare organization problem or challenge.',
  },
  {
    course_code: 'NGR6734',
    course_name:
      'Project Development and Management for Healthcare Professionals',
    course_desc:
      'This course provides a foundation for project management as it applies to healthcare. Learning will be focused on the development of health project ideas, implementation strategies, and skill sets for project management and sustainment. At the conclusion of this course, students should be able to develop, execute, and manage a basic project plan that is capable of supporting organizational objectives linked to measures of success for a single project.',
  },
  {
    course_code: 'NGR6740',
    course_name: 'Contemporary Issues in the Role of Advanced Nursing Practice',
    course_desc:
      'Focuses on the role of the Advanced Nursing Practice nurse. Integrates nursing and other discipline theories and issues relevant to clinical practice, administration, education, and research issues. Includes theoretical analysis, application, and synthesis in the development of an individual model of advanced nursing practice for the student. Permission is required.',
  },
  {
    course_code: 'NGR6793',
    course_name: 'Fiscal Administration for the Health Professional',
    course_desc:
      'The focus of this course is on the application of financial concepts, principles, and theories in the health care industry. Foundational financial management processes equip the student with business and financial skills for assessing the fiscal status of health care systems and data driven decisions. The course culminates with the development of a business case for an identified service or problem resolution.',
  },
  {
    course_code: 'NGR6800',
    course_name: 'Nursing Research,Statistics, and Evidence Based Practice',
    course_desc:
      'This initial research, statistics and evidence-based practice (EBP) course builds on undergraduate research & statistics content. It explores complex theories and concepts in nursing research, statistics and evidence-based practice beginning the preparation of the student for the nursing scholar role. It includes critical appraisal of research evidence including the interpretation of\nstatistical analyses commonly used in evidence summaries. It includes the evidence-based practice process to prepare the graduate nurse to translate research evidence summaries into evidence-based practice project proposals. It will also prepare the nurse for the role of change agent as they identify practice areas where evidence-based practice integration is needed and facilitate the movement of evidence-based quality initiatives and practice change.  Also, it provides the student with core EBP competencies leading to preparation for a capstone project in their last semester.',
  },
  {
    course_code: 'NGR6803',
    course_name: 'Integration of Evidence in Advanced Nursing Practice',
    course_desc:
      'This course explores complex concepts and theories, including rapid critical appraisal of evidence, in preparation for translation to nursing practice. The course covers the evidence-based practice process and follows the steps in evidence-based quality improvement project implementation. Students will be prepared to function as catalysts for change.',
  },
  {
    course_code: 'NGR6833',
    course_name: 'Nursing Leadership & Management EBP Project I',
    course_desc:
      'This course follows all MSN core content and Nursing Leadership and Management\nSeminars. In this course the student will use knowledge from prior courses to develop an\nevidence-based project proposal suitable for presentation and/or publication. This project will be implemented during the NGR6833L course.  Permission is required.',
  },
  {
    course_code: 'NGR6833L',
    course_name: 'Nursing Leadership & Management EBP Project II',
    course_desc:
      'This culminating project course follows all MSN core content, Nursing Leadership and Management Seminars, and completion of an approved project proposal. In this course the student will use knowledge from prior courses to conduct the evidence-based project from NGR6833 project proposal. Permission is required.',
  },
  {
    course_code: 'NGR6834',
    course_name: 'Nursing Education Evidence Based Project I',
    course_desc:
      'This course follows all MSN core content and Nursing Education Seminars. In this course the student will use knowledge from prior courses to develop an evidence-based project proposal suitable for presentation and/or publication. This project will be implemented during the NGR6834L course.  Permission is required.',
  },
  {
    course_code: 'NGR6834L',
    course_name: 'Nursing Education Evidence Based Practice Project II',
    course_desc:
      'This course follows all MSN core content,Nursing Education Seminars, and the project proposal development course. In this course the student will use knowledge from prior courses to develop an evidence-based project proposal suitable for presentation and/or publication. This project will be implemented during the NGR6834L course.  Permission is required.',
  },
  {
    course_code: 'NGR6835',
    course_name: 'Project Evaluation and Dissemination',
    course_desc:
      'This course promotes basic skills in research utilization and scholarly writing through an in-depth exploration of a nursing topic or problem.  An evidence-based project is completed under the guidance of a graduate faculty member.',
  },
  {
    course_code: 'NGR6872',
    course_name:
      'Information Technology and Data Analysis for Healthcare Professionals',
    course_desc:
      'The focus of this course in on the use of information systems/technology to evaluate programs of care, outcomes of care, financial decision making, and patient safety and care systems to influence quality improvement. The course introduces methods for making sense of both small and big data through analysis, categorization and management.',
  },
  {
    course_code: 'NGR6880',
    course_name: 'Ethical Issues in Advanced Nursing Practice',
    course_desc:
      'This course will explore the philosophical and theoretical foundations of health care ethics. Additionally, this course will present multiple perspectives used in medical/nursing ethics decision-making. The history of and current issues in medical ethics will be explored along with relevant case studies.',
  },
  {
    course_code: 'NGR6893',
    course_name: 'Health Systems Leadership and Policy Strategies',
    course_desc:
      'This course teaches the learner to synthesize organizational theory and leadership to influence health policy within the context of current complex healthcare systems. The learner will analyze policy from a socio-economic, ideological, political, historical, and technological perspective while integrating clinical management processes and utilizing community resources. Content will focus on the organizational structure of healthcare systems, healthcare financing, and economic implications and roles of the provider in policy making.',
  },
  {
    course_code: 'NGR6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'NGR8779',
    course_name: 'Transformational Leadership for Nurse Executives',
    course_desc:
      "This course expands on the leadership skills necessary for the nurse executive to assume an advanced role of the DNP in health care administration. Effective communication and visionary skills necessary for project improvement and system's change initiatives as well as the ability to integrate nursing science into practice will be explored. Preparation to analyze the effect of epidemiological, biostatistical, cultural and environmental influences related to the care of individuals and populations is an essential component.",
  },
  {
    course_code: 'NGR8891',
    course_name:
      'Interprofessional Collaboration for Improving Patient, Population and System Outcomes',
    course_desc:
      'This course offers opportunities to explore how the roles of different agencies and individuals interrelate in the delivery of health care.  Analyzing the significance of the role of the nurse executive in relation to the health care team is paramount.  Health care policy development, management and evaluation at the local, state and global level while identifying the significant individuals and agencies involved is a focus.',
  },
  {
    course_code: 'NGR8892',
    course_name: 'Clinical Prevention, Epidemiology and Population Health',
    course_desc:
      'This course analyzes the impact of societal, cultural, and ethical factors on healthcare. Emphasis is placed on examining the influence of barriers inherent to the vulnerable and under-served. Evidence based theories and other strategies for evaluating and managing ethical dilemmas as they affect the management of health care are examined.',
  },
  {
    course_code: 'NGR8911',
    course_name: "System's Change/Innovation Project",
    course_desc:
      'This course employs consultative and advanced leadership strategies with inter and intra professional groups to create and disseminate an innovation project within a selected health system. This project represents the summation of the knowledge, skills and abilities developed throughout the program and project implementation.',
  },
  {
    course_code: 'NGR8979',
    course_name: 'Executive Health Care Immersion Experience Three',
    course_desc:
      'This course is the third of three healthcare immersion experiences for the DNP student and is designed to provide opportunities in application of advanced leadership and clinical knowledge in healthcare systems. The focus is increasing competence in the role, refining business acumen, leadership skills, and business practices within a specific healthcare institution/agency. Scientific and organizational theory, systematic evidence appraisal, policy, and outcomes analysis are integrated into this course.',
  },
  {
    course_code: 'NSP3845',
    course_name: 'Academic Writing in Nursing I',
    course_desc:
      'Provides an introduction to the academic reading and writing characteristics of higher education for the RN-BSN student.  Within the context of the nursing profession the student will demonstrate the ability to read critically, write effective arguments, and practice the writing process using APA style format.  Co-requisite NUR3081.',
  },
  {
    course_code: 'NSP4846',
    course_name: 'Academic Writing in Nursing II',
    course_desc:
      'Continues the foundation for the academic reading and writing characteristics of higher education for the RN-BSN student.  Within the context of evidence-based nursing practice the student will conduct a scholarly literature review, write extended arguments, and further develop writing expertise using APA style format.  Co-requisite NUR4165.',
  },
  {
    course_code: 'NUR3026',
    course_name: 'Patient Centered Care I',
    course_desc:
      'This course will introduce the student to the use of evidence-based strategies and the nursing process in provision of patient centered care of adults and older adults with chronic or non-complex acute illnesses.  An emphasis of this course will focus on safety, quality of care, and interprofessional collaborative efforts to optimize patient outcomes.',
  },
  {
    course_code: 'NUR3026L',
    course_name: 'Patient Centered Care I Lab',
    course_desc:
      'This course provides the student with clinical skill development and patient centered care clinical experiences effectively grounded in the principles of safety, quality, interprofessional care, and evidence based practice. Translation of theory to practice is emphasized.',
  },
  {
    course_code: 'NUR3067',
    course_name: 'Health Assessment and Promotion',
    course_desc:
      'For the RN-BSN student, this course focuses on enhancing knowledge and skills in health history interviews, health screening, and selected physical examination techniques. Identification of primary health needs and the ability to locate reliable internet resources is explored.',
  },
  {
    course_code: 'NUR3081',
    course_name: 'Transition to Professional Nursing Practice',
    course_desc:
      'This introductory course for the RN-BSN student provides educational-based guidance for progressing into the role of the baccalaureate nurse through exploration of nursing theories, healthcare policy, and the core healthcare professional competencies. Focus will be on academic writing; including citing professional sources, using APA format, and searching and using scholarly references.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'NUR3095',
    course_name: 'Introduction to Pharmacological Nursing',
    course_desc:
      "This course focuses on the pharmacologic aspects of nursing practice.  A foundation of knowledge is built in relation to pharmacokinetics, pharmacodynamics, and pharmacotherapeutics of drug therapy.  The nurses' role in error prevention and patient safety during medication administration is carefully examined.",
  },
  {
    course_code: 'NUR3138',
    course_name: 'Health Assessment and Promotion in Nursing Practice',
    course_desc:
      'This course introduces students to health assessment as a systematic process with emphasis on therapeutic communication skills and assessment of health across the lifespan.  Focus is on the development of therapeutic relationships and the use of general and specialized assessment skills as a basis for clinical decision making.',
  },
  {
    course_code: 'NUR3145',
    course_name: 'Pharmacotherapeutics for the RN-BSN',
    course_desc:
      'For the RN-BSN student, this course focuses on the principles and concepts of pharmacology, current population specific treatment and related nursing practices.',
  },
  {
    course_code: 'NUR3215',
    course_name: 'Patient Centered Care II',
    course_desc:
      'This course provides the student vital knowledge on the increasing acuity of common health illnesses and related nursing care interventions for the Adult Health client across the lifespan. Through critical thinking, clinical reasoning, evidence based practice and problem based learning, students gain an understanding of actual and potential complex health problems.',
  },
  {
    course_code: 'NUR3215L',
    course_name: 'Patient Centered Care II Lab',
    course_desc:
      'This course provides the student with clinical skill development and patient centered care clinical experiences effectively grounded in the principles of safety, quality, interprofessional care, and evidence based practice. Translation of theory to practice is emphasized.',
  },
  {
    course_code: 'NUR3505',
    course_name: 'Mental Health Nursing Care',
    course_desc:
      'Students will examine the constructs of mental health, and mental illness focusing on restoration and maintenance of individuals experiencing acute and chronic mental health issues. Evidence-based nursing strategies, with a focus on cultural considerations and groups across the lifespan will be addressed.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'NUR3505L',
    course_name: 'Mental Health Nursing Care Lab',
    course_desc:
      'This course provides the mental health clinical component of Mental Health Nursing Care.Students will perform therapeutic nursing care to diverse individuals and families across the life span. The use of evidence based practice guidelines will be incorporated into the provision of nursing care of those individuals who chronic mental health disorders.',
  },
  {
    course_code: 'NUR3805',
    course_name: 'Achieving Professionalism I',
    course_desc:
      'This course introduces the student to key concepts and expectations of professional nursing.  A comprehensive examination of nursing history, theories and models, the nursing process, nursing organizations, law and liability, ethics, education, health care systems, and professional organizations are discussed.  Additionally, the student will explore the primary roles of a professional nurse and what key elements are required.',
  },
  {
    course_code: 'NUR3835',
    course_name: 'Achieving Professionalism II',
    course_desc:
      'This course introduces new content and builds on the concepts examined in Achieving Professionalism I.  The student will now begin to explore concepts such as power, the politically active nurse, the health care debate, understanding behavior, the aging impact, and other developments in current nursing practice.',
  },
  {
    course_code: 'NUR3871',
    course_name: 'Health Care Informatics',
    course_desc:
      'This course introduces students to informatics as it applies to health care in general with a special focus on nursing practice. The emphasis of this course is on the integration of nursing, computer, and information science for the support of professional nursing practice. Core informatics concepts, competencies, skills, and tools that promote safety, improve quality, and foster patient centered care and efficiency are introduced.',
  },
  {
    course_code: 'NUR3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'NUR4125',
    course_name: 'Pathophysiology and Healthcare Management',
    course_desc:
      'For the RN-BSN student, this course is designed to integrate disease processes, healthcare and nursing interventions. This course examines the pathophysiological processes that occur in the human body.',
  },
  {
    course_code: 'NUR4165',
    course_name: 'Essentials of Evidence-Based Nursing Practice',
    course_desc:
      'This course introduces the baccalaureate nursing student to evidence-based nursing practice. Students will explore quality care initiatives through the integration of theory, evidence, clinical judgment and patient preferences.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'NUR4169',
    course_name: 'Integration of Evidence in Professional Nursing Practice',
    course_desc:
      "This course is designed to promote the student's understanding of translating research into nursing clinical reasoning and decision-making.  Upon completion of the course, the student should be able to review and use research findings in the provision of patient centered care to improve health. Additional focus on academic writing, APA formatting, searching, and using scholarly references will support the application of evidence based practice in the clinical setting. Meets Gordon Rule Requirement.\nMeets Gordon Rule Writing Requirement.",
  },
  {
    course_code: 'NUR4216',
    course_name: 'Patient Centered Care III',
    course_desc:
      "This course builds upon and broadens the student's knowledge base and clinical reasoning skills in the provision of patient centered care to individuals, families and diverse populations with increasingly complex illnesses.  Emphasis is placed on utilizing evidence based principles and the nursing process in the delivery of safe, high quality patient care.",
  },
  {
    course_code: 'NUR4216L',
    course_name: 'Patient Centered Care III Lab',
    course_desc:
      'This course provides the student with applicable clinical experiences caring for complex adult health clients with varied illnesses. Through clinical, lab, and simulation experiences, the concepts of clinical reasoning, clinical judgment, and care centered in quality and safety is emphasized. Use of evidence in the provision of complex care is also a course focus.',
  },
  {
    course_code: 'NUR4257',
    course_name: 'Patient Centered Care IV',
    course_desc:
      'This final patient centered care course synthesizes previous and current knowledge in providing safe, quality nursing care to high acuity individuals, and families with unstable or life threatening conditions. The nurse?s role as provider and manager of care is emphasized in relation to best practice strategies that improve patient outcomes.',
  },
  {
    course_code: 'NUR4257L',
    course_name: 'Patient Centered Care IV Lab',
    course_desc:
      'This final patient centered care lab course focuses on the provision of safe, competent, quality nursing care to those individuals who have high acuity illness, are unstable, or have life threatening conditions. The nurse?s role as provider and manager of care is emphasized as part of this preceptor based clinical experience. \nCourse Type Internship.',
  },
  {
    course_code: 'NUR4286',
    course_name: 'Gerontological Nursing',
    course_desc:
      'For the RN-BSN student, this course explores holistic nursing strategies for health promotion and risk reduction in the older adult.',
  },
  {
    course_code: 'NUR4445',
    course_name: 'Patient Centered Care of Families',
    course_desc:
      'The course introduces the student to fundamentals of childbearing processes and evidence-based care for women, children, and their families during the antepartum, intrapartum, and postpartum periods as well as growth and development of infants, children, and adolescents.  Emphasis is placed on caring for women, children, and their families utilizing the nursing process in diverse settings across the care continuum.  The course is designed to develop perspectives on wellness and illness in child-bearing women and children, highlighting family centered care that incorporates screening, teaching, and health counseling.',
  },
  {
    course_code: 'NUR4445L',
    course_name: 'Patient Centered Care of Families Lab',
    course_desc:
      'This course focuses on the student providing patient centered care to women, children, adolescents and families utilizing the nursing process and evidence based practice principles to promote safe quality driven care. Course design promotes the students ability to develop perspectives on wellness and illness in child-bearing women and children, highlighting family centered care that incorporates screening, teaching, and health counseling.',
  },
  {
    course_code: 'NUR4615',
    course_name: 'Community and Public Health Nursing',
    course_desc:
      'The purpose of this course is to examine strategies for wellness promotion, disease prevention, and disaster management in communities and populations utilizing evidence based practice. Emphasis is on global health and the epidemiologic principles that affect the health of vulnerable populations. This course provides students the opportunity to plan and implement a service learning project in a vulnerable population community.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'NUR4636',
    course_name: 'Public Health & Community-based Nursing',
    course_desc:
      'This RN-BSN public health nursing course explores the role of the Baccalaureate- prepared nurse in health promotion and disease prevention among diverse communities. Dimensions of cultural expressions are explored among at-risk populations. The study of epidemiology, as well as social determinants of health are studied and applied to population health by using a public health intervention framework.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'NUR4636L',
    course_name: 'Community and Public Health Nursing Lab',
    course_desc:
      'Expanding upon current knowledge and experience base, students will participate in a variety of clinical experiences in diverse settings with an emphasis on health maintenance, health promotion, education, and disease prevention.',
  },
  {
    course_code: 'NUR4826',
    course_name: 'Law & Ethics in Nursing',
    course_desc:
      'For the  RN-BSN student to explore legal concepts and regulations that guide professional nursing practice. Examines ethical decision-making related to nursing practice and health care.',
  },
  {
    course_code: 'NUR4827',
    course_name: 'Leadership and Management in Nursing',
    course_desc:
      'The purpose of this course is to examine leadership and management concepts used to address complex microsystem issues within selected healthcare organizations. Emphasis is on the application of advanced communication skills in collaboration with interprofessional teams. Focus is on the interrelationship of selected roles within the context of specific theoretical frameworks and models of care.',
  },
  {
    course_code: 'NUR4828',
    course_name: 'Nursing Systems Management',
    course_desc:
      'This RN-BSN course provides an overview of essential nurse leader/manager skills, knowledge,  and expertise required for complex health care environments. An emphasis on quality and safety initiatives will be examined to ensure the provision of highly reliable care.',
  },
  {
    course_code: 'NUR4895',
    course_name: 'Health Education in the Community',
    course_desc:
      'This capstone course focuses on the role of nurse as health educator. The student will design and implement an evidence based teaching plan for a vulnerable population in the  community setting.',
  },
  {
    course_code: 'NUR4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'OCB3108',
    course_name: 'Study Abroad In Florida - Marine Field Studies',
    course_desc:
      "This is a 5-week, field intensive course designed to expand student knowledge of the biodiversity, geochemistry, and human impact of Florida's coastal and offshore ecosystems through a round-robin trip around Florida to explore marine eco-systems. This course will take students from the reefs of the Florida Keys to the open Gulf of Mexico aboard state-of-the-art research vessels, as well as shallow tropical estuaries of the western Everglades, the temperate Estuarine and Coastal environments of Northeast Florida, and watersheds in northwest Florida.  Field and laboratory work will allow students to utilize current marine research methods while learning about marine environments and their organisms.  Some field activities will be physically demanding.  Required prerequisites include Chem I and II, Bio I and II, or permission of the instructor is required.",
  },
  {
    course_code: 'OCB4201',
    course_name: 'Biology of Coral Reefs',
    course_desc:
      'Overall, the aim of this course is to highlight the organization, structure, productivity, and biological diversity of the coral reef ecosystem. This course will address the taxonomy, biology, and ecology of the main groups (inhabitants & builders) on coral reefs. Special attention and focus will be given to environmental and anthropogenic disturbances. Offered concurrently with OCB5203 (Biology of Coral Reefs).',
  },
  {
    course_code: 'OCB5203',
    course_name: 'Biology of Coral Reefs',
    course_desc:
      'Overall, the aim of this course is to highlight the organization, structure, productivity, and biological diversity of the coral reef ecosystem. This course will address the taxonomy, biology, and ecology of the main groups (inhabitants & builders) on coral reefs. Special attention and focus will be given to environmental and anthropogenic disturbances. Offered concurrently with OCB4201 (old ZOO3556).',
  },
  {
    course_code: 'OCC4002',
    course_name: 'Chemical Oceanography',
    course_desc:
      'The chemical composition of the oceans and the physical, chemical, and biological processes governing this composition in the past and present. Topics covered include cycling of carbon, nitrogen, phosphorus, silicon, and oxygen, and processes of primary production, export production, remineralization, digenesis, and air-sea gas exchange.',
  },
  {
    course_code: 'OCE3007',
    course_name: 'Concepts of Oceanography and Marine Biology',
    course_desc:
      "This course is an examination of the principal ecosystems of the world's oceans, emphasizing the biotic and abiotic factors that contribute to the distribution of marine organisms. This course will focus on ocean literacy: awareness and understanding of the fundamental concepts about the history, function, contents, and utilization of the ocean. Emphasis will be placed on marine environmental issues and climate change.",
  },
  {
    course_code: 'OCE3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'OCE4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'OCE5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'OCE6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PAD3003',
    course_name: 'Public Administration in American Society',
    course_desc:
      'Effective administration of government agencies, nonprofit organizations and other civil institutions is necessary if American democracy is to thrive. Addresses that challenge by examining the administration of governmental and nonprofit organizations using both traditional concepts (e.g. administrative theory, civil service systems, human relations movement) and more contemporary concepts (the new public administration, reinventing government).',
  },
  {
    course_code: 'PAD3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PAD4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PAD5107',
    course_name: 'Modern Public Organization Theory',
    course_desc:
      'Analysis of contemporary theories of organizations applicable to individual, group and system levels. Public organizations treated generically with examples and applications primarily drawn from the public and nonprofit sectors. May not be taken for credit by students having credit for MAN 5204 or SOP 5617.',
  },
  {
    course_code: 'PAD5146',
    course_name: 'The Nonprofit Profession',
    course_desc:
      'Overview of the field of nonprofit organizations from a management perspective. Human resource management (including working with volunteers and professionals), public relations, board relations, daily operations, financial matters, and ethics.',
  },
  {
    course_code: 'PAD5434',
    course_name: 'Leadership in Sustainability',
    course_desc:
      'Explores the essential components of front-line leadership in sustainability, including integrating sustainability into an organization, executing organizational strategy, and committing to it for a lifetime. Students are provided with tools to analyze various leadership styles in public service organizations. Topics include administrative and sustainable leadership roles within organizations and with policyholders.',
  },
  {
    course_code: 'PAD5635',
    course_name: 'Government Contract Law',
    course_desc:
      'Examination of government contract law and ethics including major provisions of the federal Procurement Integrity Act and general federal acquisition contract principles. Authority of contracting officers, delegation of contracting officer authority, and impact of delegation. Procedures for formation of government contracts and contract protest, government property fundamentals, government contract funding and fiscal matters, labor, social, economic, environmental concerns and fraud are explored. Legal aspects of inspection, acceptance, delivery, warranties, changes, terminations and contract disputes are also examined.',
  },
  {
    course_code: 'PAD5855',
    course_name: 'Contract Planning and Formulation',
    course_desc:
      'Provides an overview of the role of acquisitions/procurement in government and the nonprofit sector, highlighting foundational concepts of Federal procurement as outlined in the Federal Acquisition Regulation (FAR) and other sources, and purchasing systems at other levels of government. A survey of government contracting policies and procedures from acquisition planning through solicitation of government contracts; emphasizes the importance of the statement of work and development of the solicitation.',
  },
  {
    course_code: 'PCB4922',
    course_name: 'Biology Seminar',
    course_desc:
      'Seminar topics from a diverse spectrum of current biological research will be presented by a variety of speakers from UWF, national and international academic research instructors and agencies. Offered concurrently with PCB5924 and PCB3930 (Biology Seminar); graduate students will be assigned additional work.',
  },
  {
    course_code: 'PAD5862',
    course_name: 'Contract Award and Administration',
    course_desc:
      'Examines government contracting policies and procedures from pre-award evaluation and negotiation to post-award contract administration activities and contract close-out.  Includes cost-price analysis needed to prepare or evaluate and analyze cost proposals and costs incurred in federal government contracts, and methods utilized by the federal government to establish estimates of fair and competitive prices for goods and services.',
  },
  {
    course_code: 'PAD5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PAD6041',
    course_name: 'Public Service Ethics',
    course_desc:
      'A fully online course concentrating on public service ethics and organizational integrity. Focuses on ethical dilemmas and concerns faced by public managers arising from their exercise of administrative discretionary power. Explores contemporary public service ethical dilemmas, and nascent studies and concepts of organizational evil, administrative evil, governance, moral inversion and technical rationality through case studies and ethics literature. Provides maps and tools to make ethical and integrity obligations more explicit and consistent.',
  },
  {
    course_code: 'PAD6053',
    course_name: 'Public Administration: Theory and Practice',
    course_desc:
      'Examines public administration theory and practice. Considers the role of administrators in government and the nonprofit sector, in increasingly complex political, social and economic contexts, through a survey of foundational texts in public administration.  Topics include the theoretical framework and trends in public administration.',
  },
  {
    course_code: 'PAD6227',
    course_name: 'Public Budgeting',
    course_desc:
      'A fully online course focusing on the economics of public sector and politics of public budgeting and finance. The course identifies and investigates intergovernmental fiscal relations, including an analysis of the budgetary practices and relations at the federal, state, and local levels of government. The course provides a review of sources of government revenues; probes market failures, public expenditure theory, public goods, publicly provided private goods, sources of inefficiencies in the public sector; differentiates between externalities and the environment, introducing the concept sustainable budgeting and triple bottom line; and evaluates public expenditures.',
  },
  {
    course_code: 'PAD6275',
    course_name: 'Political Economy of Public Administration',
    course_desc:
      'A fully online course focusing on the political economy of public administration. The political economy factors and theories are analyzed and assessed, including markets, politics and democracy, market failure and bureaucratic failure, relationships between government and business, public choice theory, sustainability, privatization and contracting out.',
  },
  {
    course_code: 'PAD6335',
    course_name: 'Strategic Management for Public Service Organizations',
    course_desc:
      'Examination and exploration of planning, targets, goal setting, and strategic sustainable management in public sector organizations. Topics include strategic planning, strategic management, and strategies deployed in sustainable and resilient public service organizations.',
  },
  {
    course_code: 'PAD6357',
    course_name: 'Sustainability and Resiliency Planning',
    course_desc:
      'The course explores the concepts of sustainability and resiliency in modern organizations and communities. Topics include theories of sustainability, sustainable development, climate resilience, targets, measurements, planning, and implementation of sustainable and resilient measures.',
  },
  {
    course_code: 'PAD6417',
    course_name: 'Public Service Human Resource Management',
    course_desc:
      'An examination of the theories, practices and issues central to contemporary human resource management in public service and nonprofit organizations. This course focuses on leadership issues in public service HRM.',
  },
  {
    course_code: 'PAD6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PAD6946',
    course_name: 'Public Administration Capstone',
    course_desc:
      "The capstone course is the culminating academic experience for students nearing completion of their MSA in the Public Administration program. The course involves content topics addressing the review and reflection of your MSA academic program, ethical leadership, including the end of the program research project. The research projects provide an opportunity for students to explore a problem or policy issues of professional interest and to address that problem or issue through focused study. The project will demonstrate the student's ability to synthesize and apply the knowledge and skills acquired in his/her academic program to real-world issues and problems.  This final project affirms students' ability to think critically and creatively, to solve practical problems, to make reasoned and ethical decisions, and to communicate effectively. Topics include the MSA PA program review, a final research project, and ethical leadership. Permission is required.",
  },
  {
    course_code: 'PAD7003',
    course_name: 'Administrative Ethics',
    course_desc:
      'This is a doctoral level course concentrating on public service ethics. The course focuses on ethical dilemmas and concerns faced by public managers arising from their exercise of administrative discretionary power. The course explores contemporary public service ethical dilemmas by examining teleological and deontological schools of thought applied to case studies and ethics literature. The course provides maps and tools to make moral experiences more explicit and consistent. Finally, the course scrutinizes the concepts of administrative evil, technical rationality, moral inversion, and ethical decision?making.',
  },
  {
    course_code: 'PAD7004',
    course_name: 'Public Budgeting and Finance',
    course_desc:
      'This course includes an analysis and practice of the budgetary processes typically employed at the federal, state, and local levels of government. The course contains practical, as well as theoretical exposure to the techniques and various formats of public budgeting. This is a\ndoctoral level course focused on the economics of public sector and the politics of public budgeting and finance. The course identifies and investigates intergovernmental\nfiscal relations, including an analysis of the budgetary practices and relations at the\nfederal, state, and local levels of government.',
  },
  {
    course_code: 'PAD7409',
    course_name: 'Strategic Management in Administration',
    course_desc:
      'This course includes an examination and practice of planning, goal setting, assessment, and strategic management in public and non-profit organizations.',
  },
  {
    course_code: 'PAD8905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PCB2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PCB3043',
    course_name: 'Ecology',
    course_desc:
      'Interactions of microorganisms, plants, and animals with abiotic and biotic factors in the environment are examined as determinants of the distribution and abundance of species, population dynamics and ecosystem function. General concepts and methodologies of ecological science are discussed at individual, population, community and ecosystem levels of organization. Material and Supply Fee will be assessed for corresponding lab.',
  },
  {
    course_code: 'PCB3043L',
    course_name: 'Ecology Lab',
    course_desc:
      'This lab accompanies the Ecology lecture, PCB3043.  The lab provides students with hands-on and field experiences linked to topics presented in the lecture course and introduces students to different ecosystems on campus and in our region.',
  },
  {
    course_code: 'PCB3063',
    course_name: 'Genetics',
    course_desc:
      'Origin, development and principles of modern genetics and genetic manipulations. Material and supply fee will be assessed for corresponding lab. Two academic terms of introductory biology are required prior to taking this course.',
  },
  {
    course_code: 'PCB3063L',
    course_name: 'Genetics Lab',
    course_desc: 'Corresponding lab for Genetics.',
  },
  {
    course_code: 'PCB3097L',
    course_name: 'Introduction to Human Anatomy Laboratory',
    course_desc:
      'Introduction to Human Anatomy is a comprehensive examination of human anatomy. The relationship between structure and function forms a continuing theme within both lecture and laboratory. This course is designed for students who intend to pursue a professional degree in health related fields. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'PCB3103',
    course_name: 'Cell Biology',
    course_desc:
      'Cell biology is the study of the structure and function of eukaryotic cells. The course will cover the basics of cellular function and biochemical foundations, cellular genetics and molecular biology, cell structure and function, cell signaling, and cytoskeletal organization and regulation. Relevant current topics in the news and disease case studies will also be used to more broadly apply the topics learned throughout the course to real-world situations.',
  },
  {
    course_code: 'PCB3103L',
    course_name: 'Cell Biology Laboratory',
    course_desc:
      'Cell biology Laboratory is designed to provide the fundamental training in the current techniques and methodologies used in research laboratories. The laboratory is to complement the cell biology lecture, however can be taken independently. The experiments are associated with the following topics: microscopy (bright-field and fluorescence), the scientific method, biochemistry, cellular organization, structure and function relationships, cellular energetics, biotechnology, forensic investigations, and the immunology of the wound response.',
  },
  {
    course_code: 'PCB3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PCB4048C',
    course_name: 'Coastal Marine Ecology',
    course_desc:
      'The study of nearshore coastal environments, particularly bays and estuaries emphasizing interactions among biotic communities, physical, geological and chemical processes. The influence of human activities on and management of these ecosystems is discussed. Offered concurrently with PCB5445C; graduate students will be assigned additional work. Material and supply fees will be assessed for corresponding lab.',
  },
  {
    course_code: 'PCB4098',
    course_name: 'Concepts in Human Physiology',
    course_desc:
      'Concepts in Human Physiology is a 3 credit lecture and 1 credit lab course for students interested in areas related to human physiology.   It covers physiological mechanisms of the human body. Emphasis is placed on mechanisms designed to maintain homeostatic conditions, membrane dynamics and cell signaling including endocrine and nervous signals, as well as other vital physiologic mechanisms necessary to homeostasis.',
  },
  {
    course_code: 'PCB4098L',
    course_name: 'Concepts in Human Physiology Laboratory',
    course_desc:
      'Concepts in Human Physiology is a 3 credit lecture and 1 credit laboratory course for students interested in areas related to human physiology.   The laboratory portion will consist of laboratory exercises design to reinforce concepts learned in lecture.  Laboratory exercises include modeling cellular activities and metabolic reactions, as well as measurements and experiments related to organ system function.',
  },
  {
    course_code: 'PCB4125',
    course_name: 'Advanced Molecular Biology and Bioinformatics for Biologists',
    course_desc:
      'This course uses stepwise building of computer analysis tools and techniques essential for upper-level undergraduate and M.S. graduate students in Biological Sciences, Biomedical Sciences, Biochemistry, including students with interests in pre-professional fields, as well as research in ecology, evolution, biotechnology, and medicine. In addition to the pre-requisites, we prefer that students have taken either Molecular Biology (PCB4524 and 4524L) or Biochemistry with lab (BCH3033 and Lab) to be the most successful in the course. Offered concurrently with PCB5525. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'PCB4233',
    course_name: 'Immunology',
    course_desc:
      'Basic principles of immunology to include humeral and cell-mediated immune mechanisms, the complement system and the inflammatory response. Offered concurrently with PCB5235; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PCB4233L',
    course_name: 'Immunology Laboratory',
    course_desc:
      'Selected experiments in immunology. Special permission required. Permission granted on the basis of fulfilling prerequisite. Material and Supply Fee will be assessed. Offered concurrently with PCB5235L; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PCB4253',
    course_name: 'Developmental Biology',
    course_desc:
      'This course covers the current understanding of the mechanisms that regulate animal development. Students will learn patterns and mechanisms of animal development, with an emphasis on model organisms such as Drosophila, Xenopus, chick, mouse, zebrafish. A central theme will be development as a phenomenon of differential gene regulation. Developmental mechanisms, especially at a molecular level, will be examined for differences and commonality among organisms, with a special focus on key signaling pathways. Specific topics include formation of early body plan, cell type determination, organogenesis, morphogenesis, stem cells, and issues in human development. Offered concurrently with PCB 5254. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'PCB5235',
    course_name: 'Immunology',
    course_desc:
      'The basic principles of immunology will be addressed. Immune-mediated disease processes will be discussed. Offered concurrently with PCB4233; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PCB4253L',
    course_name: 'Developmental Biology Lab',
    course_desc:
      'The purpose of this course is to give students experience with important techniques used to study developmental biology, to provide hands-on learning opportunities that accompany material learned in the lecture course, and to provide research and scientific communication experience applicable to developmental biology and other biomedical research fields. Offered concurrently with PCB 5254L; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PCB4364',
    course_name: 'Marine Ecological Physiology',
    course_desc:
      'Interdisciplinary approach to understanding and interpreting interrelationships between adaptation and environment in marine animals. Examines life history strategies and tactics unique to organisms found living in or around marine habitats. Specific behavioral and physiological responses of marine animals exposed to feeding, metabolic, oxic, osmotic and thermal challenges are discussed. Offered concurrently with PCB5319; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PCB4364L',
    course_name: 'Marine Ecological Physiology Laboratory',
    course_desc:
      'Field techniques for quantifying physiological adaptations of marine organisms to their abiotic environment. Students will characterize marine habitats and assess feeding, metabolic, oxic, thermal and osmoregulatory strategies used by vertebrates and invertebrates living in these habitats. Material and Supply Fee will be assessed. Offered concurrently with PCB5319L; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PCB4374',
    course_name: 'Tropical Ecology/Op Wall',
    course_desc:
      '1-6 week course culminating in an expedition with Op Wall to study coral reefs, mangrove forests, as well as tropical dry, rain and cloud forests. Students will attend a lecture series discussing selected topics in tropical ecology prior to the expedition. A series of slides featuring plants and animals common to the area will be shown to familiarize students with the local flora and fauna and to give them a greater appreciation for tropical ecology. Offered concurrently with PCB 5344; graduate students will be assigned additional work. Permission is required.',
  },
  {
    course_code: 'PCB4461',
    course_name: 'Molecular Ecology',
    course_desc:
      'Overall, the aim of this course is as an introduction to how developments in modern genetic techniques are used to improve our understanding of evolutionary and ecological processes. We will explore the biology of populations and communities of organisms using molecular data. Students will create, practice, and write a grant proposal in an area of their choosing as if it were submitted for external funding. Further, you will learn how these techniques can be applied to conservation and biodiversity issues. Offered concurrently with PCB5464. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'PCB4524',
    course_name: 'Molecular Biology',
    course_desc:
      'Study of the molecular level of the principles governing DNA replication, repair, RNA transcription, and protein synthesis in both prokaryotes and eukaryotes. Surveys molecular processing, and recombinant DNA technology. Offered concurrently with PCB 5527; graduate students are required to write a research paper and present it to the class. Material and supply fee will be assessed to the corresponding lab. A grade of "C-" or higher is required in prerequisite courses.',
  },
  {
    course_code: 'PCB4524L',
    course_name: 'Molecular Biology Lab',
    course_desc:
      'Corresponding lab for Molecular Biology. Offered concurrently with PCB 5527L; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PCB4673',
    course_name: 'Principles of Evolution',
    course_desc:
      'A survey of modern evolutionary biology, including the evidence that supports the theory of evolution, the natural processes that cause evolution, patterns and mechanisms of speciation, and methods for estimating evolutionary relationships. Offered concurrently with PCB5675; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PCB4703',
    course_name: 'Human Physiology',
    course_desc:
      'Physiological mechanisms of various organ systems in the human body. Emphasis on transport mechanisms, renal function, hormones, respiration, cardiac function, muscle physiology, digestion, and immune systems.',
  },
  {
    course_code: 'PCB4723',
    course_name: 'Comparative Animal Physiology',
    course_desc:
      'General and comparative animal physiology. Study of complex structures, phenomena, and concepts involved in regulation physiological processes employed by different groups of animals. Material and Supply Fee will be assessed for corresponding lab. Offered concurrently with PCB5727; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PCB4723L',
    course_name: 'Comparative Animal Physiology Laboratory',
    course_desc:
      'General and comparative animal physiology. Complex structures, phenomena, and concepts involved in the regulation of a variety of physiological mechanisms. Material and Supply Fee and Equipment Fee will be assessed. Offered concurrently with PCB 5727L; graduate students will be assigned additional work.\nThe Comparative Animal Physiology Laboratory requires the use of living animals, in most cases invertebrates. Be mindful, that while non-mammalian animals express a relatively low level of nervous integration (i.e. they do not perceive "pain" as you and I interpret it), they should be handled carefully and treated ethically. In this regard, each experiment is designed to provide maximal educational value with minimal insult and stress to the test animal. In most cases, animals will survive the procedures. In cases where animal do not survive, the euthanasia procedures used are the most humane possible. To achieve the laboratory goals and objectives outlined here, it will be imperative that you listen carefully and follow all directions given to you by your laboratory instructors.',
  },
  {
    course_code: 'PCB4870',
    course_name: 'Sensory Biology',
    course_desc:
      'This course is for upper-level undergraduate students interested in learning how humans and animals sense their environments and how these senses affect behavior and survival. The information learned in this course is broadly applicable to students interested in species ecology, human and animal health, biomedical science, marine biology, general biological research and psychology. Topics covered will include sensory mechanisms important for human health as well as ecology and survival of diverse marine and terrestrial species. This will be primarily a discussion-based course analyzing classical and current research articles pertaining to discussion topics. Offered concurrently with PCB5872; graduate students will be assigned additional and more in-depth work.\nPrerequisite is PCB3063 (Genetics), however students may obtain department permission to take the course without the specified pre-requisite.',
  },
  {
    course_code: 'PCB4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PCB6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PCB5235L',
    course_name: 'Immunology Laboratory',
    course_desc:
      'Selected experiments in immunology. Permission is required. Permission granted on the basis of fulfilling prerequisite or co-requisite. Material and supply fee will be assessed. Offered concurrently with PCB4233L; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PCB5256',
    course_name: 'Developmental Biology',
    course_desc:
      'This course covers the current understanding of the mechanisms that regulate animal development. Students will learn patterns and mechanisms of animal development, with an emphasis on model organisms such as Drosophila, Xenopus, chick and mouse. A central theme will be development as a phenomenon of differential gene regulation. Developmental mechanisms, especially at a molecular level, will be examined for differences and commonality among organisms, with a special focus on key signaling pathways. Specific topics include formation of early body plan, cell type determination, organogenesis, morphogenesis, stem cells, and issues in human development. Graduate students will be assigned outside reading from the primary literature on current research topics in developmental biology and will be expected to summarize and critique these papers orally and in writing. Students will also write a term paper that clearly, thoroughly and effectively summarizes a current topic in the field of developmental biology.',
  },
  {
    course_code: 'PCB5256L',
    course_name: 'Developmental Biology Lab',
    course_desc:
      'The purpose of this course is to give graduate students experience with important techniques used to study developmental biology, to provide hands-on learning opportunities that accompany material learned in the lecture course, and to provide research and scientific communication experience applicable to developmental biology and other biomedical research fields. Upon completion of this course, graduate students will be prepared for continuing graduate studies and/or a professional career with a developmental biology research/lab component.',
  },
  {
    course_code: 'PCB5319',
    course_name: 'Marine Ecological Physiology',
    course_desc:
      'Interdisciplinary approach to understanding and interpreting interrelationships between adaptation and environment in marine animals. Examines life history strategies and tactics unique to organisms found living in or around marine habitats. Specific behavioral and physiological responses of marine animals exposed to feeding, metabolic, oxic, osmotic and thermal challenges are discussed. Offered concurrently with PCB4364; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PCB5319L',
    course_name: 'Marine Ecological Physiology Laboratory',
    course_desc:
      'Field techniques for quantifying physiological adaptations of marine organisms to their abiotic environment. Students will characterize marine habitats and assess feeding, metabolic, oxic, thermal and osmoregulatory strategies used by vertebrates and invertebrates living in these habitats. Material and supply fee will be assessed. Offered concurrently with PCB4364L; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PCB5445C',
    course_name: 'Coastal Marine Ecology',
    course_desc:
      'The study of nearshore coastal environments, particularly bays and estuaries emphasizing interactions among biotic communities, physical, geological and chemical processes. The influence of human activities on and management of these ecosystems is discussed. Offered concurrently with PCB4048C; graduate students will be assigned additional work. Material and supply fees will be assessed for corresponding lab.',
  },
  {
    course_code: 'PCB5464',
    course_name: 'Molecular Ecology',
    course_desc:
      'Overall, the aim of this course is as an introduction to how developments in modern genetic techniques are used to improve our understanding of evolutionary and ecological processes. We will explore the biology of populations and communities of organisms using molecular data. Further, you will learn how these techniques can be applied to conservation and biodiversity issues. Offered concurrently with PCB4461. Graduate students will be assigned additional work usually in the form of an additional written report(s).',
  },
  {
    course_code: 'PCB5525',
    course_name: 'Advanced Molecular Biology and Bioinformatics for Biologists',
    course_desc:
      'This course uses stepwise building of computer analysis tools and techniques essential for upper-level undergraduate and M.S. graduate students in Biological Sciences, Biomedical Sciences, Biochemistry, including students with interests in pre-professional fields, as well as research in ecology, evolution, biotechnology, and medicine. Graduate students will be assigned additional work that supports more advanced skills with analysis and presentation of findings.',
  },
  {
    course_code: 'PCB5675',
    course_name: 'Principles of Evolution',
    course_desc:
      'A survey of modern evolutionary biology, including the evidence that supports the theory of evolution, the natural processes that cause evolution, patterns and mechanisms of speciation, and methods for estimating evolutionary relationships. Offered concurrently with PCB4673; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PCB5727',
    course_name: 'Comparative Animal Physiology',
    course_desc:
      'General and comparative animal physiology. Study of complex structures, phenomena, and concepts involved in regulation physiological processes employed by different groups of animals. Material and Supply Fee will be assessed for corresponding lab. Offered concurrently with PCB4723; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PCB5872',
    course_name: 'Sensory Biology',
    course_desc:
      'This course is for graduate students interested in learning how humans and animals sense their environments and how these senses affect behavior and survival. The information learned in this course is broadly applicable to students interested in species ecology, human and animal health, biomedical science, marine biology and general biological research. Topics covered will include sensory mechanisms important for human health as well as ecology and survival of diverse marine and terrestrial species. This will be primarily a discussion-based course analyzing classical and current research articles pertaining to discussion topics. Offered concurrently with PCB 4871; graduate students will be assigned additional and more in-depth work.',
  },
  {
    course_code: 'PCB5905',
    course_name: 'Water Quality',
    course_desc: '',
  },
  {
    course_code: 'PCB5924',
    course_name: 'Biology Seminar',
    course_desc:
      'Seminar topics from a diverse spectrum of current biological research will be presented by a variety of speakers from UWF, national and international academic research instructors and agencies. Offered concurrently with PCB4922; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PCB6074',
    course_name: 'Experimental Design in Biology',
    course_desc:
      'Covers experimental design in relation to the analysis of biological data. Topics include sources of error, variation in biological systems, replication and pseudoreplication, controls, multiplicity, sample size and randomization. The physical layout of biological experiments in the field and laboratory will be discussed in relation to basic parametric data analysis techniques.',
  },
  {
    course_code: 'PCO6204',
    course_name: 'Pre-Practicum: Techniques of Counseling and Psychotherapy',
    course_desc:
      'Experientially-based with an emphasis on counseling and psychotherapeutic techniques and behavior, including the identification and acquisition of broad communication and relationship-building skills, particular counseling techniques, and the development of a counseling response repertoire. Students also develop an understanding of the interaction between theory and technique as it applies to clinical practice, as well as develop their case conceptualization and case management skills. Simulated supervised counseling experience is provided through the use of micro-counseling and role-playing. Provides the opportunity to practice actual counseling skills and techniques prior to the practicum and internship experiences. The practicum placement process is included.',
  },
  {
    course_code: 'PCO6206C',
    course_name: 'Ethical and Professional Issues in Counseling',
    course_desc:
      'In depth review of critical issues in the practice of mental health counseling, including the professional organizations and ethical standards for psychologists and counselors, legal and professional requirements for practicing in the profession, and the rights of clients. Topics include standards of preparation, certifications and licensing, and the role identity and professional obligations of mental health counselors. Relevant issues for school counselors will be addressed.',
  },
  {
    course_code: 'PCO6216',
    course_name: 'Theories of Individual Counseling',
    course_desc:
      'Students must take (Either CLP3144 or PPE4003) or by permission of the instrutor or an undergraduate degree in Psychology before enrolling in this course.\nOverview of major contemporary theoretical approaches to individual counseling and psychotherapy.',
  },
  {
    course_code: 'PCO6246',
    course_name: 'Theories of Group Counseling',
    course_desc:
      'Students must take PCO6216 or by permission of the instructor before enrolling in this course. Overview of major contemporary theoretical approaches to group counseling and psychotherapy.',
  },
  {
    course_code: 'PCO6278',
    course_name: 'Multicultural Counseling',
    course_desc:
      'Addresses the similarities and differences among various culturally diverse groups, and informs counselors of the characteristics and processes necessary to become a culturally skilled counselor.',
  },
  {
    course_code: 'PCO6312',
    course_name: 'Substance Abuse Counseling',
    course_desc:
      'Examines the misuse of alcohol and other drugs, and how they affect biological, psychological, social and familial spheres of functioning. Designed to convey to counselors-in-training and community professionals the most essential information about licit and illicit drugs, provide an overview of the prominent theoretical models of addiction, and explore various clinical methods for assessing and treating substance use disorders. Courses in Theories of Individual, Group, or Family Counseling are recommended.',
  },
  {
    course_code: 'PCO6315',
    course_name: 'Assessment in Counseling',
    course_desc:
      'Practical training in the process of clinical assessment in mental health counseling. Includes an introduction to the science of clinical assessment with a focus on the use of assessment techniques such as interviewing and psychological testing, in a professionally and ethically responsible manner. Includes an experiential component in which the student will develop beginning skills in the use of clinical assessment techniques, under supervision. Permission is required. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'PCO6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PCO6946',
    course_name: 'Practicum in Counseling',
    course_desc:
      'Placement of the student in a local mental health agency for 8-10 hours each week. The emphasis of this experience is on development of clinical skills in interviewing, assessment, and counseling of individuals, groups, and families. Students will complete a minimum of 150 hours of field placement of which at least 40 will be in direct client contact. There is a weekly class meeting and individual supervision with the instructor in addition to the clinical activities and supervision at the practicum site. Permission is required based on requirements stated in the Counseling Track Policy Manual.',
  },
  {
    course_code: 'PCO6948',
    course_name: 'Internship in Counseling',
    course_desc:
      'The student functions as a staff member and participates in the full range of clinical and professional activities of the internship site under supervision. A weekly university based seminar will accompany field placement. Students in the 60sh M.A. Licensure Option must register for more than one term (total of 6sh required) and will complete a minimum of 850 hours of field placement, of which at least 240 will be in direct client contact. An internship paper and portfolio are required. Students in the 45sh M.A. degree program must complete 3sh with at least 300 hours of field placement. Graded on a satisfactory / unsatisfactory basis only. Permission is required based on requirements stated in the Counseling Track Policy Manual.',
  },
  {
    course_code: 'PEL1341',
    course_name: 'Beginning Tennis',
    course_desc:
      'Designed to introduce students to basic tennis strokes; rules; etiquette; terminology; basic tactics; strategy; and equipment.',
  },
  {
    course_code: 'PEM1116',
    course_name: 'Body Shaping I',
    course_desc:
      'Designed to introduce body shaping exercises to students to help improve overall physical fitness, improve cardiorespiratory endurance, and help reduce body fat. This entry level class will cover yoga, Pilates, cardio karate, water aerobics, step aerobics, and basic training. Students will exercise using various types of equipment.',
  },
  {
    course_code: 'PEM1120',
    course_name: 'Cardio Weightlifting and Endurance',
    course_desc:
      'Emphasizes the development of cardiovascular and muscular endurance through the use of free weights, weight machines, and cardio exercises. The exercises are based on the principle of circuit training through different exercise stations.',
  },
  {
    course_code: 'PEM1121',
    course_name: 'Yoga I',
    course_desc:
      'Designed to train the student in basic Hatha yoga techniques. An ancient method of exercise as well as a method of spiritual meditation. the physical yoga training will occur during the class periods and there will be a learning module on-line for the student to complete. Each class will be a significant physical challenge. Students of all athletic abilities are encouraged to take the course.',
  },
  {
    course_code: 'PEM2114',
    course_name: 'Cycle Fit',
    course_desc:
      'Students will participate in indoor cycling group workouts. Students will learn the proper use of cycle bikes for a safe and effective workout. Students will learn basic instruction techniques that will lay the foundation for learning to become a Cycle Fit instructor.',
  },
  {
    course_code: 'PET5702',
    course_name: 'Advanced Management of Physical Activity Programs',
    course_desc:
      'This course will prepare students to effectively use current theory and administrative techniques to design and implement  appropriate physical activity programs. Emphasis is placed on developing and implementing program plans.',
  },
  {
    course_code: 'PEM2126',
    course_name: 'Yoga Fitness',
    course_desc:
      'Students will learn information on the background of yoga, the many different types of yoga and the health benefits of participating in yoga fitness. The class includes a physical component in which students will participate in yoga fitness classes, designed to slowly progress through various sequences and poses of increasing difficulty as the semester advances. In addition, students will learn basic instruction techniques that will lay the foundation for learning to become a yoga fitness instructor.',
  },
  {
    course_code: 'PEM2179',
    course_name: 'Boot Camp Fitness',
    course_desc:
      'Students will participate in Boot Camp classes that will include aerobic exercise and anaerobic drills to improve endurance, strength, power, and agility. Classes will be designed to slowly progress through various exercises and drills of increasing difficulty as the semester advances. In addition, students will learn basic instruction techniques that will lay the foundation for learning to become a Boot Camp instructor.',
  },
  {
    course_code: 'PEM3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PEO2031',
    course_name: 'Analysis of Individual Sports',
    course_desc:
      'Practicum in analytical techniques of skills involved in individual sports. Emphasis is on analysis, instructional design, and application of skills in a teaching situation.',
  },
  {
    course_code: 'PEO2510',
    course_name: 'Theory and Practice of Coaching Soccer',
    course_desc:
      'The purpose of this course is to provide students with the skills to effectively coach beginning soccer. The focus of the course includes basic soccer skills, offensive strategies, defensive strategies, and planning effective soccer lesson/practice sessions.',
  },
  {
    course_code: 'PEO4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PEP3505',
    course_name: 'Non-Traditional Sports',
    course_desc:
      'Designed for potential physical education teachers, sport administrators teachers and fitness and conditioning specialists. sports administrators. Emphasis on development of game performance and teaching/coaching skills in the most popular non-traditional sports in physical education and sports programs. Students are expected to participate in the class by teaching, coaching, practicing and learning sport skills.',
  },
  {
    course_code: 'PET1905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PET2824',
    course_name: 'Analysis of Team Sports',
    course_desc:
      'Designed for potential physical education teachers and sports administrators. Emphasis is on development and understanding of skills in the most popular team sports in physical education and sports programs.  Students are expected to participate in the class by teaching, coaching, practicing and learning sport skills.  Skills are measured through midterm assessment (no physical performance standards, only cognitive understanding of game performance skills) and lesson\nassessment(teaching/coaching skill evaluation).',
  },
  {
    course_code: 'PET3020',
    course_name: 'Foundations of Physical Education and Sport Management',
    course_desc:
      'For physical education and sport management majors. Designed to acquaint them with the knowledge and understanding related to the development of physical education and sport and its significance to modern society.',
  },
  {
    course_code: 'PET3123',
    course_name: 'Historical Foundations of Sport and Fitness',
    course_desc:
      'For physical education and fitness and sport coaching majors. Designed to acquaint them with the knowledge and understanding related to the history and development of physical education, coaching, and physical activity professions.',
  },
  {
    course_code: 'PET3344C',
    course_name: 'Athletic Coaching Methods',
    course_desc:
      'This course provides students with specific methods on how to effectively coach in athletic and fitness settings. Emphasis is placed on understanding athletes, developing a clear coaching philosophy, planning for practices, games and seasons, player development, managing the athletic or fitness setting, and evaluating performance before, during, and between sport seasons.',
  },
  {
    course_code: 'PET3351C',
    course_name: 'Applied Exercise Physiology',
    course_desc:
      'This course provides an overview of the fundamentals of exercise physiology, including muscles and muscle adaptation, fuel for exercise, and the cardiorespiratory system. This course specifically focuses on the hands-on practical application of these concepts and expands this knowledge to address the design of training programs for achieving specific goals. Special consideration of modifications for training programs, including adjustments for changes in altitude or temperature and considerations for populations such as children, older adults, and pregnant women will be discussed.',
  },
  {
    course_code: 'PET3556C',
    course_name: 'Designing Resistance Training Programs',
    course_desc:
      'This course outlines and applies the principles of fitness training and exercise programming. Various types of strength training techniques, including isometric and eccentric training will be implemented. Students will learn how and participate in weight training programs that interact with the other fitness components such as aerobic, interval, plyometric, and flexibility training. Students will gain hands-on experience in advanced training techniques, learn how to manipulate training variables in long-term weight training programming in order to improve various fitness and health goals.',
  },
  {
    course_code: 'PET3640',
    course_name: 'Adapted Physical Education and Sport',
    course_desc:
      'Handicapping conditions and how physical activity is adapted to the special needs of individuals with these conditions.',
  },
  {
    course_code: 'PET3825',
    course_name: 'Educational Gymnastics and Dance',
    course_desc:
      'Provides the physical education major with some fundamental knowledge and abilities of gymnastics, dance and how to teach these two areas. Helps the student understand the contribution of dance and gymnastics to the field of Physical Education.',
  },
  {
    course_code: 'PET3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PET4092',
    course_name: 'Skills and Tactics of Sport',
    course_desc:
      'Skillful performance in games and sports and an understanding of the tactics in those activities. Students will actively participate in a variety of games, create modified games, assess game performance, and apply tactical skills.',
  },
  {
    course_code: 'PET5708',
    course_name: 'Physical Activity Program Development',
    course_desc:
      'The aim of this course is to examine models and current research related to curriculum and program design in physical activity disciplines. This course will provide students with skills that will enable them to interpret, critique, evaluate, justify, and develop physical activity curricula and programs.',
  },
  {
    course_code: 'PET4310C',
    course_name: 'Mechanics of Human Motion',
    course_desc:
      'Anatomical, mechanical, analytical and functional aspects of human motor performance; emphasis upon analysis of joint actions and mechanical principles and their application to efficient movement. This course focuses on applied biomechanics and skill development for students in the Fitness and Sport Coaching and Physical Education-Teacher Education (PETE) specializations. Material and supply fee will be assessed for integrated lab.',
  },
  {
    course_code: 'PET4434',
    course_name: 'Physical Education in the Elementary School',
    course_desc:
      'Designed to provide a knowledge base so prospective physical education teachers can plan and implement appropriate activities for the elementary school.',
  },
  {
    course_code: 'PET4442',
    course_name: 'Physical Education in the High School',
    course_desc:
      'Designed to provide a knowledge base from which prospective physical education teachers can plan and implement appropriate activities in the high school setting. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'PET4710',
    course_name: 'Special Methods in Physical Education',
    course_desc:
      'Acquaints student with specific methods, problems, and issues involved in teaching physical education in public schools.',
  },
  {
    course_code: 'PET4720',
    course_name: 'Physical Education in the Elementary School',
    course_desc:
      'Designed to provide a knowledge base so prospective physical education teachers can plan and implement appropriate activities for the elementary school. Material and Supply fee will be assessed.',
  },
  {
    course_code: 'PET4730',
    course_name: 'Physical Education in the Middle School',
    course_desc:
      'Designed to provide a knowledge base from which prospective physical education teachers can plan and implement appropriate activities for the middle school student. Emphasis is placed on understanding the progression from middle school to the high school developmental curricula.',
  },
  {
    course_code: 'PET4744',
    course_name: 'Student Teaching in Physical Education',
    course_desc:
      'Fourteen weeks of supervised teaching in a public or private school. Student teaching assignments will be made by application in Teacher Education Student Assessment System. Permission is required.',
  },
  {
    course_code: 'PET4765',
    course_name: 'Theory and Practice of Coaching',
    course_desc:
      'Introduction to coaching as a profession including ethical and legal considerations. Techniques and methods of coaching are explored. Active participation in a coaching internship in a selected sport and permission is required.',
  },
  {
    course_code: 'PET4801',
    course_name: 'Sport Skill Acquisition and Non-Traditional Sports',
    course_desc:
      'This course is designed for future physical education teachers, coaches, sport administrators, recreational specialists, and teachers to address sport pedagogy and skill acquisition.  Students will engage in teaching/coaching activities using non-traditional sports, games, and activities to provide movement experiences. Students are expected to participate in the class by teaching, coaching, practicing, and applying skill progression concepts while learning sport skills.',
  },
  {
    course_code: 'PET4820',
    course_name: 'Physical Education and Activities for Adolescents',
    course_desc:
      'Designed to provide a knowledge base and methodology from which prospective physical education teachers, coaches and fitness specialists can plan and implement appropriate physical education, health and movement activities for adolescents.',
  },
  {
    course_code: 'PET4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PET4926',
    course_name: 'Practicum I: Elementary School Physical Education',
    course_desc:
      'Students will complete 30 hours of practical observation in elementary school level physical education.   A minimum of three hours per week will be spent observing in the assigned school setting.  Completion of first two levels of Physical Education Teacher Education transition criteria must be met before assignment.  Application for school assignment must be made in the Teacher\nEducation Student Assessment System by the specified deadline.  Contact your advisor for confirmation of this deadline.',
  },
  {
    course_code: 'PET4927',
    course_name: 'Practicum II: Middle School Physical Education',
    course_desc:
      'Students will complete 30 hours of practical observation in middle school level physical education.   A minimum of three hours per week will be spent observing in the assigned school setting.  Completion of first two levels of Physical Education Teacher Education transition criteria must be met before assignment.  Application for school assignment must be made in the Teacher Education Student Assessment System by the specified deadline.  Contact your advisor for confirmation of this deadline.',
  },
  {
    course_code: 'PET4928',
    course_name: 'Practicum III: High School Physical Education',
    course_desc:
      'Students will complete 30 hours of practical observation in high school level physical education.   A minimum of three hours per week will be spent observing in the assigned school setting.  Completion of first two levels of Physical Education Teacher Education transition criteria must be met before assignment.  Application for school assignment must be made in the Teacher Education Student Assessment System by the specified deadline.  Contact your advisor for confirmation of this deadline.',
  },
  {
    course_code: 'PET4940',
    course_name: 'Internship',
    course_desc:
      'Placement in an appropriate agency or organization for the purpose of gaining some experience in the field. Faculty and agency personnel will supervise the student as the student participates in a wide range of services available in the setting. Goals and objectives will be planned by the student, instructor and agency supervisor. Reports will be required on a regular basis with a final report and oral interview. Permission is required.',
  },
  {
    course_code: 'PET4948',
    course_name:
      'Physical Education and Coaching Field Experience with PK - 12',
    course_desc:
      'Students will complete practical observations, field experiences and will teach and/or coach various age levels and abilities of children in the PK - 12 setting.',
  },
  {
    course_code: 'PET5701',
    course_name: 'Systematic Observation in Sport and Physical Activity',
    course_desc:
      'Students will learn to use a systematic approach to observe  participants during teaching, coaching, and training. Emphasis will be on using published systematic observation instruments and the development of new instruments as objective tools for observation.',
  },
  {
    course_code: 'PHC4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PET5709',
    course_name: 'Advanced Physical Activity Program Development',
    course_desc:
      'This course will assist students in developing knowledge and skills in the development of health supportive physical activity programs. This course will provide students with skills that will enable them to examine, evaluate, and create physical activity curricula and programs using health as a focus.',
  },
  {
    course_code: 'PET5805',
    course_name: 'Analysis and Supervision in Sport and Physical Activity',
    course_desc:
      'This course prepares students to analyze and supervise teaching, training, and quality in physical activity disciplines.',
  },
  {
    course_code: 'PET5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PET6015',
    course_name: 'Professional Issues in Physical Activity Disciplines',
    course_desc:
      'This course will assist students in understanding professional issues and concerns that are inherent parts of physical activity professions and to apply that understanding to professional participation and service contributions. Students will analyze and evaluate online professional information, critically analyze physical activity problems, critique and debate complex ethical problems within the field of physical activity, and articulate a sound philosophy for physical activity leadership.',
  },
  {
    course_code: 'PET6223',
    course_name: 'Teaching and Motivation for Physical Activity Leaders',
    course_desc:
      'This course will lead students through the exploration of sport psychology research, particularly in areas that connect psychology and physical activity behavior.  Students will connect theory to practice by integrating research and theory into logical coaching and teaching frameworks.  Additional content will focus on how training actions impact performance and motivation.',
  },
  {
    course_code: 'PET6706',
    course_name: 'Analysis of Research in Physical Activity Disciplines',
    course_desc:
      'The purpose of this course is to introduce students to various streams of research in physical activity domains and help them understand and critically analyze the quality of that research and its influence on professional activity.',
  },
  {
    course_code: 'PET6707',
    course_name: 'Advanced Research Procedures',
    course_desc:
      "This course is designed to develop the student's proficiency in conducting independent, original research.  This includes protecting research participants, modifying research goals, communicating rationales for changes in a study, collecting data, analyzing statistical data, and advanced scholarly writing.",
  },
  {
    course_code: 'PET6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PET6950',
    course_name: 'Project in Lieu of Thesis',
    course_desc:
      'The project in lieu of thesis is a project or activity that makes a significant contribution to the field(s) associated with physical education and human performance fields. Project ideas will be conceptualized and organized by the student and the course instructor. There is no set format and guidelines for each individual project will be determined by the nature of the topic and the guidance of the instructor. Students will be guided toward project completion over two semesters.',
  },
  {
    course_code: 'PET7003',
    course_name: 'Advanced Theoretical Models of Health and Physical Education',
    course_desc:
      'Provides the student with knowledge of common theoretical models used in health and physical education and the skills to use the theories in practice.',
  },
  {
    course_code: 'PET7516',
    course_name:
      'Advanced Assessment and Evaluation in Health and Physical Education',
    course_desc:
      'Prepares doctoral students to assess student learning in PreK-12 and higher education settings and to conduct effective program evaluations.',
  },
  {
    course_code: 'PET7774',
    course_name: 'Models of Teaching in Physical Education and Health',
    course_desc:
      'Provides theory and practice in teaching strategies designed to facilitate learner achievement in the cognitive, effective, and psycho motor domains.',
  },
  {
    course_code: 'PGY2401C',
    course_name: 'Photography as Art Form: Basic Camera',
    course_desc:
      'Basic theory and practice of black and white photography as an art form. Emphasis on understanding the technical aspects of the camera and exploring its potential as an artistic tool. The development of basic techniques and aesthetic concerns in relation to the photographic image. Includes basic darkroom experience. Invites all students. Material and supply fee will be assessed.',
  },
  {
    course_code: 'PGY2801C',
    course_name: 'Digital Imaging',
    course_desc:
      'This course emphasizes the aesthetic, technical, and conceptual practices of image making using digital media. In the class, students will examine how to perceive, communicate and make digital images in visual culture. This class emphasizes an experimental and conceptual approach to digital image making. Students will be challenged to develop their own visual language and to create unique aesthetic and conceptual experiences to communicate with viewers. This class will consist of lectures, software demonstrations, digital camera demonstrations, studio lighting demonstrations, image making exercises, projects, and readings. Students are evaluated based on their contribution to class discussions, critiques, and their aesthetic, technical, and conceptual development in regards to their digital image making practices.',
  },
  {
    course_code: 'PGY3152C',
    course_name: 'Photography for Non-Majors',
    course_desc:
      'This class teaches the basic theory and practices of photography for the non-art major. Students will learn about the history of photography, the camera, analog and digital photographic practices, and how to create their own cameras. Through lecture, discussion, and hands-on experience, students will learn how to communicate complex ideas through photography. Non-art students will be exposed to, and learn how to express themselves through photography. This class will deepen students creative thinking, communication, and knowledge of the visual world around them.',
  },
  {
    course_code: 'PGY3420C',
    course_name: 'Photo Art II',
    course_desc:
      'Development of advanced techniques and concerns in relation to the black and white photographic image. Emphasis on exploration as a means of creative artistic expression. Material and supply fee will be assessed.',
  },
  {
    course_code: 'PGY3500C',
    course_name: 'Photographic Imaging as an Art Form',
    course_desc:
      'Theory and practice of black and white photography as an art form. Emphasis on understanding the technical aspects of the camera and exploring its potential as an artistic tool. The development of techniques, aesthetic concerns, and teaching methodology in relation to the photographic image. Includes darkroom lab experience. For art education students. Material and supply fee will be assessed.',
  },
  {
    course_code: 'PGY3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PHH3100',
    course_name: 'Greek Philosophy',
    course_desc:
      'Development of ancient Greek philosophy; pre-Socratic, Plato, Aristotle and Hellenistic philosophy.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'PGY4104C',
    course_name: 'Creative Darkroom',
    course_desc:
      'In-depth exploration of the use of darkroom techniques, procedures, and manipulations as an artistic means to the development of advanced techniques and aesthetic concerns in relation to the altered photographic image. Material and supply fee will be assessed.',
  },
  {
    course_code: 'PGY4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PGY4940C',
    course_name: 'Photography: Personal Directions',
    course_desc:
      "Fosters the development of personal expression within the framework of black-and-white photography as an art form. Covers advanced camera and darkroom techniques, as appropriate to the individual's direction. Material and Supply fee will be assessed.",
  },
  {
    course_code: 'PHC2082',
    course_name: 'Informatics and Your Health',
    course_desc:
      'Multi-disciplinary exploration of the nature of information - how it is represented, processed, shared, preserved, and protected in tools and applications directly linked to your health and the health of our planet. Identifies enduring principles; examines impacts on individuals and society; provides practice with a variety of digital technologies and data collection strategies; addresses interpreting results of and concerns in human subject research. This course helps students develop integral professional and technical skills, including presentation of ideas through written and verbal communication, within an informatics framework. Students will have the opportunity to focus on a particular technology company or issue as a mechanism for developing critical thinking and teamwork skills. Meets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'PHC3767',
    course_name: 'Globalization and Public Health',
    course_desc:
      'The course examines the role of globalization in the burden of disease and global cooperation in development of interventions that promote health and avert transmission of transboundary pathogens across national boundaries and continents. The course will discuss the role of multinational and bilateral global collaborations for addressing health issues that cross national borders. The emerging threats require consistent multinational approaches and an informed public health workforce at all levels of practice. The course will use case studies to examine the impact of globalization on human health.',
  },
  {
    course_code: 'PHC4024',
    course_name: 'Applied Research Methods in Public Health',
    course_desc:
      'In this applied course, students will learn how to conduct and interpret research in population health and disease, building on their knowledge from epidemiology and biostatistics and other content areas in public health. The course will provide skills in critically reading the literature related to public health-related research, developing a research question and a testable hypothesis, creating an analysis plan, and dissemination of results in paper and digital modes. The course will cover quantitative and qualitative research methods commonly used in public health research and practice.',
  },
  {
    course_code: 'PHC4101',
    course_name: 'Essentials of Public Health',
    course_desc:
      "Course teaches basic terms and definitions of public health and the factors leading to disease causation as well as disease prevention. Students study programs and policies that effect healthcare in a positive manner and apply basic principles of scientific reasoning with the use of available data and information. Topics introduced serve as a basis for enhancing the participants' ability to critically evaluate current trends in healthcare and develop programs and policies in an analytical manner.",
  },
  {
    course_code: 'PHC4109',
    course_name: 'Diseases in Human Populations',
    course_desc:
      'An overview of scientific principles of public health and their application to public health problems with significant state, national, and international impact. It is recommended that students have at least one semester of a college science such as biology or a comparable course before enrolling.',
  },
  {
    course_code: 'PHC4140',
    course_name: 'Public Health Planning and Analysis',
    course_desc:
      "This course introduces students to the history of public health, the structure of the public health system and the various sectors of public health practice, in order to gain an understanding of the complex factors that determine the health status of a community. Lectures will draw from the public health field, but also related disciplines such as behavioral sciences, healthcare management, medical ethics, and social work. National, state, and local level practices will be analyzed, as well as the role that law and government play in the public's health. The course is also intended to simulate student interest in other public health courses and program offerings. Graduate students will be assigned additional work.",
  },
  {
    course_code: 'PHC4340',
    course_name: 'Fundamentals of Industrial Hygiene',
    course_desc:
      'An online-multidisciplinary approach to the study of industrial hygiene intended for a wide range of health related professionals. Recognition, evaluation and control of environmental or occupational hazards. Insight into the management of occupational health hazards and diseases that can be leveraged in a professional practice. Offered concurrently with PHC5356; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PHC4341',
    course_name: 'Fundamentals of Occupational Safety and Health',
    course_desc:
      'Concerns worker protection and serves as a prerequisite for advanced study of hazards and work settings. Development and management of occupational safety and health programs, resolution of safety and health issues, and improvement of safety performance. Introduction to safety and health fields, overview of loss control information and analysis, specific safety and health programs, and program implementation and maintenance. Offered concurrently with PHC5355; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PHC4363',
    course_name:
      'Occupational Safety and Health in the Health Care Environment',
    course_desc:
      'A multidisciplinary approach to the study of occupational safety and health in health care with researcher and practitioner perspectives. Programs and applications to health care. Common worker safety hazards and controls are reviewed and safety improvement strategies are presented. Teaches recognition of safety and hazards in health care, relevant safety and health standards requirements, and identification and implementation of safety improvement initiatives. Permission is required. Offered concurrently with PHC5351; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PHC4464',
    course_name: 'Understanding Health Equity and Health Disparities',
    course_desc:
      'This course introduces students to social determinants of health, health equity, and health disparities in the United States. This course provides students with an overview of the societal impacts of racism, poverty, and inequity and the ways these constructs are contributing health disparities among individuals and communities. Students will explore sources of data for health disparities analysis. The course further explores the role of major national stakeholders and programs addressing social determinants of health contributing to disparities and implementing evidence-based strategies for eliminating health inequalities.',
  },
  {
    course_code: 'PHC4930',
    course_name: 'Public Health Seminar',
    course_desc:
      'This public health seminar course presents current topics in the public health field at the local, regional, national, and international levels that may not be taught in traditional public health courses. Students employ critical thinking in analyzing and articulating opposing viewpoints on contemporary public health problem topics.',
  },
  {
    course_code: 'PHC4940',
    course_name: 'Public Health Capstone',
    course_desc:
      'This course provides students with opportunities for practical and experiential high impact practices. The course serves a capstone requirement for undergraduate Public Health majors and is designed to allow students to review, integrate, and apply concepts and methods presented in the foundational core courses.  All students complete a cumulative, integrative, and scholarly, and applied experience or inquiry project that serves as a capstone to the BSPH educational experience. Students develop an ePortfolio documenting their experiential learning. The capstone requirement must be taken in the senior year.',
  },
  {
    course_code: 'PHC5050',
    course_name: 'Biostatistics for Public Health',
    course_desc:
      'This is a second course in biostatistics for students in the graduate Public Health program. The topics include descriptive statistics, probability, standard probability distributions, sampling distributions, point and confidence interval estimation, hypothesis testing, power and same size estimation, one and two-sample parametric and non-parametric methods for analyzing continuous or discrete data, simple linear regression, logistic regression and other multivariate methods. Students will use a statistical software package for data management and statistical analyses. This is a fully online course with its own office hours and discussions. STA2023 or equivalent is a pre-requisite for this course (see UWF Catalog). It is important to have a good understanding of inferential statistics, such as confidence intervals and test of hypotheses (for two samples). Students must have completed STA2023 or equivalent in college.',
  },
  {
    course_code: 'PHC5102',
    course_name: 'Principles of Public Health',
    course_desc:
      "This course introduces students to the history of public health, the structure of the public health system and the various sectors of public health practice, in order to gain an understanding of the complex factors that determine the health status of a community. Lectures will draw from the public health field, but also related disciplines such as behavioral sciences, healthcare management, medical ethics, and social work. National state, and local level practices will be analyzed, as well as the role that law and government play in the public's health. The course is also intended to stimulate student interest in other public health courses and program offerings.",
  },
  {
    course_code: 'PHC5108',
    course_name: 'Monitoring and Evaluation in Global Health',
    course_desc:
      'The course provides students with fundamental frameworks for monitoring and evaluation in global health practice. The course provides an overview of different types of program evaluation, including needs assessment, formative research, process evaluation, monitoring of outputs and outcomes, and impact assessment. Students gain practical experience through a series of case-studies involving the use of a conceptual framework in the design of an evaluation plan, that includes development of indicators, analysis of computerized service statistics, and impact measurement. The course addresses experimental, quasi-experimental, and non-experimental study designs, including the strengths and limitations of these designs in population and global health practice.',
  },
  {
    course_code: 'PHC5123',
    course_name: 'Biological Basis of Public Health',
    course_desc:
      'An overview of scientific principles of public health and their application to public health problems with significant state, national and international impact. It is recommended that students have at least one semester of a college science such as, biology or a comparable course before enrolling.',
  },
  {
    course_code: 'PHC5198',
    course_name: 'Applied Qualitative Research Methods',
    course_desc:
      'The purpose of this course is to provide an introduction and overview of qualitative research methodology. Healthcare and public health professionals not only need to use evidence-based information to guide their practice in clinical, administration, and academic positions, but also need to examine, describe, explain and/or understand phenomena or cultures. Using qualitative methods, the researcher can create solutions to practical problems and contribute to the evidenced-based practice literature.  This course will introduce the students to the basic principles of qualitative research and will allow them to understand the steps of the qualitative research process.',
  },
  {
    course_code: 'PHC5351',
    course_name:
      'Occupational Safety and Health in the Health Care Environment',
    course_desc:
      'This course offers a multidisciplinary approach to the study of occupational safety and health in healthcare with researcher and practitioner perspectives. Common worker safety hazards and controls are reviewed and safety improvement strategies are presented. The course promotes the recognition of safety and hazards in healthcare, relevant safety and health standards requirements, and identification and implementation of safety improvement initiatives. Offered concurrently with PHC4363; graduate students will be assigned additional work to include a semester project.',
  },
  {
    course_code: 'PHC5355',
    course_name: 'Fundamentals of Occupational Safety and Health',
    course_desc:
      'The course covers worker safety and protection regulations and procedures, and serves as a prerequisite for advanced study of hazards commonly found in workplace settings. Additional topics include development and management of occupational safety and health programs, resolution of safety and health issues, and improvement of safety performance. Students will receive an introduction and overview of safety and health fields, loss control information and analysis, specific safety and health programs, and program implementation and maintenance. Offered concurrently with PHC4341; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PHC5356',
    course_name: 'Fundamentals of Industrial Hygiene',
    course_desc:
      'An on-line multidisciplinary approach to the study of industrial hygiene intended for a wide range of health related professionals. Recognition, evaluation and control of environmental or occupational hazards. Insight into the management of occupational health hazards and diseases that can be leveraged in a professional practice. Offered concurrently with PHC4340; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PHC5410',
    course_name: 'Social and Behavioral Sciences in Public Health',
    course_desc:
      'Covers behavioral and social science contributions to science disciplines, including psychology, sociology, and anthropology, will be reviewed and integrated with public health objectives and outcomes. Using a biopsychosocial framework, the role of social, psychological, and behavioral factors in health and illness are emphasized.',
  },
  {
    course_code: 'PHH3400',
    course_name: 'Modern Philosophy',
    course_desc:
      'Development of modern philosophy from Renaissance through 18th century; Descartes, Locke, Berkeley, Hume, Spinoza, Leibniz and Kant.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'PHC5442',
    course_name: 'Global Health',
    course_desc:
      'The course will introduce students to the main concepts of the public health field and the critical links between global health and social and economic development. Students will get an overview of the determinants of health, and how health status is measured.  Students will also review the burden of disease, risk factors, and key measures to address the burden of disease in cost-effective ways.  The course will review specific topics related to the most important communicable and non-communicable diseases as well as issues related to food distribution, reproductive health and other global major health concerns with an important focus on low- and middle-income countries and on the health of the poor. We will also discuss cross-cutting global health issues such as poverty and equity, human rights and ethical issues in public health; globalization and health and complex emergencies.',
  },
  {
    course_code: 'PHC5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PHC6000',
    course_name: 'Epidemiology for Public Health Professionals',
    course_desc:
      'This foundational course covers the application of epidemiologic procedures to the understanding of the occurrence and control of conditions such as infections and chronic diseases, mental disorders, community, and environmental health hazards, accidents, and geriatric problems in human populations. The course is critical to developing student competency in the foundational and practical utilities of epidemiology as a tool for disease surveillance and outbreak investigations, disease prevention and treatment. Part of the Master of Public Health degree program.',
  },
  {
    course_code: 'PHC6003',
    course_name: 'Chronic Diseases Epidemiology',
    course_desc:
      'The course is designed to give the student current and comprehensive information on the epidemiology, etiology, pathogenesis, risk factors and preventive measures of common chronic diseases at the population level. The course will cover selected topics in chronic disease with an emphasis on disease occurrence in the United States, Florida and the current status of local research projects.',
  },
  {
    course_code: 'PHC6005',
    course_name: 'Urbanization and Population Health',
    course_desc:
      'The course focuses on the impact of urbanization and the transmission of disease-causing organisms, as well as the interaction between human behavior and environmental changes on population health. Factors such as overcrowding, access to quality housing, modernized urban amenities, lifestyle choices and sanitation(WASH) contribute to the spread of disease in urban areas in developed and low-to-middle income countries.',
  },
  {
    course_code: 'PHC6015',
    course_name: 'Epidemiological Research Designs and Methods',
    course_desc:
      'The course covers research design and methods commonly used in epidemiology and public health research. The course covers both quantitative and qualitative research designs, including, observational, quasi-experimental, and experimental designs used in epidemiological investigations.  Methods for reliable and valid data collection and analysis will be covered. Common statistical methods for the analysis of public health data are discussed.',
  },
  {
    course_code: 'PHC6110',
    course_name: 'Comparative Health Systems',
    course_desc:
      "This course will cover the major models for provision and financing of healthcare used around the world today. The historical development of these models will be traced, and the societal values and other factors underlying countries' choice of healthcare systems and policies will be examined. Students will learn to analyze the advantages and disadvantages of various ways of organizing and financing healthcare and to evaluate health policies according to a range of criteria for cost, quality, and equity.",
  },
  {
    course_code: 'PHC6150',
    course_name: 'Public Health Policy',
    course_desc:
      'The course explores general principles of planning, management, and evaluation of health care programs, policies and interventions implemented by public and private organizations. The goal of the course is to ensure a broad understanding of critical issues concerning the organization, delivery, and financing of public health and health care in the United States and examines the role of private, community-based organizations, federal, state, and local governments in ensuring healthy communities. The basic conceptual frameworks underlying healthcare decision making and assessment of the financing, organization, outcomes and delivery of healthcare services are presented.',
  },
  {
    course_code: 'PHC6194',
    course_name: 'GIS Applications in Public Health',
    course_desc:
      'An online course providing hands-on training in the use of geographic information systems for public health-related data. Students will complete projects covering the collection, analysis, and visualization of spatial data using both public domain and commercial software tools supporting geospatial data. Through a set of focused case studies, students will learn the basic features and limits of each tool, as well as interoperability with other GIS software products (both public domain and commercial packages). Part of the Master of Public Health degree program.',
  },
  {
    course_code: 'PHC6196',
    course_name: 'Applied Data Analysis in Public Health',
    course_desc:
      'This course provides an overview of computer applications software for public health and health-related data. Fundamentals of data collection, data mining, statistical analysis, interpretation, and reporting of results are covered. Students gain hands-on experience in data management and analysis using real-world public health and health-related data. Enrollment in this course assumes a basic understanding of statistical reasoning and epidemiological experience. Note: Ideally students must have successfully completed PHC6000, PHC6300, PHC5410, and PHC5050 or equivalents before enrolling in this course.',
  },
  {
    course_code: 'PHC6251',
    course_name: 'Disease Surveillance and Monitoring',
    course_desc:
      'Disease surveillance and monitoring is the systematic collection, analysis, interpretation, and dissemination of data for use in prioritizing, planning, implementing, and evaluating health programs, activities and practices in the United States as well as in other developed and developing countries. We will focus on these fundamental processes and procedures which are utilized to investigate and track infectious and communicable diseases as well as non-infectious chronic diseases. The course will highlight the importance of designing and reporting quantitative and qualitative contents in disease surveillance.',
  },
  {
    course_code: 'PHC6300',
    course_name: 'Environmental Health',
    course_desc:
      'This foundational pubic health course provides a broad overview of the relationship between humans and their environment, and of the efforts to prevent or mitigate environmental threats. Students will be given an overview of the chemical, physical, and biological hazards present in our living and working environment and their effects on human health. The course is designed to acquaint students with the scientific and technical foundations of population health and examines both the practice of environmental health and problems addressed public health practitioners.',
  },
  {
    course_code: 'PHI6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PHC6310',
    course_name: 'Environmental Toxicology',
    course_desc:
      'Environmental toxicology is the study of the effects of toxic substances on health and the environment. The student will recognize that human survival depends upon the well-being of other species and upon the availability of clean air, water, and food; and anthropogenic, as well as naturally occurring, chemicals can have detrimental effects on living organisms and ecological processes. Concepts to be covered include occurrence of toxicants, damage process and action of toxicants, factors affecting zenobiotic action, defense responses to toxicants, and others. Will also examine chemicals of environmental interest and how they are tested and regulated. Case studies and special topics will be examined.',
  },
  {
    course_code: 'PHC6347',
    course_name: 'Aerospace and Occupational Toxicology',
    course_desc:
      'Part of the MPH program for military Residents in Aerospace Medicine.',
  },
  {
    course_code: 'PHC6360',
    course_name: 'Accident Investigation and Risk Managament',
    course_desc:
      'Accident Investigation & Risk Management includes an aerospace safety overview, biomechanics of impact, restraint systems, crew protection, and crew escape concepts, aviation and space vehicle crashworthiness, aerospace injury mechanisms, conduct of an accident investigation, forensic concepts, legal issues, and promoting prevention strategies to avoid future accidents.  Students in MPH degree program, and need special permission from instructor.',
  },
  {
    course_code: 'PHC6670',
    course_name: 'Ethical Issues in Global Health',
    course_desc:
      'The purpose of this course is to provide an overview of major ethical principles and theories applied to global health, and how culture influences ethical decision-making in health resource allocation. Students will examine some of the primary theories and principles in global health practice and research ethics including virtue, deontology, utilitarian, autonomy, justice, beneficence, and nonmaleficence. The course explores prominent global health issues to build greater knowledge and understanding of global health ethics as a vital tenant of effective decision-making to promote optimal health. Topics will address broad ethical issues related to pandemic preparedness, ethical human subject research in developing countries, human rights, gender based violence, resource allocation, and the effects of globalization on health and quality of life within countries.',
  },
  {
    course_code: 'PHC6676',
    course_name: 'Public Health Response in Humanitarian Emergencies',
    course_desc:
      'This course provides an overview of the types of humanitarian emergencies and their public health significance.  Students explore the public health impact of emergencies and disasters in low-to-middle income countries. Students are introduced to population health needs assessment during emergencies and key indicators needed for timely response and mitigation. Emphasis is placed on the coordination among local, regional, national, governmental, and non-governmental organizations in the delivery of public health services.',
  },
  {
    course_code: 'PHC6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PHC6945',
    course_name: 'Internship in Public Health I',
    course_desc:
      'This course is an internship in a public health agency or setting. It is completed under the supervision of an adjunct or full-time faculty member teaching in the UWF MPH program and an approved preceptor. The student will work on a problem related to management, development or administration of a program in public health or related to research in public health. A written report on the internship experience is required, along with a an oral presentation before a committee of MPH faculty. The course is graded on a Satisfactory / Unsatisfactory scale. Permission is required.',
  },
  {
    course_code: 'PHC6946',
    course_name: 'Internship in Public Health II',
    course_desc:
      'This is the second of a two course sequence. In the second course the student develops a project report based on practical activities completed during PHC6946: Internship in Public Health I and be making satisfactory progress in the course. This is done under the supervision by an adjunct or full-time faculty member teaching in the UWF MPH program and an approved preceptor. The student develops the report on the internship experience and presents the project report, including a virtual poster before a committee of MPH faculty. Students can only register for Internship II in the last semester of enrollment. The student must Graded on a satisfactory / unsatisfactory basis only.',
  },
  {
    course_code: 'PHC7011',
    course_name: 'Advanced Epidemiological Methods',
    course_desc:
      'This doctoral-level applied methodology course is designed for students in the Doctor of Public Health Program. The advanced epidemiology course provides students with the skills and knowledge of special techniques in epidemiological practice, including measurement error, missing data, and intermediate variables. The course is project based and relies on real local population data for informed public health practice.',
  },
  {
    course_code: 'PHC7467',
    course_name: 'Behavioral Health Intervention Strategies',
    course_desc:
      'This course is designed for advanced students in population health science to provide them competencies and skills needed to conceptualize, develop, implement and evaluate theory-based programs that influence health-related behaviors. It builds on the content from PHC5410 in the foundational core courses.',
  },
  {
    course_code: 'PHC7704',
    course_name: 'Community Participatory Research for Health',
    course_desc:
      'This course provides an overview of Community Participatory Research (CPR) approach as a framework for understanding and addressing population health, including health disparities solutions at the community level. Community participatory research (CPR) is a widely accepted collaborative approach to research that works to understand and protect public health by involving all partners in the research process. Students will apply integrated models and strategies for working with communities and community organizations in promoting health and wellness.',
  },
  {
    course_code: 'PHC7710',
    course_name: 'Qualitative Research Methods and Applications',
    course_desc:
      'The purpose of this course is to provide an introduction and overview of qualitative research methodology. Public health professionals and health-related social scientists need to use evidence-based information to guide their practice in health promotion and program planning. Using qualitative methods, the researcher can create solutions to practical problems and contribute to the evidence-based practice literature. This course will introduce the students to the basic principles of qualitative research and will allow them to understand the steps of the qualitative research process.',
  },
  {
    course_code: 'PHC7944',
    course_name: 'Doctoral Public Health Practicum',
    course_desc:
      'The course is a field internship experience in public health agency or work site setting under the supervision of preceptor and university graduate faculty. Requires a significant project proposal approved by public health instructor and a final report. The practicum is designed to provide Dr.PH students with the opportunity to integrate the knowledge and skills developed during their academic program in a structured, supervised, real-world professional setting under the direction of a site supervisor in a public health or social service agency.',
  },
  {
    course_code: 'PHH4200',
    course_name: 'Medieval Philosophy',
    course_desc:
      'History of medieval philosophy from Augustine to Ockham, including such issues as the existence of God, the problem of evil, free will and the nature of human knowledge.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'PHH4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PHH6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PHI1905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PHI2010',
    course_name: 'Introduction to Philosophy',
    course_desc:
      'Nature of philosophical thinking, discussion of fundamental and perennial problems of philosophy.\nMeets General Education requirement in Humanities.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'PHI2103',
    course_name: 'Critical Thinking',
    course_desc:
      'This course will introduce students to the fundamentals of critical thinking, argument, conceptual analysis and evidence. Students will learn how to think critically, read actively, and write persuasively across a variety of contexts. Appropriate for and applicable to any major.\nMeets General Education requirement in Humanities.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'PHI2603',
    course_name: 'Ethics in Contemporary Society',
    course_desc:
      'Explores the fundamental problems of Western ethics, the classical and Judeo-Christian traditions, modern ideals of the good for the individual business, politics and the environment.\nMeets General Education requirement in Humanities.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'PHI3130',
    course_name: 'Modern Logic',
    course_desc:
      'Training and skills of modern symbolic logic and their application to evaluation of arguments. Propositional logic, predicate logic.',
  },
  {
    course_code: 'PHI3320',
    course_name: 'Philosophy of Mind',
    course_desc:
      'Introduces and examines proposed theories, from philosophy as well as the brain and behavioral sciences, regarding various aspects of the mind-body problem: mental representation, consciousness, mental imagery, innateness, the language of thought and the computer model of the mind, etc.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'PHI3400',
    course_name: 'Philosophy of Science',
    course_desc:
      'Concepts and types of explanation used in sciences. May include differences between natural and social sciences, inductive reasoning and scientific explanation, and relation of science to society.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'PHI3452',
    course_name: 'Philosophy of Biology',
    course_desc:
      'Philosophy of biology focuses on evolutionary theory, examining such questions as "what is a gene", "what does natural selection select" and "what are the moral/social implications of evolutionary theory"?\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'PHI3500',
    course_name: 'Metaphysics: Furniture of the Universe',
    course_desc:
      'Metaphysics is the study of everything. Hence this course is about all the stuff in the universe, and perhaps even some stuff not in the universe. It would probably be fair to say that metaphysics is concerned with identifying what the furniture of the universe is. Additionally, metaphysicians worry about not just what the actual furniture of the universe is, but what are the possible kinds of furniture that may populate the universe. Metaphysics also seeks to uncover the fundamental principles that govern reality (and possible "realities"). Due to the vastness of the domain of metaphysical topics, we will restrict our attention to a small sample of topics-ones that are, or should be, near and dear to us for they bear on our lives as citizens of the universe. For example, do you have free will? Do you have a mind? Do numbers exist? Is time travel possible? What is time, anyway? Are there naturally occurring categories of stuff in the universe? Could the world have turned out differently than it did? A well rounded background in philosophy includes, among other things, conversance with central topics in metaphysics; this course aims to provide just that. Offered Fall and Spring semester only.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'PHI3640',
    course_name: 'Environmental Ethics',
    course_desc:
      'Introduces students to issues and problems in the field of environmental ethics. Theories of value are investigated in the effort to clarify the interrelations between humanity and nature. Discussions concerning the moral status of the non-human community will not be restricted to debates over value theory alone, but will also encompass metaphysical issues that bear upon environmental problems.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'PHI3670',
    course_name: 'Ethics',
    course_desc:
      'Philosophical theories concerning nature of the good, moral obligation, human excellence and application of ethical theory to problems of the individual in relation to society.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'PHI3700',
    course_name: 'Philosophy of Religion',
    course_desc:
      'Problem of religious language. Arguments for atheism and existence of God. Phenomenology of religious experience. Problems of evil and nature of God. Theories of immortality.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'PHI3790',
    course_name: 'African Philosophy',
    course_desc:
      'This course examines historical developments and trends in African philosophy. It offers an opportunity for integrative reflection on issues covered in philosophy and the shape they take in a concrete African historical context. Distinctive areas in philosophy covered include logic, epistemology, metaphysics, ethics, religion, and political thought.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'PHI3800',
    course_name: 'Philosophy of Art',
    course_desc:
      'Creative process-artist and percipient. Various art forms: painting, sculpture, architecture, literature, theatre, music. Theories of evaluation. Artist and community; commercialism, propaganda and pornography.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'PHI3880',
    course_name: 'Philosophy of Film',
    course_desc:
      'Investigates the major theoretical and conceptual issues surrounding the art of film. Philosophical concepts underlying film theories such as realism, formalism, hermeneutics, and structuralism will be examined and applied to cinematography, editing, sound, and mise en scene. Other conceptual issues may include perception, representation, narrative, and ideology.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'PHI3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PHI4300',
    course_name: 'Theory of Knowledge',
    course_desc:
      'Various theories of relation between human knowledge and reality; empirical, rationalistic, linguistic and phenomenological.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'PHI4633',
    course_name: 'Biomedical Ethics',
    course_desc:
      'Designed to introduce students to the moral and conceptual foundations of ethics, to various ways of analyzing selected problems in the field, and applications of various theories to the professions.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'PHI4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PHI5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PHY1020',
    course_name: 'Conceptual Physics',
    course_desc:
      'An introductory course in physics designed for non-science majors, emphasizing topics relevant to everyday life. The course focuses on major physical discoveries and their implications for the world around us.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'PHY2048',
    course_name: 'Calculus-Based Physics I',
    course_desc:
      'Physics with Calculus I is the first of a two-semester sequence of calculus-based physics topics for scientists and engineers. The principal subject of this course is mechanics, the science of motion. The topics covered will be the kinematics and dynamics of particles and rigid bodies, conservation laws and principles, gravity, and oscillations.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'PHY2048C',
    course_name: 'Calculus-Based Physics I Studio',
    course_desc:
      'Physics with Calculus I Studio is the first of a two-semester sequence of calculus-based physics topics for scientists and engineers. The principal subject of this course is mechanics, the science of motion. The topics covered will be the kinematics and dynamics of particles and rigid bodies, conservation laws and principles, gravity, oscillations and waves.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'PHY2048L',
    course_name: 'Calculus-Based Physics I Lab',
    course_desc:
      'Selected experiments in mechanics, oscillatory motion, and heat.\nSatisfies Florida Common Core Natural Sciences requirement.',
  },
  {
    course_code: 'PHY2049',
    course_name: 'Calculus-Based Physics II',
    course_desc:
      'Continuation of PHY2048. Electrostatics and magnetism; basic electric circuits; optics; selected topics in modern physics.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'PHY2049L',
    course_name: 'Calculus-Based Physics II Lab',
    course_desc: 'Selected experiments in optics, electricity, and magnetism.',
  },
  {
    course_code: 'PHY2053',
    course_name: 'Algebra-Based Physics I',
    course_desc:
      'Algebra-Based Physics 1 is the first of a two-semester sequence of physics topics chosen as an introduction to this science. This is an algebra and trigonometry based physics course. Structure and properties of matter; kinematics, dynamics and statics; momentum and energy; rotation; elasticity; fluids; temperature and expansion, heat transfer, thermal behavior of gases; oscillations; wave motion and sound.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'PHY2053L',
    course_name: 'Algebra-Based Physics I Lab',
    course_desc:
      'Selected experiments in mechanics, oscillatory motion, and heat.',
  },
  {
    course_code: 'PHY2054',
    course_name: 'Algebra-Based Physics II',
    course_desc:
      'Algebra-Based Physics II is the second of a two-semester sequence of physics topics chosen as an introduction to this science. This is an algebra and trigonometry based course.  Light; optics; electricity and magnetism; circuits; elementary quantum theory; atomic, nuclear and particle physics.\nMeets General Education requirement in Natural Sciences.',
  },
  {
    course_code: 'PHY2054L',
    course_name: 'Algebra-Based Physics II Lab',
    course_desc: 'Selected experiments in optics, electricity, and magnetism.',
  },
  {
    course_code: 'PHY2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PHY3106',
    course_name: 'Calculus-Based Physics III',
    course_desc:
      'Laws of thermodynamics, wave phenomena, breakdown of classical physics, theory of relativity, quantization of charge, light, and energy, atomic structure.',
  },
  {
    course_code: 'PHY3107',
    course_name: 'Calculus-Based Physics IV',
    course_desc:
      'Special topics in modern physics: quantum mechanics, atomic structure, molecular structure, atomic and molecular spectra, physics of solids, and band structure, nuclear structure, nuclear forces, radioactive decay and nuclear reactions, elementary particles, and fundamental interactions.',
  },
  {
    course_code: 'PHY3220',
    course_name: 'Intermediate Mechanics',
    course_desc:
      'Particle mechanics in 1, 2 and 3 dimensions for various forces. Central forces and celestial mechanics. Systems of many particles. Rigid body dynamics. Introduction to Lagrangian methods.',
  },
  {
    course_code: 'PHY3424',
    course_name: 'Optics',
    course_desc:
      'Geometrical, physical, and modern optics. Polarization, interference, diffraction, holography, and optical fibers. A grade of C- or better is required for all prerequisites.',
  },
  {
    course_code: 'PHY3722C',
    course_name: 'Electronics',
    course_desc:
      'This is an introductory course in electronic design and circuitry with emphasis on common instrumentation. This course has both lecture and laboratory components.',
  },
  {
    course_code: 'PHY3802L',
    course_name: 'Intermediate Physics Lab',
    course_desc:
      'Laboratory work in basic measurements of physical constants; experiments in electronics, modern physics, nuclear physics, optics, and solid state physics.',
  },
  {
    course_code: 'PHY3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PHY4323',
    course_name: 'Electricity and Magnetism I',
    course_desc:
      "Electrostatics, Gauss's Theorem, magnetic fields, Biot-Savart Law, electromagnetic induction, introduction to Maxwell's Equations, and electromagnetic waves. A grade of C- or better is required for prerequisite courses.",
  },
  {
    course_code: 'PHY4325',
    course_name: 'Electricity and Magnetism II',
    course_desc:
      "Continuation of PHY4323 Electricity & Magnetism I. Maxwell's equations and electromagnetic waves in vacuum and in a medium, radiation from dipoles and antennas, transmission lines, wave guides, relativistic electrodynamics, Lienard-Weichert Potentials. A grade of C- or better in prerequisite courses is required.",
  },
  {
    course_code: 'PHY4445',
    course_name: 'Lasers and Applications',
    course_desc:
      'Introduction to lasers and applications covering topics on nature of light, photons, elements of semi-conductor physics, modulation of light, displays, laser principles, types of lasers and their design, photodetectors, fiber optics, optical communications. A grade of C- or better is required for all prerequisite courses.',
  },
  {
    course_code: 'PHY4513',
    course_name: 'Thermal and Statistical Physics',
    course_desc:
      'Laws of thermodynamics and their application to simple systems, kinetic theory of gases, introduction to the classical and quantum statistical mechanics of weakly interacting systems.',
  },
  {
    course_code: 'PHY4604',
    course_name: 'Quantum Theory I',
    course_desc:
      'This is the first semester of a two semester undergraduate level course covering the theory of quantum mechanics.  This theory is the foundations of modern physics and is an introduction to the main concepts and tools for applying quantum mechanics to a variety of different problems.',
  },
  {
    course_code: 'PHY4605',
    course_name: 'Quantum Theory II',
    course_desc:
      'This is the second semester of a two semester undergraduate level course covering the theory of quantum mechanics.  This theory is the foundations of modern physics.  This course emphasizes the application of quantum mechanics to a variety of problems. Offered Spring semester only.',
  },
  {
    course_code: 'PHY4822L',
    course_name: 'Advanced Physics Lab',
    course_desc:
      'Advanced laboratory topics are treated.  Modern physics laboratory equipment is used to introduce students to current laboratory practices.',
  },
  {
    course_code: 'PHY4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PHY4910',
    course_name: 'Undergraduate Research',
    course_desc:
      'Undergraduate experimental or theoretical research under the direction of physics faculty.',
  },
  {
    course_code: 'PHY5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PHZ3108L',
    course_name: 'Physics Skills',
    course_desc:
      'A professional development course for students in physics. Introduction to necessary skills for upper division physics courses, including problem solving strategies, reading and interpretation of scientific papers, LaTeX, critical thinking, resumes, and communication of physics.',
  },
  {
    course_code: 'PHZ3151C',
    course_name: 'Introduction to Scientific Computing',
    course_desc:
      'Scientific computation relevant to science, mathematics, and engineering, with emphasis on the process of modeling, simulation, visualization, and evaluation.',
  },
  {
    course_code: 'PHZ3400',
    course_name: 'Phenomena in Condensed Matter Physics',
    course_desc:
      'This course is intended to introduce students to the basic phenomena and concepts related to condensed matter systems. It will cover structural, thermal, electrical, magnetic, and optical properties of solids and the experimental methods used to study these properties.',
  },
  {
    course_code: 'PHZ4113',
    course_name: 'Mathematical Physics I',
    course_desc:
      'Algebra of complex numbers, Taylor series, linear algebra, vector algebra and calculus, and curvilinear coordinates. A grade of C or better is required for prerequisite courses.',
  },
  {
    course_code: 'PHZ4114',
    course_name: 'Mathematical Physics II',
    course_desc:
      'This course is an application of mathematical methods to physics in areas including Fourier series, special functions, boundary value problems, partial differential equations, series solutions, and integral transforms. A grade of C- or better is required for prerequisite courses.',
  },
  {
    course_code: 'PLA2013',
    course_name: 'Survey of American Law',
    course_desc:
      'Study of American law, focusing on why there are laws, as well as who makes and enforces the laws. Covers what is commonly known as "everyday law," that is, how law affects us in our daily lives.  This course surveys the main areas of procedural and substantive law and provides an overview of the practice of law.\nMeets General Education requirement in Social Sciences.',
  },
  {
    course_code: 'PLA3020',
    course_name: 'Law and Society',
    course_desc:
      'Exploration of the evolution of laws in the American legal system related to complex social issues. Exploration of how the structure of the American legal system responds to diverse and dynamic social structures. Examination of how individual differences affect perceptions of justice and the role of the justice system in American society.',
  },
  {
    course_code: 'PLA3021',
    course_name: 'Law and Film: Fact or Fiction',
    course_desc:
      "Films chosen illustrate the realities of the legal system, the concept of justice, the involvement of various stakeholders in the system and the merit or lack of merit of character's decision-making. Films highlight the practice of law, stakeholders, judicial processes, as well as interactions with society and politics.",
  },
  {
    course_code: 'PLA3106',
    course_name: 'Legal Research and Writing',
    course_desc:
      'Legal Research and Writing introduces the student to the sources, tools and techniques of legal research and writing including, but not limited to, primary and secondary sources covering judicial, legislative and executive branches. Legal Research and Writing is designed to introduce skills needed in order to become proficient in legal research.',
  },
  {
    course_code: 'PLA3240',
    course_name: 'Alternative Dispute Resolution',
    course_desc:
      'Introduction to different alternative dispute resolution (ADR) methods as a means of peacefully communicating with another person regarding a conflict and working together to find a solution in an appropriate manner.',
  },
  {
    course_code: 'PLA3429',
    course_name: 'Contracts and Business Entities',
    course_desc:
      'Overview of contract law, and law related to business entities such as corporations, partnerships, and sole proprietorships.',
  },
  {
    course_code: 'PLA3471',
    course_name: 'Employment Law',
    course_desc:
      'Designed for students interested in the subject of employment law discrimination from many approaches: as a practitioner in the legal field, as an employer, as an advisor to employers, as an employee, or as an advisor to employees. The focus of the course will be on the basic laws of employment discrimination, employee rights, and the means and methods of seeking the protections of those laws, and the means and methods of employers assuring compliance with the laws.',
  },
  {
    course_code: 'PLA3583',
    course_name: 'Cyber Law',
    course_desc:
      'Examines legal aspects of the law related to the Internet, including intellectual property rights, online jurisdictional issues, privacy and the first amendment in an online world.  Domain name rights, and e-commerce will be explored.',
  },
  {
    course_code: 'PLA3613',
    course_name: 'Property Law and Transactions',
    course_desc:
      'Covers contracts for the sale of land, forms, or real estate ownership, steps involved in a real estate transaction, drafting of leases, purchases, and sales agreements, drafting of mortgages and notes, drafting of deeds, preparing and executing a complete real estate closing and preparing a title search and real estate abstract.',
  },
  {
    course_code: 'PLA3703',
    course_name: 'The Legal System and Ethics',
    course_desc:
      'Students will explore ethics as it relates to attorney/paralegal conduct in legal systems in the United States.',
  },
  {
    course_code: 'PLA3806',
    course_name: 'Family Law',
    course_desc:
      'The law of family relations (a.k.a. domestic relations) including marriage, divorce,\nsupport, property division and annulment will be covered in depth using Florida\nlaw as a basis. The collateral topics of adoption, paternity and child abuse/neglect\nwill also be addressed briefly.',
  },
  {
    course_code: 'PLA3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PLA3940',
    course_name: 'Service Learning',
    course_desc:
      'A cooperative effort between the UWF Legal Studies Program and a public, government or non-profit law office. Allows students the opportunity to focus on various learning objectives in a potential career field. The Field Study/Service Learning student will work under the overall supervision of a practicing attorney consistent with R. Regulating Fla. Bar 4-5.3 regarding supervision of non-lawyer assistants. Permission of faculty is required.',
  },
  {
    course_code: 'PLA3948',
    course_name: 'Service Learning Field Study II',
    course_desc:
      'A cooperative effort between the UWF Legal Studies Program, the UWF Center for Learning Through Volunteer Efforts (CLOVE), and a public or private law-related office. Allows students the opportunity to focus on various learning objectives in a potential career field. Students work under the overall supervision of a licensed attorney or other legal professional at the placement site. Permission is required.',
  },
  {
    course_code: 'PLA4023',
    course_name: 'Women and the Law',
    course_desc:
      "An examination of treatment of women in, and by, the U.S. legal profession.  Survey of landmark cases that have impacted specifically on women's legal rights.",
  },
  {
    course_code: 'PLA4155',
    course_name: 'Legal Advocacy',
    course_desc:
      'Emphasis is on improving persuasive advocacy and legal writing ability through the use of both practical writing assignments and oral advocacy, including case briefs, legal correspondence, legal memoranda, and trial briefs.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'PLA4204',
    course_name: 'Civil Procedure',
    course_desc:
      'Civil litigation in the Florida and Federal courts. Covers substantive civil law, Florida and Federal rules of civil procedure and related matters from initial interview through pre-trial preparation including drafting of pleadings and preparing discovery.',
  },
  {
    course_code: 'PLA4225',
    course_name: 'Trial Practice',
    course_desc:
      'A case through the trial process from opening statements through verdict.',
  },
  {
    course_code: 'PLA4263',
    course_name: 'Evidence',
    course_desc:
      'Rules of evidence, including relevancy, hearsay, competency of witnesses and burdens of proof. The Federal Rules of Evidence are emphasized.',
  },
  {
    course_code: 'PLA4277',
    course_name: 'Tort Law',
    course_desc:
      'In-depth study of the fundamental principles of negligence, intentional torts, strict liability, product liability, and vicarious liability.',
  },
  {
    course_code: 'PLA4306',
    course_name: 'Criminal Law',
    course_desc:
      'This course covers the criminal law, with a particular focus on the core elements of a crime, types of crimes against persons and property, and criminal defenses.',
  },
  {
    course_code: 'PLA4309',
    course_name: 'Criminal Procedure',
    course_desc:
      'The study of criminal procedure examines the power of the government to enforce the criminal law versus the right of individuals to be free from government intrusion as guaranteed by the Constitution.  This course explores the legal framework for the enforcement of criminal law and the variety of roles that are played throughout the process.',
  },
  {
    course_code: 'PLA4554',
    course_name: 'Environmental Law and Jurisprudence',
    course_desc:
      'The evolution of both American and international environmental law is explored through a review of the basic, existing environmental laws and regulations, with a jurisprudential/philosophical look at the underlying issues and principles of environmental law, using an interdisciplinary approach.',
  },
  {
    course_code: 'PLA4607',
    course_name: 'Wills, Estates, and Trusts',
    course_desc:
      'This course will provide an overview of the law related to wills, estates, and trusts.  Various sources of law will be examined, in particular, statutes, case law, and uniform laws.',
  },
  {
    course_code: 'PLA4885',
    course_name: 'Constitutional Law for the Legal Professional',
    course_desc:
      'The study of the U.S. Constitution and the major Supreme Court cases interpreting it, focusing on the current status of the law. Seeks an integration of the study of the Constitution with the pragmatics of the practice of law for the paralegal. Introduces the basic concepts of the Constitution in the light of how Constitutional issues arise in the modern practice of law and how to prepare to meet these arguments. Covers Supreme Court jurisdiction, how to read Supreme Court cases, Sseparation of Ppowers, Federalism, Commerce Clause, Due Process cases, First Amendment, Privacy, and Equal Production. Will be focusing on issues confronted in modern courts and law office. Credit may not be received in both PLA4885 and PLA 4880.',
  },
  {
    course_code: 'PLA4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PLA4941',
    course_name: 'Legal Studies Internship',
    course_desc:
      'The Legal Studies Internship is a cooperative effort between the Legal Studies Program at UWF and a public or private law-related office. The purpose is to give students the opportunity to apply their education to actual work situations. The student intern works under the overall supervision of a licensed attorney.',
  },
  {
    course_code: 'PLA5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'POR1905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'POR2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'POR4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'POS2041',
    course_name: 'American Politics',
    course_desc:
      'Deals with the constitutional principles on which the republic was founded, the evolution of institutions which emerged after 1789, and the development of processes and policies in response to 20th Century challenges and changes in the political culture.\nMeets General Education requirement in Social Sciences.',
  },
  {
    course_code: 'PSY6953',
    course_name: 'Research Capstone 1',
    course_desc:
      'Students will be engaged in a group supervised research project. They will build upon their experimental research design skills and strengthen their data collection experience. Skills required for research, writing in the style of the American Psychological Association, and ethical conduct of research will be discussed.',
  },
  {
    course_code: 'POS3033',
    course_name: 'Political Analysis',
    course_desc:
      'This course introduces students to methods of analysis used by political scientists. Students learn to approach analysis like a social scientist employing existing theories to set up the evaluation of evidence and information. Common sources of political evidence such as polls, surveys, and coded data sets may provide a basis for applied analysis in the course. Political issues are considered as students learn to apply tools such as visual data interpretation, statistical analysis, coding qualitative sources, and modeling to derive insights.',
  },
  {
    course_code: 'POS3270',
    course_name: 'Elections and Campaigning',
    course_desc:
      'This course is designed to introduce students of American politics to the practical side of campaigns and elections.  The class will undertake an extensive examination of the local, state, and national elections to be held during the fall by focusing on candidates, parties, interest groups, and the media as well as some of the new influences in elections such as political consultants and pollsters.  The focuses on the electoral process as well as the primary and general phases of American elections.',
  },
  {
    course_code: 'POS3413',
    course_name: 'The Presidency',
    course_desc:
      'We begin our exploration of the American presidency with a critical overview of the constitutional parameters of the executive office. What did our founding fathers expect from an executive? From there we examine how the presidential institution has evolved since the founding. The presidency definitely has a somewhat different place now in our separated system of branches sharing power than it once did. One of the most important features we address is how individual presidents have impacted the scope and direction of the office. We highlight the important role of person style, leadership, persuasion, and charisma as an influence on American government as a whole. Finally, we evaluate competing theories of presidential power to see how useful they are in explaining contemporary presidential politics.',
  },
  {
    course_code: 'POS3424',
    course_name: 'The Legislative Process',
    course_desc:
      'Politics of accommodation in formulating authoritative policies and general rules; emphasis on U.S. Congress and Florida Legislature in action; relations to other governmental processes.',
  },
  {
    course_code: 'POS3453',
    course_name: 'Political Parties and Interest Groups',
    course_desc:
      'Political parties, nominations, campaigns, elections, voting behavior, political recruitment, party organization and parties as managers of government. Roles and functions of interest groups.',
  },
  {
    course_code: 'POS3608',
    course_name: 'Constitutional Law: Federalism and Separation of Powers',
    course_desc:
      'Offers an introduction to the fundamental features of the Supreme Court and its Constitutional jurisprudence. In particular, students will examine through a case-study approach the evolution of judicial review, separation of powers, powers of the President and Congress, the evolution of federalism, the national commerce power, and national taxing and spending powers.',
  },
  {
    course_code: 'POS3613',
    course_name: 'Constitutional Controversies',
    course_desc:
      "The American Founders established a Supreme Court to resolve all cases and controversies arising under the federal Constitution and its subsequent laws and treaties. This Court would serve primarily as an appellate tribunal, a court of last resort, reviewing and remanding, reversing or upholding the rulings of lower courts in both the federal and state judiciaries. In this course we will examine those elements of the appellate process on constitutional law, including the\nCourt's review of petitions of certiorari, of merits briefs and the corresponding amici briefs and oral argument.",
  },
  {
    course_code: 'POS3624',
    course_name: 'Constitutional Law: Individual Rights and Privileges',
    course_desc:
      "Offers an introduction to Supreme Court's role in the protection of individual rights, due process, and the equal protection of the laws. In particular, students will examine through a case study approach the evolution of the Court's jurisprudence in cases pertaining to civil rights and individual freedoms protected under the Constitution of the United States.",
  },
  {
    course_code: 'POS3625',
    course_name: 'First Amendment Freedoms',
    course_desc:
      'Problem areas and doctrinal evolution in the judicial protection of First Amendment freedoms. Among specific subjects to be examined will be: free speech and press, free exercise of religion, state aid to religious schools, regulation of obscenity, freedom of association, and regulation of subversive activity.',
  },
  {
    course_code: 'POS3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'POS4602',
    course_name: "The Founders' Constitution",
    course_desc:
      'Analysis of the notes of the Constitutional Convention of 1787 and the alternative proposals for the organization of the National Government. Examination of the merits of arguments both for and against the adoption of the Constitution and the records of the creation and adoption of the Bill of Rights in the First Congress. This course is offered concurrently with POS5637; graduate students will have additional work.',
  },
  {
    course_code: 'POS4673',
    course_name: 'Jurisprudence',
    course_desc:
      'A survey of various approaches to theorizing about the Concept of Law. The Natural Law, Legal and Analytical Positivist, Sociological, Realist, and Critical Legal Studies approaches will be studied. In addition, concepts of Justice will be considered.',
  },
  {
    course_code: 'POS4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'POS4941',
    course_name: 'Internships',
    course_desc:
      'Special "real-world" encounters programs designed for the individual student. Student must contact their advisor one semester in advance of desired date for internship. Graded on a satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'POS5637',
    course_name: "The Founders' Constitution",
    course_desc:
      'Analysis of the notes of the Constitutional Convention of 1787 and the alternative proposals for the organization of the National Government. Examination of the merits of arguments both for and against the adoption of the Constitution and the records of the creation and adoption of the Bill of Rights in the First Congress. This course is offered concurrently with POS4602; graduate students will have additional work.',
  },
  {
    course_code: 'POS6006',
    course_name: 'The Study of Politics',
    course_desc:
      'Introduces the graduate study of political science. It concerns "scope" more than "method," and the range is broad, focusing on what political scientists do--teach, research, advise, and serve. Concerns embrace every conceivable level--local, regional, national, cultural, global, planetary.',
  },
  {
    course_code: 'POS6045',
    course_name: 'Seminar in American Politics',
    course_desc:
      'Course content includes an overview of the institutions and processes of the American political system, the trend and tendencies of political behavior, and the diverse theoretical understandings of American government in the world of political science.  Focus is on understanding and critically evaluating interpretations of the structure and function of our governmental system, including: the three branches of government, elections, political socialization and civic engagement,representation, political parties, and interest mobilization.',
  },
  {
    course_code: 'POS6704',
    course_name: 'Political Science Research Methods',
    course_desc:
      'Methods and logic of research in political science. POS6704, Political Science Research Methods provides students with the knowledge and skills required to analyze and critique, as well as design, applied research in public policy and public affairs. The course introduces the student to the enterprise of academic research in these areas, provides the student with knowledge and understanding of the various philosophical and methodological approaches to applied research and allows the student to develop and hone analytical skills. Accepted social science research designs will be introduced and an analysis of threats to the validity and reliability of these different designs will be considered. Sampling theory and statistical analysis will be introduced.',
  },
  {
    course_code: 'POS6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'POS6971',
    course_name: 'Thesis',
    course_desc:
      'Graded on satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'POT3103',
    course_name: 'Law and Politics in Literature',
    course_desc:
      "Discussion of law and politics within history's most prominent literary works. Examination of the rule of law within political life in relation to character and plot development. Exploration in the ways in which literature illustrates the challenges posed by human nature to the just administration of law.",
  },
  {
    course_code: 'POT4013',
    course_name: 'Ancient Masters of Political Thought',
    course_desc:
      'A survey of several of the seminal works by political theorists of the ancient and medieval period, including Plato, Aristophanes, Xenophon, Aristotle, Cicero, and St. Augustine. Readings will introduce such themes as the classification of regimes, the debate between the poets and the philosophers, the role of the virtues in perpetuation of civic order, the problem of the many and the one, the tension between the philosopher and the city, the problems of justice, the ideas\nof Nature and human nature, and the status of the gods and/or religion in political life. Graduate course POT5016 will have additional work.  Course only offered Fall semester.',
  },
  {
    course_code: 'POT4204',
    course_name: 'American Political Thought',
    course_desc:
      'Significant American political theorists, schools of thought and their influence on the political system.',
  },
  {
    course_code: 'POT4601',
    course_name: 'Modern Masters of Political Thought',
    course_desc:
      'Evaluates ideas about the origin, justification, organization, and performance of government by great thinkers from Machiavelli to the present.   Offered concurrently with POT5602; graduate students will be assigned additional work.',
  },
  {
    course_code: 'POT4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'POT5016',
    course_name: 'Seminar in Political Theory',
    course_desc:
      'A survey of several of the seminal works by political theorists of the ancient and medieval period, including Plato, Aristophanes, Xenophon, Aristotle, Cicero, and St. Augustine. Readings will introduce such themes as the classification of regimes, the debate between the poets and the philosophers, the role of the virtues in perpetuation of civic order, the problem of the many and the one, the tension between the philosopher and the city, the problems of justice, the ideas\nof Nature and human nature, and the status of the gods and / or religion in political life. Offered Fall semester only.',
  },
  {
    course_code: 'POT5602',
    course_name: 'Modern Masters of Political Thought',
    course_desc:
      'Evaluates ideas about the origin, justification, organization, and performance of government by great thinkers from Machiavelli to the present.   Offered concurrently with POT4601; graduate students will be assigned additional work.',
  },
  {
    course_code: 'POT6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PPE4003',
    course_name: 'Theories of Personality',
    course_desc:
      'Assumptions, structure, dynamics and determinants of personality. Consideration of various personality theories, pertinent research and its application to everyday life.',
  },
  {
    course_code: 'PPE4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PPE5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PSB4002',
    course_name: 'Brain, Behavior, and Experience',
    course_desc:
      'Introduction to the brain and its relationship to behavior and experience. Topics covered: structure and function of the nervous and endocrine systems, sensation / perception, emotion and motivation, thinking and consciousness, learning and memory, malfunctions of the mind.',
  },
  {
    course_code: 'PSB4731',
    course_name: 'Psychobiology of Sexual Behavior',
    course_desc:
      'Study of biological and sociocultural determinants of sexual development throughout the human life span. Special emphasis is given to sexual orientation, sexual preference, sexual variance, and purported gender differences.',
  },
  {
    course_code: 'PSB4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PSB5035',
    course_name: 'Cognitive Neuroscience',
    course_desc:
      'Biological bases of mind and behavior: History and methods of cognitive neuroscience; evolutionary perspectives on cognition; neural substrates of development and motor control, attention and perception, learning and memory, language and consciousness, cerebral lateralization and specialization.',
  },
  {
    course_code: 'PSB5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PSB6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PSY2012',
    course_name: 'General Psychology',
    course_desc:
      'A survey of methods, theories, and body of knowledge of contemporary psychology, including such topics as learning, motivation, sensation and perception, development, thinking, personality, social behavior, psychological adjustment, and methods of therapy.\nMeets General Education requirement in Social Sciences.',
  },
  {
    course_code: 'PSY2023',
    course_name: 'Professional Development in Psychology',
    course_desc:
      'This course will provide students with an overview of the discipline of psychology, including expectations for the psychology major, career options for students completing a bachelor degree in psychology, and career options for students who pursue a graduate degree in psychology. Skills required for library research, writing in the style of the American Psychological Association, professional communication, and ethical and professional issues will be discussed.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'PSY2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PSY6954',
    course_name: 'Research Capstone II',
    course_desc:
      'In the second course in the Research Capstone sequence, students will continue to be engaged in a supervised research project and work on writing in the style of the American Psychological Association. They will also strengthen their statistical analyses skills by working directly with data. Students will build their presentation skills by presenting their research at the completion of the project.',
  },
  {
    course_code: 'PSY3213',
    course_name: 'Research Methods in Psychological Science I',
    course_desc:
      'The first course of a two-course sequence designed to expose a student to the research methods and the behavioral statistics that are commonly employed in psychological (behavioral) research. Although the fundamental principles of scientific observation, research design, and research statistics will be discussed, special emphasis will be placed on methodology that provides a basic or descriptive understanding of human behavior. Ethical issues pertaining to both human and non-human research will also be introduced and discussed.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'PSY3215',
    course_name: 'Research Methods in Psychological Science II',
    course_desc:
      'The second course of a two-course sequence designed to expose a student to the research methods and the behavioral statistics that are commonly employed in psychological (behavioral) research. Although the fundamental principles of scientific observation, research design, and research statistics will be discussed, special emphasis will be placed on methodology that provides a more complex or inferential understanding of human behavior. Ethical issues pertaining to both human and non-human research will also be introduced and discussed.',
  },
  {
    course_code: 'PSY3860',
    course_name: 'Positive Psychology',
    course_desc:
      'This scientific study of positive experience includes a review of the historical and philosophical foundations of positive psychology and of its contributions to traditional research and practice areas in psychology. Specific emphasis is on the applied positive psychology perspective of the pursuit of the good life, health and well-being, positive psychology at work, clinical psychology and psychotherapy, and positive development across the lifespan.\nMeets Gordon Rule Writing Requirement.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'PSY3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PSY3948',
    course_name: 'Service Learning Field Study II',
    course_desc:
      "Placement in community agency or other social organizational setting related to field of study. Supervision by faculty and agency. Students and faculty customize courses to fit a full range of services available in the setting. Student must be able to draw correlation between the discipline and field study. Journal and reflective experience paper are required. With the agreement of the student's faculty sponsor, a minimum of 4-6 hours per week must be done at the field site per semester hour of credit. Permission is required. Graded on a satisfactory / unsatisfactory basis only.",
  },
  {
    course_code: 'PSY4302',
    course_name: 'Psychology of Assessment',
    course_desc:
      'Fundamentals of testing and measurement of aptitude, achievement and personality. STA2023 is recommended prior to taking this course. Credit may not be received in both PSY4302 and PSY 4383.',
  },
  {
    course_code: 'PSY4832',
    course_name: 'Sport and Exercise Psychology',
    course_desc:
      'Introduces students interested in psychology, exercise science, physical education, sports medicine, coaching, athletic training or fitness instruction, to principles of psychology as applied to sports and exercise. Topics covered include methods of performance enhancement and mental training, exercise adherence, violence in sports, effects of sports on children, team dynamics, and drug and steroid use among athletes.',
  },
  {
    course_code: 'PSY4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PSY4930',
    course_name: 'Capstone in Psychology: Special Topics',
    course_desc:
      'The objectives of the capstone courses will provide students an opportunity to: 1) study a target area in psychology in depth 2) integrate knowledge and skills across courses, and 3) prepare an effective pursuit strategy for a meaningful psychology-related career Student must earn a C or higher to pass the course.',
  },
  {
    course_code: 'PSY5016',
    course_name: 'Conjunctive Psychology',
    course_desc:
      "A practical and integrated overview of the fundamental dynamics of human behavior and consciousness, drawing from all the world's psychologies, and emphasizing contributions not well known in Western Psychology. Topics include breathwork, nutrition, ayurveda, pranayama, chi kung, chakras, yoga, behaviors of the mind, states and levels of consciousness, self and will, and transpersonal awakening, and their applications in professional settings.",
  },
  {
    course_code: 'PSY5016L',
    course_name: 'Conjunctive Psychology Laboratory',
    course_desc:
      'Practical experience and skill training that parallel topics of the lecture course. Grading is based on attendance and participation, and contribution to the class.',
  },
  {
    course_code: 'PSY5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PSY6217',
    course_name: 'Research Design in Psychology',
    course_desc:
      'This course focuses on quantitative research approaches with particular attention given to the selection of procedures for obtaining empirical data that provide meaningful answers to research questions and to the relation between research design and statistical analysis. Topics include researching the literature, developing research questions, designing and evaluating empirical research, and communicating research methods and results in standard technical format (APA style). Ethical issues in the conduct of research will be addressed.',
  },
  {
    course_code: 'PSY6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PSY6917',
    course_name: 'Supervised Research',
    course_desc:
      'Credit is earned by serving in an apprenticeship position under a faculty member and assisting with one or more research projects. Although the student may enroll in more than one supervised experience in research or teaching (see PSY6940), a maximum of 3 sh in supervised experiences will be applied toward the degree requirements. Permission is required.',
  },
  {
    course_code: 'PSY6940',
    course_name: 'Supervised Teaching',
    course_desc:
      'Credit is earned by serving in an apprenticeship position under a faculty member and assisting with the teaching of one or more courses. Although the student may enroll in more than one supervised experience in teaching or research (see PSY6917), a maximum of 3 sh for supervised experiences will be applied toward the degree requirements. Permission is required.',
  },
  {
    course_code: 'PSY6948',
    course_name: 'Internship',
    course_desc:
      'Students are required to complete 350 hours of I-O-related high-impact activities under the supervision of an external supervisor in an organizational setting, and the internal internship coordinator.  Using a scientist-practitioner approach, students will integrate their internship experiences with what they learned in the classroom through written work and presentations.  Students may enroll for more than one term-total of 6sh required for M.A. degree. Permission to enroll is required.',
  },
  {
    course_code: 'PSY6971',
    course_name: 'Thesis',
    course_desc:
      'Includes research projects, theoretical treatises and case studies. May enroll for more than one term-total of 6sh required for M.A. degree. Graded on satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'PUP4004',
    course_name: 'Public Policy',
    course_desc:
      'Study of how public policy is made, especially at the national level. Focus is on current issues and events including the role of the President, Congress, interest groups, bureaucracy and the public. Extensive use of current news sources in the print, television, and internet media.',
  },
  {
    course_code: 'PUP4044',
    course_name: 'Analytic Techniques for Public Policy',
    course_desc:
      'Practical orientation to public policy analysis. The role of the policy analyst in the context of the American public policy process and its institutional framework. Focus upon actual techniques required to perform policy analysis. Different policy areas are utilized to demonstrate the application of techniques. Offered concurrently with PUP5045; graduate students will be assigned additional work.',
  },
  {
    course_code: 'PUP4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PUP5045',
    course_name: 'Public Policy Analysis',
    course_desc:
      'Examines the issues involved in and methods of developing, implementing, and analyzing public policy. The role of the public manager is assessed relative to other actors in the development of public policy. The graduate course in analytic techniques provides students an opportunity to deepen their understanding of methods of policy analysis and the processes and challenges of implementation. Pre/Co-requisite: None.',
  },
  {
    course_code: 'PUP6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PUR3000',
    course_name: 'Principles of Public Relations',
    course_desc:
      'Increases understanding of the theory and practice of public relations, functions in organizations, and role in society. Is the foundation course for all other courses in public relations.',
  },
  {
    course_code: 'PUR3100',
    course_name: 'Writing for Public Relations',
    course_desc:
      'Develops professional-level writing skills expected of beginning public relations practitioners. Students practice writing for different audiences and media, such as preparing memos, letters, new releases, crisis communication plans, features, media kits, speeches and newsletters.',
  },
  {
    course_code: 'PUR3404',
    course_name: 'International Public Relations',
    course_desc:
      'This course examines public relations theory and practice from a global perspective.  A primary function of the course is to prepare students for the professional practice of public relations across cultures. Course content will provide an overview of cultural and political differences in media systems and the impact of public relations practice. Students will have the opportunity to review case studies, theory and practice in regions with established and emerging public relations indistries.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'PUR3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PUR4400',
    course_name: 'Crisis Public Relations',
    course_desc:
      'Examines crisis public relations planning, preparation, and execution. Focus is on assessment of risk, types of crises, role of and interaction with the media and other publics. Cases are examined to apply what is learned to examples of actual organizational crises. An "ask-the-expert" discussion series presents crisis communication as it relates to corporate, not-for-profit, education, and national-level government public relations.',
  },
  {
    course_code: 'PUR4407',
    course_name: 'Managing Media Relations',
    course_desc:
      'The ability to communicate effectively with the media on behalf of an organization is an essential skill for public relations professionals. Techniques and guidelines are provided for the role of organizational media relations manager with emphasis on the spokesperson. An overview of media needs, including communication planning, tips and techniques, and common pitfalls of organizational media relations programs. A considerable portion of the course requires students to participate as spokespersons in various scenario-based, video-tapped exercises.',
  },
  {
    course_code: 'PUR4600',
    course_name: 'Communication Management',
    course_desc:
      'Capstone course for public relations and advertising majors. Emphasis on case study analysis and the management of integrated communication programs. Senior status required.',
  },
  {
    course_code: 'PUR4801',
    course_name: 'Public Relations Campaigns',
    course_desc:
      'A capstone course focusing on applying communication and public relations research and theory for a real client. Provides a thorough experience in conducting public relations and integrated communications campaigns and in preparing communication materials. Working in teams, students prepare and conduct the research, planning, implementation and evaluation of an actual campaign for a client.  An advanced course requiring full understanding of public relations theory, writing, techniques and research methods. Credit may not be received in both PUR4801 and PUR 4802.',
  },
  {
    course_code: 'PUR4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PUR4930',
    course_name: 'Current Issues and Trends in Public Relations',
    course_desc:
      'Focuses on a range of current issues facing the public relations profession from a theoretical and practical perspective. Exploration of selected topics such as emerging trends in the use of technology, diversity and multiculturalism, increased use of social media, and environmental issues impacting the organization. Senior status within the PR major required.',
  },
  {
    course_code: 'PUR6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'PUR6937',
    course_name: 'Emerging Topics in Public Relations',
    course_desc:
      'Provides students with an advanced-level understanding of public relations theory and practice. Depending on emerging issues and market needs, areas of study may include issues in international public relations, social media and analytics, public affairs, crisis management, and more.',
  },
  {
    course_code: 'QMB3820',
    course_name: 'Introduction to Quantitative Models for Business Decisions',
    course_desc:
      'Formulation and application of mathematical models in business decision making scenarios. Focuses on a system modeling view of resources, constraints and objectives. Credit can only be earned for one of these two courses:  MAN3550 and QMB3820.',
  },
  {
    course_code: 'QMB6305',
    course_name: 'Quantitative Methods for Business',
    course_desc:
      'Provides students with quantitative skills that are required to make business decisions. These skills involve using statistical, forecasting and estimation techniques. Students are expected to use the subject matter for problem sets and exams.',
  },
  {
    course_code: 'REA1905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'RTV3511',
    course_name: 'Electronic Field Production',
    course_desc:
      'This course will examine the unique aspects of non-studio television production styles, techniques and formats.This is a hands-on, equipment-intensive course. Credit may not be received in both RTV3511, 3320 and RTV 3320C.',
  },
  {
    course_code: 'RED3310',
    course_name: 'Literacy Instruction for the Intermediate Learner',
    course_desc:
      'This course prepares educators for effective literacy instruction in the intermediate grades.  Learning activities focus on research based instructional approaches that incorporate the major components of reading, including word study, guided reading, and guided writing. Additionally, students will examine  instruction that provides appropriate accommodations for students with special needs.',
  },
  {
    course_code: 'RED3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'RED4542',
    course_name: 'Assessment and Differentiated Instruction in Reading',
    course_desc:
      'This course prepares pre-service teachers in the areas of differentiated reading and language arts instruction based on appropriate assessment practices. A major component of this course is building capacity with regard to providing individualized instruction in the areas of reading, writing, speaking, and listening.',
  },
  {
    course_code: 'RED4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'RED5515',
    course_name: 'Classroom Reading Assessments',
    course_desc:
      "This course is designed to provide an exploration into the theory and practices of informal reading assessments appropriate for the K-12 classroom teacher.  During this course, students will administer, analyze, and interpret a variety of informal reading assessments in their respective classrooms. Students will identify a struggling reader, develop a remedial, individualized plan based on the student's reading needs, and provide immediate intensive instruction based on data from the informal assessments previously administered in the class. This course is required for students in the Reading Education M.Ed. program and for those seeking reading endorsement.",
  },
  {
    course_code: 'RED5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'RED6060',
    course_name: 'Foundations of Middle and Secondary Literacy',
    course_desc:
      'Students in this course will learn about literacy theory and instruction in the middle and secondary grades based on research and classroom practice. Students will examine theories for enhancing reading, writing, speaking, and listening across various subjects in the school curriculum for middle and secondary students.',
  },
  {
    course_code: 'RED6116',
    course_name: 'Foundations of Literacy Development',
    course_desc:
      'Students in this course will learn about current methods, materials, issues, and trends in the teaching of literacy in early childhood and elementary classrooms.  Students will examine how particular theories of literacy impact instructional practices used when teaching reading and writing in the pre-k-5 classroom.',
  },
  {
    course_code: 'RED6240',
    course_name: 'Differentiating Instruction',
    course_desc:
      'Explores differentiating instruction to meet the needs of all learners and teaches how to prevent or remediate reading difficulties. The focus will be on the interpretation of reading assessment and the implementation of research based instructional practices.',
  },
  {
    course_code: 'RED6546',
    course_name: 'Identifying and Preventing Reading Difficulties',
    course_desc:
      'Course work with required clinical experience to develop competence in determining causes and degrees of reading disabilities and identifying appropriate corrective or remedial instruction to meet the specific needs of students.',
  },
  {
    course_code: 'RED6701',
    course_name: 'The Organization and Administration of Literacy Programs',
    course_desc:
      'Explores the role of a specialized literacy leader in organizing and implementing literacy programs from the pre-elementary through the college level.  Includes an examination of leadership practices and advocacy that promote effective literacy practices to a variety of stakeholders, including administrators, teachers, parents/guardians, and students.',
  },
  {
    course_code: 'RED6747',
    course_name: 'Research and Trends in Reading',
    course_desc:
      'Review of significant research in reading, introduction to techniques and critical analysis of reading research, review and comparison of trends in development of materials, approaches and reading programs.',
  },
  {
    course_code: 'RED6866',
    course_name: 'Reading Practicum',
    course_desc:
      'Provides practical experience in increasing the reading performance of K-12 students with the prescription and utilization of appropriate strategies and materials. Requires demonstration of knowledge in the prevention, identification and remediation of reading difficulties.',
  },
  {
    course_code: 'RED6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'REE4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'REL1300',
    course_name: 'World Religions',
    course_desc:
      'Broad understanding of the major religious traditions. May include Judaism, Christianity, Hinduism, Buddhism, Islam and others. Comparative study of similarities and differences among these traditions.\nMeets General Education requirement in Humanities.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'REL2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'REL3241',
    course_name: 'Studies in the New Testament',
    course_desc:
      'Exegetical study of literature of the early Christian community with emphasis on life and teaching of Jesus and letters of Paul from variety of theological perspectives.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'REL3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'REL4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'RLG6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'RTV3210',
    course_name: 'Radio Production',
    course_desc:
      'Introduction to the tools and techniques of audio production with emphasis on the practical application of theoretical concepts. Credit may not be received in RTV3210 and either RTV 3210C or RTV 3240C.',
  },
  {
    course_code: 'RTV3301',
    course_name: 'Broadcast Journalism',
    course_desc:
      'Principles and techniques of radio and television news operation. Credit may not be received in both RTV3301 and RTV 3304.',
  },
  {
    course_code: 'RTV3400',
    course_name: 'History of Television',
    course_desc:
      'Examines the entire television industry from its inception to present day and its social, economic and financial ramifications on societies, especially their inter-relations. The course will also review, compare and contrast both the domestic and international television industries with regard to technical applications and advances, programming, production, and developmental theory and\nwhere the industry may be headed.',
  },
  {
    course_code: 'RTV3533',
    course_name: 'Television Production',
    course_desc:
      'Studio operations and equipment; theoretical and technical aspects of television production. Credit may not be received in both RTV 3200, 3533 and RTV 3200C.',
  },
  {
    course_code: 'RTV3700',
    course_name: 'Broadcast Management and Regulation',
    course_desc:
      'Management issues in the broadcast industry and governmental regulations that apply to that industry.',
  },
  {
    course_code: 'RTV3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'RTV3942',
    course_name: 'Practicum: Television News',
    course_desc:
      'Experience in production of a weekly television news program telecast to the local community.',
  },
  {
    course_code: 'RTV4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'RTV6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SCE3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SCE4310',
    course_name: 'Teaching Science in Elementary Schools',
    course_desc:
      "This course incorporates current research and best practices in science education to prepare prospective teachers to foster meaningful science learning in the elementary (K-6) classroom. In the course, prospective teachers reflect on and develop their competence in the three dimensions of science learning, and their understanding of the nature of science. They also explore subject-specific pedagogy with an emphasis on planning inquiry-based instruction that engages elementary learners in experiencing and explaining phenomena, and builds on their prior knowledge. Furthermore, the course develops prospective teachers' awareness of strategies to assess science learning, and promote equitable participation of underrepresented populations in science learning experiences. \nA material and supply fee is assessed for an elementary science materials kit.",
  },
  {
    course_code: 'SCE4320',
    course_name: 'Teaching Science in Middle and Secondary Schools',
    course_desc:
      'Theory and methods of teaching science in the middle and secondary schools; explores current research on approaches in teaching and learning science; examines the practice of science, disciplinary core ideas in specific science disciplines of choice (i.e. Biology, Earth/Space, Chemistry, Physics), and crosscutting themes in science; compares various models of teaching (i.e. direct instruction, inquiry, project-based learning); Includes practices to effectively move student thinking toward meaningful understanding focusing on best practices in STEM disciplines.',
  },
  {
    course_code: 'SCE4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SCE6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SDS6345',
    course_name: 'Educational and Vocational Guidance',
    course_desc:
      'Socio-psychological forces influencing career choice; identification, selection and use of educational and career guidance resources; use of decision-making concepts and skills in choosing educational and occupational alternatives.',
  },
  {
    course_code: 'SDS6647',
    course_name:
      'Foundations of Counseling Principles for Student Affairs Administration',
    course_desc:
      'This course is designed to serve as a professional preparation course in which students will have the opportunity to learn basic counseling concepts and applications essential for effective student affairs practice. Students will be prepared for competent student affairs practice through the examination of personal values, professional ethics, and personal demonstration of essential practice skills that will serve diverse populations with specific attention to gender, sexual orientation, class, race, and ethnicity. Issues related to college student mental illness will also be addressed.',
  },
  {
    course_code: 'SDS6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SLS1109',
    course_name: 'Foundations for Academic Success',
    course_desc:
      'The course introduces students to campus resources and provides skills and tools that will help them to be successful. Faculty will use High Impact approaches to getting students engaged and connected on campus.',
  },
  {
    course_code: 'SLS2401',
    course_name: 'Major Exploration Career Choice',
    course_desc:
      'This course is designed to assist students in identifying their values, interests, personality, and skills and how these relate and connect to choosing a major and/or career. Students will have the opportunity to develop relevant ideas for experience in their field and be able to explore networking opportunities to assist them with their career objectives. The class is designed to use an introspective approach to identifying majors and careers and then to give students the tools for developing experiential learning opportunities.',
  },
  {
    course_code: 'SLS2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SLS2940',
    course_name: 'Internship Experience',
    course_desc:
      'This course will consist of a variable internship opportunity for current UWF students or recent UWF students not yet returning to UWF for their second year of study. These students will be placed with a UWF department, community agency or employer. Placements will be managed by the Office of Career Development and Community Engagement (Career Services), a department within the Division of Academic Engagement. The course will include both for credit and not for credit sections with variable credit hours. Special permission is required for course registration. Credit generated from this course may or may not count towards a degree.',
  },
  {
    course_code: 'SLS4408',
    course_name: 'Career Strategies Workshop',
    course_desc:
      'Students will develop the strategies necessary to conduct effective job searches and identify appropriate graduate education opportunities to achieve their individual career goals.  Students will identify and participate in career-specific networking opportunities to enhance their professional development.',
  },
  {
    course_code: 'SLS4940',
    course_name: 'Internship Experience',
    course_desc:
      'This course will consist of a variable internship opportunity for current UWF students or recent UWF graduates placed with a UWF department, community agency or employer. Placements will be managed by the Office of Career Development and Community Engagement (Career Services), a department within the Division of Academic Engagement. The course will include both for credit and not for credit sections with variable credit hours. Special permission is required for course registration. Credit generated from this course may or may not count towards a degree.',
  },
  {
    course_code: 'SOP3004',
    course_name: 'Social Psychology',
    course_desc:
      'This course is a survey of theory, method, and research results in areas of social psychology, such as attitude formation and change, social perception/ cognition, impression formation, social influence, interpersonal attraction and relationships, aggression and pro-social behavior, and group dynamics.',
  },
  {
    course_code: 'SOP3730',
    course_name: 'Psychology, Culture, and Society',
    course_desc:
      'The study of social processes within a cultural context. Topics include non-verbal behavior, the construction of social reality, communication, personal relationships, social influence, discrimination and prejudice, group dynamics, organizational culture and behavior, implications for health and wellness.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'SOP3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SOP4702',
    course_name: 'Psychology and Gender',
    course_desc:
      'Addresses the construction of gender as a psychological construct. The psychological construct of gender is considered from biological, social, and individual perspectives. Lecture, discussion, readings, and participative learning methods are used.',
  },
  {
    course_code: 'SOP4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SOP5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SOP6069',
    course_name: 'Advanced Social Psychology',
    course_desc:
      'Students must take SOP3004 before enrolling in this course.\nContribution of social psychology to understanding of human behavior: emphasis is on theory and research in major areas such as attitude, perception and attribution, attraction, altruism, group behavior, etc.',
  },
  {
    course_code: 'SOP6668',
    course_name: 'Organizational Change and Development',
    course_desc:
      'Organizational development: change agentry, role of self in O.D., change theory, feedback methodology, relationship building, team building and quality, Lab learning methodology.',
  },
  {
    course_code: 'SOP6669',
    course_name: 'Advanced Organizational Psychology',
    course_desc:
      'Seminar reviewing much of the recent research literature in areas of organizational psychology, including leadership, motivation, job performance, job satisfaction, role behavior in work settings and communications.',
  },
  {
    course_code: 'SOP6776',
    course_name: 'Human Sexuality and Sex Therapy',
    course_desc:
      'Major emphasis is given to research regarding a broad range of sexual dysfunctions and analyses of specific therapeutic interventions. Various styles of sexual expression are also examined in terms of their social and psychological implications. Assumes prior knowledge of counseling theory and practice.',
  },
  {
    course_code: 'SOP6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SOW2192',
    course_name: 'Understanding Relationships in the 21st Century',
    course_desc:
      'Human relationships with a focus on the interrelatedness and effects of underlying theoretical principles as they relate to individual, family and group interactions.\nMeets General Education requirement in Social Sciences.',
  },
  {
    course_code: 'SOW3103',
    course_name: 'Human Behavior in Social Environment',
    course_desc:
      'Social personality and cognitive development, normal and abnormal, normative and non-normative crisis and gender issues with an emphasis on cultural diversity. Importance of social work intervention and treatment with individual, family, and community.',
  },
  {
    course_code: 'SOW3113',
    course_name: 'Human Behavior in Organizations and Communities',
    course_desc:
      "Introduces the future practitioner to the concept of change agent within organizations, institutions, and communities. Prepares the student with academic concepts on community organization as a prelude to the practice course. Emphasis is placed on the student's ethical responsibilities to the client, organizational structure of human service agencies and the elements common to them. Students will understand structural and organizational differences between profit and nonprofit agencies. Students will experience organizational obstacles to planned change. The dynamics of gender, class, race, ethnicity, and sexual orientation are examined in relationship to how they are played out within the organizational context.",
  },
  {
    course_code: 'SOW3203',
    course_name: 'Introduction to the Field of Social Work',
    course_desc:
      'Survey of the social work profession from its roots to contemporary practice with a descriptive focus on its values, knowledge bases, skills, and fields of practice. Emphasis is on generalist social work and social policy structures which sustain society. Introduces the relationship of social problems to social policy and to social service delivery systems.',
  },
  {
    course_code: 'SOW3313',
    course_name: 'Work With Individuals',
    course_desc:
      "One of four practice courses designed to prepare the student for generalist social work. Emphasis is on the values, knowledge, and skills necessary for effective assessment and intervention on the micro level, and is reflected in several areas, including the worker / client relationship, assessment, strategies and implementation techniques, the social worker's use of self, the phases of the helping process, and evaluation. Using the systems approach, emphasis is placed on social, cultural familial, and environmental influences on the functioning of individuals. Permission is required.",
  },
  {
    course_code: 'SOW3314',
    course_name: 'Case Management',
    course_desc:
      'Designed to help students develop a general overview of case management and how it is defined and practiced in a variety of settings, such as juvenile justice programs, mental health programs, and nonprofit community agencies.',
  },
  {
    course_code: 'SOW3322',
    course_name: 'Work With Groups',
    course_desc:
      'One of a series of four courses designed to prepare a student for generalist social work practice. The student will acquire the knowledge base, values and skills necessary for working with groups at the beginning professional level. The focus will be on developing the knowledge base, values and practice skills needed to use the problem solving approach to work with diverse populations within various types of groups. Stages of groups and activities that can enhance the group process will be explored. Permission is required.',
  },
  {
    course_code: 'SOW3350',
    course_name: 'Interviewing and Recording',
    course_desc:
      'Practice in interviewing techniques and in precise, descriptive, and accurate writing techniques for practitioners in social work, psychology, and other helping professions. Students will learn interview techniques, how to record sessions accurately and in formats required for opening, transferring, updating and closing a social work client record.  Students will learn American Psychological Association writing guidelines.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'SPM4505',
    course_name: 'Principles and Issues in Sport Finance',
    course_desc:
      'Students will gain the knowledge necessary to successfully financially manage budget, account, ascertain funding, and navigate other complex sport finance issues.  The specific financial implications of managing a sport related business are covered. Open only to Juniors and Seniors.',
  },
  {
    course_code: 'SOW3503',
    course_name: 'Introduction to Generalist Practice',
    course_desc:
      'One of four practice courses designed to prepare the student for generalist social work. Through agency experience, classroom instruction, and introspective discussion, students develop self-awareness, beginning skills and knowledge, and a professional attitude. Students are introduced to a social agency setting, the varying needs and vulnerabilities of clients served, the problem solving process, and the development of basic knowledge and skills necessary in helping relationships with systems of various sizes. Restricted to social work majors. Permission is required.',
  },
  {
    course_code: 'SOW3650',
    course_name: 'Introduction to Child Welfare',
    course_desc:
      'Prepares social workers and others to enter the field of child welfare with a better understanding of the history of this movement and the types of services and programs designed to assist children and families. Also introduces and provides information to any interested person regarding the social problems of children and the availability of services to children in need.',
  },
  {
    course_code: 'SOW3783',
    course_name: 'Human Trafficking',
    course_desc:
      'The purpose of this course is to educate social work students on human trafficking and develop a framework for professional intervention. This course is designed to examine the human trafficking phenomenon of modern day slavery of men, women, and children. Course content will include the examination of domestic and international policy, the differences in labor and sexual trafficking, and\nthe scope and prevalence of human trafficking as an international concern. The socio-political, cultural, and economic issues that contribute to the increased phenomenon of trafficking with women and children will be explored as well as the traumatic effects on victims, families, and the community. The social workers role in providing intervention and advocacy services will be explored.',
  },
  {
    course_code: 'SOW3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SOW4111',
    course_name: 'Adolescents At Risk',
    course_desc:
      'Explores environmental and societal factors that contribute to risky behaviors of adolescents such as substance use, delinquency, sexual activity, and violent behavior, and others. Characteristics of high risk and low risk youth are discussed including the relationship of these characteristics to adolescent development. Prevention, intervention, and treatment approaches are discussed.',
  },
  {
    course_code: 'SOW4141',
    course_name: 'Social Aspects of Family Violence',
    course_desc:
      'Introduces basic concepts, principles, and methods for understanding and identifying family violence. Topics include an historical overview; the impact of domestic violence on the community and on the woman, children, and man involved; the identification of emotional, physical, and sexual aspects of abuse; safety planning and levels of lethality; an introduction to effective intervention.',
  },
  {
    course_code: 'SOW4232',
    course_name: 'Introductory Analysis of Social Service Policy',
    course_desc:
      'Examines social welfare policy as a central concern to social work. Addresses policy practice. Includes improvement of human services delivery systems through the application of problem solving, critical thinking and other necessary skills.',
  },
  {
    course_code: 'SOW4233',
    course_name: 'Human Diversity and Social Justice',
    course_desc:
      'Examines the impact of social, economic, and political environments on diverse populations specifically race, gender, age, ethnicity, culture, class, sexual orientation, religion, and physical and mental ability. Integrates the key elements of the profession of social work through the filter/lens of social, political, and economic justice.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'SOW4242',
    course_name: 'Families and Family Treatment',
    course_desc:
      'This course is designed with a definition and understanding of contemporary family forms and family function, both normative and in crisis, and to introduce modalities for assisting troubled families. This course also addresses such issues as: the impact of the family life cycle, strategies and goals of family treatment, single-parent families, gay and lesbian couples and families, and practical applications of family social work.',
  },
  {
    course_code: 'SOW4403',
    course_name: 'Social Work Research Foundations',
    course_desc:
      'Introduction to scientific strategies used to evaluate social work practice and theory. The different strategies covered range from participant and observational techniques, to controlled experimentation. Ethical/value dilemmas involved in social science research are also covered.',
  },
  {
    course_code: 'SOW4510',
    course_name: 'Social Work Field Instruction',
    course_desc:
      'Field education experience in social service agency with a qualified professional supervisor. A minimum of 400 hours is required. Restricted to social work majors. Graded on a satisfactory/unsatisfactory basis only.  Eighteen semester hours of required social work courses, 2.5 GPA in major, and permission is required. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'SOW4522',
    course_name: 'Senior Seminar',
    course_desc:
      'Designed to integrate previously learned beginning generalist practice concepts, values, knowledge, attitudes and skills with practice. Eighteen semester hours of required social work courses, 2.5 GPA in major, and permission is required.',
  },
  {
    course_code: 'SOW4674',
    course_name:
      'Social Issues and Intervention Strategies in Social Work Practice with Older Adults',
    course_desc:
      'Embraces an interdisciplinary approach to intervention strategies to eliminate or ameliorate problems/crises faced by aging clients. Demographics are addressed.',
  },
  {
    course_code: 'SOW4700',
    course_name: 'Substance Abuse Prevention and Treatment: Special Issues',
    course_desc:
      'Historical, legal, ethical, and social issues relating to drug abuse prevention and treatment. The family unit will serve as a basic focus for the area of prevention. Various treatment approaches will be covered from outpatient counseling to therapeutic communities. Offered concurrently with SOW5710; graduate students will be assigned additional work.',
  },
  {
    course_code: 'SOW4740',
    course_name: 'Dimensions of Death and Dying: Special Issues',
    course_desc:
      'Assists the student, both personally and as a professional helping others, to approach death and dying with enhanced knowledge, sensitivity, and less dread and denial. Examines historical, social, legal, cultural, and interpersonal aspects of death and bereavement within the context of professional practice. Offered concurrently with SOW 5745; graduate students will be assigned additional work. Credit cannot be received for both SOW 4682 and SOW4740.',
  },
  {
    course_code: 'SOW4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SOW4941',
    course_name: 'Immersive Experiences in Social Work',
    course_desc:
      'This course offers students an opportunity to immerse themselves in intensive experiential learning though study abroad or study away.  The course examines historical, cultural, social, economic, and political aspects of terra incognita, integrating key elements of the social work profession through the lens of social, political, and economic justice.  A focus on the acquisition of 21st Century skills related to career development (e.g. global awareness, initiative and self-direction, flexibility and adaptability, social and cross-cultural skills, critical thinking and problem solving, etc.) will be emphasized.  Offered concurrently with SOW5942; graduate students will be assigned additional work.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'SOW5105',
    course_name: 'Human Behavior in the Social Environment',
    course_desc:
      'This foundation year class presents a bio-psycho-socio-spiritual and ecosystems framework that introduces students to a macro, mezzo, and micro systems perspective. A major focus of the course is on the analysis of diversity within these systems as well as an examination of power and privilege. The person-in-environment framework provides students with an understanding of human adaptation and the various forces that support or impede well-being. Models for understanding human development are introduced. An overview of social functioning throughout the lifecycle within the context of the social environment is covered.',
  },
  {
    course_code: 'SOW5106',
    course_name: 'Human Behavior in Communities and Organizations',
    course_desc:
      "This foundation year course focuses on Human Behavior in Organizations and Communities. The course familiarizes students with the intervention strategies of community organization. Emphasis is placed on the social worker's role as change agent and models and strategies for community organizing. Content related to values and ethics of community organization in relation to the client, the organization, and the community is covered. Intervention plans are highlighted which focus on planned change efforts and containing strong evaluation plans are utilized in working with human service agencies serving vulnerable populations.",
  },
  {
    course_code: 'SOW5128',
    course_name: 'Cognitive Behavioral Therapy',
    course_desc:
      'This course focuses on cognitive behavioral therapy, clinical decision making, advanced clinical interventions, while building on a generalist approach to social work practice. The course utilizes the clinical-community concentration prerequisites and an understanding of normal development and psychopathology as a foundation for advanced practice. It examines ways in which cognitive behavioral theory and model of intervention with individuals, families and groups can be tailored to client needs. The course addresses work with clients across the life cycle who are experiencing a variety of problems and difficulties. Methods of enhancing adaptive functioning and resiliency through cognitive behavioral therapy are emphasized. Permission is required.',
  },
  {
    course_code: 'SOW5149',
    course_name: 'Social Work Practice In The Military',
    course_desc:
      'A comprehensive and in depth examination of the practice of military social work. The course provides a historical context and a thorough review of the specific practice of social work in the \nU.S. military.',
  },
  {
    course_code: 'SOW5218',
    course_name: 'Analysis of Social Service Policy',
    course_desc:
      'This course will examine social work as a policy-based profession and how social welfare policy is a central concern to the social work profession. This course also addresses policy practice roles such as planner, administrator, policy analyst, and program evaluator. This course will review ways to improve human services delivery systems through the application of problem-solving, critical thinking, and other necessary skills.',
  },
  {
    course_code: 'SOW5305',
    course_name: 'Generalist Practice I',
    course_desc:
      'This is the first course in a two-course sequence which covers generalist social work practice. This course covers basic generalist practice skills in the beginning phase of the helping process with individuals and families. Basic communication and interviewing skills essential to the helping relationship are introduced and practiced. Students learn the tasks and skills required in the beginning phase of practice: preparation, engagement, first interviewing skills and case documentation. Students learn the process of collecting relevant social, psychological, cultural, economic, and biological data from both individuals and families, as well as the process of organizing and analyzing these data for purposes of problem formulation. Case management as a form of social work is examined, along with historical and contemporary perspectives on the case management process, with a focus on advocacy roles. Throughout the course, emphasis is placed on practice skills through the use of interactive exercises and role plays utilizing case examples representative of the client populations with which the students work.',
  },
  {
    course_code: 'SOW5324',
    course_name: 'Generalist Practice II',
    course_desc:
      'This is the second course in the Generalist Practice sequence. This course continues to build the generalist skills, of practice with individuals, families, and groups, with the addition of community practice concepts. In this course the skills and intervention roles relevant to the middle and end phases of interventions with individuals, families, groups, and communities will be covered in more detail. Throughout the course emphasis will be placed on the practice and application of skills by using interactive exercises and role plays using case examples form client populations with whom students work.',
  },
  {
    course_code: 'SOW5356',
    course_name: 'Play Therapy: Theory and Techniques',
    course_desc:
      'Students will learn the theoretical underpinnings of play therapy and the techniques by which the theory is practiced. Permission is required.',
  },
  {
    course_code: 'SOW5404',
    course_name: 'MSW Research Foundations',
    course_desc:
      'An introduction to research methodology in the evaluation of social work practice and program evaluation.',
  },
  {
    course_code: 'SOW5532',
    course_name: 'Foundation Year Field Instruction and Integrative Seminar',
    course_desc:
      "This course is designed to integrate the foundation curriculum course content and field education experience utilizing a generalist approach. Agency based casework experiences and seminar discussions provide an opportunity to gain professional and peer feedback regarding acquisition of generalist practice skills. Focus will include critical thinking skills regarding the application of social work knowledge to the solution of client problems. Issues related to social work values and ethics, diversity, social and economic justice, populations-at risk, HBSE, social welfare policy and services, practice, and research are examined within the context of the student's field education experience.",
  },
  {
    course_code: 'THE3062',
    course_name: 'Theatre Ireland Experience',
    course_desc:
      'Research and explore the culture and history of Ireland through the regional festivals, and work with Carlow College.  The class will meet with a variety of faculty from Carlow College and do field research based on lectures given at the college.',
  },
  {
    course_code: 'SOW5629',
    course_name: 'MSW Human Diversity and Social Justice',
    course_desc:
      'This course examines the impact of social, economic, and political environments on diverse populations specifically race, gender, age, ethnicity, social class, sexual orientation, gender identity, religion, and physical and mental ability. This course integrates the key elements of the social work profession through the lens of social, political, and economic justice. It includes the history, and philosophical foundations of social welfare, community organization, and social action strategies and tactics. Included are effects of cultural and group differences, the results of oppression, economic systems, and social policies on social work professional practice.',
  },
  {
    course_code: 'SOW5710',
    course_name: 'Substance Abuse Treatment: Theories, Practices, and Policies',
    course_desc:
      'This course is designed to provide students with background on the multiple issues associated with substance use and mental health disorders.  This course will address substance abuse terminology, classification of substances, substance abuse/mental health policy and ethical dilemmas. Students will gain knowledge on evaluating, assessing, and developing treatment plans using evidence-based approaches for working with substance users and their families.',
  },
  {
    course_code: 'SOW5757',
    course_name: 'The History, Philosophy, and Theory of Social Work Practice',
    course_desc:
      'This course examines the current structure of social welfare programs in the United States, their historical evolution, and the role ideological, political, economic, and social forces have played in the development of the social welfare system and its present character focusing on social and economic injustice in the United States. Also discusses the impact of social welfare policies on clients, agencies, service delivery, and social work practice. Students are provided an overview of the historical development, philosophical orientation, basic values, principles and knowledge base, and practice of the profession. The course will examine critical social problems that impact societies with an emphasis on the quest for social justice at local, national and global levels. Various perspectives on social welfare, social work as a profession, and many of the core concepts of the profession will be introduced. Content will cover major concepts and perspectives to include issues in poverty, child welfare, criminal justice, health and mental health, values, ethics, and working with a diverse and vulnerable population of individuals and families, ethnicity, minorities, women, gays and lesbians, aging, and disabled people.',
  },
  {
    course_code: 'SOW5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SOW5942',
    course_name: 'Immersive Experiences in Social Work',
    course_desc:
      'This course offers students an opportunity to immerse themselves in intensive experiential learning though study abroad or study away.  The course examines historical, cultural, social, economic, and political aspects of terra incognita, integrating key elements of the social work profession through the lens of social, political, and economic justice.  A focus on the acquisition of 21st Century skills related to career development (e.g. global awareness, initiative and self-direction, flexibility and adaptability, social and cross-cultural skills, critical thinking and problem solving, etc.) will be emphasized.  Offered concurrently with SOW4941; graduate students will be assigned additional work.',
  },
  {
    course_code: 'SOW6125',
    course_name: 'Psychopathology for Social Work',
    course_desc:
      'This course addresses patterns of human behavior and psychosocial functioning commonly conceptualized as psychopathology.  The course addresses such concepts as function, mental health, mental illness, normality and abnormality.  Prevalent categories of psychiatric disorders are considered as to their labeling process, differentiating characteristics, explanatory theories and relevance for social work practice. This course is open to students admitted to the MSW program only.',
  },
  {
    course_code: 'SOW6345',
    course_name: 'Social Work Leadership, Management and Supervision',
    course_desc:
      'Introduction to the values, principles and functions that provide the foundation for effective leadership and management practice in the field of social work. Students will receive an overview of styles and skills used in social work leadership, management and supervision which are appropriate to both clinical and community social work practice settings. This course will provide students with values, principles and strategies for leading teams, problem-solving, and supporting multicultural and diverse staffing in social work agencies. Department Permission is required.',
  },
  {
    course_code: 'SOW6432',
    course_name: 'Evaluation of Social Work Practice',
    course_desc:
      'The second of two required courses in the social work practice in research sequence.  This advanced curriculum course builds on the knowledge and skills acquired in the foundation research course.  The focus of this course is on the advanced skills necessary to effectively evaluate practice.  The course utilizes single subject design and program evaluation techniques that are grounded in the social sciences and social work literature.  Particular attention will be paid to the ethical issues of conducting research with oppressed and vulnerable populations.This course is open to students admitted to the MSW program only.',
  },
  {
    course_code: 'SOW6535',
    course_name: 'Advanced Year Field Instruction and Integrative Seminar I',
    course_desc:
      'Integrates theoretical models and concepts with practical experience gained in concurrent field education. Integrates skills and knowledge acquired through the entire social work curriculum. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'SOW6536',
    course_name: 'Advanced Year Field Instruction and Integrative Seminar II',
    course_desc:
      "This is the second of two advanced master's level field internship and integrative seminars. Assists social work graduate students in integrating theoretical models and concepts with practical experience gained in concurrent field education. Integrates skills and knowledge acquired through the entire social work curriculum. Material and Supply Fee will be assessed.",
  },
  {
    course_code: 'SOW6548',
    course_name: 'Capstone in Advanced Clinical Practice',
    course_desc:
      'Capstone course in clinical-community social work practice. Student analysis of practice with individuals, families, and group through a written and oral presentation of case material. Focus is on refinement of intervention skills relying on field practicum experience for integration of learning. Integration of knowledge from the Clinical Practice courses and Field Instruction. Students will prepare and present a case from their internship for oral presentation and demonstrate ability to organize and select appropriate treatment strategies for a specific client, family, or group. A broad range of field placements will provide diverse clients and a range of clinical issues. Students are expected to show evidence of critical thinking and self-awareness in written and oral presentations.',
  },
  {
    course_code: 'SOW6618',
    course_name: 'Clinical Practice with Individuals',
    course_desc:
      'This course builds on the knowledge base of generalist social work practice and expands and deepens that base.  The course emphasizes advanced assessment of clients across the life span, trauma assessment, and beginning evaluation of practice skills.  Treatment planning with individuals is stressed.  Building on the generalist practice base for analyzing and interpreting bio-psycho-socio-spiritual content, interpreting and implementing professional values and ethics and utilizing the professional helping relationship, this course expands and deepens that base by introducing an advanced clinical practice base of clinical-community social work.  Major contemporary theories of psychotherapy will be introduced, including cognitive-behavioral, experiential, interpersonal, and integrative therapies. We will investigate clinical processes as they are informed by psychopathology and developmental issues across the life cycle, as well as institutionalized oppression, poverty, racism, sexism, heterosexism and other inequities.  This course is open to students admitted to the MSW program only.',
  },
  {
    course_code: 'SOW6619',
    course_name: 'Clinical Practice with Families',
    course_desc:
      'Clinical decision-making and advanced clinical interventions by building on a generalist approach to social work practice. Utilizes the clinical community concentration prerequisites to examine normal development and psychopathology as a foundation for advanced practice. Examines specific theories and models of intervention with individuals, families, and groups that can be tailored to client needs. Addresses work with clients across the life cycle with diverse issues. The impact of poverty, racism, sexism, and manifestations of institutionalized oppression upon clients and workers are addressed at an advanced level. Methods of enhancing adaptive functioning and resiliency are emphasized. Students will be expected to demonstrate clinical expertise, an understanding of social work ethics and values, incorporate client preferences, utilize critical thinking skills, and apply empirical evidence to practice decisions.  This course is open to students admitted to the MSW program only.',
  },
  {
    course_code: 'SOW6678',
    course_name: 'Grief, Loss, and Life',
    course_desc:
      "Introduction to the current and historical perspectives of death, dying and bereavement. This course will address experiences and responses to a variety of deaths including   perinatal death, death of a child, death following a terminal illness, suicide, homicide, and military related death. The Hospice movement's history and goals will be part of the curriculum, as well as the experience of dying well. Special attention will be given to how other cultures and religions view death and ethical dilemmas related to death. Loss is a central and inescapable dimension of the human experience. How an individual learns to deal with loss from an early age shapes the adjustment that s/he is able to make to adverse life events throughout the life cycle and indeed determines to a large extent how satisfying and creative a life that person is able to live. This course will help the social work clinician explore and understand major theories of grief and loss, as well as treat clients of all ages who are dealing with a variety of losses. It will also assist the generalist practitioner in determining those situations in which an unresolved past experience of loss is contributing to poor adjustment in the present, as well as providing guidelines for helping the client grieve in a way that allows him or her to re-establish a sense of meaning, adapt to what is gone, and move on to live with increased vitality and joy.",
  },
  {
    course_code: 'SOW6846',
    course_name: 'Clinical Practice with Groups',
    course_desc:
      'The advanced social work practitioner is required to demonstrate group skills in a wide variety of practice situations. The focus of this course is on the design and implementation of group treatment services for at risk populations of varying ages, social situations and composition. Students will be afforded the opportunity to develop a clear sense of the scope, uses and skills of group work in the social work profession.  This course is open to students admitted to the MSW program only.',
  },
  {
    course_code: 'SOW6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SOW6916',
    course_name: 'Mind/Body Practice and Positive Psychology',
    course_desc:
      "A focus on research from the last 25 years that has revolutionized our knowledge of brain function, its relation to overall coping, and specific practices that promote resilience and well-being. It will be an important contribution to the social work curriculum at the master's level because it revolves around a strengths perspective that social work has always embraced, as well as teaching the advanced practitioner specific skills that s/he can use to help clients in the process of improving their lives. The course will be richly multicultural and will also include ancient wisdom from the humanities that supports this new evidence-based field of mind-body interaction. Department Permission is required.",
  },
  {
    course_code: 'SPC2608',
    course_name: 'Basic Communication Skills',
    course_desc:
      'Emphasizes the link between the fundamental theories in speech communication and effective public speaking. Includes practical training and study in public presentation skills, audience analysis, speech construction and problem solving using lecture and experiential learning format. Credit may not be received in both SPC2608 and SPC 2016.\nMeets General Education requirement in Humanities.',
  },
  {
    course_code: 'SPC3301',
    course_name: 'Interpersonal Communication',
    course_desc:
      'Emphasizes the link between interpersonal communication skills and relationship building in personal and professional contexts. Includes components on self-awareness, impression management, rapport building, developing intimacy, managing conflict, ethical use of interpersonal power, diversity issues, leadership, and using technology to facilitate interpersonal communication. Involves hands-on service learning project that provides the opportunity to practice interpersonal skills in a professional setting.',
  },
  {
    course_code: 'SPC3593',
    course_name: 'Practicum in Forensics',
    course_desc:
      'Active forensics participation through library research, topic analysis, discussion, practice and travel to intercollegiate tournaments. Permission is required. Credit may not be received in both SPC3593 and SPC 3594.',
  },
  {
    course_code: 'SPC3605',
    course_name: 'Great Speeches in American History',
    course_desc:
      'Practical application in writing, analyzing, and delivering speeches for a variety of professional and social rhetorical situations.',
  },
  {
    course_code: 'SPC3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SPC4540',
    course_name: 'Propaganda and Persuasion',
    course_desc:
      'Explores persuasion theory of persuasive activity at a variety of turns in the modern world. Special focus is on social movements, political campaigns and advertising. Seeks to gain a clearer understanding of how persuasive strategy works, from where it emerges and why and how we are affected by it.',
  },
  {
    course_code: 'SPC4680',
    course_name: 'Rhetorical Criticism',
    course_desc:
      'The rationale, methods, and applications of rhetorical criticism. Goal is to improve understanding and evaluation of real-world persuasive communication. Lecture and reading materials are divided into two main units. First is the general nature of both rhetoric and criticism, providing a basic conceptual framework for the identification and analysis of rhetorical artifacts. Second is a survey of nine contemporary critical approaches; cluster criticism, fantasy-theme criticism, feminist criticism, genre criticism, ideological criticism, metamorphic criticism, narrative criticism, pentadic criticism, generative criticism.',
  },
  {
    course_code: 'SPC4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SPC6545',
    course_name: 'Persuasion',
    course_desc:
      'Familiarizes students with major theories, areas of research, and ethical issues in the social scientific study and application of persuasion.',
  },
  {
    course_code: 'SPC6646',
    course_name: 'Strategic Approaches to Presentational Speaking',
    course_desc:
      'Emphasizes advanced rhetorical theory, executive-level presentational speaking skill set development, and a diverse array of analytic tools used for context and public audience analysis. Focuses on the strategic application of these analytic and performance tools to instances of public and professional advocacy.',
  },
  {
    course_code: 'SPC6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SPM2010',
    course_name: 'Sport in Global Society',
    course_desc:
      'The course examines the ways in which sport contributes to or inhibits the formation of positive cultural or societal norms. The topics addressed in the course demonstrate the diversity of social impacts sport has had on global society and culture. Historical and contemporary cases are used to illustrate the impacts of sport in different social contexts.\nMeets General Education requirement in Social Sciences.',
  },
  {
    course_code: 'SPM3004',
    course_name: 'Introduction to Contemporary Sport Management',
    course_desc:
      "Introduction to the field of sport management required for all students in the major and available to students interested in working in the sport industry.  Provides an overview of sport management rather than detailed instructions about how to manage sport enterprises. It serves as a foundation for students' further studies in various subject areas in the field/profession of sport management,\nsuch as sport marketing, sport law, sport facility and event management, economics of sport, sport finance, etc.",
  },
  {
    course_code: 'SPM3104',
    course_name: 'Sport Facility and Event Management',
    course_desc:
      'This course is designed to provide students an overview of the major components of both facility and event management: planning, financing, marketing, implementation, and evaluation. The course focuses on a broad range of facilities and events to demonstrate the diversity of the industry, touching on various topics relating to recreation, leisure, health, and fitness. The objective of the course is to provide a working knowledge of how to manage sport facilities and how to plan, manage, implement, and evaluate sport events.',
  },
  {
    course_code: 'SPM3115',
    course_name: 'Organizational Management and Leadership in Sport',
    course_desc:
      'Organizational behavior, management, and leadership issues specific to the sport business environment. Students will gain knowledge of management and leadership best practices in sport business. Students will also learn how a variety of management and leadership practices impact sport organizations.',
  },
  {
    course_code: 'SPM3306',
    course_name: 'Sports Marketing',
    course_desc:
      'Topics and issues involved in the promotion and marketing of sporting events, products, and services will be discussed.  Examination of the evolution, theories, and practical applications of marketing strategies and current issues relative to social, political, ethical, and cultural     environments will be presented. Open only to Juniors and Seniors.',
  },
  {
    course_code: 'SPM3403',
    course_name: 'Sport Media',
    course_desc:
      "Examines the role media plays in contemporary sports, the relationship between sports and sports media, and how these two entities influence the public's perception of sport as a growing industry. Examines the many professional careers associated with sports media including sports information, public/media relations, journalism, and broadcasting.",
  },
  {
    course_code: 'SPM3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SPM3941',
    course_name: 'Sport Management Internship',
    course_desc:
      'The Sport Management Internship course provides students with an opportunity to explore their career interests and apply classroom knowledge and skills in a professional setting. The internship also allows students to begin to build a professional network. Students must enroll a minimum of 3 credit hours as pre-/co-requisite to enroll SPM4945, Senor Capstone in Sport Management. The course credit hours can also range from an additional 1-6 hours to meet the needs of the student and the internship site as a major elective.',
  },
  {
    course_code: 'SPM4003',
    course_name: 'Sport Management Careers Seminar',
    course_desc:
      "Designed to prepare and assist students entering the workforce by completing a field experience and participating in classroom discussions.  Students will learn job seeking skills including job searching, creating quality application documents, interviewing, networking, and professionalism.  The primary objective of this course is to have students secure their ideal internship. It is taken the semester prior to students' internship/capstone course. Must complete 12 hours of SPM 3/4000 level courses.",
  },
  {
    course_code: 'SPM4012',
    course_name: 'Sociology of Sport',
    course_desc:
      "Students are introduced to the fundamental concepts of sports and sociology and examine various social phenomena taking place relating to sports such as violence and sports in schools and colleges. It introduces students to an array of social theories that apply to analyzing some social issues related to sports such as race and ethnicity, gender, social class, politics, and religion. This course will generate the awareness for students to understand the importance of, and paying attention to, the social functions of sports played in today's society.",
  },
  {
    course_code: 'SPM4503',
    course_name: 'Economic Issues in Sport',
    course_desc:
      'The course includes a review of the foundations of economics and their applications in the sport industry. Students will learn how leagues and teams function most efficiently to meet their goals of profit and/or win maximization.',
  },
  {
    course_code: 'SPM4604',
    course_name: 'Governance in Sport',
    course_desc:
      'This course is designed to introduce sport management students the concepts on how sport is governed. Students will investigate the history, philosophy, and current governance practices of major North American sport. Students will critically analyze different segments of the sport industry, learn about the characteristics of a governing body, and analyze the role of policy in sport governance.',
  },
  {
    course_code: 'SPM4723',
    course_name: 'Sport Law and Risk Management',
    course_desc:
      "An introduction to the legal concepts that may significantly affect one's career in management of amateur or professional sports, and of other areas in sport operations. Topics of discussion primarily focus on the legal issues involved in business practices in the sport industry using a case analysis format.  Open only to Juniors and Seniors.",
  },
  {
    course_code: 'SPM4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SPM4945',
    course_name: 'Senior Capstone in Sport Management',
    course_desc:
      'This capstone course for Sport Management majors provides opportunities for students to demonstrate their learning of sport management theories through practices. Students must enroll 3 sh of SPM3941 Sport Management Internship as a co-requisite to enroll this course. Students complete the coursework on various topics to ensure their accomplishment of the student learning outcomes designed for the course as well as for the sport management program. Approval by academic advisor and sport management program coordinator are required.',
  },
  {
    course_code: 'SPN1120C',
    course_name: 'Spanish I',
    course_desc:
      'For students with no knowledge of Spanish or with less than two years of high school Spanish. Lays a foundation for speaking, writing, and reading Spanish. In addition to the three hours of scheduled classroom time, students are required to do one hour of laboratory work per week.  This course is not available for native speakers.',
  },
  {
    course_code: 'SPN1121C',
    course_name: 'Spanish II',
    course_desc:
      'This is a continuation of SPN1120C, a proficiency-oriented course, emphasizing the mastery of the basic skills of the language. An integrated (multi-media) approach to develop proficiency in all the basic language skills: listening/understanding, speaking, reading, writing and cross-cultural awareness. Students will build on their ability to understand frequently used words in oral contexts, as well as understand and respond appropriately to simple phrases and questions. Emphasis is placed on practical vocabulary and accurate pronunciation.  This course is not available to native speakers. Pre-requisite is SPN1120C (minimum grade of C) or successful completion of a placement test.',
  },
  {
    course_code: 'SPN1905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SPN2200',
    course_name: 'Intermediate Reading and Translation',
    course_desc:
      'The purpose of this course is to offer opportunities for students to develop their language skills. The course will emphasize intensive practice in reading, translation and conversation. For students who have previous experience in Spanish, but are not yet prepared for advanced work in the language. Pre-requisite: SPN1121C (minimum grade of C) or successful completion of a placement test.',
  },
  {
    course_code: 'SPN2210',
    course_name: 'Intermediate Composition & Conversation',
    course_desc:
      'Practical oral and written communication course designed to assist students in improving their abilities to speak, listen, write, and read Spanish. For students who have previous experience in Spanish, but not yet prepared for advanced work in the language. Pre-requisite: SPN1121C (minimum grade of C) or successful completion of a placement test.',
  },
  {
    course_code: 'SPN2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SPN3400',
    course_name: 'Advanced Stylistics',
    course_desc:
      'Increasing and improving language skills. Classes conducted in Spanish.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'SPN3410',
    course_name: 'Composition and Conversation',
    course_desc: 'Skill in writing and speaking Spanish.',
  },
  {
    course_code: 'SPN3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SPN4520',
    course_name: 'Latin American Culture and Civilization',
    course_desc:
      'Cultural and historical backgrounds of Latin American literature.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'SPN4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SPW3190',
    course_name: 'Topics in Hispanic Literature',
    course_desc:
      'An introduction to the literary analysis of selected Hispanic Texts, using readings and film, discussions and writing assignments. Normally offered in Spanish (it could also be taught in English), it will be aimed at intermediate to native Spanish speakers with an interest in Hispanic--Spanish and / or Latin American--literature. It will enhance language skills and foster an appreciation of Hispanic culture, adding the challenge of applying critical analysis to selected texts in Hispanic literature.',
  },
  {
    course_code: 'SPW3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SPW4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SPW6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SSE3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SSE4113',
    course_name: 'Social Studies for Elementary Teachers',
    course_desc:
      'This course will provide students with instructional strategies and materials for teaching a contemporary program in social studies in the elementary school. Students will creatively interact with history, geography, civics and economics.  Particular attention will be paid to citizenship education, multicultural understandings and 21st century models for teaching social studies.',
  },
  {
    course_code: 'SSE4324',
    course_name: 'Teaching Social Studies in the Middle and Secondary Schools',
    course_desc:
      'This course will provide students with instructional strategies and materials for teaching a contemporary program in social studies in the secondary school. Students will creatively interact with history, geography, civics and economics. Particular attention will be paid to citizenship education, multicultural understandings and 21st century models for teaching social studies.',
  },
  {
    course_code: 'SSE4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SSE6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SSE7905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'STA2023',
    course_name: 'Elements of Statistics',
    course_desc:
      'STA2023 covers descriptive statistics, elementary probability theory, and basic statistical procedures, estimation, and inference. In addition to provide basic concepts in the mentioned areas it prepares the student for other more advanced statistical courses that are necessary for research.\nMeets General Education requirement in Mathematics.\nMeets Gordon Rule Applied Mathematics Requirement.',
  },
  {
    course_code: 'STA3162C',
    course_name: 'Applied Statistics',
    course_desc:
      'Inferential statistics from an applied point of view. Probability and sampling distributions, confidence intervals and hypothesis testing, ANOVA, correlation, simple and multiple linear regressions. SAS computer techniques. Lab required.\nMeets Gordon Rule Applied Mathematics Requirement.',
  },
  {
    course_code: 'STA3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'STA4051',
    course_name: 'Nonparametric Statistics',
    course_desc:
      'The nonparametric or distribution-free methods can be useful in cases such as (i) no assumptions about the underlying population distribution is made, (ii) the data can be categorical or ranked, such as good or bad. This course provides an introduction of some key concepts of nonparametric statistics. Students will learn Why, When, and How to apply nonparametric techniques. This course covers several nonparametric tests as it is described below in Topics.',
  },
  {
    course_code: 'STA4173',
    course_name: 'Biostatistics',
    course_desc:
      'A second course in statistics for students in the Biological Sciences. Topics covered include analysis of variance, regression analysis, nonparametric statistics, contingency tables. Offered concurrently with STA5176; graduate students will be assigned additional work.\nMeets Gordon Rule Applied Mathematics Requirement.',
  },
  {
    course_code: 'STA4222',
    course_name: 'Sampling Theory',
    course_desc:
      'A first course in sampling methods with application to survey sampling and field sampling. Topics include simple random sampling, stratified sampling, cluster sampling, systematic sampling, and adaptive sampling and corresponding estimates for these sampling designs.',
  },
  {
    course_code: 'STA4234',
    course_name: 'Regression Analysis',
    course_desc:
      'Simple Linear Regression, Multiple Linear Regression, Model Adequacy Checking, Transformations and Weighting to Correct Model Inadequacies, Diagnostics for Leverage and Influence, Polynomial Regression Models, Indicator Variables, Multicollinearity, Variable Selection and Model Building, Validation of Regression Models, Introduction to Logistic Regression.',
  },
  {
    course_code: 'STA4321',
    course_name: 'Introduction to Mathematical Statistics I',
    course_desc:
      'Probability, conditional probability, distributions of random variables, distribution of functions of random variables, limiting distributions, multivariate probability distributions. Offered concurrently with MAP 5XX1 (Introduction to Mathematical Statistics I); graduate students will be assigned additional work.\nMeets Gordon Rule Applied Mathematics Requirement.',
  },
  {
    course_code: 'STA4322',
    course_name: 'Mathematical Statistics II',
    course_desc:
      'Point and interval estimates, measures of quality of estimates, Bayesian estimates, robust estimation, statistical hypothesis testing, including goodness of fit, contingency tables and ANOVA, SPR test, the Cramer-Rao inequality, multiple comparisons, completeness, distributions of quadratic forms, multivariate normal distributions.\nMeets Gordon Rule Applied Mathematics Requirement.',
  },
  {
    course_code: 'STA4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'STA5108',
    course_name: 'MathStat Tools',
    course_desc:
      'MathStat Tools will cover computer-oriented statistics projects\nusing various software programs. This course provides students with a fundamental hands-on experience with SAS, R, Matlab, and Latex. Topics include data manipulation and\nmanagement, statistical and mathematical functions, and common statistical procedures\nand techniques. Successful completing assignments require a mix of computing and statistics/mathematics.',
  },
  {
    course_code: 'STA5176',
    course_name: 'Statistical Modeling',
    course_desc:
      'This course will provide further examination of statistics and data analysis beyond an introductory course. Topics covered include data visualization, point, and interval estimation, hypothesis testing of means, variances, and proportions, and linear and logistic regressions. Emphasis will be placed on conducting reproducible research.',
  },
  {
    course_code: 'STA5326',
    course_name: 'Statistical Inference',
    course_desc:
      'This course is an advanced course in mathematical statistics. It is more theoretical than an applied statistics course and takes a mathematical approach to problem solving. Some theorems will be proved. There will be some "real world" applications of the theory.',
  },
  {
    course_code: 'STA5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'STA6235',
    course_name: 'Modeling in Regression',
    course_desc:
      "Several advanced topics in regression are covered, such as nonlinear regression, influence diagnostics, Eigensystem analysis of X'X matrix, logistic regression, ridge regression, robust regression, and generalized linear models.",
  },
  {
    course_code: 'STA6246',
    course_name: 'Design and Analysis of Experiments',
    course_desc:
      'Further concepts in design and analysis of planned experiments with emphasis on confounding and fractional replications of factorial experiments; composite designs; incomplete block designs; estimation of variance components.',
  },
  {
    course_code: 'STA6257',
    course_name: 'Advanced Statistical Modeling',
    course_desc:
      'This course will cover advanced statistical models, enabling students to model various discrete and continuous outcomes. The focus will be determined by instructor and may include such analyses as generalized linear analysis, nonlinear regression analysis, or spatial cluster analysis. In addition to advanced models, the course will include model constructions, model fi\nt, interpretation of results, and dissemination of results.',
  },
  {
    course_code: 'STA6507',
    course_name: 'Nonparametric Statistics',
    course_desc:
      'Extensive coverage of goodness-of-fit tests, location problems, association analysis and general nonparametric topics.',
  },
  {
    course_code: 'STA6666',
    course_name: 'Statistical Quality Control I',
    course_desc:
      'Procedures used in acceptance sampling and statistical process control are based on concepts and theory from probability and statistics. Introduces the applications of these procedures, investigates them from the standpoint of their statistical properties and develops the methodology for construction, evaluation and comparison of procedures.',
  },
  {
    course_code: 'STA6707',
    course_name: 'Multivariate Methods',
    course_desc:
      'This course provides some of the concepts and methods of Multivariate analysis in order to describe and analyze multivariate data. Students will be introduced to multivariate extensions of Chi-Square and t-tests; discrimination and classification procedures; applications to diagnostic problems in biological, medical, anthropological and social research; multivariate analysis of variance; factor analysis and principal components analysis.',
  },
  {
    course_code: 'STA6856',
    course_name: 'Time Series Analysis',
    course_desc:
      'Time series data are time-oriented data that can be used to forecast future values or to analyze data. This course provides students with a fundamental understanding of the nature and basic processes used to analyze such data. This course also introduces the theory and practice of time series analysis, with an emphasis on practical skills. Successful completion of assignments requires a mix of computing and statistics/mathematics.',
  },
  {
    course_code: 'STA6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'STA6912',
    course_name: 'Statistics Research 1',
    course_desc:
      'This course gives students the opportunity to engage in group and independent research projects. Research topics and materials vary according to instructor. Technical reports and oral presentations are expected of each student. Students must have completed 15 hours of graduate course work in the program and have maintained at least a 3.0 GPA. Students must also commit to both fall and spring sections of the course.',
  },
  {
    course_code: 'STA6913',
    course_name: 'Statistics Research 2',
    course_desc:
      'This course gives students the opportunity to engage in group and independent research projects. Research topics and materials vary according to instructor. Technical reports and oral presentations are expected of each student.',
  },
  {
    course_code: 'STA6930',
    course_name: 'Proseminar in Statistics',
    course_desc:
      'Each M.A. candidate (except those who choose the thesis option), shall, under the direction of a project advisor, independently investigate a topic or topics in mathematics/statistics or mathematics education through the study of journal articles or other appropriate sources. The candidate shall submit a formal written report and make an oral presentation of the results of his/her investigations. The goal of the proseminar is to provide students an opportunity to integrate the total experience gained during their graduate training. Graded on satisfactory / unsatisfactory basis only. MA candidacy and permission is required.',
  },
  {
    course_code: 'STA6950',
    course_name: 'Capstone Projects in Statistics',
    course_desc:
      'This course will give students the opportunity to engage in group and independent research projects. Research topics and materials vary according to the instructor with the thrust being applied or theoretical Statistics. Technical reports and oral presentations will be expected of each student.',
  },
  {
    course_code: 'STA6971',
    course_name: 'Thesis',
    course_desc:
      'Graded on satisfactory / unsatisfactory basis only. Permission is required.',
  },
  {
    course_code: 'SYA3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SYA4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SYA5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SYA6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SYA7905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SYD3810',
    course_name: "Introduction to Women's Studies",
    course_desc:
      'Examination of the economic, political, social and cultural positions of women in the past and now in American society. Also examines social roots of their self-concepts, values, beliefs and perceptions.',
  },
  {
    course_code: 'SYD3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SYD4800',
    course_name: 'Sociology of Sex Roles',
    course_desc:
      'Changing sex roles in American society with particular attention to socialization and sex-differentiated roles in social institutions.',
  },
  {
    course_code: 'SYD4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SYD5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SYD6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SYG2000',
    course_name: 'Introduction to Sociology',
    course_desc:
      'Fundamental principles concerning social relationships, social interaction and social structure.\nMeets General Education requirement in Social Sciences.',
  },
  {
    course_code: 'SYG2010',
    course_name: 'Current Social Problems',
    course_desc:
      'Major social issues affecting individuals in groups in modern industrial societies. Not open to students with Social Problems as lower division course.\nMeets General Education requirement in Social Sciences.',
  },
  {
    course_code: 'SYG3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SYG4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SYG5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SYG6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SYO3100',
    course_name: 'The Family',
    course_desc:
      'Social and psychological aspects of interpersonal relationships within the family. Emphasis on modern problems of family.',
  },
  {
    course_code: 'SYO3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'THE2000',
    course_name: 'Theatre Appreciation',
    course_desc:
      'This course is an introduction to theatre from an audience perspective. It is designed to build an appreciation and understanding of the theatre and of the many disparate processes used to create theatrical productions. The course will present the current and historical context of how theatre informs and inspires an audience.\nMeets General Education requirement in Humanities.',
  },
  {
    course_code: 'THE2300',
    course_name: 'Survey of Dramatic Literature',
    course_desc:
      'Survey of play scripts representing a succinct history of Western drama.\nMeets General Education requirement in Humanities.\nMeets Gordon Rule Writing Requirement.',
  },
  {
    course_code: 'THE2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SYO4250',
    course_name: 'Sociology of Education',
    course_desc:
      'This course will examine the school, the social organization of schools and school systems, situated in society. It will explore the school in the context of and as a constructed entity in society, interdependent on other institutions, molded by social forces and social norms, and, as an effective  vehicle for promoting multicultural awareness and for meeting the educational needs of the diverse populations. Sociologists who study education utilize various theories and empirical methodologies in order to understand the relationship between schools and society.\nAccordingly, this course will examine the importance of education as a social institution from a sociological perspective. The course will begin by discussing the history and goals of education, as well as the ways in which sociologists have sought to understand this institution. We will then examine important topics including educational inequality, the dynamics of race, class, and gender in education, standardized testing, school choice, and higher education. Offered concurrently with SYO5255; graduate students will be assigned additional work. Instructor permission required.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'SYO4421',
    course_name: 'Sociology of Health, Illness and Health Care',
    course_desc:
      'The sociological study of health, illness and health care places human well-being in a social context. It focuses on the relationship between social conditions and physical and mental health, differences and disparities in health across social groups, as well as health care and health care policy.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'SYO4530',
    course_name: 'Inequality in America',
    course_desc:
      'This course is an introduction to the cultural and structural factors creating and sustaining social inequality by race, ethnicity, gender, class, disability and sexual orientation.\nMeets Multicultural Requirement.',
  },
  {
    course_code: 'SYO4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SYO5255',
    course_name: 'Sociology of Education',
    course_desc:
      'This course will examine the school, the social organization of schools, and school systems, situated in society. It will explore the school in the context of and as a constructed entity in society, interdependent on other institutions, molded by social forces and social norms, and, as an effective  vehicle for promoting multicultural awareness and for  meeting the educational needs of the  diverse populations. Sociologists who study education utilize various theories and empirical methodologies in order to understand the relationship between schools and society.\nAccordingly, this course will examine the importance of education as a social institution from a sociological perspective. The course will begin by discussing the history and goals of education, as well as the ways in which sociologists have sought to understand this institution. We will then examine important topics including educational inequality; the dynamics of race, class, and gender in education; standardized testing; school choice; and higher education.\nOffered concurrently with SYO4250; graduate students will be assigned additional work. Instructor permission required.',
  },
  {
    course_code: 'SYO5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SYO6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SYP3630',
    course_name: 'Popular Culture',
    course_desc:
      'Analysis of the social foundations and cultural ramifications of mass culture with primary reference to American society.',
  },
  {
    course_code: 'SYP3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SYP4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SYP5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'SYP6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'TAX4001',
    course_name: 'Taxation of individuals',
    course_desc:
      'Principles of federal income taxation of individuals. Includes coverage of the income determination and taxation of individuals. Credit may not be received in both TAX4001 and TAX 4002.',
  },
  {
    course_code: 'TAX4012',
    course_name: 'Corporate Income Tax',
    course_desc:
      "Federal income taxation of subchapter C corporations and their shareholders. Includes coverage of incorporation, income determination, income distribution, reorganization, liquidation, and tax preparers' legal and professional responsibilities. Offered concurrently with TAX5105; TAX5105 includes tax research learning objectives that are not included in TAX4012. Credit for both TAX4012 and TAX5105 is not permitted.",
  },
  {
    course_code: 'TAX4316',
    course_name: 'Taxation of Flow-Through Entities',
    course_desc:
      'Principles of income taxation of flow-through entities and their beneficiaries, including partnerships, S corporations, trusts, and estates. Includes coverage of entity formation, income determination, income distribution, and liquidation. Offered concurrently with TAX5317; TAX5317 includes tax research learning objectives that are not included in TAX4316. Credit for both TAX4316 and TAX5317 is not permitted.',
  },
  {
    course_code: 'TAX4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'TAX5105',
    course_name: 'Corporate Income Tax',
    course_desc:
      "Federal income taxation of subchapter C corporations and their shareholders. Includes coverage of incorporation, income determination, income distribution, reorganization, liquidation, and tax preparers' legal and professional responsibilities.  Offered concurrently with TAX4012; TAX5105 includes tax research learning objectives that are not included in TAX4012. Credit for both TAX4012 and TAX5105 is not permitted. TAX4001 is a prerequisite.",
  },
  {
    course_code: 'TAX5317',
    course_name: 'Taxation of Flow-Through Entities',
    course_desc:
      'Principles of income taxation of flow-through entities and their beneficiaries, including partnerships, S corporations, trusts, and estates. Includes coverage of entity formation, income determination, income distribution, and liquidation. Offered concurrently with TAX4316; TAX5317 includes tax research learning objectives that are not included in TAX4316. Credit for both TAX4316 and TAX5317 is not permitted. TAX4001 is a prerequisite.',
  },
  {
    course_code: 'TAX5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'TAX6065',
    course_name: 'Tax Data Bases, Research and Procedure',
    course_desc:
      'Interpretative sources of tax laws and their interrelationships plus an analysis of federal tax procedures at the judicial and administrative level.',
  },
  {
    course_code: 'TAX6405',
    course_name: 'Estate Gift and Trust Taxation',
    course_desc:
      'Estate and gift taxation and Subchapter J with emphasis on family tax planning.',
  },
  {
    course_code: 'TAX6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'THE2925',
    course_name: 'Play Production',
    course_desc:
      'Study and participation in the preparation and production of plays and/or musicals. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'THE3092',
    course_name: 'Theatrical Production & Performance',
    course_desc:
      'Individualized study in all areas of theatrical production and performance through apprenticeship on departmental productions during a semester. Completion of all lower division common prerequisites is required. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'THE3112',
    course_name: 'History of Theatre I',
    course_desc: 'Theatre history from origins through the eighteenth century.',
  },
  {
    course_code: 'THE3113',
    course_name: 'History of Theatre II',
    course_desc: 'Theatre history from eighteenth century through the present.',
  },
  {
    course_code: 'THE3243',
    course_name: 'Musical Theatre History',
    course_desc:
      'History and development of musical theatre from origins to present.',
  },
  {
    course_code: 'THE3287',
    course_name: 'Architecture and Decor',
    course_desc:
      'This course will take students through visual history of architecture and decor from ancient times to present.  Covering architectural changes and the significance of the decor associated with each time period and region.',
  },
  {
    course_code: 'THE3306',
    course_name: 'Dramatic Literature II',
    course_desc:
      'A survey of play scripts representing important contributions from various genres of Western Theatre from the Greeks through contemporary Drama.',
  },
  {
    course_code: 'THE3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'THE4260',
    course_name: 'Costume History',
    course_desc:
      'Historical periods of costume and fashion from ancient times to the present, their relation to theatre history, and potential use as sources for theatrical costume design.',
  },
  {
    course_code: 'THE4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'THE4970',
    course_name: 'Senior Project',
    course_desc:
      'Preparation and completion of performance or design presentation as culminating project for the Bachelor of Fine Arts or Bachelor of Arts degree. Permission is required.',
  },
  {
    course_code: 'THE5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'THE6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'TPA2200',
    course_name: 'Technical Theatre',
    course_desc:
      'Methods of constructing and rigging scenery for the stage. Basic scene painting techniques. Stage lighting equipment and its use. Lab required.',
  },
  {
    course_code: 'TPA2248',
    course_name: 'Introduction to Stage Makeup',
    course_desc:
      'Basic principles of the art of stage makeup. Practice in the design and execution of makeup for various purposes. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'TPA2290L',
    course_name: 'Technical Theatre Laboratory',
    course_desc:
      'A practical laboratory for application of technical theatre skills. Material and supply fee will be assessed.',
  },
  {
    course_code: 'TPA3004L',
    course_name: 'Drawing for the Stage',
    course_desc:
      'This lab course gives students the skills and practice needed to sketch, render and draft design ideas.  Design ideas relating to costume, lighting, set, scenic painting or any other design related objective.',
  },
  {
    course_code: 'TPA3022',
    course_name: 'Lighting Design I',
    course_desc:
      "Introduction to the work of the lighting designer through theoretical design projects and light lab projects. The theoretical designs cover the design process that the lighting designer uses to light a theatrical production. The light lab projects build the student's ability to understand light and how to use light in a theatre situation. Projects also build in complexity and add to the overall design experience.",
  },
  {
    course_code: 'TPA3064',
    course_name: 'Scene Design I',
    course_desc:
      'Scene design is a complex combination of artist, painter, sculptor, actor, and director. Designers need to be able to envision the script and translate it to a three dimensional space, interpret how the actor is going to move in the space and how the director will compose the stage picture. Course examines those aspects of design and through theoretical projects explores visualizing a script in theatrical space.',
  },
  {
    course_code: 'TPA3223',
    course_name: 'Lighting Technology',
    course_desc:
      'Advanced study of the lighting equipment, dimmers, control, and other electronics used in the Theatre.',
  },
  {
    course_code: 'TPA3230',
    course_name: 'Costume Construction',
    course_desc:
      'Techniques of patterning, cutting, fitting, draping, and basic construction of stage costumes. Material and supply fee will be assessed.',
  },
  {
    course_code: 'TPA3313',
    course_name: 'Scenic Technology',
    course_desc:
      'Advanced study of theatrical construction techniques, rigging, materials, hardware, and their use in the Theatre. In addition, the study of drafting for construction drawing, budgeting, time estimations and theatre safety.',
  },
  {
    course_code: 'TPA3601',
    course_name: 'Stage Management',
    course_desc:
      'Stage Managers work with things and people. Course clarifies the things to work with as a Stage Manager and the techniques needed to work effectively with them. Discusses different methods to use with the myriad of people and personalities encountered in the Theatre. Improvisation and class discussion are employed to examine how to work more effectively with everyone on a production.',
  },
  {
    course_code: 'TPA3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'TPA4021C',
    course_name: 'Lighting Design II',
    course_desc:
      "Advances the study of the design process involved in lighting design. Theoretical design projects and light lab projects are used to give the student challenges in the classroom that can be directly translated to the design process. Theoretical projects in a variety of design venues and types of theatre with lab projects that further build the designer's resources.",
  },
  {
    course_code: 'TPA4045',
    course_name: 'Costume Design I',
    course_desc:
      'Introduction to theatrical costume design for the stage using the design principles of line, shape, space, color, form, texture, and size. Permission is required.',
  },
  {
    course_code: 'TPA4046',
    course_name: 'Costume Design II',
    course_desc:
      'Advanced theatrical costume design for the stage using the design principles of line, shape, space, color, form, texture, and size.',
  },
  {
    course_code: 'TPA4061',
    course_name: 'Scene Design II',
    course_desc:
      "Advanced projects in scene design examine the challenges involved in designing in a variety of different venues and types of production. Expands the designer's tools to communicate their design idea to the director.",
  },
  {
    course_code: 'TPA4077',
    course_name: 'Scene Painting',
    course_desc:
      'Practice in various techniques of scene painting. Consideration of pigments, color mixing, kinds of paints, paint equipment and its care. Material and supply fee will be assessed.',
  },
  {
    course_code: 'EUH4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'TPA4504',
    course_name: 'Performing Arts Administration',
    course_desc:
      'Various aspects involved in the administration of a Performing Arts Organization. Special attention will be paid to the interrelationship in both goals and administration among various performing arts institutions including theatres, opera companies, and symphonies. Lectures and class discussion will provide an overview of the different areas of non-profit performing arts administration (including organizational structures, marketing, fundraising, grant writing, financial management, and producing) and applying these skills to the unique needs of a theatre company or other performing arts organization.',
  },
  {
    course_code: 'TPA4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'TPA5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'TPP1282',
    course_name: 'Voice and Movement for the Stage',
    course_desc:
      'Beginning course in the exploration of the sources of voice and movement and the process of developing individual expression and strength. Required of all theatre majors and directed primarily toward preparation for stage work.',
  },
  {
    course_code: 'TPP2100',
    course_name: 'Acting for Non-majors',
    course_desc:
      'Introduction to the process of acting. Work is directed toward bringing a character to life on the stage and communicating this life and relationships with others to an audience.',
  },
  {
    course_code: 'TPP2110',
    course_name: 'Acting I',
    course_desc:
      'An introduction to the process of acting designed for students with some prior experience on stage. Work is directed toward bringing a character to life on the stage and communicating this life and relationships with others to an audience.',
  },
  {
    course_code: 'TPP2167C',
    course_name: 'Acting for Musical Theatre',
    course_desc:
      'Exploring practical acting technique as it applies to musical theatre scene, song and monologue study.',
  },
  {
    course_code: 'TPP2190',
    course_name: 'Rehearsal and Performance',
    course_desc:
      'Production involvement in any area of theatre performance. Permission is required. Material and Supply Fee will be assessed.',
  },
  {
    course_code: 'TPP2250L',
    course_name: 'Musical Theatre Vocal Theory Lab',
    course_desc:
      'The Lab will provide students the opportunity to execute their skills in music readiness by demonstrating assign concepts on the piano. These will be directly applied to music they are preparing to perform.',
  },
  {
    course_code: 'TPP2513C',
    course_name: 'Movement for the Actor',
    course_desc:
      'Beginning course in the exploration of movement and bodywork for the stage. Required of all theatre majors and directed primarily toward preparation for stage work.',
  },
  {
    course_code: 'TPP2715L',
    course_name: 'Music Theatre Voice I',
    course_desc:
      'This course focuses on the foundation of the voice through classical methods. Vocal technique and repertoire knowledge necessary for performance in Musical Theatre.  Emphasis is given to breath control, tone production, and interpretation of songs for musical theatre productions.',
  },
  {
    course_code: 'TPP2744C',
    course_name: 'Voice for the Actor',
    course_desc:
      'Beginning course in the exploration of the source and placement of the voice for the stage and the process of developing individual expression and strength. Required of all performance students in theatre and directed primarily toward preparation for stage work.',
  },
  {
    course_code: 'TPP2905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'TPP3102L',
    course_name: 'Acting Studio',
    course_desc:
      'Studio Class provides an immersive space for actors to develop and hone their instruments and to exercise their abilities to express freedom, power, range and sensitivity in their lives on stage.',
  },
  {
    course_code: 'TPP3121',
    course_name: 'Acting Improvisation',
    course_desc:
      'Study of improvisational technique through games and exercises.',
  },
  {
    course_code: 'TPP3155',
    course_name: 'Acting II',
    course_desc:
      "Continues development of the fundamentals of acting through work on scenes from contemporary American theatre. Further develops student's understanding of the various acting philosophies and techniques of Hagen and Stanislavski.",
  },
  {
    course_code: 'TPP3221',
    course_name: 'Audition Techniques',
    course_desc:
      'Techniques for audition in theatre, musical theatre, television, and film including resume preparation and an overview of opportunities in professional acting and graduate school.',
  },
  {
    course_code: 'TPP3250',
    course_name: 'Musical Theatre Performance',
    course_desc:
      'Serving as the capstone to the Musical Theatre B.F.A. Combines the study of vocal technique with acting technique to create a performance ensemble to tour to various venues throughout the region.',
  },
  {
    course_code: 'TPP3252C',
    course_name: 'Music Theatre Scene Study',
    course_desc:
      'Students will work on scenes and songs from musical theatre repertoire of different styles and / or eras.  Work will involve partner work and / or work in small groups.',
  },
  {
    course_code: 'TPP3257',
    course_name: 'Music Theatre Voice II',
    course_desc:
      'This course will focus on interpretation and contemporary music theatre technique.  Vocal technique and repertoire knowledge necessary for performance in Musical Theatre. Emphasis is given to breath control, diction, tone production, and interpretation of songs for musical theatre production.',
  },
  {
    course_code: 'TPP3260',
    course_name: 'Acting for the Camera',
    course_desc:
      'Adapting the craft of acting to the needs of the TV or film camera. Work in a studio on scenes, daytime serials, commercials. Permission is required. Material and supply fee will be assessed.',
  },
  {
    course_code: 'TPP3310',
    course_name: 'Play Directing',
    course_desc:
      'This course is an introduction to the art and craft of directing for the stage.  Class work is aimed at teaching new directors the fundamentals of analyzing the text, communicating effectively with actors, working on different types of stages, and creating a cohesive production concept.  This course requires rehearsal time outside of regularly scheduled class hours.',
  },
  {
    course_code: 'TPP3650',
    course_name: 'Script Analysis',
    course_desc:
      'Exploration of a variety of styles and historical periods of play scripts through reading and analysis of the text as the basis of performance and production.',
  },
  {
    course_code: 'TPP3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'TPP4113',
    course_name: 'Acting III',
    course_desc:
      "Developing the actor's timing, vocal, and physical skill to create characters in plays from Restoration, French farce, Theatre of the Absurd, etc. Credit may not be received in both TPP4113 and TPP 4141.",
  },
  {
    course_code: 'TPP4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ARH4889',
    course_name: 'Tattoo and Body Art',
    course_desc:
      'Explores the history of body art, from its association with prehistoric non-western cultures to contemporary artistic expression. Topics include: tattoo, piercings, body modification, adornment, conceptions of beauty, status, power, and identity.',
  },
  {
    course_code: 'TRA3153',
    course_name: 'Strategic Transportation Management',
    course_desc:
      'Presents the fundamental elements necessary to plan transportation systems. It examines the importance of transportation in the economy and the strategic and operational roles of transportation in supply chains. Emphasis is placed on domestic and global transportation operations, services pricing, carrier selection, equipment and shipment planning, transportation execution systems, intermodal operations, security, and expanded services in distribution.',
  },
  {
    course_code: 'TRA3234',
    course_name: 'Warehousing and Terminal Management',
    course_desc:
      'Planning and managing the flow of materials, parts and finished goods from suppliers, through production and final distribution to customers. Domestic distribution and import/export intermodal terminal operations are examined to understand how decisions and performance pertaining to such operations influence service quality, total cost to the organization and total cost for the entire supply chain.',
  },
  {
    course_code: 'TRA4155',
    course_name: 'Seminar in Supply Chain Logistics Strategy',
    course_desc:
      "Seminar in Supply Chain Logistics Strategy provides active learning opportunities for students to evaluate current strategic issues in managing logistics and transportation throughout consumer and industrial supply chains. Today's supply chains require managers to be skilled in evaluating complex business logistics situations and in making decisions that have immediate and long-term corporate implications. The real-world and live case-based materials are designed to help students develop high-level analytical and decision-making skills pertaining to the many logistics operations that influence the service levels and capabilities of domestic and global supply chains.\nOffered concurrently with TRA5159; graduate students will be assigned additional work.",
  },
  {
    course_code: 'TRA4202',
    course_name: 'Logistics Systems and Analytics',
    course_desc:
      'Students will learn to make improved business logistics and supply chain management decisions through the practical application of multiple analytical techniques used by managers in the field. Emphasis is placed on supply chain network analysis and design, inventory analysis and decision making, equipment and resource management, information management systems for analyzing and executing logistics decisions, and process management improvements to reduce total logistics cost and improve logistics service.\nOffered concurrently with TRA5206; graduate students will be assigned additional work.',
  },
  {
    course_code: 'TRA5159',
    course_name: 'Seminar in Supply Chain Logistics Strategy',
    course_desc:
      "Seminar in Supply Chain Logistics Strategy provides active-learning opportunities for students to evaluate current strategic issues in managing logistics and transportation throughout consumer and industrial supply chains. Today's supply chains require managers to be skilled in evaluating complex business logistics situations and in making decisions that have immediate and long-term corporate implications. The real-world and live case-based materials are designed to help students develop high-level analytical and decision-making skills pertaining to the many logistics operations that influence the service levels and capabilities of domestic and global supply chains.\nMust have the equivalent of MAR3202 Supply Chain Logistics Management, or TRA3153 Transportation Strategy, or MAN3504 Operations Management.\nOffered concurrently with TRA4155; graduate students will be assigned additional work.",
  },
  {
    course_code: 'TRA5206',
    course_name: 'Logistics Systems and Analytics',
    course_desc:
      'Students will learn to make improved business logistics and supply chain management decisions through the practical application of multiple analytical techniques used by managers in the field. Emphasis is placed on supply chain network analysis and design, inventory analysis and decision making, equipment\nand resource management, information management systems for analyzing and executing logistics decisions, and process management improvements to reduce total logistics cost and improve logistics service.\nMust have the equivalent of MAR3202 Supply Chain Logistics Management, TRA3153 Transportation Strategy, or MAN3504 Operations Management.\nOffered concurrently with TRA4202; graduate students will be assigned additional work.',
  },
  {
    course_code: 'TSL4080',
    course_name: 'ESOL Principles and Practices',
    course_desc:
      'The course provides an overview of information and skills concerning the education of students who are English Language Learners (ELLs).  The course focuses on cross-cultural understanding and methods of teaching English to speakers of other languages, as well as curriculum and materials to support such work.  It builds capacity with regard to working with families of students learning English. Frequently offered concurrently with TSL5085; graduate students will complete additional higher-level work.',
  },
  {
    course_code: 'TSL4081',
    course_name: 'Teaching English to ESOL Students',
    course_desc:
      'This is the second in a sequence of two courses designed to provide students with knowledge and skills related to the education of English Language Learners (ELLs). The course addresses cross-cultural communication and methods of Teaching English to Speakers of Other Languages (TESOL) with emphasis on second language acquisition theories, the role of applied linguistics in second language teaching and learning, and the assessment of ELL students.',
  },
  {
    course_code: 'TSL5085',
    course_name: 'ESOL Principles and Practices',
    course_desc:
      'The course provides an overview of information and skills concerning the education of students of students who are English Language Learners (ELLs.)  The course focuses on cross-cultural understanding and methods of teaching English to speakers of other languages, as well as curriculum and materials to support such work.  It builds capacity with regard to working with families of students learning English. Frequently offered concurrently with TSL4080; graduate students will complete higher-level work.',
  },
  {
    course_code: 'TSL5142',
    course_name: 'ESOL Curriculum and Materials Development',
    course_desc:
      'The course is designed to prepare teachers of English language learners (ELLs) to help them recognize and meet the unique academic needs of ELLs in learning content and their development of English as an additional language. Students enrolled in the course are required to create and adapt materials in all four language skills (reading, writings, listening, and speaking) with specific focus on literacy. The course entails planning and evaluating instruction for K - 12 classroom settings. The main objective of this course is to ensure that teachers of ELLs have the knowledge and skills needed to help culturally and linguistically diverse students achieve academic success in school.',
  },
  {
    course_code: 'PLA4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'TSL5250',
    course_name: 'Applied Linguistics',
    course_desc:
      'This course focuses on preparing educators to work effectively with English Learners (ELLs) with specific focus on how knowledge of language can benefit them in their teaching of ELLs.  This course covers the linguistic components of language including an overview of pragmatics, semantics, phonology, morphology, syntax, language variation, first-language acquisition, and second-language acquisition with analyses of how each component relates to social interaction, the linguistic development, and academic success of ELLs. Written language will also be examined and analyzed as it pertains to language teaching and learning.',
  },
  {
    course_code: 'TSL5345',
    course_name: 'Methods of Teaching ESOL',
    course_desc:
      'This course offers an in-depth examination of approaches, methods, and techniques suitable for teaching English learners (ELs). The course provides a survey of the history of methods in the teaching of languages with a focus on current research-based   instructional approaches and methods used in content instruction of culturally and linguistically diverse students to effectively teach content area subjects and increase academic success.  The course introduces theories and theorist in the field of teaching English to speakers of other languages and examines their contribution to the education of ELs.',
  },
  {
    course_code: 'TSL5440',
    course_name: 'ESOL Testing and Evaluation',
    course_desc:
      'This course is designed to help prepare teachers of English language learners (ELLs) to evaluate instructional outcomes and appropriately identify role of culture and the effect of English language proficiency on testing and evaluation of ELLs. Issues related to bias in testing are discussed along with the effects of standardized testing on culturally and linguistically diverse students.  Traditional and alternative methods of assessment for ELLs are addressed with a focus on their role in making informed decision related to instruction and placement. Adaptation of testing and evaluation materials for ELLs is also addressed and practiced.',
  },
  {
    course_code: 'TSL5525',
    course_name: 'Cross Cultural Communication and Understanding',
    course_desc:
      'This course is designed to provide teachers of English language learners (ELLs) with the fundamentals of cultural issues that come into play in their professional lives as teachers of culturally and linguistically diverse learners. The complexity of the concept of "culture" and common approaches related to intercultural communication and competence are addressed.  Culture is analyzed and its role is examined in second language learning and teaching. Intercultural communication principles will be applied to working in diverse settings and strategies for fostering positive learning environments are evaluated. Students are encouraged to reflect on their personal cultures and their own views of other cultures as part of their analyses of cross-cultural communication and understanding in the teaching of languages.',
  },
  {
    course_code: 'TSL5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ZOO3558',
    course_name: 'Coral Reefs',
    course_desc:
      'Coral Reefs is a non-biology major course designed to provide a general overview of tropical and sub-tropical coral reefs to students with an interest in these fascinating ecosystems, but who lack a strong theoretical background in the biological sciences. Covers basic concepts dealing with the structure, formation, biology and ecology of Atlantic and Pacific coral reefs. Students will be presented with interactive exercises, projects, and module-assessments throughout the course that will reinforce major biological concepts and promote critical thinking.',
  },
  {
    course_code: 'ZOO3905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ZOO4254C',
    course_name: 'Marine Invertebrate Zoology',
    course_desc:
      'Survey of the invertebrates, with emphasis on systematics, morphology, physiology and ecology. Labs include detailed study of types and exposure to diversity, using live and preserved specimens, and exposure to techniques used in zoological research. Emphasis is on local marine species. Material and supply fee will be assessed for corresponding lab.',
  },
  {
    course_code: 'ZOO4304C',
    course_name: 'Marine Vertebrate Zoology',
    course_desc:
      'Structure and function of chordates, especially those in water such as fish, whales and seals. Study of behavioral, ecological, physiological and structural adaptations to various modes of living, stressing local marine forms in lab. Material and supply fee will be assessed for corresponding lab. Offered concurrently with ZOO5305C. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'ZOO4454',
    course_name: 'Elasmobranch Biology',
    course_desc:
      'Survey of current advances in the rapidly growing field of elasmobranch biology. Lectures promote an understanding of the interactive physiological, behavioral, and ecological components of adaptive life-history strategies seen in sharks, rays, skates and chimeras. Offered concurrently with ZOO5452; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ZOO4457',
    course_name: 'Ichthyology',
    course_desc:
      'Classic and contemporary topics in the study of fishes discussed within an ecological and evolutionary context. Emphasis is placed on understanding interactive physiological components of adaptive life-history strategies such as movement, feeding, reproduction, oxygen uptake, water balance, and excretion. Offered concurrently with ZOO5458; graduate students will be assigned additional work.',
  },
  {
    course_code: 'AML4990',
    course_name: 'Special Topic Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'CJE4990',
    course_name: 'Special Topic Course',
    course_desc: '',
  },
  {
    course_code: 'CPO3990',
    course_name: 'Special Topic Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'BSC2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'ZOO4472',
    course_name: 'Avian Science',
    course_desc:
      'Avian Science is a course that describes and provides experience in the study of birds in order to answer questions about their basic ecology, with special emphasis on techniques for data collection and data management typically associated with research and monitoring of bird populations.  Topics include species identification (visual and by song), movements and migration, habitat selection, foraging behavior, reproduction and nesting ecology, and demography (estimating survival, population size, nest success).  Avian Science emphasizes S.T.E.M education, covering aspects of science, engineering, technology, and math important to many areas of ecology. Many of the techniques and concepts taught in this course, especially the sections on movements and spatial ecology, habitat selection, and demography, apply to fauna other than birds.  Bird identification and survey experiences focus on species found on the UWF campus and on wintering waterfowl in local estuaries.  The course consists of approximately 1/3 lectures and discussion, 1/3 laboratory exercise, and 1/3 field experiences.  The class meets once per week for 2.75 hours.   In addition, participation in one supervised day long (approximately12-hrs) bird survey is required outside of normal class time, and may need to take place on a weekend (depending on survey schedule and weather). A one weekend field trip is required in this course, and students are expected to have the ability to hike and do field work. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'ZOO4485',
    course_name: 'Marine Mammalogy',
    course_desc:
      'Application of current mammalogy principles to the study of marine mammal biology and phylogeny. Emphasizes ecology, physiology and behavior of the sixteen marine mammal families. Offered concurrently with ZOO5486; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ZOO4513',
    course_name: 'Animal Behavior',
    course_desc:
      'Contemporary view of animal behavior including discussion of sensory and neurobiology, biological rhythms, genetic and experiential influences on behavior, communication, orientation, migration, predator-prey relationships and social behavior. Offered concurrently with ZOO5514; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ZOO4905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ZOO5305C',
    course_name: 'Marine Vertebrate Zoology',
    course_desc:
      'Structure and function of chordates, especially those in water such as fish, whales and seals. Study of behavioral, ecological, physiological and structural adaptations to various modes of living, stressing local marine forms in lab. Material and supply fee will be assessed for corresponding lab. Offered Concurrently with ZOO 4304; Graduate students will be assigned additional work.',
  },
  {
    course_code: 'ZOO5452',
    course_name: 'Elasmobranch Biology',
    course_desc:
      'Survey of current advances in the rapidly growing field of elasmobranch biology. Lectures promote an understanding of the interactive physiological, behavioral, and ecological components of adaptive life-history strategies seen in sharks, rays, skates and chimeras. Offered concurrently with ZOO4454; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ZOO5458',
    course_name: 'Ichthyology',
    course_desc:
      'Classic and contemporary topics in the study of fishes discussed within an ecological and evolutionary context. Emphasis is placed on understanding interactive physiological components of adaptive life-history strategies such as movement, feeding, reproduction, oxygen uptake, water balance, and excretion. Offered concurrently with ZOO4457; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ZOO5475',
    course_name: 'Avian Science',
    course_desc:
      'Avian Science is a course that describes and provides experience in the study of birds in order to answer questions about their basic ecology, with special emphasis on techniques for data collection and data management typically associated with research and monitoring of bird populations. Topics include species identification (visual and by song), movements and migration, habitat selection, foraging behavior, reproduction and nesting ecology, and demography (estimating survival, population size, nest success). Avian Science emphasizes S.T.E.M education, covering aspects of science, engineering, technology, and math important to many areas of ecology. Many of the techniques and concepts taught in this course, especially the sections on movements and spatial ecology, habitat selection, and demography, apply to fauna other than birds. Bird identification and survey experiences focus on species found on the UWF campus and on wintering waterfowl in local estuaries. The course consists of approximately 1/3 lectures and discussion, 1/3 laboratory exercise, and 1/3 field experiences. The class meets once per week for 2.75 hours. In addition, participation in one supervised day long (approximately12-hrs) bird survey is required outside of normal class time, and may need to take place on a weekend (depending on survey schedule and weather). A one weekend field trip is required in this course, and students are expected to have the ability to hike and do field work. Graduate students will be assigned additional work.',
  },
  {
    course_code: 'ZOO5486',
    course_name: 'Marine Mammology',
    course_desc:
      'Application of current mammalogy principles to the study of marine mammal biology and phylogeny. Emphasizes ecology, physiology, and behavior of the sixteen marine mammal families. Offered concurrently with ZOO4485; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ZOO5514',
    course_name: 'Animal Behavior',
    course_desc:
      'Animal behavior including discussion of sensory biology and neurobiology, biological rhythms, genetic and experiential influences on behavior, communication, orientation, migration, predator-prey relationships and social behavior. Offered concurrently with ZOO4513; graduate students will be assigned additional work.',
  },
  {
    course_code: 'ZOO5905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ZOO6905',
    course_name: 'Directed Study',
    course_desc: '',
  },
  {
    course_code: 'ANT4990',
    course_name: 'Special Topic Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'SLS1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MAC1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MAC4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MAC5990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MAC6990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'SLS2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'SLS3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PEM3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PEM2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PEM4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PEM5990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PEM6990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MSL1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MSL2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MSL3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MUL1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MUL2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MUL3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MUL4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'IDS2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'IDS4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'EML3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'EML4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'GER4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'GER1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PHI1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PHI2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PHI3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PHI4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PGY3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PGY1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PGY2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PGY4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'SOW1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'SOW2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'SOW3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'SOW4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PHZ1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PHZ2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PHZ3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PHZ4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'TPA3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'TPA3990L',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'POS1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'POS2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'POS3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'POS4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'GRA2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'GRA4990C',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'LIT1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'LIT2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'LIT3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'LIT4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MVV1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MVV2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MVV3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MVV4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MHF1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MHF2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MHF3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MHF4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'CGS1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'CGS2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'CGS3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'CGS4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PSY1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PSY2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PSY3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PSY4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PSY4990L',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'SPN1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'SPN2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'SPN3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'SP4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'FIN1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'FIN2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'FIN3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'FIN4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'DEP1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'DEP2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'DEP3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'DEP4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MUN1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MUN2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MUN3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'MUN4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'EGM1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'EGM2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'EGM3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'EGM4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'HFT1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'HFT2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'HFT3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'HFT4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'DAA1990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'DAA2990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'DAA3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'DAA3990C',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'DAA4990C',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'DAA4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'PCB4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'COM4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'ECO4990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
  {
    course_code: 'ECO3990',
    course_name: 'Special Topics Course',
    course_desc:
      'Special Topics course numbers are used by departments to teach courses that are offered only occasionally and do not have permanent course numbers. The selection of Special Topics courses varies each semester. Students should refer to individual sections in a given semester for course titles and course descriptions.',
  },
];
